const _ = {
  T_50_XYL_2NBCL_BLOODMOON_SKYBOX: "Tsukuyomi Background",
  BR_WORKSHOP_INVALID_PERFORMANCE_COST: "Failed to publish due to excessive scene assets. Please delete some assets and try again.",
  BR_WORKSHOP_NO_PERMISSION_PUB_MONETIZATION_MAP: "Currently no permission to access membership-related features",
  T_12_I_GIFT_SENDER_BELL: "بیل (گھنٹی)",
  T_12_L_ACCESSORY_COS_MOTORHELMET_DESC: "اب تم اسے دیکھتے ہو، اب تم نہیں دیکھتے ہو۔ [FFB300] (ہیلمیٹ چھپاتا ہے) [-]",
  T_12_L_ACCESSORY_COS_SANTAHEAD: "بوڑھے آدمی کا ماسک",
  T_12_L_COS_PINKMAN: "پنک ڈائنو",
  T_12_L_COS_POLAR: "قطبی ریچھ",
  T_12_L_COS_RENDER: "رینبو ڈنو",
  T_12_L_COS_TIGER: "ٹائیگر سوٹ",
  T_12_L_MALE_BOTTOM_COS_ELF: "ونٹر ایلف (باٹم)",
  T_12_L_MALE_COS_SANTA: "بدمزاج بوڑھا آدمی",
  T_12_L_MALE_HAIR_COS_ELF: "ونٹر ایلف (ہیڈ)",
  T_12_L_MALE_SHOE_COS_ELF: "ونٹر ایلف (جوتے)",
  T_12_L_MALE_TOP_COS_ELF: "ونٹر ایلف (ٹاپ)",
  T_12_O_CAT_NAME: "کٹی",
  T_12_O_M1014_CHRISTMAS_NAME: "M1014 - ونٹر لینڈ",
  T_12_O_MACHETE_GOLD_NAME: "گولڈن بلیڈ",
  T_12_O_PET_TITLE: "پِٹ",
  T_12_Q_ITEM_AN94: "AN94",
  T_12_Q_ITEM_DOUBLEJUMPSHOE: "چمپ لگانے والے شوز",
  T_12_Q_ITEM_DOUBLEJUMPSHOE_DESC: "جدید ٹیکنالوجی سے بنائے گئے جوتے۔ انسانوں کو ڈبل چھلانگ لگانے کرنے کی اجازت دیتا ہے۔",
  T_12_Q_ITEM_FLYSHOE: "جیٹ پیک شوز",
  T_12_Q_ITEM_FLYSHOE_DESC: "جوتے جو کھلاڑی کو اڑنے کی صلاحیت دیتے ہیں۔ کوشش کریں کہ پرواز کے دوران ایندھن ختم نہ ہو جائے۔",
  T_12_Q_ITEM_STOCK1: "اسٹاک لیول 1",
  T_12_Q_ITEM_STOCK2: "اسٹاک لیول 2",
  T_12_Q_ITEM_STOCK3: "اسٹاک لیول 3",
  T_12_Q_ITEM_TREATMENTGUN: "ٹریٹمنٹ پستول",
  T_12_Q_ITEM_VEST4: "بلٹ پروف جیکٹ لیول 4",
  T_12_R_CHARACTER_GANGLEADER_NAME: "انتونیو",
  T_12_R_CHARACTER_MONKEYGOD_NAME: "ووکونگ",
  T_12_R_EMOTE_SHOOTDANCE_NAME: "گولی مار ڈانس",
  T_12_R_EMOTE_WAVE_NAME: "بازووں کو لہرانا",
  T_12_R_SKILL_NAME_GANGLEADER: "گینگسٹر کی روح",
  T_12_R_SKILL_NAME_MONKEYGOD: "کیمو فلاج",
  T_13_I_COLLECTION_V_AMPHIBIAN: "امفیبیئن کار",
  T_13_I_COLLECTION_V_JEEP: "جیپ",
  T_13_I_COLLECTION_V_MONSTER: "مونسٹر ٹرک",
  T_13_I_COLLECTION_V_MOTOBIKE: "موٹربائیک",
  T_13_I_COLLECTION_V_ROADSTER: "اسپورٹس کار",
  T_13_I_COLLECTION_V_SUV: "پک اپ ٹرک",
  T_13_I_COLLECTION_V_TUTU: "تو تو کار",
  T_13_L_MALE_ACCESSORY_COS_BJD: "آرکٹک بلیو (ماسک)",
  T_13_L_MALE_BOTTOM_COS_VALENTINE: "ہوا میں محبت (باٹم)",
  T_13_L_MALE_HAIR_COS_BJD: "آرکٹک بلیو (ہیڈ)",
  T_13_L_MALE_TOP_COS_VALENTINE: "ہوا میں محبت (ٹاپ)",
  T_13_M_PVE_MATCH_SUMMARY_WEAPON: "ہتھیار",
  T_13_O_PETSKIN_OCELOT_CAT_NAME: "پِٹ اسکن: سراغ رساں کٹی",
  T_13_O_SCAR_VALENTINE_NAME: "سکار - کیوپڈ",
  T_13_R_CHARACTER_HACKERGIRL_NAME: "موکو",
  T_13_R_EMOTE_BABYSHARK_NAME: "بے بی شارک",
  T_13_R_EMOTE_BOMBSQUAD_NAME: "پش-اپ",
  T_13_R_EMOTE_EGYPT_NAME: "ممی ڈانس",
  T_13_R_PVE_WEAPON_SLOT: "ہتھیار کی سلاٹ",
  T_13_R_PVE_WEAPONSKIN_RANGE: "موثر حد",
  T_13_R_PVE_WEAPONSKIN_SPEED: "فائر کی شرح",
  T_13_R_SKILL_DESC_HACKERGIRL: "دشمنوں کو ٹیگ کریں اور{0} سیکنڈ تک گولیاں ماریں۔ ٹیم کے ساتھیوں کے ساتھ معلومات شیئر کی جائیں گی۔",
  T_13_R_SKILL_NAME_HACKERGIRL: "ہیکر کی آنکھ",
  T_13_Z_KICKOFF_BAN: "پابندی",
  T_13_Z_ROOM_MORNING: "دن",
  T_13_Z_ROOM_NIGHT: "رات",
  T_14_G_ITEM_KATANA: "کٹانا",
  T_14_I_HEADPIC_SONGKRAN_NAME: "سپلیش!",
  T_14_L_ACCESSORY_COS_EASTERHEAD2: "کیوبک خرگوش",
  T_14_L_COS_EASTER: "مبصر 1937",
  T_14_L_FEMALE_SHOE_COS_FIREFIGHTERS: "لیڈی آف فلیم (جوتے)",
  T_14_L_MALE_ACCESSORY_COS_EASTERRABBIT: "خرگوش وارئیر (ماسک)",
  T_14_O_AK_WATERSPLASHING_NAME: "AK47-  واٹر بیلون",
  T_14_O_DOG_NAME: "مکینیکل پپ",
  T_14_O_PETSKIN_IRON_DOG_NAME: "پِٹ کی جلد: مکمل اسٹیل پپ",
  T_14_O_PETSKIN_LIGNTNING_DOG_NAME: "پِٹ کی جلد: بجلی والا پپ",
  T_14_O_PETSKIN_MAGNETIC_DOG_NAME: "پِٹ کی جلد: مقناطیسی پپ",
  T_14_O_PETSKIN_NIGHT_CAT_NAME: "پِٹ کی جلد: اندھیری بلی",
  T_14_O_SCAR_BLOODMOON_NAME: "سکار- بلڈ مون",
  T_14_O_SCAR_SHARK_NAME: "سکار- شارک حملہ",
  T_14_Q_ITEM_RGS50: "RGS50",
  T_14_R_CHARACTER_SAMURAI_NAME: "حیاٹو",
  T_14_R_SKILL_DESC_SAMURAI: "زیادہ سے زیادہ ہیلتھ پوائنٹ میں ہر {0}٪ کی کمی کے ساتھ، آرمر میں چھید ہونے میں {1}٪ اضافہ ہوتا ہے",
  T_14_R_SKILL_NAME_SAMURAI: "بشیڈو",
  T_15_L_MALE_ACCESSORY_COS_FAIM: "Hunger Strike (ماسک)",
  T_15_L_MALE_ACCESSORY_COS_PESTILENCE: "وینم ٹچ (ماسک)",
  T_15_L_MALE_BOTTOM_COS_FAIM: "Hunger Strike (باٹم)",
  T_15_L_MALE_BOTTOM_COS_PESTILENCE: "وینم ٹچ (باٹم)",
  T_15_L_MALE_SHOE_COS_FAIM: "Hunger Strike (جوتے)",
  T_15_L_MALE_SHOE_COS_PESTILENCE: "وینم ٹچ (جوتے)",
  T_15_L_MALE_TOP_COS_FAIM: "Hunger Strike (ٹاپ)",
  T_15_L_MALE_TOP_COS_PESTILENCE: "وینم ٹچ (ٹاپ)",
  T_15_L_TOP_COS_MOTHERSDAY: "بہترین ماں",
  T_15_O_AN94_APOCALYPSE_NAME: "AN94 - تباہی",
  T_15_O_BASEBALLBAT_VIKING_NAME: "The Viking",
  T_15_O_M1014_APOCALYPSE_NAME: "M1014 - تباہی",
  T_15_O_M4A1_APOCALYPSE_NAME: "M4A1 - تباہی",
  T_15_O_PANTHER_NAME: "نائٹ پینتھر",
  T_15_O_PETSKIN_CAPTAIN_PANTHER_NAME: "پِٹ اسکن: کیپٹن",
  T_15_O_PETSKIN_GOLDEN_PANTHER_NAME: "پِٹ اسکن: سنہری چیتا",
  T_15_O_PETSKIN_PURPLE_PANTHER_NAME: "پِٹ اسکن: تسلط",
  T_15_O_SKS_DEATH_NAME: "SKS-Death Wish",
  T_15_O_UMP_APOCALYPSE_NAME: "UMP - تباہی",
  T_15_Q_ITEM_CG15: "CG15",
  T_15_Q_ITEM_GATLING: "گیٹلنگ",
  T_15_R_CHARACTER_AGENT_NAME: "لورا",
  T_15_R_EMOTE_LETSGROOVE_NAME: "Shake With Me",
  T_15_R_SKILL_DESC_AGENT: "سکوپڈ ان کے دوران درستگی میں {0}% ​اضافہ ہوتا ہے۔",
  T_15_R_SKILL_NAME_AGENT: "ماہر شوٹر",
  T_15_W_BACKPACK_MECHGIRL_NAME: "پرپل ونگز",
  T_16_B_ITEM_GRAPPLINGHOOK: "ہک",
  T_16_B_ITEM_GRAPPLINGHOOKGUN: "ہک گن",
  T_16_L_MALE_COS_LEGO: "پاگل برک مین",
  T_16_L_MALE_SHOE_COS_SUMMER: "Summer Holidays (جوتے)",
  T_16_P_MANUAL_MONSTER: "مونسٹر ٹرک",
  T_16_P_MANUAL_MUSHROOM1: "مشروم لیول 1",
  T_16_P_MANUAL_MUSHROOM2: "مشروم لیول 2",
  T_16_P_MANUAL_MUSHROOM3: "مشروم لیول 3",
  T_16_P_MANUAL_MUSHROOM4: "مشروم لیول 4",
  T_16_P_MANUAL_ROADSTER_DESC: "اسٹائلیش اسپورٹس کار۔ کم ہیلتھ پوائنٹ لیکن شدید تیز رفتار ہے۔ 2 کھلاڑیوں تک کو لے جا سکتی ہے۔",
  T_16_P_MANUAL_STROP: "زپ لائن",
  T_16_P_MANUAL_SUV: "پک اپ ٹرک",
  T_16_P_MANUAL_SUV_DESC: "فری فائر کی روایتی گاڑی ۔ میڈیم آرمر اور زیادہ سے زیادہ رفتار۔ 2 کھلاڑی لے جا سکتی ہے۔",
  T_16_P_MANUAL_TUTU_DESC: "ایک ایسی گاڑی جس میں کم ہیلتھ پوائنٹ اور سست حرکت ہے۔ 3 کھلاڑی لے جا سکتی ہے۔",
  T_16_P_MANUAL_WEAPON_AR: "رائفل",
  T_16_P_MANUAL_WEAPON_BOMB: "گرینیڈ",
  T_16_P_MANUAL_WEAPON_PISTOL: "پستول",
  T_16_P_MANUAL_WEAPON_SG: "شاٹگن",
  T_16_P_MANUAL_WEAPON_SMG: "ایس_ایم_جی",
  T_16_P_MANUAL_WEAPON_SR: "Sniper",
  T_16_Q_MINISENTRY: "Mini Turrents",
  T_16_Q_MINISENTRY_DESC: "Auto turret جدید ٹکنالوجی سے بنا ہے۔ یہ قریب قریب دشمنوں کو اسکین اور حملہ کرے گا۔",
  T_16_R_EMOTE_DESERT_NAME: "Furious Slam",
  T_16_R_EMOTE_EPHUNTER_NAME: "Battle Dance",
  T_16_R_EMOTE_EPHUNTER2_NAME: "ہائی فائیو",
  T_16_R_EMOTE_KICKTHEMOON_NAME: "Moon Flip",
  T_16_R_EMOTE_WIGGLEWALK_NAME: "Wiggle walk",
  T_16_W_AK_FIRE_NAME: "AK47- فلیمنگ ریڈ",
  T_16_W_SCAR_LLENN_NAME: "سکار- گلابی شیطان",
  T_16_W_SCAR_WATER_NAME: "سکار- آب عنصری",
  T_16_Y_CHARACTER_HITMAN_NAME: "رافیل",
  T_16_Y_PANDA_NAME: "جاسوس پانڈا",
  T_16_Y_PETSKIN_BROWN_PANDA_NAME: "پِٹ کی جلد: جنگلی پانڈا",
  T_16_Y_PETSKIN_SKELETON_PANDA_NAME: "پِٹ کی جلد: کھوپڑی والا پانڈا",
  T_16_Y_PETSKIN_THOR_PANDA_NAME: "پِٹ کی جلد: بجلی والا پانڈا",
  T_17_B_CS_MODE_NAME: "کلیش اسکواڈ",
  T_17_C_SKILL_NAME_PLAYBOY: "پاگل تحریک",
  T_17_L_FEMALE_ACCESSORY_COS_JOKER_ROYAL: "Royal Jester (ماسک)",
  T_17_L_FEMALE_ACCESSORY_COS_VAMPIRE: "Bloody Mistress (ماسک)",
  T_17_L_FEMALE_BOTTOM_COS_VAMPIRE: "Bloody Mistress (باٹم)",
  T_17_L_FEMALE_HAIR_COS_SELVEDGEWORK: "Magical Fox (ہیڈ)",
  T_17_L_FEMALE_SHOE_COS_VAMPIRE: "Bloody Mistress (جوتے)",
  T_17_L_FEMALE_TOP_COS_VAMPIRE: "Bloody Mistress (ٹاپ)",
  T_17_L_MALE_ACCESSORY_COS_VAMPIRE: "ویمپائر کا بدلہ (ماسک)",
  T_17_L_MALE_BOTTOM_COS_BOSOZOKU: "Street Thug (باٹم)",
  T_17_L_MALE_BOTTOM_COS_VAMPIRE: "ویمپائر کا بدلہ (باٹم)",
  T_17_L_MALE_HAIR_COS_FFUNIT: "Purple Shade (ہیڈ)",
  T_17_L_MALE_SHOE_COS_INDEPENDENCE: "The Gentleman (جوتے)",
  T_17_L_MALE_SHOE_COS_VAMPIRE: "ویمپائر کا بدلہ (جوتے)",
  T_17_L_MALE_TOP_COS_VAMPIRE: "ویمپائر کا بدلہ (ٹاپ)",
  T_17_L_MALE_TOP_COS_YINYANG_GOLD: "گولڈن شیڈ (ٹاپ)",
  T_17_O_PETSKIN_ANNIVERSARY_CAT_NAME: "پِٹ کی جلد: بلی شہزادی",
  T_17_O_PETSKIN_EARTHDRAGON_SHIBA_NAME: "پِٹ کی جلد: سنہری قصہ",
  T_17_O_PETSKIN_ELECTRICDRAGON_SHIBA_NAME: "پِٹ کی جلد: گہرا نیلا",
  T_17_O_PETSKIN_GREENDRAGON_SHIBA_NAME: "پِٹ کی جلد: لکی گرین",
  T_17_O_SHIBA_NAME: "شیبا",
  T_17_Q_FOLDWINGS: "Glider",
  T_17_Q_FOLDWINGS_DESC: "تمہیں بلندی والے علاقوں سے نیچے جانے کی اجازت دیتا ہے۔",
  T_17_Q_SUPERHEAT: "پلازما",
  T_17_R_EMOTE_PARTYDANCE_NAME: "پارٹی ڈانس",
  T_17_W_FAMAS_VAMPIRE_NAME: "FAMAS - ویمپائر",
  T_17_W_SCAR_ASSASSIN_NAME: "سکار- فینٹم حَشيشين",
  T_17_W_SCAR_PLAYBOY_NAME: "سکار- پرانی طرز والا",
  T_17_Y_CHARACTER_MADEMANA_NAME: "اے124",
  T_17_Y_CHARACTER_PLAYBOY_NAME: "جوزف",
  T_17_Z_CS_NAME: "نام",
  T_17_Z_ROOM_JUMP_SWITCH: "جمپ کی اونچائی",
  T_17_Z_ROOM_SPEED_SWITCH: "حرکت کرنے کی رفتار",
  T_18_B_THROWINGKNIFE_NAME: "FF Knife",
  T_18_C_DUMMY_NAME: "جھوٹا گرینیڈ",
  T_18_C_SKILL_DESC_DJMALE: "ایک {1} میٹر کا اورا بنائیں جو اتحادیوں کی حرکت کی رفتار میں {3}% اضافہ کرتا ہے اور {0} سیکنڈ کے لئے {2} ہیلتھ پوائنٹ فی سیکنڈ کو بحال کرتا ہے۔ اسے جمع نہیں کیا جاسکتا۔ تبریدی مدت: {4} سیکنڈ۔",
  T_18_C_SKILL_NAME_DJMALE: "بیٹ ڈراپ کریں",
  T_18_C_SKILL_NAME_JUNKENGINEER: "گئر ری سائیکل",
  T_18_L_COS_INDIANEWYEAR: "دیوالی ڈائنو",
  T_18_L_HAIR_COS_HALLOWEEN2019: "تیوری چڑھا چہرہ",
  T_18_L_MALE_ACCESSORY_COS_BJD2_MAGMA: "Flaming Red (ماسک)",
  T_18_O_FOX_NAME: "لومڑی کی روح",
  T_18_O_PETSKIN_BLACKFOX_NAME: "پِٹ کی جلد: جنگی فاکس",
  T_18_O_PETSKIN_BLUEFOX_NAME: "پِٹ کی جلد: بلیو فاکس",
  T_18_O_PETSKIN_HALLOWEEN_SHIBA_NAME: "پِٹ کی جلد: لاوا پمپکن",
  T_18_O_PETSKIN_PINKFOX_NAME: "پِٹ کی جلد: ریڈ فاکس",
  T_18_O_PETSKIN_SPIRIT_PANTHER_NAME: "پِٹ کی جلد:  روح",
  T_18_U_WEAPON_M1887_NAME: "M1887",
  T_18_W_M4A1_FIRESKELETON_N: "M4A1-Flaming Skull",
  T_18_W_UMP_GEISHA_N: "UMP-Art of War",
  T_18_Y_CHARACTER_DJMALE_N: "آلوک",
  T_18_Y_CHARACTER_JUNKENGINEER_N: "شانی",
  T_19_B_HB_NAME: "Electric Surfboard",
  T_19_C_ICE_GUN_NAME: "برفانی بندوق",
  T_19_C_SKILL_DESC_DEMOLITIONIST: "دھماکہ خیز ویپنز کے نقصان میں {0}% اضافہ ہوا ، نقصان کی حد میں {1}% اضافہ ہوا",
  T_19_C_SKILL_DESC_TOMBOY: "جب گاڑی چلاتے ہو تو گاڑی میں موجود تمام افراد کے ہیلتھ پوائنٹ کو ہر {0} s کے ذریعہ {1} ہیلتھ پوائنٹ سے بحال کریں۔ اثرات جمع نہیں رہتے ہیں۔",
  T_19_C_SKILL_NAME_DEMOLITIONIST: "تباہی کا فن",
  T_19_C_SKILL_NAME_TOMBOY: "ریسر کی برکت",
  T_19_I_EVENT_INFI_ITEM: "غیر محدود",
  T_19_L_A_ICEFESTIVAL19_B: "آخری قہقہہ",
  T_19_L_F_S_ICEFESTIVAL: "Snowy Servitude (جوتے)",
  T_19_L_MALE_BOTTOM_COS_DISCOMAN: "Disco Fiasco (باٹم)",
  T_19_L_MALE_HAIR_COS_DISCOMAN: "Disco Fiasco (ہید)",
  T_19_L_MALE_TOP_COS_DISCOMAN: "Disco Fiasco (ٹاپ)",
  T_19_O_PETSKIN_NAME: "پِٹ کی جلد: ڈیفالٹ",
  T_19_O_PETSKIN_PANDA_TRAPRAP_NAME: "پِٹ کی جلد:  ہپ ہاپ پانڈا",
  T_19_O_PETSKIN_PANDA_WINTERFELL_NAME: "پِٹ کی جلد: پولر پانڈا",
  T_19_O_PETSKIN_ROBOT_PHARAOH_NAME: "پِٹ کی جلد:  فرعون کا روبو",
  T_19_O_PETSKIN_ROBOT_SPRING_NAME: "پِٹ کی جلد: موسم بہار کا تہوار روبو",
  T_19_O_PETSKIN_ROBOT_WINTERFELL_NAME: "پِٹ کی جلد: سنوئی روبو",
  T_19_O_PETSKIN_SHIBA_TRAPRAP_NAME: "پِٹ کی جلد: ہپ ہاپ شیبہ",
  T_19_O_ROBOT_NAME: "روبو",
  T_19_O_TDM_NAME: "ٹیم ڈیتھ میچ",
  T_19_R_EMOTE_MIGUEL_NAME: "بریک ڈانس",
  T_19_S_SECOND_WEAPON_TITLE: "دوسرا ویپن",
  T_19_S_VEST_TITLE: "بلٹ پروف جیکٹ",
  T_19_U_DOUBLEMAGEZINE_ATTACHMENT_NAME: "ڈبل میگزین",
  T_19_W_GROZA_TAGGERCREW_N: "GROZA-Tagger's Revolt",
  T_19_W_M60_ICEFESTIVAL_N: "M60- Santa's Choice",
  T_19_W_MP40_PARK_N: "MP40-Carnival Carnage",
  T_19_W_SCAR_CNNEWYEAR19_N: "سکار- اوروس ڈریگن",
  T_19_X_PVE_SAMURAINAME: "گارڈین سیمورائی",
  T_19_Y_CHARACTER_DEMOLITIONIST_N: "الوارو",
  T_19_Y_CHARACTER_TOMBOY_N: "نوٹورا",
  T_20_C_INHALER_NAME: "سانس لینے والا",
  T_20_C_SKILL_DESC_PARKOURGUY: "بندوقیں استعمال کرتے وقت ، دشمن کو نشانہ بنانے سے یوزر کے لئے کچھ ہیلتھ پوائنٹ ریکوور ہوتی ہے ، دشمن کو گرا کر یوزر کے لئے {0}٪ ہیلتھ پوائنٹ ریکوور ہوتی ہے۔",
  T_20_C_SKILL_NAME_GRAFFITIST: "پینٹ ریفیوج",
  T_20_C_SKILL_NAME_KELLY_AWAKENING: "Deadly Velocity",
  T_20_C_SKILL_NAME_PARKOURGUY: "مسلسل چھاپے",
  T_20_L_A_APRILFOOL2020: "Doggo",
  T_20_L_F_A_METALHEAD_RED: "محترمہ شعلہ امپ-ہیڈ (ماسک)",
  T_20_L_F_B_THAIGIRL: "Phoenix Accession (باٹم)",
  T_20_L_F_H_KILLERCUPID: "Sweetheart Cupid (ہیڈ)",
  T_20_L_F_H_THAIGIRL: "Phoenix Accession (ہیڈ)",
  T_20_L_F_S_THAIGIRL: "Phoenix Accession (جوتے)",
  T_20_L_F_T_METALHEAD_RED: "محترمہ شعلہ امپ-ہیڈ (ٹاپ)",
  T_20_L_F_T_THAIGIRL: "Phoenix Accession (ٹاپ)",
  T_20_L_JEANDINO: "Denim Dino",
  T_20_L_M_A_METALHEAD_RED: "محترم شعلہ امپ-ہیڈ (ماسک)",
  T_20_L_M_T_METALHEAD_RED: "محترم شعلہ امپ-ہیڈ (ٹاپ)",
  T_20_L_M_T_STOCKING: "Gentle-man (ٹاپ)",
  T_20_O_PETSKIN_LOVERFOX_NAME: "پِٹ کی جلد: ویلنٹائن کی لومڑی",
  T_20_P_CHANNEL_G: "گلڈ",
  T_20_P_WORLD_SSPEAKER: "Loudspeaker",
  T_20_S_CSROOM_COIN: "ڈیفالٹ سکے",
  T_20_U_SHIELD_GUN_NAME: "شیلڈ گن",
  T_20_W_AN94_METALHEAD_N: "AN94- Carrot Imp-Head",
  T_20_W_P90_EVILBONE_N: "P90 - سزا دینے والے",
  T_20_Y_CHARACTER_GRAFFITIST_N: "اسٹیفی",
  T_20_Y_CHARACTER_KELLY_AWAKENING_N: 'کیلی "سوئفٹ"',
  T_20_Y_CHARACTER_PARKOURGUY_N: "جوٹا",
  T_21_B_SMOKEGRENADE_DESC: "دھواں پیدا کرتا ہے ، اسکریننگ اور فلینگکنگ ترتیبات کے لئے بہت اچھا ہے",
  T_21_B_SMOKEGRENADE_NAME: "دھواں گرینیڈ",
  T_21_C_AUTOPICKUP_AVERAGE: "ڈیفالٹ",
  T_21_C_SKILL_DESC_KPOPSINGER: "شفا یابی کی آئٹمز کے ایفیکٹس میں {0}٪ اور شفا یابی کی مہارت میں {1}٪ اضافہ۔ اتحادی ہیلتھ پوائنٹ کے نقصان کو کم کریں جب {2}٪ کم ہوجائیں۔ ایفیکٹس اکٹھے نہیں ہوتے ہیں۔",
  T_21_C_SKILL_DESC_SOCCERSTAR: "ہر خاتمے سے زیادہ سے زیادہ ہیلتھ پوائنٹ میں {0}، {1} تک اضافہ ہوتا ہے",
  T_21_C_SKILL_NAME_KPOPSINGER: "شفا بخش گانا",
  T_21_C_SKILL_NAME_SOCCERSTAR: "ہیٹ ٹرک",
  T_21_L_ANGELICAL: "اینجل ڈائنو",
  T_21_L_S_VNSLIPPER: "ویتنام سلیپرز",
  T_21_O_OTTER_NAME: "اوٹیرو",
  T_21_O_PETSKIN_OTTER_GREY_NAME: "پِٹ کی جلد: تابکار اوٹیرو",
  T_21_O_PETSKIN_OTTER_PINK_NAME: "پِٹ کی جلد: ساکورہ اوٹیرو",
  T_21_O_PETSKIN_OTTER_PURPLE_NAME: "پِٹ کی جلد: نی آن اوٹیرو",
  T_21_O_PETSKIN_ROBOT_DEATH_NAME: "پِٹ کی جلد: موت کا ماسٹر",
  T_21_O_PETSKIN_SPINE_PANTHER_NAME: "پِٹ کی جلد: لائٹننگ بولٹ",
  T_21_R_EMOTE_SORROW_NAME: "کیوں؟ اوہ کیوں؟",
  T_21_U_WEAPON_THOMPSON_NAME: "تھامپسن",
  T_21_W_BACKPACK_SPINE_N: "Punkster Backpack",
  T_21_W_BASEBALLPOLE_DEATH2020_N: "موت کا حتمی وار",
  T_21_W_M79_RABBITKILLER_N: "M79 - ہپسٹر خرگوش",
  T_21_W_PAN_VOLCANO_N: "فرائی پین - Volcanic Fury",
  T_21_W_XM8_RAINBOW_N: "XM8-Abyssal",
  T_21_Y_CHARACTER_KPOPSINGER_N: "کپیلا",
  T_21_Y_CHARACTER_SOCCERSTAR_N: "لوکیٹا",
  T_22_C_BLT_NAME: "M82B",
  T_22_C_SKILL_DESC_DETECTIVE: "دشمنوں کی پوزیشنیں {0} میٹر کے اندر تلاش کریں جو شکار یا اسکویٹ پوزیشن میں نہیں ہیں۔ {1} سیکنڈ ، تبریدی مدت {2} سیکنڈ تک رہتا ہے۔ ٹیم کے ساتھیوں کے ساتھ دشمن کی پوزیشنیں شیر ہیں۔",
  T_22_C_SKILL_NAME_DETECTIVE: "سراغ لگانے کے اقدامات",
  T_22_C_SKILL_NAME_STREAMERGUY: "لائم لائٹ",
  T_22_L_F_H_COLLEGE: "Bloodshot Junior (ہیڈ)",
  T_22_L_F_S_SUMMER20: "Summer Darling (جوتے)",
  T_22_L_M_A_GREENCOAT: "Lush Clubber (ماسک)",
  T_22_L_M_A_PINKFUR: "ساکورا کلبر (ماسک)",
  T_22_L_M_A_PLAGUE2: "طاعون فینٹم (ماسک)",
  T_22_L_M_B_FAIM2: "Famine Felon (باٹم)",
  T_22_L_M_B_GREENCOAT: "Lush Clubber (باٹم)",
  T_22_L_M_B_PINKFUR: "Sakura Clubber (باٹم)",
  T_22_L_M_B_PLAGUE2: "طاعون فینٹم (باٹم)",
  T_22_L_M_B_REDPANTS: "Trendy Clubber (باٹم)",
  T_22_L_M_B_TIGERSTRIPE: "Tiger Clubber (باٹم)",
  T_22_L_M_H_COLLEGE: "Bloodshot Senior (ہیڈ)",
  T_22_L_M_H_FAIM2: "Famine Felon (ہیڈ)",
  T_22_L_M_H_GREENCOAT: "Lush Clubber (ہیڈ)",
  T_22_L_M_H_PINKFUR: "Sakura Clubber (Head)",
  T_22_L_M_H_PLAGUE2: "طاعون فینٹم (ہیڈ)",
  T_22_L_M_H_REDPANTS: "Trendy Clubber(ہیڈ)",
  T_22_L_M_H_TIGERSTRIPE: "Tiger Clubber (ہیڈ)",
  T_22_L_M_S_FAIM2: "Famine Felon (جوتے)",
  T_22_L_M_S_PLAGUE2: "طاعون فینٹم (جوتے)",
  T_22_L_M_T_FAIM2: "قحط فیلون (ٹاپ)",
  T_22_L_M_T_GREENCOAT: "Lush Clubber (ٹاپ)",
  T_22_L_M_T_PINKFUR: "Sakura Clubber (ٹاپ)",
  T_22_L_M_T_PLAGUE2: "طاعون فینٹم (ٹاپ)",
  T_22_L_M_T_REDPANTS: "Trendy Clubber (ٹاپ)",
  T_22_L_M_T_TIGERSTRIPE: "Tiger Clubber (ٹاپ)",
  T_22_LC_KAR98K_COLLEGE_N: "Kar98K-Rebel Academy",
  T_22_LC_PAN_CAPTAINBUBBLE_N: "فرائی پین - Watermelon",
  T_22_LC_SCAR_HERMIT_N: "سکار- میسٹک سیکر",
  T_22_LC_TREATMENTGUN_APOCALYPSE2_N: "ٹریٹمنٹ پستول - لائف بیم",
  T_22_O_HAWK_NAME: "فالکو",
  T_22_O_PETSKIN_FOX_APOCALYPSE_NAME: "پِٹ کی جلد: تباہ کن فاکس",
  T_22_O_PETSKIN_HAWK_FIRE_NAME: "پِٹ کی جلد: ہیل فائر فالکو",
  T_22_O_PETSKIN_HAWK_NATURE_NAME: "پِٹ کی جلد: سدا بہار فالکو",
  T_22_O_PETSKIN_SHIBA_SUMMER_NAME: "پِٹ کی جلد: دھوپ شیبہ",
  T_22_Q_BOMB_PLIERS: "ناکارہ بنانے والا پلاس",
  T_22_R_EMOTE_SHIMMY_NAME: "Shimmy",
  T_22_U_GOLD_AWM_N: "AWM-Y",
  T_22_U_WPNSKN_BITE: "آرمر کا چھید",
  T_22_U_WPNSKN_SPEED_RUN: "نقل و حرکت کی رفٹار",
  T_22_Y_CHARACTER_DETECTIVE_N: "کلو",
  T_22_Y_CHARACTER_STREAMERGUY_N: "ولفرح",
  T_23_B_CARDIAC_NAME: "ہوریزا لائن",
  T_23_C_SKILL_NAME_HAYATO_AWAKENING: "آرٹ آف بلیڈز",
  T_23_C_SKILL_NAME_SWATGUY: "ریجنگ ری لوڈ",
  T_23_D_CHARACTER_HAYATO_AWAKENING_N: 'حیاٹو "فائر برینڈ"',
  T_23_D_CHARACTER_SWATGUY_N: "جئے",
  T_23_L_F_B_GANGSTERRAP_GOLD: "Big Bucks Vibe (باٹم)",
  T_23_L_F_B_MIKOGIRL: "Arcticfire Priestess (باٹم)",
  T_23_L_F_B_NAVYGIRL: "Navy Girl (باٹم)",
  T_23_L_F_H_GANGSTERRAP_GOLD: "Big Bucks Vibe (ہیڈ)",
  T_23_L_F_H_MIKOGIRL: "Arcticfire Priestess (ہیڈ)",
  T_23_L_F_H_NAVYGIRL: "Navy Girl (ہیڈ)",
  T_23_L_F_S_MIKOGIRL: "Arcticfire Priestess (جوتے)",
  T_23_L_F_S_ORDERCHALLENGER: "ڈکیتی ماسٹر مائنڈ (جوتے)",
  T_23_L_F_T_GANGSTERRAP_GOLD: "Big Bucks Vibe (ٹاپ)",
  T_23_L_F_T_MIKOGIRL: "Arcticfire Priestess (ٹاپ)",
  T_23_L_F_T_NAVYGIRL: "Navy Girl (ٹاپ)",
  T_23_L_M_A_GANGSTERRAP_GOLD: "Big Bucks Rapper (ماسک)",
  T_23_L_M_B_FOXGUY: "Arcticfire Priest (باٹم)",
  T_23_L_M_B_GANGSTERRAP_GOLD: "Big Bucks Rapper (باٹم)",
  T_23_L_M_H_FOXGUY: "Arcticfire Priest (ہیڈ)",
  T_23_LC_SKS_GEMINI_N: "SKS-Hysteria",
  T_23_O_PENGUIN_NAME: "مسٹر واگور",
  T_23_O_PETSKIN_PENGUIN_A_NAME: "پٹ سکن: پارٹی واگور",
  T_23_O_PETSKIN_PENGUIN_C_NAME: "پٹ سکن: سائبر واگور",
  T_23_O_PETSKIN_PENGUIN_G_NAME: "پٹ سکن: گولڈ واگور",
  T_23_T_ANNI3_LOBBY_NODENAME20: "کلیش اسکواڈ",
  T_23_T_ANNI3_LOBBY_NODENAME5: "کریکٹر",
  T_23_U_AUG: "AUG",
  T_23_Z_R_UID: "UID",
  T_24_AD_ADSPACE_WARNING: "انتباہ",
  T_24_C_FLAMETHROWER_NAME: "آتش گیر",
  T_24_C_SKILL_DESC_PROFESSOR: "میکس  توانائی پوائنٹ میں {0} تک اضافہ ہوتا ہے۔ جیو-جِتسو موڈ: {2} میٹر کے اندر اتحادیوں کو توانائی پوائنٹ تبادلوں کی شرح میں {1}% کا اضافہ ملتا ہے۔ نفسیاتی موڈ: ہر {4} سیکنڈ میں {5} توانائی پوائنٹ کی بحالی کریں، {6} توانائی پوائنٹ تک۔ موڈ سوئچ سی ڈی: {3} سیکنڈ۔",
  T_24_C_SKILL_NAME_PARTYGIRL: "جشن منا رہے ہیں",
  T_24_C_SKILL_NAME_PROFESSOR: "سب کا ماسٹر",
  T_24_D_CHARACTER_PARTYGIRL_N: "داشا",
  T_24_D_CHARACTER_PROFESSOR_N: "کۓ",
  T_24_L_B_MAXPANTS: "MAX پتلونیں",
  T_24_L_H_PUMPKIN2020_A: "Twisted Pumpkin (ہیڈ)",
  T_24_L_T_TSHIRT_COMEDIAN: "آخری شاٹ ہیرو",
  T_24_LC_MP5_RICHBOXER_N: "MP5 - چیمپیئن باکسر",
  T_24_LC_SCAR_PARTYGIRL_N: "سکار - عیاش",
  T_24_LC_SVD_WARRINGSTATES_N: "SVD - تلوار باز لیجنڈز",
  T_24_U_M21A5: "ووڈپیکر",
  T_24_U_PARAFAL: "پارافل",
  T_24_V_TRAINING_AIMBOT_GAMESCORE: "ٹوٹل اسکور",
  T_24_V_TRAINING_BOX_ATTACH: "منسلکات",
  T_24_V_TRAINING_BOX_WEAPON: "ہتھیار",
  T_24_W_ARMORY: "ہتھیار",
  T_24_W_ARMOTY_MELEE: "قریبی وار",
  T_24_W_ARMOTY_PISTOL: "پستول",
  T_24_W_ARMOTY_RIFLE: "رائفل",
  T_24_W_ARMOTY_SHOTGUN: "شاٹگن",
  T_24_W_ARMOTY_SNIPER: "اسنائپرز",
  T_24_W_ARMOTY_SPECIAL: "دوسرے",
  T_24_W_ARMOTY_SUBMACHINE: "سب مشین گن",
  T_24_W_PETSKIN_PANDA_BOOYAHDAY_N: "پِٹ کی جلد: بویاہ پانڈا",
  T_24_W_PETSKIN_RACCOON_BRIGHT_N: "پِٹ کی جلد: ڈھانچا روکی",
  T_24_W_PETSKIN_RACCOON_MECH_N: "پِٹ کی جلد: پارٹی روکی",
  T_24_W_PETSKIN_RACCOON_UNDEAD_N: "پِٹ کی جلد: انڈیڈ روکی",
  T_24_W_RACCOON_N: "راکی",
  T_25_C_SKILL_NAME_BOUNTYHUNTER: "ٹائم ٹرنر",
  T_25_D_CHARACTER_BOUNTY_N: "کرونو",
  T_25_E_HUD_01: "پیش سیٹ 1",
  T_25_E_HUD_02: "پیش سیٹ 2",
  T_25_L_F_B_DEMONKILLER: "Frenzy Junior (باٹم)",
  T_25_L_F_H_DEMONKILLER: "Frenzy Junior (ہیڈ)",
  T_25_L_F_S_DEMONKILLER: "Frenzy Junior (جوتے)",
  T_25_L_F_T_DEMONKILLER: "Frenzy Junior (ٹاپ)",
  T_25_L_HA_FP_EVIL: "Evil (فیس پینٹ)",
  T_25_L_M_H_ANIMEHAIR: "Breezy (ہیئر)",
  T_25_L_S_MAXSNEAKERS: "میکس جوتے",
  T_25_LC_BASEBALLBAT_BOUNTY_N: "Cyber Swing",
  T_25_LC_GLOO_WINTERFEST2020_N: "گلو وال - ونٹر لینڈز 2020",
  T_25_LC_M1887_WINTERFEST2020_N: "M1887 -ونٹر لینڈ 2020",
  T_25_LC_MACHETE_BOUNTY_N: "Cyber Blade",
  T_25_LC_P90_MUSICFALL_GREEN_N: "P90-Tune Blaster Green",
  T_25_LC_P90_MUSICFALL_RED_N: "P90 - ٹیون بلاسٹر ریڈ",
  T_25_LC_PAN_BOUNTY_N: "فرائی پین - سائبر باؤنٹی ہنٹر",
  T_25_R_LEGEND_REMIND: "یاد دہانی",
  T_25_U_MAG7: "MAG-7",
  T_25_U_SICKLE: "Scythe",
  T_25_U_VECTOR: "ویکٹر",
  T_25_W_BABOON_N: "بیسٹن",
  T_25_W_PETSKIN_BABOON_FROZEN_N: "پِٹ کی جلد: گلیشیر بیسٹن",
  T_25_W_PETSKIN_BABOON_HELL_N: "پِٹ کی جلد: بلیزنگ بیسٹن",
  T_25_W_PETSKIN_BABOON_PURE_N: "پِٹ کی جلد: گریٹ وائٹ بیسٹن",
  T_25_W_PETSKIN_PANTHER_WINTERFEST2020_N: "پِٹ کی جلد: برف پینتھر",
  T_25_Z_R_SIMULATOR_OFF: "اجازت نہ دیں",
  T_26_C_SKILL_DESC_SUPERSTAR: "{0} میٹر تک آواز کی لہر کو آگے بڑھاتا ہے۔ لہر کے پھٹنے سے دھماکہ ہوتا ہے  ہے جو {2} سیکنڈ کے لیے {1} میٹر کے ریڈیس میں گلو والز کو نقصان پہنچاتا ہے۔ کولڈاؤن: {3}سیکنڈ۔",
  T_26_C_SKILL_NAME_SUPERSTAR: "رپٹائڈ تال",
  T_26_D_CHARACTER_DELIVERY_N: "شیرو",
  T_26_D_CHARACTER_SUPERSTAR_N: "اسکائیلر",
  T_26_ET_CELLPHONE_NAME: "یو_اے_وی - Lite",
  T_26_L_A_FLAMING_PREM: "Infernal Soldier (ماسک)",
  T_26_L_A_SANTAMODE: "Snowman Bob (ماسک)",
  T_26_L_B_SANTAMODE: "Snowman Bob (باٹم)",
  T_26_L_F_B_WATERFEST21_A: "Summer Breeze (باٹم)",
  T_26_L_F_H_WATERFEST21_A: "Summer Breeze (ہیڈ)",
  T_26_L_F_S_WATERFEST21_A: "Summer Breeze (جوتے)",
  T_26_L_F_T_WATERFEST21_A: "Summer Breeze (ٹاپ)",
  T_26_L_M_A_EGGDAY2021: "سائبر خرگوش (ماسک)",
  T_26_L_M_B_EGGDAY2021: "سائبر خرگوش (باٹم)",
  T_26_L_M_B_PAIRING: "متحرک جوڑی مردانہ (باٹم)",
  T_26_L_M_B_WATERFEST21_A: "Summer Wave (باٹم)",
  T_26_L_M_H_EGGDAY2021: "سائبر خرگوش (ہیڈ)",
  T_26_L_M_H_PAIRING: "متحرک جوڑی مردانہ (ہیڈ)",
  T_26_L_M_H_WATERFEST21_A: "Summer Wave (ہیڈ)",
  T_26_L_M_S_EGGDAY2021: "سائبر خرگوش (جوتے)",
  T_26_L_M_S_PAIRING: "متحرک جوڑی مردانہ (جوتے)",
  T_26_L_M_S_WATERFEST21_A: "Summer Wave (جوتے)",
  T_26_L_M_T_EGGDAY2021: "سائبر خرگوش (ٹاپ)",
  T_26_L_M_T_PAIRING: "متحرک جوڑی مردانہ (ٹاپ)",
  T_26_L_M_T_WATERFEST21_A: "Summer Wave (tAP)",
  T_26_L_S_SANTAMODE: "Snowman Bob (جوتے)",
  T_26_L_T_SANTAMODE: "Snowman Bob (ٹاپ)",
  T_26_LC_AWM_KOICARP_N: "AWM-لکی Koi",
  T_26_LC_KATANA_VALENTINE2021_N: "کٹانا- سیزن گلابی",
  T_26_LC_VEHICLE_ROADSTER_COBRA_N: "اسپورٹس کار - کوبرا",
  T_26_P_SKILL_NAME_DELIVERY: "نقصان پہنچایا گیا",
  T_26_V_TRAINING_BHH: "فینسی ہتھوڑا",
  T_26_V_TRAINING_DICE: "بہت بڑا ڈائس",
  T_26_W_DRAGON_N: "ڈریکی",
  T_26_W_PETSKIN_DRAGON_EVIL_N: "پِٹ کی جلد: سپلیشی ڈریکی",
  T_26_W_PETSKIN_DRAGON_GOLDEN_N: "پِٹ کی جلد: زیپنگ ڈریکی",
  T_26_W_PETSKIN_DRAGON_PURPLE_N: "پِٹ کی جلد: گلیکسی ڈریکی",
  T_26_W_PETSKIN_PENGUIN_VALENTINE2021_N: "پِٹ کی جلد: محبت میں ویگور",
  T_26_XL_SETTING_TEAMMATE_INFO: "ٹیم کے ساتھی کی معلومات",
  T_26_YP_HISTORY_WIN: "فتح",
  T_26_YP_SOCIAL_GENDER_FEMALE: "زنانہ",
  T_26_YP_SOCIAL_GENDER_MALE: "مردانہ",
  T_26_YP_SOCIAL_NAME: "چھوٹا نام",
  T_27_C_SKILL_DESC__RACERGIRL: "ڈرائیونگ کی رفتار میں {0}٪ اضافہ ہوتا ہے۔ گاڑی میں رہتے ہوئے، کردار کا مقصد زیادہ مشکل ہے اور ہونے والے نقصان میں {1}% کی کمی واقع ہوتی ہے۔",
  T_27_C_SKILL_DESC_BOUNTYHUNTER: "ایک ناقابل تسخیر قوت فیلڈ بناتا ہے جو {0} نقصانات کو روکتا ہے۔ میدان کے اندر سے باہر کے دشمنوں پر حملہ کرنے سے قاصر۔ تمام اثرات {1} سیکنڈ تک رہتے ہیں۔ تبریدی مدت {2} سیکنڈ۔",
  T_27_C_SKILL_DESC_FALCONER: "نقصان فاصلے کے ساتھ {0}٪ تک بڑھ جاتا ہے۔ نشان زد دشمنوں کو پہنچنے والے نقصان میں {1}٪ کا اضافہ",
  T_27_C_SKILL_DESC_HAYATO_AWAKENING: "بیداری: ہر {0}% زیادہ سے زیادہ ہیلتھ پوائنٹ نقصان کےلئے سامنے سے نقصان کو {1}٪ سے کم کرتا ہے۔",
  T_27_C_SKILL_DESC_KELLY_AWAKENING: "بیداری: چالو کرنے کے لئے {0} سیکنڈ کے لئے سپرنٹ۔ جب چالو ہوجاتا ہے تو ہدف پر پہلی {2} گولی مار کر {1}٪ کو نقصان پہنچاتا ہے۔ {3} سیکنڈ تک رہتا ہے۔",
  T_27_C_SKILL_NAME_FALCONER: "فالکن جوش",
  T_27_C_SKILL_NAME_XTREME: "شدید لڑائی",
  T_27_D_CHARACTER_ANDREW_AWAKENING_N: "اینڈریو خطرناک",
  T_27_D_CHARACTER_FALCONER_N: "مارؤ",
  T_27_D_CHARACTER_XTREME_N: "زائین",
  T_27_F_EAP_PKG3_D: "!بیٹل ان اسٹائل",
  T_27_HYL_SKILLBOARD_HP: "ہیلتھ پوائنٹ",
  T_27_L_A_CARDBOARD_MID2: "Tiger Papercut (ماسک)",
  T_27_L_B_CARDBOARD_REG: "Grizzly Papercut (باٹم)",
  T_27_L_M_S_KAZAKHSTAN: "The Baghatur (جوتے)",
  T_27_L_S_CARDBOARD_REG: "Grizzly Papercut (جوتے)",
  T_27_L_T_CARDBOARD_REG: "Grizzly Papercut (ٹاپ)",
  T_27_LC_VECTOR_FFWS2021_N: "ویکٹر - FFWS 2021",
  T_27_LC_VEHICLE_MONSTER_FFWS2021_N: "مونسٹر ٹرک - ایف_ایف_ڈبلیو_ایس 2021",
  T_27_LC_VEHICLE_MOTOBIKE_BOXER_N: "موٹربائیک - کے.او. رات",
  T_27_LC_VEHICLE_ROADSTER_FASTBREAKING_N: "اسپورٹس کار - Emerald Flash",
  T_27_LC_VEHICLE_SUV_DRAGON_N: "پک اپ ٹرک - شعلہ ڈریکو",
  T_27_P_SKILL_NAME_HITMAN_RE: "بلکل خاموش",
  T_27_R_EMOTE_GREETING_NAME: "سلام",
  T_27_R_VEHICLE_ACCELERATION: "ایکسلریشن",
  T_27_R_VEHICLE_HP: "استحکام",
  T_27_R_VEHICLE_SPEED: "تیز رفتار",
  T_27_U_KORD: "Kord",
  T_27_U_M1917: "M1917",
  T_27_U_SKILL_DESC_ANDREW_AWAKENING: "بیداری: آرمر کو پہنچنے والے نقصان میں کمی کو {0}% بڑھایا گیا۔ اس مہارت کو رکھنے والے ہر ساتھی سے اضافی 15% نقصان میں کمی۔",
  T_27_U_SKILL_NAME_ANDREW_AWAKENING: "بھیڑیا پیک",
  T_27_U_WSP: "USP-2",
  T_27_W_ALIEN_N: "مونی",
  T_27_W_ARMOTY_DMR: "مارکس مین رائفل",
  T_27_W_PETSKIN_ALIEN_CRYSTAL_N: "پِٹ کی جلد: کرسٹل مونی",
  T_27_W_PETSKIN_ALIEN_GAMER_N: "پِٹ کی جلد: گیمر مونی",
  T_27_W_PETSKIN_ALIEN_HIPSTER_N: "پِٹ کی جلد: ہپسٹر مونی",
  T_27_W_PETSKIN_DOG_FFWS2021_N: "پِٹ کی جلد: ایف_ایف_ڈبلیو_ایس 2021 پپ",
  T_27_W_PETSKIN_PANDA_FFWS2021_N: "پِٹ کی جلد: ایف_ایف_ڈبلیو_ایس 2021 پانڈا",
  T_27_XC_REPLAY_DIE: "موت",
  T_27_XC_REPLAY_KILL: "خاتمہ",
  T_27_XL_WEREWOLVES_INGAME_REPAIR: "مرمت",
  T_28_C_G_ICE_NAME: "فلیش فریز",
  T_28_C_SKILL_DESC_STREETBEAT: "جب حرکت کرتے ہوئے فائرنگ کرتے ہو تو نقل و حرکت کی رفتار {0}% بڑھ جاتی ہے، درستگی میں {1}% اضافہ ہوتا ہے۔",
  T_28_C_SKILL_NAME_STREETBEAT: "گولی والی بیٹ",
  T_28_D_CHARACTER_STREETBEAT_N: "ڈی-بی",
  T_28_HI_UZI: "مینی اوزی",
  T_28_L_B_BRJERSEY_A: "No.23 Soccer Jersey (پتلون)",
  T_28_L_B_BRJERSEY_B: "No.10 Soccer Jersey (پتلون)",
  T_28_L_B_BRJERSEY_C: "No.24 Soccer Jersey (پتلون)",
  T_28_L_B_BRJERSEY_D: "No.30 Soccer Jersey (پتلون)",
  T_28_L_B_BRJERSEY_E: "No.1 Soccer Jersey (پتلون)",
  T_28_L_B_BRJERSEY_F: "No.20 Soccer Jersey (پتلون)",
  T_28_L_F_B_FOURSYMBOLS_C: "Vermilion Whirlwind (پتلون)",
  T_28_L_F_H_FOURSYMBOLS_C: "Vermilion Whirlwind (سر)",
  T_28_L_F_HA_FOURSYMBOLS_C: "Vermilion Whirlwind (فیس پینٹ)",
  T_28_L_F_S_FOURSYMBOLS_C: "Vermilion Whirlwind (جوتے)",
  T_28_L_F_T_FOURSYMBOLS_C: "Vermilion Whirlwind (شرٹ)",
  T_28_L_HA_THUNDER: "Lightning Eye (فیس پینٹ)",
  T_28_L_M_A_SPORTSUIT: "Ballsy Skaterboi (ماسک)",
  T_28_L_M_B_FOURSYMBOLS_D: "Shadow Earthshaker (پتلون)",
  T_28_L_M_B_SPORTSUIT: "Ballsy Skaterboi (پتلون)",
  T_28_L_M_H_FOURSYMBOLS_D: "Shadow Earthshaker (سر)",
  T_28_L_M_H_SPORTSUIT: "Ballsy Skaterboi (سر)",
  T_28_L_M_S_FOURSYMBOLS_D: "Shadow Earthshaker (جوتے)",
  T_28_L_M_S_SPORTSUIT: "Ballsy Skaterboi (جوتے)",
  T_28_L_M_T_FALLWINTER: "Sauce Swagger (شرٹ)",
  T_28_L_M_T_FOURSYMBOLS_D: "Shadow Earthshaker (شرٹ)",
  T_28_L_M_T_SPORTSUIT: "Ballsy Skaterboi (شرٹ)",
  T_28_L_T_BRJERSEY_A: "No.23 Soccer Jersey (شرٹ)",
  T_28_L_T_BRJERSEY_B: "No.10 Soccer Jersey (شرٹ)",
  T_28_L_T_BRJERSEY_C: "No.24 Soccer Jersey (شرٹ)",
  T_28_L_T_BRJERSEY_D: "No.30 Soccer Jersey (شرٹ)",
  T_28_L_T_BRJERSEY_E: "No.1 Soccer Jersey (شرٹ)",
  T_28_L_T_BRJERSEY_F: "No.20 Soccer Jersey (شرٹ)",
  T_28_LC_AN94_CRIMSONBRIDE_N: "AN94 - روبی برائڈ",
  T_28_LC_GLOO_FALLWINTER_N: "گلو وال - سوس سوویگر",
  T_28_LC_GLOO_FOURSYMBOLS_N: "گلو وال - سٹارم برنگر",
  T_28_LC_KORD_SHINOBI_N: "Kord - کِل اسپارک شنوبی",
  T_28_LC_M21A5_FANTASYEYE_N: "ووڈپیکر - مرسیلیس نیکرومانسر",
  T_28_LC_MAG7_WHITESHARK_N: "MAG-7 - لیتھل فنسٹوتھ",
  T_28_LC_PAN_FOURSYMBOLS_N: "فرائی پین - Earthshaker Stomp",
  T_28_LC_VEHICLE_JEEP_FOURSYMBOLS_N: "جیپ - سٹارم برنگر",
  T_28_T_WS_ITEM1: "مربع باکس",
  T_28_T_WS_ITEM10: "ہٹ",
  T_28_T_WS_ITEM11: "گارڈ ٹاور",
  T_28_T_WS_ITEM12: "چوکی",
  T_28_T_WS_ITEM13: "گھر A",
  T_28_T_WS_ITEM14: "گھر B",
  T_28_T_WS_ITEM15: "گھر C",
  T_28_T_WS_ITEM16: "ریت کی ساخت",
  T_28_T_WS_ITEM17: "فاؤنٹین",
  T_28_T_WS_ITEM18: "چیری بلوسم",
  T_28_T_WS_ITEM19: "کیلے کا درخت",
  T_28_T_WS_ITEM2: "لمبا باکس",
  T_28_T_WS_ITEM20: "ٹوائلٹ کٹورا",
  T_28_T_WS_ITEM21: "باڑ",
  T_28_T_WS_ITEM3: "جھاڑی",
  T_28_T_WS_ITEM4: "گھاس گنجی",
  T_28_T_WS_ITEM5: "گاڑی",
  T_28_T_WS_ITEM6: "بس",
  T_28_T_WS_ITEM7: "کنٹینر A",
  T_28_T_WS_ITEM8: "کنٹینر B",
  T_28_T_WS_ITEM9: "کنٹینر C",
  T_28_T_WS_TYPE1: "اعتراضات",
  T_28_T_WS_TYPE4: "سجاوٹ",
  T_28_W_DUCK_N: "ڈاکٹر بینی",
  T_28_W_PETSKIN_DRAGON_FOURSYMBOLS_N: "پِٹ کی جلد: میتھوس ڈریکی",
  T_28_W_PETSKIN_DUCK_ARMY_N: "پِٹ کی جلد: سارجنٹ بینی",
  T_28_W_PETSKIN_DUCK_BLACK_N: "پِٹ کی جلد: گینگسٹر بینی",
  T_28_W_PETSKIN_DUCK_SHINY_N: "پِٹ کی جلد: ڈی جے بینی",
  T_28_YF_AR15: "کنگ فشر",
  T_29_C_SKILL_DESC_MOCO_AWAKENING: "بیداری: ہٹ دشمنوں پر نشانات زیادہ دیر تک چلتے ہیں جب دشمن حرکت کرتے ہیں ،، {0}  تک۔",
  T_29_C_SKILL_NAME_MOCO_AWAKENING: "خفیہ آنکھ",
  T_29_C_SKILL_NAME_MUSICBRO_BLACK: "اہم وائب",
  T_29_C_SKILL_NAME_MUSICBRO_WHITE: "دل کی دھڑکن کو ٹھیک کرنا",
  T_29_D_CHARACTER_AMOCO_N: 'موکو "اینگما"',
  T_29_D_CHARACTER_MUSICBRO1_N: "دمتری",
  T_29_D_CHARACTER_MUSICBRO2_N: "تھیوا",
  T_29_HI_MINI14: "AC80",
  T_29_L_B_TRJERSEY: "دھاری دار فٹ بال جرسی (پتلون)",
  T_29_L_M_A_FALCONER_C: "موڈی لاویشر (ماسک)",
  T_29_L_M_A_JUNGLE_GREEN: "کیمو وار ٹرٹل (ماسک)",
  T_29_L_M_B_FALCONER_C: "موڈی لاویشر (پتلون)",
  T_29_L_M_B_JUNGLE_GREEN: "کیمو وار ٹرٹل (پتلون)",
  T_29_L_M_H_FALCONER_C: "موڈی لیوشر (سر) ",
  T_29_L_M_H_JUNGLE_GREEN: " کیمو وار ٹرٹل (سر)  ",
  T_29_L_M_S_FALCONER_C: "موڈی لیوشر (جوتے) ",
  T_29_L_M_S_JUNGLE_GREEN: " کیمو وار ٹرٹل (جوتے)  ",
  T_29_L_M_T_FALCONER_C: "موڈی لیوشر (ٹاپ) ",
  T_29_L_M_T_JUNGLE_GREEN: " کیمو وار ٹرٹل (ٹاپ)  ",
  T_29_L_T_TRJERSEY: "دھاری دار فٹ بال جرسی (ٹاپ) ",
  T_29_M_WS_ITEM22: "ناہموار کنٹینر۔",
  T_29_M_WS_ITEM23: " ناہموار باڑ  ",
  T_29_M_WS_ITEM24: "A سپان پوائنٹ",
  T_29_M_WS_ITEM25: "B سپان پوائنٹ",
  T_29_M_WS_TYPE5: "انٹرایکٹوز",
  T_29_W_PETSKIN_BROWN_TIGER_N: "پیٹ سکن ارتھ سینسے ٹگ",
  T_29_W_PETSKIN_FIRE_TIGER_N: "پیٹ سکن فایر سینسے ٹگ",
  T_29_W_PETSKIN_HAWK_MOCOMONTH_N: "پیٹ سکن سائبر فالکو ",
  T_29_W_PETSKIN_PANDA_MUSICFEST_N: "پیٹ سکن پارٹی پانڈا ",
  T_29_W_PETSKIN_WHITE_TIGER_N: "پِٹ سکن آئس سینسے ٹگ",
  T_29_W_TIGER_NINJA_N: "سینسے ٹگ ",
  T_29_YF_MACHETE_MUSICFEST_N: "ساؤنڈ ویو تھراشر",
  T_29_YF_MAGEZINE_CHAIN_N: "اے آر میگزین",
  T_29_YF_MUZZLE_CRASH_N: "ایس_ایم_جی مزل",
  T_29_YF_MUZZLE_WIDE_N: "شاٹگن مزل",
  T_29_YF_SPAS12_MOCOMONTH_N: "SPAS12- کاسمک ٹیلی پورٹیا",
  T_29_YF_UZI_GOLDENWING_N: "منی عزی - امبر میگاسیفر",
  T_29_YF_VEHICLE_MONSTER_SKELETONTRUCK_N: "مونسٹر ٹرک - گناوینگ راجر",
  T_30_AD_RP_ROUNDEND: "راؤنڈ ختم",
  T_30_AD_TRAINING_SNOWBALL: "سنو بال",
  T_30_AD_TRAINING_SNOWBALL_DES: "آئیے سنوبال سے لڑیں!",
  T_30_C_SKILL_DESC_BOOYAHGUY: "[FFB300]{0}s[-] after being attacked, recover [FFB300]{1}HP[-]/s for [FFB300]{2}s[-]",
  T_30_C_SKILL_NAME_BOOYAHGUY: "بزر بیٹر",
  T_30_C_SKILL_NAME_MUERTOGUY: "میموری مسٹ",
  T_30_D_CHARACTER_BOOYAHGUY_N: "لیون",
  T_30_D_CHARACTER_MUERTOGUY_N: "اوتھو",
  T_30_JMF_SKILLCHIP_NAME_SWATGUY: "جئے کی مائکروچپ",
  T_30_L_A_BRMASCOT_ADULT: "ناراض چوزے کا سر",
  T_30_L_A_BRMASCOT_KIDS: "پیارے چوزے کا سر",
  T_30_L_A_SUGARSKULL21_BANDANA: "موت کے کاٹنے کا ماسک",
  T_30_L_B_BRFOOTBALL_BLACK: "سی بی ایف سوکر جرسی - بلیک (باٹم)",
  T_30_L_B_BRFOOTBALL_GREEN: "سی بی ایف سوکر جرسی - گرین (باٹم)",
  T_30_L_B_BRFOOTBALL_GREY: "سی بی ایف سوکر جرسی - گرے (باٹم)",
  T_30_L_B_BRUNIFORM: "لٹل کینری (باٹم)",
  T_30_L_F_A_SUGARSKULL21: "گولڈریم کوئین (ماسک)",
  T_30_L_F_B_SUGARSKULL21: "گولڈریم کوئین (باٹم)",
  T_30_L_F_B_THASIAN: "کورل ٹربل (باٹم)",
  T_30_L_F_H_CATEARS: "کوائی کان",
  T_30_L_F_H_SUGARSKULL21: "گولڈریم کوئین (ہیڈ)",
  T_30_L_F_H_THASIAN: "کورل ٹربل (ہیڈ)",
  T_30_L_F_S_SUGARSKULL21: "گولڈریم کوئین (جوتے)",
  T_30_L_F_S_THASIAN: "کورل ٹربل (جوتے)",
  T_30_L_F_T_SUGARSKULL21: "گولڈریم کوئین (ٹاپ)",
  T_30_L_F_T_THASIAN: "کورل ٹربل (ٹاپ)",
  T_30_L_H_CHILDRENSDAY_BLUE: "ڈولفن کا سر",
  T_30_L_H_CHILDRENSDAY_RED: "ہاتھی کا سر",
  T_30_L_H_CLOWNHAT: "سرکس ٹوپی - پیلا",
  T_30_L_H_ZASCARF: "بولڈ گولڈ سکارف",
  T_30_L_M_A_LIGHTFEST_GANGSTER: "دیسی گینگسٹر (ماسک)",
  T_30_L_M_A_SUGARSKULL21: "گولڈریم کنگ (ماسک)",
  T_30_L_M_B_LIGHTFEST_GANGSTER: "دیسی گینگسٹر (باٹم)",
  T_30_L_M_B_PKCRICKET: "چیمپ ان گرین (باٹم)",
  T_30_L_M_B_SUGARSKULL21: "گولڈریم کنگ (باٹم)",
  T_30_L_M_B_SUGARSKULL21_CASUAL: "ونڈ ریسر (باٹم)",
  T_30_L_M_B_THASIAN: "کورل ریبیل (باٹم)",
  T_30_L_M_H_LIGHTFEST_GANGSTER: "دیسی گینگسٹر (ہیڈ)",
  T_30_L_M_H_SUGARSKULL21: "گولڈریم کنگ (ہیڈ)",
  T_30_L_M_H_SUGARSKULL21_CASUAL: "ونڈ ریسر (ہیڈ)",
  T_30_L_M_H_THASIAN: "کورل ریبیل (ہیڈ)",
  T_30_L_M_HA_BOOYAHDAY21_YELLOW: "الفا بون ریجر (فیس پینٹ)",
  T_30_L_M_S_LIGHTFEST_GANGSTER: "دیسی گینگسٹر (جوتے)",
  T_30_L_M_S_PKCRICKET: "چیمپ ان گرین (جوتے)",
  T_30_L_M_S_SUGARSKULL21: "گولڈریم کنگ (جوتے)",
  T_30_L_M_S_SUGARSKULL21_CASUAL: "ونڈ ریسر (جوتے)",
  T_30_L_M_S_THASIAN: "کورل ریبیل (جوتے)",
  T_30_L_M_T_LIGHTFEST_GANGSTER: "دیسی گینگسٹر (ٹاپ)",
  T_30_L_M_T_PKCRICKET: "چیمپ ان گرین (ٹاپ)",
  T_30_L_M_T_SUGARSKULL21: "گولڈریم کنگ (ٹاپ)",
  T_30_L_M_T_SUGARSKULL21_CASUAL: "ونڈ ریسر (ٹاپ)",
  T_30_L_M_T_THASIAN: "کورل ریبیل (ٹاپ)",
  T_30_L_S_BRUNIFORM: "لٹل کینری (جوتے)",
  T_30_L_T_BRFOOTBALL_BLACK: "سی بی ایف سوکر جرسی - بلیک (ٹاپ)",
  T_30_L_T_BRFOOTBALL_GREEN: "سی بی ایف سوکر جرسی - گرین (ٹاپ)",
  T_30_L_T_BRFOOTBALL_GREY: "سی بی ایف سوکر جرسی - گرے (ٹاپ)",
  T_30_L_T_BRUNIFORM: "لٹل کینری (ٹاپ)",
  T_30_M_WS_PARTY_MODE: "کھیل کا میدان",
  T_30_R_EMOTE_BATTLEINSTYLE_NAME: "بیٹل ان اسٹائل",
  T_30_R_EMOTE_BOOYAHDAY21_PROVOCATION_NAME: "چیلنجر",
  T_30_R_EMOTE_MAX_NAME: "ریپ سواگ",
  T_30_R_LEGEND_HALO_NAME: "حرارت کا دائرہ",
  T_30_T_WS_DEFAULTDESCRIPTION: "فری فائر کرافٹ لینڈ میں ایک دلچسپ نقشہ",
  T_30_T_WS_ITEM26: "ٹائر",
  T_30_T_WS_ITEM27: "میسی ٹائر A",
  T_30_T_WS_ITEM28: "میسی ٹائر B",
  T_30_T_WS_ITEM29: "میسی ٹائر C",
  T_30_T_WS_ITEM30: "بمپر کار",
  T_30_T_WS_ITEM31: "امفیبیئن کار",
  T_30_T_WS_ITEM32: "جیپ",
  T_30_T_WS_ITEM33: "کچرے دان",
  T_30_T_WS_ITEM34: "شیڈ",
  T_30_T_WS_ITEM35: "میڈیکل ٹینٹ",
  T_30_T_WS_ITEM36: "گیراج",
  T_30_T_WS_ITEM37: "پینٹ والز",
  T_30_T_WS_ITEM38: "توری",
  T_30_T_WS_ITEM39: "آئرن پلیٹ فارم",
  T_30_T_WS_ITEM40: "سائٹ ہٹ",
  T_30_T_WS_ITEM41: "ٹریلر",
  T_30_T_WS_ITEM42: "وال اے",
  T_30_T_WS_ITEM43: "وال بی",
  T_30_T_WS_ITEM44: "وال سی",
  T_30_T_WS_ITEM45: "وال ڈی",
  T_30_T_WS_ITEM46: "وال ای",
  T_30_T_WS_ITEM47: "وال ایف",
  T_30_U_ATTACHMENT_1: "ویسٹ ہیلتھ پوائنٹ بوسٹر",
  T_30_U_ATTACHMENT_4: "ویسٹ بڑھانے والا",
  T_30_U_ATTACHMENT_5: "ہیلمٹ موٹا کرنے والا",
  T_30_U_ATTACHMENT_6: "بنیان موٹا کرنے والا",
  T_30_W_PETSKIN_BABOON_SUGARSKULL21_N: "پٹ اسکن: کھوپڑی کا جانور",
  T_30_W_PETSKIN_PENGUIN_EVILRHYTHM_N: "پٹ اسکن: پنک واگگور",
  T_30_W_PETSKIN_RABBIT_BULLSEYE_N: "پٹ اسکن: بلذ آۓ ایجنٹ ہاپ",
  T_30_W_PETSKIN_RABBIT_CLOWN_N: "پٹ اسکن: کارنیول ایجنٹ ہاپ",
  T_30_W_PETSKIN_RABBIT_URBAN_N: "پٹ اسکن: سائبر ایجنٹ ہاپ",
  T_30_W_PETSKIN_ROBOT_TRNAZAR_N: "پٹ اسکن: نذر روبو",
  T_30_W_PETSKIN_ROBOT_VNDRINK_N: "پٹ اسکن: گرین فریز روبو",
  T_30_W_RABBIT_N: "ایجنٹ ہاپ",
  T_30_XH_PCMAP_P17: "فیکٹری",
  T_30_YF_GLOO_BOOYAHDAY21_N: "گلو وال- بویاہ دن 2021",
  T_30_YF_GRENADE_BOOYAHDAY21_N: "دستی بم- بویاہ دن 2021",
  T_30_YF_Healinggun_Sniper_N: "ٹریٹمنٹ سنائپر",
  T_30_YF_MINI_LIGHTFEST_N: "AC80- رائل واریر",
  T_30_YF_PARAFAL_ZATRIBAL_N: "پیرافل- کرمسن وارث",
  T_30_YF_SCAR_LIGHTFEST_N: "سکار -  رائل واریر",
  T_30_YF_THOMPSON_SUGARSKULL21_N: "تھامسن- گولڈریم خراج تحسین",
  T_30_YF_VEHICLE_ROADSTER_EVILRHYTHM_N: "اسپورٹس کار- کھوپڑی پنکر",
  T_31_C_SKILL_NAME_WINTERGUY: "آئس آئرن",
  T_31_HQ_BASEBALLBAT_WINTERFEST21_N: "ونٹر بیشر",
  T_31_HQ_GLOO_EAGLE_N: "گلو وال - ہیٹ باؤنڈ ڈیزرٹ",
  T_31_HQ_HEALINGSNIPER_WINTERFEST21_N: "ٹریٹمنٹ سنائپر- آئس بونز",
  T_31_HQ_KATANA_WINTERFEST21_N: "کٹانا - سنو ڈوم",
  T_31_HQ_PAN_WINTERFEST21_N: "پین - برف کا عذاب",
  T_31_HQ_PETSKIN_OTTER_WINTERFEST21_N: "پٹ اسکن: سنو اوٹیرو",
  T_31_HQ_PETSKIN_PENGUIN_WINTERFEST21_N: "پٹ اسکن: برف پر واگور",
  T_31_HQ_PETSKIN_YETI_GREEN_N: "پٹ اسکن: قبائلی یتی",
  T_31_HQ_PETSKIN_YETI_RED_N: "پٹ اسکن: آتش گیر یتی",
  T_31_HQ_SICKLE_WINTERFEST21_N: "سنو کی سائیتھ",
  T_31_HQ_VEHICLE_MOTOBIKE_NEWYEAR21_N: "موٹر بائیک- برف کے پھول",
  T_31_HQ_YETI_N: "یتی",
  T_31_KK_WINTER_BUJIX: "سپلائی کریٹ",
  T_31_KK_WINTER_SANJITOU: "ہیلمٹ",
  T_31_L_A_BDCRICKET: "وکٹری بیٹر (ماسک)",
  T_31_L_A_WINTERFEST21: "رینڈیر کوؤر",
  T_31_L_B_BDCRICKET: "وکٹری بیٹر (باٹم)",
  T_31_L_B_MEJERSEY_10: "نمبر 10 روبی جرسی (باٹم)",
  T_31_L_B_MEJERSEY_11: "نمبر 11 ریڈ جرسی (باٹم)",
  T_31_L_B_MEJERSEY_13: "نمبر 13 وائٹ جرسی (باٹم)",
  T_31_L_B_MEJERSEY_18G: "نمبر 18 گرین جرسی (باٹم)",
  T_31_L_B_MEJERSEY_18R: "نمبر 18 میرون جرسی (باٹم)",
  T_31_L_B_MEJERSEY_7: "نمبر 7 باسل جرسی (باٹم)",
  T_31_L_F_B_RUMUSICIAN: "سٹریپڈ ٹرانس (باٹم)",
  T_31_L_F_B_THAGENT: "نائٹ پرووکیٹر (باٹم)",
  T_31_L_F_H_REGGAETON_HEADWEAR: "ٹائی ڈائی بکیٹ",
  T_31_L_F_H_RUMUSICIAN: "سٹریپڈ ٹرانس (ہیڈ)",
  T_31_L_F_H_THAGENT: "نائٹ پرووکیٹر (ہیڈ)",
  T_31_L_F_HA_RUMUSICIAN: "سٹریپڈ ٹرانس (فیس پینٹ)",
  T_31_L_F_S_RUMUSICIAN: "سٹریپڈ ٹرانس (جوتے)",
  T_31_L_F_S_THAGENT: "نائٹ پرووکیٹر (جوتے)",
  T_31_L_F_T_RUMUSICIAN: "سٹریپڈ ٹرانس (ٹاپ)",
  T_31_L_F_T_THAGENT: "نائٹ پرووکیٹر (ٹاپ)",
  T_31_L_HA_RUMUSICIAN_MU: "سٹریپ ٹریپ (فیس پینٹ)",
  T_31_L_HA_WINTERFEST21_BLUE: "فروزن کلاؤن فیس پینٹ",
  T_31_L_HA_WINTERFEST21_PINK: "پنک فائر اسپارکس فیس پینٹ",
  T_31_L_M_A_REGGAETON_B: "نیون ریگیٹن (ماسک)",
  T_31_L_M_A_REGGAETON_P: "وائبرینٹ وینیٹی (ماسک)",
  T_31_L_M_A_RUMUSICIAN: "سٹریپڈ ٹریپ (ماسک)",
  T_31_L_M_A_THAGENT: "نائٹ اسکاؤٹر (ماسک)",
  T_31_L_M_B_PKCOSTUME: "اسمارٹ ان گرین (باٹم)",
  T_31_L_M_B_REGGAETON_B: "نیون ریگیٹن (باٹم)",
  T_31_L_M_B_REGGAETON_P: "وائبرینٹ وینیٹی (باٹم)",
  T_31_L_M_B_RUMUSICIAN: "سٹریپڈ ٹریپ (باٹم)",
  T_31_L_M_B_THAGENT: "نائٹ اسکاؤٹر (باٹم)",
  T_31_L_M_H_GREENCAP: "ونر کیپ",
  T_31_L_M_H_PKCOSTUME: "اسمارٹ ان گرین (ہیڈ)",
  T_31_L_M_H_REGGAETON_B: "نیون ریگیٹن (ہیڈ)",
  T_31_L_M_H_REGGAETON_HEADWEAR: "ٹائی ڈائی ہیٹ",
  T_31_L_M_H_REGGAETON_P: "وائبرینٹ وینیٹی (ہیڈ)",
  T_31_L_M_H_RUMUSICIAN: "سٹریپڈ ٹریپ (ہیڈ)",
  T_31_L_M_H_THAGENT: "نائٹ اسکاؤٹر (ہیڈ)",
  T_31_L_M_S_PKCOSTUME: "اسمارٹ ان گرین (جوتے)",
  T_31_L_M_S_REGGAETON_B: "نیون ریگیٹن (جوتے)",
  T_31_L_M_S_REGGAETON_P: "وائبرینٹ وینیٹی (جوتے)",
  T_31_L_M_S_RUMUSICIAN: "سٹریپڈ ٹریپ (جوتے)",
  T_31_L_M_S_THAGENT: "نائٹ اسکاؤٹر (جوتے)",
  T_31_L_M_T_PKCOSTUME: "اسمارٹ ان گرین (ٹاپ)",
  T_31_L_M_T_REGGAETON_B: "نیون ریگیٹن (ٹاپ)",
  T_31_L_M_T_REGGAETON_P: "وائبرینٹ وینیٹی (ٹاپ)",
  T_31_L_M_T_REGGAETON_TATOO: "فیمیلیا انک",
  T_31_L_M_T_RUMUSICIAN: "سٹریپڈ ٹریپ (ٹاپ)",
  T_31_L_M_T_THAGENT: "نائٹ اسکاؤٹر (ٹاپ)",
  T_31_L_S_BDCRICKET: "وکٹری بیٹر (جوتے)",
  T_31_L_T_BDCRICKET: "وکٹری بیٹر (ٹاپ)",
  T_31_L_T_BRBANK: "مارون بومبر",
  T_31_L_T_MEJERSEY_10: "نمبر 10 روبی جرسی (ٹاپ)",
  T_31_L_T_MEJERSEY_11: "نمبر 11 ریڈ جرسی (ٹاپ)",
  T_31_L_T_MEJERSEY_13: "نمبر 13 وائٹ جرسی (ٹاپ)",
  T_31_L_T_MEJERSEY_18G: "نمبر 18 گرین جرسی (ٹاپ)",
  T_31_L_T_MEJERSEY_18R: "نمبر 18 میرون جرسی (ٹاپ)",
  T_31_L_T_MEJERSEY_7: "نمبر 7 باسل جرسی (ٹاپ)",
  T_31_L_T_PKMOBILE: "انفینکس ٹی-شرٹ",
  T_31_L_T_REGGAETON_HOOD: "گینگ سمائل ہوڈی",
  T_31_MF_CHARACTER_WINTERGUY_N: "نیری",
  T_31_R_EMOTE_FALCONER_NAME: "نمبر 1",
  T_31_RW_COMBINEMACHINE_2: "اکمبو ایکٹیویٹر (ایڈوانسڈ)",
  T_31_RW_VIBRATION_EXPLOSION: "دھماکے",
  T_31_RW_VIBRATION_MELEEWEAPONS: "قریبی وار ہتھیار",
  T_31_RW_VIBRATION_OTHERWEAPONS: "دوسری بندوقیں",
  T_31_T_WS_1PLAYERTEAM: "اکیلے",
  T_31_T_WS_2PLAYERTEAM: "جوڑی",
  T_31_T_WS_3PLAYERTEAM: "تگڈم",
  T_31_T_WS_4PLAYERTEAM: "اسکوڈ",
  T_31_T_WS_5PLAYERTEAM: "بمقابلہ 5",
  T_31_T_WS_6PLAYERTEAM: "بمقابلہ 6",
  T_31_T_WS_BUFFTIME_TITLE: "ریفریش ٹائم",
  T_31_T_WS_BUFFTYPE_AMMO: "بارود",
  T_31_T_WS_BUFFTYPE_ARMOR: "آرمر",
  T_31_T_WS_BUFFTYPE_HP: "ہیلتھ پوائنٹ",
  T_31_T_WS_BUFFTYPE_RANDOM: "بے ترتیب",
  T_31_T_WS_BUFFTYPE_TITLE: "بف کی قسم",
  T_31_T_WS_DESC48: "ملی سیکنڈ میں آپ کو دوسری جگہ لے جاتا ہے",
  T_31_T_WS_DESC49: "پیانو کی آواز پیدا کرتا ہے",
  T_31_T_WS_DESC51: "ڈھول کی آواز پیدا کرتا ہے",
  T_31_T_WS_DESC53: "ایک سنتھیسائزر کی آواز پیدا کرتا ہے",
  T_31_T_WS_DESC59: "ایک آلہ جو وقتاً فوقتاً بف پیدا کرتا ہے۔ متعلقہ اضافہ حاصل کرنے کے لیے اسے اٹھائیں",
  T_31_T_WS_DRUMTYPE_CLAPS: "تالی",
  T_31_T_WS_DRUMTYPE_HIHATS: "ہائی ہیٹ",
  T_31_T_WS_DRUMTYPE_KICK: "کک ڈرم",
  T_31_T_WS_DRUMTYPE_OPENHIHATS: "ہائی ہیٹ کھل رہی ہے",
  T_31_T_WS_DRUMTYPE_RIDES: "سواری سمبل",
  T_31_T_WS_DRUMTYPE_SNARES: "سنیئرڈرم",
  T_31_T_WS_EARLYSHRINK: "فوری سکڑا",
  T_31_T_WS_ITEM48: "پورٹل",
  T_31_T_WS_ITEM49: "پیانو کی",
  T_31_T_WS_ITEM51: "ڈرم کی",
  T_31_T_WS_ITEM53: "کومبو کی اے",
  T_31_T_WS_ITEM55: "کومبو کی بی",
  T_31_T_WS_ITEM57: "کومبو کی C",
  T_31_T_WS_ITEM59: "بف جنریٹر",
  T_31_T_WS_LATESHRINK: "دیر سے سکڑا",
  T_31_T_WS_ME_DAMAGE: "نقصان پہنچا",
  T_31_T_WS_ME_DAMAGED: "نقصان اٹھایا گیا",
  T_31_T_WS_ME_DEFAULTEPPERCENT: "ابتدائی  توانائی پوائنٹ تناسب",
  T_31_T_WS_ME_DEFAULTSAFERADIUS: "پہلے سیف زون کا ریڈیس",
  T_31_T_WS_ME_EPQUICKRESTORE: "فوری توانائی پوائنٹ کی تبدیلی",
  T_31_T_WS_ME_FLOW: "موڈ",
  T_31_T_WS_ME_GENERALSETTING: "جنرل",
  T_31_T_WS_ME_INRANDOMSPAWN: "بے ترتیب سپان پوائنٹ",
  T_31_T_WS_ME_KILLSCORE: "کِل بونس",
  T_31_T_WS_ME_MAXEP: "زیادہ سے زیادہ توانائی پوائنٹ",
  T_31_T_WS_ME_MAXHP: "زیادہ سے زیادہ ہیلتھ پوائنٹ",
  T_31_T_WS_ME_NEARTEAM: "ساتھیوں کے قریب",
  T_31_T_WS_ME_REBIRTH: "ریسپان انتظار کا وقت",
  T_31_T_WS_ME_REBIRTHLOCATION: "ریسپان مقام",
  T_31_T_WS_ME_SAFEZONESHRINKTIME: "زون سکڑنے کے شروع ہونے کا وقت",
  T_31_T_WS_ME_WINSCORE: "جیتنے کا اسکور",
  T_31_T_WS_MINIZONE: "منی زون",
  T_31_T_WS_MUSICTYPE_TITLE: "موسیقی کی قسم",
  T_31_T_WS_UNLIMITEDAMMO: "بے تحاشا بارود",
  T_31_WT_WS_DESC1: "ایک چوکور لکڑی کا ڈبہ جسے سجایا جا سکتا ہے",
  T_31_WT_WS_DESC10: "اوپر چڑھنے کے لیے لکڑی کی سیڑھیوں کے ساتھ ایک رن ڈاون جھونپڑی",
  T_31_WT_WS_DESC11: "شوٹنگ کے مقاصد کے لیے متعدد کھڑکیوں کے ساتھ بنایا گیا ہے",
  T_31_WT_WS_DESC12: "دھات سے بنا ہوا اور دروازے اور کھڑکیاں پر مشتمل ہے",
  T_31_WT_WS_DESC13: "دروازے اور کھڑکیوں پر مشتمل ہے",
  T_31_WT_WS_DESC14: "چھت والا دو منزلہ مکان",
  T_31_WT_WS_DESC15: "مکمل بند چھت والا دو منزلہ مکان",
  T_31_WT_WS_DESC16: "سجاوٹ - دل کے سائز کا ریت کا مجسمہ",
  T_31_WT_WS_DESC17: "سجاوٹ - کرسٹل-کلیئر پانی کا چشمہ",
  T_31_WT_WS_DESC18: "سجاوٹ - گلابی پھولوں کا ایک درخت",
  T_31_WT_WS_DESC19: "سجاوٹ - کیلے کے بغیر کیلے کا ایک چھوٹا درخت",
  T_31_WT_WS_DESC2: "ایک مستطیل لکڑی کا ڈبہ جسے سجایا جا سکتا ہے",
  T_31_WT_WS_DESC20: "باتھ روم کا ایک سفید فرنیچر جسے گھر کے اندر رکھا جا سکتا ہے",
  T_31_WT_WS_DESC21: "ایک چھوٹی باڑ جو علاقوں کو تقسیم کرنے کے لیے استعمال کی جا سکتی ہے",
  T_31_WT_WS_DESC22: "اس کنٹینر کے سائیڈ ووڈن بورڈ کو طاقت سے توڑا جا سکتا ہے",
  T_31_WT_WS_DESC23: "ایک چھوٹی سی باڑ جسے طاقت سے توڑا جا سکتا ہے",
  T_31_WT_WS_DESC24: "ٹیم A  کے لیے سپان ایریا (صرف کلیش اسکواڈ، ٹیم ڈیتھ میچ، اور پلے گراؤنڈ موڈز میں درست)",
  T_31_WT_WS_DESC25: "ٹیم B  کے لیے سپان ایریا (صرف کلیش اسکواڈ، ٹیم ڈیتھ میچ، اور پلے گراؤنڈ موڈز میں درست)",
  T_31_WT_WS_DESC26: "تھوڑے فاصلے کے لیے کھلاڑیوں کو جس سمت کا سامنا کرنا پڑتا ہے اس کی طرف باؤنس کر دیتا ہے",
  T_31_WT_WS_DESC27: "کھلاڑیوں کو پہلے سے طے شدہ سمت میں، تھوڑے فاصلے کے لیے باؤنس کرتا ہے",
  T_31_WT_WS_DESC28: "درمیانے فاصلے تک کھلاڑیوں کو پہلے سے طے شدہ سمت میں باؤنس کرتا ہے",
  T_31_WT_WS_DESC29: "کھلاڑیوں کو پہلے سے طے شدہ سمت میں باؤنس کرتا ہے، لمبے فاصلے تک",
  T_31_WT_WS_DESC3: "سرخ اور پیلے رنگ کے پھولوں سے مزین جو آپ کے میدان جنگ کو روشن کر سکتے ہیں",
  T_31_WT_WS_DESC30: "ایک بمپر کار جو چلائی جا سکتی ہے",
  T_31_WT_WS_DESC31: "ایک ایمفیبیئن کار جسے چلایا جا سکتا ہے",
  T_31_WT_WS_DESC32: "ایک جیپ جو چلائی جا سکتی ہے",
  T_31_WT_WS_DESC33: "کچرے سے بھرا ہوا ہے۔ انسان سے چھوٹا لیکن کچھ کور فراہم کر سکتا ہے",
  T_31_WT_WS_DESC34: "کھلی ہوا، دھاتی ریس ٹریک پناہ گاہ",
  T_31_WT_WS_DESC35: "ایک درمیانے سائز کا خیمہ جس میں دو دروازے ہیں لیکن کھڑکیاں نہیں ہیں",
  T_31_WT_WS_DESC36: "اینٹوں سے بنا ہوا ایک بڑا گیراج",
  T_31_WT_WS_DESC37: "اینٹوں کی ایک بڑی دیوار جو علاقوں کو تقسیم کرنے کے لیے استعمال کی جا سکتی ہے",
  T_31_WT_WS_DESC38: "ایک مفید نشان",
  T_31_WT_WS_DESC39: "ایک بڑا دھاتی پلیٹ فارم جو لڑائی کے اہم گڑھے کے طور پر استعمال ہو سکتا ہے",
  T_31_WT_WS_DESC4: "ایک انسان سے لمبا اور اس وجہ سے کور کے طور پر کام کر سکتا ہے",
  T_31_WT_WS_DESC40: "تفریحی گاڑی کی طرح لگتی ہے اور اس میں متعدد دروازے اور کھڑکیاں ہیں",
  T_31_WT_WS_DESC41: "تفریحی گاڑی کی طرح لگتی ہے اور اس میں ایک دروازہ اور متعدد کھڑکیاں ہیں",
  T_31_WT_WS_DESC42: "داخلی دروازے کے ساتھ یک طرفہ دیوار",
  T_31_WT_WS_DESC43: "ایک باقاعدہ یک طرفہ دیوار",
  T_31_WT_WS_DESC44: "دیوار کا ایک کونا",
  T_31_WT_WS_DESC45: "دیوار کا ایک ناہموار کونا",
  T_31_WT_WS_DESC46: "دیوار کا ایک ناہموار کونا",
  T_31_WT_WS_DESC47: "کھڑکیوں کے ساتھ دیوار کا کونا",
  T_31_WT_WS_DESC5: "ایک لاوارث کار جو انسان سے تھوڑی چھوٹی ہے لیکن کچھ کور فراہم کر سکتی ہے",
  T_31_WT_WS_DESC6: "ایک انسان سے لمبا اور اس وجہ سے کور کے طور پر کام کر سکتا ہے",
  T_31_WT_WS_DESC7: "دونوں سروں پر کھلے ہیں اور راستے بنانے یا علاقوں کو تقسیم کرنے میں استعمال کیا جا سکتا ہے",
  T_31_WT_WS_DESC8: "ایک سرے سے کھلا اور علاقوں کو تقسیم کرنے کے لیے استعمال کیا جا سکتا ہے",
  T_31_WT_WS_DESC9: "دونوں سروں پر بند اور علاقوں کو تقسیم کرنے کے لیے استعمال کیا جا سکتا ہے",
  T_31_YF_MAC10_N: "MAC10",
  T_31_YM_PIN_VEHICLE: "گاڑی",
  T_31_Z_OB_UAV: "یو_اے_وی",
  T_32_C_SKILL_DESC_YAKUZA: "{0} سیکنڈ کے لیے تیز رفتاری سے آگے ڈیش کرتا ہے۔ ڈیش کرنے کا وقت: {1} سیکنڈ۔ اس مہارت کو ہر استعمال کے درمیان 5 سیکنڈ کے کولڈاؤن کے ساتھ، {2}  مرتبہ استعمال تک کے لیے جمع کیا جا سکتا ہے۔",
  T_32_C_SKILL_NAME_YAKUZA: "باغی رش",
  T_32_HQ_AUG_VNSTREET_N: "AUG- رورنگ گن فائٹر",
  T_32_HQ_BACKPACK_REDDRAGON_N: "ڈان لِٹ ڈریگو بیگ",
  T_32_HQ_BLT_VALENTINE2022_N: "M82B- ویمپائر میلولنس",
  T_32_HQ_GLOO_DUNHUANG_N: "گلو وال- فروزن پلاٹینم",
  T_32_HQ_GLOO_HURRICANE_2_N: "گلو وال - ارورہ کور",
  T_32_HQ_GRENADE_HURRICANE_N: "گرینیڈ - براسی مائک",
  T_32_HQ_MAC10_DUNHUANG_N: "MAC10- فروزن پلاٹینم",
  T_32_HQ_PETSKIN_DUCK_RED_N: "پٹ سکن: ریڈ بینی",
  T_32_HQ_PETSKIN_TORTOISE_BLUE_N: "پٹ سکن: سائبر فلیش",
  T_32_HQ_PETSKIN_TORTOISE_GREEN_N: "پٹ سکن: گیمر فلیش",
  T_32_HQ_PETSKIN_TORTOISE_RED_N: "پٹ سکن: تہوار کی فلیش",
  T_32_HQ_TORTOISE_N: "فلیش",
  T_32_HQ_VEHICLE_ROADSTER_UNDERTAKER_N: "اسپورٹس کار- بریڈ پرپلڈسٹ",
  T_32_L_F_A_PHARAOH: "گولڈ کوٹیڈ کلیو (ماسک)",
  T_32_L_F_B_PHARAOH: "گولڈ کوٹیڈ کلیو (باٹم)",
  T_32_L_F_H_PHARAOH: "گولڈ کوٹیڈ کلیو (ہیڈ)",
  T_32_L_F_HA_PHARAOH: "گولڈ کوٹیڈ کلیو (فیس پینٹ)",
  T_32_L_F_S_PHARAOH: "گولڈ کوٹیڈ کلیو (جوتے)",
  T_32_L_F_T_PHARAOH: "گولڈ کوٹیڈ کلیو (ٹاپ)",
  T_32_L_M_A_JUNKFOOD: "برگر لیڈ (ماسک)",
  T_32_L_M_A_PHARAOH: "گولڈ لائنڈ ممی (ماسک)",
  T_32_L_M_B_JUNKFOOD: "برگر لیڈ (باٹم)",
  T_32_L_M_B_PHARAOH: "گولڈ لائنڈ ممی (باٹم)",
  T_32_L_M_H_JUNKFOOD: "برگر لیڈ (ہیڈ)",
  T_32_L_M_H_PHARAOH: "گولڈ لائنڈ ممی (ہیڈ)",
  T_32_L_M_S_JUNKFOOD: "برگر لیڈ (جوتے)",
  T_32_L_M_S_PHARAOH: "گولڈ لائنڈ ممی (جوتے)",
  T_32_L_M_T_JUNKFOOD: "برگر لیڈ (ٹاپ)",
  T_32_L_M_T_PHARAOH: "گولڈ لائنڈ ممی (ٹاپ)",
  T_32_L_T_WHITESWEATER: "وائٹ ٹرٹل نیک",
  T_32_LC_NEWVAULT_EMOTE: "ایموٹ",
  T_32_LO_WS_IMMORTAL: "لافانی زون",
  T_32_LO_WS_ITEM60: "پائپ",
  T_32_LO_WS_ITEM60_DESC: "چلنے کے قابل سرنگ",
  T_32_LO_WS_ITEM61: "ٹی پائپ",
  T_32_LO_WS_ITEM61_DESC: "چلنے کے قابل ٹی سرنگ",
  T_32_LO_WS_ITEM62: "پائپ چوراہا",
  T_32_LO_WS_ITEM62_DESC: "چلنے کے قابل ایک دوسرے کو ملانے والی سرنگ",
  T_32_LO_WS_ITEM63: "پائپ کارنر",
  T_32_LO_WS_ITEM63_DESC: "چلنے کے قابل زاویہ والی سرنگ",
  T_32_LO_WS_ITEM64: "فوڈ ٹرک",
  T_32_LO_WS_ITEM64_DESC: "ایک بائٹ کے لئے یہاں رکیں",
  T_32_LO_WS_ITEM65: "مش شیڈ",
  T_32_LO_WS_ITEM65_DESC: "ایک بڑا مشروم جو انسان کو لے جا سکتا ہے",
  T_32_LO_WS_ITEM66: "ہینگر",
  T_32_LO_WS_ITEM66_DESC: "عام طور پر رہائشی علاقوں میں دیکھا جاتا ہے۔",
  T_32_LO_WS_ITEM67: "لکڑی کا تختہ",
  T_32_LO_WS_ITEM67_DESC: "ایک سادہ لکڑی کا پل بنانے کے لیے استعمال کریں",
  T_32_LO_WS_ITEM68: "جالی سکرین",
  T_32_LO_WS_ITEM68_DESC: "ایک اورینٹل احساس",
  T_32_LO_WS_ITEM69: "ستون",
  T_32_LO_WS_ITEM69_DESC: "عام طور پر تعمیراتی مقامات پر دیکھا جاتا ہے",
  T_32_LO_WS_ITEM70: "کیکٹس",
  T_32_LO_WS_ITEM70_DESC: "بہت بڑا لیکن ڈنک نہیں مارتا",
  T_32_LO_WS_ITEM71: "لیف لیس ٹری",
  T_32_LO_WS_ITEM71_DESC: "ایک درخت جو صدیوں سے زندہ ہے",
  T_32_LO_WS_ITEM72: "پتھر کی لالٹین",
  T_32_LO_WS_ITEM72_DESC: "شاہی باغات میں قدرتی سجاوٹ",
  T_32_LO_WS_ITEM73: "اسٹریٹ لیمپ",
  T_32_LO_WS_ITEM73_DESC: "عام طور پر سڑکوں پر دیکھا جاتا ہے",
  T_32_LO_WS_ITEM74: "سولر پینل",
  T_32_LO_WS_ITEM74_DESC: "سورج کی روشنی سے توانائی جذب کرتا ہے",
  T_32_LO_WS_ITEM75: "ائیر کنڈشنر A",
  T_32_LO_WS_ITEM75_DESC: "گرمی میں ٹھنڈے رہیں",
  T_32_LO_WS_ITEM76: "پنکھا",
  T_32_LO_WS_ITEM77: "فلائی پین",
  T_32_LO_WS_ITEM78: "کیوب",
  T_32_LO_WS_ITEM79: "انگوٹھی",
  T_32_LO_WS_ITEM80: "ہیمر",
  T_32_LO_WS_ITEM81: "بورڈ",
  T_32_LO_WS_ITEM82: "شوٹنگ کا ہدف",
  T_32_LO_WS_ITEM83: "فلیکس وال",
  T_32_LO_WS_ITEM84AMMO: "بارود لوٹ پوائنٹ",
  T_32_LO_WS_ITEM84AMMO_DESC: "جب رکھا جائے گا، منتخب بارود کی قسمیں وہاں سپان ہو جائیں گی",
  T_32_LO_WS_ITEM84AR: "آرمر لوٹ پوائنٹ",
  T_32_LO_WS_ITEM84AR_DESC: "رکھے جانے پر، منتخب آرمر قسمیں وہاں پھیل جائیں گی",
  T_32_LO_WS_ITEM84ARLV1: "آرمر لیول 1",
  T_32_LO_WS_ITEM84ARLV2: "آرمر لیول 2",
  T_32_LO_WS_ITEM84ARLV3: "آرمر لیول 3",
  T_32_LO_WS_ITEM84CO: "استعمال کی اشیاء لوٹ پوائنٹ",
  T_32_LO_WS_ITEM84CO_DESC: "جب رکھا جائے گا، منتخب قابل استعمال قسمیں وہاں پھیل جائیں گی",
  T_32_LO_WS_ITEM84JA: "تھرو ایبلز لوٹ پوائنٹ",
  T_32_LO_WS_ITEM84JA_DESC: "جب رکھا جائے گا، منتخب سپان کے قابل قسمیں وہاں پھیل جائیں گی",
  T_32_LO_WS_ITEM84TE: "اسکوپس لوٹ پوائنٹ",
  T_32_LO_WS_ITEM84TE_DESC: "رکھے جانے پر، منتخب دائرہ کار کی قسمیں وہاں سپان ہو جائیں گی",
  T_32_LO_WS_ITEM84W: "ہتھیار لوٹ پوائنٹ",
  T_32_LO_WS_ITEM84W_DESC: "جب رکھا جائے گا، منتخب ہتھیاروں کی قسمیں وہاں سپان ہوں گی",
  T_32_LO_WS_ITEM85: "متحرک",
  T_32_LO_WS_ITEM85_DESC: "رکھے جانے پر، وہ کھلاڑی جو ٹرگر زون میں داخل ہوتے ہیں ان کو امر یا عذاب کے مخصوص اثر کا سامنا کرنا پڑے گا۔ (کلیش اسکواڈ، ٹیم ڈیتھ میچ، اور پلے گراؤنڈ موڈز میں درست نہیں)",
  T_32_LO_WS_ITEM85CP: "چیک پوائنٹ",
  T_32_LO_WS_ITEM85CP_DESC: "پارکور موڈ میں گیم پلے بنانے کے لیے استعمال ہونے والی آئٹم۔ آخری چیک پوائنٹ  ظاہر ہونے کے لیے، کھلاڑیوں کو ایک ایک کر کے ہر چیک پوائنٹ سے گزرنا چاہیے۔ جب اسے ختم کیا جاتا ہے اور دوبارہ اسپان کیا جاتا ہے، تو کھلاڑی آخری چیک پوائنٹ  پر دوبارہ اسپان کرنے کا انتخاب کر سکتا ہے جسے وہ گزر چکا تھا۔ (کلیش اسکواڈ، ٹیم ڈیتھ میچ، اور پلے گراؤنڈ موڈز میں درست نہیں)",
  T_32_LO_WS_ITEM85TM: "فنشنگ پوائنٹ",
  T_32_LO_WS_ITEM85TM_DESC: "پارکور موڈ میں گیم پلے بنانے کے لیے استعمال ہونے والی آئٹم۔ گول مکمل کرنے کے لیے کھلاڑیوں کو فائنل لائن کے اندر پہنچنا چاہیے۔ (کلیش اسکواڈ، ٹیم ڈیتھ میچ، اور پلے گراؤنڈ موڈز میں درست نہیں)",
  T_32_LO_WS_ITEM86: "سپان پوائنٹس",
  T_32_LO_WS_ITEM86_DESC: "اس پوائنٹ پر کوئی مخصوص ٹیم تفویض نہیں کی جائے گی۔ رکھے جانے پر، ایک رینڈم ٹیم یہاں اسپان کرے گی۔ (کلیش اسکواڈ، ٹیم ڈیتھ میچ، اور پلے گراؤنڈ موڈز میں درست نہیں)",
  T_32_LO_WS_ITEM86L: "بڑا سپان پوائنٹ",
  T_32_LO_WS_ITEM86L_DESC: "پارکور موڈ کے لیے ایک بڑا اسپان پوائنٹ تجویز کیا گیا ہے، جہاں تمام کھلاڑی ایک قطار میں اسپان کریں گے۔(کلیش اسکواڈ، ٹیم ڈیتھ میچ، اور پلے گراؤنڈ موڈز میں درست نہیں)",
  T_32_LO_WS_ITEM87: "بلاک",
  T_32_LO_WS_ITEM87_DESC: "سائز حسب ضرورت کو فعال کرتا ہے",
  T_32_LO_WS_ITEM88: "ڈھلوان",
  T_32_LO_WS_ITEM88_DESC: "سائز حسب ضرورت کو فعال کرتا ہے",
  T_32_LO_WS_ITEMLINE: "شفٹ",
  T_32_LO_WS_ITEMMOVE: "متحرک کی ترتیبات",
  T_32_LO_WS_ITEMROT: "گھومتا ہے",
  T_32_LO_WS_ITEMSCALE: "پیمانہ",
  T_32_LO_WS_KILLZONE: "ڈوم زون",
  T_32_LO_WS_LOOT_AMMOTYPE: "بارود",
  T_32_LO_WS_LOOT_ARTYPE: "آرمر",
  T_32_LO_WS_LOOT_COTYPE: "قابل استعمال",
  T_32_LO_WS_LOOT_JATYPE: "پھینکنے کے قابل",
  T_32_LO_WS_LOOT_RANDOM: "بے ترتیب",
  T_32_LO_WS_LOOT_TETYPE: "سکوپ",
  T_32_LO_WS_LOOT_WEAPONTYPE: "ہتھیار",
  T_32_LO_WS_SCALEX: "لمبائی",
  T_32_LO_WS_SCALEY: "اونچائی",
  T_32_LO_WS_SCALEZ: "چوڑائی",
  T_32_LO_WS_TRIGGERH: "چھپائیں",
  T_32_LO_WS_TRIGGERHORP: "ٹرگرز دکھائیں/چھپائیں",
  T_32_LO_WS_TRIGGERP: "دکھائیں",
  T_32_LO_WS_TRIGGERTYPE: "ٹرگر کی قسم",
  T_32_M_WS_MODE_ANNIHILATE: "صفایا کرنا",
  T_32_M_WS_MODE_SCORE: "حاصل کردہ پوائنٹس",
  T_32_M_WS_MODE_SPEED: "پارکور",
  T_32_M_WS_MULTIPLETEAMS: "ملٹی ٹیم کامبیٹ",
  T_32_M_WS_ROUNDS: "راؤنڈز",
  T_32_R_EMOTE_HURRICANE_BLUE_NAME: "سوئچنگ کے مراحل",
  T_32_RW_WEAPON_M1887TD_NAME: "M1887-X",
  T_32_T_WS_ME_BLUECIRCLE: "ڈینجر زون",
  T_32_T_WS_ME_BLUECIRCLEDAMAGE: "نقصان",
  T_32_T_WS_ME_BLUECIRCLESETTING: "ڈینجر زون",
  T_32_T_WS_ME_CUSTOM: "حسب ضرورت بنائیں",
  T_32_T_WS_ME_ENDTYPE1: "صفایا کرنا",
  T_32_T_WS_ME_ENDTYPE2: "حاصل کردہ پوائنٹس",
  T_32_T_WS_ME_ENDTYPE3: "پارکور",
  T_32_T_WS_ME_ENDTYPEDESC1: "زندہ رہنے والی آخری ٹیم بنیں",
  T_32_T_WS_ME_ENDTYPEDESC2: "ہدف حاصل کرنے والی پہلی ٹیم جیت گئی۔",
  T_32_T_WS_ME_ENDTYPEDESC3: "پہلی ٹیم جس نے تمام ممبران کو فائنل پوائنٹ تک پہنچایا جیت گئی",
  T_32_T_WS_ME_MATCHTIME: "میچ کا وقت",
  T_32_T_WS_ME_MECHANIC: "میکینزم",
  T_32_T_WS_ME_NEARCHECKPOINT: "چیک پوائنٹ کے قریب",
  T_32_T_WS_ME_PLAYERNUMLIMIT: "مجموعی طور پر 12 سے زیادہ کھلاڑی رکھنے سے قاصر",
  T_32_T_WS_ME_PREGAMETIME: "تیاری کا وقت",
  T_32_T_WS_ME_RESPAWN: "ریسپانس",
  T_32_T_WS_ME_RESPAWNSETTING: "ریسپانس",
  T_32_T_WS_ME_ROUNDNUM: "راؤنڈز کی تعداد",
  T_32_T_WS_ME_ROUNDOPEN: "متعدد راؤنڈ کو فعال کریں",
  T_32_T_WS_ME_ROUNDRESET: "راؤنڈ ری سیٹس",
  T_32_T_WS_ME_ROUNDSETTING: "راؤنڈس",
  T_32_T_WS_ME_SAFEZONESHRINKTIME2: "زون سکڑنے کا دورانیہ",
  T_32_T_WS_ME_SCORESETTING: "سکور",
  T_32_T_WS_ME_TEAMMATENUM: "فی ٹیم ممبران",
  T_32_T_WS_ME_TEAMNUM: "ٹیموں کی تعداد",
  T_32_T_WS_ME_TEAMSETTING: "ٹیم",
  T_32_U_ATTACHMENT_8: "بیگ کی تھیلی",
  "T_32_U_GOLD_FAMAS-I": "Famas-I",
  "T_32_U_GOLD_FAMAS-II": "Famas-II",
  "T_32_U_GOLD_FAMAS-III": "Famas-III",
  T_32_U_GOLD_HEATGUN_I: "PLASMA-I",
  T_32_U_GOLD_HEATGUN_II: "PLASMA-II",
  T_32_U_GOLD_HEATGUN_III: "PLASMA-III",
  T_32_U_GOLD_KAR98K_I: "Kar98K-I",
  T_32_U_GOLD_KAR98K_II: "Kar98K-II",
  T_32_U_GOLD_KAR98K_III: "Kar98K-III",
  T_32_U_GOLD_M14_I: "M14-I",
  T_32_U_GOLD_M14_II: "M14-II",
  T_32_U_GOLD_M14_III: "M14-III",
  "T_32_U_GOLD_M4A1-I": "M4A1-I",
  "T_32_U_GOLD_M4A1-II": "M4A1-II",
  "T_32_U_GOLD_M4A1-III": "M4A1-III",
  T_32_U_GOLD_M60_I: "M60-I",
  T_32_U_GOLD_M60_II: "M60-II",
  T_32_U_GOLD_M60_III: "M60-III",
  T_32_U_GOLD_MP5_I: "MP5-I",
  T_32_U_GOLD_MP5_II: "MP5-II",
  T_32_U_GOLD_MP5_III: "MP5-III",
  T_32_U_GOLD_VSS_I: "VSS-I",
  T_32_U_GOLD_VSS_II: "VSS-II",
  T_32_U_GOLD_VSS_III: "VSS-III",
  T_32_U_REPLACER: "اپ گریڈ چپ",
  T_32_WT_WS_BARRIER: "رکاوٹیں",
  T_32_WT_WS_BDS: "عمارتیں",
  T_32_WT_WS_MMINVALIDERROR: "غلط نقشہ کوڈ",
  T_32_WT_WS_TRGS: "متحرک",
  T_32_YF_CHARGESHOT_N: "چارج بسٹر",
  T_32_YF_GOLD_GROZA_N: "GROZA-X",
  T_32_YF_GOLD_M249_N: "M249-X",
  T_32_YF_GOLD_SVD_N: "SVD-Y",
  T_32_YS_WEAPON_TAG_18: "اضافی نقصان",
  T_32_YS_WEAPON_TAG_3: "فائر کی شرح",
  T_32_YS_WEAPON_TAG_36: "آرمر چھیدنا",
  T_32_YS_WEAPON_TAG_39: "اکمبو کی حمایت کرتا ہے",
  T_32_YS_WEAPON_TAG_42: "آئس وال",
  T_33_C_SKILL_DESC_GRAFFITIST: "ایک {0} میٹر کا علاقہ بناتا ہے، جہاں تھرو ایبلز غلط ہیں۔ علاقے میں اتحادی ہر سیکنڈ میں {1} فیصد آرمر کے استحکام کو بحال کریں گے اور بارود سے ہونے والے نقصان میں {2} فیصد کمی آئے گی۔ {3} سیکنڈ تک رہتا ہے۔ کول ڈاؤن: {4} سیکنڈ۔ ایفیکٹس اسٹیک نہیں ہوتے ہیں۔",
  T_33_C_SKILL_DESC_HITMAN: "اسنائپرز اور مارکس مین رائفلز کا استعمال کرتے وقت، فائرنگ کی آواز کو خاموش کر دیا جاتا ہے اور صارف کا {0}٪ تیزی سے خون بہانے کے ذریعے دشمنوں کو گرا دیا جاتا ہے۔",
  T_33_C_SKILL_DESC_KENTA: "{0} میٹر چوڑائی کی ایک شیلڈ بناتا ہے جو سامنے سے آنے والے ہتھیاروں کے نقصان کو {1}٪ کم کرتا ہے۔ فائرنگ کرتے وقت، نقصان میں کمی {2}٪ ہو جاتی ہے۔ {3} سیکنڈ تک رہتا ہے۔ کولڈاؤن: {4} سیکنڈ۔",
  T_33_C_SKILL_DESC_MADEMANA: "ایک {0} میٹر برقی مقناطیسی لہر کو جاری کرتا ہے جو دشمنوں کی مہارت کو ناکارہ بناتی ہے، {3} کا نقصان پہنچاتی ہے اور ان کے انٹرایکشن کاؤنٹ ڈاؤن میں خرابی پیدا کرتی ہے۔ {1} سیکنڈ تک رہتی ہے۔ کولڈاؤن: {2} سیکنڈ۔",
  T_33_C_SKILL_NAME_BODYGUARD: "آتشیں اسلحہ کا ماہر",
  T_33_C_SKILL_NAME_KENTA: "تلوار باز کا قہر",
  T_33_C_SKILL_NAME_MADEMANA: "جنگ کی سنسنی",
  T_33_DY_AXOLOTL_N: "زیسل",
  T_33_DY_PETSKIN_AXOLOTL_GREY_N: "پٹ اسکن: فروٹ زیسل",
  T_33_DY_PETSKIN_DUCK_FFWS03_N: "پٹ اسکن: FFUS بینی",
  T_33_DY_PETSKIN_HAWK_FASTBREAKING22_N: "پٹ اسکن: بلومنگ فالکو",
  T_33_HQ_BASEBALLBAT_APRILFOOL22_N: "مہلک بیگیوٹ",
  T_33_HQ_EMOTE_SONGKRAN_N: "آئیں اور ڈانس کریں",
  T_33_HQ_G18_CYBERTHIEF_N: "G18- ہائپر کور بلیوز",
  T_33_HQ_GRENADE_CYBERTHIEF_N: "گرینیڈ- ہائپر کور بلیوز",
  T_33_HQ_M14_SPIDERLILY_N: "M14- برننگ للی",
  T_33_HQ_MAG7_FFUNIT2_N: "MAG-7- شیڈو روگ",
  T_33_HQ_MP40_FFWS03_N: "MP40- Haven Warrior",
  T_33_HQ_SCAR_FFWS03_N: "سکار- ہیون واریر",
  T_33_HQ_SICKLE_FASTBREAKING22_N: "ایمرلڈ پاور سکیتھ",
  T_33_HQ_THROWINGKNIFE_FFWS03_N: "ہیون واریر خنجر",
  T_33_HQ_VECTOR_CYBERTHIEF_N: "ویکٹر- ہائپر کور بلیوز",
  T_33_HQ_VEHICLE_JEEP_FASTBREAKING22_N: "جیپ- ایمرلڈ شمر",
  T_33_HQ_VEHICLE_MONSTER_LION_RED_N: "مونسٹر ٹرک - بونبروزر سکورچ",
  T_33_HQ_VEHICLE_SUV_FFWS03_N: "پک اپ ٹرک - ہیون گارڈین",
  T_33_LO_WS_BHPARA_A: "فعال",
  T_33_LO_WS_BHPARA_ATKMODE: "حملے کی قسم",
  T_33_LO_WS_BHPARA_GROUP: "ٹیم",
  T_33_LO_WS_BHPARA_NA: "کوئی حملہ نہیں",
  T_33_LO_WS_BHPARA_P: "غیر فعال",
  T_33_LO_WS_DICE_DESC: "چھلانگ کو بہتر بنانے والا ڈائس جو مختلف گیم پلے میں استعمال کیا جا سکتا ہے",
  T_33_LO_WS_DICEVXZ: "ہوریزونٹل رفتار",
  T_33_LO_WS_DICEVY: "عمودی رفتار",
  T_33_LO_WS_DTOWER: "ٹاور",
  T_33_LO_WS_DTOWER_DESC: "خود بخود دشمنوں پر حملہ کرتا ہے جو دفاعی ڈھانچے سے ایک خاص فاصلے کے اندر ہیں۔ اگر اس کا ہیلتھ پوائنٹ صفر تک پہنچ جائے تو تباہ ہو جاتا ہے۔ (کلیش اسکواڈ، ٹیم ڈیتھ میچ، اور پلے گراؤنڈ موڈز میں درست نہیں)",
  T_33_LO_WS_FORT: "قلعہ",
  T_33_LO_WS_FORT_DESC: "اہم ڈھانچے سے ایک خاص فاصلے کے اندرخود بخود دشمنوں پر حملہ کرتا ہے۔ ہیلتھ پوائنٹ صفر تک پہنچنے پر غیر فعال ہو جاتا ہے۔(کلیش اسکواڈ، ٹیم ڈیتھ میچ، اور پلے گراؤنڈ موڈز میں درست نہیں)",
  T_33_LO_WS_ITEM89: "ریفائنری ٹینک",
  T_33_LO_WS_ITEM89_DESC: "واٹر- سٹورنگ سٹرکچر",
  T_33_LO_WS_ITEM90: "ڈاگ ہاؤس",
  T_33_LO_WS_ITEM90_DESC: "کتے کے بچوں کے لیے ایک گھر",
  T_33_LO_WS_ITEM91: "بس اسٹاپ",
  T_33_LO_WS_ITEM91_DESC: "ایک عام بس اسٹاپ",
  T_33_LO_WS_ITEM92: "گرافٹی وال",
  T_33_LO_WS_ITEM92_DESC: "سپرے پینٹ سے اچھی طرح مزین",
  T_33_LO_WS_ITEM93: "مستحکم",
  T_33_LO_WS_ITEM93_DESC: "بنیادی گھاس سے بنی ساخت",
  T_33_LO_WS_ITEM94: "بینچ",
  T_33_LO_WS_ITEM94_DESC: "پارک کا بینچ",
  T_33_LO_WS_ITEM95: "پتھر کا پل",
  T_33_LO_WS_ITEM95_DESC: "پتھروں سے بنا ہوا پل",
  T_33_LO_WS_ITEM96: "سن شیڈ",
  T_33_LO_WS_ITEM96_DESC: "چھتری کے نیچے دھوپ میں جلنے سے بچیں۔",
  T_33_LO_WS_ITEM97: "فنش لائن آرک",
  T_33_LO_WS_ITEM97_DESC: "فنشنگ لائن کی نشاندہی کریں",
  T_33_LO_WS_ITEM98: "اشتہاری بورڈ",
  T_33_LO_WS_ITEM98_DESC: "اشتہارات کے لیے ایک باقاعدہ بینر",
  T_33_LO_WS_PARA_DM: "نقصان",
  T_33_LO_WS_PARA_HP: "ہیلتھ پوائنٹ",
  T_33_LO_WS_PARA_RANGE: "دشمن کے فاصلے کا اسکین",
  T_33_LO_WS_PARA_SP: "رفتار",
  T_33_LO_WS_ZBPARA_AMOUNT: "زومبی فی لہر",
  T_33_LO_WS_ZBPARA_INTERVAL: "لہر کا دورانیہ",
  T_33_LO_WS_ZBPARA_ROUND: "لہروں کا #",
  T_33_LO_WS_ZBSPAWNER: "زومبی سپان",
  T_33_LO_WS_ZBSPAWNER_DESC: "ترتیب کے مطابق خود بخود زومبی اسپان کرتا ہے۔ ان کے رویے کو ڈراپ ڈاؤن مینو کا استعمال کرتے ہوئے ترتیب دیا جا سکتا ہے۔ (کلیش اسکواڈ، ٹیم ڈیتھ میچ، اور پلے گراؤنڈ موڈز میں درست نہیں)",
  T_33_MF_CHARACTER_BLACKSMITH_N: "کینٹہ",
  T_33_PD_ZOMBIE_LEVELUP: "لیول اپ",
  T_33_RW_SKILL_DESC_GANGGIRL: "فائرنگ کی شرح کو {0} فیصد تک بڑھاتا ہے۔ جب صارف کسی دشمن کو مارتا ہے تو، فائرنگ کی شرح کا زیادہ سے زیادہ {1} فیصد حرکت کی رفتار میں بدل جاتا ہے، اور جب صارف لڑائی سے بچ جاتا ہے تو مہارت ری سیٹ ہو جاتی ہے۔",
  T_33_RW_SKILL_NAME_GANGGIRL: "لڑائی یا پرواز کریں",
  T_33_WT_WS_BASICSET1: "بنیادی",
  T_33_WT_WS_QCEPRTIP: "ایلیٹ پاس کو تیزی سے ہیلتھ پوائنٹ میں تبدیل کریں",
  T_33_WT_WS_SKILLSET_TAG: "لامحدود مہارت",
  T_33_WT_WS_SKILLSET1: "مہارت کی ترتیبات",
  T_33_WT_WS_SKILLSET10: "ٹائم ٹرنر (کرونو)",
  T_33_WT_WS_SKILLSET11: "رپٹائڈ تال (اسکائیلر)",
  T_33_WT_WS_SKILLSET12: "ایکسٹریم انکاؤنٹر (زائین)",
  T_33_WT_WS_SKILLSET13: "ہیلنگ ہارٹ بیٹ (دیمتری)",
  T_33_WT_WS_SKILLSET2: "غیر فعال مہارت",
  T_33_WT_WS_SKILLSET2_TIP: "غیر فعال مہارتوں کو آن/آف کریں",
  T_33_WT_WS_SKILLSET3: "فعال مہارت (نیچے کولڈاؤن ٹائم ایڈجسٹ کرنے کے لیے آن کریں)",
  T_33_WT_WS_SKILLSET3_TIP: "فعال مہارتوں کو آن/آف کریں۔ اگر آن ہے تو، مختلف فعال مہارتوں کا کول ڈاؤن ٹائم ذیل میں ترتیب دیا جا سکتا ہے۔",
  T_33_WT_WS_SKILLSET4: "کیموفلاج (ووکونگ)",
  T_33_WT_WS_SKILLSET5: "بیٹل کی سنسنی (A124)",
  T_33_WT_WS_SKILLSET6: "ڈراپ دی بیٹ (الوک)",
  T_33_WT_WS_SKILLSET7: "پینٹڈ ریفیوج (اسٹیفی)",
  T_33_WT_WS_SKILLSET8: "ٹریسنگ کے مراحل (کلو)",
  T_33_WT_WS_SKILLSET9: "سب کا ماسٹر(کے)",
  T_33_WT_WS_UNIT_HPSECOND: "ہیلتھ پوائنٹ/سیکنڈ",
  T_33_WT_WS_UNIT_METER: "میٹر",
  T_33_WT_WS_UNIT_SECOND: "سیکنڈ",
  T_33_YF_G36_N: "G36",
  T_33_YS_B_RAINCOAT: "رینڈول (باٹم)",
  T_33_YS_H_ONIGIRI: "اونیگیری ہڈ",
  T_33_YS_H_RAINCOAT: "رینڈول (ہیڈ)",
  T_33_YS_HA_CRYINGFACE: "کرائنگ ایموٹ (فیس پینٹ)",
  T_33_YS_M_H_FROGKING: "مینڈک کنگ ٹوپی",
  T_33_YS_S_RAINCOAT: "رینڈول (جوتے)",
  T_33_YS_T_BLACKHOLE: "ڈوپلر شفٹ ہوڈی",
  T_33_YS_T_RAINCOAT: "رینڈول (ٹاپ)",
  T_33_YS_T_SOCCER_GREEN: "الیکٹریفائیڈ کِک (جرسی)",
  T_33_YS_T_SOCCER_YELLOW: "انرجیائزڈ کِک (جرسی)",
  T_33_YS_T_WIFI: "نیٹ & نیکسٹ ٹی شرٹ",
  T_34_C_SKILL_DESC_STREAMERGUY: "ہر خاتمے سے ایک تماشائی کا اضافہ ہوگا، اور تماشائیوں کی تعداد کم نہیں ہوگی۔ ہر اضافی تماشائی کے ساتھ، ہیڈ شاٹس سے ہونے والا نقصان {0}% (زیادہ سے زیادہ {1}%) کم ہو جاتا ہے اور ہیڈ شاٹس سے دشمنوں کو پہنچنے والا نقصان {2}% (زیادہ سے زیادہ {3}%) بڑھ جاتا ہے۔",
  T_34_C_SKILL_DESC_TRACKER: "100 میٹر کے فرنٹل فاصلے کے اندر قریب ترین دشمن کی طرف ڈرون چھوڑتا ہے، جس سے 5 میٹر قطر کا پلس دھماکہ ہوتا ہے جو حرکت کی رفتار کو {0} فیصد اور فائرنگ کی رفتار کو {1} فیصد تک کم کرتا ہے،{3} سیکنڈ تک رہتا ہے اور {2} کو نقصان پہنچاتا ہے۔ کولڈاؤن: {4} سیکنڈ۔",
  T_34_C_SKILL_NAME_TRACKER: "شاک ویو کا احساس",
  T_34_DY_PETSKIN_SURFSHARK_ENERGY_N: "پٹ اسکن: اینگری سرفرفن",
  T_34_DY_PETSKIN_SURFSHARK_SEA_N: "پٹ اسکن: ڈیپ اوشین فن",
  T_34_DY_PETSKIN_SURFSHARK_STORM_N: "پیٹ اسکن: تھنڈر سٹارم فن",
  T_34_DY_PETSKIN_TIGER_BIS_N: "پٹ اسکن: ڈیجیٹل ٹگ",
  T_34_DY_SURFSHARK_N: "فن",
  T_34_HQ_EMOTE_BIS_COMMAND_N: "زبردست کنڈکٹر",
  T_34_HQ_EMOTE_RAMPAGE4_BLUE_N: "توانائی بخش",
  T_34_HQ_EMOTE_RIDICULE_N: "تضحیک",
  T_34_HQ_VEHICLE_SUV_CRAZYSCIENTIST_N: "پک اپ ٹرک - ایول انجینئر",
  T_34_HQ_VEHICLE_TUTU_WINTERDOG_N: "ٹک ٹک - ہسکی پپ",
  T_34_JL_EAGLE_RAMPAGE4_N: "ڈیزرٹ ایگل - ہائبرڈ دھماکہ",
  T_34_JL_G36_MADBIONIC_N: "G36- فلیرنگ بایونیکا",
  T_34_JL_GRENADE_BIS_N: "گرینیڈ- سولجر پکسل",
  T_34_JL_MACHETE_RAMPAGE4_N: "نائٹ بلیڈ",
  T_34_JL_THROWINGKNIFE_BANANA_N: "بنانا ڈیگر",
  T_34_JL_UMP45_BIS_N: "UMP- ڈیجیٹل ڈیشر",
  T_34_LY_WS_ABS_DESC: "اس نمبر کی مطلق ویلیو حاصل کریں",
  T_34_LY_WS_ADD_DESC: "ایک لسٹ کے آخر میں ایک نیا ایلیمینٹ شامل کریں",
  T_34_LY_WS_AUTO_A: "آٹو اسکین دشمن",
  T_34_LY_WS_BOT: "ریگولر",
  T_34_LY_WS_BOT_PATH: "پاتھ",
  T_34_LY_WS_BOT_TYPE: "قسم",
  T_34_LY_WS_BOT4: "کلہاڑی",
  T_34_LY_WS_BOT5: "ٹاسنگ",
  T_34_LY_WS_BOT6: "خود کار دھماکہ",
  T_34_LY_WS_BOT8: "قصاب",
  T_34_LY_WS_COL_DESC: "ایک رنگ منتخب کریں",
  T_34_LY_WS_DEL_DESC: "ایک لسٹ میں نامزد انڈیکس کے متعلقہ ایلیمینٹ کو ڈیلیٹ کریں",
  T_34_LY_WS_DF_PER: "دفاع ٪",
  T_34_LY_WS_FORT_INTERVAL: "حملے کا انٹرول ٹائم",
  T_34_LY_WS_GET: "حاصل کریں",
  T_34_LY_WS_GET_DESC: "ایک لسٹ میں نامزد انڈیکس کا متعلقہ ایلیمینٹ حاصل کریں",
  T_34_LY_WS_GLEN_ARR_DESC: "موجودہ لسٹ میں ایلیمینٹس کی تعداد حاصل کریں",
  T_34_LY_WS_GLEN_DESC: "ٹیکسٹ کے اس سٹرنگ کی لمبائی حاصل کریں",
  T_34_LY_WS_GVX: "x ویکٹر کمپونینٹ حاصل کریں",
  T_34_LY_WS_GVX_DESC: "ویکٹر کا پہلا کمپونینٹ حاصل کریں",
  T_34_LY_WS_GVY: "y ویکٹر کمپونینٹ حاصل کریں",
  T_34_LY_WS_GVY_DESC: "ویکٹر کا دوسرا کمپونینٹ حاصل کریں",
  T_34_LY_WS_GVZ: "z ویکٹر کمپونینٹ حاصل کریں",
  T_34_LY_WS_GVZ_DESC: "ویکٹر کا تیسرا کمپونینٹ حاصل کریں۔",
  T_34_LY_WS_INDEX: "انڈیکس",
  T_34_LY_WS_JOIN: "جڑیں",
  T_34_LY_WS_NEG_DESC: "اس نمبر کی منفی ویلیو حاصل کریں",
  T_34_LY_WS_PATH: "پاتھ سیٹٹر",
  T_34_LY_WS_PATH_DESC: "خاص زندہ اشیاء کے سفری راستے شامل کرنے/مٹانے کے لیے استعمال کریں۔(کلیش اسکواڈ، ٹیم ڈیتھ میچ، اور پلے گراؤنڈ موڈز میں درست نہیں)",
  T_34_LY_WS_POINT: "مارکر",
  T_34_LY_WS_POINT_DESC: "موجودہ پوزیشن کے مقام کو نشان زد کرنے کے لیے استعمال کریں۔(کلیش اسکواڈ، ٹیم ڈیتھ میچ، اور پلے گراؤنڈ موڈز میں درست نہیں)",
  T_34_LY_WS_RANGE_F: "دور",
  T_34_LY_WS_RANGE_M: "میڈیم",
  T_34_LY_WS_RANGE_N: "قریب",
  T_34_LY_WS_RNDF_DESC: "انٹرول سے رینڈم ڈیسیمل بنائیں",
  T_34_LY_WS_RNDI_DESC: "انٹرول سے رینڈم انٹیجر بنائیں",
  T_34_LY_WS_SET: "تبدیل کریں",
  T_34_LY_WS_SET_DESC: "ایک لسٹ میں نامزد انڈیکس کے متعلقہ ایلیمینٹ کو سیٹ کریں",
  T_34_LY_WS_SQRT_DESC: "اس نمبر کا اسکوئر روٹ حاصل کریں",
  T_34_LY_WS_STRC_DESC: "ٹیکسٹ کی دو سٹرنگز جوڑیں",
  T_34_LY_WS_SVX: "x ویکٹر کا کمپونینٹ سیٹ کریں",
  T_34_LY_WS_SVX_DESC: "ویکٹر کا پہلا کمپونینٹ سیٹ کریں",
  T_34_LY_WS_SVY: "y ویکٹر کمپونینٹ حاصل کریں",
  T_34_LY_WS_SVY_DESC: "ویکٹر کا دوسرا کمپونینٹ سیٹ کریں",
  T_34_LY_WS_SVZ: "z ویکٹر کمپونینٹ سیٹ کریں",
  T_34_LY_WS_SVZ_DESC: "ویکٹر کا تیسرا کمپونینٹ سیٹ کریں",
  T_34_LY_WS_VADD: "ویکٹر کا اضافہ",
  T_34_LY_WS_VADD_DESC: "دو ویکٹرز ایڈ کریں",
  T_34_LY_WS_VAL_DESC: "منظر نامے کے مطابق ایک انٹیجر یا ڈیسیمل داخل کریں",
  T_34_LY_WS_VANG_DESC: "دو ویکٹرز کے درمیان اینگل کیلکیولیٹ کریں",
  T_34_LY_WS_VCP: "کراس پروڈکٹ",
  T_34_LY_WS_VCP_DESC: "دو ویکٹرز کا کراس پروڈکٹ کیلکیولیٹ کریں",
  T_34_LY_WS_VDIS_DESC: "دو ویکٹرز کے درمیان فاصلے کا حساب لگائیں",
  T_34_LY_WS_VDP: "ڈاٹ پروڈکٹ",
  T_34_LY_WS_VDP_DESC: "دو ویکٹر کے ڈاٹ پروڈکٹ کا حساب لگائیں",
  T_34_LY_WS_VFX1: "سفیئریکل",
  T_34_LY_WS_VFX2: "سیلینڈریکل",
  T_34_LY_WS_VFX3: "رنگ",
  T_34_LY_WS_VFX4: "بوم",
  T_34_LY_WS_VFX5: "پکسلز",
  T_34_LY_WS_VFX6: "سپارکس",
  T_34_LY_WS_VMOD_DESC: "ویکٹر کا میگنیٹیوڈ کیلکیولیٹ کریں",
  T_34_LY_WS_VMUL: "ویکٹر ملٹیپلیکیشن",
  T_34_LY_WS_VMUL_DESC: "دو ویکٹرز کو ملٹیپلائے کریں",
  T_34_LY_WS_VNOR_DESC: "ویکٹر کو نارملائز کریں",
  T_34_LY_WS_VSUB: "ویکٹر تفریق",
  T_34_LY_WS_VSUB_DESC: "دو ویکٹرز کو سبٹریکٹ کریں",
  T_34_M_WS_ANGLE: "اینگل گھمائیں",
  T_34_M_WS_ARRAY: "لسٹ",
  T_34_M_WS_ATT: "پراپرٹی",
  T_34_M_WS_BOOL: "بولین",
  T_34_M_WS_COLORARRAY: "کلر آرے",
  T_34_M_WS_COLOUR: "رنگ",
  T_34_M_WS_CONFRONBANNER: "بیٹل بینر",
  T_34_M_WS_COORDINATE: "کوآرڈینیٹس",
  T_34_M_WS_CUSTOMINF: "کسٹم HUD",
  T_34_M_WS_CUSTOMMODEDESC: "مکمل کسٹمائزیشن۔ اپنے قوانین کے مطابق بنائیں اور کھیلیں۔",
  T_34_M_WS_DAMAGETYPE: "نقصان کی قسم",
  T_34_M_WS_DAMAGETYPEDESC: "نقصان کی قسم جو فی الحال سسٹم کے ذریعے سیٹ کی گئی ہے",
  T_34_M_WS_DESCTEXT: "وضاحتی ٹیکسٹ",
  T_34_M_WS_DURACTION: "دورانیہ",
  T_34_M_WS_ECAMODE: "کسٹمائز موڈ",
  T_34_M_WS_ENDPHASEDESC: "موجودہ مرحلے کو فوری طور پر ختم کریں اور اگلے مرحلے پر جائیں",
  T_34_M_WS_ENTITY: "اینٹیٹی",
  T_34_M_WS_FLOAT: "ڈیسیمل",
  T_34_M_WS_GAME: "گیم",
  T_34_M_WS_GAMERESULTS: "میچ کا نتیجہ",
  T_34_M_WS_GETCONTROL2: "اینٹیٹی کی پراپرٹیز (بشمول ڈیزائن، رنگ، مواد وغیرہ) میں تبدیلی کرنے کے لیے پلیئرز انٹرفیس سے ایک کنٹرول اینٹیٹی حاصل کریں۔",
  T_34_M_WS_HEIGHT: "اونچائی",
  T_34_M_WS_HUDBUTTONWIDGET: "بٹن کنٹرول",
  T_34_M_WS_HUDEMPTYWIDGET: "ایمپٹی محور",
  T_34_M_WS_HUDIMAGEWIDGET: "ایمیج کنٹرول",
  T_34_M_WS_HUDINPUTWIDGET: "ٹیکسٹ باکس کنٹرول",
  T_34_M_WS_HUDLABELWIDGET: "ٹیکسٹ کنٹرول",
  T_34_M_WS_ICON: "آئیکن",
  T_34_M_WS_ICON_AIM: "ہدف",
  T_34_M_WS_ICON_ARROW: "تیر",
  T_34_M_WS_ICON_BLAST: "بلاسٹ",
  T_34_M_WS_ICON_CIRCULAR: "دائرہ",
  T_34_M_WS_ICON_CLOTH: "پام",
  T_34_M_WS_ICON_COLLIMATION: "کراس ہیئر",
  T_34_M_WS_ICON_CORPSE: "زومبی",
  T_34_M_WS_ICON_CROSS: "کراس",
  T_34_M_WS_ICON_DAY: "سورج",
  T_34_M_WS_ICON_DEFENSE: "شیلڈ",
  T_34_M_WS_ICON_DIALOGUE: "مکالمہ",
  T_34_M_WS_ICON_DIAMONDS: "ڈائمنڈ",
  T_34_M_WS_ICON_EXCLAMATIONMARK: "فجائیہ نشان",
  T_34_M_WS_ICON_FLAG: "جھنڈا",
  T_34_M_WS_ICON_FOLDER: "فولڈر",
  T_34_M_WS_ICON_GLASSES: "آنکھ",
  T_34_M_WS_ICON_GUN: "گن",
  T_34_M_WS_ICON_HEART: "دل",
  T_34_M_WS_ICON_HEXAGON: "مسدس",
  T_34_M_WS_ICON_HOURGLASS: "ہآرگلاس",
  T_34_M_WS_ICON_HOUSE: "گھر",
  T_34_M_WS_ICON_KEY: "چابی",
  T_34_M_WS_ICON_LIGHTNING: "لائٹنگ",
  T_34_M_WS_ICON_LOCK: "تالا",
  T_34_M_WS_ICON_LOOP: "لوپ",
  T_34_M_WS_ICON_MAGNIFIER: "کلاں نما شیشہ",
  T_34_M_WS_ICON_MONEY: "پیسہ",
  T_34_M_WS_ICON_MONTH: "چاند",
  T_34_M_WS_ICON_OPENFOLDER: "فولڈر کھولیں",
  T_34_M_WS_ICON_PLUS: "پلس",
  T_34_M_WS_ICON_QUADRI: "چوکور",
  T_34_M_WS_ICON_QUESTIONMARK: "سوالیہ نشان",
  T_34_M_WS_ICON_RECYCLING: "ری سائیکل",
  T_34_M_WS_ICON_REFRESH: "ریفریش کریں",
  T_34_M_WS_ICON_REST: "ریسٹ",
  T_34_M_WS_ICON_RETURN: "واپس",
  T_34_M_WS_ICON_RIGHTTRAPEZOID: "رائٹ ٹریپزوائڈ",
  T_34_M_WS_ICON_SCISSORS: "قینچی",
  T_34_M_WS_ICON_SETUP: "سیٹنگ",
  T_34_M_WS_ICON_SIGN: "نشان",
  T_34_M_WS_ICON_SIGNOUT: "باہر نکلیں",
  T_34_M_WS_ICON_SQUARE: "اسکوائر",
  T_34_M_WS_ICON_STAR: "ستارہ",
  T_34_M_WS_ICON_STONE: "سٹون",
  T_34_M_WS_ICON_SWIMMINGCIRCLE: "تیراکی کی رنگ",
  T_34_M_WS_ICON_TAGGING: "پن",
  T_34_M_WS_ICON_THESWORD: "تلوار",
  T_34_M_WS_ICON_TRAPEZOID: "ٹریپزوائڈ",
  T_34_M_WS_ICON_TRASHCAN: "کچرے دان",
  T_34_M_WS_ICON_TRIANGLE: "ٹرائی اینگل",
  T_34_M_WS_ICON_TROPHY: "ٹرافی",
  T_34_M_WS_ICON_UP: "بہت خوب",
  T_34_M_WS_ICON_WRONG: "غلط",
  T_34_M_WS_ICON_YES: "رائٹ",
  T_34_M_WS_ICONNAME: "آئیکن کا نام",
  T_34_M_WS_INT: "انٹیجر",
  T_34_M_WS_KILLZONE: "ڈوم زون",
  T_34_M_WS_LEFTCOLOR: "بائیں طرف کا رنگ",
  T_34_M_WS_LEFTTEAMINDEX: "بائیں ٹیم انڈیکس",
  T_34_M_WS_LEFTTEAMSCORE: "سائیتھ پر مشتمل ہے: موکو آرک",
  T_34_M_WS_LOCSWITCH: "لوکلائزیشن سوئچ",
  T_34_M_WS_MAX: "زیادہ سے زیادہ",
  T_34_M_WS_MIN: "کم از کم",
  T_34_M_WS_NUMBER: "نمبر",
  T_34_M_WS_OBJECT: "اینٹیٹی",
  T_34_M_WS_OPEN: "آن",
  T_34_M_WS_OPENSATUS: "اسٹیٹس کو آن کریں",
  T_34_M_WS_PICTURE: "گرافکس",
  T_34_M_WS_RANKARRAY: "درجے کی آرے",
  T_34_M_WS_RESULTS: "نتائج",
  T_34_M_WS_RIGHTCOLOR: "صحیح رنگ",
  T_34_M_WS_RIGHTTEAMINDEX: "دائیں طرف کی ٹیم کا انڈیکس",
  T_34_M_WS_RIGHTTEAMSCORE: "دائیں طرف کی ٹیم کا اسکور",
  T_34_M_WS_ROUNDBANNER: "راؤنڈ بینر",
  T_34_M_WS_ROUNDDESC: "راؤنڈ کی تفصیل",
  T_34_M_WS_ROUNDHUD: "راؤنڈ نمبر",
  T_34_M_WS_ROUNDPARAMS: "راؤنڈ نمبر آرے",
  T_34_M_WS_SAME_NAME: "دہرایا جانے والا نام۔ براہ کرم ایک نیا آزمائیں۔",
  T_34_M_WS_SCOREARRAY: "اسکور آرے",
  T_34_M_WS_SCORINGTYPE: "اسکور کی قسم",
  T_34_M_WS_SCORINGTYPEDECS: "اسکور کی قسم کھلاڑی حاصل کر سکتے ہیں۔ اسکور حسب ضرورت کی حمایت کرتا ہے۔",
  T_34_M_WS_SCUFFLESCORING: "ملٹی ٹیم اسکور",
  T_34_M_WS_SETATTRIBUTES: "پراپرٹی کی ترتیبات",
  T_34_M_WS_SHUT: "آف",
  T_34_M_WS_SOUND: "ساؤنڈ ایفیکٹس",
  T_34_M_WS_SOUNDCLICK: "کلک کریں",
  T_34_M_WS_SOUNDDD: "کاؤنٹ ڈاؤن",
  T_34_M_WS_SOUNDFEMALEA: "زخمی (خاتون)",
  T_34_M_WS_SOUNDM: "گولی چلانا",
  T_34_M_WS_SOUNDMALEA: "زخمی (مرد)",
  T_34_M_WS_SOUNDUAV: "دھماکہ",
  T_34_M_WS_ST_ASSISTCOUNT: "مدد",
  T_34_M_WS_ST_CHECKPROGRESS: "چیک پوائنٹ کی پیشرفت",
  T_34_M_WS_ST_DAMAGESUM: "نقصان پہنچانا",
  T_34_M_WS_ST_FINISHCOUNT: "حاصل کردہ اہداف کی مقدار",
  T_34_M_WS_ST_FINISHORDER: "حاصل کردہ اہداف کی ترتیب",
  T_34_M_WS_ST_FINISHTIME: "حاصل کردہ اہداف کا وقت",
  T_34_M_WS_ST_KILLCOUNT: "کلز",
  T_34_M_WS_ST_MAINSCORE: "ہدف سکور",
  T_34_M_WS_ST_RANKSCORE: "رینک اسکور",
  T_34_M_WS_ST_SURVIVALDURACTION: "سروائیول کا وقت",
  T_34_M_WS_ST_UNKOWN: "نامعلوم",
  T_34_M_WS_STARTBANNER: "بینر شروع کریں",
  T_34_M_WS_STARTTIME: "شروع ہونے کا وقت",
  T_34_M_WS_STRING: "ٹیکسٹ",
  T_34_M_WS_STUDIO: "اسٹوڈیو",
  T_34_M_WS_TEAMARRAY: "ٹیم آرے",
  T_34_M_WS_TEXTCONTENT: "مواد",
  T_34_M_WS_THEMECOLOR: "تھیم کا رنگ",
  T_34_M_WS_TIME: "کاؤنٹ ڈاؤن HUD",
  T_34_M_WS_TITLETEXT: "ٹائٹل ٹیکسٹ",
  T_34_M_WS_TYPE: "ٹائپ",
  T_34_M_WS_UODATETYPE: "اپ ڈیٹ کی قسم",
  T_34_M_WS_VARNAME: "ویریایبل کا نام",
  T_34_M_WS_VECTOR: "ویکٹر",
  T_34_M_WS_VFX: "ویژول افکیٹس",
  T_34_M_WS_WIDTH: "چوڑائی",
  T_34_MF_CHARACTER_TRACKER_N: "ہومر",
  T_34_PD_FlagBattle_HYPE_1: "فائر",
  T_34_SP_WS_BLOCK1_NAME: "اسٹیج سوئچ کریں",
  T_34_SP_WS_BLOCK1_NAMEDESC: "مطلوبہ مرحلے (یا راؤنڈ) میں داخل ہونے کے لیے میچ کے اسٹیج کو سوئچ کریں۔ راؤنڈ میں اسٹیج انڈیکس بھی ہوتے ہیں اور یہ ایک خاص قسم کا اسٹیج ہوتا ہے۔",
  T_34_SP_WS_BLOCK1_PARAM1_NAMEDESC: "ہدف کے مرحلے کا اشاریہ",
  T_34_SP_WS_BLOCK10_NAME: "ویژول افکیٹس بنائیں",
  T_34_SP_WS_BLOCK10_NAMEDESC: "نامزد ویژول افکیٹس کا استعمال کرتے ہوئے ایک آئیکن بنائیں۔ ویژول افکٹ کی مزید پراپرٹیز کو ویژول افکیٹس اینٹیٹی کی خصوصیات کو ایڈجسٹ کرکے ترتیب دیا جاسکتا ہے۔",
  T_34_SP_WS_BLOCK10_PARAM3_NAME: "ویژول افکیٹ",
  T_34_SP_WS_BLOCK10_PARAM3_NAMEDESC: "وہ قسم کے ویژول افکیٹس جو لاگو کیے جا سکتے ہیں",
  T_34_SP_WS_BLOCK12_NAME: "ویژول افکیٹس کو حذف کریں",
  T_34_SP_WS_BLOCK12_NAMEDESC: "نامزد ویژول افکیٹ کو حذف کریں۔",
  T_34_SP_WS_BLOCK12_PARAM1_NAME: "ویژول افکیٹس اینٹیٹی",
  T_34_SP_WS_BLOCK12_PARAM1_NAMEDESC: "ویژول افکیٹ اینٹیٹی جس کو حذف کرنا ہے",
  T_34_SP_WS_BLOCK13_NAMEDESC: "کلائنٹ کو ویژول افکیٹس چلانے کا حکم دیں",
  T_34_SP_WS_BLOCK13_PARAM1_NAME: "کھلاڑیوں کی فہرست",
  T_34_SP_WS_BLOCK13_PARAM1_NAMEDESC: "وہ کھلاڑی جو پیغام وصول کریں گے",
  T_34_SP_WS_BLOCK13_PARAM2_NAME: "ریسورس پاتھ",
  T_34_SP_WS_BLOCK13_PARAM2_NAMEDESC: "سسٹم ریسورس پاتھ اس میں ہے:path۔ حسب ضرورت وسائل کا راستہ ختم ہو گیا ہے:پاتھ۔ بطور ڈیفالٹ خالی۔",
  T_34_SP_WS_BLOCK13_PARAM3_NAMEDESC: "RGBA چینل، جس میں ہر چینل 0 اور 255 کے درمیان ویلیو لیتا ہے جو int32 میں محفوظ ہوتا ہے۔ پہلے سے طے شدہ رنگ سفید ہے (255,255,255,255)۔",
  T_34_SP_WS_BLOCK13_PARAM4_NAME: "زوم",
  T_34_SP_WS_BLOCK13_PARAM4_NAMEDESC: "زوم پیمانہ؛ ڈیفالٹ 1 ہے",
  T_34_SP_WS_BLOCK13_PARAM5_NAMEDESC: "ڈسپلے کی پوزیشن عالمی کوآرڈینیٹس میں ظاہر کی گئی ہے۔ ویکٹر3(0) بطور ڈیفالٹ۔",
  T_34_SP_WS_BLOCK14_NAME: "ساؤنڈ ایفیکٹ پلے کریں",
  T_34_SP_WS_BLOCK14_NAMEDESC: "کلائنٹ کو ساؤنڈ ایفیکٹ چلانے کا حکم دیں",
  T_34_SP_WS_BLOCK15_NAME: "آؤٹ پٹ لاگ",
  T_34_SP_WS_BLOCK15_NAMEDESC: "لاگ انٹرفیس پر مواد کو آؤٹ پٹ کریں",
  T_34_SP_WS_BLOCK2_NAMEDESC: "سیف زون سے باہر کھلاڑیوں کو نقصان پہنچانے کے لیے آن کریں",
  T_34_SP_WS_BLOCK2_PARAM1_NAMEDESC: "سیف زون کا مرکزی پوائنٹ",
  T_34_SP_WS_BLOCK2_PARAM2_NAME: "ریڈیس",
  T_34_SP_WS_BLOCK2_PARAM2_NAMEDESC: "سیف زون کا ریڈیس",
  T_34_SP_WS_BLOCK2_PARAM3_NAMEDESC: "سیف زون کے سکڑنے کے لیے الٹی گنتی شروع ہو گئی ہے۔",
  T_34_SP_WS_BLOCK2_PARAM4_NAMEDESC: "زون کے سکڑنے کا دورانیہ",
  T_34_SP_WS_BLOCK2_PARAM5_NAMEDESC: "سیف زون سے باہر ہونے پر ہونے والے نقصان کی مقدار",
  T_34_SP_WS_BLOCK3_NAMEDESC: "ڈینجر زون بند ہونے پر، سیف زون سے باہر کے کھلاڑیوں کو نقصان نہیں پہنچے گا۔",
  T_34_SP_WS_BLOCK4_NAMEDESC: "کسی متعین وقت کے لیے بعد کی کارروائی میں تاخیر کرنے کے لیے استعمال کریں۔",
  T_34_SP_WS_BLOCK4_PARAM1_NAMEDESC: "انتظار کا دورانیہ، ملی سیکنڈ میں ناپا جاتا ہے",
  T_34_SP_WS_BLOCK5_NAMEDESC: "اس کے بعد کے ایکشن کو اگلے فریم تک ملتوی کرنے کے لیے استعمال کریں",
  T_34_SP_WS_BLOCK6_NAME: "اپنی مرضی کے مطابق HUD بنائیں",
  T_34_SP_WS_BLOCK6_NAMEDESC: "ایک نامزد کسٹم HUD بنائیں",
  T_34_SP_WS_BLOCK6_PARAM1_NAMEDESC: "ایک نام جو HUD اینٹیٹی بنانے کے لیے استعمال ہوتا ہے۔ لوکل ویرییبل جس سے یہ مطابقت رکھتا ہے وہ HUD کی تخلیق ہے۔",
  T_34_SP_WS_BLOCK6_PARAM2_NAME: "کھلاڑی",
  T_34_SP_WS_BLOCK6_PARAM2_NAMEDESC: "ایک مخصوص کھلاڑی کی اینٹیٹی۔ صرف مذکورہ کھلاڑی کو نظر آتا ہے۔",
  T_34_SP_WS_BLOCK6_PARAM3_NAMEDESC: "HUD کا منفرد انڈیکس",
  T_34_SP_WS_BLOCK7_NAMEDESC: "ایک ڈیفالٹ HUD بنائیں، جو صرف نامزد کھلاڑیوں کے لیے نظر آتا ہے۔",
  T_34_SP_WS_BLOCK8_NAMEDESC: "حذف ہونے پر، ڈیفالٹ HUD کلائنٹ پر نہیں دیکھا جائے گا (یا تو پوشیدہ یا مسترد)",
  T_34_SP_WS_BLOCK8_PARAM1_NAME: "HUD اینٹیٹی",
  T_34_SP_WS_BLOCK8_PARAM1_NAMEDESC: "HUD اینٹیٹی جس کو ڈیلیٹ کرنا ہے",
  T_34_SP_WS_BLOCK9_NAMEDESC: "ڈیلیٹ ہونے پر، کسٹم HUD کلائنٹ پر نہیں دیکھا جائے گا (یا تو پوشیدہ یا مسترد)",
  T_34_T_WS_BLOCK1_NAMEDESC: "واقعہ ٹرگر ہوتا ہے جب میچ شروع ہوتا ہے",
  T_34_T_WS_BLOCK10_NAMEDESC: "واقعہ اس وقت ٹرگر ہوتا ہے جب کسی کھلاڑی کو ختم کیا جاتا ہے",
  T_34_T_WS_BLOCK10_PARAM1_DESC: "ختم شدہ کھلاڑی جو واقعہ کو ٹرگر کرے گا۔",
  T_34_T_WS_BLOCK13_NAMEDESC: "واقعہ اس وقت ٹرگر ہوتا ہے جب ایک کھلاڑی دوسرے کھلاڑی کی مدد کرتا ہے",
  T_34_T_WS_BLOCK13_PARAM2_DESC: "وہ کھلاڑی جسے ختم کر دیا گیا ہے",
  T_34_T_WS_BLOCK14_NAMEDESC: "واقعہ اس وقت ٹرگر ہوتا ہے جب کوئی کھلاڑی نقصان پہنچاتا ہے",
  T_34_T_WS_BLOCK14_PARAM2_DESC: "کھلاڑی جو نقصان وصول کرتا ہے",
  T_34_T_WS_BLOCK14_PARAM3_DESC: "نقصان پہنچانے کی قسم",
  T_34_T_WS_BLOCK14_PARAM4_DESC: "پہنچنے والے نقصان کی مقدار",
  T_34_T_WS_BLOCK15_NAMEDESC: "واقعہ اس وقت ٹرگر ہوتا ہے جب ایک کھلاڑی دوسرے کھلاڑی کو ختم کرتا ہے",
  T_34_T_WS_BLOCK15_PARAM2_DESC: "وہ کھلاڑی جسے ختم کر دیا گیا ہے",
  T_34_T_WS_BLOCK15_PARAM3_DESC: "نقصان کی قسم جو خاتمے کا سبب بنتی ہے",
  T_34_T_WS_BLOCK16_NAMEDESC: "واقعہ اس وقت ٹرگر ہوتا ہے جب کوئی کھلاڑی میچ میں شامل ہوتا ہے",
  T_34_T_WS_BLOCK17_NAMEDESC: "واقعہ اس وقت ٹرگر ہوتا ہے جب کسی کھلاڑی کو بحال کیا جاتا ہے",
  T_34_T_WS_BLOCK18_NAMEDESC: "جب کسی ٹیم کو ہٹا دیا جاتا ہے تو واقعہ ٹرگر ہوتا ہے",
  T_34_T_WS_BLOCK19_NAMEDESC: "جب ٹیم شامل کی جاتی ہے تو واقعہ ٹرگر ہوتا ہے",
  T_34_T_WS_BLOCK2_NAMEDESC: "میچ ختم ہونے پر واقعہ ٹرگر ہوتا ہے",
  T_34_T_WS_BLOCK20_NAMEDESC: "واقعہ اس وقت ٹرگر ہوتا ہے جب کسی ٹیم کا صفایا ہو جاتا ہے",
  T_34_T_WS_BLOCK3_NAMEDESC: "واقعہ اس وقت ٹرگر ہوتا ہے جب ہر راؤنڈ شروع ہوتا ہے",
  T_34_T_WS_BLOCK3_PARAM1_DESC: "راؤنڈ نمبر 0 سے شروع ہوتا ہے",
  T_34_T_WS_BLOCK3_PARAM1_NAME: "راؤنڈ انڈیکس",
  T_34_T_WS_BLOCK4_NAMEDESC: "واقعہ اس وقت ٹرگر ہوتا ہے جب ہر راؤنڈ ختم ہوتا ہے",
  T_34_T_WS_BLOCK5_NAMEDESC: "واقعہ اس وقت ٹرگر ہوتا ہے جب اسٹیج شروع ہوتی ہے",
  T_34_T_WS_BLOCK5_PARAM1_DESC: "اسٹیج نمبر 0 سے شروع ہوتا ہے",
  T_34_T_WS_BLOCK5_PARAM1_NAME: "اسٹیج اینٹیٹی",
  T_34_T_WS_BLOCK6_NAMEDESC: "واقعہ اس وقت ٹرگر ہوتا ہے جب اسٹیج ختم ہوتی ہے",
  T_34_T_WS_BLOCK7_NAMEDESC: "واقعہ اس وقت ٹرگر ہوتا ہے جب کوئی کھلاڑی میچ چھوڑ دیتا ہے۔",
  T_34_T_WS_BLOCK7_PARAM1_DESC: "وہ کھلاڑی جو واقعہ کو ٹرگر کرے گا",
  T_34_T_WS_BLOCK7_PARAM1_NAME: "متحرک کھلاڑی",
  T_34_T_WS_BLOCK8_NAMEDESC: "کھلاڑی کا اسکور تبدیل ہونے واقعہ ٹرگر ہوتا ہے",
  T_34_T_WS_BLOCK8_PARAM2_DESC: "تبدیل شدہ اسکور کی قسم",
  T_34_T_WS_BLOCK8_PARAM3_DESC: "تبدیلی کے بعد سکور کی ویلیو",
  T_34_T_WS_BLOCK9_NAMEDESC: "ٹیم کا اسکور تبدیل ہونے واقعہ ٹرگر ہوتا ہے",
  T_34_T_WS_BLOCK9_PARAM1_DESC: "وہ ٹیم جو واقعہ کو ٹرگر کرے گی",
  T_34_WT_WS_BORNENTITY_PARAM1: "سپان پوائنٹ",
  T_34_WT_WS_BORNENTITY_PARAM2: "دستیاب کوآرڈینیٹس",
  T_34_WT_WS_BORNENTITY_PARAM3: "ڈیفالٹ سپان پوائنٹ کے طور پر سیٹ کریں",
  T_34_WT_WS_BORNENTITY_PARAM4: "چمکتی ہوئی حدود",
  T_34_WT_WS_BORNENTITY_PARAM5: "استعمال میں ہے یا نہیں",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM1: "چیک پوائنٹ HUD",
  T_34_WT_WS_CHECKPOINTENTITY_PARAM2: "کھلی حیثیت",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM1: "اسٹیٹس ٹرگر",
  T_34_WT_WS_DEADTRIGGERNTITY_PARAM2: "خاتمے کا ٹرگر ہے یا نہیں",
  T_34_WT_WS_ENTITY_PARAM1: "گیم اینٹیٹی",
  T_34_WT_WS_ENTITY_PARAM10: "ٹیموں کا#",
  T_34_WT_WS_ENTITY_PARAM11: "# ٹیم کے اراکین",
  T_34_WT_WS_ENTITY_PARAM12: "ہر راؤنڈ کا سامان دوبارہ ترتیب دیا جاتا ہے",
  T_34_WT_WS_ENTITY_PARAM13: "زون سے باہر ہونے والے نقصان کو فعال کریں",
  T_34_WT_WS_ENTITY_PARAM14: "زون کا سائز",
  T_34_WT_WS_ENTITY_PARAM15: "زون سکڑنے کا وقت",
  T_34_WT_WS_ENTITY_PARAM16: "زون سکڑنے کا دورانیہ",
  T_34_WT_WS_ENTITY_PARAM17: "زون سے باہر ہونے والے نقصان",
  T_34_WT_WS_ENTITY_PARAM18: "ہدف سکور",
  T_34_WT_WS_ENTITY_PARAM19: "خاتمے کا سکور",
  T_34_WT_WS_ENTITY_PARAM2: "غلط اسٹیٹس",
  T_34_WT_WS_ENTITY_PARAM20: "بحالی کی ٹائپ",
  T_34_WT_WS_ENTITY_PARAM21: "راؤنڈ سکور کی درجہ بندی کا معیار (کھلاڑی)",
  T_34_WT_WS_ENTITY_PARAM22: "معیار کی اہمیت (کھلاڑی)",
  T_34_WT_WS_ENTITY_PARAM23: "راؤنڈ اسکور کی درجہ بندی کا معیار (ٹیم)",
  T_34_WT_WS_ENTITY_PARAM24: "معیار کی اہمیت (ٹیم)",
  T_34_WT_WS_ENTITY_PARAM25: "اسکور کی درجہ بندی کا معیار (MVP)",
  T_34_WT_WS_ENTITY_PARAM26: "معیار کی اہمیت (MVP)",
  T_34_WT_WS_ENTITY_PARAM27: "راؤنڈ رینکنگ سکور",
  T_34_WT_WS_ENTITY_PARAM28: "نتائج کے پیج پر معیار دکھائیں",
  T_34_WT_WS_ENTITY_PARAM29: "راؤنڈز کا کل #",
  T_34_WT_WS_ENTITY_PARAM3: "گیم ٹائم",
  T_34_WT_WS_ENTITY_PARAM4: "موجودہ راؤنڈ انڈیکس",
  T_34_WT_WS_ENTITY_PARAM5: "موجودہ اسٹیج انڈیکس",
  T_34_WT_WS_ENTITY_PARAM6: "موڈ ٹیمپلیٹ ID",
  T_34_WT_WS_ENTITY_PARAM7: "کھلاڑی کی بحالی کو فعال کریں",
  T_34_WT_WS_ENTITY_PARAM8: "بوٹ کی بحالی کو فعال کریں",
  T_34_WT_WS_ENTITY_PARAM9: "بحالی کا وقت",
  T_34_WT_WS_ENTITY1_NAME: "موجودہ اینٹیٹی",
  T_34_WT_WS_ENTITY1_NAMEDESC: "موجودہ اینٹیٹی پر واپس جائیں",
  T_34_WT_WS_ENTITY10_NAME: "آئیکن کو ہٹا دیں",
  T_34_WT_WS_ENTITY10_NAMEDESC: "ایک نامزد آئیکن کو ہٹا دیں",
  T_34_WT_WS_ENTITY10_PARAM1DESC: "جس آئیکن کو آپ ہٹانا چاہتے ہیں اسے منتخب کریں",
  T_34_WT_WS_ENTITY11_NAME: "ٹیکسٹ مٹا دیں",
  T_34_WT_WS_ENTITY11_NAMEDESC: "ٹیکسٹ اینٹیٹی کو ہٹا دیں",
  T_34_WT_WS_ENTITY11_PARAM2ESC: "وہ ٹیکسٹ منتخب کریں جسے آپ مٹانا چاہتے ہیں",
  T_34_WT_WS_ENTITY12_NAMEDESC: "نامزد کھلاڑیوں کے لیے ایک آئٹم شامل کریں",
  T_34_WT_WS_ENTITY12_PARAM1DESC: "کھلاڑی جو آئٹم وصول کریں گے",
  T_34_WT_WS_ENTITY12_PARAM2DESC: "مخصوص آئٹم ID حاصل کرنی ہے",
  T_34_WT_WS_ENTITY12_PARAM2DESC3: "دی جانے والی آئٹمزکی مقدار",
  T_34_WT_WS_ENTITY12_PARAM3: "مقدار",
  T_34_WT_WS_ENTITY13_PARAM1: "ٹائپ",
  T_34_WT_WS_ENTITY13_PARAM2: "مقام",
  T_34_WT_WS_ENTITY13_PARAM2DESC: "آبجیکٹ کے سپان مقام کے کوآرڈینیٹس",
  T_34_WT_WS_ENTITY13_PARAM4: "آبجیکٹ",
  T_34_WT_WS_ENTITY14_NAME: "آبجیکٹ ہٹائیں",
  T_34_WT_WS_ENTITY14_NAMEDESC: "ایک نامزد آبجیکٹ کو ہٹا دیں",
  T_34_WT_WS_ENTITY14_PARAM1DESC: "آبجیکٹ کو ڈیلیٹ کریں",
  T_34_WT_WS_ENTITY15_NAMEDESC: "تمام پلیئر اینٹیٹیز کو حاصل کریں",
  T_34_WT_WS_ENTITY16_NAMEDESC: "ٹیم  کی تمام اینٹیٹیزکو حاصل کریں",
  T_34_WT_WS_ENTITY17_NAMEDESC: "نامزد کھلاڑیوں کے لیے ہیلتھ پوائنٹ کی ایک مقررہ تعداد بازیافت کریں۔ اگر وصولی کی تعداد زیادہ سے زیادہ ہیلتھ پوائنٹ سے زیادہ ہے، ہیلتھ پوائنٹ صرف زیادہ سے زیادہ وصولی کرے گا۔",
  T_34_WT_WS_ENTITY17_PARAM1DESC: "وہ کھلاڑی جن کے ہیلتھ پوائنٹ کے اتار چڑھاؤ کو کنفیگر کیا جا رہا ہے",
  T_34_WT_WS_ENTITY17_PARAM2DESC: "ہیلتھ پوائنٹ کی مقرر کردہ تعداد وصول کی جانی ہے",
  T_34_WT_WS_ENTITY18_NAME: "رینڈم سپان کوآرڈینیٹس حاصل کریں",
  T_34_WT_WS_ENTITY18_NAMEDESC: "نامزد کھلاڑیوں کے لیے اس جگہ کو ترتیب دیں جہاں سے اسپان کرنا اور واپس جانا ہے",
  T_34_WT_WS_ENTITY18_PARAM1DESC: "کھلاڑی جو اس مقام سے رینڈم طور پر سپان ہوں گے",
  T_34_WT_WS_ENTITY18_RETURNDESC: "اس مقام کے کوآرڈینیٹس جہاں کھلاڑی کو تفویض کیا جائے گا",
  T_34_WT_WS_ENTITY19_NAME: "پلیئر سکور حاصل کریں",
  T_34_WT_WS_ENTITY19_NAMEDESC: "نامزد کھلاڑیوں کے کچھ اسکور حاصل کریں",
  T_34_WT_WS_ENTITY19_PARAM1DESC: "اس کھلاڑی (کھلاڑیوں) کی اسکور اینٹیٹی حاصل کریں",
  T_34_WT_WS_ENTITY19_PARAM2DESC: "اسکور کی قسم حاصل کریں",
  T_34_WT_WS_ENTITY19_RETURNDESC: "حاصل کرنے کے لیے مخصوص سکور کی ویلیو",
  T_34_WT_WS_ENTITY2_NAME: "پراپرٹی سیٹ کریں",
  T_34_WT_WS_ENTITY2_NAMEDESC: "کسی پراپرٹی کی ویلیو کو ترتیب دیں، جہاں پراپرٹی کی قسم پہلے ہی منتخب کی گئی ہے",
  T_34_WT_WS_ENTITY2_PARAM1: "اینٹیٹی",
  T_34_WT_WS_ENTITY2_PARAM1DESC: "گیم اینٹیٹی کی پراپرٹی ویلیو",
  T_34_WT_WS_ENTITY2_PARAM3: "پراپرٹی",
  T_34_WT_WS_ENTITY2_PARAM3DESC: "اس گیم اینٹیٹی کی ایک خاص پراپرٹی",
  T_34_WT_WS_ENTITY2_PARAM4: "ویلیو",
  T_34_WT_WS_ENTITY2_PARAM4DESC: "پراپرٹی کی ایک مخصوص قیمت۔ یقینی بنائیں کہ پراپرٹی کی قسم منتخب کردہ کے ساتھ سیدھ میں ہے اور متعلقہ بلاکس میں کنفیگر کی گئی قسم سے میچ کرتی ہے۔",
  T_34_WT_WS_ENTITY20_NAMEDESC: "نامزد کھلاڑیوں کے مخصوص اسکور کو ترتیب دیں",
  T_34_WT_WS_ENTITY20_PARAM1DESC: "اس کھلاڑی (کھلاڑیوں) کی اسکور اینٹیٹی کو ترتیب دیں",
  T_34_WT_WS_ENTITY20_PARAM2DESC: "اسکور کی قسم کو ترتیب دیں",
  T_34_WT_WS_ENTITY20_PARAM3: "سکور",
  T_34_WT_WS_ENTITY20_PARAM3DESC: "مخصوص سکور کی ویلیو سیٹ کی جا رہی ہے",
  T_34_WT_WS_ENTITY21_NAME: "ٹیم کا کل سکور حاصل کریں",
  T_34_WT_WS_ENTITY21_NAMEDESC: "نامزد ٹیموں کے کل اسکور کی ایک خاص قسم حاصل کریں",
  T_34_WT_WS_ENTITY21_PARAM1: "ٹیم",
  T_34_WT_WS_ENTITY21_PARAM1DESC: "اس ٹیم (ٹیموں) کی اسکور اینٹیٹی حاصل کریں",
  T_34_WT_WS_ENTITY22_NAME: "ٹیم کا موجودہ راؤنڈ اسکور سیٹ کریں",
  T_34_WT_WS_ENTITY22_NAMEDESC: "نامزد ٹیموں کے موجودہ راؤنڈ اسکور کی ایک خاص قسم کو کنفیگر کریں",
  T_34_WT_WS_ENTITY22_PARAM1DESC: "اس ٹیم (ٹیمز) کے اسکور کو ترتیب دیں",
  T_34_WT_WS_ENTITY23_NAME: "پلیئر راؤنڈ اسکور حاصل کریں",
  T_34_WT_WS_ENTITY23_NAMEDESC: "نامزد کھلاڑیوں کے لیے مخصوص راؤنڈ کے کچھ اسکور حاصل کریں",
  T_34_WT_WS_ENTITY23_PARAM1DESC: "اس کھلاڑی (کھلاڑیوں) کا راؤنڈ سکور حاصل کریں",
  T_34_WT_WS_ENTITY23_PARAM2: "راؤنڈ",
  T_34_WT_WS_ENTITY23_PARAM2DESC: "اس راؤنڈ سے اسکور حاصل کریں",
  T_34_WT_WS_ENTITY24_NAME: "ٹیم راؤنڈ اسکور حاصل کریں",
  T_34_WT_WS_ENTITY24_NAMEDESC: "نامزد ٹیمز کے لیے مخصوص راؤنڈ کے کچھ اسکور حاصل کریں",
  T_34_WT_WS_ENTITY25_NAME: "ٹیلی پورٹ",
  T_34_WT_WS_ENTITY25_NAMEDESC: "نامزد کھلاڑیوں کو ایک مخصوص جگہ پر ٹیلی پورٹ کریں",
  T_34_WT_WS_ENTITY25_PARAM1DESC: "کھلاڑی جنہیں ٹیلی پورٹ کیا جائے گا",
  T_34_WT_WS_ENTITY25_PARAM2DESC: "کوآرڈینیٹس جہاں کھلاڑی (کھلاڑیوں) کو ٹیلی پورٹ کیا جائے گا۔",
  T_34_WT_WS_ENTITY26_NAMEDESC: "نامزد اہداف کو نقصان پہنچانے کے لیے نامزد کھلاڑیوں کو ایکٹیویٹ کریں۔ اگر کوئی حملہ آور کھلاڑی منتخب نہیں کیا جاتا ہے تو، مقرر کردہ اہداف کو سسٹم سے نقصان پہنچے گا۔",
  T_34_WT_WS_ENTITY26_PARAM2DESC: "اینٹیٹیز جو نقصان وصول کریں گی",
  T_34_WT_WS_ENTITY26_PARAM4DESC: "نمٹائے گئے نقصان کی مقدار",
  T_34_WT_WS_ENTITY28_NAMEDESC: "نامزد کھلاڑیوں کو زندہ کریں",
  T_34_WT_WS_ENTITY28_PARAM1DESC: "پلیئر اینٹیٹیز جن کو دوبارہ زندہ کیا جاسکتا ہے",
  T_34_WT_WS_ENTITY3_NAMEDESC: "بلاک کی قسم کو ترتیب دیں",
  T_34_WT_WS_ENTITY3_PARAM1: "کے طور پر",
  T_34_WT_WS_ENTITY4_NAME: "پراپرٹی حاصل کریں",
  T_34_WT_WS_ENTITY4_NAMEDESC: "کسی اینٹیٹی کی مخصوص پراپرٹی حاصل کریں۔",
  T_34_WT_WS_ENTITY4_PARAM1DESC: "پراپرٹی کی قیمت کی مخصوص گیم اینٹیٹی حاصل کریں۔",
  T_34_WT_WS_ENTITY4_RETURNDESC: "مخصوص پراپرٹی کی ویلیو حاصل کی جانی ہے",
  T_34_WT_WS_ENTITY5_NAMEDESC: "تمام کھلاڑیوں کے لیے حرکت کرنے کی صلاحیت کو ترتیب دیں",
  T_34_WT_WS_ENTITY6_NAME: "آئیکن بنائیں",
  T_34_WT_WS_ENTITY6_PARAM1: "آئیکن",
  T_34_WT_WS_ENTITY6_PARAM1DESC: "HUD پر ظاہر ہونے والی ایک تصویر۔ مختلف ڈیزائنز میں سے انتخاب کریں۔",
  T_34_WT_WS_ENTITY6_PARAM4DESC: "آئیکن کو منتخب کریں جس پر ڈیزائن لاگو کیا جانا چاہئے",
  T_34_WT_WS_ENTITY7_NAMEDESC: "نامزد کھلاڑیوں کے لیے ایک HUD آئیکن بنائیں۔ اگر کسی کھلاڑی کا انتخاب نہیں کیا جاتا ہے، تو HUD تمام کھلاڑیوں کے لیے بنایا جائے گا۔",
  T_34_WT_WS_ENTITY7_PARAM1: "کھلاڑی",
  T_34_WT_WS_ENTITY7_PARAM1DESC: "منتخب کھلاڑیوں کے لیے ایک HUD آئیکن بنائیں",
  T_34_WT_WS_ENTITY8_NAME: "ٹیکسٹ بنائیں",
  T_34_WT_WS_ENTITY8_PARAM1: "ٹیکسٹ",
  T_34_WT_WS_ENTITY8_PARAM1DESC: "اس کمانڈ سے بنائے جانے والے مخصوص ٹیکسٹ کا مواد",
  T_34_WT_WS_ENTITY8_PARAM3DESC: "ٹیکسٹ اینٹیٹی جو فی الحال بنائی جا رہی ہے۔",
  T_34_WT_WS_ENTITY9_NAMEDESC: "نامزد کھلاڑیوں کے لیے HUD ٹیکسٹ کی ایک لائن شامل کریں۔ اگر کسی کھلاڑی کی اینٹیٹی کو منتخب نہیں کیا جاتا ہے، تو ٹیکسٹ تمام کھلاڑیوں کے HUD پر بنایا جائے گا۔",
  T_34_WT_WS_ENTITY9_PARAM1DESC: "منتخب کھلاڑیوں کے لیے HUD ٹیکسٹ شامل کریں",
  T_34_WT_WS_ICONENTITY_PARAM1: "آئیکن اینٹیٹی",
  T_34_WT_WS_ICONENTITY_PARAM2: "ڈیزائن",
  T_34_WT_WS_ICONENTITY_PARAM3: "رنگ",
  T_34_WT_WS_ICONENTITY_PARAM4: "سکیل",
  T_34_WT_WS_ICONENTITY_PARAM5: "ڈسپلے کی پوزیشن",
  T_34_WT_WS_ICONENTITY_PARAM6: "ہدف کی فالو کریں",
  T_34_WT_WS_ICONENTITY_PARAM7: "دیواروں سے پار نظر آتا ہے",
  T_34_WT_WS_ICONENTITY_PARAM8: "ہمیشہ اسکرین پر",
  T_34_WT_WS_ONETEAM_TAG: "سنگل ٹیم",
  T_34_WT_WS_PHASEENTITY_PARAM1: "اسٹیج اینٹیٹی",
  T_34_WT_WS_PHASEENTITY_PARAM2: "اسٹیج انڈیکس",
  T_34_WT_WS_PHASEENTITY_PARAM3: "شروع ہونے کا وقت",
  T_34_WT_WS_PHASEENTITY_PARAM4: "اختتامی وقت",
  T_34_WT_WS_PHASEENTITY_PARAM5: "دورانیہ",
  T_34_WT_WS_PLAYERENTITY_PARAM1: "پلیئر اینٹیٹی",
  T_34_WT_WS_PLAYERENTITY_PARAM10: "بحالی پوائنٹ",
  T_34_WT_WS_PLAYERENTITY_PARAM12: "ہتھیاروں کا نقصان %",
  T_34_WT_WS_PLAYERENTITY_PARAM13: "کریکٹر 3D ماڈل",
  T_34_WT_WS_PLAYERENTITY_PARAM17: "شناخت",
  T_34_WT_WS_PLAYERENTITY_PARAM18: "موجودہ ہیلتھ پوائنٹ",
  T_34_WT_WS_PLAYERENTITY_PARAM2: "زیادہ سے زیادہ ہیلتھ پوائنٹ",
  T_34_WT_WS_PLAYERENTITY_PARAM3: "AI",
  T_34_WT_WS_PLAYERENTITY_PARAM4: "کھلاڑی کا اسٹیٹس",
  T_34_WT_WS_PLAYERENTITY_PARAM5: "سروائیول کا وقت",
  T_34_WT_WS_PLAYERENTITY_PARAM6: "ناقابل تسخیر",
  T_34_WT_WS_PLAYERENTITY_PARAM7: "ٹیم",
  T_34_WT_WS_PLAYERENTITY_PARAM8: "ٹارگٹ چیک پوائنٹ ID",
  T_34_WT_WS_PLAYERENTITY_PARAM9: "سپان پوائنٹ",
  T_34_WT_WS_PROCIRCLE_ICON: "آئیکن",
  T_34_WT_WS_PVEDESC1: "اگر کم از کم ایک کھلاڑی وقت ختم ہونے سے پہلے فائنل لائن تک پہنچ جاتا ہے تو ٹیم جیت جاتی ہے۔ اگر تمام کھلاڑی ایک ہی وقت میں ختم ہو جائیں تو کھیل ختم ہو جائے گا۔",
  T_34_WT_WS_PVEDESC2: "جیتنے کے لیے مقررہ وقت تک زندہ رہیں۔ اگر تمام کھلاڑی ایک ہی وقت میں ختم ہو جائیں تو گیم ختم ہو جائے گی۔",
  T_34_WT_WS_PVENAME1: "رش",
  T_34_WT_WS_PVENAME2: "برداشت",
  T_34_WT_WS_RUNCHECKENTITY_PARAM1: "موجودہ چیک پوائنٹ ID",
  T_34_WT_WS_RUNCHECKENTITY_PARAM2: "پارکور موڈ چیک پوائنٹ نمبر",
  T_34_WT_WS_SKILLSET14: "تلوار باز کا قہر (کینٹہ)",
  T_34_WT_WS_TEAMENTITY_PARAM1: "ٹیم اینٹیٹی",
  T_34_WT_WS_TEAMENTITY_PARAM2: "اککا",
  T_34_WT_WS_TEAMENTITY_PARAM3: "تمام ممبران",
  T_34_WT_WS_TRIGGERNTITY_PARAM1: "باقاعدہ ٹرگر",
  T_34_WT_WS_TRIGGERNTITY_PARAM2: "ظاہری شکل",
  T_34_WT_WS_TXTENTITY_PARAM1: "ٹیکسٹ اینٹیٹی",
  T_34_WT_WS_TXTENTITY_PARAM2: "مواد",
  T_34_WT_WS_VFXENTITY_PARAM1: "ویژول افکیٹس اینٹیٹی",
  T_34_WZ_WS_LOGIC10_NAME: "اگلے پر جاری رکھیں",
  T_34_WZ_WS_LOGIC10_NAMEDESC: "موجودہ لوپ تکرار کو چھوڑیں اور اگلا عمل کریں",
  T_34_WZ_WS_LOGIC11_NAME: "واپسی",
  T_34_WZ_WS_LOGIC11_NAMEDESC: "موجودہ عمل کو ختم کرتا ہے اور مرکزی پروگرام میں واپس آتا ہے۔ واپس آنے پر ڈیٹا واپس بھیجنے کی اجازت دیتا ہے۔",
  T_34_WZ_WS_LOGIC11_PARAM1_NAME: "واپسی کی قیمت",
  T_34_WZ_WS_LOGIC11_PARAM1_NAMEDESC: "مرکزی پروگرام میں واپس بھیجے جانے والا ڈیٹا",
  T_34_WZ_WS_LOGIC2_NAME: "موازنہ کریں",
  T_34_WZ_WS_LOGIC2_NAMEDESC: "نامزد آپریٹر کا استعمال کرتے ہوئے 2 ویلیوز کا موازنہ کریں۔",
  T_34_WZ_WS_LOGIC2_PARAM1_NAME: "بائیں ویلیو",
  T_34_WZ_WS_LOGIC2_PARAM1_NAMEDESC: "کمپیریزن کے لیے استعمال ہونے والی لیفٹ سائڈ ویلیو",
  T_34_WZ_WS_LOGIC2_PARAM2_NAME: "کمپیریزن فنکشن",
  T_34_WZ_WS_LOGIC2_PARAM2_NAMEDESC: "منتخب کریں کہ آپ ویلیوز کا موازنہ کیسے کرنا چاہتے ہیں۔ سپورٹڈ آپریٹرز یہ ہیں: >, >=,==, !=, <=, <, AND (صرف بولین)، OR (صرف بولین)",
  T_34_WZ_WS_LOGIC2_PARAM3_NAME: "دائیں ویلیو",
  T_34_WZ_WS_LOGIC2_PARAM3_NAMEDESC: "کمپیریزن کے لیے استعمال ہونے والی دائیں طرف کی ویلیو",
  T_34_WZ_WS_LOGIC2_PARAM4_NAMEDESC: "کمپیریزن کا نتیجہ",
  T_34_WZ_WS_LOGIC3_NAME: "NOT",
  T_34_WZ_WS_LOGIC3_NAMEDESC: "ایک لاجیکل ویلیو کا ریورس دیتا ہے",
  T_34_WZ_WS_LOGIC3_PARAM1_NAMEDESC: "وہ قدر جس پر آپ NOT آپریٹر استعمال کرنا چاہتے ہیں",
  T_34_WZ_WS_LOGIC3_PARAM2_NAMEDESC: "NOT آپریشن کا نتیجہ",
  T_34_WZ_WS_LOGIC4_NAME: "خالی چیک کریں",
  T_34_WZ_WS_LOGIC4_NAMEDESC: "چیک کریں کہ آیا کوئی اینٹیٹی خالی ہے۔",
  T_34_WZ_WS_LOGIC4_PARAM1_NAME: "اینٹیٹی",
  T_34_WZ_WS_LOGIC4_PARAM1_NAMEDESC: "وہ اینٹیٹی جس سے خالی پن کو جانچنا ہے۔",
  T_34_WZ_WS_LOGIC4_PARAM2_NAMEDESC: "اینٹیٹی خالی ہے یا نہیں؟",
  T_34_WZ_WS_LOGIC5_NAME: "کنڈیشنل اسٹیٹمنٹس",
  T_34_WZ_WS_LOGIC5_NAMEDESC: "کنڈیشنز پوری ہو رہی ہیں یا نہیں اس کے مطابق عملدرآمد کرتا ہے۔ سب-پراسیزس بعد میں آنے والی لاجک برانچز ہی ہیں۔",
  T_34_WZ_WS_LOGIC5_PARAM1_NAME: "ویلیو",
  T_34_WZ_WS_LOGIC5_PARAM1_NAMEDESC: "کنڈیشنز کی تعداد اور سب-پراسیزس (لاجک برانچز) کی تعداد ایک جیسی ہونی چاہیے",
  T_34_WZ_WS_LOGIC6_NAME: "انٹیجر رینج کا لوپ",
  T_34_WZ_WS_LOGIC6_NAMEDESC: "z کے ایک سٹیپ سے x سے y تک لوپ کریں۔ سب-پراسیس خود لوپ ہے",
  T_34_WZ_WS_LOGIC6_PARAM1_NAMEDESC: "لوپ انڈیکس کا نام جو لوکل ویریایبل کے لوپ انڈیکس کی ویلیو نکالنے کے لیے استعمال کیا جا سکتا ہے",
  T_34_WZ_WS_LOGIC6_PARAM2_NAME: "شروع ویلیو",
  T_34_WZ_WS_LOGIC6_PARAM2_NAMEDESC: "وہ ویلیو جس سے لوپ شروع ہوتا ہے",
  T_34_WZ_WS_LOGIC6_PARAM3_NAME: "اختتامی ویلیو",
  T_34_WZ_WS_LOGIC6_PARAM3_NAMEDESC: "وہ ویلیو جس پر لوپ ختم ہوتا ہے",
  T_34_WZ_WS_LOGIC6_PARAM4_NAME: "قدم",
  T_34_WZ_WS_LOGIC6_PARAM4_NAMEDESC: "ہر لوپ کا مرحلہ۔ جب شروعاتی ویلیواختتامی ویلیو سے کم ہو، تو مرحلہ 0 سے زیادہ ہونا چاہیے۔ جب آغاز کی ویلیو اختتامی ویلیو سے زیادہ ہو، تو مرحلہ 0 سے کم ہونا چاہیے۔",
  T_34_WZ_WS_LOGIC7_NAME: "ہر ایلیمینٹ کو لوپ کریں",
  T_34_WZ_WS_LOGIC7_NAMEDESC: "ڈیٹا کنٹینر کے ٹریورسل کو اس میں موجود ہرسب-ایلیمینٹ کو نکالنے کے قابل بناتا ہے۔ سب-پراسیز خود لوپ ہے۔",
  T_34_WZ_WS_LOGIC7_PARAM1_NAME: "عنصر",
  T_34_WZ_WS_LOGIC7_PARAM1_NAMEDESC: "اس نام پر ٹریورس کرنے سے لوکل ویریایبل کے سب-ایلیمینٹ کی ویلیو معلوم ہو جائے گی۔",
  T_34_WZ_WS_LOGIC7_PARAM3_NAME: "ڈیٹا کنٹینر",
  T_34_WZ_WS_LOGIC7_PARAM3_NAMEDESC: "ٹریورس کرنے کے لیے ڈیٹا کنٹینر۔ فی الحال لسٹ کی اقسام کو اسپورٹ کرتا ہے",
  T_34_WZ_WS_LOGIC8_NAME: "کنڈیشنل لوپ",
  T_34_WZ_WS_LOGIC8_NAMEDESC: "ایک کنڈیشنل لوپ اس وقت تک دہرایا جاتا ہے جب تک کہ کوئی کنڈیشن پوری نہ ہوجائے۔ کنڈیشن غلط ہونے پر لوپ رک جاتا ہے۔",
  T_34_WZ_WS_LOGIC8_PARAM1_NAME: "کنڈیشن",
  T_34_WZ_WS_LOGIC8_PARAM1_NAMEDESC: "کنڈیشن درست ہونے پر لوپ کو دہرایا جاتا ہے اور کنڈیشن غلط ہونے تک رک جاتا ہے",
  T_34_WZ_WS_LOGIC9_NAME: "لوپ بریک کریں",
  T_34_WZ_WS_LOGIC9_NAMEDESC: "موجودہ لوپ کے عمل کو روکتا ہے اور لوپ سے باہر چھلانگ لگاتا ہے",
  T_34_Y_B_DINOSAURS: "ڈائناسور الیوژن (باٹم)",
  T_34_YF_M24_N: "M24",
  T_34_YS_F_B_ANGEL_BW: "پیور اینجل (F)",
  T_34_YS_F_B_PANDACATTLE: "مو زو (باٹم)",
  T_34_YS_F_B_RAMPAGE4_RAIN: "ایکوا روگ (باٹم)",
  T_34_YS_F_H_RAMPAGE4_RAIN: "ایکوا روگ (ہیڈ)",
  T_34_YS_F_HA_RAMPAGE4_RAIN: "ایکوا روگ (فیس پینٹ)",
  T_34_YS_F_S_PANDACATTLE: "مو زو (جوتے)",
  T_34_YS_F_S_RAMPAGE4_RAIN: "ایکوا روگ (جوتے)",
  T_34_YS_F_T_PANDACATTLE: "مو زو (ٹاپ)",
  T_34_YS_F_T_RAMPAGE4_RAIN: "ایکوا روگ (ٹاپ)",
  T_34_YS_M_B_ANGEL_BW: "خالص اینجل (M)",
  T_34_YS_M_B_PANDACATTLE: "پانڈا پاجامہ (باٹم)",
  T_34_YS_M_H_PANDACATTLE: "پانڈا پاجامہ (ہیڈ)",
  T_34_YS_M_S_PANDACATTLE: "پانڈا پاجامہ (جوتے)",
  T_34_YS_M_T_PANDACATTLE: "پانڈا پاجامہ (ٹاپ)",
  T_34_YZY_CHARACTER_RHYTHMGIRL_N: "A-Patroa",
  T_35_C_SKILL_DESC_BRAZILSOLDIER: "دشمن کو گرا کر {0} توانائی پوائنٹ حاصل کریں",
  T_35_DY_PET_OWL_N: "ہوٹ",
  T_35_DY_PETSKIN_ALIEN_DIGITALUNIVERSE_N: "پٹ اسکن: سپیسشپ مونی",
  T_35_DY_PETSKIN_CATEAM_AXOLOTL_N: "پٹ اسکن: کریمی بلیو ٹریس زیسل",
  T_35_DY_PETSKIN_CATEAM_HAWK_N: "پٹ اسکن: اگوئی بلیو",
  T_35_DY_PETSKIN_OWL_FIRE_N: "پٹ اسکن: ہوٹ آن فائر",
  T_35_DY_PETSKIN_OWL_NIGHT_N: "پٹ اسکن: نوکترنل ہوٹ",
  T_35_DY_PETSKIN_OWL_STORM_N: "پٹ اسکن: فروسٹی ہوٹ",
  T_35_JL_KNOCKEDDOWN: "گرا دیا گیا ہے",
  T_35_JL_SKILL_DESC_CRAZYGIRL: "{1} سیکنڈ کے لیے، گلو والز پر کامیابی کے ساتھ فائرنگ سے دشمنوں کو اس کے {3} میٹر کے اندر نشان زد کر دے گا اور نشان زدہ دشمنوں کو نقصان پہنچانے کے لیے گلو وال میں گھس جائے گا(جس کو پہنچنے والا نقصان معمول سے کم ہو گا)۔ زیادہ سے زیادہ {0} گلو والز پر مؤثر۔ کولڈاؤن: {2}سیکنڈ۔",
  T_35_JL_SKILL_NAME_CRAZYGIRL: "وال برال",
  T_35_KY_INFECTION_MAPNAME: "بنجر زمین",
  T_35_M_WS_BUTTONCLICKDESC: "اس واقعہ کو ٹرگر کرتا ہے جب متعلقہ بٹن دبایا جاتا ہے۔ ٹرگر پلیئر پیرامیٹرز کا استعمال کرتے ہوئے حاصل کیا جا سکتا ہے۔",
  T_35_M_WS_GETTEAMMATEPOS: "قریبی ٹیم کے ساتھیوں کے مقامات حاصل کریں",
  T_35_M_WS_ROUND2: "موجودہ ویو",
  T_35_PD_Infection_HUMANSELECT: "ہتھیار منتخب کریں",
  T_35_PD_INFECTION_MODENAME: "ڈرویڈ کی تباہ کاریاں",
  T_35_QX_WS_ICONTYPE_ITEM: "چیز",
  T_35_QX_WS_ICONTYPE_NATURE: "فطرت کی شکلیں",
  T_35_QX_WS_ICONTYPE_SHAPE: "جیومیٹرک",
  T_35_QX_WS_ICONTYPE_SYMBOL: "علامت",
  T_35_QX_WS_SOUNDTYPE_WEAPON: "ہتھیار",
  T_35_R_EMOTE_TAG_MUSIC_N: "میوزک",
  T_35_RW_SKILL_DESC_Singers: "{0} میٹر کے اندر ہنر مند صارف اور اتحادی توانائی پوائنٹ کا استعمال کرتے ہوئے {1}% نقصان کو روک سکتے ہیں۔ اس صورت میں، اتحادیوں سے کاٹی گئی توانائی پوائنٹ کی رقم کو ہنر مند صارف کے توانائی پوائنٹ میں شامل کیا جائے گا۔",
  T_35_RW_SKILL_NAME_Singers: "سائلنٹ سینٹینیل",
  T_35_SP_WS_COMMENTKEY_01: "مناسب مشکل",
  T_35_SP_WS_COMMENTKEY_02: "تخلیقی",
  T_35_SP_WS_COMMENTKEY_03: "دلچسپ گیم پلے",
  T_35_SP_WS_COMMENTKEY_04: "بار بار کھیلا جا سکتا ہے",
  T_35_SP_WS_COMMENTKEY_05: "دلچسپ کہانی",
  T_35_SP_WS_COMMENTKEY_06: "اچھی طرح سے متوازن",
  T_35_SP_WS_COMMENTKEY_07: "خوشگوار تجربہ",
  T_35_SP_WS_COMMENTKEY_08: "آسان",
  T_35_SP_WS_COMMENTKEY_09: "جمالیاتی لحاظ سے خوش کن",
  T_35_SP_WS_COMMENTKEY_10: "بہت مشکل",
  T_35_SP_WS_COMMENTKEY_11: "بہت آسان",
  T_35_SP_WS_COMMENTKEY_12: "بورنگ",
  T_35_SP_WS_COMMENTKEY_13: "بہت لمبا",
  T_35_SP_WS_COMMENTKEY_14: "خراب توازن",
  T_35_SP_WS_COMMENTKEY_15: "ناخوشگوار تجربہ",
  T_35_SP_WS_IMAGE03: "ساخت",
  T_35_SP_WS_IMAGE04: "فریم",
  T_35_SY_CHARGESHOT_TEARS_N: "چارج بسٹر- لاوا لسٹر",
  T_35_SY_GRENADE_DIGITALUNIVERSE_01_N: "گرینیڈ- کرسٹل ایری",
  T_35_SY_GRENADE_PIRATES_N: "گرینیڈ- راؤڈی سیرولر",
  T_35_SY_GRENADE_RIDERS_N: "گرینیڈ- گریم رائڈر",
  T_35_SY_M24_KUN_N: "M24- ریور ڈسٹ سپلاشر",
  T_35_SY_SCAR_PARKOUR_N: "سکار- گسٹو فری رنر",
  T_35_SY_VEHICLE_JEEP_PANTOMIME_N: "جیپ- مونوکروم جگسا",
  T_35_SY_VEHICLE_MONSTER_DIGITALUNIVERSE_D: "جشن کا لطف اٹھائیں!",
  T_35_SY_VEHICLE_MOTOBIKE_DIGITALUNIVERSE_N: "موٹربائیک- کرسٹل سمٹری",
  T_35_WT_WS_PREFAB_MENUBAR_1: "ساخت & سجاوٹ",
  T_35_WT_WS_PREFAB_MENUBAR_1_1: "ڈھانچے",
  T_35_WT_WS_PREFAB_MENUBAR_1_6: "دیگر",
  T_35_WT_WS_PREFAB_MENUBAR_2: "فن تعمیر",
  T_35_WT_WS_PREFAB_MENUBAR_2_1: "بڑی عمارتیں",
  T_35_WT_WS_PREFAB_MENUBAR_2_2: "درمیانی سائز کی عمارتیں",
  T_35_WT_WS_PREFAB_MENUBAR_3: "گیم پلے آبجیکٹ",
  T_35_WT_WS_PREFAB_MENUBAR_3_1: "موڈ لوازم",
  T_35_WT_WS_PREFAB_MENUBAR_3_6: "میوزک",
  T_35_WT_WS_PVEMODE_TAG: "سروائیول موڈ",
  T_35_WZY_WS_BECRE_NAMEDESC: "جب یہ اینٹیٹی بنائی جاتی ہے تو ٹرگر ہوتا ہے",
  T_35_WZY_WS_BEKILL_NAMEDESC: 'جب اس اینٹیٹی کو ختم کیا جاتا ہے تو ٹرگر ہوتا ہے۔ حملے کے سورس کی شناخت "ٹرگر اینٹیٹی " کا استعمال کرتے ہوئے کی جا سکتی ہے۔ اور حملے کی قسم کو "نقصان کی قسم" کا استعمال کرتے ہوئے پہچانا جا سکتا ہے۔',
  T_35_WZY_WS_BEKILL_PARAM1_NAMEDESC: "وہ اینٹیٹی جو واقعہ کو ٹرگر کرتی ہے",
  T_35_WZY_WS_CREPROP_NAMEDESC: "کسی مخصوص جگہ پر کسی قسم کی آئٹم یا آئٹمز کا سیٹ بنائیں۔ ایک قسم کی آئٹم بناتے وقت، تعداد اس آئٹم کی تعداد ہوتی ہے۔ آئٹمز کا سیٹ بناتے وقت، تعداد وہ تعداد کی فہرست ہوتی ہے جو آئٹم کی فہرست سے مطابقت رکھتی ہے۔ تخلیق کردہ آئٹمز نقشے کی یونٹس پر منحصر ہوں گے۔",
  T_35_WZY_WS_CREPROP_PARAM1_NAMEDESC: "ایک لسٹ جس میں وہ آئٹمز ہوں جو بنائے جائیں گے۔ یہ ایک آئٹم پر بھی مشتمل ہو سکتی ہے۔",
  T_35_WZY_WS_CREPROP_PARAM2_NAMEDESC: "تعداد کی لسٹ جو آئٹم کی لسٹ سے مطابقت رکھتی ہے۔ اس میں صرف ایک قسم کے آئٹم کی تعداد ہو سکتی ہے۔",
  T_35_WZY_WS_DAMTYPE_CAR: "وہیکل",
  T_35_WZY_WS_DAMTYPE_FALL: "فال",
  T_35_WZY_WS_DAMTYPE_FIREARMS: "گن",
  T_35_WZY_WS_DAMTYPE_GRENADE: "گرینیڈ",
  T_35_WZY_WS_DAMTYPE_MELEE: "قریبی وار",
  T_35_WZY_WS_DAMTYPE_ZONE: "زون سے باہر",
  T_35_WZY_WS_DELPROP_NAMEDESC: "مخصوص کھلاڑیوں کے آئٹمز کی ایک مخصوص تعداد کو حذف کریں",
  T_35_WZY_WS_ENTERTRIGGER_NAME: "ٹرگر ایریا داخل کریں",
  T_35_WZY_WS_ENTERTRIGGER_NAMEDESC: 'ٹرگر اس وقت ہوتا ہے جب ایک "ٹرگراینٹیٹی" ایک ٹرگر علاقے میں داخل ہوتی ہے',
  T_35_WZY_WS_ENTITYPLAYER_DESC: "اینٹیٹی حاصل کرنے کے لیے کھلاڑی۔ کھلاڑی کے ساتھ منسلک ہونے پر، اینٹیٹی کی معلومات صرف مذکورہ کھلاڑی کے لیے اپ ڈیٹ کی جائے گی۔ جب کوئی کھلاڑی منسلک نہیں ہوتا ہے، تمام کھلاڑیوں کو اینٹیٹی کی معلومات موصول ہوں گی",
  T_35_WZY_WS_FIGHTENTITY_NAME: "بیٹل اینٹیٹی",
  T_35_WZY_WS_GETALLOB_NAMEDESC: "ایک مخصوص قسم کی تمام آئٹمز حاصل کریں۔ واپس آنے والا نتیجہ ایک لسٹ ہے۔",
  T_35_WZY_WS_GETALLOB_PARAM1_NAMEDESC: "آبجیکٹ کی قسم",
  T_35_WZY_WS_HUDWIDGET_NAME: "UI کنٹرول",
  T_35_WZY_WS_HURT_NAMEDESC: 'جب اس اینٹیٹی کو نقصان پہنچاتا ہے تو  ٹرگر ہوتا ہے۔ حملے کے سورس کی شناخت "ٹرگر اینٹیٹی" کے ذریعے کی جا سکتی ہے۔',
  T_35_WZY_WS_ITEMSTYPE_NAMEDESC: "آئٹم کی قسم",
  T_35_WZY_WS_LEVELOBJECT_NAME: "اسٹیج آبجیکٹ",
  T_35_WZY_WS_OBKILL_NAMEDESC: 'اس وقت اینٹیٹی ہوتا ہے جب یہ اینٹیٹی کسی دوسری اینٹیٹی کو ختم کرتی ہے۔ جس اینٹیٹی کو ختم کیا جا رہا ہے اس کی شناخت "ختم شدہ اینٹیٹی" کے ذریعے کی جا سکتی ہے۔',
  T_35_WZY_WS_OBKILL_PARAM1_NAMEDESC: "وہ اینٹیٹی جو ختم ہو گئی ہے",
  T_35_WZY_WS_ONHURT_NAMEDESC: "ٹرگر ہوتا ہے جب کوئی اینٹیٹی نقصان کا باعث بنتی ہے",
  T_35_WZY_WS_ONHURT_PARAM1_DESC: "وہ اینٹیٹی جو نقصان سے نمٹ رہی ہے",
  T_35_WZY_WS_ONHURT_PARAM1_NAME: "ٹارگٹ اینٹیٹی",
  T_35_WZY_WS_PREFABID_NAME: "ٹیمپلیٹ ID",
  T_35_WZY_WS_PROPERTY_EPNOW: "موجودہ توانائی",
  T_35_WZY_WS_PROPERTY_JUMP: "جمپ ہائیٹ",
  T_35_WZY_WS_QUITTRIGGER_NAME: "ٹرگر ایریا سے باہر نکلیں",
  T_35_WZY_WS_QUITTRIGGER_NAMEDESC: 'ٹرگر اس وقت ہوتا ہے جب ایک "ٹرگراینٹیٹی" ایک ٹرگر علاقے سے باہر نکلتی ہے',
  T_35_WZY_WS_REMOVEELEMENT_NAMEDESC: 'ایک لسٹ سے ایک مخصوص ایلیمینٹ کو ہٹا دیں۔ "لسٹ" وہ لسٹ ہے جس میں ایلیمینٹ موجود ہے۔ "ایلیمینٹ" ہٹا دیا جانے والا ایلیمینٹ ہے',
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAME: "ایلیمینٹ کی ویلیو",
  T_35_WZY_WS_REMOVEELEMENT_PARAM1_NAMEDESC: "ایلیمینٹ کی ویلیو جسے ہٹانا ہے",
  T_35_WZY_WS_ROUNDENTITY_NAME: "راؤنڈ اینٹیٹی",
  T_35_WZY_WS_TOWER_PARAM1: "ٹاور اور قلعہ",
  T_35_WZY_WS_TOWER_PARAM2: "ٹیم ID",
  T_35_WZY_WS_TOWER_PARAM3: "موجودہ ہیلتھ پوائنٹ",
  T_35_WZY_WS_TOWER_PARAM4: "زیادہ سے زیادہ ہیلتھ پوائنٹ",
  T_35_WZY_WS_TOWER_PARAM5: "نقصان",
  T_35_WZY_WS_TOWER_PARAM6: "حملے کا دورانیہ",
  T_35_WZY_WS_TOWER_PARAM7: "حملے کی رینج",
  T_35_WZY_WS_TOWER_PARAM8: "دفاع ٪",
  T_35_XYL_PDM_REVENGE: "بدلہ لیا",
  T_35_XYL_WS_BISPARTERRE: "گرافٹی فلاور بیڈ",
  T_35_XYL_WS_BISPARTERRE_DESC: "بیٹل ان اسٹائل تھیمڈ سٹون فلاور بیڈ",
  T_35_XYL_WS_BISWALL: "گرافٹی وال",
  T_35_XYL_WS_BISWALL_DESC: "ایک بیٹل-ان-اسٹائل تھیم والی دیوار جسے یکجا کیا جا سکتا ہے",
  T_35_XYL_WS_BOTDROP: "لوٹ ڈراپ کو آن/آف کریں",
  T_35_XYL_WS_CUSTOMTRIGGER: "کسٹم ٹرگر",
  T_35_XYL_WS_CUSTOMTRIGGER_DESC: "ایک ایسا آبجیکٹ رکھیں جو ایک خاص طور پر کسٹمائزڈ کردہ اسپیشل ایفیکٹ کو ٹرگر کرتا ہے جب کوئی کھلاڑی اسے ایکٹیویٹ کرتا ہے۔ ایفیکٹ کو اسکرپٹ میں ترتیب دیا جانا چاہیے۔ (صرف کسٹمائز موڈ میں ظاہر ہوتا ہے)",
  T_35_XYL_WS_DOUBLEDOOR: "گیٹ",
  T_35_XYL_WS_DOUBLEDOOR_DESC: "ایک دروازہ جو توڑ کر کھولا گیا ہے",
  T_35_XYL_WS_RESET: "ہر راؤنڈ کو دوبارہ ترتیب دیں",
  T_35_XYL_WS_RESETN: "نہیں",
  T_35_XYL_WS_RESETY: "جی ہاں",
  T_35_XYL_WS_ROADBLOCK: "روڈ بلاک A",
  T_35_XYL_WS_ROADBLOCK_DESC: "گزرنے سے روکتا ہے",
  T_35_XYL_WS_STAIRS: "سیڑھیاں",
  T_35_XYL_WS_STAIRS_DESC: "سیڑھیاں جو لینڈنگ کے ساتھ مل سکتی ہیں",
  T_35_XYL_WS_STAIRSL: "لینڈنگ B",
  T_35_XYL_WS_STAIRSL_DESC: "ایک پلیٹ فارم جسے سیڑھیوں کے ساتھ ملایا جا سکتا ہے",
  T_35_XYL_WS_STAIRSZ: "لینڈنگ A",
  T_35_XYL_WS_STAIRSZ_DESC: "ایک پلیٹ فارم جسے سیڑھیوں کے ساتھ ملایا جا سکتا ہے",
  T_35_XYL_WS_TBOOTH: "عام طور پر سڑکوں پر دیکھا جاتا ہے",
  T_35_XYL_WS_TBOOTH_DESC: "عام طور پر سڑکوں پر دیکھا جاتا ہے",
  T_35_YF_PP19_N: "بیزون",
  T_35_YS_A_CATEAM_HW: "اگوئی",
  T_35_YS_A_CUBBY: "کب ماسک",
  T_35_YS_F_A_PANTOMIME: "ٹو ٹونڈ گریف (ماسک)",
  T_35_YS_F_A_RIDERS: "فیٹل رائڈر (ماسک)",
  T_35_YS_F_B_DIGITALUNIVERSE2: "بیوٹی ری یونیٹر (باٹم)",
  T_35_YS_F_B_GOLDCHAIN: "آرمر آف ریچز (باٹم)",
  T_35_YS_F_B_PANTOMIME: "ٹو ٹونڈ گریف (باٹم)",
  T_35_YS_F_B_RIDERS: "فیٹل رائڈر (باٹم)",
  T_35_YS_F_H_BEAR_HW: "کب کیپ",
  T_35_YS_F_H_DIGITALUNIVERSE2: "بیوٹی ری یونیٹر (ہیڈ)",
  T_35_YS_F_H_GOLDCHAIN: "آرمر آف ریچز (ہیڈ)",
  T_35_YS_F_H_PANTOMIME: "ٹو ٹونڈ گریف (ہیڈ)",
  T_35_YS_F_H_RIDERS: "فیٹل رائڈر (ہیڈ)",
  T_35_YS_F_HA_GOLDCHAIN: "آرمر آف ریچز (فیس پینٹ)",
  T_35_YS_F_S_DIGITALUNIVERSE2: "بیوٹی ری یونیٹر (جوتے)",
  T_35_YS_F_S_GOLDCHAIN: "آرمر آف ریچز (جوتے)",
  T_35_YS_F_S_PANTOMIME: "ٹو ٹونڈ گریف (جوتے)",
  T_35_YS_F_S_RIDERS: "فیٹل رائڈر (جوتے)",
  T_35_YS_F_T_DIGITALUNIVERSE2: "بیوٹی ری یونیٹر (ٹاپ)",
  T_35_YS_F_T_GOLDCHAIN: "آرمر آف ریچز (ٹاپ)",
  T_35_YS_F_T_PANTOMIME: "ٹو ٹونڈ گریف (ٹاپ)",
  T_35_YS_F_T_RIDERS: "فیٹل رائڈر (ٹاپ)",
  T_35_YS_ITEM_SUPERFAK: "سپر میڈ",
  T_35_YS_M_A_GOLDCHAIN: "چینز آف لکس (ماسک)",
  T_35_YS_M_A_RIDERS: "گریم رائڈر (ماسک)",
  T_35_YS_M_B_GOLDCHAIN: "چینز آف لکس (باٹم)",
  T_35_YS_M_B_RIDERS: "گریم رائڈر (باٹم)",
  T_35_YS_M_H_BEAR_HW: "کب کیپ",
  T_35_YS_M_H_GOLDCHAIN: "چینز آف لکس (ہیڈ)",
  T_35_YS_M_H_RIDERS: "گریم رائڈر (ہیڈ)",
  T_35_YS_M_S_GOLDCHAIN: "چینز آف لکس (جوتے)",
  T_35_YS_M_S_RIDERS: "گریم رائڈر (جوتے)",
  T_35_YS_M_T_GOLDCHAIN: "چینز آف لکس (ٹاپ)",
  T_35_YS_M_T_RIDERS: "گریم رائڈر (ٹاپ)",
  T_35_YS_T_CHAMPION: "چیمپئن ٹی",
  T_35_YS_T_PAINTING: "اسکویز ٹی",
  T_35_YZY_CHARACTER_CRAZYGIRL_N: "آئرس",
  T_35_YZY_CHARACTER_SINGERS_N: "J.Biebs",
  T_36_JH_WS_BASEMONEY: "میچ شروع ہونے پر سکے حاصل کریں",
  T_36_JH_WS_CESAYCLOSE: "دستی بند کرنا روکیں یا نہیں",
  T_36_JH_WS_CHOOSEEDITSHOP: "ترمیم کرنے کے لیے ایک اسٹور منتخب کریں",
  T_36_JH_WS_CHOOSESHOP: "ایک اسٹور منتخب کریں",
  T_36_JH_WS_COINCOUNT: "کرنسی کی رقم",
  T_36_JH_WS_COINHUD: "سکے کی رقم ڈسپلے کریں یا نہیں",
  T_36_JH_WS_CRAFTSHOP: "اسٹور میں ترمیم کریں",
  T_36_JH_WS_CREATEGOLD: "کوئن جنریٹر",
  T_36_JH_WS_CSHOPENTITY: "بائنڈ اسٹور اینٹیٹی",
  T_36_JH_WS_CSHOPHUD: "اسٹور انٹرفیس",
  T_36_JH_WS_CURRENTLIMIT: "باقی خریداری کی حد",
  T_36_JH_WS_ECONOMIC: "معیشت",
  T_36_JH_WS_INGAMEECONOMI: "گیم کی معیشت",
  T_36_JH_WS_ITEMINDEXID: "مرچنڈائز نمبر",
  T_36_JH_WS_KILLMONEY: "ختم کرنے پر سکے حاصل کریں",
  T_36_JH_WS_KILLMONEYTIP: "رش موڈ اور اینڈیورینس موڈ میں زومبیز کو مارنے کے لیے پائے گئے سکے کی تعداد",
  T_36_JH_WS_LISTINDEX: "مرچنڈائز کی اقسام کی لسٹ",
  T_36_JH_WS_NULL: "خالی",
  T_36_JH_WS_NUMBER: "رقم",
  T_36_JH_WS_OPTIONNAME: "ڈرائیڈ اپولیکپس موڈ خصوصی",
  T_36_JH_WS_REALSHOPENTITY: "اسٹور اینٹیٹی",
  T_36_JH_WS_SEEORHIDE: "ڈسپلے وینڈنگ مشین",
  T_36_JH_WS_SHOPFRONT: "اسٹور",
  T_36_JH_WS_SHOPITEMLIST: "مرچنڈائز کی قسم",
  T_36_JH_WS_SHOPOPENCON: "اسٹیٹس کھولیں",
  T_36_JH_WS_SSHOPNAME: "اسٹور کا نام",
  T_36_JH_WS_TOTALLIMIT: "خریداری کی حد",
  T_36_JH_WS_TRIGGERWIDE: "ٹرگر رینج",
  T_36_JH_WS_VENDMACHINE: "وینڈنگ مشین",
  T_36_JH_WS_WINMONEY: "فتح پر سکے حاصل کریں",
  T_36_JH_WS_WORTH: "قیمت",
  T_36_JL_FOREGRIP_MR_N: "مارکس مین فورگریپ",
  T_36_JL_GOLD_SCAR_I_N: "اسکار-I",
  T_36_JL_GOLD_SCAR_II_N: "اسکار-II",
  T_36_JL_GOLD_SCAR_III_N: "اسکار-III",
  T_36_JL_STOCK_SG_N: "شاٹگن اسٹاک",
  T_36_JL_STOCK_SR_N: "سنائپر اسٹاک",
  T_36_KK_WS_MONTSTERDES: "ایک 4 سیٹوں والا ٹرک اعلی پائیداری کے ساتھ اور سخت خطوں سے گزر سکتا ہے",
  T_36_M_WS_SETTEMPVAR: "عارضی ویریایبل سیٹ کریں",
  T_36_M_WS_TEMPVAR: "عارضی ویریایبل",
  T_36_SY_AK47_MAMBAS_N: "AK47- ممبا گنا",
  T_36_SY_AN94_MAMBAS_N: "AN94- ممبا گنا",
  T_36_SY_AR15_MAMBAS_N: "کنگ فشر- ممبا گنا",
  T_36_SY_AUG_MAMBAS_N: "AUG- ممبا گنا",
  T_36_SY_AWM_MAMBAS_N: "AWM- ممبا گنا",
  T_36_SY_BLT_MAMBAS_N: "M82B- ممبا گنا",
  T_36_SY_CHARGESHOT_MAMBAS_N: "چارج بسٹر- ممبا گنا",
  T_36_SY_EAGLE_MAMBAS_N: "ڈیزرٹ ایگل- ممبا گنا",
  T_36_SY_FAMAS_MAMBAS_N: "FAMAS- ممبا گنا",
  T_36_SY_G18_MAMBAS_N: "G18- ممبا گنا",
  T_36_SY_G36_MAMBAS_N: "G36- ممبا گنا",
  T_36_SY_GRENADE_FESTIVAL_TU_N: "گرینیڈ - نیوی فیسٹیویٹی",
  T_36_SY_GROZA_MAMBAS_N: "گروزا- ممبا گنا",
  T_36_SY_HAND_CANNON_MAMBAS_N: "ہینڈ کینن- ممبا گنا",
  T_36_SY_HEALINGSNIPER_MAMBAS_N: "ٹریٹمنٹ سنائپر- ممبا گنا",
  T_36_SY_ICE_GUN_MAMBAS_N: "آئس گن- ممبا گنا",
  T_36_SY_KAR98K_MAMBAS_N: "Kar98k- ممبا گنا",
  T_36_SY_KORD_MAMBAS_N: "کورڈ- ممبا گنا",
  T_36_SY_M1014_MAMBAS_N: "M1014- ممبا گنا",
  T_36_SY_M14_MAMBAS_N: "M14- ممبا گنا",
  T_36_SY_M1873_MAMBAS_N: "M1873- ممبا گنا",
  T_36_SY_M1887_MAMBAS_N: "M1887- ممبا گنا",
  T_36_SY_M1917_MAMBAS_N: "M1917- ممبا گنا",
  T_36_SY_M21A5_MAMBAS_N: "ووڈپیکر- ممبا گنا",
  T_36_SY_M24_MAMBAS_N: "M24- ممبا گنا",
  T_36_SY_M249_MAMBAS_N: "M249- ممبا گنا",
  T_36_SY_M4A1_MAMBAS_N: "M4A1- ممبا گنا",
  T_36_SY_M500_MAMBAS_N: "M500- ممبا گنا",
  T_36_SY_M60_MAMBAS_N: "M60- ممبا گنا",
  T_36_SY_M79_MAMBAS_N: "M79- ممبا گنا",
  T_36_SY_MAC10_MAMBAS_N: "MAC10- ممبا گنا",
  T_36_SY_MAG7_MAMBAS_N: "MAG-7- ممبا گنا",
  T_36_SY_MINI_MAMBAS_N: "AC80- ممبا گنا",
  T_36_SY_MP40_MAMBAS_N: "MP40- ممبا گنا",
  T_36_SY_MP5_MAMBAS_N: "MP5- ممبا گنا",
  T_36_SY_P90_MAMBAS_N: "P90- ممبا گنا",
  T_36_SY_PARAFAL_MAMBAS_N: "پیرافل- ممبا گنا",
  T_36_SY_PP19_MAMBAS_N: "بیزون- ممبا گنا",
  T_36_SY_PP19_POLICEMAN_N: "بیزون- ورائتھ پٹرول",
  T_36_SY_SCAR_MAMBAS_N: "اسکار- ممبا گنا",
  T_36_SY_SKS_MAMBAS_N: "SKS- ممبا گنا",
  T_36_SY_SPAS12_MAMBAS_N: "SPAS12- ممبا گنا",
  T_36_SY_SUPERHEAT_GUN_MAMBAS_N: "پلازما- ممبا گنا",
  T_36_SY_SVD_MAMBAS_N: "SVD- ممبا گنا",
  T_36_SY_THOMPSON_MAMBAS_N: "تھامسن- ممبا گنا",
  T_36_SY_THROWINGKNIFE_MAMBAS_N: "مامبا ڈیگر",
  T_36_SY_THROWINGKNIFE_MENA_N: "بوہو ڈیگر",
  T_36_SY_TREATMENTGUN_MAMBAS_N: "ٹریٹمنٹ پستول- ممبا گنا",
  T_36_SY_UMP45_MAMBAS_N: "UMP- ممبا گنا",
  T_36_SY_USP45_MAMBAS_N: "USP- ممبا گنا",
  T_36_SY_UZI_MAMBAS_N: "مینی اوزی- ممبا گنا",
  T_36_SY_VECTOR_MAMBAS_N: "ویکٹر- ممبا گنا",
  T_36_SY_VEHICLE_MONSTER_TRUCK_BDK_N: "مونسٹر ٹرک - بلائڈنگ گولڈ",
  T_36_SY_VEHICLE_MOTOBIKE_SUGARSKULL22_N: "موٹر بائیک- سپیکٹرل رائڈ",
  T_36_SY_VEHICLE_ROADSTER_BDK_N: "سپورٹس کار- سپیڈ ایسر",
  T_36_SY_VEHICLE_TUTU_POLICEMAN_N: "ٹک ٹک- نیدرورلڈ رائڈ",
  T_36_SY_VSS_MAMBAS_N: "VSS- ممبا گنا",
  T_36_SY_XM8_MAMBAS_N: "XM8- ممبا گنا",
  T_36_WZY_AFTERACCUMULATOR: "بیک ایکمیولیٹر",
  T_36_WZY_AVAILAB: "فعال",
  T_36_WZY_BACKANDFORTH: "راؤنڈ-ٹرپ",
  T_36_WZY_BASEMULTIPLIER: "بنیادی ملٹیپلائر",
  T_36_WZY_BASIC: "بنیادی قسم",
  T_36_WZY_BEFORACCUMULATOR: "فرنٹ ایکمیولیٹر",
  T_36_WZY_CYLIC: "سرکل-بیک",
  T_36_WZY_GUNPRO_PARAM1: "بنیادی نقصان",
  T_36_WZY_GUNPRO_PARAM10: "گولیوں کا بوچھاڑ شروع",
  T_36_WZY_GUNPRO_PARAM11: "زیادہ سے زیادہ پھیلاؤ کا علاقہ",
  T_36_WZY_GUNPRO_PARAM12: "برسٹ",
  T_36_WZY_GUNPRO_PARAM2: "میگزین میں بلٹس",
  T_36_WZY_GUNPRO_PARAM3: "میگزین کا ابتدائی نمبر",
  T_36_WZY_GUNPRO_PARAM4: "فائرنگ انٹرول",
  T_36_WZY_GUNPRO_PARAM7: "زیادہ سے زیادہ نقصان کے لیے فاصلہ",
  T_36_WZY_GUNPRO_PARAM8: "کم سے کم نقصان کے لیے فاصلہ",
  T_36_WZY_GUNPRO_PARAM9: "کم سے کم نقصان",
  T_36_WZY_MULTIPLIR: "ملٹیپلائر",
  T_36_WZY_PRICE: "قیمت",
  T_36_WZY_SUMMULTIPLIER: "ملٹیپلائر ایکمیولیٹر",
  T_36_WZY_WS_3DZOOM: "3D زوم",
  T_36_WZY_WS_ABSRES: "مطلق ویلیو کا نتیجہ",
  T_36_WZY_WS_ADDALLELE_NAMEDESC: "[سورس لسٹ] سے تمام ایلیمینٹس کو [ٹارگٹ لسٹ] کے نیچے شامل کریں",
  T_36_WZY_WS_ADDALLELE_PARAM1_DESC: "ایلیمینٹس کو شامل کرنے کے لیے ٹارگٹ لسٹ",
  T_36_WZY_WS_ADDALLELE_PARAM2_DESC: "سورس لسٹ جس میں شامل کیے جانے والے ایلیمنٹس شامل ہیں",
  T_36_WZY_WS_ADDCURR_NAMEDESC: "ایک مقرر کردہ والیٹ میں مخصوص کرنسی کا اضافہ کریں",
  T_36_WZY_WS_ADDCURR_PARAM1_NAME: "بٹوا",
  T_36_WZY_WS_ADDCURR_PARAM1_NAMEDESC: "بٹوا جس میں کرنسی شامل کرنی ہے",
  T_36_WZY_WS_ADDSUB: "ویلیوز کو شامل/تفریق کریں",
  T_36_WZY_WS_AIENTITY: "AI اینٹیٹی",
  T_36_WZY_WS_ALLSHOP_DESC: "ایک لسٹ جو اسٹور اینٹیٹیز پر مشتمل ہے",
  T_36_WZY_WS_ANGLE_DESC: "اینگل کی پیمائش",
  T_36_WZY_WS_ANYTYPE: "کسی بھی قسم کا",
  T_36_WZY_WS_ARILEFT: "آپریشن میں بائیں ویلیو",
  T_36_WZY_WS_ARIRES: "آپریشن کا نتیجہ",
  T_36_WZY_WS_ARIRIGHT: "آپریشن میں رائٹ ویلیو",
  T_36_WZY_WS_ARITHMETIC_NAME: "4 آرتھمیٹک آپریشنز",
  T_36_WZY_WS_ARITHMETIC_NAMEDESC: "بنیادی انٹیجر آپریشنز ایڈیشن، سبٹریکشن، ملٹیپلیکیشن، ڈیویژن اور ریمینڈر کو سپورٹ کرتے ہیں۔ فلوٹ آپریشنز ایڈیشن، سبٹریکشن، ملٹیپلیکیشن اور ڈیویژن کو سپورٹ کرتے ہیں",
  T_36_WZY_WS_ARRAY_DESC: "ٹارگٹ لسٹ",
  T_36_WZY_WS_ARRCONELE_NAMEDESC: "چیک کریں کہ کیا کسی لسٹ میں نامزد ایلیمینٹ شامل ہے۔ لوٹائی گئی ویلیو بولین ہے۔",
  T_36_WZY_WS_ARRCONELE_PARAM1_DESC: "نامزد لسٹ",
  T_36_WZY_WS_ARRCONELE_PARAM2_DESC: "لسٹ میں تلاش کرنے کے لیے ایلیمینٹ",
  T_36_WZY_WS_ARRCONELERES: "اس کا نتیجہ معلوم کرنا کہ کیا لسٹ میں ایک نامزد ایلیمینٹ موجود ہے۔ ویلیو بولین ہے۔",
  T_36_WZY_WS_ATTACK: "گشت اور حملہ",
  T_36_WZY_WS_BEKNODOWN_NAMEDESC: "اس وقت ٹرگر ہوتا ہے جب کھلاڑی کو گرایا جاتا ہے",
  T_36_WZY_WS_BIGFLOAT: "بڑا ڈیسیمل",
  T_36_WZY_WS_BIGTOYBALL: "ڈائس",
  T_36_WZY_WS_BOOLLIST: "بولین لسٹ",
  T_36_WZY_WS_CEIL_NAME_DESC: "کسی ویلیو کو خود سے بڑے چھوٹے انٹیجر میں راؤنڈ کریں",
  T_36_WZY_WS_CEIL_PARAM1_NAMEDESC: "راؤنڈ اپ کرنے کی ویلیو",
  T_36_WZY_WS_CEILRES: "راؤنڈ اپ کا نتیجہ",
  T_36_WZY_WS_CHASEENT_NAMEDESC: "منتخب کردہ AI فاصلے کے باوجود اس اینٹیٹی کا پیچھا کرے گا۔ [پیچھا کی گئی اینٹیٹی] کوئی بھی اینٹیٹی ہو سکتی ہے۔ جب [یچھا کی گئی اینٹیٹی] کے پاس ہیلتھ پوائنٹ پراپرٹی نہیں ہے، تو AI اینٹیٹی کو کوئی نقصان نہیں پہنچے گا۔",
  T_36_WZY_WS_CHASEENT_PARAM1_NAMEDESC: "وہ اینٹیٹی جو پیچھا کر رہی ہے",
  T_36_WZY_WS_CHASEENT_PARAM2_NAMEDESC: "ٹارگٹ کی اینٹیٹی جس کا پیچھا کیا جا رہا ہے۔ یہ کوئی بھی اینٹیٹی ہو سکتی ہے۔",
  T_36_WZY_WS_CLONEOBJ_PARAM1_DESC: "اشیاء کی کلوننگ کے لیے ٹیمپلیٹ۔ کرسر کا استعمال کرتے ہوئے منتخب کریں۔ کلون کی پراپرٹی اور اسکرپٹ وہی ہوں گے جو کہ منتخب کردہ آبجیکٹ کی ہیں۔",
  T_36_WZY_WS_CLONEOBJ_PARAM2_DESC: "کلون کی جانے والی آبجیکٹ اینٹیٹی",
  T_36_WZY_WS_CONDITION: "کنڈیشن",
  T_36_WZY_WS_CONDITIONLIST: "کنڈیشن لسٹ",
  T_36_WZY_WS_CONOFHUD: "HUD اینٹیٹی جس میں کنٹرول موجود ہے",
  T_36_WZY_WS_CONTROL_DESC: "کنٹرول کا واحد انڈیکس",
  T_36_WZY_WS_COS_NAMEDESC: "اینگل کا کوسائن نکالیں",
  T_36_WZY_WS_COSRES: "اینگل کا کوسائن",
  T_36_WZY_WS_CREABLEOB: "قابل تخلیق آبجیکٹ",
  T_36_WZY_WS_CREOBJ_NAMEDESC: "ایک مقررہ جگہ پر ایک آبجیکٹ اینٹیٹی بنائیں۔ (ٹیسٹ ورژن)",
  T_36_WZY_WS_CREOBJ_PARAM1_DESC: "جس چیز کو بنایا جانا ہے اس کے کوآرڈینیٹس",
  T_36_WZY_WS_CREOBJ_PARAM2_DESC: "جس  آبجیکٹ کو بنایا جانا ہے اس کی قسم",
  T_36_WZY_WS_CREOBJ_PARAM3_DESC: "جس آبجیکٹ کی اینٹیٹی بنائی جانی ہے",
  T_36_WZY_WS_CREPROD_PARAM2_NAME: "کرنسی",
  T_36_WZY_WS_CREPROD_PARAM4_NAME: "مرچنڈائز اینٹیٹی",
  T_36_WZY_WS_CREPROD_PARAM4_NAMEDESC: "مرچنڈائز اینٹیٹی بنائیں",
  T_36_WZY_WS_CREWALL_NAMEDESC: "ایک والیٹ اینٹیٹی بنائیں۔ [بائنڈ کھلاڑی] وہ کھلاڑی ہے جو اس والیٹ کو دیکھ سکتا ہے۔ [مالک] وہ کھلاڑی ہے جس کا والیٹ ہے۔ اگر والیٹ پہلے سے موجود ہے تو غلط ہے۔",
  T_36_WZY_WS_CREWALL_PARAM1_NAME: "کھلاڑی کو پابند کریں",
  T_36_WZY_WS_CREWALL_PARAM1_NAMEDESC: "وہ کھلاڑی جس کو والیٹ نظر آتا ہے۔ اگر کوئی سیٹنگز کنفیگر نہیں ہیں تو والیٹ سب کو نظر آئے گا۔",
  T_36_WZY_WS_CREWALL_PARAM2_NAMEDESC: "والیٹ کا مالک",
  T_36_WZY_WS_CREWALL_PARAM3_NAME: "والیٹ اینٹیٹی",
  T_36_WZY_WS_CREWALL_PARAM3_NAMEDESC: "والیٹ اینٹیٹی بنائی گئی",
  T_36_WZY_WS_CURRAMT: "کرنسی کی رقم",
  T_36_WZY_WS_DATA_TYPE1: "پیرامیٹر شامل کیا گیا",
  T_36_WZY_WS_DATA_TYPE2: "بنیادی اور لاجک حساب کتاب",
  T_36_WZY_WS_DATA_TYPE3: "لسٹ میں ہیرا پھیری",
  T_36_WZY_WS_DATA_TYPE4: "ویکٹر کا حساب کتاب",
  T_36_WZY_WS_DESTITEM_NAME: "پلیئر آئٹم کو تباہ کریں",
  T_36_WZY_WS_DESTITEM_NAMEDESC: "ایک نامزد کھلاڑی کے لیے مخصوص قسم کی آئٹم کو تباہ کریں",
  T_36_WZY_WS_DESTITEM_PARAM1_NAMEDESC: "جن آئٹمز کو تباہ کیا جا سکتا ہے وہ ہتھیار، واسکٹ اور ہیلمٹ ہیں",
  T_36_WZY_WS_DESTITEM_PARAM2_NAMEDESC: "منتخب کردہ آئٹم کی قسم کا سلاٹ انڈیکس۔ ہتھیاروں کا انڈیکس [1,3] ہے اور واسکٹ اور ہیلمٹ پہلے سے 1 ہے۔",
  T_36_WZY_WS_DESTITEM_WHELOSTEQU: "خاتمے پر سامان کھو دیں",
  T_36_WZY_WS_DESTOBJ: "تباہ کن آبجیکٹس",
  T_36_WZY_WS_DIRPOINT: "ڈائریکشن پوائنٹ",
  T_36_WZY_WS_DIRPOINTDESC: "ڈائریکشن پوائنٹ بنایا جانا ہے",
  T_36_WZY_WS_ELEFINDRES: "کسی ایلیمینٹ کی پہلی پوزیشن کا انڈیکس",
  T_36_WZY_WS_ELEFIRINDEX_NAMEDESC: 'لسٹ میں کسی ایلیمینٹ کی پہلی پوزیشن کا انڈیکس حاصل کریں۔ اگر لسٹ میں ٹارگٹ ایلیمینٹ موجود نہیں ہے، تو "-1" نتیجہ واپس آئے گا',
  T_36_WZY_WS_ELEFIRINDEX_PARAM2_DESC: "فہرست میں تلاش کرنے کے لیے ایلیمینٹ",
  T_36_WZY_WS_ELELASINDEX_NAMEDESC: 'لسٹ میں کسی ایلیمینٹ کی آخری پوزیشن کا انڈیکس حاصل کریں۔ اگر لسٹ میں ٹارگٹ ایلیمینٹ موجود نہیں ہے، تو "-1" نتیجہ واپس آئے گا',
  T_36_WZY_WS_ELELINDRES: "کسی ایلیمینٹ کی آخری پوزیشن کا انڈیکس",
  T_36_WZY_WS_ELEMENTSNUM: "لسٹ میں ایلیمینٹس کا #",
  T_36_WZY_WS_ENTCOLLIDE_NAMEDESC: "ٹرگر ہوتا ہے جب [ٹرگرینگ اینٹیٹی] اس ٹرگر سے ٹکراتی ہے",
  T_36_WZY_WS_ENTCOLLIDE_PARAM1_NAMEDESC: "وہ اینٹیٹی جس سے یہ ٹرگر ٹکراتی ہے",
  T_36_WZY_WS_ENTDRIVEH_NAMEDESC: "ٹرگر اس وقت ہوتا ہے جب کوئی [ٹرگرینگ اینٹیٹی] گاڑی چلاتی ہے",
  T_36_WZY_WS_ENTDRIVEH_PARAM1_NAMEDESC: "وہ اینٹیٹی جو گاڑی چلا رہی ہے",
  T_36_WZY_WS_ENTERTRI_NAMEDESC: "جب کھلاڑی ٹرگر میں داخل ہوتا ہے تو ٹرگر ہوتا ہے",
  T_36_WZY_WS_ENTERTRI_PARAM1_DESC: "داخل ہونے کا ٹرگر",
  T_36_WZY_WS_ENTGETOFFVEH_NAMEDESC: "ٹرگر اس وقت ہوتا ہے جب [ٹرگرینگ اینٹیٹی] گاڑی سے باہر نکلتی ہے",
  T_36_WZY_WS_ENTGETOFFVEH_PARAM1_NAMEDESC: "وہ اینٹیٹی جو گاڑی سے باہر نکلتی ہے",
  T_36_WZY_WS_ENTGETONVEH_NAMEDESC: "جب ایک [ٹرگرینگ اینٹیٹی] گاڑی میں داخل ہوتی ہے تو ٹرگر ہوتی ہے",
  T_36_WZY_WS_ENTGETONVEH_PARAM1_NAMEDESC: "وہ اینٹیٹی جو گاڑی میں داخل ہوتی ہے",
  T_36_WZY_WS_ENTITY_TYPE1: "عام طور پر استعمال کیا جاتا ہے",
  T_36_WZY_WS_ENTITY_TYPE2: "پراپرٹیز",
  T_36_WZY_WS_ENTITY_TYPE3: "آبجیکٹس اور آئٹمز",
  T_36_WZY_WS_ENTITY_TYPE4: "AI",
  T_36_WZY_WS_ENTITY2_PARAM4_DESC: "ایلیمینٹ ویلیو جس کو تبدیل کرنا ہے",
  T_36_WZY_WS_ENTITY7_PARAM1_DESC: "ٹرگر کھلاڑی",
  T_36_WZY_WS_ENTITYLIST: "اینٹیٹی لسٹ",
  T_36_WZY_WS_ENTKNOFLY_NAMEDESC: "ٹرگر اس وقت ہوتا ہے جب کوئی [ٹرگرینگ اینٹیٹی] ٹائر سے باؤنس کرتا ہے",
  T_36_WZY_WS_ENTKNOFLY_PARAM1_NAMEDESC: "وہ اینٹیٹی جو ٹائر کو باؤنس کرتی ہے",
  T_36_WZY_WS_ENTTP_NAMEDESC: "ٹرگر کرتا ہے جب ایک [ٹرگرینگ اینٹیٹی] پورٹل میں داخل ہوتا ہے اور اسے ٹیلی پورٹ کیا جاتا ہے",
  T_36_WZY_WS_ENTTP_PARAM1_NAMEDESC: "وہ اینٹیٹی جسے ٹیلی پورٹ کیا جاتا ہے",
  T_36_WZY_WS_EQUARMOR_PARAM2_DESC: "ویسٹ، ہیلمٹ، اور بیگ سمیت لیس آرمر کی قسم",
  T_36_WZY_WS_EQUWEAP_NAMEDESC: "اس وقت ٹرگر ہوتا ہے جب کوئی کھلاڑی کامیابی سے ہتھیار لیس کرتا ہے۔ [ٹرگر کھلاڑی] وہ کھلاڑی ہے جو کامیابی کے ساتھ ہتھیار سے لیس کرتا ہے۔ [ہتھیار اینٹیٹی] وہ ہتھیار ہے جسے کھلاڑی لیس کرتا ہے۔",
  T_36_WZY_WS_EQUWEAP_PARAM2_DESC: "لیس کی گئی ہتھیاروں کی اینٹیٹی",
  T_36_WZY_WS_EQUWEAP_PARAM2_NAME: "ہتھیار کی قسم",
  T_36_WZY_WS_EULERANGLE: "یولر اینگلز",
  T_36_WZY_WS_FACECAMERA: "ہمیشہ کیمرہ کا سامنا کریں",
  T_36_WZY_WS_FLOATLIST: "فلوٹ لسٹ",
  T_36_WZY_WS_FLOOR_NAME_DESC: "کسی ویلیو کو سب سے بڑے لیکن اپنے سے چھوٹے انٹیجر تک راؤنڈ کریں",
  T_36_WZY_WS_FLOOR_PARAM1_NAMEDESC: "راؤنڈ ڈاؤن کی ویلیو",
  T_36_WZY_WS_FLOORRES: "راؤنڈانگ ڈاؤن کا نتیجہ",
  T_36_WZY_WS_FORMUENT: "پراپرٹی کی تشکیل کے قابل اینٹیٹی",
  T_36_WZY_WS_FORMUFACT: "پراپرٹی فارمولا فیکٹر کی قسم",
  T_36_WZY_WS_GAME_TYPE2: "گیم پلے",
  T_36_WZY_WS_GAME_TYPE3: "اسپیشل ایفیکٹس",
  T_36_WZY_WS_GENENT_NAMEDESC: "جنریٹر کے یونٹس کو اسپان کرنے پر ٹرگر ہوتا ہے۔ [یونٹ اینٹیٹی لسٹ] جنریٹر کے ذریعہ تیار کردہ یونٹس کی لسٹ ہے۔ [لہروں کی تعداد] جنریش کے ذریعے اسپان ہونے والی لہروں کی تعداد ہے۔",
  T_36_WZY_WS_GENENT_PARAM1_NAME: "یونٹ اینٹیٹی",
  T_36_WZY_WS_GENENT_PARAM1_NAMEDESC: "ایک لسٹ جو ایک جنریٹر کے ذریعے سپان کی گئی یونٹ اینٹیٹیز پر مشتمل ہے",
  T_36_WZY_WS_GENENT_PARAM2_NAMEDESC: "لہروں کی تعداد جو ایک جنریٹر سپان کرتا ہے",
  T_36_WZY_WS_GETALLSHOP_NAMEDESC: "میچ کے تمام اسٹورز حاصل کریں۔ واپس کی گئی ویلیو ایک لسٹ ہے جو اسٹور اینٹیٹیز پر مشتمل ہے",
  T_36_WZY_WS_GETCOLOR_NAMEDESC: "کلر حاصل کرنے کے لیے RGB کا استعمال کریں",
  T_36_WZY_WS_GETCURRAMT_NAMEDESC: "ایک مخصوص بٹوے میں ایک مخصوص کرنسی کی رقم حاصل کریں",
  T_36_WZY_WS_GETCURRAMT_PARAM1_NAMEDESC: "وہ بٹوا جس سے کرنسی کی رقم حاصل کی جائے",
  T_36_WZY_WS_GETCURRAMT_PARAM2_NAMEDESC: "حاصل کی جانے والی کرنسی کی رقم کی کرنسی کی قسم",
  T_36_WZY_WS_GETENTTYPE_NAMEDESC: "ٹارگٹ کی اینٹیٹی کی اینٹیٹی کی قسم حاصل کریں",
  T_36_WZY_WS_GETENTTYPE_PARAM1_DESC: "وہ اینٹیٹی جس کی قسم کو حاصل کرنا ہے",
  T_36_WZY_WS_GETENTTYPERES: "ہدف کی اینٹیٹی کی قسم",
  T_36_WZY_WS_GETFOR_NAME: "ڈائریکشن کوآرڈینیٹس حاصل کریں",
  T_36_WZY_WS_GETFOR_NAMEDESC: "ایک مقرر کردہ ڈائریکشن پوائنٹ کا ویکٹر حاصل کریں",
  T_36_WZY_WS_GETFORRES: "ڈائریکشن پوائنٹ کا ویکٹر",
  T_36_WZY_WS_GETMONEYENT_NAMEDESC: "بٹوے میں ایک مخصوص کرنسی کی قسم کی کرنسی اینٹیٹی حاصل کریں",
  T_36_WZY_WS_GETMONEYENT_PARAM1_DESC: "وہ بٹوا جس میں کرنسی اینٹیٹی ہے",
  T_36_WZY_WS_GETPOS_NAME: "کوآرڈینیٹس حاصل کریں",
  T_36_WZY_WS_GETPOS_NAMEDESC: "ایک مقرر کردہ ڈائریکشن پوائنٹ کے کوآرڈینیٹس حاصل کریں",
  T_36_WZY_WS_GETPOS_PARAM1_DESC: "مقرر کردہ ڈائریکشن پوائنٹ",
  T_36_WZY_WS_GETPROP_PARAM2_NAME: "سامان کی قسم",
  T_36_WZY_WS_GETWALLET_NAME: "والیٹ حاصل کریں",
  T_36_WZY_WS_GETWALLET_NAMEDESC: "منتخب مالک کا والیٹ حاصل کریں",
  T_36_WZY_WS_GETWALLET_PARAM2_NAMEDESC: "والیٹ موجود ہے یا نہیں؟",
  T_36_WZY_WS_GETWALLETRES: "مالک کی والیٹ اینٹیٹی",
  T_36_WZY_WS_HUDCONTROL_DESC: "HUD کی کنٹرول اینٹیٹی",
  T_36_WZY_WS_HUDTYPE: "HUD کی قسم",
  T_36_WZY_WS_INCIDENT_TYPE1: "گلوبل واقعہ",
  T_36_WZY_WS_INCIDENT_TYPE2: "ایٹیٹی کا واقعہ",
  T_36_WZY_WS_INDEX_DESC: "لسٹ کی ایک انڈیکس ویلیو۔ 0 سے شروع ہوتا ہے۔",
  T_36_WZY_WS_INTLIST: "انٹیجر لسٹ",
  T_36_WZY_WS_JENTSUBCL_NAMEDESC: "چیک کریں کہ کیا ایک اینٹیٹی کی قسم کسی مخصوص سب کیٹاگری سے تعلق رکھتی ہے۔ لوٹائی گئی ویلیو بولین ہے۔",
  T_36_WZY_WS_JENTSUBCL_PARAM2_NAMESESC: "پیرنٹ کیٹاگری چیک کرنے کے لیے کہ کیا اینٹیٹی اس سے تعلق رکھتی ہے",
  T_36_WZY_WS_JENTSUBCLRES: "پیرنٹ کیٹاگری چیک کا نتیجہ",
  T_36_WZY_WS_JENTTYPE_NAMEDESC: "چیک کریں کہ آیا کوئی ایٹیٹی کسی مخصوص ایٹیٹی کی قسم سے تعلق رکھتی ہے۔ واپس آیا نتیجہ بولین ہے۔",
  T_36_WZY_WS_JENTTYPE_PARAM1_NAMEDESC: "چیک کرنے والی اینٹیٹی",
  T_36_WZY_WS_JENTTYPE_PARAM2_NAMEDESC: "اس کا مطلب یہ ہے کہ یہ اینٹیٹی کی قسم کی طرح ہے",
  T_36_WZY_WS_JENTTYPERES: "اینٹیٹی چیک کا نتیجہ",
  T_36_WZY_WS_JUSTPATROL: "صرف گشت",
  T_36_WZY_WS_LEAVETRI_NAMEDESC: "جب کھلاڑی ٹرگر سے باہر نکلتا ہے تو ٹرگر ہوتا ہے",
  T_36_WZY_WS_LEAVETRI_PARAM1_DESC: "باہر نکلنے کا ٹرگر",
  T_36_WZY_WS_LEVELOBLIST: "آبجیکٹ لسٹ",
  T_36_WZY_WS_LEVOBJSLIST: "اس میچ میں نقشے کی تمام اشیاء کی لسٹ",
  T_36_WZY_WS_LEVOBTYPE: "آبجیکٹ کی قسم",
  T_36_WZY_WS_LISTT: "کوئی بھی لسٹ",
  T_36_WZY_WS_LOGCONTEXT_DESC: "پرنٹ ہونے والا مواد",
  T_36_WZY_WS_LOGIC2_PARAM1_NAMEDESC: "بائیں طرف کی سٹرنگ منسلک ہونی ہے",
  T_36_WZY_WS_LOGIC2_PARAM3_NAMEDESC: "کنیکٹ کرنے کے لیے صحیح اسٹرنگ",
  T_36_WZY_WS_LOGIC5_PARAM1_NAMEDESC: "ایلیمینٹ ویلیو جس کو شامل کرنا ہے",
  T_36_WZY_WS_LOGOPER: "لاجک آپریشنز کرتے وقت (اور & یا): اگر اور آپریشن کا استعمال کرتے ہوئے اور دو بولین ویلیوز ٹرو ہیں، تو نتیجہ ٹرو ہے، اور اگر یا آپریشن کا استعمال کرتے ہوئے اور دو بولین ویلیوز دونوں فالز نہیں ہیں، تو نتیجہ ٹرو ہے۔",
  T_36_WZY_WS_LOOTPOINT: "لوٹ پوائنٹ",
  T_36_WZY_WS_MAINWEAP: "موجودہ ہتھیار",
  T_36_WZY_WS_MAX_DESC: "جنریٹڈ انٹیجر کی اوپری رینج (اوپن انٹرول)",
  T_36_WZY_WS_MIN_DESC: "جنریٹڈ انٹیجر کی نچلی رینج (کلوزڈ انٹرول)",
  T_36_WZY_WS_MODGUNPRO_PARAM1_NAME: "ہتھیار کی اینٹیٹی",
  T_36_WZY_WS_MONENT: "کرنسی کی اینٹیٹی",
  T_36_WZY_WS_MONTYPE: "کرنسی کی قسم",
  T_36_WZY_WS_MOVETO_NAMEDESC: "AI کو ایک ٹارگٹ پوائنٹ کی طرف بڑھائیں۔ یہ منتخب کرنے کے لیے کہ آیا AI اپنی اصل پوزیشن پر واپس آئے گا [واپسی یا نہیں] کا استعمال کریں۔ یہ منتخب کرنے کے لیے کہ آیا AI اپنے راستے میں دشمنوں کے لیے اسکین کرے گا [حملہ کریں یا نہیں] کا استعمال کریں۔",
  T_36_WZY_WS_MOVETO_PARAM1_NAMEDESC: "AI اینٹیٹی جو سفر کرے گی",
  T_36_WZY_WS_MOVETO_PARAM2_NAMEDESC: "منزل",
  T_36_WZY_WS_MOVETO_PARAM3_NAMEDESC: "یہ سیٹ کرنے کے لیے استعمال کریں کہ آیا منزل پر پہنچنے کے بعد AI اصل مقام پر واپس آئے گا۔ ٹرو کا مطلب ہے واپس آئے گا; فالز کا مطلب ہے واپس نہیں آئے گا۔",
  T_36_WZY_WS_MOVETO_PARAM4_NAME: "حملہ کریں یا نہ کریں",
  T_36_WZY_WS_MOVETO_PARAM4_NAMEDESC: "یہ سیٹ کرنے کے لیے استعمال کریں کہ آیا AI راستے میں قریبی دشمنوں پر حملہ کرے گا۔ ٹرو کا مطلب ہے دشمنوں کے لیے اسکین کریں; فالز کا مطلب ہے دشمنوں کو اسکین نہ کریں۔",
  T_36_WZY_WS_MULVALUE: "اسکیلر",
  T_36_WZY_WS_MULVEC: "اسکیلر ملٹیپلیکیشن ویکٹر",
  T_36_WZY_WS_NEGRES: "منفی ویلیو کا نتیجہ",
  T_36_WZY_WS_NEUTRAL: "غیر جانبدار رائے",
  T_36_WZY_WS_NEXTVAWE_NAMEDESC: "نامزد جنریٹر کو اگلی ویو سپان کرنے پر مجبور کرتا ہے۔ جنریٹرز میں زومبی سپان اور آئٹم سپان شامل ہیں۔",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAME: "جنریٹر اینٹیٹی",
  T_36_WZY_WS_NEXTVAWE_PARAM1_NAMEDESC: "نامزد جنریٹر اینٹیٹی، جیسے کہ زومبی اسپانز اور آئٹم اسپانز",
  T_36_WZY_WS_OBJENT: "آبجیکٹ اینٹیٹی",
  T_36_WZY_WS_OBTITEM_NAMEDESC: "جب کوئی آئٹم حاصل ہوتا ہے تو ٹرگر ہوتا ہے۔ [آئٹم کی قسم] آئٹم کی وہ قسم ہے جو حاصل کی جاتی ہے۔",
  T_36_WZY_WS_OBTWEAP_NAMEDESC: "جب کوئی ہتھیار حاصل ہوتا ہے تو ٹرگر ہوتا ہے۔ [ہتھیار اینٹیٹی] حاصل کردہ ہتھیار ہے۔",
  T_36_WZY_WS_ONEWAY: "یک طرفہ",
  T_36_WZY_WS_OPENSTATE: "سٹیٹس",
  T_36_WZY_WS_OPERMETHOD_NAME: "آپریشن",
  T_36_WZY_WS_OPERMETHOD_NAMEDESC: "بنیادی  آرتھمیٹک آپریشنز۔ فی الحال، انٹیجر آپریشنز میں ایڈیشن، سبٹریکشن، ملٹیپلیکیشن، ڈیویژن اور ریمینڈر شامل ہیں، اور فلوٹ آپریشنز میں ایڈیشن، سبٹریکشن، ملٹیپلیکیشن اور ڈیویژن شامل ہیں۔",
  T_36_WZY_WS_OWNERENT_DESC: "وہ اینٹیٹی جس کا والیٹ حاصل کرنا ہے",
  T_36_WZY_WS_PERCENTAGE: "فیصد ایڈجسٹمنٹ",
  T_36_WZY_WS_PLACOLLIDE_NAME: "جب کھلاڑی ٹرگر سے ٹکرا جاتا ہے",
  T_36_WZY_WS_PLACOLLIDE_NAMEDESC: "جب [ٹرگر پلیئر] ٹرگر سے ٹکراتا ہے تو ٹرگر ہوتا ہے",
  T_36_WZY_WS_PLACOLLIDE_PARAM1_NAMEDESC: "وہ کھلاڑی جو ٹرگر سے ٹکراتا ہے",
  T_36_WZY_WS_PLACOLLIDE_PARAM2_NAMEDESC: "وہ آبجیکٹ اینٹیٹی جس سے کھلاڑی ٹکراتا ہے",
  T_36_WZY_WS_PLADRIVEH_NAME: "جب کھلاڑی گاڑی چلاتا ہے",
  T_36_WZY_WS_PLADRIVEH_NAMEDESC: "ٹرگر اس وقت ہوتا ہے جب [ٹرگر کھلاڑی] گاڑی چلاتا ہے",
  T_36_WZY_WS_PLADRIVEH_PARAM1_NAMEDESC: "وہ کھلاڑی جو وہیکل چلا رہا ہے",
  T_36_WZY_WS_PLADRIVEH_PARAM2_NAMEDESC: "گاڑی کی وہ اینٹیٹی جسے کھلاڑی چلا رہا ہے",
  T_36_WZY_WS_PLAGETOFFVEH_NAME: "جب کھلاڑی گاڑی سے باہر نکلتا ہے",
  T_36_WZY_WS_PLAGETOFFVEH_NAMEDESC: "جب [ٹرگر پلیئر] گاڑی سے باہر نکلتا ہے تو ٹرگر ہوتا ہے",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM1_NAMEDESC: "وہ کھلاڑی جو گاڑی سے باہر نکل رہا ہے",
  T_36_WZY_WS_PLAGETOFFVEH_PARAM2_NAMEDESC: "گاڑی کی وہ اینٹیٹی جس سے کھلاڑی باہر نکل رہا ہے",
  T_36_WZY_WS_PLAGETONVEH_NAME: "جب کھلاڑی گاڑی میں داخل ہوتا ہے",
  T_36_WZY_WS_PLAGETONVEH_NAMEDESC: "ٹرگر ہوتا ہے جب [ٹرگر کھلاڑی] گاڑی میں داخل ہوتا ہے",
  T_36_WZY_WS_PLAGETONVEH_PARAM2_NAMEDESC: "گاڑی کی وہ اینٹیٹی جس میں کھلاڑی داخل ہو رہا ہے",
  T_36_WZY_WS_PLAKNOFLY_NAME: "جب کھلاڑی ٹائر سے چھلانگ لگاتا ہے",
  T_36_WZY_WS_PLAKNOFLY_NAMEDESC: "جب [ٹرگر پلیئر] ٹائر کو باؤنس کرتا ہے تو ٹرگر ہوتا ہے",
  T_36_WZY_WS_PLAKNOFLY_PARAM1_NAMEDESC: "وہ کھلاڑی جو ٹائر کو باؤنس کرتا ہے",
  T_36_WZY_WS_PLAKNOFLY_PARAM2_NAMEDESC: "آبجیکٹ اینٹیٹی جس پر کھلاڑی باؤنس کرتا ہے",
  T_36_WZY_WS_PLATP_NAME: "کھلاڑی کے ٹیلی پورٹ ہونے کے بعد",
  T_36_WZY_WS_PLATP_PARAM1_NAMEDESC: "وہ کھلاڑی جو پورٹل استعمال کرتا ہے",
  T_36_WZY_WS_PLATP_PARAM2_NAMEDESC: "پورٹل اینٹیٹی جسے کھلاڑی نے استعمال کیا",
  T_36_WZY_WS_PLAYERLIST_DESC: "اس میچ کے تمام کھلاڑیوں کی لسٹ",
  T_36_WZY_WS_POINTPICKER: "راستہ محور",
  T_36_WZY_WS_PORTALENT: "پورٹل اینٹیٹی",
  T_36_WZY_WS_PREFAB: "ٹیمپلیٹ",
  T_36_WZY_WS_PRODLIST: "مرچنڈائز لسٹ",
  T_36_WZY_WS_PRODSORT_PARAM3_NAME: "ترتیب",
  T_36_WZY_WS_PROPMOD: "پراپرٹی کی تبدیلی کا طریقہ",
  T_36_WZY_WS_RANKABLEE: "درجہ بندی کے قابل اینٹیٹی",
  T_36_WZY_WS_REDCURR_NAMEDESC: "ایک مقررہ والیٹ میں مخصوص کرنسی کا استعمال کریں",
  T_36_WZY_WS_REDCURR_PARAM1_NAMEDESC: "وہ والیٹ جو کرنسی خرچ کرتا ہے",
  T_36_WZY_WS_REDCURR_PARAM2_NAMEDESC: "استعمال شدہ کرنسی کی قسم",
  T_36_WZY_WS_REDCURR_PARAM3_NAMEDESC: "استعمال شدہ کرنسی کی رقم",
  T_36_WZY_WS_RNDFRES: "جنریٹڈ رینڈم فلوٹ",
  T_36_WZY_WS_RNDIRES: "رینڈم انٹیجر جنریشن کا نتیجہ",
  T_36_WZY_WS_ROUND_NAME_DESC: "کسی ویلیو کو قریب ترین انٹیجر تک راؤنڈ کریں",
  T_36_WZY_WS_ROUND_PARAM1_NAMEDESC: "راؤنڈ کرنے کی ویلیو",
  T_36_WZY_WS_ROUNDRES: "راؤنڈنگ کا نتیجہ",
  T_36_WZY_WS_RUNAI_NAMEDESC: "طرز عمل کا درخت جسے منتخب AI لاگو کرے گا",
  T_36_WZY_WS_RUNAI_PARAM1_NAMEDESC: "یونٹ اینٹیٹی جو ڈیفالٹ بیہیویر ٹری کو روکتی/ چلاتی ہے",
  T_36_WZY_WS_SCOREABLEE: "اسکور کے قابل اینٹیٹی",
  T_36_WZY_WS_SCORECHANGE_NAMEDESC: "اسکور تبدیل ہونے پر ٹرگر۔ [اسکور کی قسم] اسکور کی وہ قسم ہے جو تبدیل ہوئی ہے۔ [اسکور] نیا اسکور ہے۔",
  T_36_WZY_WS_SETDIRPOINT_NAME: "ایک ڈائریکشن پوائنٹ بنائیں",
  T_36_WZY_WS_SETDIRPOINT_NAMESESC: "ایک نیا بنایا ہوا ڈائریکشن پوائنٹ حاصل کریں۔ پوائنٹ کے کوآرڈینیٹس کو سیٹ کرنے کے لیے [مقام] اور سمت کے ویکٹر کو متعین کرنے کے لیے [ڈائریکشن] کا استعمال کریں۔",
  T_36_WZY_WS_SETDIRPOINT_PARAM1_NAMEDESC: "ڈائریکشن پوائنٹ کے کوآرڈینیٹس",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAME: "ڈائریکشن",
  T_36_WZY_WS_SETDIRPOINT_PARAM2_NAMEDESC: "ڈائریکشن پوائنٹ کا ویکٹر",
  T_36_WZY_WS_SETPATH_NAMEDESC: "AI اینٹیٹیز یہاں ترتیب دیے گئے آرڈر کے مطابق سفر کریں گی۔ دستیاب سفری اقسام سرکل-بیک، ون-وے اور راؤنڈ-ٹرپ ہیں۔ آپ یہ بھی منتخب کر سکتے ہیں کہ آیا AI راستے میں دشمنوں کو اسکین کرے گا۔",
  T_36_WZY_WS_SETPATH_PARAM2_NAMEDESC: "ایک لسٹ جو ان پوائنٹس پر مشتمل ہوتی ہے جہاں AI کو سفر کرنا چاہیے",
  T_36_WZY_WS_SETPATH_PARAM3_NAME: "منتقل کرنے کا طریقہ",
  T_36_WZY_WS_SETPATH_PARAM3_NAMEDESC: "یہ سفر کی اقسام ہیں۔ ون-وے یہ ہے کہ AI منزل پر پہنچنے کے بعد سفر کرنا بند کر دے۔ سرکل-بیک AI کے لیے ہے کہ وہ منزل پر پہنچنے کے بعد واپسی کا راستہ تلاش کرے۔ راؤنڈ-ٹرپ AI کے لیے راستے کی فہرست کے الٹی ترتیب کے مطابق اصل مقام پر واپسی ہے۔",
  T_36_WZY_WS_SHOPECON: "اسٹور اور معیشت",
  T_36_WZY_WS_SHOWFLO_NAMEDESC: "اسکرین پرفلوٹ کرنے والی نوٹیففیکیشن کو ظاہر کرنے کے لیے استعمال کریں۔ [ٹیکسٹ] کا استعمال کرتے ہوئے مواد کو ترتیب دیں، [کلر] کا استعمال کرتے ہوئے متن کا رنگ، اور [دورانیہ] کا استعمال کرتے ہوئے ڈسپلے کا دورانیہ (یونٹ ملی سیکنڈ ہے)۔",
  T_36_WZY_WS_SHOWFLO_PARAM1_DESC: "فلوٹنگ نوٹیفیکیشن کا مواد",
  T_36_WZY_WS_SHOWFLO_PARAM2_DESC: "فلوٹنگ نوٹیفیکیشن کا کلر",
  T_36_WZY_WS_SHOWFLO_PARAM3_DESC: "فلوٹنگ نوٹیفیکیشن کا ڈسپلے دورانیہ، ملی سیکنڈ میں",
  T_36_WZY_WS_SIN_NAMEDESC: "اینگل کا سائن نکالیں",
  T_36_WZY_WS_SINRES: "اینگل کا سائن",
  T_36_WZY_WS_SKIPKNODOWN: "گرانے پر ختم کیا گیا یا نہیں",
  T_36_WZY_WS_SQRTRES: "اسکوئر روٹ کا نتیجہ",
  T_36_WZY_WS_STRCONRES: "سٹرنگ کنکشن کا نتیجہ",
  T_36_WZY_WS_STRINGLIST: "سٹرنگ لسٹ",
  T_36_WZY_WS_STRLEN: "سٹرنگ کی لمبائی",
  T_36_WZY_WS_STRVAL: "سٹرنگ کا نتیجہ",
  T_36_WZY_WS_TAN_NAMEDESC: "اینگل کا ٹینجنٹ تلاش کریں",
  T_36_WZY_WS_TANRES: "اینگل کا ٹینجنٹ",
  T_36_WZY_WS_TEAMLIST: "ٹیم کی لسٹ",
  T_36_WZY_WS_TEAMLIST_DESC: "اس میچ کی تمام ٹیموں کی لسٹ",
  T_36_WZY_WS_TIMETWEENTIPS: "کاؤنٹ ڈاؤن نوٹیفیکیشن اینٹیٹی",
  T_36_WZY_WS_TOSTRING_NAMEDESC: "ٹارگٹ ویلیو کو سٹرنگ میں تبدیل کریں",
  T_36_WZY_WS_TOSTRING_PARAM1_DESC: "سٹرنگ میں تبدیل کرنے کے لیے ٹارگٹ ویلیو",
  T_36_WZY_WS_TOSTRINGRES: "سٹرنگ کی تبدیلی کا نتیجہ",
  T_36_WZY_WS_TOWERCAMP_DESC: "سائیڈ نمبر اور ٹیم نمبر ایک ہی ہیں۔ غیر جانبدار ٹاورز اور قلعے رینج کے اندر تمام کھلاڑیوں اور AIs پر حملہ کرتے ہیں۔",
  T_36_WZY_WS_TRACURR_NAMEDESC: "ایک پرس سے دوسرے والیٹ میں مخصوص کرنسی کی مخصوص رقم منتقل کریں",
  T_36_WZY_WS_TRACURR_PARAM1_NAMEDESC: "کرنسی کو باہر نکالنے کے لیے بٹوہ",
  T_36_WZY_WS_TRACURR_PARAM2_NAMEDESC: "ٹرانزیکشن میں کرنسی کی قسم",
  T_36_WZY_WS_TRACURR_PARAM3_NAMEDESC: "ٹرانزیکشن میں کرنسی کی تعداد",
  T_36_WZY_WS_TRACURR_PARAM4_NAMEDESC: "کرنسی کو منتقل کرنے کے لئے والیٹ",
  T_36_WZY_WS_TWEENTIPS: "فلوٹنگ نوٹیفیکیشن اینٹیٹی",
  T_36_WZY_WS_TYPEENUM: "اینم ٹائپ",
  T_36_WZY_WS_USEPROP_NAMEDESC: "جب کوئی کھلاڑی کوئی آئٹم استعمال کرتا ہے تو ٹرگر ہوتا ہے۔ [ٹرگری کھلاڑی] وہ کھلاڑی ہے جو کسی چیز کو استعمال کرتا ہے۔ [آئٹم کی قسم] وہ آئٹم ہے جسے کھلاڑی استعمال کرتا ہے۔",
  T_36_WZY_WS_USEPROP_PARAM2_DESC: "کھلاڑی کا استعمال کردہ آئٹم کی قسم",
  T_36_WZY_WS_VECADDLEFT: "ویکٹر کے اضافے کی بائیں ویلیو",
  T_36_WZY_WS_VECADDRES: "ویکٹر کے اضافے کا نتیجہ",
  T_36_WZY_WS_VECADDRIGHT: "ویکٹرز ایڈیشن کی رائٹ ویلیو",
  T_36_WZY_WS_VECANGLEFT: "ویکٹر اینگل کی بائیں ویلیو",
  T_36_WZY_WS_VECANGRES: "2 ویکٹر کے درمیان اینگل",
  T_36_WZY_WS_VECANGRIGHT: "ویکٹرز اینگل کی رائٹ ویلیو",
  T_36_WZY_WS_VECCROLEFT: "کراس پروڈکٹ کی بائیں ویلیو",
  T_36_WZY_WS_VECCRORES: "کراس پروڈکٹ کا نتیجہ",
  T_36_WZY_WS_VECCRORIGHT: "کراس پروڈکٹ کی صحیح ویلیو",
  T_36_WZY_WS_VECDISLEFT: "ویکٹر کے فاصلے کی بائیں ویلیو",
  T_36_WZY_WS_VECDISRES: "2 ویکٹر کے درمیان فاصلہ",
  T_36_WZY_WS_VECDISRIGHT: "ویکٹر کے فاصلے کی صحیح ویلیو",
  T_36_WZY_WS_VECDOCLEFT: "ڈاٹ پروڈکٹ کی بائیں ویلیو",
  T_36_WZY_WS_VECDOCRES: "ڈاٹ پروڈکٹ کا نتیجہ",
  T_36_WZY_WS_VECDOCRIGHT: "ڈاٹ پروڈکٹ کی صحیح ویلیو",
  T_36_WZY_WS_VECMULRES: "اسکیلر ملٹیپلیکیشن کا نتیجہ",
  T_36_WZY_WS_VECNORRES: "نارملائزڈ ویکٹر",
  T_36_WZY_WS_VECSIZERES: "ویکٹر کا میگنیٹیوڈ",
  T_36_WZY_WS_VECSUBLEFT: "ویکٹر تفریق کی لیفٹ ویلیو",
  T_36_WZY_WS_VECSUBRES: "ویکٹر تفریق کا نتیجہ",
  T_36_WZY_WS_VECSUBRIGHT: "ویکٹر تفریق کی رائٹ ویلیو",
  T_36_WZY_WS_VECTORLIST: "ویکٹر لسٹ",
  T_36_WZY_WS_VECX: "x کمپونینٹ",
  T_36_WZY_WS_VECY: "y کمپونینٹ",
  T_36_WZY_WS_VECZ: "z کمپونینٹ",
  T_36_WZY_WS_VEHENT: "گاڑی کی اینٹیٹی",
  T_36_WZY_WS_WALLCONT: "والیٹ کا مواد",
  T_36_WZY_WS_ZOMBIESPERWAVE: "مسلسل",
  T_36_XYL_WS_AIBOT: "یونٹ",
  T_36_XYL_WS_AIGENERATOR: "یونٹ جنریٹر",
  T_36_XYL_WS_AIGENERATOR_DESC: "ایک جنریٹر جو مسلسل نامزد یونٹس (جیسے زومبی) جنریٹ کر سکتا ہے",
  T_36_XYL_WS_AIWAVE: "ہر ویو پر جنریٹڈ یونٹس #",
  T_36_XYL_WS_ARROW: "ڈائریکشن سائن",
  T_36_XYL_WS_ARROW_DESC: "ایک پوائنٹ جو کسی ڈائریکشن کی طرف اشارہ کرتا ہے",
  T_36_XYL_WS_BREAKBOX: "ٹوٹنے والا باکس",
  T_36_XYL_WS_BREAKBOX_DESC: "لکڑی کا ایک باکس جو حملہ کرنے پر ٹوٹ سکتا ہے",
  T_36_XYL_WS_FENCE: "لوہے کی باڑ",
  T_36_XYL_WS_FENCE_DESC: "ایک باڑ جو گولیوں کو گزرنے  کے قابل بناتی ہے",
  T_36_XYL_WS_STAIRI: "لینڈنگ C",
  T_36_XYL_WS_STAIRI_DESC: "ایک پلیٹ فارم جسے سیڑھیوں کے ساتھ ملایا جا سکتا ہے",
  T_36_XYL_WS_ZOMBIEAI: "زومبی",
  T_36_XYL_WS_ZOMBIEAI_DESC: "ایک زومبی جسے اپنی مرضی کے مطابق بنایا جا سکتا ہے اور یونٹ جنریٹر میں حاصل کردہ اور نقل شدہ مضمون ہو سکتا ہے",
  T_36_YF_CORRODE_GRENADE_N: "گلو میلٹر",
  T_36_YF_SETTING_TYPE3: "پری سیٹ 3",
  T_36_YS_B_BRFOOTBALL_BLUE01: "CBF اوشین جرسی (باٹم)",
  T_36_YS_B_BRFOOTBALL_YELLOW01: "CBF سنشائن جرسی (باٹم)",
  T_36_YS_F_A_GHOSTHUNTER: "فائنڈیش فاکسٹیل (ماسک)",
  T_36_YS_F_B_GHOSTHUNTER: "فائنڈیش فاکسٹیل (باٹم)",
  T_36_YS_F_H_GHOSTHUNTER: "فائنڈیش فاکسٹیل (ہیڈ)",
  T_36_YS_F_S_GHOSTHUNTER: "فائنڈیش فاکسٹیل (جوتے)",
  T_36_YS_SETTING_GRENADE: "تھرو ایبلز",
  T_36_YS_SETTING_MOVE: "حرکت",
  T_36_YS_T_BRFOOTBALL_BLUE01: "CBF اوشین جرسی (ٹاپ)",
  T_36_YS_T_BRFOOTBALL_YELLOW01: "CBF سنشائن جرسی (ٹاپ)",
  T_36_YZY_CHARACTER_GANGGIRL_N: "لونا",
  T_36_YZY_CHARACTER_YAKUZA_N: "تتسویا",
  T_36_YZY_PET_WOLF_N: "فینگ",
  T_36_YZY_PETSKIN_AXOLOTL_GRIZA_N: "پٹ اسکن: پرپل زاسل",
  T_36_YZY_PETSKIN_HAWK_BDK_N: "پٹ اسکن: لائٹننگ فالکو",
  T_36_YZY_PETSKIN_WOLF_FIRE_N: "پٹ اسکن: لاوا فینگ",
  T_36_YZY_PETSKIN_WOLF_SUGARSKULL22_N: "پٹ اسکن: سپیکٹرل گائیڈ",
  T_36_YZY_PETSKIN_WOLF_WINTER_N: "پٹ اسکن: آرکٹک فینگ",
  T_37_B_WS_HIDE: "چھپن چھپائی",
  T_37_HZ_WS_CATMODEDESC1: "چھپن چھپائی",
  T_37_JH_WS_CREATEGOLD_DESC: "ایک وینڈنگ مشین جس سے کھلاڑی آئٹمز خرید سکتے ہیں۔ (کلیش اسکواڈ، ٹیم ڈیتھ میچ، پلے گراؤنڈ، اور ڈرائیڈ اپولیکپس موڈز میں درست نہیں)",
  T_37_JH_WS_NAME1: "FF نائف (ڈرائیڈ اپولیکپس)",
  T_37_JH_WS_NAME10: "M1887-X (ڈرائیڈ اپولیکپس)",
  T_37_JH_WS_NAME11: "SPAS12 (ڈرائیڈ اپولیکپس)",
  T_37_JH_WS_NAME12: "M1014 (ڈرائیڈ اپولیکپس)",
  T_37_JH_WS_NAME13: "MP40 (ڈرائیڈ اپولیکپس)",
  T_37_JH_WS_NAME14: "MP5-III (ڈرائیڈ اپولیکپس)",
  T_37_JH_WS_NAME15: "P90 (ڈرائیڈ اپولیکپس)",
  T_37_JH_WS_NAME16: "M60-III (ڈرائیڈ اپولیکپس)",
  T_37_JH_WS_NAME17: "تھامسن (ڈرائیڈ اپولیکپس)",
  T_37_JH_WS_NAME18: "UMP (ڈرائیڈ اپولیکپس)",
  T_37_JH_WS_NAME19: "SVD (ڈرائیڈ اپولیکپس)",
  T_37_JH_WS_NAME2: "گروزا (ڈرائیڈ اپولیکپس)",
  T_37_JH_WS_NAME20: "AWM (ڈرائیڈ اپولیکپس)",
  T_37_JH_WS_NAME21: "M82B (ڈرائیڈ اپولیکپس)",
  T_37_JH_WS_NAME22: "M249-X (ڈرائیڈ اپولیکپس)",
  T_37_JH_WS_NAME23: "Kar98k-III (ڈرائیڈ اپولیکپس)",
  T_37_JH_WS_NAME3: "AK47 (ڈرائیڈ اپولیکپس)",
  T_37_JH_WS_NAME4: "M4A1-III (ڈرائیڈ اپولیکپس)",
  T_37_JH_WS_NAME5: "SCAR (ڈرائیڈ اپولیکپس)",
  T_37_JH_WS_NAME6: "M14-III (ڈرائیڈ اپولیکپس)",
  T_37_JH_WS_NAME7: "پارافل (ڈرائیڈ اپولیکپس)",
  T_37_JH_WS_NAME8: "XM8 (ڈرائیڈ اپولیکپس)",
  T_37_JH_WS_NAME9: "MAG-7 (ڈرائیڈ اپولیکپس)",
  T_37_JH_WS_VENDMACHINE_DESC: "گولڈ جو نقشے کے ارد گرد سے اٹھایا جا سکتا ہے۔ (کلیش اسکواڈ، ٹیم ڈیتھ میچ، پلے گراؤنڈ، اور ڈرائیڈ اپولیکپس موڈز میں درست نہیں)",
  T_37_JH_WS_X: "X محور",
  T_37_JH_WS_Y: "Y محور",
  T_37_JH_WS_Z: "Z محور",
  T_37_JL_FOOTBALL_TIE: "برابر",
  T_37_JL_GOLD_M1014_I_N: "M1014-I",
  T_37_JL_GOLD_M1014_II_N: "M1014-II",
  T_37_JL_GOLD_M1014_III_N: "M1014-III",
  T_37_JL_M1216_N: "ٹروگن",
  T_37_KK_WS_SNOWMAN: "واگور سنو مین",
  T_37_LC_BP_ENTRANCE_GIFT: "تحفہ!",
  T_37_M_WS_MISSING: "سورس غائب ہے",
  T_37_M_WS_NAMEERROR: "حساس کرداروں پر مشتمل ہے۔ براہ کرم تبدیل کریں۔",
  T_37_PD_HuntingGround_BOSSTITLE: "قصاب",
  T_37_QL_JUMPPAD_DES: "زمین پر جمپ پیڈ بناتا ہے۔ اسے ہوا میں اونچی چھلانگ لگانے کے لیے استعمال کیا جا سکتا ہے اور ہوائی فائرنگ کے قابل بناتا ہے۔",
  T_37_QL_JUMPPAD_NAME: "ٹرامپولین",
  T_37_R_TAILOR_LIMIT: "محدود وقت",
  T_37_RW_LOADOUT_BORNFIRETAG: "Get 2 Bonfires at the start of the match. Bonfire [FFBA00]regenerates 5 HP and 20 EP per second[-] (up to 10 seconds) for you and your teammates within the area. Bonfire effects do not stack.",
  T_37_RW_PROPCATAPULT_DESC: "فلانے پر، لانچ پیڈ کو کسی کھلاڑی کو ہوا میں اچھالنے کے لیے استعمال کیا جا سکتا ہے۔ لیکن محفوظ زون میں رہنا یقینی بنائیں",
  T_37_RW_PROPCATAPULT_NAME: "لانچ پیڈ",
  T_37_SP_WS_COLOR_02: "رنگ",
  T_37_SP_WS_COLOR_03: "ظاہری شکل",
  T_37_SP_WS_LOG_ENTITY_IS_EMPTY: "اینٹیٹی اپنی پراپرٹی حاصل کرنے یا سیٹنگ کرنے پر خالی ہوتی ہے",
  T_37_SP_WS_LOG_PHASE_END: "مرحلہ {0} ختم ہوا۔",
  T_37_SP_WS_LOG_PHASE_START: "مرحلہ {0} شروع ہوتا ہے",
  T_37_SP_WS_LOG_ROUND_END: "راؤنڈ {0} ختم ہوا۔",
  T_37_SP_WS_LOG_ROUND_START: "راؤنڈ {0} شروع ہوا۔",
  T_37_SP_WS_LOG_VAR_ASSIGNMENT_OPERATOR_MISMATCH: "ویریایبل کو ویلیو دینے کے وقت مس میچ قسم۔ موجودہ قسم: {0}۔ مطلوبہ قسم: {1}۔",
  T_37_SP_WS_LOG_VAR_UNDEFINED_OR_OUT_OF_SCOPE: "غیر متعینہ یا اسکوپ سے باہر لوکل ویریایبل {0}",
  T_37_SP_WS_MAPACCESS_08: "ترمیم",
  T_37_SP_WS_RACEMODE_01: "کاؤنٹ ڈاؤن موڈ",
  T_37_SP_WS_RACEMODE_02: "کاؤنٹ ڈاؤن ٹائم",
  T_37_SP_WS_RACEMODE_04: "آن ہونے پر، ایک کاؤنٹ ڈاؤن شروع ہوگا جب ایک پوری ٹیم فنشنگ پوائنٹ پر پہنچ جائے گی۔ کاؤنٹ ڈاؤن ختم ہونے پر گیم ختم ہو جاتی ہے۔",
  T_37_SY_AR15_KABUKI_N: "کنگ فشر - ہانا کا گانا",
  T_37_SY_BACKPACK_STRAW_N: "اسٹرا ہیٹ بیگ",
  T_37_SY_GRENADE_FFWS2022_01_N: "گرینیڈ - نیوی اسٹارسی",
  T_37_SY_GROUPANIM_BLACKHOLE_N: "بلیک ہول",
  T_37_SY_M1216_MAMBAS_N: "ٹروگن - ممبا گنا",
  T_37_SY_PET_FLYINGCREATURE_N: "آروان",
  T_37_SY_PETSKIN_DUCK_WINTERFEST22_N: "پٹ اسکن: گلیم اسٹار بینی",
  T_37_SY_PETSKIN_FLYINGCREATURE_BLUE_N: "پٹ اسکن: ایش آروان",
  T_37_SY_PETSKIN_FLYINGCREATURE_ORANGE_N: "پٹ اسکن: گلیکسی آروان",
  T_37_SY_PETSKIN_FLYINGCREATURE_PURPLE_N: "پٹ سکن: فائر میتھ آروان",
  T_37_SY_PETSKIN_TORTOISE_SOCCER22_N: "پٹ اسکن: فوٹی فلیش",
  T_37_SY_PETSKIN_YETI_NEWYEAR22_N: "پٹ اسکن: ونٹر لینڈز یتی",
  T_37_SY_VEHICLE_JEEP_WINTERFEST22_N: "جیپ- راکن فیسٹیول رائڈ",
  T_37_SY_VEHICLE_SUV_FFWS2022_N: "پک اپ ٹرک - اسٹارسی بیسٹ",
  T_37_WT_WS_PVE2DESC: "محدود وقت کے اندر ٹارگٹ نمبر زومبیوں کو ختم کریں یا آخر تک زندہ رہیں",
  T_37_WT_WS_RULEDESC: "جیتنے کے لیے ٹارگٹ نمبر زومبیوں کو ختم کریں۔",
  T_37_WT_WS_RULETITLE: "ہدف",
  T_37_WT_WS_TXT1: "زومبیز کو ختم کریں",
  T_37_WT_WS_TXT1DESC: "آن ہونے پر، کھلاڑی زومبیوں کی مخصوص تعداد کو ختم کر کے جیت جاتے ہیں۔ آف ہونے پر، کھلاڑی آخر تک زندہ رہ کر جیت جاتے ہیں۔",
  T_37_WT_WS_TXT2: "خاتمے کی رقم",
  T_37_WZY_FRIDPLA: "دوستانہ کھلاڑی",
  T_37_WZY_FRIDSIDE: "دوستانہ فیکشن",
  T_37_WZY_FRIDTEAM: "دوستانہ ٹیم",
  T_37_WZY_HOSTPLA: "دشمن کا کھلاڑی",
  T_37_WZY_HOSTSIDE: "دشمن کا گروہ",
  T_37_WZY_WS_ACCFRAMES: "جمع شدہ فریم",
  T_37_WZY_WS_ADDITEMTOPROD_NAMEDESC: "آئٹمز کو مرچنڈائز میں شامل کریں۔ آپ ایک آئٹم یا آئٹمز کا ایک گروپ شامل کر سکتے ہیں۔ رقم یا تو انفرادی آئٹمز کی تعداد ہو سکتی ہے یا ایک لسٹ جو اس رقم کی آئٹمز پر مشتمل ہو۔",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM1_DESC: "آئٹمز کو شامل کرنے کے لیے مرچنڈائز اینٹیٹی",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM2_DESC: "شامل کرنے کے لئے آئٹمز. آپ ایک آئٹم یا آئٹمز کا ایک گروپ شامل کر سکتے ہیں۔",
  T_37_WZY_WS_ADDITEMTOPROD_PARAM3_DESC: "شامل کرنے کے لیے انفرادی آئٹمز کی مقدار یا ایک لسٹ جو اس رقم کے آئٹمز پر مشتمل ہو۔",
  T_37_WZY_WS_ADDLABEL_NAMEDESC: "منتخب اینٹیٹی کے لیے ایک ٹیگ شامل کریں",
  T_37_WZY_WS_ADDLABEL_PARAM1_DESC: "وہ اینٹیٹی جس میں ٹیگ شامل کرنا ہے",
  T_37_WZY_WS_ADDLABEL_PARAM2_DESC: "شامل کرنے کے لیے ٹیکسٹ کا مواد",
  T_37_WZY_WS_AIMABLEENT: "مقصد کے قابل اینٹیٹی",
  T_37_WZY_WS_AIMASSISTTYPE: "نشانے میں مدد کی قسم",
  T_37_WZY_WS_ALLOWDROP_NAME: "آئٹم گرانے کو فعال/غیر فعال کریں",
  T_37_WZY_WS_ALLOWDROP_NAMEDESC: "آیا کوئی کھلاڑی آئٹمز گرا سکتا ہے",
  T_37_WZY_WS_ALLOWDROP_PARAM1_DESC: "کھلاڑی کی اینٹیٹی کنفیگر کرنے کے لیے کہ آیا آئٹمز کو گرانا ہے",
  T_37_WZY_WS_ALLOWDROP_PARAM2_DESC: "آیا کوئی کھلاڑی آئٹمز گرا سکتا ہے۔ یہ بولین ویلیو ہے۔",
  T_37_WZY_WS_ALLOWPICKUP_NAME: "آئٹم اٹھانے کو فعال/غیر فعال کریں",
  T_37_WZY_WS_ALLOWPICKUP_NAMEDESC: "آیا کوئی کھلاڑی آئٹمز اٹھا سکتا ہے",
  T_37_WZY_WS_ALLOWPICKUP_PARAM1_DESC: "کھلاڑی کی اینٹیٹی کنفیگر کرنے کے لیے کہ آیا آئٹمز کو اٹھانا ہے۔",
  T_37_WZY_WS_ALLOWPICKUP_PARAM2_DESC: "آیا کوئی کھلاڑی آئٹم اٹھا سکتا ہے۔ یہ بولین ویلیو ہے۔",
  T_37_WZY_WS_AMBIENTCOLOR: "ارد گرد کی روشنی کا رنگ",
  T_37_WZY_WS_AMRORTOOL: "آرمر کی مرمت",
  T_37_WZY_WS_ATTACK: "حملہ",
  T_37_WZY_WS_BACKTONOR_NAMEDESC: "کھلاڑی کے بھیس کو منسوخ کریں تاکہ وہ اپنے معمول پر واپس آجائیں",
  T_37_WZY_WS_BACKTONOR_PARAM1_DESC: "کھلاڑی کی اینٹیٹی جس کے بھیس میں منسوخ کرنا ہے",
  T_37_WZY_WS_BALLADDV_NAMEDES: "فٹ بال کی رفتار کو بڑھائیں",
  T_37_WZY_WS_BALLADDV_PARAM1_DESC: "فٹ بال جس کے لیے ایکسلریشن شامل کرنی ہے",
  T_37_WZY_WS_BALLADDV_PARAM2_DESC: "بوسٹ کا سپیڈ ویکٹر",
  T_37_WZY_WS_BALLKICKED_NAMEDESC: "جب فٹ بال کو فٹ بال شوٹر سے ہٹ  کیا جاتا ہے تو ٹرگر ہوتا ہے۔ [کھلاڑی اینٹیٹی] وہ کھلاڑی ہے جو فٹ بال شوٹر کا مالک ہے۔ [رفتار کا بوسٹ] ہٹ ہونے کے بعد فٹ بال کی اضافی رفتار ہے۔",
  T_37_WZY_WS_BALLKICKED_PARAM1_DESC: "وہ کھلاڑی جو فٹ بال شوٹر کا مالک ہے",
  T_37_WZY_WS_BALLKICKED_PARAM2_DESC: "فٹ بال کی رفتار کے ویکٹر کو ہٹ کرنے کے بعد",
  T_37_WZY_WS_BALLKNOCKED_NAMEDESC: "اس وقت ٹرگر ہوتا ہے جب فٹ بال کسی اینٹیٹی سے ٹکراتا ہے اور بال کی رفتار بڑھ جاتی ہے۔ [ٹکرانے والی اینٹیٹی] وہ اینٹیٹی ہے جو فٹ بال سے ٹکراتی ہے۔ [رفتار کا بوسٹ] ٹکرانے کے بعد فٹ بال کی اضافی رفتار ہے۔",
  T_37_WZY_WS_BALLKNOCKED_PARAM1_DESC: "وہ اینٹیٹی جو فٹ بال سے ٹکراتی ہے",
  T_37_WZY_WS_BALLKNOCKED_PARAM2_DESC: "تیز رفتار ویکٹر جو ٹکرانے پر فٹ بال میں شامل ہوتا ہے",
  T_37_WZY_WS_BEAIMED_NAMEDESC: "اس وقت ٹرگر ہوتا ہے جب کسی کھلاڑی کی طرف سے اینٹیٹی کو نشانہ بنایا جا رہا ہو",
  T_37_WZY_WS_BEAIMED_PARAM1_DESC: "وہ کھلاڑی جو اینٹیٹی کو نشانہ بنا رہا ہے",
  T_37_WZY_WS_BEHAVIORSTAT: "کھلاڑی کے رویے کا سٹیٹس",
  T_37_WZY_WS_BEHIT_PARAM1_DESC: "وہ ہتھیار جو اس اینٹیٹی کو ہٹ کرتا ہے",
  T_37_WZY_WS_BLOODBARENT: "ہیلتھ بار اینٹیٹی",
  T_37_WZY_WS_BOMBEND: "دھماکے سے پہلے",
  T_37_WZY_WS_BOMBSTART: "بم کا اشارہ",
  T_37_WZY_WS_CHANENT: "چینل اینٹیٹی",
  T_37_WZY_WS_CHEER: "خوش ہو جاؤ",
  T_37_WZY_WS_CHELABEL_NAMEDESC: "چیک کریں کہ آیا ایک منتخب اینٹیٹی نامزد ٹیگز پر مشتمل ہے",
  T_37_WZY_WS_CHELABEL_PARAM1_DESC: "وہ اینٹیٹی جس کی جانچ کرنی ہے کہ آیا اس میں ٹیگز موجود ہیں",
  T_37_WZY_WS_CHELABEL_PARAM2_DESC: "چیک کرنے کے لیے ٹیگ",
  T_37_WZY_WS_CHELABELRES: "ٹیگ چیک کا نتیجہ۔ یہ ایک بولین ویلیو ہے۔",
  T_37_WZY_WS_CJERSEY_NAME: "جرسی تبدیل کریں",
  T_37_WZY_WS_CJERSEY_PARAM1_DESC: "وہ کھلاڑی جس کی جرسی تبدیل کی جائے",
  T_37_WZY_WS_CJERSEY_PARAM2: "جرسی ڈیزائن",
  T_37_WZY_WS_CJERSEY_PARAM2_DESC: "ڈیزائن جس میں تبدیلی کرنی ہے",
  T_37_WZY_WS_CJERSEY_PARAM3_DESC: "جرسی پر حصہ 1 کا رنگ",
  T_37_WZY_WS_CJERSEY_PARAM4_DESC: "جرسی پر حصہ 2 کا رنگ",
  T_37_WZY_WS_CJERSEY_PARAM5_DESC: "جرسی پر حصہ 3 کا رنگ",
  T_37_WZY_WS_CJERSEYTYPE1: "ڈیزائن 1",
  T_37_WZY_WS_CJERSEYTYPE2: "ڈیزائن 2",
  T_37_WZY_WS_CJERSEYTYPE3: "ڈیزائن 3",
  T_37_WZY_WS_CLEAR_ARR_DESC: "لسٹ میں موجود تمام ایلیمینٹس کو صاف کریں",
  T_37_WZY_WS_CREABLEOB_DESC: "آبجیکٹ کی قسم جو بلاکس کا استعمال کرتے ہوئے بنائی جا سکتی ہے",
  T_37_WZY_WS_CREPROD_NAMEDESC: "ایک حسب ضرورت مرچنڈائز بنائیں اورمرچنڈائز کی ایک اینٹیٹی واپس کریں۔ مرچنڈائز مواد کو پراپرٹی سیٹنگ کے ذریعے تشکیل کیا جا سکتا ہے۔",
  T_37_WZY_WS_CRESHELVES_NAMEDESC: "ایک حسب ضرورت مرچنڈائز لسٹ بنائیں اور مرچنڈائز لسٹ کی اینٹیٹی واپس کریں۔ اس لسٹ کے مواد کو پراپرٹی کی سیٹنگز کے ذریعے تبدیل کیا جا سکتا ہے۔",
  T_37_WZY_WS_CRESHELVES_PARAM1_DESC: "مرچنڈائز لسٹ کی اینٹیٹی جو بنائی جانی ہے",
  T_37_WZY_WS_CRESIDE_NAMEDESC: "ایک فیکشن اینٹیٹی بنائیں",
  T_37_WZY_WS_CRESIDE_PARAM1_DESC: "فیکشن اینٹیٹی بنائی جائے گی",
  T_37_WZY_WS_CRESTORE_NAMEDESC: "ایک حسب ضرورت اسٹور بنائیں اور اسٹور اینٹیٹی واپس کریں۔ اسٹور کے مواد کو پراپرٹی سیٹنگز کے ذریعے تبدیل کیا جا سکتا ہے۔",
  T_37_WZY_WS_CRESTORE_PARAM2_DESC: "اسٹور اینٹیٹی بنائی گئی",
  T_37_WZY_WS_CSKYBOX_NAMEDESC: "گیم میں اسکائی کے ماحول کو تبدیل کریں۔ آپشنز میں دن، شام اور رات شامل ہیں۔",
  T_37_WZY_WS_CSKYBOX_PARAM1_DESC: "اسکائی کی اقسام جن میں تبدیل کیا جا سکتا ہے۔ آپشنز میں دن، شام اور رات شامل ہیں۔",
  T_37_WZY_WS_DARKNESS: "مجموعی طور پر اندھیرا",
  T_37_WZY_WS_DELENT_NAMEDESC: "ایک نامزد اینٹیٹی کو ڈیلیٹ کریں۔ فی الحال آئیکن اینٹیٹی، ٹیکسٹ اینٹیٹی، HUD اینٹیٹی، ویژولز ایفیکٹس اینٹیٹی، ہتھیار اینٹیٹی، اور دیگر آبجیکٹ اینٹیٹییز کو سپورٹ کرتا ہے۔",
  T_37_WZY_WS_DELENT_PARAM1_DESC: "حذف کرنے والا اینٹیٹی",
  T_37_WZY_WS_DROP: "غلطی",
  T_37_WZY_WS_DROPITEMS_NAMEDESC: "جب کھلاڑی کسی آئٹم کو گراتا ہے تو ٹرگر ہوتا ہے۔ [آئٹم کی قسم] گرائے گئے آئٹم کی قسم کی ID ہے۔",
  T_37_WZY_WS_DROPITEMS_PARAM1_DESC: "گرائی گئی آئٹم کی قسم ID",
  T_37_WZY_WS_DROPWEAP_NAMEDESC: "اس وقت ٹرگر ہوتا ہے جب کھلاڑی ہتھیار گراتا ہے۔ [ہتھیار اینٹیٹی] وہ ہتھیار ہے جسے گرایا جا رہا ہے۔",
  T_37_WZY_WS_DROPWEAP_PARAM1_DESC: "وہ ہتھیار جو گرایا جاتا ہے",
  T_37_WZY_WS_DUMMYLEOBJ: "باقاعدہ اسٹیج آبجیکٹ",
  T_37_WZY_WS_DUST: "شام",
  T_37_WZY_WS_EMPTYCH: "ڈیفالٹ خالی چینل",
  T_37_WZY_WS_EMPTYCH1: "خالی چینل 1",
  T_37_WZY_WS_EMPTYCH2: "خالی چینل 2",
  T_37_WZY_WS_EMPTYCH3: "خالی چینل 3",
  T_37_WZY_WS_EMPTYCH4: "خالی چینل 4",
  T_37_WZY_WS_EMPTYCH5: "خالی چینل 5",
  T_37_WZY_WS_EMPTYCH6: "خالی چینل 6",
  T_37_WZY_WS_ENTFILTER_NAMEDESC: 'ایک لسٹ حاصل کریں جس میں موجود تمام اینٹیٹییاں 3 شرائط کو پورا کرتی ہوں۔ "سب کچھ جو شامل ہے"، "کیا شامل نہیں"، اور "شامل ہے" کیلئے داخل کردہ مواد ایک جزو کی قسم یا اجزاء کی اقسام کی لسٹ ہے۔ واپس آنے والا نتیجہ ان اینٹیٹییوں کی لسٹ ہے جو شرائط کو پورا کرتی ہیں۔',
  T_37_WZY_WS_ENTFILTER_PARAM1_DESC: "فلٹر کی گئی اینٹیٹیز میں اس آرے کے تمام اجزاء شامل ہونے چاہئیں",
  T_37_WZY_WS_ENTFILTER_PARAM2_DESC: "فلٹر کی گئی اینٹیٹیوں میں اس آرے سے مخصوص حصہ (حصے) نہیں ہونے چاہئیں",
  T_37_WZY_WS_ENTFILTER_PARAM3_DESC: "فلٹر کی گئیں اینٹیٹیوں میں اس آرے سے کم از کم ایک حصہ ہونا چاہیے",
  T_37_WZY_WS_ENTITY2_PARAM3_DESC: "اس اینٹیٹی کی پراپرٹی کی قسم کو تبدیل کرنا ہے",
  T_37_WZY_WS_ENTITY2_PARAM4_DESC: "پراپرٹی کی ویلیو تبدیل کرنے کے لئے",
  T_37_WZY_WS_EXITCHAN_NAMEDESC: "کھلاڑی کو موجودہ چینل چھوڑنے دیں تاکہ وہ کسی چینل میں نہ رہیں",
  T_37_WZY_WS_EXITCHAN_PARAM1_DESC: "چینل چھوڑنے والا کھلاڑی",
  T_37_WZY_WS_FAKEENT: "بھیس اینٹیٹی",
  T_37_WZY_WS_FIND_STR_DESC: "ایک سٹرنگ کے اندر ایک نامزد ٹیکسٹ کا مقام تلاش کریں",
  T_37_WZY_WS_FINDSTR_PARAM1DESC: "کون سا کردار تلاش کرنا ہے",
  T_37_WZY_WS_FINDSTR_PARAM2DESC: "ابتدائی مقام سے ایک اسٹرنگ تلاش کریں، جو 0 سے شروع ہوتی ہے",
  T_37_WZY_WS_FINDSTRRES: "پہلی جگہ جہاں اسٹرنگ ظاہر ہوتی ہے۔ 0 سے شروع ہوتی ہے۔",
  T_37_WZY_WS_FOGCOLOR: "دھند کا رنگ",
  T_37_WZY_WS_FRICTIONCON: "ریگولر رگڑ ضرب",
  T_37_WZY_WS_FRICTIONIMP: "تصادم رگڑ ضرب",
  T_37_WZY_WS_FROMDEATH: "ریوائیول",
  T_37_WZY_WS_FROMKNODOWN: "مدد کریں",
  T_37_WZY_WS_GETCHAN_NAMEDESC: "وہ چینل حاصل کریں جس میں نامزد کھلاڑی موجود ہے",
  T_37_WZY_WS_GETCHAN_PARAM1_DESC: "کھلاڑی کی اینٹیٹی جس کا چینل حاصل کرنا ہے",
  T_37_WZY_WS_GETCHANRES: "وہ چینل جس میں کھلاڑی اس وقت ہے",
  T_37_WZY_WS_GETEMPTYCH_NAMEDES: "چینل ID 1 سے 8 کے مطابق، وہ خالی چینل حاصل کریں جو گیم کے شروع میں بطور ڈیفالٹ بنایا گیا تھا۔",
  T_37_WZY_WS_GETEMPTYCH_PARAM1_DESC: "ڈیفالٹ خالی چینل کی ID",
  T_37_WZY_WS_GETEMPTYCH_RES: "حاصل کردہ چینل اینٹیٹی",
  T_37_WZY_WS_GETFAKEENT_NAMEDESC: "کسی کھلاڑی کی بھیس اینٹیٹی حاصل کریں",
  T_37_WZY_WS_GETFAKEENT_PARAM1_DESC: "وہ چیز جس کی بھیس اینٹیٹی حاصل کرنی ہے",
  T_37_WZY_WS_GETGAMEENT_NAME: "میچ اینٹیٹی حاصل کریں",
  T_37_WZY_WS_GETGAMEENT_NAMEDESC: "اس میچ کی گیم اینٹیٹی حاصل کریں",
  T_37_WZY_WS_GETHOSTPLA_NAME: "حملہ آور کھلاڑی حاصل کریں",
  T_37_WZY_WS_GETHOSTSIDE_PARAM1: "فیکشن اینٹیٹی",
  T_37_WZY_WS_GOAL_NAMEDESC: "جب فٹ بال گول میں داخل ہوتا ہے تو ٹرگر ہوتا ہے۔ [گول] وہ گول ہے جس میں یہ فٹ بال داخل ہوتا ہے۔ [اسکورر] وہ آخری کھلاڑی ہے جو بال کے ساتھ رابطے میں آیا ہے۔ [مدد کرنے والا] آخری سے پچھلا کھلاڑی ہے جو بال کے ساتھ رابطے میں آیا ہے۔",
  T_37_WZY_WS_GOAL_PARAM1_DESC: "یہ فٹ بال جس گول میں داخل ہوتا ہے",
  T_37_WZY_WS_GOAL_PARAM2_DESC: "بال کے ساتھ رابطے میں آنے والا آخری کھلاڑی",
  T_37_WZY_WS_GOAL_PARAM3_DESC: "بال کے ساتھ رابطے میں آنے والا آخری سے پچھلا کھلاڑی",
  T_37_WZY_WS_HEARTBEAT: "ہارٹ بیٹ",
  T_37_WZY_WS_HEAVYWEAPON: "بھاری ہتھیار",
  T_37_WZY_WS_HIHGSHOOTANGLE: "سب سے چھوٹا والی اینگل",
  T_37_WZY_WS_HOSTPLA: "حملہ آور کھلاڑیوں کی لسٹ",
  T_37_WZY_WS_HOSTSIDE: "حملہ آور گروہوں کی فہرست",
  T_37_WZY_WS_HOSTTEAM: "حملہ آور ٹیموں کی لسٹ",
  T_37_WZY_WS_ICON_CLOCK: "کاؤنٹ ڈاؤن",
  T_37_WZY_WS_ICON_CLOTHES: "کپڑے",
  T_37_WZY_WS_ICON_QUIT: "باہر نکلیں",
  T_37_WZY_WS_INSERT_ARR_DESC: "لسٹ میں ایک مخصوص جگہ پر ایک نیا ایلیمینٹ داخل کریں",
  T_37_WZY_WS_INTERCEPT_STR_DESC: "انڈیکس کے مقام سے شروع کرتے ہوئے، ایک مقررہ لمبائی کی ایک سٹرنگ نکالیں۔ اگر نکالنے کی لمبائی سٹرنگ کی لمبائی سے زیادہ ہے، تو یہ سٹرنگ کے اختتام تک مواد کو نکالے گا۔",
  T_37_WZY_WS_INTERCEPTSTR_PARAM1DESC: "نکالنے کی لمبائی",
  T_37_WZY_WS_INTERCEPTSTRRES_DESC: "وہ اسٹرنگ جو نکالی گئی",
  T_37_WZY_WS_INTORINTL: "انٹیجر یا انٹیجر لسٹ",
  T_37_WZY_WS_JOINSIDE_NAMEDESC: "کسی کھلاڑی کو نامزد فیکشن میں شامل ہونے دیں",
  T_37_WZY_WS_JOINSIDE_PARAM2_DESC: "کھلاڑی کے شامل ہونے کے لیے گروہ",
  T_37_WZY_WS_JUMP: "چھلانگ لگائیں",
  T_37_WZY_WS_LABEL: "ٹیگ",
  T_37_WZY_WS_LENSFLARE: "لینس فلیئر",
  T_37_WZY_WS_LENTH: "لمبائی",
  T_37_WZY_WS_LIGHTATTACK: "کامیاب ہٹ",
  T_37_WZY_WS_LIGHTCOLOR: "لائٹ سورس کلر",
  T_37_WZY_WS_LIGHTINTENSITY: "لائٹ سورس بڑائٹنیس",
  T_37_WZY_WS_LOADSCENE_NAMEDESC: "ایک نئی سینری لوڈ کریں",
  T_37_WZY_WS_LOADSCENE_PARAM1_DESC: "لوڈ کرنے کے لیے سینری کا نام",
  T_37_WZY_WS_MOROBJECT: "بھیس آبجیکٹ",
  T_37_WZY_WS_MOVEAXISX: "x محور کے ساتھ حرکت کریں",
  T_37_WZY_WS_MOVEAXISY: "y محور کے ساتھ حرکت کریں",
  T_37_WZY_WS_MOVEAXISZ: "z محور کے ساتھ حرکت کریں",
  T_37_WZY_WS_MOVEDISTITLE: "نقل و حرکت کا فاصلہ",
  T_37_WZY_WS_MUTEQUICKCHAT_NAME: "فوری میسجز آن-آف ٹوگل",
  T_37_WZY_WS_MUTEQUICKCHAT_NAMEDESC: "فوری میسجز کو آن یا آف کریں۔ آف ہونے پر، فوری میسج HUD استعمال نہیں کیا جا سکتا ہے اور کھلاڑی فوری میسجز بھیج یا وصول نہیں کر سکیں گے۔",
  T_37_WZY_WS_MUTEQUICKCHAT_PARAM1_DESC: "فوری میسجز کو آن/آف کرنے والا کھلاڑی",
  T_37_WZY_WS_MUTEVOICE_NAME: "وائس چیٹ آن-آف ٹوگل",
  T_37_WZY_WS_MUTEVOICE_NAMEDESC: "وائس چیٹ کو آن یا آف کریں۔ آف ہونے پر، وائس HUD استعمال نہیں کیا جا سکتا اور کھلاڑی صوتی میسجز بھیج یا وصول نہیں کر سکیں گے۔",
  T_37_WZY_WS_MUTEVOICE_PARAM1_DESC: "وائس چیٹ کو آن/آف کرنے والا کھلاڑی",
  T_37_WZY_WS_MUTEVOICE_PARAM2_DESC: "بولین۔ ٹرو کا مطلب آف; فالز کا مطلب آن ہے۔",
  T_37_WZY_WS_NIGHTMODE: "نائٹ موڈ",
  T_37_WZY_WS_ONAIM_NAMEDESC: "اس وقت ٹرگر ہوتا ہے جب کھلاڑی کسی نشانے کے قابل اینٹیٹی کو نشانہ بنا رہا ہو۔ [ٹارگٹ اینٹیٹی] وہ اینٹیٹی ہے جس کا نشانہ بنانا ہے۔ جب کوئی اینٹیٹی نہ ہو، تو واپسی کی ویلیو خالی ہو جاتی ہے۔",
  T_37_WZY_WS_ONAIM_PARAM1_NAME: "نشانے پر اینٹیٹی",
  T_37_WZY_WS_ONHIT_PARAM1_DESC: "وہ اینٹیٹی جسے ہتھیار نے ہٹ کیا ہے",
  T_37_WZY_WS_ONSCENELOADING_NAMEDESC: "جب سینری کامیابی کے ساتھ لوڈ ہو جاتی ہیں تو ٹرگر ہوتا ہے",
  T_37_WZY_WS_ONSCENELOADING_PARAM1_DESC: "لوڈ کرنے کے لیے سینری کا نام۔ یہ ایک سٹرنگ ہے۔",
  T_37_WZY_WS_ONSCENESWITCH_NAMEDESC: "اس وقت ٹرگر ہوتا ہے جب سینری کامیابی کے ساتھ سوئچ ہو جاتی ہے",
  T_37_WZY_WS_ONSCENESWITCH_PARAM1_DESC: "نئی سینری کا نام۔ یہ ایک سٹرنگ ہے۔",
  T_37_WZY_WS_OUTJERSEY_NAMEDESC: "کھلاڑی کے لباس کو اس کی ڈیفالٹ شکل میں واپس لائیں",
  T_37_WZY_WS_OUTJERSEY_PARAM1_DESC: "وہ کھلاڑی جس کا ڈیفالٹ لباس بحال کرنا ہے",
  T_37_WZY_WS_PETSET: "پٹ سیٹنگ",
  T_37_WZY_WS_PETSKILL: "پٹ کی مہارتیں",
  T_37_WZY_WS_PETSWITCH2: "آیا پٹ کی مہارتوں کو استعمال کیا جا سکتا ہے",
  T_37_WZY_WS_PLAMOVE_PARAM2_DESC: "آیا کھلاڑی کی نقل و حرکت کو فعال کرنا ہے۔ یہ ایک بولین ویلیو ہے۔",
  T_37_WZY_WS_PLAYERBEHAVIOR: "کھلاڑی کے رویے کی قسم",
  T_37_WZY_WS_PRESS: "آرام سے کلک کریں",
  T_37_WZY_WS_PROGRESS: "موجودہ پیشرفت",
  T_37_WZY_WS_PROGRESSBAR: "HUD اینٹیٹی کی پیشرفت",
  T_37_WZY_WS_RANKDOWN: "درجہ گرنا",
  T_37_WZY_WS_REMLABEL_NAMEDESC: "منتخب کردہ اینٹیٹی کے لیے ایک ٹیگ ہٹا دیں",
  T_37_WZY_WS_REMLABEL_PARAM1_DESC: "ٹیکسٹ مواد جسے ہٹانا ہے",
  T_37_WZY_WS_REPLACE_STR_DESC: "سٹرنگ کے مواد کو نامزد مواد سے تبدیل کریں",
  T_37_WZY_WS_REPLACESTR_PARAM1DESC: "بدلنے والا کردار",
  T_37_WZY_WS_REPLACESTR_PARAM2DESC: "نیا کردار جس کے ساتھ بدلنا ہے",
  T_37_WZY_WS_REVERSE_ARR_DESC: "اس لسٹ کے تمام ایلیمینٹس کو ریورس کریں",
  T_37_WZY_WS_REVIVEHERE: "وہ کھلاڑی جو اس بحالی پوائنٹ پر ساتھی ساتھیوں کو زندہ کر رہا ہے",
  T_37_WZY_WS_REVIVEHERE_NAMEDESC: "اس وقت ٹرگر ہوتا ہے جب کوئی کھلاڑی اس بحالی کے مقام پر ٹیم کے ساتھیوں کو زندہ کر رہا ہوتا ہے",
  T_37_WZY_WS_REVIVEWAYDESC: "وہ طریقہ جس کے ذریعے کسی کھلاڑی کو زندہ کیا جاتا ہے یا اسے ختم یا گرائے جانے سے مدد ملتی ہے",
  T_37_WZY_WS_SATBEHAVIOR_NAMEDESC: "کھلاڑیوں کے لیے مختلف طرز عمل کی حیثیت کو ترتیب دیں۔ غیر فعال ہونے پر، HUD پر متعلقہ بٹن استعمال نہیں کیے جا سکتے، اور دستی اور خودکار نقل و حرکت کی اجازت نہیں ہے۔ چھپنے پر، متعلقہ بٹن HUD پر ظاہر نہیں ہوں گے، اور دستی نقل و حرکت کی اجازت نہیں ہے جبکہ خودکار نقل و حرکت کی اجازت ہے۔ فعال ہونے پر، متعلقہ بٹن HUD پر ظاہر ہوں گے، اور دستی اور خودکار نقل و حرکت کی اجازت ہے۔",
  T_37_WZY_WS_SATBEHAVIOR_PARAM1_DESC: "وہ کھلاڑی جس کے لیے رویے کا سٹیٹس سیٹ کیا جائے",
  T_37_WZY_WS_SATBEHAVIOR_PARAM2_DESC: "کھلاڑی کا رویہ جس میں حرکت کرنا، حملہ کرنا، چھلانگ لگانا اور دوڑنا شامل ہیں۔",
  T_37_WZY_WS_SATBEHAVIOR_PARAM3_DESC: "اسٹیٹس میں غیر فعال، پوشیدہ اور فعال شامل ہیں۔ چھپنے پر، متعلقہ بٹن HUD پر ڈسپلے نہیں ہوں گے، اور دستی حرکت کی اجازت نہیں ہے جبکہ خودکار نقل و حرکت کی اجازت ہے۔ فعال ہونے پر، متعلقہ بٹن HUD پر ڈسپلے ہوں گے، اور دستی اور خودکار نقل و حرکت کی اجازت ہے۔",
  T_37_WZY_WS_SETBALL_PARAM2_DESC: "فٹ بال کے کوآرڈینیٹس",
  T_37_WZY_WS_SETBALL_PARAM3_DESC: "کیا فٹ بال کو اپنی پری کنفیگریشن کی رفتار کو برقرار رکھنا چاہیے۔ یہ ایک بولین ویلیو ہے۔",
  T_37_WZY_WS_SETPLAHOST_NAME: "پلیئر اٹیک سیٹنگ",
  T_37_WZY_WS_SETPLAHOST_NAMEDESC: "کنفیگر کریں کہ کیا [سیٹنگ کھلاڑی] [ٹارگٹ کھلاڑی] پر حملہ کر سکتا ہے۔ پہلے سے طے شدہ سیٹنگ اس بات پر مبنی ہوتی ہے کہ کیا ٹارگٹ کھلاڑی کسی ٹیم اور گروہ سے تعلق رکھتا ہے جس پر حملہ کیا جا سکتا ہے۔ یہ سیٹنگ ٹیم/ گروہ کی سیٹنگ سے زیادہ ترجیحی ہے۔",
  T_37_WZY_WS_SETPLAHOST_PARAM1_DESC: "دشمنوں کو کنفیگر کرنے والا کھلاڑی",
  T_37_WZY_WS_SETPLAHOST_PARAM2_DESC: "وہ کھلاڑی جو دشمن ہے",
  T_37_WZY_WS_SETPLAHOST_PARAM3: "قابل حملہ ہے یا نہیں",
  T_37_WZY_WS_SETPLAHOST_PARAM3_DESC: '"جی ہاں" مطلب حملہ کیا جا سکتا ہے "نہیں" مطلب حملہ نہیں کیا جا سکتا ہے۔ پہلے سے طے شدہ سیٹنگ اس بات پر مبنی ہوتی ہے کہ آیا ہدف کا کھلاڑی کسی ٹیم اور گروہ سے تعلق رکھتا ہے جس پر حملہ کیا جا سکتا ہے۔',
  T_37_WZY_WS_SETSIDEHOST_PARAM3_DESC: `"جی ہاں" مطلب حملہ کیا جا سکتا ہے
"نہیں" مطلب حملہ نہیں کیا جا سکتا ہے`,
  T_37_WZY_WS_SHADOWSTRENGTH: "سائے",
  T_37_WZY_WS_SHOOTANGLE: "شوٹنگ کا سب سے چھوٹا اینگل",
  T_37_WZY_WS_SKYBOX: "اسکائی",
  T_37_WZY_WS_SKYBOXENT: "سکائی اینٹیٹی",
  T_37_WZY_WS_SKYBOXTYPE: "اسکائی کی بنیادی اقسام",
  T_37_WZY_WS_STEPPED: "ٹرگر پر قدم رکھیں",
  T_37_WZY_WS_SWCHAN_NAMEDESC: "پلیئر کا وائس چیٹ چینل تبدیل کریں",
  T_37_WZY_WS_SWCHAN_PARAM1_DESC: "وہ کھلاڑی جس کے لیے چینلز کو سوئچ کرنا ہے",
  T_37_WZY_WS_SWCHAN_PARAM2_DESC: "جس چینل پر سوئچ کرنا ہے",
  T_37_WZY_WS_SWITCHSCENE_NAMEDESC: "ایک نامزد سینری پر سوئچ کریں",
  T_37_WZY_WS_SWITCHSCENE_PARAM1_DESC: "سینری کا نام جس پر سوئچ کرنا ہے",
  T_37_WZY_WS_TARGETSTR_DESC: "ٹارگٹ سٹرنگ",
  T_37_WZY_WS_TEAMASIDE: "ٹیم اور گروہ",
  T_37_WZY_WS_TELEPORTN_AUTO: "خودکار",
  T_37_WZY_WS_TELEPORTN_AVAILABLE: "ٹیلی پورٹ ایبل ہے یا نہیں",
  T_37_WZY_WS_TELEPORTN_MANUAL: "دستی",
  T_37_WZY_WS_TELEPORTN_NO: "نہیں",
  T_37_WZY_WS_TELEPORTN_TITLE: "ٹیلی پورٹ کا طریقہ",
  T_37_WZY_WS_TELEPORTN_YES: "جی ہاں",
  T_37_WZY_WS_TERRAINWET: "زمین کی نمی",
  T_37_WZY_WS_TRANSFORM_NAMEDESC: "[کھلاڑی اینٹیٹی] کی ظاہری شکل کو [سینری آبجیکٹ] کی ظاہری شکل کے ساتھ بدل دیں",
  T_37_WZY_WS_TRANSFORM_PARAM1_DESC: "کھلاڑی کی ایٹیٹی جس کی شکل بدلنی ہو",
  T_37_WZY_WS_TRANSFORM_PARAM2_DESC: "وہ کھلاڑی جس کی بھیس اینٹیٹی حاصل کی جائے",
  T_37_WZY_WS_TRANSP: "شفافیت",
  T_37_WZY_WS_UNLOADSCENE_NAMEDESC: "ایک نامزد سینری کو ان انسٹال کریں",
  T_37_WZY_WS_UNLOADSCENE_PARAM1_DESC: "ان انسٹال کرنے کے لیے سینری کا نام",
  T_37_WZY_WS_VFX1: "علامتی",
  T_37_WZY_WS_VFX2: "سموکی",
  T_37_WZY_WS_VFX3: "لعنتی دھماکہ خیز",
  T_37_WZY_WS_VFX5: "جما هوا",
  T_37_WZY_WS_VFX6: "اسپاٹ لائٹ",
  T_37_WZY_WS_VFX7: "اوپر کی طرف ہنگامہ خیزی",
  T_37_WZY_WS_VFX8: "ماحول میں دھماکہ",
  T_37_WZY_WS_VISABLE: "ظاہر ہونا",
  T_37_WZY_WS_WEAOPEN: "دکھائیں یا نہیں",
  T_37_WZY_WS_WEAPONENT: "ہتھیار اینٹیٹی",
  T_37_WZY_WS_WEATARGETED: "کیا نشانے میں مدد سے ہدف بنانا ممکن ہے یا نہیں؟",
  T_37_XYL_CUSTOMJERSEY: "جرسی مشین",
  T_37_XYL_CUSTOMJERSEY_DESC: "اپنی مثالی جرسی بنانے کے لیے جرسی مشین کا استعمال کریں",
  T_37_XYL_FOOTGUN: "فٹ بال شوٹر",
  T_37_XYL_SOCCER: "فٹ بال",
  "T_37_XYL_SOCCER_ RADIUS": "ریڈیس",
  T_37_XYL_SOCCER_DESC: "ایک فٹ بال جس کی خصوصیات کو اپنی مرضی کے مطابق بنایا جا سکتا ہے",
  T_37_XYL_SOCCER_HIGHT1: "ریگولراینگل",
  T_37_XYL_SOCCER_HIGHT2: "والی اینگل",
  T_37_XYL_SOCCER_RESET: "ایک گول کے بعد ری سیٹ ٹائم",
  T_37_XYL_SOCCER_RESIST1: "رگڑ (کک موڈ)",
  T_37_XYL_SOCCER_RESIST2: "فرکشن (گن موڈ)",
  T_37_XYL_SOCCERGOAL: "گول",
  T_37_XYL_SOCCERGOAL_DESC: "یہ گول ہے۔ گول کرنے کے لیے فٹ بال کو شوٹ کریں۔ (صرف پوائنٹس حاصل کرنے میں درست ہے۔)",
  T_37_XYL_SOCCERITEM: "آئٹم سپان",
  T_37_XYL_SOCCERITEM_DESC: "رکھے جانے پر، یہ منتخب کردہ آئٹم تیار کرے گا",
  T_37_XYL_SPAWN_PEOPLE: "کھلاڑیوں کی تعداد",
  T_37_XYL_WS_AIRCONDITIONER001: "ایئر کنڈیشنر B",
  T_37_XYL_WS_AMMUCHEST: "وار چیسٹ A",
  T_37_XYL_WS_BAFFLE001: "بیریئر A",
  T_37_XYL_WS_BARREL001: "بیرلز",
  T_37_XYL_WS_BARREL001_DES: "عام طور پر سرکلر لکڑی کے بیرل دیکھے جاتے ہیں۔",
  T_37_XYL_WS_BOARD001: "Ad بورڈ B",
  T_37_XYL_WS_BOOK001: "کتابوں کا ڈھیر A",
  T_37_XYL_WS_BOOK002: "بورڈ گیم A",
  T_37_XYL_WS_BOUGAINVILLEA: "بوگین ویلا",
  T_37_XYL_WS_BOUGAINVILLEA_DES: "سجاوٹ: جگہ کو روشن کریں!",
  T_37_XYL_WS_BOX001: "A باکسز کا ڈھیر",
  T_37_XYL_WS_BOX002: "چھوٹا باکس",
  T_37_XYL_WS_BUSHCOVER: "جهاڑی",
  T_37_XYL_WS_BUSHCOVER_DES: "ایک جھاڑی جسے چھپنے کے لیے استعمال کیا جا سکتا ہے۔",
  T_37_XYL_WS_CABINET001: "ڈرارز A",
  T_37_XYL_WS_CHAIR001: "کرسی A",
  T_37_XYL_WS_COCONUTTREE: "ناریل کا درخت",
  T_37_XYL_WS_COCONUTTREE_DES: "سجاوٹ - ساحل سمندر کے ماحول کے لئے!",
  T_37_XYL_WS_COMPUTER001: "کمپیوٹر A",
  T_37_XYL_WS_DAMAGERATIO: "نقصان کا تناسب",
  T_37_XYL_WS_FIREEX: "اگ بجھانے کا الہ",
  T_37_XYL_WS_GUIDEPOSE: "ڈائریکشن پوسٹ",
  T_37_XYL_WS_HUGEHOUSE001: "3 منزلہ مکان B",
  T_37_XYL_WS_HUGEHOUSE002: "2 منزلہ مکان B",
  T_37_XYL_WS_JACKSTRAW: "سکیئرکرو",
  T_37_XYL_WS_LADDER001: "سیڑھی A",
  T_37_XYL_WS_OILDRUM: "جیری کین",
  T_37_XYL_WS_ORNAMENT001: "گلدان A",
  T_37_XYL_WS_PACKBOX: "سپلائی کنٹینر",
  T_37_XYL_WS_PILLA001: "کنکریٹ کا ستون",
  T_37_XYL_WS_PRESENT: "گفٹ باکس",
  T_37_XYL_WS_PRESENT_DES: "چھٹیوں کے تحائف پر مشتمل ہے",
  T_37_XYL_WS_PUMPKIN: "اسکوائر جیک او - لالٹین",
  T_37_XYL_WS_PUMPKINCUT: "جیک او لالٹین",
  T_37_XYL_WS_PUMPKINCUT_DES: "ایک خوفناک تہوار کے لیے عام سجاوٹ",
  T_37_XYL_WS_ROADBLOCK001: "روڈ بلاک B",
  T_37_XYL_WS_SHELF001: "بک شیلف A",
  T_37_XYL_WS_SOFA001: "صوفہ A",
  T_37_XYL_WS_SPAWNTEAM: "تمام ٹیمز",
  T_37_XYL_WS_SUPPLYBOX: "بارود کریٹ",
  T_37_XYL_WS_TABLE001: "ٹیبل A",
  T_37_XYL_WS_TABLE002: "ٹیبل B",
  T_37_XYL_WS_TARGET001: "ٹارگٹ",
  T_37_XYL_WS_TEAMID_1: "1",
  T_37_XYL_WS_TEAMID_10: "10",
  T_37_XYL_WS_TEAMID_11: "11",
  T_37_XYL_WS_TEAMID_12: "12",
  T_37_XYL_WS_TEAMID_2: "2",
  T_37_XYL_WS_TEAMID_3: "3",
  T_37_XYL_WS_TEAMID_4: "4",
  T_37_XYL_WS_TEAMID_5: "5",
  T_37_XYL_WS_TEAMID_6: "6",
  T_37_XYL_WS_TEAMID_7: "7",
  T_37_XYL_WS_TEAMID_8: "8",
  T_37_XYL_WS_TEAMID_9: "9",
  T_37_XYL_WS_TELEPORTEND: "پورٹل فنش پوائنٹ",
  T_37_XYL_WS_TELEPORTNEW: "پورٹل A",
  T_37_XYL_WS_TELEPORTNEW_DESC: "ایک پورٹل جو کھلاڑی کو پورٹل کے فنشنگ پوائنٹ پر ٹیلی پورٹ کر سکتا ہے",
  T_37_XYL_WS_TIRES001: "ٹائر A",
  T_37_XYL_WS_TOOLRACK: "ٹول شیلف",
  T_37_XYL_WS_WALL001: "وال",
  T_37_XYL_WS_WOOD001: "کٹی ہوئی لکڑی",
  T_37_XYL_WS_YELLOWDUCK001: "ڈکی فلوٹ",
  T_37_XYL_WS_YELLOWDUCK001_DES: "بطخ کی شکل میں ایک فلایا ہوا تیراکی کا رنگ",
  T_37_YM_BOMBSQUAD_DEFUSER: "ڈیفیوزر",
  T_37_YS_B_BRFOOTBALL_WHITE: "CBF وائٹ جرسی (باٹم)",
  T_37_YS_F_B_VN_STREET: "کرمسن آسپیشن (باٹم)",
  T_37_YS_F_H_VN_STREET: "کرمسن آسپیشن (ہیڈ)",
  T_37_YS_F_S_VN_STREET: "کرمسن آسپیشن (جوتے)",
  T_37_YS_F_T_VN_STREET: "کرمسن آسپیشن (ٹاپ)",
  T_37_YS_M_A_CRICKET_BLACK: "بمبلبی کرکٹر (ماسک)",
  T_37_YS_M_A_THKOL: "بلیز بینش (ماسک)",
  T_37_YS_M_B_CRICKET_BLACK: "بمبلبی کرکٹر (باٹم)",
  T_37_YS_M_B_SILVERERA: "فیئرلیس گرے گارڈ (باٹم)",
  T_37_YS_M_B_THKOL: "بلیز بینش (باٹم)",
  T_37_YS_M_H_SILVERERA: "فیئرلیس گرے گارڈ (ہیڈ)",
  T_37_YS_M_H_THKOL: "بلیز بینش (ہیڈ)",
  T_37_YS_M_S_CRICKET_BLACK: "بمبلبی کرکٹر (جوتے)",
  T_37_YS_M_S_SILVERERA: "فیئرلیس گرے گارڈ (جوتے)",
  T_37_YS_M_S_THKOL: "بلیز بینش (جوتے)",
  T_37_YS_M_T_CRICKET_BLACK: "بمبلبی کرکٹر (ٹاپ)",
  T_37_YS_M_T_SILVERERA: "فیئرلیس گرے گارڈ (ٹاپ)",
  T_37_YS_M_T_THKOL: "بلیز بینش (ٹاپ)",
  T_37_YS_T_BRFOOTBALL_WHITE: "CBF وائٹ جرسی (ٹاپ)",
  T_37_ZF_ROOM_UGC_MINPLAYER: "کم سے کم کھلاڑی",
  T_38_BQ_SKILL_NAME_DUMMY1: "اسٹنٹ ڈبل",
  T_38_BQ_SKILL_NAME_DUMMY2: "شیپ سپلٹر",
  T_38_CJ_F_B_STREAMER_MUSIC: "ای-ہارٹ سیکر (باٹم)",
  T_38_CJ_F_H_STREAMER_MUSIC: "ای-ہارٹ سیکر (ہیڈ)",
  T_38_CJ_F_S_STREAMER_MUSIC: "ای-ہارٹ سیکر (جوتے)",
  T_38_CJ_F_T_STREAMER_MUSIC: "ای-ہارٹ سیکر (ٹاپ)",
  T_38_JH_WS_CM1: "واضح اصول",
  T_38_JH_WS_CM2: "غیر واضح اصول",
  T_38_JH_WS_CM3: "بار بار باہر نکلنا",
  T_38_JL_M79_AMMO_N: "M79 بارود",
  T_38_JMF_SKILLCHIP_NAME_SINGER: "J. Biebs کی مائیکرو چِپ",
  T_38_M_WS_VECTOR2: "2D ویکٹر",
  T_38_R_TACTICS_N: "پیش سیٹ",
  T_38_RW_NIW_NIWNAME: "گلو میکر",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CALLSTACKCOUNTMAX: "بلاکس کی بہت زیادہ لیئرز۔ موجودہ: {0}۔ زیادہ سے زیادہ: {1}۔",
  T_38_SP_WS_LOG_EXCEED_LIMIT_CREATEITEMCOUNTMAXPERMATCHKEY: "آپ کے بنائے ہوئے ({0}) آئٹمز کی تعداد حد ({1}) سے تجاوز کر گئی ہے۔",
  T_38_SP_WS_LOG_EXCEED_LIMIT_DISPATCHEVENTMAXCOUNTPERFRAME: "ایک ہی فریم ({0}) کے اندر موصول ہونے والے واقعات کی تعداد حد ({1}) سے تجاوز کر گئی ہے۔",
  T_38_SP_WS_LOG_EXCEED_LIMIT_ENTITIESCREATEDPERFRAMEMAX: "ایک ہی فریم ({0}) میں تخلیق اینٹیٹیز کی تعداد حد ({1}) سے تجاوز کر گئی ہے۔",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LISTINITLENGTHMAX: "ابتدائی فہرست کی لمبائی ({0}) حد ({1}) سے تجاوز کر گئی ہے۔",
  T_38_SP_WS_LOG_EXCEED_LIMIT_LOOPTIMESMAX: "لوپس کی تعداد ({0}) حد ({1}) سے تجاوز کر گئی ہے۔ لوپ میں خلل پیدا ہوا",
  T_38_SP_WS_LOG_EXCEED_LIMIT_PERSCOPECOROUTINECONCURRENCYMAX: "کوروٹین دائرہ کار میں ہم آہنگی کورٹینز ({0}) کی تعداد حد ({1}) سے تجاوز کر گئی ہے۔",
  T_38_SP_WS_LOG_LIST_APPEND_IS_NIL: "لسٹ میں ایلیمینٹ شامل کرنے میں ناکام۔ لسٹ {0} خالی ہے۔",
  T_38_SP_WS_LOG_VAR_ARITHMETIC_FAILED: "بنیادی ریاضی کے عمل کو انجام دیتے وقت غیر مماثل ویلیو کی اقسام۔ بائیں ویلیو کی قسم {0} ہے اور دائیں ویلیو کی قسم {1} ہے۔",
  T_38_SP_WS_LOG_VAR_REPEATED_DEF_IN_SCOPE: "دہرائی گئی عارضی ویرایبل کی تعریف۔ ویرایبل کا نام: {0}۔",
  T_38_SP_WS_REVIEW_01: "ٹاکسیک",
  T_38_SP_WS_REVIEW_02: "بیہودہ",
  T_38_SP_WS_REVIEW_03: "توہین آمیز",
  T_38_SP_WS_REVIEW_04: "انتہائی ٹاکسیک",
  T_38_SP_WS_REVIEW_05: "دھمکی",
  T_38_SP_WS_REVIEW_06: "بے ادب",
  T_38_SP_WS_REVIEW_07: "زیر جائزہ",
  T_38_SP_WS_REVIEW_08: "{0} نام {1} قواعد کی پیروی نہیں کرتا ہے۔ {2}۔",
  T_38_SP_WS_REVIEW_09: "اسٹرنگ",
  T_38_SP_WS_REVIEW_10: "اسٹور",
  T_38_SP_WS_REVIEW_11: "ویریایبل",
  T_38_SP_WS_REVIEW_12: "فنکشن",
  T_38_SP_WS_REVIEW_13: "آبجیکٹ",
  T_38_SP_WS_REVIEW_14: "تعریف پر جائیں۔",
  T_38_SP_WS_REVIEW_15: "آبجیکٹ کا نظم کریں پر جائیں۔",
  T_38_SP_WS_REVIEW_16: "کوئی ری ڈائریکشن نہیں۔",
  T_38_SP_WS_REVIEW_17: "نقشے کا نام",
  T_38_SP_WS_REVIEW_18: "تفصیل",
  T_38_SP_WS_REVIEW_19: "کور امیج",
  T_38_SP_WS_REVIEW_20: "ٹیکسٹ حساس الفاظ پر مشتمل ہے۔",
  T_38_SP_WS_REVIEW_21: "محفوظ کرنا ناکام ہو گیا۔ جائزہ لینے سے قاصر۔",
  T_38_SP_WS_REVIEW_22: "کولڈاؤن کے تحت جائزہ لیں۔",
  T_38_SY_BASEBALLBAT_KITCHEN_N: "میہم بیٹ",
  T_38_SY_CHARACTER_DESIGNER_N: "سینٹینو",
  T_38_SY_PET_CACTUS_N: "کیکٹس",
  T_38_SY_PETSKIN_CACTUS_BLACK_N: "پٹ اسکن: گھوسٹ کیکٹس",
  T_38_SY_PETSKIN_CACTUS_PINK_N: "پٹ اسکن: نیین کیکٹس",
  T_38_SY_PETSKIN_CACTUS_YELLOW_N: "پٹ اسکن: پام ڈریم کیکٹس",
  T_38_SY_PETSKIN_FLYINGCREATURE_ES_N: "پٹ اسکن: پارٹی آروان",
  T_38_SY_PETSKIN_RACCOON_MO_N: "پٹ اسکن: ٹرینڈی راکی",
  T_38_SY_SCAR_ELDERGODS_N: "اسکار- نائٹ فائر کامی",
  T_38_SY_SICKLE_ES_N: "پاپ پاؤ سکل",
  T_38_SY_VEHICLE_SUV_KITCHEN_N: "موچی فوڈ ٹرک",
  T_38_WT_WS_MUITLEVEL: "ملٹی لیول",
  T_38_WT_WS_SKILLSET15: "بیٹل کی سنسنی (A124)",
  T_38_WT_WS_SKILLSET16: "سینسز شاک ویو (ہومر)",
  T_38_WT_WS_SKILLSET17: "وال برال (آئرس)",
  T_38_WT_WS_SKILLSET18: "ریبل رش (تتسویا)",
  T_38_WZY_WS_ACTIVEA: "سینری میں قابل استعمال ہے یا نہیں",
  T_38_WZY_WS_ACTIVEB: "لاجک ریفریش آن کریں یا نہیں",
  T_38_WZY_WS_ACTIVEVALUE: "ایکٹیویٹی اسٹیٹس",
  T_38_WZY_WS_AIR: "ہوا",
  T_38_WZY_WS_ALLOWMOVE: "حرکت پذیر ہے یا نہیں",
  T_38_WZY_WS_AMMOAMOUNT: "بارود کی رقم",
  T_38_WZY_WS_AMMONAME: "بارود اینٹیٹی",
  T_38_WZY_WS_ARMOR_DAMRED: "نقصان میں کمی کا ملٹیپلائر",
  T_38_WZY_WS_ARMOR_DAMRED_EXP: "دھماکہ DMG کمی ملٹیپلائر",
  T_38_WZY_WS_ARMOR_DURABILITY: "موجودہ استحکام",
  T_38_WZY_WS_ARMOR_DURABILITYMAX: "زیادہ سے زیادہ استحکام",
  T_38_WZY_WS_ARMOR_ISDAMAGE: "نقصان دہ ہے یا نہیں",
  T_38_WZY_WS_ARMOR_ISDESTROY: "تباہ کن ہے یا نہیں",
  T_38_WZY_WS_ARMOR_LEVEL: "لیول",
  T_38_WZY_WS_ASSCONZOM: "زومبی کے خاتمے میں مدد۔",
  T_38_WZY_WS_BAGNAME: "بیک پیک اینٹیٹی",
  T_38_WZY_WS_BAGSPACEEX: "اضافی بیگ کی جگہ",
  T_38_WZY_WS_BRIDGING: "برج رینڈر کمپونینٹ",
  T_38_WZY_WS_BUBBLE: "ببل",
  T_38_WZY_WS_CLEARBAG_NAMEDESC: "[کھلاڑی کی اینٹیٹی کے] بیگ میں موجود تمام آئٹمز کو کلیئر کریں",
  T_38_WZY_WS_CLEARMAP_NAMEDESC: "نقشے کے ارد گرد پڑی ناپسندیدہ آئٹمز کو کلیئر کریں، جیسے لوٹ، تھرو ایبل باقیات، اور لوٹ بکسز",
  T_38_WZY_WS_CLEARPRO: "واحد پراپرٹی فیکٹر کو کلیئر کریں",
  T_38_WZY_WS_CLONEOBJ_NAMEDESC: "کسی [کھلاڑی کی اینٹیٹی] کے مقام پر ایک [سینری آبجیکٹ] اینٹیٹی کو کلون کریں اور [بھیس میں آنے والی اینٹیٹی] کو واپس کریں۔",
  T_38_WZY_WS_COMPONENT: "اجزاء کی قسم",
  T_38_WZY_WS_COSTAMMO: "بارود استعمال کریں یا نہ کریں",
  T_38_WZY_WS_CRECREMA_NAMEDESC: "ایک کیمرہ بنائیں اور ایک [کیمرہ اینٹیٹی] واپس کریں، جس کی خصوصیات کو پراپرٹی کی ترتیبات کے ذریعے تبدیل کیا جا سکتا ہے۔",
  T_38_WZY_WS_CYCLES: "پلے کرنے کی تعداد",
  T_38_WZY_WS_CYLINDERJUD_NAMEDESC: "چیک کریں کہ آیا کوئی [اینٹیٹی] سرکیولر پول کے اسکوپ کے اندر ہے۔ [سینٹر] پول کا سینٹر ہے، [ریڈیس] سرکیولر سرفیز کا ریڈیس ہے، [اونچائی] پول کی اونچائی ہے، [ایولراینگلز] پول کی 3D آریاینٹیشن کے اینگلز ہیں۔",
  T_38_WZY_WS_CYLINDERJUD_RES: "سرکلر پول اسکوپ چیک کا نتیجہ۔ یہ ایک بولین ویلیو ہے۔",
  T_38_WZY_WS_DAMSUMZOM: "زومبیز کو نقصان",
  T_38_WZY_WS_DARKNESS: "اندھیرا",
  T_38_WZY_WS_DIFCOLOR: "سرفیس کا رنگ",
  T_38_WZY_WS_DIFTEXTURE: "سرفیس کی ساخت",
  T_38_WZY_WS_DRUMMUSIC: "کمپونینٹ کی قسم: ڈرم",
  T_38_WZY_WS_ENTITY_PLAYERDISDESC: "وہ کھلاڑی جس سے رابطہ منقطع ہو گیا تھا",
  T_38_WZY_WS_ENTITY_PLAYERRECDESC: "وہ کھلاڑی جو دوبارہ جڑ رہا ہے",
  T_38_WZY_WS_EUIANCHOR: "HUD اینکر کی قسم کی گنتی",
  T_38_WZY_WS_FEATHER: "فیدر",
  T_38_WZY_WS_FLAMEAMMO: "آتش گیر بارود",
  T_38_WZY_WS_FLOWER: "پھول",
  T_38_WZY_WS_FOLLOW_NAMEDESC: "[اینٹیٹی] کو ہمیشہ [فالوڈ اینٹیٹی] کو فالو کرنے کے لیے سیٹ کریں۔ [آفسیٹ کوآرڈینیٹ] دو اینٹیٹی کے درمیان فاصلہ ہے۔",
  T_38_WZY_WS_FOLLOWENT: "فالو کی گئی اینٹیٹی",
  T_38_WZY_WS_GETCURCAM_NAMEDESC: "کیمرہ اینٹیٹی حاصل کریں جو فی الحال ایک [کھلاڑی اینٹیٹی] کے ذریعہ استعمال کیا جا رہا ہے",
  T_38_WZY_WS_GETCURCAMDESC: "وہ کیمرہ جو فی الحال کھلاڑی استعمال کر رہا ہے۔",
  T_38_WZY_WS_GETITEMNUM_NAMEDESC: "[نامزد آئٹم کی قسم] میں کسی آئٹم کی مقدار حاصل کریں جو ایک [کھلاڑی] کے پاس ہے",
  T_38_WZY_WS_GETITEMNUM_RES: "نامزد آئٹم کی مقدار جو کھلاڑی کے پاس ہے۔",
  T_38_WZY_WS_GETVEC_NAME: "ویکٹر حاصل کریں",
  T_38_WZY_WS_GETVEC_NAMEDESC: "کوآرڈینیٹ کے سیٹ کے x، y، اور z اجزاء کا استعمال کرتے ہوئے ایک ویکٹر حاصل کریں۔",
  T_38_WZY_WS_GETVECRES: "y، x، اور z کمپونینٹس سے حاصل کردہ ویکٹر",
  T_38_WZY_WS_GHOST: "گھوسٹ",
  T_38_WZY_WS_GRENADEFROZENNAME: "فلیش فریز اینٹیٹی",
  T_38_WZY_WS_GRENADEFROZENPARAM1: "فریز زون ریڈیس",
  T_38_WZY_WS_GRENADEFROZENPARAM2: "فریز دورانیہ",
  T_38_WZY_WS_GRENADENAME: "گرینیڈ اینٹیٹی",
  T_38_WZY_WS_GRENADEPARAM1: "کم از کم نقصان",
  T_38_WZY_WS_GRENADEPARAM2: "زیادہ سے زیادہ نقصان",
  T_38_WZY_WS_GRENADEPARAM4: "دھماکے کی رینج",
  T_38_WZY_WS_GRENADEPARAM5: "پھینکنے کی رفتار",
  T_38_WZY_WS_GRENADEPARAM6: "دھماکے میں تاخیر",
  T_38_WZY_WS_GRENADEPARAM7: "خود کو نقصان پہنچانے والا ملٹیپلائر",
  T_38_WZY_WS_GRENADEPARAM8: "اتحادیوں کے نقصان کا ملٹیپلائر",
  T_38_WZY_WS_GRENADEPARAM9: "گاڑی کو پہنچنے والے نقصان کا ضرب",
  T_38_WZY_WS_GUNFIRE: "گن فائر",
  T_38_WZY_WS_GUNPRO_PARAM2: "دوبارہ لوڈ کرنے کی رفتار",
  T_38_WZY_WS_GUNPRO_PARAM3: "باڈی شاٹس DMG ریشو",
  T_38_WZY_WS_GUNPRO_PARAM4: "ہیڈ شاٹس DMG ریشو",
  T_38_WZY_WS_GUNPRO_PARAM5: "لمب شاٹس DMG ریشو",
  T_38_WZY_WS_GUNPRO_PARAM7: "گاڑیوں، تیل کے بیرلز اور گلو والز کو اضافی نقصان",
  T_38_WZY_WS_HELMET_NAME: "ہیلمٹ اینٹیٹی",
  T_38_WZY_WS_ICON1: "تاج",
  T_38_WZY_WS_ICON2: "ڈوئل",
  T_38_WZY_WS_INITPOS: "ابتدائی مقام",
  T_38_WZY_WS_ISRESET: "ریسیپروکیٹنگ موشن",
  T_38_WZY_WS_KILLCONZOM: "زومبیز کی تعداد ختم کردی گئی",
  T_38_WZY_WS_KILLENT_NAMEDESC: "منتخب کردہ [اینٹیٹی] کو ختم کریں، جو کہ بیٹل اینٹیٹی کی قسم ہونی چاہیے۔ ناقابل تسخیر اسٹیٹس کو نظر انداز کرتا ہے۔",
  T_38_WZY_WS_LABELPARAM: "ٹیکسٹ کے مواد کے پیرامیٹر کی فہرست",
  T_38_WZY_WS_LEADMUSICA: "کمپونینٹ کی قسم: پیانو (تگنا)",
  T_38_WZY_WS_LEADMUSICB: "کمپونینٹ کی قسم: پیانو (آلٹو)",
  T_38_WZY_WS_LEADMUSICC: "کمپونینٹ کی قسم: پیانو (باس)",
  T_38_WZY_WS_LINE: "لائن",
  T_38_WZY_WS_LIQUID: "لیکویڈ",
  T_38_WZY_WS_LOCALKEY: "لوکلائزڈ کی",
  T_38_WZY_WS_LOCALPOS: "رشتہ دار مقام",
  T_38_WZY_WS_LOOKAT_NAMEDESC: "ہمیشہ [مقصد اینٹیٹی] کا سامنا کرنے کے لیے ایک [اینٹیٹی] مقرر کریں۔ [آفسیٹ کوآرڈینیٹ] مقصد پوائنٹ اور اینٹیٹی کی پوزیشن کے کوآرڈینیٹس میں فرق ہے۔",
  T_38_WZY_WS_MAINWEAPONA: "اہم ہتھیار 1",
  T_38_WZY_WS_MAINWEAPONB: "اہم ہتھیار 2",
  T_38_WZY_WS_MOTIONTIME: "نقل و حرکت کا دورانیہ",
  T_38_WZY_WS_MOTIONTYPE: "نقل و حرکت کا طریقہ",
  T_38_WZY_WS_MUSHROOM_EPMODIFY: "ترمیم شدہ EP",
  T_38_WZY_WS_MUSHROOMNAME: "مشروم اینٹیٹی",
  T_38_WZY_WS_OBFACTION: "تماشائی گروہ",
  T_38_WZY_WS_OBGLOBAL: "سب دیکھیں",
  T_38_WZY_WS_OBSERVER: "سپیکٹیٹر آپشنز",
  T_38_WZY_WS_OBTEAM: "سپیکٹیٹ ٹیم",
  T_38_WZY_WS_OFFSETVEC: "آفسیٹ کوآرڈینیٹس",
  T_38_WZY_WS_ONBUY_NAMEDESC: "اس وقت ٹرگر ہوتا ہے جب کوئی کھلاڑی اس وینڈنگ مشین سے آئٹمز خرید رہا ہو۔ [کھلاڑی اینٹیٹی] وہ کھلاڑی ہے جو خریداری کرتا ہے۔ [مرچنڈائز اینٹیٹی] خریدی گئی آئٹم ہے۔",
  T_38_WZY_WS_ONEQUIPED_NAMEDESC: "ٹرگرز جب کسی [کھلاڑی کی  اینٹیٹی] سے لیس ہوتے ہیں",
  T_38_WZY_WS_ONJUMP_NAMEDESC: "جب کھلاڑی جمپنگ ایکشن مکمل کرتا ہے تو متحرک ہوتا ہے",
  T_38_WZY_WS_ONLIE_NAMEDESC: "اس وقت متحرک ہوتا ہے جب کھلاڑی شکار کی پوزیشن کو مکمل کرتا ہے",
  T_38_WZY_WS_ONRELOAD_NAMEDESC: "جب ہتھیار دوبارہ لوڈ ہوتا ہے تو متحرک ہوتا ہے",
  T_38_WZY_WS_ONSPRINT_NAMEDESC: "جب کھلاڑی سپرنٹنگ ایکشن مکمل کرتا ہے تو ٹرگر ہوتا ہے۔",
  T_38_WZY_WS_ONSQUAT_NAMEDESC: "جب کھلاڑی کراؤچنگ ایکشن مکمل کرتا ہے تو ٹرگر ہوتا ہے۔",
  T_38_WZY_WS_ONWAEPKILL_NAMEDESC: "اس وقت ٹرگر ہوتا ہے جب ہتھیار کسی یونٹ کو ختم کرتا ہے۔ [ختم کی گئی اینٹیٹی] وہ یونٹ ہے جسے ختم کیا گیا تھا۔",
  T_38_WZY_WS_ONWEAPDAMAGE_NAMEDESC: "اس وقت ٹرگر ہوتا ہے جب ہتھیار کسی بیٹل اینٹیٹی کو نقصان پہنچاتا ہے۔ [ہٹ ٹارگٹ] وہ بیٹل اینٹیٹی ہے جسے نقصان پہنچایا گیا تھا۔ [ڈیمیج] وہ نقصان ہے جو پہنچایا جا رہا ہے۔",
  T_38_WZY_WS_OWNER: "مالک",
  T_38_WZY_WS_PARAMLIST: "پیرامیٹر لسٹ",
  T_38_WZY_WS_PARTICALMAP: "پارٹیکل میپنگ",
  T_38_WZY_WS_PAUSEMOTE_NAMEDESC: 'کسی [کھلاڑی اینٹیٹی] کے لیے موجودہ ایموٹ کو روکیں یا دوبارہ شروع کریں۔ [روکنا چاہیے یا نہیں] ایک بولین ویلیو ہے۔ "ہاں"کا مطلب روکیں۔"نہیں" کا مطلب دوبارہ شروع کریں',
  T_38_WZY_WS_PLAENTTRI_DESC: "ٹرگر میں داخل ہونے والے کھلاڑی کے ذریعہ ایکٹیویٹ کیا جاتا ہے۔",
  T_38_WZY_WS_PLAQUITTRI_DESC: "پلیئر کو ٹرگر چھوڑ کر ایکٹیویٹ کیا گیا",
  T_38_WZY_WS_PLAYEMOTE_NAMEDESC: "[کھلاڑی کی اینٹیٹی] کو ایک بار نامزد [ایموٹ] کھیلنے پر مجبور کریں اور ختم ہونے پر اصل پوزیشن پر واپس جائیں",
  T_38_WZY_WS_PLAYSPEED: "پلے بیک کی رفتار",
  T_38_WZY_WS_PREHUD_NAME: "پیش سیٹ آئیکن",
  T_38_WZY_WS_QUITFACTION_NAMEDESC: "[کھلاڑی اینٹیٹی] کو اس کے موجودہ فیکشن کو چھوڑنے دیں",
  T_38_WZY_WS_RESETENT: "ہر راؤنڈ میں اجزاء کو ری سیٹ کریں",
  T_38_WZY_WS_RESUUID: "ریسورس UUID",
  T_38_WZY_WS_RIMCOLOR: "بارڈر کا رنگ",
  T_38_WZY_WS_RIMTEXTURE: "بارڈر کی ساخت",
  T_38_WZY_WS_SECTORJUD_NAMEDESC: "چیک کریں کہ آیا کوئی [اینٹیٹی] کون کے اندر ہے۔ [سینٹر] اور [ریڈیس] کون کا سینٹر اور ریڈیس ہیں۔ کون کے اندر چھوٹے سیکٹر کا ریڈیس [نکالا ہوا ریڈیس] ہے۔ اونچائی 3D ڈھانچے کی اونچائی ہے۔ [اینگل] کون کا سینٹر اینگل ہے۔ [ڈائریکشن اینگل] سینٹرل ایکسز کا ڈائریکشن ویکٹر ہے۔",
  T_38_WZY_WS_SECTORJUD_RES: "فین-شیپڈ اسکوپ چیک کا نتیجہ۔ یہ ایک بولین ویلیو ہے۔",
  T_38_WZY_WS_SETACTIVE_NAMEDESC: "ایک [ٹارگٹ اینٹیٹی] کے ایکٹیویٹی اسٹیٹش کو سیٹ کریں۔ [ایکٹیویٹی اسٹیٹش] ایک بولین ویلیو ہے اور یہ اینٹیٹی کی دستیابی، دکھنے کی صلاحیت اور ٹکراؤ کو متاثر کرتی ہے۔",
  T_38_WZY_WS_SETROUNDSCORE: "کھلاڑی کا راؤنڈ اسکور سیٹ کریں",
  T_38_WZY_WS_SHOOTANGMAX: "زیادہ سے زیادہ شوٹنگ اینگل",
  T_38_WZY_WS_SHOWMAPINFO: "اسی گروہ کے لیے نقشے کی معلومات دکھائیں",
  T_38_WZY_WS_SHOWNAMEHUD: "اسی فیکشن کے لیے نام HUD ڈسپلے کریں",
  T_38_WZY_WS_SOUND1: "ایکسلریشن",
  T_38_WZY_WS_SOUND10: "اسٹیج اسٹارٹ",
  T_38_WZY_WS_SOUND11: "زومبیز",
  T_38_WZY_WS_SOUND12: "وحشت",
  T_38_WZY_WS_SOUND13: "تبدیلی",
  T_38_WZY_WS_SOUND14: "دھڑکتا دل",
  T_38_WZY_WS_SOUND15: "درمیانی ہارٹ بیٹ",
  T_38_WZY_WS_SOUND16: "سست ہارٹ بیٹ",
  T_38_WZY_WS_SOUND17: "رش ٹائم",
  T_38_WZY_WS_SOUND18: "کلک",
  T_38_WZY_WS_SOUND19: "اسکل ریکور",
  T_38_WZY_WS_SOUND2: "نوٹیفیکیشن غائب کریں",
  T_38_WZY_WS_SOUND20: "گیم میں شامل ہوں",
  T_38_WZY_WS_SOUND3: "ویژول افکیٹس",
  T_38_WZY_WS_SOUND4: "نائٹ چرپس",
  T_38_WZY_WS_SOUND5: "ہٹ (بلنٹ)",
  T_38_WZY_WS_SOUND6: "رد عمل",
  T_38_WZY_WS_SOUND7: "سرپرائز فائنڈ",
  T_38_WZY_WS_SOUND8: "ظاہری شکل",
  T_38_WZY_WS_SOUNDENT: "میوزک اینٹیٹی",
  T_38_WZY_WS_SPAWNPOS: "پرانا سپان پوائنٹ",
  T_38_WZY_WS_SPHERENAME: "بنیادی سفیئر",
  T_38_WZY_WS_SPHERERADIUS: "سفیئر ریڈیس",
  T_38_WZY_WS_SPHERICALJUD_NAMEDESC: "چیک کریں کہ آیا کوئی [اینٹیٹی] سفیئریکل اسکوپ کے اندر ہے۔ [سینٹر] اور [ریڈیس] سفیئریکل سٹرکچر کا سینٹر اور ریڈیس ہے۔",
  T_38_WZY_WS_SPHERICALJUD_RES: "سفیئریکل اسکوپ چیک کا نتیجہ۔ یہ ایک بولین ویلیو ہے۔",
  T_38_WZY_WS_SQUAREJUD_NAMEDESC: "چیک کریں کہ آیا کوئی [اینٹیٹی] کیوب کے اسکوپ کے اندر ہے۔ [سینٹر] کیوب کا سینٹر ہے، [لمبائی]، [چوڑائی]، اور [اونچائی] کیوب کی لمبائی، چوڑائی اور اونچائی ہیں، اور [ایولر اینگلز] کیوب کے 3D آریاینٹیشن کے اینگلز ہیں۔",
  T_38_WZY_WS_SQUAREJUD_RES: "کیوبک اسکوپ چیک کا نتیجہ۔ یہ ایک بولین ویلیو ہے۔",
  T_38_WZY_WS_STARTGENTIME: "سپان شروع ہونے کا وقت",
  T_38_WZY_WS_STAYTIME: "وقفے کا دورانیہ",
  T_38_WZY_WS_SWITCHCAM_NAMEDESC: "کسی کھلاڑی کے کیمرہ کو [کیمرہ اینٹیٹی] میں تبدیل کریں۔ [سوئچ موڈ] یا تو کوئی اینیمیشن یا ترقی پسند حرکت نہیں ہوسکتی ہے۔ [سوئچ ٹائم] ترقی پسند موڈ کے دوران سوئچ کرنے کا وقت ہے۔",
  T_38_WZY_WS_SWITCHCAM_PARAM3_DESC: "کیمرہ موڈ سوئچ کریں۔ آپ بغیر اینیممیشن اور پراگریسیو موومنٹ کے درمیان انتخاب کر سکتے ہیں۔",
  T_38_WZY_WS_SWITCHCAM_PARAM4_DESC: 'پراگریسیو موومنٹ موڈ کے دوران سوئچ کا وقت۔ جب "کوئی اینیمیشن نہیں" منتخب کیا جاتا ہے، تو یہ ترتیب وائڈ ہو جاتی ہے۔',
  T_38_WZY_WS_TEXTHUD: "HUD ٹیکسٹ کمپونینٹ",
  T_38_WZY_WS_TEXTTYPE: "فانٹ سائز",
  T_38_WZY_WS_TEXTUREID: "ساخت کی قسم",
  T_38_WZY_WS_TRANDIST: "زیادہ سے زیادہ فاصلہ",
  T_38_WZY_WS_TWEENERENABLED: "UITweener اسکرپٹ کو آن کریں یا نہیں",
  T_38_WZY_WS_TYPELIST: "ٹائپ لسٹ",
  T_38_WZY_WS_TYPELISTORLIST: "ٹائپ یا ٹائپ لسٹ",
  T_38_WZY_WS_VEST_NAME: "ویسٹ اینٹیٹی",
  T_38_WZY_WS_VFX1: "ہائیڈر کا خاتمہ",
  T_38_WZY_WS_VFX10: "سائیکلک دہن",
  T_38_WZY_WS_VFX11: "زہریلی گیس",
  T_38_WZY_WS_VFX13: "ہارٹ",
  T_38_WZY_WS_VFX15: "دروازہ",
  T_38_WZY_WS_VFX2: "ریمپیج",
  T_38_WZY_WS_VFX3: "کلون کا خاتمہ",
  T_38_WZY_WS_VFX4: "ہٹ فیڈ بیک",
  T_38_WZY_WS_VFX5: "کلون",
  T_38_WZY_WS_VFX6: "بھیس",
  T_38_WZY_WS_VFX7: "فلیش بینگ اسپارکس",
  T_38_WZY_WS_VFX8: "موشن ٹریل",
  T_38_WZY_WS_VFX9: "فائر چارج",
  T_38_WZY_WS_VFXENT: "VFX انسٹینس",
  T_38_WZY_WS_VFXTYPEA_NAME: "حسب ضرورت میپنگ VFX",
  T_38_WZY_WS_VFXTYPEB_NAME: "غیر حسب ضرورت میپنگ VFX",
  T_38_WZY_WS_VISIBILITY: "دیکھائی دینے کی قسم",
  T_38_WZY_WS_VOLUME: "والیوم",
  T_38_WZY_WS_WEAPONGEN: "ہتھیار جنریٹر",
  T_38_WZY_WS_WHECYCLE: "ری پلے کریں یا نہیں",
  T_38_XXJ_WS_BLOCKMODE: "بلاکڈ موڈ",
  T_38_XXJ_WS_CUSTOMCAMARA: "کسٹم کیمرہ",
  T_38_XXJ_WS_FFCLASSIC: "کلاسک FF (شوٹنگ)",
  T_38_XXJ_WS_FOV: "منظر کی فیلڈ",
  T_38_XXJ_WS_FOVDESC: "منظر کی فیلڈ کیمرے کی قابل مشاہدہ رینج ہے۔",
  T_38_XXJ_WS_FPS: "پہلا شخص (شوٹنگ)",
  T_38_XXJ_WS_HORIZONTALANGLE: "ہاریزانٹل اینگل",
  T_38_XXJ_WS_INVISICAM: "سیمی-ٹرانسپیرنٹ",
  T_38_XXJ_WS_OFFSET: "آفسیٹ",
  T_38_XXJ_WS_ORTHOGRAPHIC: "آرتھوگرافک",
  T_38_XXJ_WS_PERSPECTIVE: "نقطہ نظر",
  T_38_XXJ_WS_PROJECTIONMODE: "پروجیکشن موڈ",
  T_38_XXJ_WS_STABLE: "فکسڈ",
  T_38_XXJ_WS_STARTCAMERA: "ڈیفالٹ کیمرہ",
  T_38_XXJ_WS_STARTCAMERAMODE: "ڈیفالٹ کیمرہ موڈ",
  T_38_XXJ_WS_THIRD: "کیمرے کا پیچھا",
  T_38_XXJ_WS_TOPVIEW: "ہائی اینگل",
  T_38_XXJ_WS_TPS: "تیسرا شخص",
  T_38_XXJ_WS_TRANSVERSE: "ہاریزانٹل موومنٹ",
  T_38_XXJ_WS_VERTICALANGLE: "ورٹیکل اینگل",
  T_38_XXJ_WS_ZOOM: "زوم",
  T_38_XYL_WS_AISTARTTIME: "اسٹارٹ ٹائم",
  T_38_XYL_WS_ARMORDESTROY: "آرمر ڈیمیج ملٹیپلائر",
  T_38_XYL_WS_BONFIRE: "بان فائر",
  T_38_XYL_WS_CANDLE01: "کینڈل A",
  T_38_XYL_WS_CANNON01: "مکینیکل کینن",
  T_38_XYL_WS_CLIPAMMOSIZE: "میگزین اسٹوریج",
  T_38_XYL_WS_DAMAGEDTRUCK: "تباہ شدہ ٹرک",
  T_38_XYL_WS_DOLL01: "ایری ڈال",
  T_38_XYL_WS_ENTERANCEHOUSE01: "برک ہاؤس A",
  T_38_XYL_WS_FENCE002: "آئرن فینس B",
  T_38_XYL_WS_FIREWORK01: "آتش بازی A",
  T_38_XYL_WS_GENERATOR: "جنریٹر",
  T_38_XYL_WS_GRAVITY: "گریویٹیشنل ایکسلریشن",
  T_38_XYL_WS_GRAVITYAREA: "غیر معمولی گریو زون",
  T_38_XYL_WS_GRAVITYAREA_DESC: "ایک ایسا زون جہاں کھلاڑی گریویٹی کو تبدیل کر سکتے ہیں۔",
  T_38_XYL_WS_HOLDWEAPON: "ویپن ہولڈ",
  T_38_XYL_WS_INDOORFURNITURE: "انڈور فرنیچر",
  T_38_XYL_WS_LIGHTTUBE001: "ٹیوب لائٹ A",
  T_38_XYL_WS_LOVEBALLOON01: "ویلنٹائن بیلون A",
  T_38_XYL_WS_LOVELAMP01: "ہارٹ اسٹریٹ لائٹ",
  T_38_XYL_WS_LOVESIGN01: "لوو نیون لائٹس",
  T_38_XYL_WS_OILDRUM_DAMAGE: "تیل کے بیرل کے نقصان کا تناسب",
  T_38_XYL_WS_OUTDOORPROPS: "آؤٹ ڈور آئٹمز",
  T_38_XYL_WS_PIPEANDBOX: "پائپ اور کنٹینرز",
  T_38_XYL_WS_PLANT: "پودے",
  T_38_XYL_WS_ROSE01: "روز",
  T_38_XYL_WS_ROSEN: "گلاب کا گلدستہ",
  T_38_XYL_WS_SMALLBUILDING: "چھوٹی عمارتیں",
  T_38_XYL_WS_SOFA002: "صوفہ B",
  T_38_XYL_WS_TOWNHOUSE01: "پرانا 2 منزلہ مکان",
  T_38_XYL_WS_TV001: "پرانا TV",
  T_38_ZP_CC_EXCHANGESTATUS: "سٹیٹس",
  T_39_BQ_SKILL_NAME_VILLAIN: "کرمسن کرش",
  T_39_CJ_A_BURN: "وکٹری گلنٹ مارک",
  T_39_HJ_WS_Arrow002: "تیر 2",
  T_39_HJ_WS_LIKERATE2: "{0} منٹ",
  T_39_HJ_WS_LIKERATE3: "{0} - {1} منٹ",
  T_39_HJ_WS_SOUND10: "قدم",
  T_39_HJ_WS_SOUND11: "مشن مکمل 1",
  T_39_HJ_WS_SOUND13: "ڈینجر الرٹ 1",
  T_39_HJ_WS_SOUND14: "ڈینجر الرٹ 2",
  T_39_HJ_WS_SOUND15: "کاؤنٹ ڈاؤن 3",
  T_39_HJ_WS_SOUND16: "ٹپس ساؤنڈ",
  T_39_HJ_WS_SOUND17: "کرو کاؤ",
  T_39_HJ_WS_SOUND18: "غلط علاقے میں ٹیلی پورٹ کرنے کی آواز",
  T_39_HJ_WS_SOUND19: "صحیح علاقے میں ٹیلی پورٹ کرنے کا ساؤنڈ",
  T_39_HJ_WS_SOUND2: "کاؤنٹ ڈاؤن 1",
  T_39_HJ_WS_SOUND20: "ٹیلی پورٹ",
  T_39_HJ_WS_SOUND21: "الیکٹرک شاک",
  T_39_HJ_WS_SOUND23: "آئٹم حاصل کریں",
  T_39_HJ_WS_SOUND24: "الیکٹرانک & پیارا BGM",
  T_39_HJ_WS_SOUND25: "کیژول گیم BGM",
  T_39_HJ_WS_SOUND4: "مکینیکل ڈیوائس ایکو",
  T_39_HJ_WS_SOUND5: "مچھر",
  T_39_HJ_WS_SOUND6: "ڈنگ ڈنگ ڈنگ 1",
  T_39_HJ_WS_SOUND7: "ڈنگ ڈنگ ڈنگ 2",
  T_39_HJ_WS_SOUND8: "گیئر آن کر دیا گیا",
  T_39_HJ_WS_SOUND9: "چارج 1",
  T_39_HJ_WS_UNLIMITEDGLOOWALL: "لا محدود گلو والز",
  T_39_HJ_WS_UNLIMITEDTHROWABLES: "لامحدود تھرو ایبلز",
  T_39_HQ_EVOGUN2_SOUNDEQUIP3: "اسپیشل فائرنگ ساؤنڈ",
  T_39_HQ_UGC_CUSTOMRES: "کسٹم ریسورسز",
  T_39_M_ACCOUNTID: "اکاؤنٹ",
  T_39_M_WS_BUTTON_DOUBLECLICKDESC: "ڈبل کلک کے بعد عمل کریں",
  T_39_MF_SKILLTAG_4: "حرکت",
  T_39_PD_HuntingGroundSnow_MYNAME: "Mr. V",
  T_39_QL_SKILL_OTHO_DES: "کسی دشمن کو گرانے کے بعد، گرے دشمنوں میں گرائے گئے دشمن کے {0} میٹر کے اندر نشان زد کرتا ہے اور ان کی نقل و حرکت کی رفتار کو {1}% کم کرتا ہے۔ {2} سیکنڈ تک رہتا ہے۔ نیچے گرنے پر، نشان زد کرتا ہے اور قریبی دشمنوں کو سست کرتا ہے۔",
  T_39_QL_SKILL_WOLFRAHH_DES: "دشمن کا خاتمہ کرنے کے بعد، ہائی لائٹ موڈ میں داخل ہوں، جس سے فائر کی شرح {0}٪ اور حرکت کی رفتار میں {1}٪ اضافہ ہوتا ہے لیکن پھر تیزی سے ختم ہوتا ہے۔ {2} سیکنڈ تک رہتا ہے۔ ہائی لائٹ موڈ کے دوران، دشمنوں کو لگاتار گرانے سے کاؤنٹ ڈاؤن ری سیٹ ہو جائے گا اور فائر کی شرح میں {3}٪ اور حرکت کی رفتار میں {4}٪ اضافہ ہو جائے گا۔",
  T_39_QL_SKILL_XAYNE_DES1: "ایکسٹریم موڈ: {1} کے لیے {0} عارضی ہیلتھ پوائنٹ حاصل کریں۔ اس وقت کے دوران، ہیلتھ پوائنٹ ہیلنگ ایفیکٹس میں {2}٪ اضافہ ہوتا ہے۔ کولڈاؤن: {3}سیکنڈ۔",
  T_39_RW_GM_DEFEAT: "ناکام",
  T_39_RW_SKILL_DESC_FORD: "نقصان اٹھاتے وقت، {0} سیکنڈ کے لیے {1} ہیلتھ پوائنٹ/سیکنڈ حاصل کریں۔ کولڈاؤن: {2}۔ایک فعال مہارت کو جاری کرنے کے بعد، یہ غیر فعال مہارت فوری طور پر دوبارہ ترتیب دی جائے گی۔",
  T_39_SP_WS_ITEMENTITY_01: "آئٹم اینٹیٹی",
  T_39_SY_CHARACTER_ALVARO_AWAKENING_N: 'الوارو "ریج بلاسٹ"',
  T_39_SY_CHARACTER_VILLAIN_N: "اورین",
  T_39_SY_KATANA_FASTBREAKING23_N: "کٹانا - 1001 نائٹس",
  "T_39_SY_PETSKIN_FLYINGCREATURE_FB23 _N": "پٹ اسکن: گرین امپ آراون",
  "T_39_SY_PETSKIN_TIGER_BDFEST _N": "پٹ اسکن: رائل ٹِگ",
  "T_39_SY_PETSKIN_WOLF_SCARLET _N": "پٹ اسکن: اسکورپیو فینگ",
  T_39_SY_VEHICLESKIN_MONSTER_TRUCK_FASTBREAKING23_N: "مونسٹر ٹرک - گرین جائنٹ",
  T_39_SY_VEHICLESKIN_TUTU_BDFEST_N: "ٹک ٹک - فلورل چیرییوٹ",
  T_39_WH_SKILL_DESC_GRENADESPLIT: "بیداری: دھماکہ کرنے سے {0} سیکنڈ پہلے، گرینیڈ {1} اضافی گرینیڈ تیار کرتا ہے، جس سے اس کو {2}٪ نقصان ہو سکتا ہے۔",
  T_39_WH_SKILL_NAME_GRENADESPLIT: "سپلٹ بلٹز",
  T_39_WT_WS_EMPTYMAP_TAG: "خالی جگہ",
  T_39_WT_WS_FEMAPMODE: "موڈ ٹائٹل",
  T_39_WT_WS_FEMAPTAG: "نقشے کا ٹیگ",
  T_39_WT_WS_MAPPLAYER: "کھلاڑیوں کی تعداد",
  T_39_WT_WS_MEDENTERNUM: "مڈ گیم میں شامل ہونے والے کھلاڑی کی حد",
  T_39_WT_WS_MIDENTER: "مڈ گیم میں شمولیت",
  T_39_WT_WS_MIDENTERCOUNT: "مڈ گیم میں شامل ہونے کا کوٹہ",
  T_39_WT_WS_MIDENTERTIME1: "مڈ گیم میں شامل ہونے کی وقت کی حد",
  T_39_WT_WS_MIDENTERTIME2: "میڈ گیم میں شمولیت کا دورانیہ",
  T_39_WT_WS_MIDENTERTIMETIP: "جب میپ پلیئر نمبر کی حد پوری نہیں ہوتی ہے تو، میچ شروع ہونے کے بعد کھلاڑیوں کو N سیکنڈ کے اندر اندر شامل ہونے کے قابل بنائیں۔ کھلاڑی N سیکنڈ کے بعد شامل نہیں ہو سکتے۔",
  T_39_WT_WS_MIDENTERTIP: "فعال ہونے پر، کھلاڑی اس میپ کے مڈ گیم میں شامل ہو سکتے ہیں۔",
  T_39_WT_WS_PLAYERCOUNT: "ابتدائی کھلاڑی نمبر",
  T_39_WT_WS_PLAYERCOUNTTIP: "میچ شروع ہونے پر کھلاڑی کا نمبر۔ مزید کھلاڑی مڈ گیم میں شامل ہو سکتے ہیں جب تک کہ یہ نقشہ کی حد تک نہ پہنچ جائے۔",
  T_39_WT_WS_TAG1: "سب کے لئے مفت",
  T_39_WT_WS_TAG10: "آسان",
  T_39_WT_WS_TAG11: "میڈیم",
  T_39_WT_WS_TAG12: "مشکل",
  T_39_WT_WS_TAG13: "بہت چیلنجنگ",
  T_39_WT_WS_TAG14: "فرار",
  T_39_WT_WS_TAG16: "VIP",
  T_39_WT_WS_TAG17: "کسٹم ریسورسز",
  T_39_WT_WS_TAG18: "پزلز",
  T_39_WT_WS_TAG19: "ریسنگ",
  T_39_WT_WS_TAG2: "گن کی لڑائی",
  T_39_WT_WS_TAG20: "میوزک",
  T_39_WT_WS_TAG21: "MOBA",
  T_39_WT_WS_TAG22: "ایڈونچر",
  T_39_WT_WS_TAG23: "PvE",
  T_39_WT_WS_TAG24: "PvP",
  T_39_WT_WS_TAG25: "پارٹی گیم",
  T_39_WT_WS_TAG26: "ٹیم ڈیتھ میچ",
  T_39_WT_WS_TAG27: "برج کا دفاع",
  T_39_WT_WS_TAG28: "ٹریننگ",
  T_39_WT_WS_TAG3: "گن کنگ",
  T_39_WT_WS_TAG4: "ری سپان",
  T_39_WT_WS_TAG5: "سنائپر",
  T_39_WT_WS_TAG6: "سروائیول",
  T_39_WT_WS_TAG7: "سولو",
  T_39_WT_WS_TAG8: "ہارر",
  T_39_WT_WS_TAG9: "کیژول",
  T_39_WT_WS_TAGMAXTIP: "{0} ٹیگز تک منتخب کریں",
  T_39_WT_WS_TAGTYPE1: "گیم پلے کی قسم",
  T_39_WT_WS_TAGTYPE2: "نقشے کی قسم",
  T_39_WT_WS_TAGTYPE3: "موڈ کی قسم",
  T_39_WT_WS_TAGTYPE4: "ٹیم کا سائز",
  T_39_WZY_WS_ACCSPEED: "ایکسلریشن",
  T_39_WZY_WS_ADDSCRIPT_NAMEDESC: "[اینٹیٹی] کے لیے اسکرپٹ [اسکرپٹ نام] شامل کریں",
  T_39_WZY_WS_ASC: "اسینڈنگ",
  T_39_WZY_WS_ASCIGZERO: "اسینڈنگ کا استعمال کرتے ہوئے صفر کو نظر انداز کریں",
  T_39_WZY_WS_BALLISTMOVENT: "بیلسٹک موشن اینٹیٹی",
  T_39_WZY_WS_BEUSED_NAMEDESC: "واقعہ کو ٹرگر کرتا ہے جب آئٹم [کھلاڑی اینٹیٹی] کے ذریعہ استعمال کیا جاتا ہے",
  T_39_WZY_WS_BODYSCALE: "باڈی اسکیل",
  T_39_WZY_WS_BRAKETORQUE: "بریک ہارس پاور",
  T_39_WZY_WS_CAMTRANTYPE: "کیمرہ ٹرانزیشن ٹائپ",
  T_39_WZY_WS_CARVEHICLE: "4-وہیلر",
  T_39_WZY_WS_CHECKSCRIPT_NAMEDESC: "چیک کریں کہ آیا ایک مخصوص اسکرپٹ [اسکرپٹ نام] [اینٹیٹی] میں موجود ہے۔ (واپس کی گئی ویلیو بولین ہونی چاہیے)",
  T_39_WZY_WS_CHECKSCRIPT_RES: "چیک کریں کہ آیا اینٹیٹی کے پاس مخصوص اسکرپٹ کا نتیجہ ہے (بولین)",
  T_39_WZY_WS_COMBINEALL: "ڈوول ویلڈنگ (مختلف گنز)",
  T_39_WZY_WS_COMBINESELF: "ڈوول ویلڈنگ (ایک ہی گن)",
  T_39_WZY_WS_CONENAME: "بنیادی کون",
  T_39_WZY_WS_COORSYS: "کوآرڈینیٹ سسٹم",
  T_39_WZY_WS_CRASHMAXD: "زیادہ سے زیادہ کریش نقصان",
  T_39_WZY_WS_CRASHMIND: "کم سے کم کریش نقصان",
  T_39_WZY_WS_CRAWLSPEED: "نقل و حرکت کی رفتار کا فیصد (شکار)",
  T_39_WZY_WS_CREBALLISTMOV_NAMEDESC: "[ٹارگٹ اینٹٹی] کے لیے بیلسٹک موشن بنائیں۔ ٹارگٹ اینٹٹی کے لیے ابتدائی رفتار کی سمت میں جمع [ابتدائی رفتار]، [تیز رفتار]، اور [زیادہ سے زیادہ فاصلہ] میں ترمیم کر سکتے ہیں، اور [بیلسٹک موشن اینٹیٹی] کو واپس کر سکتے ہیں۔",
  T_39_WZY_WS_CRETWEEN_NAME: "انٹرپولیشن موشن بنائیں",
  T_39_WZY_WS_CRETWEEN_NAMEDESC: "[وقت] کے اندر [اسٹارٹ ویلیو] سے [ٹارگٹ ویلیو] تک آسانی سے منتقل ہونے والی ہستی کے [صفات] کے ساتھ، [اینٹیٹی] کے لیے ایک انٹرپولیشن موشن بنائیں۔ [طریقہ] موشن کے راستے کی نمائندگی کرتا ہے، بشمول [ایک طرفہ]، [پنگ پونگ]، [سائیکل]۔ [کروو] موشن کا کروو ہے۔ اور [انٹرپولیشن موشن اینٹیٹی] کو موشن بنانے کے بعد واپس کر دیا جائے گا۔",
  T_39_WZY_WS_CURVE: "کروو",
  T_39_WZY_WS_CUSTRESULT: "کسٹم میچ کا نتیجہ",
  T_39_WZY_WS_CYLINDERNAME: "بنیادی سلنڈر",
  T_39_WZY_WS_DEFAULT: "کوئی اینیمیشن نہیں (ڈیفالٹ)",
  T_39_WZY_WS_DESC: "ڈیسینڈنگ",
  T_39_WZY_WS_DIFFUSEALPHA: "سطح کی شفافیت",
  T_39_WZY_WS_DISCONNECT: "منقطع کرنا",
  T_39_WZY_WS_DOUBLEJUMPSHOE_ENERGYRECOVERY: "توانائی کی بحالی فی سیکنڈ",
  T_39_WZY_WS_DOUBLEJUMPSHOE_JUMCONSUME: "توانائی استعمال کریں",
  T_39_WZY_WS_DOUBLEJUMPSHOE_MAXJUMPH: "زیادہ سے زیادہ دوسری چھلانگ کی اونچائی",
  T_39_WZY_WS_ENABLEJOIN: "درمیان میں شامل ہونے کی اجازت دیں",
  T_39_WZY_WS_ENDPOS: "اختتامی پوائنٹ کوآرڈینیٹس",
  T_39_WZY_WS_ENGINETORQUE: "انجن ہارس پاور",
  T_39_WZY_WS_EXPLODED: "دھماکے سے ہونے والا نقصان",
  T_39_WZY_WS_FEELDSPEED: "نقل و حرکت کی رفتار کا فیصد (کمی)",
  T_39_WZY_WS_FLASH_CFLASHTIME: "سینٹر فلیش ٹائم",
  T_39_WZY_WS_FLASH_CRANGE: "سینٹر رینج",
  T_39_WZY_WS_FLASH_EFLASHTIME: "ایج فلیش ٹائم",
  T_39_WZY_WS_FLASH_HITEFFECTSWITCH: "فلیش بم ہٹ ایفیکٹ",
  T_39_WZY_WS_FLASH_RANGE: "دھماکے کی رینج",
  T_39_WZY_WS_FOLDWINGS_FALLSPEED: "ڈیسینڈنگ رفتار",
  T_39_WZY_WS_FOLDWINGS_FLYMAXH: "زیادہ سے زیادہ اونچائی",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDH: "ہاریزانٹل گلائیڈ رفتار",
  T_39_WZY_WS_FOLDWINGS_FLYSPEEDV: "ورٹیکل گلائڈ کی رفتار",
  T_39_WZY_WS_FOLDWINGS_MINENDH: "کم از کم اینڈ کی اونچائی",
  T_39_WZY_WS_FOLDWINGS_MINFLYH: "ٹیک آف کی کم از کم اونچائی",
  T_39_WZY_WS_FOLDWINGS_OVERHFALLSPEED: "سپر ہائی کے بعد ڈیسنٹ کی رفتار",
  T_39_WZY_WS_FOLDWINGS_TURNSPEED: "موڑنے کی رفتار",
  T_39_WZY_WS_FOLMOVENT: "پوزیشن فالونگ موشن اینٹیٹی",
  T_39_WZY_WS_GETSKILLLIST_NAMEDESC: "[کھلاڑی اینٹیٹی] کی مہارت کی فہرست حاصل کریں",
  T_39_WZY_WS_HB_BOOSTCD: "سپرنٹ کولڈاؤن",
  T_39_WZY_WS_HB_BOOSTDURATION: "سپرنٹ کا دورانیہ",
  T_39_WZY_WS_HB_BOOSTINITIAL: "اسکائی بورڈ پر اسپرنٹ کولڈاؤن",
  T_39_WZY_WS_HB_BOOSTINITIALSWITCH: "اسکائی بورڈ پر اسپرنٹ کولڈاؤن",
  T_39_WZY_WS_HB_BOOSTSPEED: "سپرنٹ کی رفتار",
  T_39_WZY_WS_HB_HOVERBCD: "اسکائی بورڈ کولڈاؤن",
  T_39_WZY_WS_HB_JUMPCD: "جمپ کولڈاؤن",
  T_39_WZY_WS_HB_JUMPH: "اسکائی بورڈ جمپ اونچائی",
  T_39_WZY_WS_HEADSCALE: "ہیڈ اسکیل",
  T_39_WZY_WS_HEADSHOTDESCALE: "ہیڈ شاٹ نقصان میں کمی",
  T_39_WZY_WS_INTITALSPEED: "ابتدائی رفتار",
  T_39_WZY_WS_INVENTORYBASE: "بنیادی آئٹم کی اقسام",
  T_39_WZY_WS_JETSHOE_BASEENERGYCOST: "توانائی کی قیمت فی سیکنڈ",
  T_39_WZY_WS_JETSHOE_BASEHSPEED: "بنیادی ہوریزونٹل رفتار",
  T_39_WZY_WS_JETSHOE_BASEVSPEED: "بنیادی ورٹیکل رفتار",
  T_39_WZY_WS_JETSHOE_DASHENERGYCOST: "ڈیش انرجی کی قیمت فی سیکنڈ",
  T_39_WZY_WS_JETSHOE_DASHHSPEED: "سپرنٹ ہوریزونٹل رفتار",
  T_39_WZY_WS_JETSHOE_RUSHDIS: "سپرنٹ کا فاصلہ",
  T_39_WZY_WS_JETSHOE_RUSHENERGYCOST: "رش انرجی کی قیمت فی سیکنڈ",
  T_39_WZY_WS_JETSHOE_RUSHVSPEED: "سپرنٹ ورٹیکل رفتار",
  T_39_WZY_WS_JETSHOE_UPENERGYCOST: "اوپر کی توانائی کی قیمت فی سیکنڈ",
  T_39_WZY_WS_LANDMINE_CANBEATTACK: "حملہ آور",
  T_39_WZY_WS_LANDMINE_CANSELFTRIGGER: "خود محرک",
  T_39_WZY_WS_LANDMINE_CANTEAMTRIGGER: "اتحادیوں کی طرف سے ٹرگر کیا جا سکتا ہے یا نہیں",
  T_39_WZY_WS_LANDMINE_CANVEHICLETRIGGER: "گاڑی سے متحرک",
  T_39_WZY_WS_LANDMINE_LIFETIME: "دورانیہ",
  T_39_WZY_WS_LANDMINE_STARTTIME: "ایکٹیویشن کا وقت",
  T_39_WZY_WS_LANDMINE_TRIGGERRADIUS: "ٹرگر ریڈیس",
  T_39_WZY_WS_LANDMINE_TRIGGERTIME: "ٹرگر ٹائم",
  T_39_WZY_WS_LEAVE: "چھوڑ دیں",
  T_39_WZY_WS_LIMBSCALE: "لمبز اسکیل",
  T_39_WZY_WS_LISTLOCSTR: "لوکلائزڈ ٹیکسٹ لسٹ",
  T_39_WZY_WS_LOADRESULT_NAME: "بیٹل کا نتیجہ اپ لوڈ کریں",
  T_39_WZY_WS_LOADRESULT_NAMEDESC: "[کھلاڑی] کا بیٹل کا نتیجہ اپ لوڈ کریں، بشمول [رینک]، [نتیجہ]، [اسکور کا نام]، [اسکور ویلیو]۔ نتیجہ کی قسم ایک انٹیجر ہے۔ فتح کے لیے 1، شکست کے لیے 2، بویاہ کے لیے 3، اور ڈرا کے لیے 4۔",
  T_39_WZY_WS_LOOKMOVENT: "گیز-فالونگ موشن اینٹیٹی",
  T_39_WZY_WS_MAXCOUNT: "زیادہ سے زیادہ مقدار",
  T_39_WZY_WS_MAXDISTANCE: "زیادہ سے زیادہ فاصلہ",
  T_39_WZY_WS_MINISENTRY_ANGELDOWN: "برج ڈپریشن اینگل",
  T_39_WZY_WS_MINISENTRY_ANGELSPEED: "برج اینگیولر رفتار",
  T_39_WZY_WS_MINISENTRY_ANGELUP: "برج بلندی کا اینگل",
  T_39_WZY_WS_MINISENTRY_DAM: "برج کا نقصان",
  T_39_WZY_WS_MINISENTRY_DEFENSE: "نقصان میں کمی کی شرح",
  T_39_WZY_WS_MINISENTRY_FIREANGLE: "فائرنگ اینگل",
  T_39_WZY_WS_MINISENTRY_HITCHANCE: "برج ہٹ ریٹ",
  T_39_WZY_WS_MINISENTRY_INTERVAL: "برج حملے کا وقفہ",
  T_39_WZY_WS_MINISENTRY_MAXCOUNT: "زیادہ سے زیادہ برج نمبر",
  T_39_WZY_WS_MINISENTRY_RANGE: "برج حملے کی رینج",
  T_39_WZY_WS_MOVEENT: "موشن اینٹیٹی",
  T_39_WZY_WS_NOCOMBINE: "ڈوول ویلڈایبل نہیں",
  T_39_WZY_WS_ONCE: "ایک بار",
  T_39_WZY_WS_ONDROP_NAMEDESC: "جب آئٹم کو [کھلاڑی اینٹیٹی] کے ذریعے رد کر دیا جاتا ہے تو واقعے کو ٹرگر کرتا ہے",
  T_39_WZY_WS_ONEQUIP_NAMEDESC: "واقعہ کو ٹرگر کرتا ہے جب آئٹم [کھلاڑی اینٹیٹی] کے ذریعہ لیس ہوتا ہے",
  T_39_WZY_WS_ONGRAPFIRE_NAMEDESC: "جب ہک گن فائر کرتی ہے تو واقعے کو ٹرگر کرتی ہے",
  T_39_WZY_WS_ONLANDSTART_NAMEDESC: "لینڈ مائن کے ایکٹیویٹ ہونے پر واقعے کو ٹرگر کرتا ہے۔",
  T_39_WZY_WS_ONLANDTRIGGER_NAMEDESC: "جب [کھلاڑی اینٹیٹی] کے ذریعے لینڈ مائن کو ٹرگر کیا جاتا ہے تو واقعے کو ٹرگر کرتا ہے",
  T_39_WZY_WS_ONMOTIONPAUSE_NAMEDESC: "جب اینٹیٹی کی حرکت رکنے پر ٹرگر ہوتا ہے۔",
  T_39_WZY_WS_ONMOTIONREATART_NAMEDESC: "اس وقت ٹرگر ہوتا ہے جب اینٹیٹی موقوف سے آگے بڑھ کر دوبارہ شروع ہوتی ہے",
  T_39_WZY_WS_ONMOTIONSTART_NAMEDESC: "اس وقت ٹرگر ہوتا ہے جب اینٹیٹی حرکت کرنا شروع کر دیتی ہے",
  T_39_WZY_WS_ONPICKUP_NAMEDESC: "جب آئٹم کو [کھلاڑی اینٹیٹی] کے ذریعے اٹھایا جاتا ہے تو واقعہ کو ٹرگر ہوتا ہے",
  T_39_WZY_WS_ONTHROWHIT_NAMEDESC: "اس واقعے کو ٹرگر کرتا ہے جب تھرو ایبل ٹارگٹ کو ہٹ کرتا ہے",
  T_39_WZY_WS_OPENATTACK: "آیا حملے کو فعال کرنا ہے",
  T_39_WZY_WS_PAUSEMOV_NAMEDESC: "موشن اینٹیٹی یا موشن اینٹیٹی لسٹ کو روکیں۔",
  T_39_WZY_WS_PAUSESOUND_NAME: "ساؤنڈ ایفیکٹ کو روکیں۔",
  T_39_WZY_WS_PAUSESOUND_NAMEDESC: "ساؤنڈ اینٹیٹی یا ساؤنڈ اینٹیٹی لسٹ کو روکیں",
  T_39_WZY_WS_PIANOTYPE: "میوزک کے کمپونینٹ کی قسم",
  T_39_WZY_WS_PINGPONG: "پنگ پونگ",
  T_39_WZY_WS_PLAYABLELIST: "موشن اینٹیٹی کی فہرست",
  T_39_WZY_WS_PLAYINGSTATUE: "اسٹیٹس",
  T_39_WZY_WS_PLAYMOV_NAMEDESC: "رکے ہوئی موشن اینٹیٹی یا موشن اینٹیٹی کی فہرست کو بحال کریں۔ دوبارہ سے شروع کرنے یا ری اسٹارٹ کرنے کا انتخاب کر سکتے ہیں۔",
  T_39_WZY_WS_PLAYSOUND_NAME: "پلے ساؤنڈ ایفیکٹس",
  T_39_WZY_WS_PLAYSOUND_NAMEDESC: "موقوف کردہ ساؤنڈ اینٹیٹی یا ساؤنڈ اینٹیٹی کی لسٹ کو بحال کریں۔ دوبارہ شروع کرنے یا دوبارہ شروع کرنے کا انتخاب کر سکتے ہیں۔",
  T_39_WZY_WS_PROCIRCLE_NAME: "پروگریس سرکل",
  T_39_WZY_WS_RAYINSPCON_NAMEDESC: "[ابتدائی کوآرڈینیٹس] سے [سمت] کے ساتھ ایک شعاع خارج کرتا ہے، [فاصلے] کے اندر پہلی ہستی کا پتہ لگاتا ہے، اور [ہٹ کی فہرست] اور [کوآرڈینیٹس ہٹ کی فہرست] لوٹاتا ہے۔",
  T_39_WZY_WS_RAYINSPSIN_NAMEDESC: "[ابتدائی کوآرڈینیٹس] سے [سمت] کے ساتھ ایک شعاع خارج کرتا ہے، [فاصلے] کے اندر پہلی اینٹیٹی کا پتہ لگاتا ہے، اور [اینٹیٹی ہٹ] اور [کوآرڈینیٹس ہٹ] کو لوٹاتا ہے۔",
  T_39_WZY_WS_REAHEALHP: "آرمر کی بازیابی کی ویلیو",
  T_39_WZY_WS_REAHEALTIME: "غیر موثر وقت کا وقفہ",
  T_39_WZY_WS_RELATCOORSYS: "ریلٹیو کوآرڈینیٹ سسٹم",
  T_39_WZY_WS_REPAIRARM: "مرمت کٹ",
  T_39_WZY_WS_REVERSE: "ریورس",
  T_39_WZY_WS_RIMALPHA: "ایج کی شفافیت",
  T_39_WZY_WS_SCORENAME: "اسکور کا نام",
  T_39_WZY_WS_SENDSIGN_NAMEDESC: "ٹارگٹ اینٹیٹی کو سگنل بھیجیں، اپ لوڈ کردہ پیرامیٹرز کی وضاحت پہلے سے طے شدہ سگنل کے پیرامیٹرز سے ہوتی ہے۔ تعریف کے وقت اینٹیٹی کی قسم کا انتخاب متعلقہ سگنل قبول کرنے والا ایونٹ جنریٹ کرے گا۔",
  T_39_WZY_WS_SETFOLMOV_NAMEDESC: "[ٹارگٹ اینٹیٹی] کے لیے حرکت کے بعد ایک پوزیشن بنائیں۔ [ٹارگٹ اینٹیٹی] [فالونگ اینٹیٹی] کو فالو کرتا ہے۔ [آفسیٹ کوآرڈینیٹس] [ٹارگٹ اینٹیٹی] اور [فالونگ اینٹیٹی] کے درمیان کوآرڈینیٹ آفسیٹ ہے۔ [کوآرڈینیٹ سسٹم] مندرجہ ذیل اینٹیٹی کی واقفیت کی بنیاد پر ورلڈ کوآرڈینیٹ سسٹم اور ریلیٹیو کوآرڈینیٹ سسٹم کو منتخب کر سکتا ہے۔ موشن بنانے کے بعد [پوزیشن فالونگ موشن اینٹیٹی] کو واپس کر دیا جائے گا۔",
  T_39_WZY_WS_SETLOOKMOV_NAMEDESC: "[ٹارگٹ اینٹیٹی] کے لیے ایک گیز-فالونگ موشن بنائیں۔ [ٹارگٹ اینٹیٹی] [فالونگ اینٹیٹی] کو فالو کرتا ہے۔ [آفسیٹ کوآرڈینیٹس] [ٹارگٹ اینٹیٹی] اور [فالونگ اینٹیٹی] کے درمیان کوآرڈینیٹ آفسیٹ ہے۔ [کوآرڈینیٹ سسٹم] مندرجہ ذیل اینٹیٹی کی واقفیت کی بنیاد پر ورلڈ کوآرڈینیٹ سسٹم اور ریلیٹیو کوآرڈینیٹ سسٹم کو منتخب کر سکتا ہے۔ موشن بنانے کے بعد [گیز-فالونگ موشن اینٹیٹی] کو واپس کر دیا جائے گا۔",
  T_39_WZY_WS_SHOE_FALLDAMSCALE: "گرنے پر نقصان کا فیصد",
  T_39_WZY_WS_SHOE_MAXENERGY: "زیادہ سے زیادہ انرجی",
  T_39_WZY_WS_SKILLLIST: "اسکل لسٹ",
  T_39_WZY_WS_SKILLTYPE: "کردار کی مہارت",
  T_39_WZY_WS_SMOKEG_EFFECTTIME: "سموک ایفیکٹ کا دورانیہ",
  T_39_WZY_WS_SMOOTH: "کیمرہ سوئچ",
  T_39_WZY_WS_SOUNDENTL: "ساؤنڈ ایفیکٹ اینٹیٹی لسٹ",
  T_39_WZY_WS_SOUNDENTLORSENT: "ساؤنڈ ایفیکٹ اینٹیٹی یا لسٹ",
  T_39_WZY_WS_SPRINTSPEED: "سپرنٹ کی رفتار کا فیصد",
  T_39_WZY_WS_SQUATSPEED: "نقل و حرکت کی رفتار کا فیصد (اسکواٹ)",
  T_39_WZY_WS_STARTCOO: "ابتدائی کوآرڈینیٹس",
  T_39_WZY_WS_STATE: "Play status",
  T_39_WZY_WS_TARGETVAL: "ٹارگٹ ویلیو",
  T_39_WZY_WS_THROWSPEED: "ہک فلائنگ کی رفتار",
  T_39_WZY_WS_TOWER_PARAM10: "روٹیشن اینگل",
  T_39_WZY_WS_TOWER_PARAM11: "برج کا اسٹیٹس",
  T_39_WZY_WS_TOWER_PARAM12: "اینٹیٹی ID",
  T_39_WZY_WS_TOWER_PARAM9: "اٹیک ٹارگٹ",
  T_39_WZY_WS_TOWSPEED: "کھلاڑی کی سفر کی رفتار",
  T_39_WZY_WS_TWEENCURVE_NAME: "کسٹم کروو",
  T_39_WZY_WS_TWEENCURVE_NAMEDESC: "کسٹم کروو کو انٹرپولیشن موشن کے لیے استعمال کیا جا سکتا ہے",
  T_39_WZY_WS_TWEENENT: "انٹرپولیشن موشن اینٹیٹی",
  T_39_WZY_WS_TWEENPLAYST_NAME: "حرکت کے طریقے",
  T_39_WZY_WS_TWEENPLAYST_NAMEDESC: "انٹرپولیشن موشن کے طریقے",
  T_39_WZY_WS_TWEENSTYLE: "طریقہ",
  T_39_WZY_WS_UNLOADSCRIPT_NAMEDESC: "[اینٹیٹی] کے لیے اسکرپٹ [اسکرپٹ کا نام] کو حذف کریں",
  T_39_WZY_WS_UPSET_NAMEDESC: "درج کردہ ایلیمینٹس کو بے ترتیب بنائیں",
  T_39_WZY_WS_VISIBLEONBACK: "پیچھے پر نظر آتا ہے",
  T_39_WZY_WS_WEAPCOMBINET: "ڈوول ویلڈنگ ہتھیار کی قسم",
  T_39_WZY_WS_WEAPON_KNOCKDOWNDAM: "ڈاونڈ پر اضافی نقصان",
  T_39_WZY_WS_WEAPON_ONCEAMMO: "سنگل شاٹ بولٹ نمبر",
  T_39_WZY_WS_WEAREPLAY: "حرکت دوبارہ شروع کریں؟",
  T_39_WZY_WS_WORLDCOORSYS: "ورلڈ کوآرڈینیٹ سسٹم",
  T_39_XXJ_WS_ADDFRIEND: "دوست شامل کریں",
  T_39_XXJ_WS_ALLOWZ: "پلیئر x محور حرکت کو فعال کریں",
  T_39_XXJ_WS_BLOCKMODEDESC: "کیمرے کی حرکت جب کیمرے اور ٹاڑگٹ کے درمیان کوئی چیز ہو",
  T_39_XXJ_WS_CAMERADISTANCE: "ٹارگٹ سے فاصلہ",
  T_39_XXJ_WS_CAMERATYPEDESC: "متعدد قسم کے پری سیٹ اور کسٹم کیمرہ فراہم کیے گئے ہیں",
  T_39_XXJ_WS_CAMERAUSER: "کیمرہ استعمال کرنے والا",
  T_39_XXJ_WS_CURENTCAMERA: "کیمرہ استعمال کیا گیا",
  T_39_XXJ_WS_DETAILS: "میچ کی تفصیلات",
  T_39_XXJ_WS_FFECONOMY: "معیشت",
  T_39_XXJ_WS_FOCUSTARGET: "ہدف کا مشاہدہ کیا گیا",
  T_39_XXJ_WS_FOLLOWTARGET: "ٹارگٹ کو فالو کیا گیا",
  T_39_XXJ_WS_GAMERESULT: "میچ کا نتیجہ",
  T_39_XXJ_WS_GAMETITLE1: "میچ 1",
  T_39_XXJ_WS_GAMETITLE2: "میچ 2",
  T_39_XXJ_WS_GIFT: "تحفہ",
  T_39_XXJ_WS_HORIZONTALANGLEDESC: "کیمرے کا ہاریزانٹل روٹیشن اینگل",
  T_39_XXJ_WS_INVISICAM: "پارباسی",
  T_39_XXJ_WS_INVISICAMDESC: "کیمرے اور ہدف کے درمیان آبجیکٹ پارباسی ہو جاتا ہے",
  T_39_XXJ_WS_LEFTSCORE: "بائیں ٹیم کا اسکور",
  T_39_XXJ_WS_LIKE: "لائک",
  T_39_XXJ_WS_LOBBY: "لابی",
  T_39_XXJ_WS_MAINSCORENAME: "کل سکور کا نام",
  T_39_XXJ_WS_MAINSCORENUM: "ٹوٹل اسکور نمبر",
  T_39_XXJ_WS_MAPEVALUATE: "نقشے کی درجہ بندی",
  T_39_XXJ_WS_MULTITEAMRESULTHUD: "متعدد ٹیمز کا نتیجہ",
  T_39_XXJ_WS_MVP1: "MVP 1",
  T_39_XXJ_WS_MVP2: "MVP 2",
  T_39_XXJ_WS_OFFSET2: "مشاہداتی پوائنٹ آفسیٹ",
  T_39_XXJ_WS_OFFSET2DESC: "عام طور پر کھلاڑی کی اصل پوزیشن سے متعلق کیمرے کے فوکس پوائنٹ کے آفسیٹ سے مراد ہے۔ (مطلب کیمرے کی قسم کے لحاظ سے مختلف ہوتا ہے)",
  T_39_XXJ_WS_OFFSETDESC: "عام طور پر کھلاڑی کی اصل پوزیشن سے متعلق کیمرے کی پوزیشن کے آفسیٹ سے مراد ہے۔ (مطلب کیمرے کی قسم کے لحاظ سے مختلف ہوتا ہے)",
  T_39_XXJ_WS_ORTHOGONAL: "آرتھوگونل",
  T_39_XXJ_WS_ORTHOGONALDESC: "کیمرا دور اور قریب کے ٹارگٹس کو ایک ہی سائز کے طور پر پیش کرتا ہے۔",
  T_39_XXJ_WS_PERSPECTIVE: "نقطہ نظر",
  T_39_XXJ_WS_PERSPECTIVEDESC: "کیمرہ ٹارگٹ کا مشاہدہ کرنے کے لیے تناظر پروجیکشن کا استعمال کرتا ہے",
  T_39_XXJ_WS_PROJECTIONMODEDESC: "رینڈر کرتے وقت کیمرے کی تصویر کی تشکیل",
  T_39_XXJ_WS_RANK1: "ٹیم رینک",
  T_39_XXJ_WS_RANK2: "پلیئر رینک",
  T_39_XXJ_WS_REPORT: "رپورٹ",
  T_39_XXJ_WS_REVIEW: "ری پلے",
  T_39_XXJ_WS_RIGHTSCORE: "رائٹ ٹیم اسکور",
  T_39_XXJ_WS_SCORENUM1: "اسکور 1",
  T_39_XXJ_WS_SCORENUM2: "سکور 2",
  T_39_XXJ_WS_SCORENUM3: "سکور 3",
  T_39_XXJ_WS_SCORENUM4: "سکور 4",
  T_39_XXJ_WS_SCORENUM5: "سکور 5",
  T_39_XXJ_WS_SCORETITLELIST: "اسکور کے نام کی فہرست",
  T_39_XXJ_WS_SHARE: "شیئر",
  T_39_XXJ_WS_SPECTATORSWITCH: "سپیکٹیٹر",
  T_39_XXJ_WS_STABLE: "مستحکم",
  T_39_XXJ_WS_STABLEDESC: "کیمرہ مستحکم رہتا ہے اگر کیمرہ اور فالو کی گئی اینٹیٹی کے درمیان کوئی چیز موجود ہو۔",
  T_39_XXJ_WS_TEAMNAME1: "بائیں ٹیم کا نام",
  T_39_XXJ_WS_TEAMNAME2: "رائٹ ٹیم کا نام",
  T_39_XXJ_WS_TEAMRANK: "ٹیم رینک",
  T_39_XXJ_WS_TRANSITIONTIME: "کیمرہ ٹرانزیشن ٹائم",
  T_39_XXJ_WS_TRANSITIONTYPE: "کیمرہ ٹرانزیشن ٹائپ",
  T_39_XXJ_WS_TWOTEAMRESULTHUD: "2 ٹیموں کا نتیجہ",
  T_39_XXJ_WS_VERTICALANGLEDESC: "کیمرے کا ورٹیکل روٹیشن اینگل",
  T_39_XXJ_WS_ZOOM: "زوم",
  T_39_XXJ_WS_ZOOMDESC: "کیمرہ زوم ان ہوتا ہے اگر کیمرہ اور فالو اینٹیٹی کے درمیان کوئی چیز موجود ہو۔",
  T_39_XYL_WS_LIGHTINTENSITY: "روشنی کی شدت",
  T_39_XYL_WS_LIGHTRANGE: "لائٹ رینج",
  T_39_XYL_WS_POINTLIGHT: "پوائنٹ لائٹ",
  T_39_XYL_WS_WATERZONE: "کسٹم واٹر زون",
  T_40_B_DISABLE_RECONNECT: "Disable Auto-reconnection",
  T_40_CJ_T_SHUTTLECOCK_BLACK: "Midnight Jersey",
  T_40_CJ_T_SHUTTLECOCK_RED2: "Arctic Blaze Jersey",
  T_40_CJ_T_SHUTTLECOCK_REDBLACK: "Cherry Coal Jersey",
  T_40_CJ_T_SHUTTLECOCK_YELLOW: "Sunny Sky Jersey",
  T_40_CJ_T_SPORTSWEAR_FIRE: "Flame Up Jersey",
  T_40_DYEING_CLEAR: "Clear Coloring Status",
  T_40_HJ_WS_EFFECT32: "Sneakers",
  T_40_HJ_WS_EFFECT33: "Explosion",
  T_40_HJ_WS_EFFECT34: "Spawnpoint",
  T_40_HJ_WS_EFFECT35: "Laser",
  T_40_HJ_WS_EFFECT36: "Ammo",
  T_40_HJ_WS_EFFECT37: "Hit Effect",
  T_40_HJ_WS_EFFECT38: "Firing Effect",
  T_40_HJ_WS_EFFECT43: "Spider Web",
  T_40_HJ_WS_EFFECT44: "Releasing a Skill",
  T_40_HJ_WS_SOUND69: "Opening a Box",
  T_40_HJ_WS_SOUND70: "Level Up",
  T_40_HJ_WS_SOUND71: "Level Maxed",
  T_40_HJ_WS_SOUND72: "Tapping a Button",
  T_40_HJ_WS_SOUND73: "Countdown 1",
  T_40_HJ_WS_SOUND74: "Whistle",
  T_40_HJ_WS_SOUND75: "Game Over",
  T_40_HJ_WS_SOUND76: "Forward",
  T_40_HJ_WS_SOUND77: "Booyah",
  T_40_HJ_WS_SOUND78: "Checkpoint",
  T_40_HJ_WS_SOUND79: "Countdown 2",
  T_40_HJ_WS_SOUND80: "Game Starts",
  T_40_HJ_WS_SOUND81: "Obtained Many Coins",
  T_40_HJ_WS_SOUND82: "Obtained Coins",
  T_40_HJ_WS_SOUND83: "Obtained Some Coins",
  T_40_HJ_WS_SOUND84: "Joined the Game",
  T_40_HJ_WS_SOUND85: "Opening Guild Supply",
  T_40_HJ_WS_SOUND86: "Horn",
  T_40_HJ_WS_SOUND87: "Eliminated a Boss",
  T_40_HJ_WS_SOUND88: "Opening War Chest",
  T_40_HJ_WS_SOUND89: "Explosive Paint Skill",
  T_40_HJ_WS_SOUND90: "Bullet Hitting",
  T_40_HJ_WS_SOUND91: "Paint Shield Skill",
  T_40_HJ_WS_SOUND92: "Tapping a Disabled Button",
  T_40_HJ_WS_SOUND93: "Skill Charging Complete",
  T_40_HJ_WS_SOUND95: "Laser Skill",
  T_40_HJ_WS_SOUND96: "Get Item 2",
  T_40_HJ_WS_SOUND97: "Game Over 2",
  T_40_HJ_WS_SOUND98: "Elimination Notification",
  T_40_HJ_WS_SOUNDTYPE_BMG: "Background Music",
  T_40_HJ_WS_SOUNDTYPE_INGAME: "In-Match Sound Effect",
  T_40_HJ_WS_SOUNDTYPE_UI: "UI Widget Sound Effect",
  T_40_JH_WS_MAPTAG1: "Color Game",
  T_40_JH_WS_MAPTAG10: "Color Hide N Seek",
  T_40_JH_WS_MAPTAG11: "Anniversary",
  T_40_JH_WS_MAPTAG12: "Role Play",
  T_40_JH_WS_MAPTAG13: "Simulation",
  T_40_JH_WS_MAPTAG14: "Asymmetrical",
  T_40_JH_WS_MAPTAG15: "Resource Battle",
  T_40_JH_WS_MAPTAG16: "Cart Escort",
  T_40_JH_WS_MAPTAG17: "Official Map",
  T_40_JH_WS_MAPTAG18: "Mini Game",
  T_40_JH_WS_MAPTAG19: "Speed Challenge",
  T_40_JH_WS_MAPTAG2: "Color Spray",
  T_40_JH_WS_MAPTAG20: "Roguelike",
  T_40_JH_WS_MAPTAG3: "Color Fight",
  T_40_JH_WS_MAPTAG4: "Color Fight",
  T_40_JH_WS_MAPTAG5: "Color Playground",
  T_40_JH_WS_MAPTAG6: "Playground Color",
  T_40_JH_WS_MAPTAG7: "Color Party",
  T_40_JH_WS_MAPTAG8: "Color Parkour",
  T_40_JH_WS_MAPTAG9: '"Spider-Verse" Parkour',
  T_40_JH_WS_TAG30: "Tycoon",
  T_40_JH_WS_TAG31: "Home-Wreck Havoc",
  T_40_JH_WS_TAG32: "Mystery Town",
  T_40_JH_WS_TAG33: "Dawn Crisis",
  T_40_JH_WS_TAG34: "Death Uprising",
  T_40_JH_WS_TAG35: "Fist Fight",
  T_40_JH_WS_TAG36: "Old Factory Roof",
  T_40_JH_WS_UGCTOKENNAME: "Craftland Token",
  T_40_L_QUICKMESSAGE_MODE2: "Clash Squad",
  T_40_M_WS_HIS: "of",
  T_40_SP_WS_DYEING: "Color",
  T_40_SP_WS_DYEING_AREA: "Area Coloring",
  T_40_SP_WS_DYEING_COLOR: "Color number",
  T_40_SP_WS_DYEING_COUNT: "Coloring Count",
  T_40_SP_WS_DYEING_DIR: "Coloring Direction",
  T_40_SP_WS_DYEING_DIS: "Coloring Distance",
  T_40_SP_WS_DYEING_FIXEDDYEINGRANGE: "Fixed Coloring Area",
  T_40_SP_WS_DYEING_NORMAL: "Normal",
  T_40_SP_WS_DYEING_PLANE: "Plane Area Coloring",
  T_40_SP_WS_DYEING_POSITION: "Coordinate",
  T_40_SP_WS_DYEING_RANDOMDECAY: "Random Coloring Rate Decay",
  T_40_SP_WS_DYEING_RANDOMRATIO: "Random Coloring Rate",
  T_40_SP_WS_DYEING_RANGE: "Coloring Area",
  T_40_SP_WS_DYEING_STATE: "Coloring Status",
  T_40_SP_WS_FACTIONTIPS_11: "Purple",
  T_40_SP_WS_SHOE_CURENERGY: "Current Energy",
  T_40_SW_SKILL_Name_Nanoscientist: "Nano Lifeshield",
  T_40_SY_AK47_PENGUIN_W_N: "AK47 - Waggor's Wonder",
  T_40_SY_CHARACTER_DJMALE_AWAKENING_N: "Awakened Alok",
  T_40_SY_CHARACTER_NANOSCIENTIST_N: "Sonia",
  T_40_SY_FAMAS_PENGUIN_W_N: "FAMAS - Waggor's Wonder",
  T_40_SY_M1014_PENGUIN_W_N: "M1014 - Waggor's Wonder",
  T_40_SY_M24_PENGUIN_W_N: "M24 - Waggor's Wonder",
  T_40_SY_MINI_PENGUIN_W_N: "AC80 - Waggor's Wonder",
  T_40_SY_PET_PUG_N: "Pug",
  T_40_SY_PETSKIN_ALIEN_TIGHTGUY_N: 'Pet Skin: "Spider-Verse" Moony',
  T_40_SY_PETSKIN_FLYINGCREATURE_ME_N: "Pet Skin: Electric Arvon",
  T_40_SY_PETSKIN_PUG_BLACK_N: "Pet Skin: Laser Eyes Pug",
  T_40_SY_PETSKIN_PUG_GREEN_N: "Pet Skin: Aloha Pug",
  T_40_SY_PETSKIN_PUG_ORANGE_N: "Pet Skin: Tigerstripe Pug",
  T_40_SY_SCAR_PENGUIN_W_N: "SCAR - Waggor's Wonder",
  T_40_SY_THOMPSON_PENGUIN_W_N: "Thompson - Waggor's Wonder",
  T_40_SY_UMP45_PENGUIN_W_N: "UMP - Waggor's Wonder",
  T_40_SY_USP45_PENGUIN_W_N: "USP - Waggor's Wonder",
  T_40_SY_UZI_PENGUIN_W_N: "Mini Uzi - Waggor's Wonder",
  T_40_V_WS_INPUT_TEXT_ACTIVE: "Activate Text Content",
  T_40_V_WS_INPUT_TEXT_DEFAULT: "Placeholder Text Content",
  T_40_W_DJMALE_AWAKENING_D: "Awakening: While the aura is active, music notes that last for [FFB300]{2}s[-] will be dropped [FFB300]{1}m[-] behind the skill user every [FFB300]{0}s[-]. Teammates who pick up the music note will receive the same effect as the aura.",
  T_40_W_DJMALE_AWAKENING_N: "Party Remix",
  T_40_W_NURSE_D: "Spread [FFB300]{0}%[-] of the user's single-target healing effects (skill, Med Kit, heal gun, etc.) to teammates within [FFB300]{1}m[-] of the user.",
  T_40_WH_MP_BOXING_NAME: "Boxing Match",
  T_40_WH_MP_C_PACK: "Unlawful Backpack",
  T_40_WH_MP_EXCH_COIN: "Cash",
  T_40_WH_MP_EXCH_TEMPCOIN: "Unlawful Money",
  T_40_WH_MP_PAYCHECK: "Wages",
  T_40_WT_SKILL_DESC_MUSICBRO_BLACK: "The speed of helping up teammates is increased by [FFB300]{0}%[-]. Cooldown: [FFB300]{3}s[-]. The helped up teammate recovers [FFB300]{2} HP[-] in [FFB300]{1}s[-].",
  T_40_WT_SKILL_DESC_MUSICBRO_WHITE2: "Creates a [FFB300]{0}m-radius[-] healing zone. Inside, user and allies recover [FFB300]{1} HP/s[-]. Help up will be automatically triggered when needed. Zone lasts for [FFB300]{2}s[-]. The effects of helping up teammates can be enhanced by other skills. Cooldown: [FFB300]{3}s[-].",
  T_40_WT_WS_ICONENTITY_PARAM6: "Method of display",
  T_40_WZY_WS_CUSTOMTRIGGER_CAPSULE: "Capsule",
  T_40_WZY_WS_CUSTOMTRIGGER_HEIGHT: "Height",
  T_40_WZY_WS_CUSTOMTRIGGER_RADIUS: "Radius",
  T_40_WZY_WS_CUSTOMTRIGGER_SPHERE: "Sphere",
  T_40_WZY_WS_FONT_FF_CN_T: "FZLanTingHei-R-BIG5",
  T_40_WZY_WS_FONT_HINDSILIGURI: "Hind Siliguri",
  T_40_WZY_WS_FONT_NOTONASTALIQURDU: "Noto Nastaliq Urdu",
  T_40_WZY_WS_FONT_NOTOSANS: "GFF Devanagari",
  T_40_WZY_WS_FONT_SIMPBDO: "Simplified Arabic",
  T_40_WZY_WS_FONT_SUPERMARKET: "Supermarket",
  T_40_WZY_WS_ICONENTITY_COLOR: "Color",
  T_40_WZY_WS_ICONENTITY_FILLED: "Progressive",
  T_40_WZY_WS_ICONENTITY_ICONTYPE: "Image Resources",
  T_40_WZY_WS_ICONENTITY_NAME: "Icon object",
  T_40_WZY_WS_ICONENTITY_RENDERTYPE: "Method of display",
  T_40_WZY_WS_ICONENTITY_SIMPLE: "Simple",
  T_40_WZY_WS_ICONENTITY_SLICED: "9-Grid",
  T_40_WZY_WS_ICONENTITY_TILED: "Tiles",
  T_40_WZY_WS_NEWMAPTAG: "New Map Icon",
  T_40_WZY_WS_NEWVFX1: "Halo",
  T_40_WZY_WS_NEWVFX10: "Curse",
  T_40_WZY_WS_NEWVFX11: "Freeze Zone",
  T_40_WZY_WS_NEWVFX12: "Cold Air",
  T_40_WZY_WS_NEWVFX13: "Snowflake",
  T_40_WZY_WS_NEWVFX14: "Flame",
  T_40_WZY_WS_NEWVFX15: "Light Beam",
  T_40_WZY_WS_NEWVFX16: "Spread of Poison Gas",
  T_40_WZY_WS_NEWVFX17: "Poison Gas",
  T_40_WZY_WS_NEWVFX18: "Explosive Blaze",
  T_40_WZY_WS_NEWVFX19: "Light Effect",
  T_40_WZY_WS_NEWVFX2: "Bubble",
  T_40_WZY_WS_NEWVFX20: "Star",
  T_40_WZY_WS_NEWVFX3: "Ash",
  T_40_WZY_WS_NEWVFX4: "Stone Splash",
  T_40_WZY_WS_NEWVFX5: "Line",
  T_40_WZY_WS_NEWVFX6: "Flicker",
  T_40_WZY_WS_NEWVFX7: "Ring",
  T_40_WZY_WS_NEWVFX8: "Rising Particle",
  T_40_WZY_WS_NEWVFX9: "Smoke",
  T_40_WZY_WS_PRESENTTXT_FONTSIZE: "Font Size",
  T_40_WZY_WS_PRESENTTXT_FONTSTYLE: "Font Style",
  T_40_WZY_WS_TEXTENTITY_FONTTYPE: "Font",
  T_40_WZY_WS_TEXTENTITY_NAME: "Text object",
  T_40_WZY_WS_UIFONT_LATIN: "Agency FB",
  T_40_WZY_WS_UIFONT_LATIN_BOLD: "GFF Latin",
  T_40_XXJ_WS_ACTIONHUD: "Interaction button HUD component",
  T_40_XXJ_WS_ACTIVEINHIERARCHY_DESCKEY: 'Whether it can be used in the scenery. This is read only and depends on "Parent available or not" and "Activity status".',
  T_40_XXJ_WS_ACTIVEPARENT_DESCKEY: "Whether all parents are active. This is read only and not visible to players.",
  T_40_XXJ_WS_ACTIVEPARENT_NAMEKEY: "Parent available or not",
  T_40_XXJ_WS_ACTIVESELF_DESCKEY: "Display when the open status is true, otherwise closed",
  T_40_XXJ_WS_ACTIVESELF1_DESCKEY: 'Whether it can be active on self. To use in the scenery, you must use "Active in scenery or not". This is read only and configured using an API.',
  T_40_XXJ_WS_ADDORREMOVECAMERACULLINGMASK_DESCKEY: "Whether the camera's cullingMask is visible to a certain layer",
  T_40_XXJ_WS_ADDTOKENATPOSITION_DESCKEY: "Generate tokens at a certain place",
  T_40_XXJ_WS_ADDTOKENTOPLAYER_DESCKEY: "The lootable item to give to the player",
  T_40_XXJ_WS_AFORWARD_DESCKEY: "Current orientation of the player",
  T_40_XXJ_WS_AFORWARD_NAMEKEY: "Direction",
  T_40_XXJ_WS_AIREALATTACKENTITY_DESCKEY: "The AI is attacking the entity",
  T_40_XXJ_WS_AITARGET_DESCKEY: "The attacking AI",
  T_40_XXJ_WS_ALIGNMENT_DESCKEY: "The align style",
  T_40_XXJ_WS_ALIGNMENT_NAMEKEY: "Horizontal align",
  T_40_XXJ_WS_ALIGNMENTVERTICAL_NAMEKEY: "Vertical align",
  T_40_XXJ_WS_ALPHA_DESCKEY: "Transparency",
  T_40_XXJ_WS_AMMOINCLIP_DESCKEY: "The remaining ammo count",
  T_40_XXJ_WS_AMMOINCLIP_NAMEKEY: "Remaining ammo",
  T_40_XXJ_WS_ANCHORMAX: "Maximum Anchor",
  T_40_XXJ_WS_ANCHORMIN: "Minimum Anchor",
  T_40_XXJ_WS_APOSITION_DESCKEY: "Current position of the player",
  T_40_XXJ_WS_APOSITION_NAMEKEY: "Position",
  T_40_XXJ_WS_ARMORHUD_NAMEKEY: "Armor HUD switch",
  T_40_XXJ_WS_ASSETCONFIGID_NAMEKEY: "Configured asset ID",
  T_40_XXJ_WS_ASSETID_NAMEKEY: "Asset ID",
  T_40_XXJ_WS_ATTACKENTITY_NAMEKEY: "Target of attack",
  T_40_XXJ_WS_ATTACKGRENADE_NAMEKEY: "Attack throwables",
  T_40_XXJ_WS_ATTACKTARGET_DESCKEY: "The entity that is being attacked by the AI",
  T_40_XXJ_WS_ATTACKTARGET_NAMEKEY: "Target attacked",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_DESCKEY: "The available coordinates of spawnpoints",
  T_40_XXJ_WS_AVAILABLEPOSVEC3_NAMEKEY: "Available coordinates",
  T_40_XXJ_WS_BACKGROUND_DESCKEY: "The bottom image",
  T_40_XXJ_WS_BACKGROUND_NAMEKEY: "Background",
  T_40_XXJ_WS_BAGHUD_NAMEKEY: "Backpack",
  T_40_XXJ_WS_BGALPHA_NAMEKEY: "Background transparency",
  T_40_XXJ_WS_BGCOLOR_DESCKEY: "Background color",
  T_40_XXJ_WS_BGCOLOR_NAMEKEY: "Background color",
  T_40_XXJ_WS_BGFILL_DESCKEY: "Whether to fill the background",
  T_40_XXJ_WS_BGFILL_NAMEKEY: "Background fill",
  T_40_XXJ_WS_BGNAME_DESCKEY: "Background name",
  T_40_XXJ_WS_BGNAME_NAMEKEY: "Background name",
  T_40_XXJ_WS_BGSIZEDELTA_DESCKEY: "Background size delta",
  T_40_XXJ_WS_BGSIZEDELTA_NAMEKEY: "Background size delta",
  T_40_XXJ_WS_BLUE: "Blue",
  T_40_XXJ_WS_BODY_DESCKEY: "Torso",
  T_40_XXJ_WS_BODY_NAMEKEY: "Torso",
  T_40_XXJ_WS_BONESCALE_NAMEKEY: "Skeleton scale",
  T_40_XXJ_WS_BORNPOSITIONVEC3_DESCKEY: "The player's spawnpoint",
  T_40_XXJ_WS_BORNPOSITIONVEC3_NAMEKEY: "Spawn point",
  T_40_XXJ_WS_BOTH: "Either",
  T_40_XXJ_WS_BUTTONNAME: "Button component name",
  T_40_XXJ_WS_CAMERA_DESCKEY: "Camera",
  T_40_XXJ_WS_CAMERADIR_DESCKEY: "The direction that the client camera is facing",
  T_40_XXJ_WS_CAMERAPOS_DESCKEY: "The location of the client camera",
  T_40_XXJ_WS_CAMERARAYCASTHUD_DESCKEY: "Detect the camera line of the client",
  T_40_XXJ_WS_CAMERARAYCASTHUD_NAMEKEY: "Camera ray detection",
  T_40_XXJ_WS_CANCELDRAGIFFITS_DESCKEY: "Stop dragging when coinciding with the viewport",
  T_40_XXJ_WS_CANCELDRAGIFFITS_NAMEKEY: "Exit drag after fit",
  T_40_XXJ_WS_CAPSULEHEIGHT_DESCKEY: "The distance between the center of the semicircles of the pill shape. It cannot be smaller than twice the radius of the sphere.",
  T_40_XXJ_WS_CELLSIZE_DESCKEY: "Cell size",
  T_40_XXJ_WS_CELLSIZE_NAMEKEY: "Child cell height",
  T_40_XXJ_WS_CELLVALUE: "Read the content of a certain cell and return an object",
  T_40_XXJ_WS_CENTER_DESCKEY: "The world coordinates that corresponds to the minimap's center. 0 by default.",
  T_40_XXJ_WS_CENTER_NAMEKEY: "Minimap center",
  T_40_XXJ_WS_CENTEROFFSET_DESCKEY: "The offset of the button's position",
  T_40_XXJ_WS_CENTEROFFSET_NAMEKEY: "Position offset",
  T_40_XXJ_WS_CENTEROFMASS_DESCKEY: "The center of mass relative to the local coordinates",
  T_40_XXJ_WS_CENTEROFMASS_NAMEKEY: "Center of mass",
  T_40_XXJ_WS_CENTRALLINEACTIVE_DESCKEY: "Whether to display the middle line",
  T_40_XXJ_WS_CENTRALLINEACTIVE_NAMEKEY: "Display middle line or not",
  T_40_XXJ_WS_CENTRALLINEPOS_DESCKEY: "Middle line position [0,1]",
  T_40_XXJ_WS_CENTRALLINEPOS_NAMEKEY: "Middle line position",
  T_40_XXJ_WS_CHASERANGE: "Chase Vicinity",
  T_40_XXJ_WS_CHASETARGET_DESCKEY: "The entity that is being chased by the AI",
  T_40_XXJ_WS_CHASETARGET_NAMEKEY: "Target chased",
  T_40_XXJ_WS_CHILD_DESCKEY: "Child entity",
  T_40_XXJ_WS_CHILDINDEX_NAMEKEY: "Parent's children",
  T_40_XXJ_WS_CHITPOS_DESCKEY: "The point that is hit by the camera line",
  T_40_XXJ_WS_CHOOSECARHUD: "Select card HUD entity",
  T_40_XXJ_WS_CLAMP_DESCKEY: "If the parameter is within the numerical range between the minimum and maximum values, the function will return the value of the parameter; if the parameter is greater than the range, the function will return the maximum value; if the argument is less than the range, the function will return the minimum value",
  T_40_XXJ_WS_CLEARALLCHILDREN_DESCKEY: "Only supports entities that have the Transform component. Currently constrained to all objects.",
  T_40_XXJ_WS_CLICKSIZE_DESCKEY: "The size of the click area",
  T_40_XXJ_WS_CLICKSIZE_NAMEKEY: "Click size",
  T_40_XXJ_WS_CLIPPINGTYPE_DESCKEY: "Clipping type",
  T_40_XXJ_WS_CLIPPINGTYPE_NAMEKEY: "Clipping type",
  T_40_XXJ_WS_CLONEENT_D: "Clone the selected entity and its attributes while keeping the original parent. If Level Object is selected, it will be based on Create Level Object.",
  T_40_XXJ_WS_CLOTHES_DESCKEY: "The list of outfits",
  T_40_XXJ_WS_CLOTHID_DESCKEY: "The outfit ID",
  T_40_XXJ_WS_CLOTHID_NAMEKEY: "Outfit ID",
  T_40_XXJ_WS_CLOTHID1_DESCKEY: "The outfit ID",
  T_40_XXJ_WS_COL_DESC: "The column to read.",
  T_40_XXJ_WS_COLNAME_DESC: "The name of the column to be read.",
  T_40_XXJ_WS_COLOR_DESCKEY: "Color",
  T_40_XXJ_WS_COLOR_NAMEKEY: "Value",
  T_40_XXJ_WS_COLOR1_DESCKEY: "Add color layers using the RGBA color channel. A channel value lies in between 0 and 255 and is stored in an Int32. White (255, 255, 255, 255) by default.",
  T_40_XXJ_WS_COLOR2_DESCKEY: "Color of the progress bar",
  T_40_XXJ_WS_COLOR3_DESCKEY: "The type of the RGBA color channel, which ranges from 0 to 255",
  T_40_XXJ_WS_COLOR4_DESCKEY: "The color of the text",
  T_40_XXJ_WS_COLOR5_DESCKEY: "The color of the HUD",
  T_40_XXJ_WS_COLOR6_DESCKEY: "The color of the lighting",
  T_40_XXJ_WS_COLORA_DESCKEY: "The A color value",
  T_40_XXJ_WS_COLORB_DESCKEY: "The B color value",
  T_40_XXJ_WS_COLORBAR_NAMEKEY: "Progress bar color",
  T_40_XXJ_WS_COLORDRUM_DESCKEY: "Color barrel",
  T_40_XXJ_WS_COLORDRUM_NAMEKEY: "Color Barrel",
  T_40_XXJ_WS_COLORG_DESCKEY: "The G color value",
  T_40_XXJ_WS_COLORGETCHANNEL_DESCKEY: "Obtain the RGBA channel",
  T_40_XXJ_WS_COLORGUN: "Rainbow Spray Rifle",
  T_40_XXJ_WS_COLORGUN_01: "Rainbow Spray Rifle (Red)",
  T_40_XXJ_WS_COLORGUN_02: "Rainbow Spray Rifle (Yellow)",
  T_40_XXJ_WS_COLORGUN_03: "Rainbow Spray Rifle (Blue)",
  T_40_XXJ_WS_COLORGUN_04: "Rainbow Spray Rifle (Green)",
  T_40_XXJ_WS_COLORGUN_05: "Rainbow Spray Rifle (Purple)",
  T_40_XXJ_WS_COLORR_DESCKEY: "The R color value",
  T_40_XXJ_WS_COLORTEXT_NAMEKEY: "Text color",
  T_40_XXJ_WS_COLVALUE: "Column Content",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_DESCKEY: "The HUD entity of a general HUD switch",
  T_40_XXJ_WS_COMMONHUDSWITCHCONTROLLER_NAMEKEY: "HUD entity of general HUD switch",
  T_40_XXJ_WS_CONSTRAINT_DESCKEY: "Constraint",
  T_40_XXJ_WS_CONSTRAINT_NAMEKEY: "Constraint",
  T_40_XXJ_WS_CONSTRAINTCOUNT_DESCKEY: "The number of constraints",
  T_40_XXJ_WS_CONSTRAINTCOUNT_NAMEKEY: "Constraint count",
  T_40_XXJ_WS_CONTENTORIGIN_DESCKEY: "Original content",
  T_40_XXJ_WS_CONTENTORIGIN_NAMEKEY: "Default direction",
  T_40_XXJ_WS_CONTENTORIGIN2_DESCKEY: "The starting point of the scroll. Upper left corner by default.",
  T_40_XXJ_WS_CREATEMAPBITENTITY_DESCKEY: "Generate a static pixel for a certain object in the map. The pixel will not move with the object.",
  T_40_XXJ_WS_CREATEMAPICONENTITY_DESCKEY: "Create a minimap icon",
  T_40_XXJ_WS_CREATETIMESTAMPLOCSTRING_DESCKEY: "Define a localized string for a timestamp",
  T_40_XXJ_WS_CREATEUIWIDGET_D: "Create a custom UI component at the designated custom HUD and parent component",
  T_40_XXJ_WS_CREEP_NAMEKEY: "Crawl",
  T_40_XXJ_WS_CROUCH_DESCKEY: "Display when true, otherwise closed",
  T_40_XXJ_WS_CROUCH_NAMEKEY: "Crouch",
  T_40_XXJ_WS_CULLINGMASK_DESCKEY: "This is the camera's cullingMask render layer. You can filter the render entity using the level of the visible layer.",
  T_40_XXJ_WS_CULLINGMASK_NAMEKEY: "CullingMask",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_DESCKEY: "The top ID",
  T_40_XXJ_WS_CUSTOMCLOTHCHESTID_NAMEKEY: "Top",
  T_40_XXJ_WS_CUSTOMCLOTHFACEID_DESCKEY: "Facepaint ID",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_DESCKEY: "The shoes ID",
  T_40_XXJ_WS_CUSTOMCLOTHFEETID_NAMEKEY: "Shoes",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_DESCKEY: "The head ID",
  T_40_XXJ_WS_CUSTOMCLOTHHAIRID_NAMEKEY: "Head",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_DESCKEY: "The facepaint ID",
  T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_NAMEKEY: "Mask",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_DESCKEY: "The bottom ID",
  T_40_XXJ_WS_CUSTOMCLOTHLEGSID_NAMEKEY: "Bottom",
  T_40_XXJ_WS_CUSTOMCLOTHMAKEUP_NAMEKEY: "Facepaint",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_DESCKEY: "The bundle ID",
  T_40_XXJ_WS_CUSTOMCLOTHSETID_NAMEKEY: "Onesie",
  T_40_XXJ_WS_CUSTOMXY_DESCKEY: "The drag amount in the xy direction",
  T_40_XXJ_WS_CUSTOMXY_NAMEKEY: "XY drag",
  T_40_XXJ_WS_DB: "Read Table Value",
  T_40_XXJ_WS_DB_DESC: "Read the corresponding value of a certain identifier on a certain table in the database.",
  T_40_XXJ_WS_DBDELETE_DESC: "Delete a corresponding value of a certain identifier on a certain table in the database.",
  T_40_XXJ_WS_DBKEY_DESCKEY: "A custom name used to identify data",
  T_40_XXJ_WS_DBKEY_NAMEKEY: "Identifier",
  T_40_XXJ_WS_DBTABLENAME: "Database Table Name",
  T_40_XXJ_WS_DBTABLENAME_DESC: "The name of a table in a database.",
  T_40_XXJ_WS_DBVALUE_DESCKEY: "The value to write",
  T_40_XXJ_WS_DBWRITE: "Write Table Value",
  T_40_XXJ_WS_DBWRITE_DESC: "Write a corresponding value of a certain identifier on a certain table in the database.",
  T_40_XXJ_WS_DEFENCEGRENADE_NAMEKEY: "Defense throwables",
  T_40_XXJ_WS_DEFULT: "Default",
  T_40_XXJ_WS_DELETELEADERBOARD_DESC: "Delete a corresponding value of a certain key on a certain leaderboard table in the database.",
  T_40_XXJ_WS_DELETELEADERBOARD2_DESC: "Delete a corresponding value of a certain rank on a certain leaderboard table in the database.",
  T_40_XXJ_WS_DEPTH: "HUD layer",
  T_40_XXJ_WS_DEPTH_D: "The basic layer of the HUD",
  T_40_XXJ_WS_DICTANDLIST: "List and Dictionary",
  T_40_XXJ_WS_DICVALUE_DESCKEY: "The value of the targeted dictionary",
  T_40_XXJ_WS_DIFFUSEALPHA_DESCKEY: "The transparency of the surface",
  T_40_XXJ_WS_DIR_DESCKEY: "Vector",
  T_40_XXJ_WS_DIRECTPOSVEC3_DESCKEY: "A point that is provided and can be used as a revival points, etc.",
  T_40_XXJ_WS_DIRECTPOSVEC3_NAMEKEY: "Coordinates",
  T_40_XXJ_WS_DISABLEALL: "Deselect All",
  T_40_XXJ_WS_DISABLECOLOR_NAMEKEY: "Disabled color",
  T_40_XXJ_WS_DISTANT_DESCKEY: "The distance of the camera line detection",
  T_40_XXJ_WS_DISTANT_NAMEKEY: "Projecting distance",
  T_40_XXJ_WS_DRAGEFFECT_DESCKEY: "Supports multiple dragging directions",
  T_40_XXJ_WS_DRAGEFFECT_NAMEKEY: "Drag effect",
  T_40_XXJ_WS_DRIVER_DESCKEY: "The driver of the vehicle",
  T_40_XXJ_WS_DRIVER_NAMEKEY: "Driver",
  T_40_XXJ_WS_EDITVALUE_DESCKEY: "Modify a value",
  T_40_XXJ_WS_EFFECTACTIVE_DESCKEY: "Display special effects",
  T_40_XXJ_WS_EFFECTACTIVE_NAMEKEY: "Display special effects",
  T_40_XXJ_WS_EFFECTCOLOR_NAMEKEY: "Effects color",
  T_40_XXJ_WS_EFFECTENTITY_DESCKEY: "The special effects entity represents the special effect to be displayed",
  T_40_XXJ_WS_EFFECTENTITYGENERATOR_DESCKEY: "The special effects object",
  T_40_XXJ_WS_EMOTIONHUD_NAMEKEY: "Emoji HUD switch",
  T_40_XXJ_WS_ENABLEALL: "Select all",
  T_40_XXJ_WS_ENABLELOGIC_DESCKEY: "Whether to turn on logic update. When off, the blocks on this entity will stop updating every frame.",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_DESCKEY: "When written into the weapon attributes, the weapon's basic statistics will be affected by the weapon skin",
  T_40_XXJ_WS_ENABLEWEAPONSKINPROP_NAMEKEY: "Write weapon skin attribute",
  T_40_XXJ_WS_ENTITY_DESCKEY: "An entity is a vessel that holds all components, which must be added to entities in order to be activated",
  T_40_XXJ_WS_ENTITY_NAMEKEY: "Entity type",
  T_40_XXJ_WS_ENTITY1_DESCKEY: "The basic component of an entity. All components will combine this component.",
  T_40_XXJ_WS_ENTITYVARNAME_DESCKEY: "The entity to transform into",
  T_40_XXJ_WS_ENTITYVARNAME11_DESCKEY: "The parameter name used in the code to represent the entity of the newly added custom UI control. Its corresponding local variable value is the entity of the newly added custom UI control.",
  T_40_XXJ_WS_ENTITYVARNAME12_DESCKEY: "The name of the entity variable",
  T_40_XXJ_WS_ENTITYVARNAME13_DESCKEY: "The parameter name used in the code to represent the entity of the created icon. Its corresponding local variable value is the entity of the created icon.",
  T_40_XXJ_WS_EPITEMHUD_NAMEKEY: "EP bar HUD switch",
  T_40_XXJ_WS_EULERANGLES_DESCKEY: "Euler angles",
  T_40_XXJ_WS_FACINFECTION: "Faction (Droid Apocalyse)",
  T_40_XXJ_WS_FACINFECTION_DESC: "Faction of the player. 1 = Human, 2 = Droid.",
  T_40_XXJ_WS_FEMALE: "Female",
  T_40_XXJ_WS_FILLDIRECTION_DESCKEY: "Fill direction",
  T_40_XXJ_WS_FILLDIRECTION_NAMEKEY: "Sort direction",
  T_40_XXJ_WS_FIRE_NAMEKEY: "Fire",
  T_40_XXJ_WS_FLOATVALUE_DESCKEY: "The value of the float",
  T_40_XXJ_WS_FOLLOWTARGET_DESCKEY: "The target entity to follow. Empty by default.",
  T_40_XXJ_WS_FONTSIZE_DESCKEY: "The size of the text",
  T_40_XXJ_WS_FONTSIZE_NAMEKEY: "Font size",
  T_40_XXJ_WS_FONTSTYLE_DESCKEY: "The font style",
  T_40_XXJ_WS_FOOTBALLGLOOWALL: "Football Gloo Wall",
  T_40_XXJ_WS_FORMATSTYLE_DESCKEY: "The formatting style",
  T_40_XXJ_WS_FORWARD_DESCKEY: "The direction of the player",
  T_40_XXJ_WS_FORWARD1_DESCKEY: "The direction to teleport",
  T_40_XXJ_WS_FREE_DESCKEY: "A camera that is controllable by the player and can be moved freely",
  T_40_XXJ_WS_FREE_NAMEKEY: "Free Camera",
  T_40_XXJ_WS_GENDER: "Gender",
  T_40_XXJ_WS_GENDER_DESCKEY: "Gender",
  T_40_XXJ_WS_GENDERTYPE_DESCKEY: "Gender enum",
  T_40_XXJ_WS_GETCAMERACULLINGMASK_DESCKEY: "Obtain the camera's cullingMask",
  T_40_XXJ_WS_GETCHILDBYINDEX_DESCKEY: "Only supports entities that have the Transform component. Currently constrained to all objects.",
  T_40_XXJ_WS_GETCHILDREN_DESCKEY: "Only supports entities that have the Transform component. Currently constrained to all objects.",
  T_40_XXJ_WS_GETPARENT_DESCKEY: "Only supports entities that have the Transform component. Currently constrained to all objects.",
  T_40_XXJ_WS_GETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "Obtain the player's outfit ID",
  T_40_XXJ_WS_GETPLAYERRANK: "Get Player Rank",
  T_40_XXJ_WS_GETPLAYERRANK_D: "Get Player Total Rank",
  T_40_XXJ_WS_GETPLAYERROUNDRANK: "Get Player Round Rank",
  T_40_XXJ_WS_GETPLAYERROUNDRANK_D: "Get Player Specific Round Rank",
  T_40_XXJ_WS_GETPLAYERTOKENNUM_DESCKEY: "Search for data of the player's token",
  T_40_XXJ_WS_GETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "Obtain the player's weapon skin",
  T_40_XXJ_WS_GETRANDOMSPAWNPOSVEC3_DESCKEY: "Obtain a set of coordinates that has not been occupied by random spawnpoints",
  T_40_XXJ_WS_GETSCENESKYBOX_DESCKEY: "Obtain the sky box of a scenery",
  T_40_XXJ_WS_GETSERVERREGION_DESCKEY: "Obtain the region of a server",
  T_40_XXJ_WS_GETSERVERTIME_DESCKEY: "Obtain the timestamp of a server",
  T_40_XXJ_WS_GETTEAMMATENEARPOSVEC3_DESCKEY: "Obtain a location near the teammate, avoiding areas where players cannot stand on",
  T_40_XXJ_WS_GETTEAMRANK: "Get Team Rank",
  T_40_XXJ_WS_GETTEAMRANK_D: "Get Team Total Rank",
  T_40_XXJ_WS_GETTEAMROUNDRANK: "Get Team Round Rank",
  T_40_XXJ_WS_GETTEAMROUNDRANK_D: "Get Team Specific Round Rank",
  T_40_XXJ_WS_GREEN: "Green",
  T_40_XXJ_WS_HALFEXTENTS_DESCKEY: "Half of the dimensions of a 3-dimensional shape",
  T_40_XXJ_WS_HEAD_DESCKEY: "Head",
  T_40_XXJ_WS_HEAD_NAMEKEY: "Head",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_DESCKEY: "The heartbeat effect entity",
  T_40_XXJ_WS_HEARTBEATEFFECTHUD_NAMEKEY: "Heartbeat effect entity",
  T_40_XXJ_WS_HEIGHT_DESCKEY: "The height",
  T_40_XXJ_WS_HINTBUTTONHUD_DESCKEY: "Hint button",
  T_40_XXJ_WS_HINTBUTTONHUD_NAMEKEY: "Tips button",
  T_40_XXJ_WS_HITPOINTEFFECT_DESCKEY: "The entity to be displayed at the target location",
  T_40_XXJ_WS_HITPOINTEFFECT_NAMEKEY: "Entity targeted",
  T_40_XXJ_WS_HITPOS_DESCKEY: "The spot that is hit",
  T_40_XXJ_WS_HORIZONTALBAR_DESCKEY: "The horizontal display type",
  T_40_XXJ_WS_HORIZONTALBAR_NAMEKEY: "Horizontal display type",
  T_40_XXJ_WS_HOSTENTITYFOLLOW_DESCKEY: "The entity that is following another entity",
  T_40_XXJ_WS_HOSTENTITYLOOK_DESCKEY: "The entity that is looking at another entity",
  T_40_XXJ_WS_HPITEMHUD_NAMEKEY: "Health bar HUD switch",
  T_40_XXJ_WS_HUDEMPTYPANEL_DESCKEY: "The HUD insertion entity. This is the HUD that players modify from the editor.",
  T_40_XXJ_WS_HUDEMPTYPANEL_NAMEKEY: "Empty HUD panel component",
  T_40_XXJ_WS_HUDENTITY_DESCKEY: "The HUD entity it belongs to",
  T_40_XXJ_WS_HUDGRID_DESCKEY: "The HUD insertion entity. It is the HUD that the player edits using the editor.",
  T_40_XXJ_WS_HUDGRID_NAMEKEY: "HUD grid component",
  T_40_XXJ_WS_HUDPANEL_DESCKEY: "The HUD insertion entity. It is the HUD that the player edits using the editor.",
  T_40_XXJ_WS_HUDPANEL_NAMEKEY: "HUD panel component",
  T_40_XXJ_WS_HUDSCROLLVIEW_DESCKEY: "The HUD insertion entity. It is the HUD that the player edits using the editor.",
  T_40_XXJ_WS_HUDSCROLLVIEW_NAMEKEY: "HUD scroll view component",
  T_40_XXJ_WS_HUMANMODELID_NAMEKEY: "Human model ID",
  T_40_XXJ_WS_ICON_DESCKEY: "The resource name of the icon",
  T_40_XXJ_WS_ICON_NAMEKEY: "Icon",
  T_40_XXJ_WS_ICON1_DESCKEY: "Select an icon",
  T_40_XXJ_WS_ICONENTITY_DESCKEY: "The icon entity represents the icon to be displayed",
  T_40_XXJ_WS_ICONPATH_DESCKEY: "A resource path. Built-in resource is in:path. Custom resource is out:path. Empty by default.",
  T_40_XXJ_WS_ICONSPRITENAME_DESCKEY: "Icon name",
  T_40_XXJ_WS_ICONSPRITENAME_NAMEKEY: "Icon name",
  T_40_XXJ_WS_ICONTYPE_DESCKEY: "The resource path. Empty by default.",
  T_40_XXJ_WS_INCLUDETRIGGER_DESCKEY: "Whether it can scan for triggers",
  T_40_XXJ_WS_INDEX_DESCKEY: "The child's index under the parent",
  T_40_XXJ_WS_INITIALVALUE_NAMEKEY: "Initial value [0, 1]",
  T_40_XXJ_WS_INTVALUE_DESCKEY: "The value of the integer",
  T_40_XXJ_WS_IS3D: "3D sound effect",
  T_40_XXJ_WS_ISBILLBOARD_DESCKEY: "Always facing the camera",
  T_40_XXJ_WS_ISBOLD_NAMEKEY: "Bold",
  T_40_XXJ_WS_ISBYORDER_D: "Detect whether players should trigger level objects in chronological order",
  T_40_XXJ_WS_ISFEBUTTON_NAMEKEY: "Is FirEditor button",
  T_40_XXJ_WS_ISHIT_DESCKEY: "Whether the camera line has hit the entity",
  T_40_XXJ_WS_ISINCULLINGMASK_DESCKEY: "Whether it is visible to a certain layer",
  T_40_XXJ_WS_ISITALIC_NAMEKEY: "Italic",
  T_40_XXJ_WS_ISSHOWSCAN_DESCKEY: "Whether marked by scan",
  T_40_XXJ_WS_ISSHOWSCAN_NAMECKEY: "Scanned or not",
  T_40_XXJ_WS_ISSHOWTAG_DESCKEY: "Whether marked by the pin button",
  T_40_XXJ_WS_ISTRIGGER: "Is trigger",
  T_40_XXJ_WS_ISUNDERLINE_NAMEKEY: "Underlined",
  T_40_XXJ_WS_ITEMID_DESCKEY: "The entity's corresponding item ID",
  T_40_XXJ_WS_ITEMID_NAMEKEY: "Item ID",
  T_40_XXJ_WS_ITEMID1_DESCKEY: "The item ID (only weapon ID available in the current version)",
  T_40_XXJ_WS_ITEMID2_DESCKEY: "The item ID of the weapon",
  T_40_XXJ_WS_ITEMID3_DESCKEY: "Item ID",
  T_40_XXJ_WS_JAILBREAKAREA_DESCKEY: "Metropolis area",
  T_40_XXJ_WS_JAILBREAKAREA_NAMEKEY: "Metropolis area",
  T_40_XXJ_WS_JUMP_NAMEKEY: "Jump",
  T_40_XXJ_WS_KEY_DESCKEY: "The value of the key",
  T_40_XXJ_WS_KEY_NAMEKEY: "Key",
  T_40_XXJ_WS_KEYNAME_DESCKEY: "The name of the key to traverse. You can use this to obtain the value of a key in a local variable.",
  T_40_XXJ_WS_KILLINGTIPS_NAMEKEY: "Elimination announcement",
  T_40_XXJ_WS_LABELCOLOR_NAMEKEY: "Text color",
  T_40_XXJ_WS_LANDMINEOBJ: "Entity after landmine creation",
  T_40_XXJ_WS_LAYERMASK_DESCKEY: "The mask of the collide layer. Layers not selected will not be included in the scan. When empty, all layers will be included in the scan.",
  T_40_XXJ_WS_LAYERSEDIT: "Edit Layers",
  T_40_XXJ_WS_LAYERSETTING: "Visible layer settings",
  T_40_XXJ_WS_LAYERTYPE_DESCKEY: "The collision layer of the camera line detection",
  T_40_XXJ_WS_LAYERTYPE_NAMEKEY: "Layer",
  T_40_XXJ_WS_LAYOUTTYPE_DESCKEY: "Layout type",
  T_40_XXJ_WS_LAYOUTTYPE_NAMEKEY: "Layout type",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD: "Scoreboard HUD component",
  T_40_XXJ_WS_LEADERBOARDBUTTONHUD_D: "The HUD entity of the scoreboard. Modifying the entity's properties will affect the content to be displayed on the corresponding UI.",
  T_40_XXJ_WS_LEADERBOARDNAME: "Leaderboard Name",
  T_40_XXJ_WS_LEADERBOARDNAME_DESC: "The name of the leaderboard table in the database.",
  T_40_XXJ_WS_LEAVEACCELERATION_DESCKEY: "The acceleration upon swinging",
  T_40_XXJ_WS_LEAVEACCELERATION_NAMEKEY: "Leave acceleration",
  T_40_XXJ_WS_LEFTARM_DESCKEY: "Left arm",
  T_40_XXJ_WS_LEFTARM_NAMEKEY: "Left arm",
  T_40_XXJ_WS_LEFTCOLOR_DESCKEY: "The left color",
  T_40_XXJ_WS_LEFTCOLOR_NAMEKEY: "Left color",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_DESCKEY: "Whether to display the special effects on the left",
  T_40_XXJ_WS_LEFTEFFECTACTIVE_NAMEKEY: "Display left effect or not",
  T_40_XXJ_WS_LEFTFOOT_DESCKEY: "Left foot",
  T_40_XXJ_WS_LEFTFOOT_NAMEKEY: "Left foot",
  T_40_XXJ_WS_LEFTHAND_DESCKEY: "Left hand",
  T_40_XXJ_WS_LEFTHAND_NAMEKEY: "Left hand",
  T_40_XXJ_WS_LEFTICON_DESCKEY: "Left icon",
  T_40_XXJ_WS_LEFTICON_NAMEKEY: "Left icon",
  T_40_XXJ_WS_LEFTLEG_DESCKEY: "Left leg",
  T_40_XXJ_WS_LEFTLEG_NAMEKEY: "Left leg",
  T_40_XXJ_WS_LEFTSCORETEXT_DESCKEY: "Left score text",
  T_40_XXJ_WS_LEFTSCORETEXT_NAMEKEY: "Left score text",
  T_40_XXJ_WS_LEFTTEXT_DESCKEY: "Left text",
  T_40_XXJ_WS_LEFTTEXT_NAMEKEY: "Left text",
  T_40_XXJ_WS_LERP_DESCKEY: 't lies in between 0 and 1. When t=0, return "from". When t=1, return "to". When t=0.5, return the average of the values of "from" and "to".',
  T_40_XXJ_WS_LEVELOBJECT: "Level Object",
  T_40_XXJ_WS_LINESPACING_NAMEKEY: "Line spacing",
  T_40_XXJ_WS_LISTFINDMAX_DESCKEY: "Compare the values in a list and return the largest one",
  T_40_XXJ_WS_LISTFINDMIN_DESCKEY: "Compare the values in a list and return the smallest one",
  T_40_XXJ_WS_LISTORMAP_NAMEKEY: "List or Dict",
  T_40_XXJ_WS_LOCALPOSITION: "Local position",
  T_40_XXJ_WS_LOCALROTA: "Local Euler angles",
  T_40_XXJ_WS_LOCALROTATIONQ: "Local quaternion rotation",
  T_40_XXJ_WS_LOCALSACLE: "Local scale",
  T_40_XXJ_WS_LOCSWITCH_NAMEKEY: "Localization switch",
  T_40_XXJ_WS_LOOPRANGE_DESCKEY: "The container to traverse",
  T_40_XXJ_WS_MALE: "Male",
  T_40_XXJ_WS_MAPCLEAR_DESCKEY: "Remove the dictionary",
  T_40_XXJ_WS_MAPGETLENGTH_DESCKEY: "Obtain the length of the dictionary",
  T_40_XXJ_WS_MAPGETVALUE_DESCKEY: "Obtain the value of the designated key in the dictionary element",
  T_40_XXJ_WS_MAPREMOVEVALUE_DESCKEY: "Remove the designated key-value pair in the dictionary",
  T_40_XXJ_WS_MAPSETVALUE_DESCKEY: "Configure the value of a designated key in the dictionary",
  T_40_XXJ_WS_MAPSIZE_DESCKEY: "The size of the minimap. Its width and height are equal.",
  T_40_XXJ_WS_MAPSIZE_NAMEKEY: "Map size",
  T_40_XXJ_WS_MAPT: "Dict template",
  T_40_XXJ_WS_MAPT_D: "The data template for dict. You may designate the content type through T1 and T2.",
  T_40_XXJ_WS_MAPVALUE_D: "A data container for dict. The element is a pair that consists of a key and a value.",
  T_40_XXJ_WS_MAPVALUE_DESCKEY: "The target dictionary",
  T_40_XXJ_WS_MAPVALUE_NAMEKEY: "Dict",
  T_40_XXJ_WS_MASKNAME_DESCKEY: "The mask type is the image name used when masking",
  T_40_XXJ_WS_MASKNAME_NAMEKEY: "Mask name",
  T_40_XXJ_WS_MASS_DESCKEY: "Mass (in kg)",
  T_40_XXJ_WS_MASS_NAMEKEY: "Mass (kg)",
  T_40_XXJ_WS_MAX_DESCKEY: "Compare 2 values and return the larger one",
  T_40_XXJ_WS_MAXLENGTH_NAMEKEY: "Max. length",
  T_40_XXJ_WS_MAXNUM_DESCKEY: "The maximum value",
  T_40_XXJ_WS_MAXWIDGETID_DESCKEY: "The biggest component ID",
  T_40_XXJ_WS_MAXWIDGETID_NAMEKEY: "Max. widget ID",
  T_40_XXJ_WS_MEDICALPROPSHUD_NAMEKEY: "Healing items",
  T_40_XXJ_WS_MIN_DESCKEY: "Compare 2 values and return the smaller one",
  T_40_XXJ_WS_MINIMAP_NAMEKEY: "Minimap component",
  T_40_XXJ_WS_MINIMAPBIT_NAMEKEY: "Minimap pixel",
  T_40_XXJ_WS_MINIMAPICON_NAMEKEY: "Minimap icon",
  T_40_XXJ_WS_MINMAPHUD_NAMEKEY: "Minimap",
  T_40_XXJ_WS_MINNUM_DESCKEY: "The minimum value",
  T_40_XXJ_WS_MOMENTUMAMOUNT_DESCKEY: "The factor of the momentum. The larger the value, the bigger the momentum while scrolling.",
  T_40_XXJ_WS_MOMENTUMAMOUNT_NAMEKEY: "Momentum factor",
  T_40_XXJ_WS_MOVINGJOYSTICK_NAMEKEY: "Movement joystick",
  T_40_XXJ_WS_MRESULT_DESCKEY: "Match result",
  T_40_XXJ_WS_NEWENTITY_D: "The new item entity after creation (may be null)",
  T_40_XXJ_WS_NEWMAP_DESCKEY: "Create a new dictionary",
  T_40_XXJ_WS_NEWMAP_NAMEKEY: "New Dict",
  T_40_XXJ_WS_NORMAL1_DESCKEY: "The normal of the hit",
  T_40_XXJ_WS_NORMALIZEDPOSITION_DESCKEY: "HUD position [0,1]",
  T_40_XXJ_WS_NORMALIZEDPOSITION_NAMEKEY: "HUD position",
  T_40_XXJ_WS_NUMLIST_DESCKEY: "The list to convert indices into numbers",
  T_40_XXJ_WS_OBJECT_DESCKEY: "The object that the spray gun hits",
  T_40_XXJ_WS_OBSOLETE: "Deleted, for safety reasons please replace this block.",
  T_40_XXJ_WS_OFFSET_DESCKEY: "The display position. When there is a followed target, it is the offset between the new position and the original position. When there is no followed target, it is the screen coordinates (the default is Vector3(0)).",
  T_40_XXJ_WS_OFFSET2_DESCKEY: "The screen coordinates (the default is Vector3(0)).",
  T_40_XXJ_WS_OFFSET3_DESCKEY: "The display position. When there is a followed target, it is the offset between the new position and the original position. When there is no followed target, it is the screen coordinates (the default is Vector3(0)).",
  T_40_XXJ_WS_OFFSET4_DESCKEY: "Display position (the anchor is on the top right corner)",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_DESCKEY: "Horizontal offset",
  T_40_XXJ_WS_OFFSETLEFTRIGHT_NAMEKEY: "Horizontal offset",
  T_40_XXJ_WS_OFFSETUPDOWN_DESCKEY: "The vertical offset",
  T_40_XXJ_WS_OFFSETUPDOWN_NAMEKEY: "Vertical offset",
  T_40_XXJ_WS_OK_DESCKEY: "Conversion successful",
  T_40_XXJ_WS_ONAISTARTATTACK_DESCKEY: "Trigger this event when the entity enters the attack vicinity",
  T_40_XXJ_WS_ONAISTARTCHASE_DESCKEY: "Trigger this event when the entity enters the chase vicinity",
  T_40_XXJ_WS_ONAISTOPATTACK_DESCKEY: "Trigger this event when the entity leaves the attack vicinity",
  T_40_XXJ_WS_ONAISTOPCHASE_DESCKEY: "Trigger this event when the entity leaves the chase vicinity",
  T_40_XXJ_WS_ONCLIENTCAMERARAYCAST_DESCKEY: "Trigger a camera line detection through the client",
  T_40_XXJ_WS_ONCOLLISION_D: "Only entities with the Collider component attached support this event",
  T_40_XXJ_WS_ONSPRAYENTITY_DESCKEY: "Trigger this event when the spray gun hits an entity",
  T_40_XXJ_WS_ONSTOPFIRE_DESCKEY: "When the firing stops",
  T_40_XXJ_WS_ONSWITCHPLAYERAREA_DESCKEY: "When a player switches the scenery area",
  T_40_XXJ_WS_OPENSTATE_DESCKEY: "Display when the open status is true, otherwise closed",
  T_40_XXJ_WS_OPENSTATE_NAMEKEY: "Open status",
  T_40_XXJ_WS_ORANGE: "Orange",
  T_40_XXJ_WS_ORDER_DESC: "The rank on the leaderboard",
  T_40_XXJ_WS_ORDER1: "Starting Rank",
  T_40_XXJ_WS_ORDER2: "Finishing Rank",
  T_40_XXJ_WS_ORIGINAL: "Keep original logic",
  T_40_XXJ_WS_OVERFLOW_NAMEKEY: "Overflow method",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_DESCKEY: "When prioritized, the attributes of the player's weapon will replace the weapon's original attributes",
  T_40_XXJ_WS_OVERLOADPLAYERWEAPONSKIN_NAMEKEY: "Prioritize player weapon skin",
  T_40_XXJ_WS_OWNER_DESCKEY: "The player that owns this entity",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_DESCKEY: "The global UID of the child scenery it belongs to",
  T_40_XXJ_WS_OWNERSUBLEVELGUID_NAMEKEY: "GUID of child scenery",
  T_40_XXJ_WS_PARENT_DESCKEY: "Parent entity",
  T_40_XXJ_WS_PARENT_NAMEKEY: "Parent",
  T_40_XXJ_WS_PARENTENTITYID_NAMEKEY: "Parent component entity ID",
  T_40_XXJ_WS_PARENTWIDGETFILEID_DESCKEY: "The file ID of the parent component",
  T_40_XXJ_WS_PASSENGERS_DESCKEY: "All the passengers in the vehicle",
  T_40_XXJ_WS_PASSENGERS_NAMEKEY: "Passenger",
  T_40_XXJ_WS_PHYSICALLAYER: "Physical Layer",
  T_40_XXJ_WS_PHYSICALLAYERMATRIX: "Physical Layer Matrix",
  T_40_XXJ_WS_PHYSICALTIP1: "Name Already Exists",
  T_40_XXJ_WS_PHYSICALTIP2: "Remove a layer name and make it invisible in the Physical Layer Matrix and Layer Enum, but the entity objects within that layer will not be affected.",
  T_40_XXJ_WS_PHYSICS: "Physics",
  T_40_XXJ_WS_PICKUPLISTHUD_NAMEKEY: "Loot list HUD switch",
  T_40_XXJ_WS_PLAYABLE_DESCKEY: "A playable entity",
  T_40_XXJ_WS_PLAYABLELOOKAT_DESCKEY: "An entity always faces another entity",
  T_40_XXJ_WS_PLAYABLEPOSFOLLOW_DESCKEY: "An entity follows another entity",
  T_40_XXJ_WS_PLAYABLETRAJECTORY_DESCKEY: "The bullet trail animation is a simulated animation of a bullet trail",
  T_40_XXJ_WS_PLAYER1_DESCKEY: "The player to receive the message",
  T_40_XXJ_WS_PLAYERAVATAR_DESCKEY: "The avatar used by the player",
  T_40_XXJ_WS_PLAYERAVATARINFO_DESCKEY: "The outfit equipped by the player",
  T_40_XXJ_WS_PLAYERAVATARINFO_NAMEKEY: "Player outfit",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_DESCKEY: "The player's HUD type",
  T_40_XXJ_WS_PLAYERHUDSWITCHTYPE_NAMEKEY: "Player HUD type",
  T_40_XXJ_WS_PLAYERIDINFAC: "Faction Serial No.",
  T_40_XXJ_WS_PLAYERLOG_DESCKEY: "The player to record in the log",
  T_40_XXJ_WS_PLAYERREMOVETOKEN_DESCKEY: "Consume a certain player's token",
  T_40_XXJ_WS_PLAYERSKILLS_DESCKEY: "The list of skills of the player",
  T_40_XXJ_WS_PLAYERSTATETYPE_DESCKEY: "The status of a player: alive, knocked down, or eliminated",
  T_40_XXJ_WS_PLAYSPEED_DESCKEY: "Playback speed",
  T_40_XXJ_WS_PLAYSPEED_NAMEKEY: "Playback speed",
  T_40_XXJ_WS_PLAYSPEED1_DESCKEY: "For example, 1.25 means 25% faster than the original speed",
  T_40_XXJ_WS_POS_DESCKEY: "The coordinates to teleport to",
  T_40_XXJ_WS_PRESENTEFFECTTEXTYPE_DESCKEY: "The type of special effects sticker",
  T_40_XXJ_WS_PRESSEDCOLOR_NAMEKEY: "Color on press",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_DESCKEY: "Executes a traversal of a container to obtain the key-value pair. Includes a child process, which is the loop.",
  T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_NAMEKEY: "Loop dict visit",
  T_40_XXJ_WS_PROGRESS_DESCKEY: "Progress [0,1]",
  T_40_XXJ_WS_PROGRESS_NAMEKEY: "Progress [0,1]",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_DESCKEY: "The button for the skill progress",
  T_40_XXJ_WS_PROGRESSSKILLBUTTONHUD_NAMEKEY: "Skill progress button",
  T_40_XXJ_WS_QUATERNION: "Quaternion rotation",
  T_40_XXJ_WS_QUICKCHATHUD_NAMEKEY: "Quick msg HUD switch",
  T_40_XXJ_WS_QUICKCHATSHOWHUD_NAMEKEY: "Msgs beside team list",
  T_40_XXJ_WS_RADIUS_DESCKEY: "The radius of the two semicircles of a pill shape",
  T_40_XXJ_WS_READCELL: "Read A Cell",
  T_40_XXJ_WS_READCSV: "Read Table Content",
  T_40_XXJ_WS_READCSV_DESC: "Read the content on the entire table. Return a two-dimensional array.",
  T_40_XXJ_WS_READCSVCELL: "Read by row # and column name",
  T_40_XXJ_WS_READCSVCOL_DESC: "Read a certain column's content on the table. Returns an array.",
  T_40_XXJ_WS_READCSVROW_DESC: "Read a certain row's content on the table. Returns an array.",
  T_40_XXJ_WS_READLEADERBOARD: "Read Leaderboard Value",
  T_40_XXJ_WS_READLEADERBOARD_DESC: "Read a corresponding value of a certain identifier on a leaderboard table in the database.",
  T_40_XXJ_WS_READLEADERBOARD2: "Read By Rank Range",
  T_40_XXJ_WS_READLEADERBOARD2_DESC: "Read the value of the difference between a certain rank to a certain rank on the leaderboard in a database.",
  T_40_XXJ_WS_RED: "Red",
  T_40_XXJ_WS_RELOAD: "Reload",
  T_40_XXJ_WS_RENDERTYPE_DESCKEY: "Method of display",
  T_40_XXJ_WS_RESETPLAYERCLOTHES_DESCKEY: "Restore the player's default outfit",
  T_40_XXJ_WS_RESETPLAYERWEAPONSKINBYWEAPONID_DESCKEY: "Restore the player's default weapon skin",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_DESCKEY: "Whether the dragging is constrained to the viewport. Selected by default.",
  T_40_XXJ_WS_RESTRICTWITHINPANEL_NAMEKEY: "Constrain drag or not",
  T_40_XXJ_WS_RESULT_DESCKEY: "The result of the read",
  T_40_XXJ_WS_RESULT_NAMEKEY: "Result",
  T_40_XXJ_WS_RESULT1_DESCKEY: "Whether to find the largest number in the list",
  T_40_XXJ_WS_RESULT2_DESCKEY: "Whether to find the smallest number in the list",
  T_40_XXJ_WS_RESULTVALUE_DESCKEY: "Find the smallest number in a list",
  T_40_XXJ_WS_RESULTVALUE1_DESCKEY: "Find the largest number in a list",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_DESCKEY: "The revival point of a player. If there are no checkpoints, use a spawnpoint. Otherwise use checkpoints.",
  T_40_XXJ_WS_REVIVEPOSITIONVEC3_NAMEKEY: "Revival point",
  T_40_XXJ_WS_RIGHTARM_DESCKEY: "Right arm",
  T_40_XXJ_WS_RIGHTARM_NAMEKEY: "Right arm",
  T_40_XXJ_WS_RIGHTCOLOR_DESCKEY: "The right color",
  T_40_XXJ_WS_RIGHTCOLOR_NAMEKEY: "Right color",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_DESCKEY: "Whether to display the special effects on the right",
  T_40_XXJ_WS_RIGHTEFFECTACTIVE_NAMEKEY: "Display right effect or not",
  T_40_XXJ_WS_RIGHTFOOT_DESCKEY: "Right foot",
  T_40_XXJ_WS_RIGHTFOOT_NAMEKEY: "Right foot",
  T_40_XXJ_WS_RIGHTHAND_DESCKEY: "Right hand",
  T_40_XXJ_WS_RIGHTHAND_NAMEKEY: "Right hand",
  T_40_XXJ_WS_RIGHTICON_DESCKEY: "Right icon",
  T_40_XXJ_WS_RIGHTICON_NAMEKEY: "Right icon",
  T_40_XXJ_WS_RIGHTLEG_DESCKEY: "Right leg",
  T_40_XXJ_WS_RIGHTLEG_NAMEKEY: "Right leg",
  T_40_XXJ_WS_RIGHTSCORETEXT_DESCKEY: "Right score text",
  T_40_XXJ_WS_RIGHTSCORETEXT_NAMEKEY: "Right score text",
  T_40_XXJ_WS_RIGHTTEXT_DESCKEY: "Right text",
  T_40_XXJ_WS_RIGHTTEXT_NAMEKEY: "Right text",
  T_40_XXJ_WS_RIGIDBODY_DESCKEY: "The component of the rigid body type",
  T_40_XXJ_WS_RIGIDBODY_NAMEKEY: "Rigid body component",
  T_40_XXJ_WS_RIGIDBODYTYPE_DESCKEY: "The enum of the rigid body type",
  T_40_XXJ_WS_RIGIDBODYTYPE_NAMEKEY: "Rigid body type enum",
  T_40_XXJ_WS_ROW_DECS: "The row to read.",
  T_40_XXJ_WS_ROWVALUE: "Row Content",
  T_40_XXJ_WS_SCALE_DESCKEY: "Configure the zoom scale of the object",
  T_40_XXJ_WS_SCALE_NAMEKEY: "Scale",
  T_40_XXJ_WS_SCALE0_DESCKEY: "The zoom scale of the coordinate series in the world",
  T_40_XXJ_WS_SCALE1_DESCKEY: "The zoom scale. 1 by default.",
  T_40_XXJ_WS_SCALECALUE_DESCKEY: "The scale value",
  T_40_XXJ_WS_SCENENAME_DESCKEY: "The name of the area",
  T_40_XXJ_WS_SCOREBARHUD_DESCKEY: "Scorebar",
  T_40_XXJ_WS_SCOREBARHUD_NAMEKEY: "Score bar",
  T_40_XXJ_WS_SCROLLDIRECTION_DESCKEY: "Supports multiple scrolling directions",
  T_40_XXJ_WS_SCROLLDIRECTION_NAMEKEY: "Scroll direction",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_DESCKEY: "The factor of the scroll. The larger the value, the faster the scrolling.",
  T_40_XXJ_WS_SCROLLWHEELFACTOR_NAMEKEY: "Scroll factor",
  T_40_XXJ_WS_SETCAMERACULLINGMASK_DESCKEY: "Configure the camera's cullingMask",
  T_40_XXJ_WS_SETGLOBAL: "Set Global",
  T_40_XXJ_WS_SETPARENT_D: "Only supports entities that have the Transform component",
  T_40_XXJ_WS_SETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY: "Configure the player's outfit ID",
  T_40_XXJ_WS_SETPLAYERCLOTHIDS_DESCKEY: "Modify multiple player outfits",
  T_40_XXJ_WS_SETPLAYERFORWAR: "Set Player Direction",
  T_40_XXJ_WS_SETPLAYERHUBSWITCH_DESCKEY: "Configure a player's HUD switch",
  T_40_XXJ_WS_SETPLAYERWEAPONSKINIDBYWEAPONID_DESCKEY: "Configure the player's weapon skin",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_DESCKEY: "Whether to display entities at the target location",
  T_40_XXJ_WS_SHOWHITPOINTEFFECT_NAMEKEY: "Display entity on target",
  T_40_XXJ_WS_SHOWPLAYER: "Display entity",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD: "Single-player match details HUD entity",
  T_40_XXJ_WS_SINGLELEADERBOARDHUD_D: "A HUD entity for single-player matches. Modifying the entity's properties will affect the content to be displayed on the corresponding UI.",
  T_40_XXJ_WS_SIZEDELTA: "Size delta of anchor box and component",
  T_40_XXJ_WS_SKELETON: "Skeleton",
  T_40_XXJ_WS_SKELETON_D: "The pivot used to access the skeleton mask",
  T_40_XXJ_WS_SKELETONPART_NAMEKEY: "Skeleton part",
  T_40_XXJ_WS_SKILLBUTTONHUD: "Skill button HUD entity",
  T_40_XXJ_WS_SLOT_DESCKEY: "The weapon's slot",
  T_40_XXJ_WS_SMOOTHDRAGSTART_DESCKEY: "When selected, there will be a slow movement upon dragging. When unselected, the dragging corresponds to the speed of the mouse.",
  T_40_XXJ_WS_SMOOTHDRAGSTART_NAMEKEY: "Smooth motion or not",
  T_40_XXJ_WS_SOFTNESS_DESCKEY: "Softness",
  T_40_XXJ_WS_SOFTNESS_NAMEKEY: "Softness",
  T_40_XXJ_WS_SOUNDNTITY_NAMEKEY: "Sound entity",
  T_40_XXJ_WS_SPACE_DESCKEY: "Space",
  T_40_XXJ_WS_SPACE_NAMEKEY: "Child cell spacing",
  T_40_XXJ_WS_SPAWNPOSVEC3_DESCKEY: "The coordinates of the AI's spawnpoint",
  T_40_XXJ_WS_SPAWNPOSVEC3_NAMEKEY: "Spawn point coordinates",
  T_40_XXJ_WS_SPEED_DESCKEY: "Speed",
  T_40_XXJ_WS_SPEED_NAMEKEY: "Speed",
  T_40_XXJ_WS_SPEEDUP_NAMEKEY: "Sprint",
  T_40_XXJ_WS_SPHERERADIUS_DESCKEY: "The radius of the sphere",
  T_40_XXJ_WS_SPRAYCOLOR_DESCKEY: "The color of the spray",
  T_40_XXJ_WS_SPRAYCOLOR_NAMEKEY: "Spray color",
  T_40_XXJ_WS_SPRAYRESULTHUD_DESCKEY: "The spray result",
  T_40_XXJ_WS_SPRAYRESULTHUD_NAMEKEY: "Spray result",
  T_40_XXJ_WS_SPRAYRIFLE_DESCKEY: "The spray gun (assault rifle)",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY: "Spray Rifle",
  T_40_XXJ_WS_SPRAYRIFLE_NAMEKEY_01: "Initial Velocity",
  T_40_XXJ_WS_SPRITEFLIP_NAMEKEY: "Flip sticker",
  T_40_XXJ_WS_SPRITEID: "Sprite asset ID",
  T_40_XXJ_WS_SPRITEID_D: "The ID used to describe the sprite asset",
  T_40_XXJ_WS_SPRITETYPE_NAMEKEY: "Sticker type",
  T_40_XXJ_WS_STARGETENTITY_DESCKEY: "The target entity to generate into a static pixel",
  T_40_XXJ_WS_STARTPOSITION_D: "The coordinates of the shape's geometrical center",
  T_40_XXJ_WS_STAY_D: "Retain the current world position, rotation, and scaling of the child? This is generally set to true, and UI settings are ineffective for this option.",
  T_40_XXJ_WS_STRING_NAMEKEY: "String",
  T_40_XXJ_WS_STRING2FLOAT_DESCKEY: "Convert a string to a float",
  T_40_XXJ_WS_STRING2INT_DESCKEY: "Convert a string to an integer",
  T_40_XXJ_WS_STYLE_DESCKEY: "The play method of the interpolation. Options include play once, loop, and play again.",
  T_40_XXJ_WS_SWITCHPLAYERAREA_DESCKEY: "Switch the player's area",
  T_40_XXJ_WS_SWITCHVALUE_DESCKEY: "Switch value",
  T_40_XXJ_WS_SWITCHWEAPONBYSLOT_DESCKEY: "Switch weapons according to the player's slot",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_DESCKEY: "Switch the item slot",
  T_40_XXJ_WS_SWITCHWEAPONEQUIPSLOT_NAMEKEY: "Item switch",
  T_40_XXJ_WS_TABLENAME_DESC: "Displayed as the table name but is actually the UID",
  T_40_XXJ_WS_TABLEVALUE: "Table content",
  T_40_XXJ_WS_TAGSLIST_DESCKEY: "The list of tags",
  T_40_XXJ_WS_TARGET_DESCKEY: "The target entity to generate map pixel. Empty by default.",
  T_40_XXJ_WS_TARGET_NAMEKEY: "Entity to create map pixel",
  T_40_XXJ_WS_TARGETATK_DESCKEY: "Attack target",
  T_40_XXJ_WS_TARGETENTITY_DESCKEY: "The target entity",
  T_40_XXJ_WS_TARGETENTITY_NAMEKEY: "Entity",
  T_40_XXJ_WS_TARGETENTITY1_DESCKEY: "The entity where the customized function is at",
  T_40_XXJ_WS_TARGETENTITYAPLAYER_DESCKEY: "The entity that is attacked by the AI",
  T_40_XXJ_WS_TARGETENTITYFOLLOW_DESCKEY: "The target entity to follow",
  T_40_XXJ_WS_TARGETENTITYITEM_DESCKEY: "The item entity (can be empty)",
  T_40_XXJ_WS_TARGETENTITYLOOK_DESCKEY: "The target entity to look at",
  T_40_XXJ_WS_TARGETENTITYSOUND_DESCKEY: "The sound entity to pause",
  T_40_XXJ_WS_TARGETENTITYSOUND2_DESCKEY: "The sound entity to play after the pause",
  T_40_XXJ_WS_TARGETENTITYSOUND3_DESCKEY: "The sound entity to delete",
  T_40_XXJ_WS_TEAMMATESINFO_NAMEKEY: "Teammates info",
  T_40_XXJ_WS_TELEPORTA_D: "Teleport the player to a designated spot with a set direction",
  T_40_XXJ_WS_TEXT_NAMEKEY: "Tip text",
  T_40_XXJ_WS_TEXTCOLOR_NAMEKEY: "Notification text color",
  T_40_XXJ_WS_TEXTENTITY_DESCKEY: "The text entity represents the text to be displayed",
  T_40_XXJ_WS_TEXTKEY_DESCKEY: "The text keys to display",
  T_40_XXJ_WS_TEXTKEY_NAMEKEY: "Text key",
  T_40_XXJ_WS_TIMESTAMP_DESCKEY: "The timestamp",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_DESCKEY: "The display style of a localized string",
  T_40_XXJ_WS_TIMESTAMPFORMATSTYLE_NAMEKEY: "Timestamp display style",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_DESCKEY: "The localized string for a timestamp",
  T_40_XXJ_WS_TIMESTAMPLOCSTRING_NAMEKEY: "Loc string timestamp",
  T_40_XXJ_WS_TIPHUD_DESCKEY: "Hint",
  T_40_XXJ_WS_TIPHUD_NAMEKEY: "Tip",
  T_40_XXJ_WS_TOKENCOUNT_DESCKEY: "The amount of lootable item",
  T_40_XXJ_WS_TOKENID_DESCKEY: "The ID of a lootable item",
  T_40_XXJ_WS_TOWSPEED_DESCKEY: "The tow speed of a player",
  T_40_XXJ_WS_TRANSITIONTYPE_NAMEKEY: "Translation type",
  T_40_XXJ_WS_TWEENENTITY_DESCKEY: "The interpolation animation entity",
  T_40_XXJ_WS_TYPE_DESCKEY: 'This is the type of the description. Using "typeof" will return its type.',
  T_40_XXJ_WS_TYPE_NAMEKEY: "Rigid body type",
  T_40_XXJ_WS_TYPE2_DESCKEY: "Different types of rigid bodies have different functions",
  T_40_XXJ_WS_TYPE3_DESCKEY: "Only basic currencies supported in the current version",
  T_40_XXJ_WS_USEDEPTHMAP_DESCKEY: "Whether to enable minimap depth display",
  T_40_XXJ_WS_USEDEPTHMAP_NAMEKEY: "Use depth map",
  T_40_XXJ_WS_USEGRAVITY_DESCKEY: "Whether it follows the gravitational law",
  T_40_XXJ_WS_USEGRAVITY_NAMEKEY: "Gravitational or not",
  T_40_XXJ_WS_UUID_DESCKEY: "The unique identifier of a player",
  T_40_XXJ_WS_UUID_NAMEKEY: "UUID",
  T_40_XXJ_WS_VALUE_DESCKEY: "The value",
  T_40_XXJ_WS_VALUE_NAMEKEY: "Value",
  T_40_XXJ_WS_VALUE01_NAMEKEY: "Value [0, 1]",
  T_40_XXJ_WS_VALUE1_DESCKEY: "The first value",
  T_40_XXJ_WS_VALUE2_DESCKEY: "The second value",
  T_40_XXJ_WS_VALUE6_DESCKEY: "Value [0,1]",
  T_40_XXJ_WS_VALUEA_DESCKEY: "The starting value",
  T_40_XXJ_WS_VALUEB_DESCKEY: "The target value",
  T_40_XXJ_WS_VALUENAME_DESCKEY: "The name of the value to traverse. You can use this to obtain the value in a local variable.",
  T_40_XXJ_WS_VALUET_DESCKEY: "The interpolation progress. Lies in between 0 and 1.",
  T_40_XXJ_WS_VARTYPE_NAMEKEY: "Variable type",
  T_40_XXJ_WS_VERTICALBAR_DESCKEY: "The vertical display type",
  T_40_XXJ_WS_VERTICALBAR_NAMEKEY: "Vertical display type",
  T_40_XXJ_WS_VISIBILITYLAYER_DESCKEY: "The level of an object's visibility",
  T_40_XXJ_WS_VISIBILITYLAYER_NAMEKEY: "Visible layer",
  T_40_XXJ_WS_WARDROBETYPE_DESCKEY: "Outfits include bundle, head, mask, facepaint, top, bottom, and shoes",
  T_40_XXJ_WS_WARDROBETYPE_NAMEKEY: "Outfit type",
  T_40_XXJ_WS_WARDROBETYPE6_DESCKEY: "Outfit slot",
  T_40_XXJ_WS_WEAPONHUD_NAMEKEY: "Weapons",
  T_40_XXJ_WS_WEAPONSKINID_DESCKEY: "The weapon skin ID",
  T_40_XXJ_WS_WEAPONSKINID_NAMEKEY: "Weapon skin ID",
  T_40_XXJ_WS_WEAPONSKINID1_DESCKEY: "The ID of the weapon skin",
  T_40_XXJ_WS_WEAPONSKINID6_DESCKEY: "The player's weapon skin",
  T_40_XXJ_WS_WIDGETTYPEENUM: "Component type enum",
  T_40_XXJ_WS_WIDTH_DESCKEY: "The width",
  T_40_XXJ_WS_WORDWRAP_NAMEKEY: "Word Wrap",
  T_40_XXJ_WS_WRITELEADERBOARD: "Write Leaderboard Value",
  T_40_XXJ_WS_WRITELEADERBOARD_DESC: "Write a corresponding value of a certain key on a certain leaderboard table in the database.",
  T_40_XYL_WS_BUMPERFACTORY: "Bumper Car Factory",
  T_40_XYL_WS_BURNDAMAGE: "Combustion Damage",
  T_40_XYL_WS_BURNINTERVAL: "Combustion Damage Interval (s)",
  T_40_XYL_WS_BURNTIME: "Combustion Time After Explosion",
  T_40_XYL_WS_COLORFULSKY: "Colorful Sky",
  T_40_XYL_WS_CRANEMACHINE: "Claw Crane",
  T_40_XYL_WS_CRASHMAXDAMAGE: "Maximum Crash Damage",
  T_40_XYL_WS_CRASHMAXSPEED: "Maximum Crash Damage Speed Limit",
  T_40_XYL_WS_CRASHMESS: "Mass Parameter During Crash",
  T_40_XYL_WS_CRASHMINDAMAGE: "Min. Crash Damage",
  T_40_XYL_WS_DISPLAYBOARD: "Billboard",
  T_40_XYL_WS_EXPLODEDAMAGE: "Explosion Damage",
  T_40_XYL_WS_EXPLODEDELAY: "Explosion Delay Time",
  T_40_XYL_WS_EXPLODERANGE: "Explosion Range",
  T_40_XYL_WS_FERRISWHEEL: "Ferris Wheel",
  T_40_XYL_WS_FOODTRUCK002: "Food Truck B",
  T_40_XYL_WS_GEARSHIFTDELAY: "Gear Changing Time (s)",
  T_40_XYL_WS_ICAROUSEL001: "Merry-Go-Round Component A",
  T_40_XYL_WS_ICAROUSEL002: "Merry-Go-Round Component B",
  T_40_XYL_WS_ICAROUSEL003: "Merry-Go-Round",
  T_40_XYL_WS_ICEDANCEDOOL: "Blue Doll",
  T_40_XYL_WS_IDLEBRAKEINPUT: "Uncontrolled Parking Horsepower Ratio",
  T_40_XYL_WS_LOLLIPOP: "Giant Lollipop",
  T_40_XYL_WS_NEWHOOKGUN: "Super Hook Gun",
  T_40_XYL_WS_OPENSWING: "Swing button",
  T_40_XYL_WS_OPENTRACTION: "Tow button",
  T_40_XYL_WS_PODIUM: "Podium",
  T_40_XYL_WS_SKYCITY: "City",
  T_40_XYL_WS_SKYSCRAPER_A001: "Skyscraper A Component A",
  T_40_XYL_WS_SKYSCRAPER_A002: "Skyscraper A Component B",
  T_40_XYL_WS_SKYSCRAPER_A003: "Skyscraper A Component C",
  T_40_XYL_WS_SKYSCRAPER_B001: "Skyscraper B Component A",
  T_40_XYL_WS_SKYSCRAPER_B002: "Skyscraper B Component B",
  T_40_XYL_WS_SKYSCRAPER_B003: "Skyscraper B Component C",
  T_40_XYL_WS_SKYSCRAPER_C001: "Skyscraper C Component A",
  T_40_XYL_WS_SKYSCRAPER_C002: "Skyscraper C Component B",
  T_40_XYL_WS_SKYSCRAPER_C003: "Skyscraper C Component C",
  T_40_XYL_WS_SKYSCRAPER_D001: "Skyscraper D Component A",
  T_40_XYL_WS_SKYSCRAPER_D002: "Skyscraper D Component B",
  T_40_XYL_WS_SKYSCRAPER_D003: "Skyscraper D Component C",
  T_40_XYL_WS_SKYSCRAPER_E001: "Skyscraper E Component A",
  T_40_XYL_WS_SKYSCRAPER_E002: "Skyscraper E Component B",
  T_40_XYL_WS_SKYSCRAPER_E003: "Skyscraper E Component C",
  T_40_XYL_WS_STEERANGLE: "High-speed Turning Radius",
  T_40_XYL_WS_STEERSPEED: "Maximum Speed During High-speed Turning",
  T_40_XYL_WS_SWINGSPEED: "Swing speed",
  T_40_XYL_WS_TARGETOBJECT: "Motion Anchor",
  T_40_XYL_WS_TRACTIONSPEED: "Tow speed",
  T_40_XYL_WS_TRIGGERCAPSULE: "Custom Capsule Trigger",
  T_40_XYL_WS_TRIGGERSPHERE: "Custom Sphere Trigger",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT: "Custom Object",
  T_40_ZQ_WS_COMPONENT_CUSTOMOBJECT_DESC: "An empty object component that can be used with the render component and collision component.",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER: "Custom Render Component",
  T_40_ZQ_WS_COMPONENT_CUSTOMRENDER_DESC: "A custom rendering component, used for rendering with custom model resources.",
  T_41_B_SKILL_DESC_ASSASSINGIRL: "Your enemy markings have bounty value. Anyone on ally team who eliminates a marked enemy will earn [FFB300]{0} in-match currency[-]. You will earn an extra [FFB300]100[-] for eliminating an enemy. Receive extra [FFB300]{1} FF Coins[-] from Coin Machines in BR matches.",
  T_41_B_SKILL_NAME_ASSASSINGIRL: "Money Mark",
  T_41_CJ_A_ESPORTS_TH: "FFTC The Pro (Mask)",
  T_41_CJ_B_ESPORTS_TH: "FFTC The Pro (Bottom)",
  T_41_CJ_H_ESPORTS_TH: "FFTC The Pro (Head)",
  T_41_CJ_S_ESPORTS_TH: "FFTC The Pro (Shoes)",
  T_41_CJ_T_ESPORTS_TH: "FFTC The Pro (Top)",
  T_41_CJ_T_FFSI: "FFSI Champion Jersey",
  T_41_CJ_T_FOOTBALL_EU01: "Sunburst Jersey",
  T_41_CJ_T_FOOTBALL_EU02: "Bold Red Jersey",
  T_41_CJ_T_FOOTBALL_EU03: "Majestic Crown Jersey",
  T_41_CJ_T_FOOTBALL_EU04: "Regal Titan Jersey",
  T_41_H_CHARACTER_ASSASSINGIRL_N: "Suzy",
  T_41_LXW_TabName_Items: "Item",
  T_41_R_CD_COIL: "Zone Shrink",
  T_41_SJ_WS_SPECIALITEM_ENABLE_DES: "Whether to activate this device",
  T_41_SJ_WS_SPECIALITEM_NAME: "Device",
  T_41_SW_SKILL_DESC_DELIVERY: "When hit by an enemy from within [FFB300]{0}m[-], said attacker is marked for [FFB300]{1}s[-] (intel is shared with teammates). Max. [FFB300]{2} markings[-].",
  T_41_SW_SKILL_DESC_GANGLEADER: "Get [FFB300]{0} extra Shield Points[-] at the start of the match. Recovers Shield Points after surviving combat.",
  T_41_SW_SKILL_DESC_JUNKENGINEER: "When using an active skill, gives [FFB300]{1} Shield Points[-] to self and teammates within [FFB300]{0}m[-]. The Shield Points decay after [FFB300]{2}s[-], after which players can obtain the effects again. Cooldown: [FFB300]{3}s[-].",
  T_41_SW_SKILL_DESC_WINTERGUY: "Deployed Gloo Walls restore [FFB300]{0}[-] durability per second when hit, during which teammates within [FFB300]{1}m[-] restore [FFB300]{2} HP/s[-]. Max. [FFB300]{3} HP[-] per teammate from each Gloo Wall.",
  T_41_SY_PETSKIN_CACTUS_SUGARSKULL23_N: "Pet Skin: Recollective Kactus",
  T_41_SY_PETSKIN_HAWK_INKPAINTING_N: "Pet Skin: Inked Falco",
  T_41_WCL_CREDITSCORE_PENALTY_HISTORY_TYPE: "Type",
  T_41_WT_SKILL_DESC_FIREBOY: "Deploys a [FFB300]{1}m[-]-wide flaming screen that lasts [FFB300]{0}s[-] and moves forward at [FFB300]{2}m/s[-] for up to [FFB300]{3}s[-]. While in effect, use the skill again to stop the screen. [FFB300]Enemies (or Gloo Walls)[-] that get in touch with it will instantly take [FFB300]{4} (or {5}) DMG[-], and then take [FFB300]{6} (or {7}) DMG/s[-]. Lasts [FFB300]{8}s[-]. Cooldown: [FFB300]{9}s[-]. Up to [FFB300]{10}[-] skill uses can be stored, with a [FFB300]{11}s[-] cooldown between each use.",
  T_41_WT_SKILL_NAME_FIREBOY: "Flame Mirage",
  T_41_WZY_WS_CHARGEMAX: "Max. Gloo Maker charge",
  T_41_WZY_WS_CROSSBOWNAME: "Crossbow",
  T_41_WZY_WS_DECELERATIONRATIO: "Deceleration % in water",
  T_41_WZY_WS_DEICEWALLPARAM1: "Radius of melt area",
  T_41_WZY_WS_DEICEWALLPARAM2: "Duration of melt",
  T_41_WZY_WS_EXPPERCHIP: "EXP from Gloo Chip",
  T_41_WZY_WS_EXPPERDAMAGE: "EXP from dealing DMG",
  T_41_WZY_WS_EXPPERMOVEMILE: "EXP from each meter traveled",
  T_41_WZY_WS_EXPPERSECOND: "EXP per second",
  T_41_WZY_WS_GRENADEEXPTIME: "Explosion delay",
  T_41_WZY_WS_GRENADELAUNCHNAME: "Explosives",
  T_41_WZY_WS_GRENADEMAX: "Maximum DMG",
  T_41_WZY_WS_GRENADEMIN: "Minimum DMG",
  T_41_WZY_WS_GRENADERANGE: "Explosion range",
  T_41_WZY_WS_GRENADERATIOCEHICLE: "DMG coefficient on vehicles",
  T_41_WZY_WS_GRENADERATIOSELF: "DMG coefficient on self",
  T_41_WZY_WS_GRENADERATIOTEAMMATE: "DMG coefficient on teammates",
  T_41_WZY_WS_GRENADTHROWSPEED: "Explosive travel speed",
  T_41_WZY_WS_HANDCANNONNAME: "Hand Cannon",
  T_41_XXJ_WS_ACCELERATION: "Acceleration",
  T_41_XXJ_WS_ACCELERATION_D: "Create a designated acceleration effect",
  T_41_XXJ_WS_ACTION: "Action node",
  T_41_XXJ_WS_ACTION_D: "Action Pivot",
  T_41_XXJ_WS_ADDHP: "Healing Items",
  T_41_XXJ_WS_ADDPLAYERMAXHP: "Add max. HP",
  T_41_XXJ_WS_AICASTSKILL_D: "AI release skill",
  T_41_XXJ_WS_AIMASSISTCENTEROFFSET: "Aim assist center offset",
  T_41_XXJ_WS_AIMASSISTDISTANCE: "Aim assist distance",
  T_41_XXJ_WS_AIMASSISTENTITY: "Aim assist entity",
  T_41_XXJ_WS_AIMASSISTENTITY_D: "Entity that can be aim assisted",
  T_41_XXJ_WS_AISKILLTYPE: "Zombie skill type",
  T_41_XXJ_WS_AISKILLTYPE_D: "Zombie skill type",
  T_41_XXJ_WS_ALLITEMGOODSTYPE: "All items",
  T_41_XXJ_WS_ALLITEMGOODSTYPE_D: "All items",
  T_41_XXJ_WS_AMMOCLIPSIZE: "Modify magazine size",
  T_41_XXJ_WS_AMMOCLIPSIZE_D: "Bullets in the magazine",
  T_41_XXJ_WS_ANCHORPOSITION_D: "The anchor coordinates in relation to the parent",
  T_41_XXJ_WS_ANGLE_D: "The z axis rotation angle",
  T_41_XXJ_WS_ANGULARDRAG: "Angular drag",
  T_41_XXJ_WS_ANGULARVELOCITY: "Angular velocity",
  T_41_XXJ_WS_ANIMATIONCLIP: "Animation state",
  T_41_XXJ_WS_ANIMATIONCONTROLLER: "Animation Controller",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE: "Animation entity",
  T_41_XXJ_WS_ANIMATIONCONTROLLERABLE_D: "The file and resource used to manage the animation controller",
  T_41_XXJ_WS_ANIMATIONCONTROLLERRESUUID: "Animation controller resource UUID",
  T_41_XXJ_WS_ANIMATIONOVERRIDELOOPTYPE: "Loop type enum",
  T_41_XXJ_WS_ANIMATIONSTATE: "Animation state",
  T_41_XXJ_WS_ARITHMETICTYPE_D: "Operation, where all types of value assignment are supported, and digital types also support self-increment, self-subtraction, self-multiplication, and self-division",
  T_41_XXJ_WS_ATTACHMENT: "Attachment",
  T_41_XXJ_WS_ATTACHMENT_D: "Attachment",
  T_41_XXJ_WS_ATTACHTARGET: "Linked entity",
  T_41_XXJ_WS_BAG: "Backpack",
  T_41_XXJ_WS_BAG_D: "Backpack Component",
  T_41_XXJ_WS_BANNERID: "Banner ID",
  T_41_XXJ_WS_BANNERID_D: "Banner ID",
  T_41_XXJ_WS_BEHAVIOURTREE: "Behavior tree",
  T_41_XXJ_WS_BEHAVIOURTREE_D: "Behavior Tree",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE: "Behavior-mountable tree entity",
  T_41_XXJ_WS_BEHAVIOURTREEATTACHABLE_D: "A behavior tree entity that can be mounted",
  T_41_XXJ_WS_BEHAVIOURTREENODE: "Behavior tree custom node",
  T_41_XXJ_WS_BEHAVIOURTREENODE_D: "Behavior Tree Custom Pivot",
  T_41_XXJ_WS_BODY: "Body",
  T_41_XXJ_WS_BORDERLR: "Border (left & right)",
  T_41_XXJ_WS_BORDERLR_D: "The left and right border",
  T_41_XXJ_WS_BORDERTB: "Border (top & bottom)",
  T_41_XXJ_WS_BORDERTB_D: "The top and bottom border",
  T_41_XXJ_WS_BRPEAKRANK: "Highest BR rank",
  T_41_XXJ_WS_BRPEAKRANK_D: "Highest BR rank",
  T_41_XXJ_WS_BRRANK: "BR rank",
  T_41_XXJ_WS_BRRANK_D: "BR Rank",
  T_41_XXJ_WS_BTCUSTOMNODETYPE: "Behavior tree node type",
  T_41_XXJ_WS_BTCUSTOMNODETYPE_D: "Behavior Tree Pivot Type",
  T_41_XXJ_WS_BTREE: "Behavior tree",
  T_41_XXJ_WS_BTREENODESTATE: "Behavior tree node state",
  T_41_XXJ_WS_BTREENODESTATE_D: "Behavior Tree Pivot Operating Status",
  T_41_XXJ_WS_BUFFABLEENTITY: "Buff-enabled entity",
  T_41_XXJ_WS_BUFFABLEENTITY_D: "Enables adding buffs, removing buffs, and getting added buff lists",
  T_41_XXJ_WS_BUILDINGICEWALL: "Gloo Wall",
  T_41_XXJ_WS_CAMOUFLAGE: "Functional items",
  T_41_XXJ_WS_CAMOUFLAGE_D: "Skyboard, Camouflage...",
  T_41_XXJ_WS_CAPICITY_D: "Initial Capacity",
  T_41_XXJ_WS_CENTERINVISIBLE: "Invisible to center",
  T_41_XXJ_WS_CENTERINVISIBLE_D: "Not visible to center",
  T_41_XXJ_WS_COLOR: "Color",
  T_41_XXJ_WS_COLOR_D: "The color",
  T_41_XXJ_WS_CONDITION: "Condition node",
  T_41_XXJ_WS_CONDITION_D: "Conditions are a special Boolean type",
  T_41_XXJ_WS_CONDITION1_D: "Condition Pivot",
  T_41_XXJ_WS_CONSTRAIN: "RigidBody constraint",
  T_41_XXJ_WS_CONSTRAIN_D: "Add constraints to the RigidBody. This is a compilation of RigidBody Constraint Type.",
  T_41_XXJ_WS_COUNT_D: "Amount",
  T_41_XXJ_WS_CROSSBOW_D: "Crossbow",
  T_41_XXJ_WS_CSPEAKRANK: "Highest CS rank",
  T_41_XXJ_WS_CSPEAKRANK_D: "Highest CS rank",
  T_41_XXJ_WS_CSRANK: "CS rank",
  T_41_XXJ_WS_CSRANK_D: "CS Rank",
  T_41_XXJ_WS_CSVNAME_D: "The csv file under SceneData that corresponds to the mode. Ends in .csv. Headers are written in lower case letters.",
  T_41_XXJ_WS_CURCAPACITY: "Used capacity",
  T_41_XXJ_WS_CURPROGRESS: "Current progress",
  T_41_XXJ_WS_CURRENTCLIP: "Current clip",
  T_41_XXJ_WS_CURRENTCLIPPROGRESS: "Current clip progress",
  T_41_XXJ_WS_CURRENTSTATE: "Current state",
  T_41_XXJ_WS_CUSTOMHUDID: "Custom HUD ID",
  T_41_XXJ_WS_CUSTOMHUDID_D: "The ID used to describe a custom HUD asset",
  T_41_XXJ_WS_DASHATTACK: "Dash attack",
  T_41_XXJ_WS_DEBUG: "Start debugging",
  T_41_XXJ_WS_DEBUG_D: "Fix",
  T_41_XXJ_WS_DECELERATIONRATIO_D: "Deceleration %: The deceleration when an object is in the water (range temporarily set as 0-100)",
  T_41_XXJ_WS_DEPTH_D: "The depth",
  T_41_XXJ_WS_DRAG: "Drag coefficient",
  T_41_XXJ_WS_DRAG_D: "The larger the coefficient, the faster the movement speed deceleration",
  T_41_XXJ_WS_DUMMY: "Dummy",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE: "Enable low-graphics mode",
  T_41_XXJ_WS_ENABLEENERGYSAVINGMODE_D: "When low fps is on, the game will run on 15 fps; or else 30 fps",
  T_41_XXJ_WS_ENTITYLIST: "Return entity list created",
  T_41_XXJ_WS_ENTITYNAME: "Object name",
  T_41_XXJ_WS_ENTITYNAME_D: "The object name customized by the player",
  T_41_XXJ_WS_ENTITYORPREFABID_D: "Logical Entity or Prefab ID",
  T_41_XXJ_WS_EQUIPANDBAG: "Armor and Backpack",
  T_41_XXJ_WS_EQUIPMENTSLOT: "Equipment slot enum",
  T_41_XXJ_WS_EQUIPMENTSLOT_D: "Equipment Slot Enum",
  T_41_XXJ_WS_EXPLODE: "Self-explode",
  T_41_XXJ_WS_EXPLOSIVEWEAPON_D: "Explosive Weapon",
  T_41_XXJ_WS_FASTAUTORELOADSPEED: "Auto reload speed",
  T_41_XXJ_WS_FILEID: "Internal ID",
  T_41_XXJ_WS_FILEID_D: "The internal ID of the control in the prefab",
  T_41_XXJ_WS_FILLAMOUNT: "Fill amount",
  T_41_XXJ_WS_FILLAMOUNT_D: "The fill value",
  T_41_XXJ_WS_FILLDIR: "Fill direction",
  T_41_XXJ_WS_FILLDIR_D: "The direction of the fill",
  T_41_XXJ_WS_FILLDIR_D1: "Fill direction enum",
  T_41_XXJ_WS_FILLTYPE: "Fill type",
  T_41_XXJ_WS_FILLTYPE_D: "The fill type",
  T_41_XXJ_WS_FILLTYPE_D1: "Fill type enum",
  T_41_XXJ_WS_FINDSTRAIGHTPATH_D: "Find path",
  T_41_XXJ_WS_FINISH: "Complete",
  T_41_XXJ_WS_FIREINTERVAL: "Firing interval",
  T_41_XXJ_WS_FIREINTERVAL_D: "Attack Interval",
  T_41_XXJ_WS_FLIP: "Flip method",
  T_41_XXJ_WS_FLIP_D: "The flip method",
  T_41_XXJ_WS_FLYBOMBBEE: "Flying Zombie",
  T_41_XXJ_WS_FORCE: "Force",
  T_41_XXJ_WS_FORCE_D: "Create a force of a designated intensity",
  T_41_XXJ_WS_FORCETYPE: "Force type",
  T_41_XXJ_WS_FORCETYPE_D: "The different types of forces on the RigidBody. P.S. Only effective on dynamic RigidBody types.",
  T_41_XXJ_WS_FREEZEALL: "Freeze movement and rotation",
  T_41_XXJ_WS_FREEZEPOSITION: "Freeze linear movement",
  T_41_XXJ_WS_FREEZEPOSITIONX: "Freeze x axis",
  T_41_XXJ_WS_FREEZEPOSITIONY: "Freeze y axis",
  T_41_XXJ_WS_FREEZEPOSITIONZ: "Freeze z axis",
  T_41_XXJ_WS_FREEZEROTATION: "Freeze all rotation",
  T_41_XXJ_WS_FREEZEROTATIONX: "Freeze x rotation",
  T_41_XXJ_WS_FREEZEROTATIONY: "Freeze y rotation",
  T_41_XXJ_WS_FREEZEROTATIONZ: "Freeze z rotation",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE: "Distance for max. damage",
  T_41_XXJ_WS_FULLDAMAGEDISTANCE_D: "Distance for max. damage",
  T_41_XXJ_WS_GAMEID_D: "Mission ID",
  T_41_XXJ_WS_GIVEJAILBREAKITEM_D: "Give a Metropolis item",
  T_41_XXJ_WS_GRADIENT: "Gradient",
  T_41_XXJ_WS_GRADIENT_D: "The gradient",
  T_41_XXJ_WS_GRADIENTBOTTOM: "Gradient at bottom",
  T_41_XXJ_WS_GRADIENTBOTTOM_D: "The gradient at the bottom",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA: "Transparency at bottom",
  T_41_XXJ_WS_GRADIENTBOTTOMALPHA_D: "Bottom Transparency",
  T_41_XXJ_WS_GRADIENTTOP: "Gradient at top",
  T_41_XXJ_WS_GRADIENTTOP_D: "The gradient at the top",
  T_41_XXJ_WS_GRADIENTTOPALPHA: "Transparency at top",
  T_41_XXJ_WS_GRADIENTTOPALPHA_D: "Top Transparency",
  T_41_XXJ_WS_GRAPHID: "Script ID",
  T_41_XXJ_WS_GRAPHID_D: "The ID used to describe a script asset",
  T_41_XXJ_WS_GRENADEDEICEWALL_D: "Gloo Melter Component",
  T_41_XXJ_WS_GRENADEEXPLOSIONTIME_D: "Explosion Delay",
  T_41_XXJ_WS_GRENADELAUNCHER_D: "Throwable",
  T_41_XXJ_WS_GRENADEMAXDAMAGE_D: "Max. DMG",
  T_41_XXJ_WS_GRENADEMINDAMAGE_D: "Min. DMG",
  T_41_XXJ_WS_GRENADERANGE_D: "Explosion Range",
  T_41_XXJ_WS_GRENADERATIOSELF_D: "Self DMG multiplier",
  T_41_XXJ_WS_GRENADERATIOTEAMMATE_D: "Ally DMG multiplier",
  T_41_XXJ_WS_GRENADERATIOVEHICLE_D: "Vehicle DMG multiplier",
  T_41_XXJ_WS_GRENADETHROWSPEED_D: "Throwing Speed",
  T_41_XXJ_WS_GRENADEWEAPON: "Throwable category",
  T_41_XXJ_WS_GRENADEWEAPON_D: "Basic Throwable Types",
  T_41_XXJ_WS_HANDCANNON_D: "Throwables",
  T_41_XXJ_WS_HEAD: "Head",
  T_41_XXJ_WS_HEADID: "Avatar ID",
  T_41_XXJ_WS_HEADID_D: "Avatar ID",
  T_41_XXJ_WS_HEAVYWEAPON_D: "Heavy Weapon",
  T_41_XXJ_WS_HELMET_D: "The current helmet",
  T_41_XXJ_WS_HELMET1_D: "Helmet",
  T_41_XXJ_WS_HELMET2_D: "Helmet Entity",
  T_41_XXJ_WS_HITBODYPART_D: "The body part that is hit",
  T_41_XXJ_WS_HITBPDYPART: "Hit body part",
  T_41_XXJ_WS_HITENTITY_D: "Hit Entity",
  T_41_XXJ_WS_HOSTHUDENTITY_D: "The HUD entity it belongs to",
  T_41_XXJ_WS_HUD3DCONTAINER: "3D content container",
  T_41_XXJ_WS_HUD3DCONTAINER_D: "The HUD 3D container entity. This is the HUD that players modify from the editor.",
  T_41_XXJ_WS_HUDGRID: "Custom Layout(Panel) control",
  T_41_XXJ_WS_HUDLAYOUT: "Layout control",
  T_41_XXJ_WS_HUDLAYOUT_D: "The HUD insertion entity. This is the HUD that players modify from the editor.",
  T_41_XXJ_WS_HUDPROFILEINFO: "Custom avatar control",
  T_41_XXJ_WS_HUDPROFILEINFO_D: "The HUD profile info entity. This is the HUD that players modify from the editor.",
  T_41_XXJ_WS_HUDTEXTURE: "Texture control",
  T_41_XXJ_WS_HUDTEXTURE_D: "The HUD texture entity. This is the HUD that players modify from the editor.",
  T_41_XXJ_WS_HUDTRANSFORM: "UITransform control component",
  T_41_XXJ_WS_HUDTRANSFORM_D: "The UITransform control entity",
  T_41_XXJ_WS_IMPULSE: "Strike",
  T_41_XXJ_WS_IMPULSE_D: "Create a strike of a designated intensity",
  T_41_XXJ_WS_INITIALWORLDPOS: "Initial world coordinates",
  T_41_XXJ_WS_INTERNALBUFFTYPE: "Buff enum",
  T_41_XXJ_WS_INTERNALBUFFTYPE_D: "Corresponds to the ID column in the BuffData.csv. Before adding new content, please first check compatability with GPP.",
  T_41_XXJ_WS_INVERTFILL: "Invert fill",
  T_41_XXJ_WS_INVERTFILL_D: "Invert the fill",
  T_41_XXJ_WS_ISLOOP: "Is loop",
  T_41_XXJ_WS_ISLOOP_D: "Whether or not to loop. Default is false.",
  T_41_XXJ_WS_ISNAVMESHSTATIC: "Static NavMesh generation",
  T_41_XXJ_WS_ISNAVMESHSTATIC_D: "Only used to check for static NavMesh generation when static loading objects",
  T_41_XXJ_WS_ISSUCCESS_D: "Destructed or not",
  T_41_XXJ_WS_ITEMENTITY_D: "Item Entity",
  T_41_XXJ_WS_ITEMID: "Item ID",
  T_41_XXJ_WS_ITEMID_D: "Item ID",
  T_41_XXJ_WS_ITEMID_D1: "The corresponding item ID of the attachment",
  T_41_XXJ_WS_ITEMLIST: "Item list",
  T_41_XXJ_WS_ITEMTYPE_D: "Item Type",
  T_41_XXJ_WS_JUMPATTACK: "Jump attack",
  T_41_XXJ_WS_LANDMINE: "Landmine",
  T_41_XXJ_WS_LENGTH: "Clip length",
  T_41_XXJ_WS_LENGTH_D: "The length of the progress bar. The default value is the length on the prefab UI.",
  T_41_XXJ_WS_LIMB: "Limbs",
  T_41_XXJ_WS_LISTLENGTHOVERLIMIT: "Failed to add element since list length has exceeded capacity",
  T_41_XXJ_WS_LISTT_INTERNALBUFFTYPE: "Buff list",
  T_41_XXJ_WS_LOOP: "Loop",
  T_41_XXJ_WS_LOOP_D: "Loop",
  T_41_XXJ_WS_MAXCAPACITY: "Capacity",
  T_41_XXJ_WS_MAXCAPACITY_D: "The backpack capacity",
  T_41_XXJ_WS_MAXPROGRESS: "Max. progress",
  T_41_XXJ_WS_MELEEWEAPON_D: "Melee Weapon",
  T_41_XXJ_WS_MINDAMAGEDISTANCE: "Distance for min. damage",
  T_41_XXJ_WS_MINDAMAGEDISTANCE_D: "Distance for min. damage",
  T_41_XXJ_WS_MINISENTRY: "Auto Turret",
  T_41_XXJ_WS_NAME: "Name",
  T_41_XXJ_WS_NAME_D: "The name of the skill button. Used for parameter sending during OnClick incidents, so uniqueness must be guaranteed.",
  T_41_XXJ_WS_NAME1_D: "Merchandise Name",
  T_41_XXJ_WS_NAME2_D: "Merchandise List Name",
  T_41_XXJ_WS_NAME3_D: "Vending Machine Name",
  T_41_XXJ_WS_NICKNAME: "Nickname",
  T_41_XXJ_WS_NICKNAME_D: "Player Name",
  T_41_XXJ_WS_NOCHANGE: "No changes",
  T_41_XXJ_WS_NONE: "No constraints",
  T_41_XXJ_WS_NONE1: "None",
  T_41_XXJ_WS_OFFSET: "Offset",
  T_41_XXJ_WS_OFFSET_D: "Offset",
  T_41_XXJ_WS_OFFSET1_D: "Written Offset Value",
  T_41_XXJ_WS_ONCE: "Once",
  T_41_XXJ_WS_ONCE_D: "Once",
  T_41_XXJ_WS_ONHIDE: "When interface is closed",
  T_41_XXJ_WS_ONHIDE_D: "When the interface is closed",
  T_41_XXJ_WS_ONNODEENTER_D: "When the pivot is entering",
  T_41_XXJ_WS_ONSHOW: "When interface is open",
  T_41_XXJ_WS_ONSHOW_D: "When the interface is open",
  T_41_XXJ_WS_ONSYNCINPUTTEXT_D: "Triggers when the text box has changed",
  T_41_XXJ_WS_PERSONALUAV: "UAV-Lite",
  T_41_XXJ_WS_PINID: "Pin ID",
  T_41_XXJ_WS_PINID_D: "Pin ID",
  T_41_XXJ_WS_PLAYERBAG: "Player backpack entity",
  T_41_XXJ_WS_PLAYERBAG_D: "The player's backpack entity",
  T_41_XXJ_WS_PLAYERBAGENTITY: "Player backpack",
  T_41_XXJ_WS_PLAYERBAGENTITY_D: "Player's backpack",
  T_41_XXJ_WS_PLAYERSPEEDFACTORAIMING: "Modified coefficient of speed while scoped in",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING: "Impact of movement speed while firing",
  T_41_XXJ_WS_PLAYERSPEEDFACTORFIRING_D: "Impact of movement speed while firing",
  T_41_XXJ_WS_PREFABID: "Prefab ID",
  T_41_XXJ_WS_PREFABID_D: "The ID used to describe a prefab asset",
  T_41_XXJ_WS_PREFABID1_D: "The HUD template entity that this ID represents",
  T_41_XXJ_WS_PRIMARYWEAPON1_D: "Main Weapon 1",
  T_41_XXJ_WS_PRIMARYWEAPON2_D: "Main Weapon 2",
  T_41_XXJ_WS_PROFILEINFO: "Player profile",
  T_41_XXJ_WS_PROFILEINFO_D: "Player bio",
  T_41_XXJ_WS_PROGRESSICON_D: "The progress icon",
  T_41_XXJ_WS_PROGRESSICONSPRITENAME: "Progress icon name",
  T_41_XXJ_WS_QUITJAILBREAKMINIGAME_D: "Quit the Metropolis minigame",
  T_41_XXJ_WS_RANGE: "Firing range",
  T_41_XXJ_WS_RANGE_D: "Attack Range",
  T_41_XXJ_WS_RANGE_D1: "Explosion Range",
  T_41_XXJ_WS_RANGE_D2: "Turret Range",
  T_41_XXJ_WS_READCSVDATAALLOVERMODE_D: "Read the content on the entire table. Return a two-dimensional array.",
  T_41_XXJ_WS_READCSVDATACELLOVERMODE_D: "Read the content of a certain cell",
  T_41_XXJ_WS_READCSVDATACOLOVERMODE_D: "Read a certain column's content. Returns an array.",
  T_41_XXJ_WS_READCSVDATAROWOVERMODE_D: "Read a certain row's content. Returns an array.",
  T_41_XXJ_WS_READDBACCUMULATEDDATA: "Read accumulated database",
  T_41_XXJ_WS_READDBACCUMULATEDDATA_D: "Read the value corresponding to a key in a table in the accumulated database",
  T_41_XXJ_WS_RECOVERPLAYERHP: "Continuously recover HP",
  T_41_XXJ_WS_RELOADSPEED: "Reload speed",
  T_41_XXJ_WS_RELOADSPEED_D: "Reload Speed (Basic Speed x Multiplier)",
  T_41_XXJ_WS_RESOURCEID: "Resource UUID",
  T_41_XXJ_WS_RESOURCEID_D: "Resource UUID",
  T_41_XXJ_WS_RESUUID: "Resource ID",
  T_41_XXJ_WS_RESUUID_D: "The designated resource UUID to render",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE: "RigidBody constraint type",
  T_41_XXJ_WS_RIGIDBODYCONSTRAINTYPE_D: "Each constraint is defined by a bit marking and can be used as a combination",
  T_41_XXJ_WS_ROTATION: "Rotation",
  T_41_XXJ_WS_ROTATION_D: "The rotation angle in the world coordinates. x, y, z refers to the yaw, pitch, and roll, respectively.",
  T_41_XXJ_WS_ROTATION1_D: "The rotation",
  T_41_XXJ_WS_RUNNING: "Running",
  T_41_XXJ_WS_SCALE: "Scale",
  T_41_XXJ_WS_SCALE_D: "Scale",
  T_41_XXJ_WS_SCALE1_D: "Scales along a certain axis. Can be a combination of three axes.",
  T_41_XXJ_WS_SCATTERMAX: "Max. bullet scatter",
  T_41_XXJ_WS_SCATTERMAX_D: "The value at which bullet spread begins",
  T_41_XXJ_WS_SCATTERMOVE1: "Spread size when moving",
  T_41_XXJ_WS_SCATTERRECOVERSPEED: "Speed of spread recovery",
  T_41_XXJ_WS_SCATTERRECOVERSPEED_D: "Speed of spread recovery",
  T_41_XXJ_WS_SCATTERSPEED: "Speed of spread increase",
  T_41_XXJ_WS_SCATTERSPEED_D: "Speed of spread increase (0.1 = The crosshair enlarges 10% for every one burst increase)",
  T_41_XXJ_WS_SCATTERSPEEDCROUCHCREEP: "Less spread on prone and crouch",
  T_41_XXJ_WS_SECONDARYWEAPON_D: "Secondary Weapon",
  T_41_XXJ_WS_SHADERNAME: "Shader name",
  T_41_XXJ_WS_SHADERNAME_D: "The shader name",
  T_41_XXJ_WS_SHIELDBROKEN: "Shield-shatter attack",
  T_41_XXJ_WS_SHIELDUP: "Shield attack",
  T_41_XXJ_WS_SHOCKWAVE: "Shockwave",
  T_41_XXJ_WS_SHOWNAME: "Display nickname",
  T_41_XXJ_WS_SHOWNAME_D: "Display Nickname",
  T_41_XXJ_WS_SHOWPIN: "Display pin",
  T_41_XXJ_WS_SHOWPIN_D: "Display Pin",
  T_41_XXJ_WS_SHOWRANK: "Display rank",
  T_41_XXJ_WS_SHOWRANK_D: "Display Rank",
  T_41_XXJ_WS_SHOWTYPE: "Design",
  T_41_XXJ_WS_SHOWTYPE_D: "Type",
  T_41_XXJ_WS_SHRINKSPEED: "Shrink speed",
  T_41_XXJ_WS_SIGHTAIMASSIST: "Enable aim assist on scope",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTFALLOFF: "Aim assist crosshair sensitivity with distance (0-1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOCOEF: "Coefficient when prioritizing distance for aim assist (≥ 1)",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMAX: "Max. distance to prioritize distance for aim assist",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIOMIN: "Min. distance to prioritize distance for aim assist",
  T_41_XXJ_WS_SIGHTAIMASSISTDISTPRIORITY: "Prioritize distance for aim assist",
  T_41_XXJ_WS_SIGHTAIMASSISTSNAPRANGE: "Aim assist crosshair sensitivity (0-1)",
  T_41_XXJ_WS_SIGHTAMPLIFYRATIO: "Scope zoom in factor",
  T_41_XXJ_WS_SIGHTFOVAMPLIFYRATIO: "FOV zoom in factor",
  T_41_XXJ_WS_SIGHTROTSENSITIVENESS: "Scope rotation sensitivity coefficient",
  T_41_XXJ_WS_SIGHTSHOOTMINDAMAGE: "Modified coefficient x of min. scoped in DMG",
  T_41_XXJ_WS_SIGHTUIACTIONEXPAND: "Scoped in firing UI zoom in time (s)",
  T_41_XXJ_WS_SIGHTUIACTIONRATIO: "Scoped in firing UI zoom in factor",
  T_41_XXJ_WS_SIGHTUIACTIONRECOVERY: "Scoped in firing UI resume time (s)",
  T_41_XXJ_WS_SPEED: "Playback speed",
  T_41_XXJ_WS_SPEEQUIP: "Functional equipment",
  T_41_XXJ_WS_SPEITEM: "Devices",
  T_41_XXJ_WS_STATICGRAPHID: "Static script ID",
  T_41_XXJ_WS_STATICGRAPHID_D: "The ID used to describe a static script asset",
  T_41_XXJ_WS_STATICWAINING: "Failed to modify static Rigidbody type",
  T_41_XXJ_WS_TARGETTREE: "Behavior tree entity",
  T_41_XXJ_WS_TARGETTREE_D: "The behavior tree entity",
  T_41_XXJ_WS_TEAMINDEX: "Team serial no.",
  T_41_XXJ_WS_TEAMINDEX_D: "The team index, which coincides with the team index in the room",
  T_41_XXJ_WS_TEAMINDEX_D1: "Team Faction Number",
  T_41_XXJ_WS_TEMPLATEPREFABID: "Template prefab ID",
  T_41_XXJ_WS_TEXT_D: "Content",
  T_41_XXJ_WS_TEXTURENAME: "Texture name",
  T_41_XXJ_WS_TEXTURENAME_D: "The texture name",
  T_41_XXJ_WS_THROWATTACK: "Grenade",
  T_41_XXJ_WS_TICKINTERVAL: "Refresh interval",
  T_41_XXJ_WS_TICKINTERVAL_D: "Refresh interval. The larger the number, the longer the refresh takes.",
  T_41_XXJ_WS_TOGGLESPECIALITEMSTATE_D: "Enable special devices in the player's backpack",
  T_41_XXJ_WS_UVRECTWH: "UV width & height",
  T_41_XXJ_WS_UVRECTWH_D: "The UV width and height",
  T_41_XXJ_WS_UVRECTXY: "UV offset",
  T_41_XXJ_WS_UVRECTXY_D: "The UV offset",
  T_41_XXJ_WS_VELOCITY: "Velocity",
  T_41_XXJ_WS_VELOCITY_D: "Refrain from directly changing the RigidBody's speed. You may change it using related APIs.",
  T_41_XXJ_WS_VEST_D: "The current vest",
  T_41_XXJ_WS_VEST1_D: "Vest",
  T_41_XXJ_WS_WIDGETID: "Control ID",
  T_41_XXJ_WS_WIDGETID_D: "The ID used to describe a control in the interface assets. It must be paired with a custom HUD ID in order to ensure that it corresponds to a unique control ID.",
  T_41_XXJ_WS_WINDATTACK: "Tornado attack",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET: "Write accumulated database offset",
  T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET_D: "Write the offset corresponding to a key in a table in the accumulated database",
  T_41_XXJ_WS_ZONEDURATION_D: "Freeze duration",
  T_41_XXJ_WS_ZONEDURATION1_D: "Gloo Melter Duration",
  T_41_XXJ_WS_ZONERADIUS_D: "Freeze zone radius",
  T_41_XXJ_WS_ZONERADIUS1_D: "Gloo Melter Radius",
  T_41_XYL_WS_BOT12: "Earth Driller",
  T_41_XYL_WS_BOT9: "Mutated Tossing Zombie",
  T_41_XYL_WS_ITEM262: "Frozen Steel Panel A",
  T_41_XYL_WS_ITEM263: "Frozen Container A",
  T_41_XYL_WS_ITEM264: "Frozen Supply Container",
  T_41_XYL_WS_ITEM265: "Frozen Metal Gate",
  T_41_XYL_WS_ITEM266: "Frozen Container B",
  T_41_XYL_WS_ITEM267: "Frozen Stone A",
  T_41_XYL_WS_ITEM268: "Frozen Stone B",
  T_41_XYL_WS_ITEM269: "Frozen Stone C",
  T_41_XYL_WS_ITEM270: "Frozen Stone D",
  T_41_XYL_WS_ITEM271: "Abandoned Subway Car",
  T_41_XYL_WS_MODELMATCHNAME: "Contest Canvas",
  T_41_XYL_WS_NAVMESH: "Dynamic navmesh",
  T_41_XYL_WS_REFCUBE: "Reflective Cube",
  T_41_XYL_WS_SNOWSKY: "Frost Galaxy",
  T_41_XYL_WS_TOYCUBE: "Play Cube",
  T_42_CJ_F_B_VOCATIONAL: "Gearing Blueprint (Bottom)",
  T_42_CJ_F_H_VOCATIONAL: "Gearing Blueprint (Head)",
  T_42_CJ_F_S_VOCATIONAL: "Gearing Blueprint (Shoes)",
  T_42_CJ_F_T_VOCATIONAL: "Gearing Blueprint (Top)",
  T_42_CJ_HA_THUNDER_GOLD: "Lightning Facepaint",
  T_42_CJ_M_B_VOCATIONAL: "Mechanic Masterplan (Bottom)",
  T_42_CJ_M_H_VOCATIONAL: "Mechanic Masterplan (Head)",
  T_42_CJ_M_S_VOCATIONAL: "Mechanic Masterplan (Shoes)",
  T_42_CJ_M_T_VOCATIONAL: "Mechanic Masterplan (Top)",
  T_42_H_CHARACTER_SUPERTEEN_N: "Ignis",
  T_42_H_GLOO_EVOTIGER_N: "Gloo Wall - Tiger's Fury",
  T_42_H_GRENADE_SMUDGE_N: "Grenade - Feline Shadow",
  T_42_H_M1917_EMPIRE_N: "M1917 - Crowned Conqueror",
  T_42_HJ_WS_VFX_INK: "Ink",
  T_42_JH_WS_BANMATCHMAKING: "Matchmaking not allowed for this map",
  T_42_JH_WS_BANROOMCREATE: "Unable to create a room",
  T_42_JH_WS_FPS: "FPS",
  T_42_JH_WS_SKILLSETALOKAWAKEN: "Party Remix (Alok)",
  T_42_JH_WS_SKILLSETFIREWALL: "Wall of Flame (Ignis)",
  T_42_JH_WS_SKILLSETSANTINO: "Shape Splitter (Santino)",
  T_42_JH_WS_SKILLSETSONIA: "Nano Lifeshield (Sonia)",
  T_42_JH_WS_TAG1: "Frost Brawl",
  T_42_JH_WS_TAG10: "Infinity Racer",
  T_42_JH_WS_TAG11: "Race Rush",
  T_42_JH_WS_TAG12: "Car Racing",
  T_42_JH_WS_TAG13: "Exclude from Popular",
  T_42_JH_WS_TAG14: "Frontline",
  T_42_JH_WS_TAG15: "Zombie War",
  T_42_JH_WS_TAG16: "Legacy Legend",
  T_42_JH_WS_TAG2: "Social Island 1.0",
  T_42_JH_WS_TAG3: "Social Island 2.0",
  T_42_JH_WS_TAG4: "Play Together",
  T_42_JH_WS_TAG5: "Ruin Survivor",
  T_42_JH_WS_TAG6: "Preying Party",
  T_42_JH_WS_TAG7: "Preying Party",
  T_42_JH_WS_TAG8: "Fort Feud 2.0",
  T_42_JH_WS_TAG9: "Bounty Hunting",
  T_42_RW_PORTALSFORPERSONAL_DESC: "Place a portal anywhere and teleport away!",
  T_42_RW_PORTALSPERSONAL_NAME: "Portal Go",
  T_42_SJ_WS_ACCESSORIESITEM: "Equip attachment",
  T_42_SJ_WS_AUTOPLAY: "Auto play",
  T_42_SJ_WS_CLIMB: "Climb over",
  T_42_SJ_WS_CLOCK_EVENTS: "Event compilation",
  T_42_SJ_WS_CLOCK_IS_COUNTDOWN: "Countdown or not",
  T_42_SJ_WS_CLOCK_LOOP_COUNT: "Loops",
  T_42_SJ_WS_CLOCK_PAUSE_EVENT: "Pause event",
  T_42_SJ_WS_CLOCK_START_EVENT: "Start event",
  T_42_SJ_WS_CLOCK_START_TIME: "Countdown start time",
  T_42_SJ_WS_CLOCK_STATE: "Stopwatch status",
  T_42_SJ_WS_CLOCK_STOP_EVENT: "Stop event",
  T_42_SJ_WS_DAMRATIOHEAD: "Headshot DMG coefficient change",
  T_42_SJ_WS_DAMRATIOLIMB: "Limb DMG coefficient change",
  T_42_SJ_WS_DAMREDUCEXPLODE: "Reduction coefficient from explosive DMG",
  T_42_SJ_WS_DRIVE: "Drive",
  T_42_SJ_WS_ENTITYITEXT_DEPTH: "Display layers",
  T_42_SJ_WS_EXTRABAGCAPACITY: "Extra backpack capacity",
  T_42_SJ_WS_EXTRAHPRATIO: "HP ratio",
  T_42_SJ_WS_GETOFF_DRIVE: "Exit vehicle",
  T_42_SJ_WS_GETON_DRIVE: "Enter vehicle",
  T_42_SJ_WS_KNIFEITEM: "Dagger",
  T_42_SJ_WS_KNIFEITEMPICK: "Dagger (ground loot)",
  T_42_SJ_WS_MARKBTNHUD: "The pin button on the HUD",
  T_42_SJ_WS_MARKBTNHUD_D: "You can enable or disable the pin button",
  T_42_SJ_WS_MAXDISTANCE: "Max. distance",
  T_42_SJ_WS_MAXDURARATIO: "Max. durability ratio",
  T_42_SJ_WS_MICBTNHUD: "The mic switch on the HUD",
  T_42_SJ_WS_MICBTNHUD_D: "You can enable or disable the mic button",
  T_42_SJ_WS_MINDISTANCE: "Min. distance",
  T_42_SJ_WS_OPE_VEHICLE: "Operate vehicle",
  T_42_SJ_WS_PLANE_DESC: "A basic mesh whose size can be freely adjusted",
  T_42_SJ_WS_PLANENAME: "Basic Plane",
  T_42_SJ_WS_PRIORITY: "Priority",
  T_42_SJ_WS_REPLACEPRIORITY: "Replace priority",
  T_42_SJ_WS_SETBTNHUD: "The settings button on the HUD",
  T_42_SJ_WS_SETBTNHUD_D: "You can enable or disable the settings button",
  T_42_SJ_WS_SIGNALBTNHUD: "The network connection button on the HUD",
  T_42_SJ_WS_SIGNALBTNHUD_D: "You can enable or disable the network connection button",
  T_42_SJ_WS_SPEAKERBTNHUD: "The horn button on the HUD",
  T_42_SJ_WS_SPEAKERBTNHUD_D: "You can enable or disable the vehicle horn button",
  T_42_SJ_WS_START_TIME: "Start time (s)",
  T_42_SW_SKILL_DESC_ARMSDEALER: "Get an additional [FFB300]{0}[-] backpack capacity for ammo, excluding Grenade Launcher. ([FFB300]{1}[-] AR Ammo, [FFB300]{2}[-] SMG Ammo, [FFB300]{3}[-] Sniper Ammo, [FFB300]{4}[-] SG Ammo)",
  T_42_SW_SKILL_DESC_Bodyguard: "Reload speed increases by [FFB300]{0}%[-]. Every time the skill user hits an enemy, said target will get a [FFB300]{1}%[-] healing deduction that lasts for [FFB300]{3}s[-] (max. deduction: [FFB300]{2}%[-]).",
  T_42_SW_SKILL_DESC_Playboy: "Become immune from disruptive effects (e.g. slowdown, marking, skill-silencing) and have a [FFB300]{1}%[-] movement speed boost for [FFB300]{2}s[-]. Cooldown: [FFB300]{0}s[-].",
  T_42_SW_SKILL_DESC_SwatGuy: "After knocking down an enemy or using an active skill, [FFB300]{0}%[-] of the gun's magazine reloads automatically.",
  T_42_SW_SKILL_NAME_Playboy: "Silver Spoon",
  T_42_SY_BACKPACK_EMPIRE_N: "Backpack - Crowned Roar",
  T_42_SY_PETSKIN_RABBIT_WINTERFEST23_N: "Pet Skin: Icy Hop",
  T_42_SY_VEHICLESKIN_MOTOBIKE_URBAN_BW_N: "Motorbike - Urban Scooter",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_AFF_N: "Aventador Ultimae Booyah",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_ASILVER_N: "Aventador Ultimae Grigio Nimbus",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VBLACK_N: "Veneno Nero Nemesis",
  T_42_SY_VEHICLESKIN_ROADSTER_BULL_VRED_N: "Veneno Rosso Efesto",
  T_42_TYC_CST_LOSE_MONEY_1: "Amount of CS Cash obtained after losing a round",
  T_42_TYC_CST_LOSE_MONEY_2: "Amount of CS Cash obtained upon a 2-round losing streak",
  T_42_TYC_CST_LOSE_MONEY_3: "Amount of CS Cash obtained upon a 3-round losing streak",
  T_42_WH_ITEM_HEALUAV: "Heal UAV-Lite",
  T_42_WH_ITEM_HEALUAV_DESC: "Deploys a UAV-Lite that flies forward and continuously heals teammates within the range below",
  T_42_WH_ITEM_SKILLCARD: "Skill: {0}",
  T_42_WH_ITEM_SKILLCARD_DESC: `Use to release the active skill of [ffba00]{0}[-]: [ffba00]{1}[-].
{2}`,
  T_42_XXJ_WS_AMMOTYPE: "Ammo Type",
  T_42_XXJ_WS_AMMOTYPE_D: "Ammo Type",
  T_42_XXJ_WS_ASSETCONFIGID: "Skin ID",
  T_42_XXJ_WS_ASSETCONFIGID_D: "Skin",
  T_42_XXJ_WS_ATTACKSTATUS: "Attack status",
  T_42_XXJ_WS_AUTOPLAY: "Auto play",
  T_42_XXJ_WS_AUTOPLAY_D: "Auto play",
  T_42_XXJ_WS_AVATARABLE: "Modifiable appearance component",
  T_42_XXJ_WS_AVATARABLE_D: "Change appearance according to the parts",
  T_42_XXJ_WS_AVATARRESUUID: "Appearance resource UUID",
  T_42_XXJ_WS_AXISANGLETOQUATERNION_D: "Convert the axis-angle representation of a rotation into Quaternions",
  T_42_XXJ_WS_B_D: "The B color value",
  T_42_XXJ_WS_BASEVALUE_D: "Base of logarithm",
  T_42_XXJ_WS_BEZIERCURVE: "Bézier curve",
  T_42_XXJ_WS_BEZIERCURVE_D: "The Bézier curve",
  T_42_XXJ_WS_BOTDIFFICULTY: "Bot Difficulty",
  T_42_XXJ_WS_BOUNCE_COMBINE: "Combination Method of Bounciness",
  T_42_XXJ_WS_BOUNCINES: "Bounciness",
  T_42_XXJ_WS_BTREEID: "Behavior tree ID",
  T_42_XXJ_WS_BTREEID_D: "Behavior tree ID",
  T_42_XXJ_WS_CANPURCHAS: "Purchasable or Not",
  T_42_XXJ_WS_CANPURCHAS_D: "Purchasable or not",
  T_42_XXJ_WS_CLIMBSTATUS: "Climbing behavior",
  T_42_XXJ_WS_CLOCK: "Timer Object",
  T_42_XXJ_WS_CLOCK_D: "Timer Object",
  T_42_XXJ_WS_CLOCK_D1: "Timer",
  T_42_XXJ_WS_CONTAINER: "Container",
  T_42_XXJ_WS_CONTROLPOINTS: "Control points",
  T_42_XXJ_WS_CONTROLPOINTS_D: "The control points",
  T_42_XXJ_WS_COROUTINEID: "Coroutine handle",
  T_42_XXJ_WS_COROUTINEID_D: "The Coroutine ID refers to the handle of a specific coroutine. It allows for various operations to be performed on the handle.",
  T_42_XXJ_WS_CREATESELFRELATIVE_D: "Create a self-relative",
  T_42_XXJ_WS_CREATESELFRELATIVEFRAME_D: "Create a self-relative",
  T_42_XXJ_WS_CREATESOUND: "Create Sound Effect",
  T_42_XXJ_WS_CREATESOUND_D: "Play the designated sound effect. If there are more properties to set, you can do so by configuring its entity properties.",
  T_42_XXJ_WS_CUSTOMMISSIONCOMPLETE_D: "Complete custom mission",
  T_42_XXJ_WS_DAMAGELIST_D: "DMG increment list",
  T_42_XXJ_WS_DAMAGERATIOHEAD_D: "Headshot DMG ratio",
  T_42_XXJ_WS_DAMAGEREDUCTIONFACTOREXPLODE_D: "Explosion DMG reduction multiplier",
  T_42_XXJ_WS_DEFAULT_PHYMAT: "Default Physics Material",
  T_42_XXJ_WS_DEFAULTFIST_D: "Default fist",
  T_42_XXJ_WS_DELTA: "Delta",
  T_42_XXJ_WS_DELTA_D: "Delta",
  T_42_XXJ_WS_DELTATIME: "Logic frame interval",
  T_42_XXJ_WS_DELTATIME_D: "The interval between the 2 logic frame updates of the GS",
  T_42_XXJ_WS_DEPTH: "Layer",
  T_42_XXJ_WS_DEPTH_D: "Display layers on the icon",
  T_42_XXJ_WS_DISABLEPICKUPITEMS: "List of disabled ground loot",
  T_42_XXJ_WS_DISABLEPICKUPITEMS_D: "The list of items that are not ground loot",
  T_42_XXJ_WS_DRIVER: "Driver's seat",
  T_42_XXJ_WS_DRIVINGSTATUS: "Drive",
  T_42_XXJ_WS_DURATION_D1: "The countdown duration in seconds",
  T_42_XXJ_WS_DURATION_D2: "The duration in seconds",
  T_42_XXJ_WS_DURATION_D3: "The duration",
  T_42_XXJ_WS_DURATION_D4: "The duration of invulnerability in seconds",
  T_42_XXJ_WS_DURATIONTIMES: "Time Duration",
  T_42_XXJ_WS_DURATIONTIMES_D: "The duration in seconds",
  T_42_XXJ_WS_DYNAMIC_FRICTION: "Dynamic Friction",
  T_42_XXJ_WS_EASY: "Very Easy",
  T_42_XXJ_WS_ENDTIMES: "End Time",
  T_42_XXJ_WS_ENDTIMES_D: "The end time on the timer in seconds",
  T_42_XXJ_WS_ENERGYTHRESHOLD: "Global Energy Threshold",
  T_42_XXJ_WS_ENTITYVARNAME_D: "The self-relative entity",
  T_42_XXJ_WS_EQUIPMENTATTACHMENT_D: "Equip attachment",
  T_42_XXJ_WS_EULERANGLETOQUATERNION_D: "Convert the given Euler angles into Quaternions",
  T_42_XXJ_WS_EXPONENTIATION_D: "Exponentiation",
  T_42_XXJ_WS_EXTRABAGCAPACITY_D: "Extra backpack capacity",
  T_42_XXJ_WS_FIST: "Fist",
  T_42_XXJ_WS_FONTTYPE: "Font enum",
  T_42_XXJ_WS_FONTTYPE_D: "Font enum",
  T_42_XXJ_WS_FORCESYNCVALUE: "Force sync GS status",
  T_42_XXJ_WS_FORCESYNCVALUE_D: "The force sync value",
  T_42_XXJ_WS_FORCESYNCVALUE_D1: "The location info. from the GS force sync",
  T_42_XXJ_WS_FORCESYNCVALUE1: "Location info from force sync",
  T_42_XXJ_WS_FORMULABLEENTITY_D: "An entity that can formulate properties",
  T_42_XXJ_WS_FORWARD_D: "Direction vector",
  T_42_XXJ_WS_FRICTION_COMBINE: "Method of Friction Combination",
  T_42_XXJ_WS_FUNCPOINT: "Function Pointer",
  T_42_XXJ_WS_FUNCPOINT_D: "A pointer that points to an instance of a function. It is used to implement virtual functions or delegate mechanisms.",
  T_42_XXJ_WS_GETMAPID_D: "Get Map ID",
  T_42_XXJ_WS_GETOFFVEHICLESTATUS: "Exit vehicle",
  T_42_XXJ_WS_GETONASDRIVERSTATUS: "Enter vehicle (driver)",
  T_42_XXJ_WS_GETONASPASSENGERSTATUS: "Enter vehicle (passenger)",
  T_42_XXJ_WS_GETPLAYERTOKENCOUNTTODAY_D: "Search for today's player token data",
  T_42_XXJ_WS_GRAVITY: "Global Gravity",
  T_42_XXJ_WS_HANDHELDITEM: "Current handheld",
  T_42_XXJ_WS_HANDHELDITEM_D: "The current handheld",
  T_42_XXJ_WS_HARD: "Hard",
  T_42_XXJ_WS_HASCOMPONENT_D: "Whether there exists a component",
  T_42_XXJ_WS_HEIGHTLIST_D: "Height increment list",
  T_42_XXJ_WS_INDEXLIST_D: "Access the index list of the string",
  T_42_XXJ_WS_INSCENE: "In scene",
  T_42_XXJ_WS_INSCENE_D: "In scene",
  T_42_XXJ_WS_IS3D_D: "Whether it is a 3D music",
  T_42_XXJ_WS_ISCOUNTDOWN_D: "Countdown or stopwatch",
  T_42_XXJ_WS_ISLOOP: "Loop or not",
  T_42_XXJ_WS_ISLOOP_D: "The IsLoop command",
  T_42_XXJ_WS_ISREPLAY_D: "Whether or not to start from the beginning",
  T_42_XXJ_WS_ISSWITCH_D: "When set to true, it can be combined with relative motion. When set to false, it can be combined with absolute motion.",
  T_42_XXJ_WS_JEEP: "Jeep",
  T_42_XXJ_WS_JUMPSTATUS: "Jump status",
  T_42_XXJ_WS_LEFTVALUE: "Left Value",
  T_42_XXJ_WS_LEFTVALUE_D: "Base",
  T_42_XXJ_WS_LOGARITHM_D: "Logarithm",
  T_42_XXJ_WS_LOOPABLE: "Loopable",
  T_42_XXJ_WS_LOOPABLE_D: "Loopable",
  T_42_XXJ_WS_MAPGETALLKEYS_D: "Get all keys from the dict",
  T_42_XXJ_WS_MAPVALUE_D: "Target Dict",
  T_42_XXJ_WS_MARKBTNHUD: "The pin button on the HUD",
  T_42_XXJ_WS_MATHE: "e",
  T_42_XXJ_WS_MATHPI: "pi",
  T_42_XXJ_WS_MAXDISTANCE_D: "The maximum distance",
  T_42_XXJ_WS_MICROPHONEBTNHUD: "The mic switch on the HUD",
  T_42_XXJ_WS_MINDISTANCE_D: "The minimum distance",
  T_42_XXJ_WS_MISSIONID_D: "Mission ID",
  T_42_XXJ_WS_MISSIONPROGRESS_D: "Progress (cannot be a negative number)",
  T_42_XXJ_WS_MODERATE: "Moderate",
  T_42_XXJ_WS_MONSTERTRUCK: "Monster Truck",
  T_42_XXJ_WS_MOTORBIKE: "Motor Bike",
  T_42_XXJ_WS_MOVEMENTSTATUS: "Movement status",
  T_42_XXJ_WS_MULTIPLYQUATERNION_D: "Multiplication of two quaternions (representing rotation superposition)",
  T_42_XXJ_WS_NORMAL: "Normal",
  T_42_XXJ_WS_OBSOLETE: "Discarded",
  T_42_XXJ_WS_OPENPLAYERVIEW: "Enable player perspective",
  T_42_XXJ_WS_OPENPLAYERVIEW_D: "Enable player perspective",
  T_42_XXJ_WS_ORIGINWEAPONTYPE: "Weapon Type",
  T_42_XXJ_WS_ORIGINWEAPONTYPE_D: "Weapon Type",
  T_42_XXJ_WS_OVERLOADPLAYERSKIN: "Prioritize Player Config.",
  T_42_XXJ_WS_PARAMSARRAY: "Parameters Array",
  T_42_XXJ_WS_PARAMSARRAY_D: "Parameters Array is a list of parameters involved in output. It needs to match the number of %v in the format description.",
  T_42_XXJ_WS_PARAMSARRAY_D1: "The list of actual parameters passed to the custom functions.",
  T_42_XXJ_WS_PARTVISABLEMASK1: "Part visibility mask 1",
  T_42_XXJ_WS_PARTVISABLEMASK2: "Part visibility mask 2",
  T_42_XXJ_WS_PARTVISABLEMASK3: "Part visibility mask 3",
  T_42_XXJ_WS_PARTVISABLEMASK4: "Part visibility mask 4",
  T_42_XXJ_WS_PASSENGER1: "Passenger seat 1",
  T_42_XXJ_WS_PASSENGER2: "Passenger seat 2",
  T_42_XXJ_WS_PASSENGER3: "Passenger seat 3",
  T_42_XXJ_WS_PHYMAT: "Physical Material",
  T_42_XXJ_WS_PLAYABLEENTITIES_D: "Entity",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME: "Self-relative motion in each frame",
  T_42_XXJ_WS_PLAYABLERELATIVEFRAME_D: "Self-relative motion every frame",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE: "Self-relative motion",
  T_42_XXJ_WS_PLAYABLESELFRELATIVE_D: "The self-relative motion",
  T_42_XXJ_WS_PLAYER_D: "The player that needs to enter the vehicle",
  T_42_XXJ_WS_PLAYERBEHAVIOR: "Entity of player behavior property sync",
  T_42_XXJ_WS_PLAYERBEHAVIOR_D: "The entity of the player behavior property sync",
  T_42_XXJ_WS_PRIORITY_D: "Priority",
  T_42_XXJ_WS_PROPID_D: "The property ID",
  T_42_XXJ_WS_QUATERNION: "Quaternion",
  T_42_XXJ_WS_QUATERNION_D: "Quaternion is a special four-dimensional vector used only to represent a rotation",
  T_42_XXJ_WS_QUATERNIONTOAXISANGLE_D: "Convert the given Quaternions to axis-angle representation",
  T_42_XXJ_WS_QUATERNIONTOEULERANGLE_D: "Convert the given Quaternions to Euler angles. If the Quaternions do not meet the standard, return (0,0,0).",
  T_42_XXJ_WS_REPEATTIMES_D: "The number of times played. Default is 1.",
  T_42_XXJ_WS_RESETPLAYABLE_D: "Reset",
  T_42_XXJ_WS_RIGHTVALUE: "Right Value",
  T_42_XXJ_WS_RIGHTVALUE_D: "Power",
  T_42_XXJ_WS_SEATTYPE: "Vehicle seat enum",
  T_42_XXJ_WS_SEPSTR_D: "String used for separation",
  T_42_XXJ_WS_SETPLAYERFALLINGDAMAGE_D: "Set player fall DMG",
  T_42_XXJ_WS_SETTINGSBTNHUD: "The settings button on the HUD",
  T_42_XXJ_WS_SHOWPOSITION: "Show Location",
  T_42_XXJ_WS_SHOWPOSITION_D: "Show Location",
  T_42_XXJ_WS_SIGNALICOHUD: "The network connection button on the HUD",
  T_42_XXJ_WS_SIMPLE: "Easy",
  T_42_XXJ_WS_SLERPQUATERNION_D: "Spherical quaternion interpolation from A to B",
  T_42_XXJ_WS_SOUNDENTITY_D: "The sound effect entity represents a sound effect that is being played",
  T_42_XXJ_WS_SPEAKERBTNHUD: "The horn button on the HUD",
  T_42_XXJ_WS_SPLITSTRING_D: "Use a certain string as a delimiter to split the string into a slice",
  T_42_XXJ_WS_SPORTSCAR: "Sports Car",
  T_42_XXJ_WS_SPRINTSTATUS: "Sprint status",
  T_42_XXJ_WS_SRCVAL_D: "The source value",
  T_42_XXJ_WS_STARTTICKCOUNT: "The moment when the GS starts to tick",
  T_42_XXJ_WS_STARTTICKCOUNT_D: "The moment when GS starts to tick",
  T_42_XXJ_WS_STARTTIME_D: "Time of start",
  T_42_XXJ_WS_STARTTIME_D1: "Time of start",
  T_42_XXJ_WS_STATE_D: "A player's status: active, knocked down, or eliminated",
  T_42_XXJ_WS_STATE_D1: "Check whether this sound effect is playing",
  T_42_XXJ_WS_STATIC_FRICTION: "Static Friction",
  T_42_XXJ_WS_STRELEMS_D: "Target string set",
  T_42_XXJ_WS_STRINGFINDAT_D: "Return the final combined string according to the index list",
  T_42_XXJ_WS_STRINGJOIN_D: "Join strings using a specified identifier",
  T_42_XXJ_WS_STRINGLOWER_D: "Convert all characters in the string to lowercase",
  T_42_XXJ_WS_STRINGSTRIP_D: "Remove whitespace characters from both sides of the string",
  T_42_XXJ_WS_STRINGUPPER_D: "Convert all characters in the string to uppercase",
  T_42_XXJ_WS_STYLE_D: "How it is played",
  T_42_XXJ_WS_SUV: "Pickup Truck",
  T_42_XXJ_WS_SWITCH: "Switch",
  T_42_XXJ_WS_SWITCH_D: "When set to true, it can be combined with relative motion. When set to false, it must be combined with absolute motion, otherwise the properties won't take effect correctly.",
  T_42_XXJ_WS_TARGETENTITY_D: "The target entity",
  T_42_XXJ_WS_TEAMROUNDSCOREBANNERHUD: "Team Round Score Banner",
  T_42_XXJ_WS_TEAMSEQ_D: "The team serial number that corresponds to the serial number property of the team entity",
  T_42_XXJ_WS_TEMPORARYSHIELD: "Temporary shield points",
  T_42_XXJ_WS_TEMPORARYSHIELD_D: "Temporary shield points",
  T_42_XXJ_WS_TEXT_D: "The original text to perform a profanity filter on",
  T_42_XXJ_WS_THREESTATESWITCH: "3-Status Switch",
  T_42_XXJ_WS_THROWINGKNIFE_D: "Dagger (ground loot)",
  T_42_XXJ_WS_THROWINGKNIFEBR_D: "Dagger",
  T_42_XXJ_WS_TUKTUK: "Tuk Tuk",
  T_42_XXJ_WS_TWOTEAMLEADERBOARDHUD: "Teams Match Details",
  T_42_XXJ_WS_UNIQUEID: "Unique ID",
  T_42_XXJ_WS_UNIQUEID_D: "Unique ID",
  T_42_XXJ_WS_VALUE_D: "The value",
  T_42_XXJ_WS_VECTOR3TOEULERANGLES_D: "Direction vector to Euler angles",
  T_42_XXJ_WS_VEHICLEID: "Vehicle ID",
  T_42_XXJ_WS_VEHICLESKINID: "Vehicle skin ID",
  T_42_XXJ_WS_VERYHARD: "Very Hard",
  T_42_XXJ_WS_VOLUME_D: "The sound volume. Default is 50.",
  T_42_XXJ_WS_WEAPONTYPE_D: "Weapon's Main Type",
  T_42_XXJ_WS_WORKSHOPCODE: "Map code",
  T_42_XXJ_WS_WORKSHOPCODE_D: "The map code that corresponds to a data in the database",
  T_42_XXJ_WS_WORLDPOSITION: "World coordinates",
  T_42_XXJ_WS_WORLDPOSITION_D: "World coordinates",
  T_42_XYL_WS_ITEM275: "Fuel Tank",
  T_42_XYL_WS_ITEM276: "Sand Bag A",
  T_42_XYL_WS_ITEM277: "Sand Bag B",
  T_42_XYL_WS_ITEM278: "Sand Bag C",
  T_42_XYL_WS_ITEM279: "Sand Bag",
  T_42_XYL_WS_ITEM280: "Double Deck Villa",
  T_42_XYL_WS_ITEM281: "Arms Factory",
  T_42_XYL_WS_ITEM282: "Stone Wall A",
  T_42_XYL_WS_ITEM283: "Stone Wall B",
  T_42_XYL_WS_ITEM284: "Stone Wall C",
  T_42_XYL_WS_ITEM285: "Stone Wall D",
  T_42_XYL_WS_ITEM286: "Military Supply Box A",
  T_42_XYL_WS_ITEM287: "Copper Coin",
  T_42_XYL_WS_ITEM288: "Silver Coin",
  T_42_XYL_WS_ITEM289: "Gold Coin",
  T_42_XYL_WS_ITEM290: "Diamond",
  T_42_XYL_WS_ITEM291: "Diamond Shards",
  T_42_XYL_WS_ITEM292: "Ruby",
  T_42_XYL_WS_ITEM293: "Emerald",
  T_42_XYL_WS_ITEM294: "Sapphire",
  T_42_XYL_WS_ITEM295: "Warning Sign",
  T_42_XYL_WS_ITEM297: "Ruin",
  T_42_XYL_WS_ITEM297TRUE: "Control Device",
  T_42_XYL_WS_ITEM298: "Supply Container B",
  T_42_XYL_WS_ITEM299: "Snow Pile",
  T_42_XYL_WS_ITEM300: "High-Tech Wall A",
  T_42_XYL_WS_ITEM301: "High-Tech Wall B",
  T_42_XYL_WS_ITEM302: "Frozen Stone F",
  T_42_XYL_WS_ITEM303: "Frozen Stone E",
  T_42_XYL_WS_ITEM304: "High-Tech Platform A",
  T_42_XYL_WS_ITEM305: "High-Tech Staircase A",
  T_42_XYL_WS_ITEM306: "Exploration Lamp A",
  T_42_XYL_WS_ITEM307: "Ruin Baffle A",
  T_42_XYL_WS_ITEM308: "Ruin Baffle B",
  T_42_XYL_WS_ITEM309: "Ruin Steel Bracket A",
  T_42_XYL_WS_ITEM310: "Ruin Stone A",
  T_42_XYL_WS_ITEM311: "Ruin Stone B",
  T_42_XYL_WS_ITEM312: "Ruin Stone C",
  T_42_XYL_WS_ITEM313: "Flashlight A",
  T_42_XYL_WS_ITEM314: "Ruin Rebar A",
  T_42_XYL_WS_LOGICALOBJECT: "Logic",
  T_42_XYL_WS_THEMEHIGHTECH: "Futuristic",
  T_42_XYL_WS_THEMEICE: "Icy",
  T_42_XYL_WS_THEMEMILITARY: "Military",
  T_42_XYL_WS_THEMEOBJECTS: "Themed Object",
  T_42_XYL_WS_TIMERCONTINUE: "Timer Resuming Incident",
  T_42_XYL_WS_TIMERCYCLE: "Loop Count",
  T_42_XYL_WS_TIMERDOWN: "Countdown",
  T_42_XYL_WS_TIMEREND: "Timer ending incident",
  T_42_XYL_WS_TIMEREVENT: "Customized Timer Incident",
  T_42_XYL_WS_TIMEREVENT1: "Control Timer",
  T_42_XYL_WS_TIMEREVENT2: "Set Timer Incidents",
  T_42_XYL_WS_TIMERORDER: "Timing Method",
  T_42_XYL_WS_TIMERPAUSE: "Timer Pausing Incident",
  T_42_XYL_WS_TIMERSTART1: "Timer Start Time",
  T_42_XYL_WS_TIMERSTART2: "Timer Starting Incident",
  T_42_XYL_WS_TIMERUP: "Count Up",
  T_42_XYL_WS_TRIGGERTIME_MS: "Trigger Time (in milliseconds)",
  T_42_ZZ_GUILDWAR_AIRCRAFTDESC: "A skywing that can hold multiple players.",
  T_42_ZZ_GUILDWAR_PERSONALSCORE: "Individual Score",
  T_42_ZZ_GUILDWAR_SCORE: "Score",
  T_43_B_SKILL_DESC_MONKEYGOD: "Transforms into a bush for [FFB300]{1}s[-] . Cooldown: [FFB300]{0}s[-]. Attacking others or being attacked will return Wukong to his original state. CD resets when taking down an enemy.",
  T_43_B_SKILL_DESC_Nanoscientist: "After taking fatal damage, enter an invulnerable and immobile state for [FFB300]{0}s[-]. Then, gain a [FFB300]{1} HP shield[-] that lasts for [FFB300]{2}s[-]. The skill user will be eliminated when the shield disappears. Cooldown: [FFB300]{3}s[-].",
  T_43_B_SKILL_DESC_ORION: "Replaces EP with [FFB300]{0} Crimson Energy[-]. Consumes [FFB300]{1} Crimson Energy[-] to activate its protection, during which you cannot take damage or attack enemies and will absorb [FFB300]{4} HP[-] (ignoring enemy Shield Points) from foes within [FFB300]{3}m[-]. Lasts for [FFB300]{2}s[-], during which your movement speed will decrease by [FFB300]{6}%[-]. Cooldown: [FFB300]{5}s[-].",
  T_43_CJ_F_A_RACER: "Velocity Racer (Mask)",
  T_43_CJ_F_B_RACER: "Velocity Racer (Bottom)",
  T_43_CJ_F_H_RACER: "Velocity Racer (Head)",
  T_43_CJ_F_HA_RACER: "Velocity Racer (Facepaint)",
  T_43_CJ_F_S_RACER: "Velocity Racer (Shoes)",
  T_43_CJ_F_T_RACER: "Velocity Racer (Top)",
  T_43_CJ_M_A_RACER: "Turbo Racer (Mask)",
  T_43_CJ_M_B_MACHINERY: "Turquoise Tech (Bottom)",
  T_43_CJ_M_B_RACER: "Turbo Racer (Bottom)",
  T_43_CJ_M_H_MACHINERY: "Turquoise Tech (Head)",
  T_43_CJ_M_H_RACER: "Turbo Racer (Head)",
  T_43_CJ_M_HA_MACHINERY: "Turquoise Tech (Facepaint)",
  T_43_CJ_M_S_MACHINERY: "Turquoise Tech (Shoes)",
  T_43_CJ_M_S_RACER: "Turbo Racer (Shoes)",
  T_43_CJ_M_T_MACHINERY: "Turquoise Tech (Top)",
  T_43_CJ_M_T_RACER: "Turbo Racer (Top)",
  T_43_H_CHARACTER_GEEK_N: "Ryden",
  T_43_H_VSK94_MAMBAS_N: "VSK94 - Mamba Gnaw",
  T_43_HJ_WS_OPTION8: "Other",
  T_43_HJ_WS_TEXTURE_BAMBOO: "Bamboo",
  T_43_HJ_WS_TEXTURE_BEACH: "Beach",
  T_43_HJ_WS_TEXTURE_BRICK1: "Brick Wall A",
  T_43_HJ_WS_TEXTURE_BRICK2: "Brick Wall B",
  T_43_HJ_WS_TEXTURE_BRICK3: "Brick Wall C",
  T_43_HJ_WS_TEXTURE_CEMENT: "Concrete Floor",
  T_43_HJ_WS_TEXTURE_CEMENT2: "Concrete",
  T_43_HJ_WS_TEXTURE_CRYSTAL: "Crystal",
  T_43_HJ_WS_TEXTURE_GLASSLAND1: "Grass A",
  T_43_HJ_WS_TEXTURE_GLASSLAND2: "Grass B",
  T_43_HJ_WS_TEXTURE_ICE: "Ice Block",
  T_43_HJ_WS_TEXTURE_IRON: "Metal Floor",
  T_43_HJ_WS_TEXTURE_IRON2: "Container",
  T_43_HJ_WS_TEXTURE_LAVA: "Lava",
  T_43_HJ_WS_TEXTURE_MARBLE: "Marble Floor",
  T_43_HJ_WS_TEXTURE_NONE: "Empty",
  T_43_HJ_WS_TEXTURE_STONE: "Stone",
  T_43_HJ_WS_TEXTURE_TEXTILE1: "Tablecloth A",
  T_43_HJ_WS_TEXTURE_TEXTILE2: "Tablecloth B",
  T_43_HJ_WS_TEXTURE_WOOD: "Wood",
  T_43_HJ_WS_TEXTURE_WOODEN: "Wooden Floor A",
  T_43_HJ_WS_TEXTURE_WOODEN2: "Wooden Floor B",
  T_43_JH_WS_MAPTAG1: "Newbie-Friendly",
  T_43_JH_WS_MAPTAG10: "Boring new content",
  T_43_JH_WS_MAPTAG11: "Little sense of reward",
  T_43_JH_WS_MAPTAG12: "Reward imbalance",
  T_43_JH_WS_MAPTAG13: "Weak sense of progress",
  T_43_JH_WS_MAPTAG14: "Newbie-Unfriendly",
  T_43_JH_WS_MAPTAG15: "Confusing tutorial",
  T_43_JH_WS_MAPTAG16: "Lack of tutorials",
  T_43_JH_WS_MAPTAG17: "Players quit a lot",
  T_43_JH_WS_MAPTAG18: "Complicated controls",
  T_43_JH_WS_MAPTAG19: "Cluttered UI",
  T_43_JH_WS_MAPTAG2: "Preferred new content",
  T_43_JH_WS_MAPTAG20: "Poor map design",
  T_43_JH_WS_MAPTAG21: "Thrilling Shooter",
  T_43_JH_WS_MAPTAG22: "Fast-paced",
  T_43_JH_WS_MAPTAG23: "Open World",
  T_43_JH_WS_MAPTAG24: "Story-rich",
  T_43_JH_WS_MAPTAG25: "Progression",
  T_43_JH_WS_MAPTAG26: "Sports Simulation",
  T_43_JH_WS_MAPTAG27: "Co-op Mission",
  T_43_JH_WS_MAPTAG28: "Social",
  T_43_JH_WS_MAPTAG29: "Diverse Instances",
  T_43_JH_WS_MAPTAG3: "Active players",
  T_43_JH_WS_MAPTAG30: "Free Exploration",
  T_43_JH_WS_MAPTAG31: "Ranking Challenge",
  T_43_JH_WS_MAPTAG32: "Achievement",
  T_43_JH_WS_MAPTAG33: "Currency Redeem",
  T_43_JH_WS_MAPTAG4: "Well-Designed Map",
  T_43_JH_WS_MAPTAG40: "Numerous rewards",
  T_43_JH_WS_MAPTAG41: "Satisfying progression",
  T_43_JH_WS_MAPTAG42: "Popular Training Grounds",
  T_43_JH_WS_MAPTAG43: "Popular Solo Tower",
  T_43_JH_WS_MAPTAG44: "Popular War Zone",
  T_43_JH_WS_MAPTAG5: "Stuttering",
  T_43_JH_WS_MAPTAG6: "Hard co-op",
  T_43_JH_WS_MAPTAG7: "Buggy",
  T_43_JH_WS_MAPTAG8: "Few updates",
  T_43_JH_WS_MAPTAG9: "Boring in-match events",
  T_43_JH_WS_SKILLSETAUTOPATHBOMB: "Spider Trap (Ryden)",
  T_43_SJ_WS_AIRDROP_ITEMS: "Drop Items",
  T_43_SJ_WS_AIRDROP_NAME: "Airdrop",
  T_43_SJ_WS_AIRDROP_TIME: "Start Drop Time",
  T_43_SJ_WS_AIRDROP_UI_ITEM: "Drop Items",
  T_43_SJ_WS_ANITRIGGER_AUTO: "Is Auto-Play",
  T_43_SJ_WS_ANITRIGGER_CENTER: "Is Center Position",
  T_43_SJ_WS_ANITRIGGER_CLIP: "Animation Clip ID",
  T_43_SJ_WS_ANITRIGGER_LOOP: "Is Loop",
  T_43_SJ_WS_ANITRIGGER_NAME: "Animation Trigger HUD",
  T_43_SJ_WS_RESET_ROUND: "Reset per Round",
  T_43_SJ_WS_START_DROPTIME: "Start Drop Time (ms)",
  T_43_SJ_WS_TRIGGER_ANIMA: "Animation Trigger",
  T_43_SY_PETSKIN_AXOLOTL_WATERFEST24_N: "Pet Skin: Meow Meow Zasil",
  T_43_SY_VEHICLESKIN_MOTOBIKE_FIGHTER_N: "Motorbike - Incarnational Speed",
  T_43_WH_ITEM_SUPPLYBOX_DESC: "Contains essential battle supplies such as ammo and medical items",
  T_43_WH_ITEM_SUPPLYBOX_NAME: "Supply Box",
  T_43_WT_SKILL_DESC_DUMMY_REWORK: "Spawn a [FFB300]{1} HP[-] mannequin that autonomously travels for [FFB300]{0}s[-]. When the mannequin is within [FFB300]{3}m[-], use the skill again to switch positions with it. You can only switch once within [FFB300]{4}s[-], up to [FFB300]{2} time(s)[-] in total. The player who destroys the mannequin will be marked for [FFB300]{5}s[-]. Cooldown: [FFB300]{6}s[-].",
  T_43_WT_W_VSK94: "VSK94",
  T_43_XXJ_WS_ACTIVITYSKILL: "Active Skill",
  T_43_XXJ_WS_AIRDROP: "Airdrop and Zombie",
  T_43_XXJ_WS_ALPHA: "Alpha",
  T_43_XXJ_WS_ALPHA_D: "The overall transparency of the HUD, with a range from 0 to 1.",
  T_43_XXJ_WS_ANIMATIONCTRLID: "Animation Controller ID",
  T_43_XXJ_WS_ANIMATIONCTRLID_D: "The ID used to describe an animation controller asset",
  T_43_XXJ_WS_AUDIOID: "Audio ID",
  T_43_XXJ_WS_AUDIOID_D: "The ID used to describe an audio asset",
  T_43_XXJ_WS_BACKGRCOLOR: "Background Color",
  T_43_XXJ_WS_BACKGRCOLOR_D: "The color of the health bar boarder and the blurred background",
  T_43_XXJ_WS_BURNING: "Burning",
  T_43_XXJ_WS_CSVID: "CSV ID",
  T_43_XXJ_WS_CSVID_D: "The ID used to describe a configuration table asset",
  T_43_XXJ_WS_CURRENTHP: "Current HP",
  T_43_XXJ_WS_CURRENTHP_D: "Current HP value",
  T_43_XXJ_WS_DAMAGEMAKER_D: "The game entity that deals damage",
  T_43_XXJ_WS_DAMAGEZONE: "Damage Zone",
  T_43_XXJ_WS_DEFAULT: "Default",
  T_43_XXJ_WS_DEFAULT_D: "Default",
  T_43_XXJ_WS_EFFECTID: "Effect ID",
  T_43_XXJ_WS_EFFECTID_D: "The ID used to describe a special effect asset",
  T_43_XXJ_WS_FIGHTINGENTITY_D: "An entity that can fight (e.g. launch attacks, be attacked, or get eliminated)",
  T_43_XXJ_WS_FOLLOWTARGET: "Follow Target",
  T_43_XXJ_WS_FOLLOWTARGET_D: "Must follow an entity with a Transform component",
  T_43_XXJ_WS_GAINHPCOLOR: "Gain HP Color",
  T_43_XXJ_WS_GAINHPCOLOR_D: "The increased portion of HP will show in this color for a short time",
  T_43_XXJ_WS_ISNOFALLDAMAGE: "Is No Fall Damage",
  T_43_XXJ_WS_ISOPENTWEEN: "Is Open Tween",
  T_43_XXJ_WS_ISOPENTWEEN_D: "Enable this to show HP changes in different colors",
  T_43_XXJ_WS_KNOCKDOWN_D1: "The player is in the knockdown state",
  T_43_XXJ_WS_KNOCKDOWN_D2: "Settings for the response to the knockdown state when eliminated",
  T_43_XXJ_WS_KNOCKDOWN_D3: "The revival source type. A player can be revived while  knocked down.",
  T_43_XXJ_WS_KNOCKDOWNSTATE: "Knockdown State",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE: "Knockdown State Type",
  T_43_XXJ_WS_KNOCKDOWNSTATETYPE_D: "The response to the knockdown state: maintain default logic, skip the knockdown state, or force into knockdown.",
  T_43_XXJ_WS_LEVEL: "Level",
  T_43_XXJ_WS_LEVEL_D: "Level",
  T_43_XXJ_WS_LEVEL_D1: "The current zombie level",
  T_43_XXJ_WS_LINESPACING: "Line Spacing",
  T_43_XXJ_WS_LINESPACING_D: "Does not display when the segmented HP between two dividers ≤ 0",
  T_43_XXJ_WS_LOSEHPCOLOR: "Lose HP Color",
  T_43_XXJ_WS_LOSEHPCOLOR_D: "The reduced portion of HP will show in this color for a short time",
  T_43_XXJ_WS_MAINCOLOR: "Main Color",
  T_43_XXJ_WS_MAINCOLOR_D: "The color for HP, levels, and outlines",
  T_43_XXJ_WS_MINISENTRY: "Turret",
  T_43_XXJ_WS_MINISENTRYATTACKTARGETTYPE_D: "The enum for the types of targets a turret can attack",
  T_43_XXJ_WS_MISSILEEXPLODE: "Missile Explode",
  T_43_XXJ_WS_MUSTKNOCKDOWN: "Must Knockdown",
  T_43_XXJ_WS_MUSTKNOCKDOWN_D: "Forced knockdown",
  T_43_XXJ_WS_OFFSET: "Offset",
  T_43_XXJ_WS_OFFSET_D: "Offset relative to the target followed",
  T_43_XXJ_WS_OILDRUMEXPLODE: "Oil Drum Explode",
  T_43_XXJ_WS_ONCONTROLLERCOLLIDERHIT_D: "Only triggered when the controller initiates movement",
  T_43_XXJ_WS_PLAYER_D: "The in-game player entity. Each player has one.",
  T_43_XXJ_WS_PLAYERHEADHUD: "Player Head HUD",
  T_43_XXJ_WS_PLAYERHEADHUD_D: "The information displayed above the player's head",
  T_43_XXJ_WS_PLAYERNAME: "Player Name",
  T_43_XXJ_WS_PLAYERNAME_D: "Displays the name of the current health bar owner",
  T_43_XXJ_WS_PLAYERORVEHICLE: "Player or Vehicle",
  T_43_XXJ_WS_PLAYERORVEHICLE_D: "The alias for the player/vehicle entity type",
  T_43_XXJ_WS_SCALE: "Scale",
  T_43_XXJ_WS_SCALE_D: "Determines the overall HUD scale size, with the font scaled to match.",
  T_43_XXJ_WS_SHOWDAMAGENUMBER: "Show Damage Number",
  T_43_XXJ_WS_SHOWDAMAGENUMBER_D: "True by default. Displays damage number.",
  T_43_XXJ_WS_SKIPKNOCKDOWN: "Skip Knockdown",
  T_43_XXJ_WS_SKIPKNOCKDOWN_D: "Skip the knockdown state and get eliminated instantly",
  T_43_XXJ_WS_SKIPSTAGGERANIMATION: "Is Skip Stagger Animation",
  T_43_XXJ_WS_TEAM_D: "(Deprecated. Please use Team ID.)",
  T_43_XXJ_WS_TERRAIN: "Terrain",
  T_43_XXJ_WS_TERRAIN_D: "A terrain component of which attributes cannot be modified. Used to test functions only.",
  T_43_XXJ_WS_TOTALHP: "Total HP",
  T_43_XXJ_WS_TOTALHP_D: "Total HP value",
  T_43_XXJ_WS_TWEENENTITY: "Tween Entity",
  T_43_XXJ_WS_VEHICLEEXPLODE: "Vehicle Explode",
  T_43_XXJ_WS_WIDTH: "Width",
  T_43_XXJ_WS_WIDTH_D: "The width of the displayed health bar",
  T_43_XXJ_WS_ZOMBIE: "Zombie",
  T_43_XYL_WS_DROIDFIST: "Fist (Droid Apocalypse)",
  T_43_XYL_WS_DROIDFLAME: "Flamethrower (Droid Apocalypse)",
  T_43_XYL_WS_JAPANESE: "Japanese-Style",
  T_43_YU_WS_ADDGAMEEVENTLOGMAP_D: "Customize match event logs. Used for user experience analysis.",
  T_43_YU_WS_AIRDROPSTATE: "Airdrop State",
  T_43_YU_WS_AIRDROPSTATE_D: "Airdrop state (1: ready, 2: dropping, 3: landed)",
  T_43_YU_WS_ANIMATIONCLIPID: "Animation Clip ID",
  T_43_YU_WS_ANIMATIONCLIPID_D: "Customize animation clip ID",
  T_43_YU_WS_ASKBUYTARGET: "Ask Buy Target",
  T_43_YU_WS_ASKBUYTARGET_D: "Specifies the target and sends purchase request",
  T_43_YU_WS_ASKEDLIST: "Asked List",
  T_43_YU_WS_ASKEDLIST_D: "The list of requested items",
  T_43_YU_WS_BACKGROUNDCOLOR1: "Background Color 1",
  T_43_YU_WS_BACKGROUNDCOLOR1_D: "The upper background color",
  T_43_YU_WS_BACKGROUNDCOLOR2: "Background Color 2",
  T_43_YU_WS_BACKGROUNDCOLOR2_D: "The bottom background color",
  T_43_YU_WS_BATCHCOMBINERENDER: "Batch Combine Render",
  T_43_YU_WS_BINDMONEYENTITYLIST: "Bind Money Entity List",
  T_43_YU_WS_BINDMONEYENTITYLIST_D: "The list of bound currency entities",
  T_43_YU_WS_BINDWALLETENTITYID: "Bind Wallet Entity ID",
  T_43_YU_WS_BINDWALLETENTITYID_D: "The ID of the bound wallet entity",
  T_43_YU_WS_CENTEROFFSET: "Center Offset",
  T_43_YU_WS_CENTEROFFSET_D: "The offset value for the capsule collider",
  T_43_YU_WS_COLLECTIONID: "Collection ID",
  T_43_YU_WS_COLLECTIONID_D: "The Collection ID used for asset information collection",
  T_43_YU_WS_CREATEAIRDROPENTITY_D: "Create an airdrop",
  T_43_YU_WS_CREATEUGCDAMAGENUM_D: "Create a damage number",
  T_43_YU_WS_CROSSPLATFORM_D: "When selected, send to the client if called on the server and vice versa.",
  T_43_YU_WS_CSROUNDRESULTHUD: "CS Round Result HUD",
  T_43_YU_WS_CSROUNDRESULTHUD_D: "Results displayed at the end of each round",
  T_43_YU_WS_CURRENTEMOTECLIP: "Current Emote Clip",
  T_43_YU_WS_CURRENTEMOTECLIP_D: "ID of the current emote clip",
  T_43_YU_WS_DAMAGE_D: "The out-of-zone damage",
  T_43_YU_WS_DICTIONARY: "Dictionary",
  T_43_YU_WS_DIRECTIONRULERHUD: "Direction Ruler HUD",
  T_43_YU_WS_DIRECTIONRULERHUD_D: "The compass on the top",
  T_43_YU_WS_DOTWEEN_D: "Whether to perform tween animations",
  T_43_YU_WS_DROPITEMS_D: "Items in the airdrop",
  T_43_YU_WS_DURATION: "Duration",
  T_43_YU_WS_ENERGY: "Energy",
  T_43_YU_WS_ENERGY_D: "EP modification value",
  T_43_YU_WS_EPHYSXPOSE_CREEPING: "Prone",
  T_43_YU_WS_EPHYSXPOSE_CROUCHING: "Crouch",
  T_43_YU_WS_EPHYSXPOSE_DASHING: "Sprinting",
  T_43_YU_WS_EPHYSXPOSE_STANDING: "Stand",
  T_43_YU_WS_EVENTID: "Event ID",
  T_43_YU_WS_EVENTID_D: "Represents an event",
  T_43_YU_WS_FACTION: "Faction",
  T_43_YU_WS_FACTION_D: "The faction entity",
  T_43_YU_WS_FACTION_D1: "Ask the faction for help with purchase",
  T_43_YU_WS_FINALRADIUS_D: "The final radius of the safe zone",
  T_43_YU_WS_FIRSTAIDKIT: "MedKit",
  T_43_YU_WS_FIRSTAIDKIT_D: "Med Kit",
  T_43_YU_WS_FIRSTPERSONMODEL: "First Person Model",
  T_43_YU_WS_FIRSTPERSONMODEL_D: "The first-person camera",
  T_43_YU_WS_FONTCOLOR_D: "The font color",
  T_43_YU_WS_FONTSIZE_D: "The font size",
  T_43_YU_WS_FORBIDEN: "Forbidden",
  T_43_YU_WS_FORBIDEN_D: "Disable the HUD for purchase request",
  T_43_YU_WS_FREEZINGTIME: "Freezing Time",
  T_43_YU_WS_FREEZINGTIME_D: "The duration for which the hit target stays frozen",
  T_43_YU_WS_GRAVITY: "Gravity",
  T_43_YU_WS_GRAVITY_D: "The gravitational acceleration. Only affects the player controller.",
  T_43_YU_WS_HANDCATAPULT: "Launch Pad",
  T_43_YU_WS_HANDCATAPULT_D: "Launch Pad",
  T_43_YU_WS_HEALTH: "Health",
  T_43_YU_WS_HEALTH_D: "The recovery value of armor durability",
  T_43_YU_WS_HEIGHT: "Height",
  T_43_YU_WS_HELPEDPLAYER_D: "The player who is helped",
  T_43_YU_WS_HELPPLAYER_D: "The player who helps with the purchase",
  T_43_YU_WS_HORIZONTALMAXANGLE: "Horizontal Max. Angle",
  T_43_YU_WS_HORIZONTALMINANGLE: "Horizontal Min Angle",
  T_43_YU_WS_HUDTOGGLE: "HUD Toggle",
  T_43_YU_WS_HUDTOGGLE_D: "The HudToggle entity that players can edit in the HUD editor",
  T_43_YU_WS_INHALER: "Inhaler",
  T_43_YU_WS_INHALER_D: "Inhaler",
  T_43_YU_WS_INITRADIUS_D: "The initial radius of the safe zone",
  T_43_YU_WS_INT64: "Int64",
  T_43_YU_WS_INT64_D: "A 64-bit signed integer",
  T_43_YU_WS_ISAPPLYSHADOW: "Is Apply Shadow",
  T_43_YU_WS_ISBOTTOMCOLLIDING: "Is Bottom Colliding",
  T_43_YU_WS_ISCURRENTEMOTELOOP: "Is Current Emote Loop",
  T_43_YU_WS_ISCURRENTEMOTELOOP_D: "Whether to set the current Emote animation to loop",
  T_43_YU_WS_ISSIDECOLLIDING: "Is Side Colliding",
  T_43_YU_WS_ISSLIDING: "Is Sliding",
  T_43_YU_WS_ISTOPCOLLIDING: "Is Top Colliding",
  T_43_YU_WS_ITEM331: "Futuristic Device A",
  T_43_YU_WS_ITEM332: "Glowing Rock A",
  T_43_YU_WS_ITEM333: "Futuristic Screen A",
  T_43_YU_WS_ITEM334: "Futuristic Container A",
  T_43_YU_WS_ITEM335: "Futuristic Container A",
  T_43_YU_WS_ITEM336: "Stone Sofa A",
  T_43_YU_WS_ITEM337: "Futuristic Switch A",
  T_43_YU_WS_ITEM338: "Futuristic Pipe A",
  T_43_YU_WS_ITEM339: "Metal Platform A",
  T_43_YU_WS_ITEM340: "Futuristic Table A",
  T_43_YU_WS_ITEM341: "Futuristic Table B",
  T_43_YU_WS_ITEM342: "Futuristic Table C",
  T_43_YU_WS_ITEM343: "Futuristic Computer A",
  T_43_YU_WS_ITEM344: "Stone A",
  T_43_YU_WS_ITEM345: "Stone B",
  T_43_YU_WS_ITEM346: "Stone C",
  T_43_YU_WS_ITEM347: "Stone D",
  T_43_YU_WS_ITEM348: "Stone E",
  T_43_YU_WS_ITEM349: "Stone F",
  T_43_YU_WS_ITEM350: "Stone G",
  T_43_YU_WS_ITEM351: "Japanese-Style Curtain A",
  T_43_YU_WS_ITEM352: "Japanese-Style Curtain B",
  T_43_YU_WS_ITEM353: "Japanese-Style Curtain C",
  T_43_YU_WS_ITEM354: "Japanese-Style Stairs A",
  T_43_YU_WS_ITEM355: "Japanese-Style Fence A",
  T_43_YU_WS_ITEM356: "Japanese-Style Fence B",
  T_43_YU_WS_ITEM357: "Japanese-Style Fence C",
  T_43_YU_WS_ITEM358: "Japanese-Style Platform A",
  T_43_YU_WS_ITEM359: "Japanese-Style Wall B",
  T_43_YU_WS_ITEM360: "Japanese-Style Gate B",
  T_43_YU_WS_ITEM361: "Futuristic Wall D",
  T_43_YU_WS_ITEM362: "Futuristic Wall B",
  T_43_YU_WS_ITEM363: "Futuristic Angled Baseboard",
  T_43_YU_WS_LEFTCOLOR: "Left Color",
  T_43_YU_WS_LEFTCOLOR_D: "The left side color",
  T_43_YU_WS_LEFTPLAYERARRAY: "Left Player Array",
  T_43_YU_WS_LEFTPLAYERARRAY_D: "The left player array",
  T_43_YU_WS_LEFTSCORE: "Left Score",
  T_43_YU_WS_LEFTSCORE_D: "The left side score",
  T_43_YU_WS_LEFTSCOREAFTER: "Left Score After",
  T_43_YU_WS_LEFTSCOREAFTER_D: "The final score of the left side. Used in score transition animations.",
  T_43_YU_WS_LEVELOBJECTID: "Level Object ID",
  T_43_YU_WS_LEVELOBJECTID_D: "Describes the object type. Requires parsing through the SceneEditPrefab configuration table before loading.",
  T_43_YU_WS_LOCALPOSITION_D: "Coordinates in the local coordinate system",
  T_43_YU_WS_LOCALPOSITION_D1: "The relative position",
  T_43_YU_WS_LOCALPOSITION_D2: "The position relative to the bottom right anchor",
  T_43_YU_WS_LOCALPOSITION_D3: "The position relative to the anchor",
  T_43_YU_WS_LOCALROTATION_D: "Rotation angles in the local coordinate system (X: yaw, Y: pitch, and Z: roll)",
  T_43_YU_WS_LOCALROTATIONQ_D: "The quaternion in the local coordinate system",
  T_43_YU_WS_LOCALSCALE_D: "The scale size in the world coordinate system",
  T_43_YU_WS_MASS: "Mass",
  T_43_YU_WS_MATERIALS: "Materials",
  T_43_YU_WS_MATERIALS_D: "The list of materials used for rendering",
  T_43_YU_WS_MAXSPEED: "Max. Speed",
  T_43_YU_WS_MAXSPEED_D: "No more horsepower will be generated after the max speed is reached, but the vehicle speed may go over the limit (e.g. through acceleration when going down a hill).",
  T_43_YU_WS_MESHID: "Mesh ID",
  T_43_YU_WS_MESHID_D: "Describes the mesh type",
  T_43_YU_WS_MESHID1: "Mesh ID",
  T_43_YU_WS_MESHID1_D: "The mesh to be used for rendering",
  T_43_YU_WS_MINMOVEDISTANCE: "Min. Move Distance",
  T_43_YU_WS_MINMOVEDISTANCE_D: "Movement with a distance shorter than this value will not be executed. It is recommended to set it to 0 unless there are special requirements.",
  T_43_YU_WS_MODULE_AI: "AI",
  T_43_YU_WS_MODULE_AIRDROP: "Airdrop",
  T_43_YU_WS_MODULE_ANIMATION: "Animation",
  T_43_YU_WS_MODULE_AVATAR: "Avatar",
  T_43_YU_WS_MODULE_BASEATTRIBUTES: "Base Attributes",
  T_43_YU_WS_MODULE_BEHAVIOURTREE: "Behavior Tree",
  T_43_YU_WS_MODULE_BUFF: "Buff",
  T_43_YU_WS_MODULE_CAMERA: "Camera",
  T_43_YU_WS_MODULE_CHATCHANNEL: "Chat Channel",
  T_43_YU_WS_MODULE_CHECKPOINT: "Checkpoint",
  T_43_YU_WS_MODULE_COLLECTION: "Collection",
  T_43_YU_WS_MODULE_COMBAT: "Combat",
  T_43_YU_WS_MODULE_COMPONENT: "Component",
  T_43_YU_WS_MODULE_CONVERT: "Convert",
  T_43_YU_WS_MODULE_CUSTOMIZEROOMPARAMETERS: "Customize Room Parameters",
  T_43_YU_WS_MODULE_DATABASE: "Data Storage",
  T_43_YU_WS_MODULE_DYEING: "Dyeing",
  T_43_YU_WS_MODULE_DYNAMICNAVMESH: "Dynamic NavMesh",
  T_43_YU_WS_MODULE_ECONOMY: "Economy",
  T_43_YU_WS_MODULE_FF_PLATFORM: "FF Platform",
  T_43_YU_WS_MODULE_FOOTBALL: "Football",
  T_43_YU_WS_MODULE_FRAMERATEMODE: "Frame Rate Mode",
  T_43_YU_WS_MODULE_GAMERESULT: "Game Results",
  T_43_YU_WS_MODULE_GLOBAL: "Global",
  T_43_YU_WS_MODULE_GLOBALSCRIPTS: "Global Scripts",
  T_43_YU_WS_MODULE_HANGUPANDCHEAT: "AFK & Cheating",
  T_43_YU_WS_MODULE_HUD: "HUD",
  T_43_YU_WS_MODULE_INPUTSYSTEM: "Input System",
  T_43_YU_WS_MODULE_ITEMS: "Items",
  T_43_YU_WS_MODULE_LEVELOBJECT: "Level Object",
  T_43_YU_WS_MODULE_LIST: "List",
  T_43_YU_WS_MODULE_MAP: "Map",
  T_43_YU_WS_MODULE_MATCHING: "Match",
  T_43_YU_WS_MODULE_MATH: "Math",
  T_43_YU_WS_MODULE_MECHANISM: "Mechanism Parameters",
  T_43_YU_WS_MODULE_MINIMAP: "Minimap",
  T_43_YU_WS_MODULE_MORPH: "Morph",
  T_43_YU_WS_MODULE_OTHER: "Other",
  T_43_YU_WS_MODULE_PET: "Pet",
  T_43_YU_WS_MODULE_PHYSICS: "Physics",
  T_43_YU_WS_MODULE_PLAYABLE: "Playable",
  T_43_YU_WS_MODULE_PLAYER: "Player",
  T_43_YU_WS_MODULE_PLAYERSCRIPTS: "Player Scripts",
  T_43_YU_WS_MODULE_PRESETCHARACTER: "Preset Character",
  T_43_YU_WS_MODULE_PROFILE: "Profile",
  T_43_YU_WS_MODULE_PROPERTYFORMULA: "Property Formula",
  T_43_YU_WS_MODULE_SAFEZONE: "Safe Zone",
  T_43_YU_WS_MODULE_SCENE: "Scene",
  T_43_YU_WS_MODULE_SKILL: "Skill",
  T_43_YU_WS_MODULE_STATICSCRIPTS: "Static Scripts",
  T_43_YU_WS_MODULE_STATISTICALREPORT: "Report",
  T_43_YU_WS_MODULE_STDLIBRARY: "STD Library",
  T_43_YU_WS_MODULE_STRINGS: "Strings",
  T_43_YU_WS_MODULE_TEAM: "Team",
  T_43_YU_WS_MODULE_WORKFLOW: "Workflow",
  T_43_YU_WS_MONEYICON: "Money Icon",
  T_43_YU_WS_MONEYICON_D: "The currency icon",
  T_43_YU_WS_MONEYICONCOLOR: "Money Icon Color",
  T_43_YU_WS_MONEYICONCOLOR_D: "The currency icon color",
  T_43_YU_WS_MOVESAFEZONE_D: "Smoothly moves the safe zone from its start position to the end position. Players outside the zone will take a certain amount of damage.",
  T_43_YU_WS_NEWVECTOR2: "New Vector2",
  T_43_YU_WS_NEWVECTOR2_D: "Gets a new 2D vector",
  T_43_YU_WS_OFFSET_D: "The world position offset relative to the target entity",
  T_43_YU_WS_ONSHOPREQUESTFILLED_D: "When the player purchase request is met",
  T_43_YU_WS_ONSHOPREQUESTPURCHASE_D: "When a player requests for help with purchase in the store",
  T_43_YU_WS_ONTOGGLECHANGE_D: "Trigger when the Toggle component state changes",
  T_43_YU_WS_OPENSTATE: "Open State",
  T_43_YU_WS_OPENSTATE_D: "Displays when set to true and hides if not",
  T_43_YU_WS_PACEMAKER: "Horizaline",
  T_43_YU_WS_PACEMAKER_D: "Horizaline",
  T_43_YU_WS_PARAMS_D: "The list of parameters",
  T_43_YU_WS_PARENT_D: "The entity ID recorded during serialization",
  T_43_YU_WS_PHYSICALCCT: "Physical CCT",
  T_43_YU_WS_PHYSICALCCT_D: "The player controller with physical effects",
  T_43_YU_WS_PLAYER_D: "The purchasing player",
  T_43_YU_WS_PLAYERDATAID: "Player Data ID",
  T_43_YU_WS_PLAYERDATAID_D: "Customize character asset ID",
  T_43_YU_WS_PLAYERPHYSXPOSETYPE: "Player PhysX Pose Type",
  T_43_YU_WS_POSITION: "Position",
  T_43_YU_WS_POSITION_D: "Coordinates in the world coordinate system",
  T_43_YU_WS_POSITION_D1: "Coordinates in the world coordinate system. Only effective for 3D music.",
  T_43_YU_WS_PRESSEDSPRITE: "Pressed Sprite",
  T_43_YU_WS_PRESSEDSPRITE_D: "The pressed sprite",
  T_43_YU_WS_PRESSEDSPRITETYPE: "Pressed Sprite Type",
  T_43_YU_WS_PRESSEDSPRITETYPE_D: "The pressed sprite type",
  T_43_YU_WS_PRETIME: "Pretime",
  T_43_YU_WS_RADIUS: "Radius",
  T_43_YU_WS_RANDOMRANGE_D: "Correct the set position based on a random range",
  T_43_YU_WS_REQUESTPURCHASETYPE: "Request Purchase Type",
  T_43_YU_WS_REQUESTPURCHASETYPE_D: "Purchase request in the store",
  T_43_YU_WS_REQUESTTYPE: "Request Type",
  T_43_YU_WS_REQUESTTYPE_D: "The type of the target requested by the current HUD player",
  T_43_YU_WS_RESPLAYERUUID: "Preset Player Type",
  T_43_YU_WS_RESPLAYERUUID_D: "The player asset ID",
  T_43_YU_WS_RESUUID: "Asset UUID",
  T_43_YU_WS_RESUUID_D: "Specifies the UUID of the Batch asset to be rendered",
  T_43_YU_WS_RIGHTCOLOR: "Right Color",
  T_43_YU_WS_RIGHTCOLOR_D: "The right side color",
  T_43_YU_WS_RIGHTPLAYERARRAY: "Right Player Array",
  T_43_YU_WS_RIGHTPLAYERARRAY_D: "The right player array",
  T_43_YU_WS_RIGHTSCORE: "Right Score",
  T_43_YU_WS_RIGHTSCORE_D: "The right side score",
  T_43_YU_WS_RIGHTSCOREAFTER: "Right Score After",
  T_43_YU_WS_RIGHTSCOREAFTER_D: "The final score of the right side. Used in score transition animations.",
  T_43_YU_WS_ROTATIONQ_D: "The quaternion in the world coordinate system",
  T_43_YU_WS_ROUNDINFOHUD: "Round Info HUD",
  T_43_YU_WS_ROUNDINFOHUD_D: "Information displayed at the start of a round",
  T_43_YU_WS_SELECTEDCOLOR: "Selected Color",
  T_43_YU_WS_SELECTEDCOLOR_D: "The selected sprite color",
  T_43_YU_WS_SELECTEDSPRITE: "Selected Sprite",
  T_43_YU_WS_SELECTEDSPRITE_D: "The selected sprite",
  T_43_YU_WS_SELECTEDTYPE: "Selected Type",
  T_43_YU_WS_SELECTEDTYPE_D: "The selected sprite type",
  T_43_YU_WS_SHADOWCOLOR: "Shadow Color",
  T_43_YU_WS_SHADOWOFFSET: "Shadow Offset",
  T_43_YU_WS_SHOWTAG: "Show Tag",
  T_43_YU_WS_SHOWTAG_D: "Show team/faction markings",
  T_43_YU_WS_SHRINKDURATION_D: "The shrinking duration of the safe zone",
  T_43_YU_WS_SIMPLERENDER_D: "The bridging rendering component used for rendering with built-in models",
  T_43_YU_WS_SKINWIDTH: "Skin Width",
  T_43_YU_WS_SKINWIDTH_D: "The depth of penetration into the capsule to prevent the character from getting stuck or jittering",
  T_43_YU_WS_SLOPELIMIT: "Slope Limit",
  T_43_YU_WS_SLOPELIMIT_D: "Objects placed on the slope exceeding this angle will slide down",
  T_43_YU_WS_SPEED: "Speed",
  T_43_YU_WS_STARTDROPTIME_D: "The airdrop arrival time in milliseconds",
  T_43_YU_WS_STARTPOS_D: "The start position of the safe zone",
  T_43_YU_WS_STATICICONCOLORS: "Static Icon Colors",
  T_43_YU_WS_STATICICONCOLORS_D: "Icon colors shown on the ruler",
  T_43_YU_WS_STATICICONS: "Static Icons",
  T_43_YU_WS_STATICICONS_D: "The icons shown on rulers",
  T_43_YU_WS_STEPOFFSET: "Step Offset",
  T_43_YU_WS_STEPOFFSET_D: "Only obstacles exceeding this height will have a blocking effect",
  T_43_YU_WS_SUBTITLE: "SubTitle",
  T_43_YU_WS_SUBTITLE_D: "The subtitle",
  T_43_YU_WS_TARGET: "Target",
  T_43_YU_WS_TARGET_D: "The target entity for the displayed damage number",
  T_43_YU_WS_TARGETICONCOLORS: "Target Icon Colors",
  T_43_YU_WS_TARGETICONCOLORS_D: "Colors of the icon shown by the marked target",
  T_43_YU_WS_TARGETICONS: "Target Icons",
  T_43_YU_WS_TARGETICONS_D: "The icons shown by the marked targets",
  T_43_YU_WS_TARGETPOS_D: "The target end position of the safe zone",
  T_43_YU_WS_TEAM: "Team",
  T_43_YU_WS_TEAM_D: "The team entity in the game. Each team has one entity.",
  T_43_YU_WS_TEAM_D1: "Ask the team for help with purchase",
  T_43_YU_WS_TIMEOFSTAY_D: "The display duration in milliseconds",
  T_43_YU_WS_TITLE: "Title",
  T_43_YU_WS_TITLE_D: "The main title",
  T_43_YU_WS_TRANSFORM_D: "Rotation, scaling, and parent-child record",
  T_43_YU_WS_UNSELECTEDCOLOR: "Unselected Color",
  T_43_YU_WS_UNSELECTEDCOLOR_D: "The unselected sprite color",
  T_43_YU_WS_UNSELECTEDSPRITE: "Unselected Sprite",
  T_43_YU_WS_UNSELECTEDSPRITE_D: "The unselected sprite",
  T_43_YU_WS_UNSELECTEDTYPE: "Unselected Type",
  T_43_YU_WS_UNSELECTEDTYPE_D: "Unselected sprite type",
  T_43_YU_WS_USEPHYSICALCCT: "Use Physical CCT",
  T_43_YU_WS_VALUE_D: "The displayed content",
  T_43_YU_WS_VECTOR2ADD: "Vector2 Add",
  T_43_YU_WS_VECTOR2GETX: "Vector2 Get X",
  T_43_YU_WS_VECTOR2GETY: "Vector2 Get Y",
  T_43_YU_WS_VECTOR2SCALE: "Vector2 Scale",
  T_43_YU_WS_VECTOR2SETX: "Vector2 Set X",
  T_43_YU_WS_VECTOR2SETY: "Vector2 Set Y",
  T_43_YU_WS_VECTOR2SUB: "Vector2 Sub",
  T_43_YU_WS_VELOCITY: "Velocity",
  T_43_YU_WS_VERTICALMAXANGLE: "Vertical Max Angle",
  T_43_YU_WS_VERTICALMINANGLE: "Vertical Min. Angle",
  T_43_YU_WS_VISIBILITY_D: "Indicates whether visibility can be set",
  T_43_YU_WS_VISIBLE_D: "The visibility setting. If set to invisible, the client stops rendering the target.",
  T_43_YU_WS_X: "X",
  T_43_YU_WS_X_D: "X",
  T_43_YU_WS_Y: "Y",
  T_43_YU_WS_Y_D: "Y",
  T_43_ZY_WS_ITEM319: "Futuristic Wall A",
  T_43_ZY_WS_ITEM320: "Futuristic Wall C",
  T_43_ZY_WS_ITEM321: "Futuristic Window",
  T_43_ZY_WS_ITEM322: "Futuristic Door",
  T_43_ZY_WS_ITEM323: "Futuristic Angled Roof",
  T_43_ZY_WS_ITEM324: "Futuristic Circular Roof",
  T_43_ZY_WS_ITEM325: "Futuristic Baseboard",
  T_43_ZY_WS_ITEM326: "Futuristic Circular Baseboard",
  T_43_ZY_WS_ITEM327: "Futuristic Stairs",
  T_43_ZY_WS_ITEM328: "Futuristic Decoration A",
  T_43_ZY_WS_ITEM329: "Futuristic Building A",
  T_43_ZY_WS_ITEM330: "Futuristic Building B",
  T_44_CJ_M_B_SPORT_TH: "Gym Uniform (Bottom)",
  T_44_CJ_M_H_SPORT_TH: "Gym Uniform (Head)",
  T_44_CJ_M_S_SPORT_TH: "Gym Uniform (Shoes)",
  T_44_CJ_M_T_SPORT_TH: "Gym Uniform (Top)",
  T_44_CJ_W_AIRBURST: "M590",
  T_44_H_CHARACTER_DUALMAN_N: "Kairos",
  T_44_H_M24_ONIMUSHA_N: "M24 - Attack-o'-the-Wisp",
  T_44_H_USP45_CARNIVORE_N: "USP - Poison Tooth",
  T_44_H_VEHICLESKIN_MOTOBIKE_COLLAGE_N: "Motorbike - Thunderstrokes",
  "T_44_HH_GOLD_AUG-I": "AUG-I",
  "T_44_HH_GOLD_AUG-II": "AUG-II",
  "T_44_HH_GOLD_AUG-III": "AUG-III",
  T_44_JH_WS_CLHALF1: "Force Start with Min. Players",
  T_44_JH_WS_HALFWAYKEY1: "Prioritize Start with Full Team",
  T_44_PD_PVE_DRAGON_NAME: "Mechadrake",
  T_44_QL_GRENADE_DRAGON: "Dragon Freeze",
  T_44_QL_GRENADE_DRAGON_DES: "An upgraded Flash Freeze that will detonate three times consecutively upon impact",
  T_44_QL_JUMPSHOESX: "Dragon Sprinters",
  T_44_QL_JUMPSHOESX_DES: "A pair of special jumping shoes that allow for sprinting in the air during a double jump",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME: "Safe Zone Close Time",
  T_44_SJ_WS_SAFEZONE_CLOSE_TIME_D: "Time when the Safe Zone disappears. If the Safe Zone Close Time is less than Safe Zone Start Time, no Safe Zone will be generated.",
  T_44_SJ_WS_SAFEZONE_COLOR: "Safe Zone Color",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME: "Damage Interval",
  T_44_SJ_WS_SAFEZONE_DAMAGE_TIME_D: "Damage interval",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE: "Damage Value",
  T_44_SJ_WS_SAFEZONE_DAMAGE_VALUE_D: "The damage dealt to a player out-of-zone in a single instance",
  T_44_SJ_WS_SAFEZONE_DESC: "A placeable out-of-zone object",
  T_44_SJ_WS_SAFEZONE_END_RADIUS: "Out-of-Zone End Radius",
  T_44_SJ_WS_SAFEZONE_END_RADIUS_D: "End radius of the out-of-zone area",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS: "Safe Zone Player List",
  T_44_SJ_WS_SAFEZONE_LIVE_PLAYERS_D: "Get the list of players in the Safe Zone",
  T_44_SJ_WS_SAFEZONE_NAME: "The out-of-zone area",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME: "Shrink Duration (s)",
  T_44_SJ_WS_SAFEZONE_SHRINKTIME_D: "Length of time the zone shrinking takes",
  T_44_SJ_WS_SAFEZONE_START_RADIUS: "Out-of-Zone Initial Radius",
  T_44_SJ_WS_SAFEZONE_START_RADIUS_D: "Initial radius of the out-of-zone area",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME: "Start Shrink Time",
  T_44_SJ_WS_SAFEZONE_START_SHRINKTIME_D: "Time when the zone shrinking starts",
  T_44_SJ_WS_SAFEZONE_STARTTIME: "Safe Zone Start Time",
  T_44_SJ_WS_SAFEZONE_STARTTIME_D: "Time when the safe zone appears each round in-match. Default is 0.",
  T_44_WT_W_FGG: "FGL-24",
  T_44_WT_W_REWORKHEAT_NAME_X: "PLASMA-X",
  T_44_XXJ_WS_ACTIVATEDALPHA: "Activated Alpha",
  T_44_XXJ_WS_ACTIVATEDALPHA_D: "Activated alpha",
  T_44_XXJ_WS_ACTIVESKILLBTNHUD: "Active Skill Button HUD",
  T_44_XXJ_WS_ADDCOMPONENT_D: "Add a component to an entity. Only supports custom components. (A component will not be added again if it already exists.)",
  T_44_XXJ_WS_ALLMEMBERS: "All Members",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE: "Allow Pressed Outside",
  T_44_XXJ_WS_ALLOWPRESSEDOUTSIDE_D: "Allow triggering outside the designated area",
  T_44_XXJ_WS_ARROWIMAGE: "Arrow Image",
  T_44_XXJ_WS_ARROWIMAGE_D: "Arrow image",
  T_44_XXJ_WS_ARROWOFFSET: "Arrow Offset",
  T_44_XXJ_WS_ARROWOFFSET_D: "Arrow offset",
  T_44_XXJ_WS_ARROWSIZE: "Arrow Size",
  T_44_XXJ_WS_ARROWSIZE_D: "Arrow size",
  T_44_XXJ_WS_AUTOPLAY_D: "Automatically play upon creation",
  T_44_XXJ_WS_BACKGROUNDIMAGE: "Background Image",
  T_44_XXJ_WS_BACKGROUNDIMAGE_D: "Base image",
  T_44_XXJ_WS_BACKGROUNDRADIUS: "Background Radius",
  T_44_XXJ_WS_BACKGROUNDRADIUS_D: "Base radius",
  T_44_XXJ_WS_BAGSKINID: "Backpack Skin ID",
  T_44_XXJ_WS_BAGSKINID_D: "The backpack skin ID",
  T_44_XXJ_WS_BONEPOSITION: "Bone Position",
  T_44_XXJ_WS_BONEPOSITION_D: "World coordinates of the bone node",
  T_44_XXJ_WS_CCTMOVE: "Move CCT",
  T_44_XXJ_WS_COLLIDER: "Collider",
  T_44_XXJ_WS_COLLIDERCOLLECTION: "Collider Collection",
  T_44_XXJ_WS_COLLIDERCOLLECTION_D: "The component used to describe the collision shape",
  T_44_XXJ_WS_COLOR: "Color",
  T_44_XXJ_WS_CONTENT: "Content",
  T_44_XXJ_WS_CONTENT_D: "Wallet content is a collection of currencies",
  T_44_XXJ_WS_CONTEXT_D: "Content to be printed",
  T_44_XXJ_WS_CROSSHAIRSHUD: "Crosshairs HUD",
  T_44_XXJ_WS_CURVE_D: "Curve",
  T_44_XXJ_WS_EFFECTCOLOR_D: "Color of the surface texture",
  T_44_XXJ_WS_ENABLE: "Enable",
  T_44_XXJ_WS_ENTITY_D: "Entity",
  T_44_XXJ_WS_GETBAGSKINID_D: "Get player backpack skin configuration",
  T_44_XXJ_WS_GETFACTION_D: "Get faction",
  T_44_XXJ_WS_GETLOADEDSCENE_D: "Get the loaded scenes that have not been uninstalled",
  T_44_XXJ_WS_GETLOCALPLAYER_D: "Get the local player",
  T_44_XXJ_WS_GROUPID: "Group ID",
  T_44_XXJ_WS_GROUPID_D: "For internal logic",
  T_44_XXJ_WS_HUDJOYSTICK: "HUD Joystick Widget",
  T_44_XXJ_WS_HUDJOYSTICK_D: "Joystick entity. Players can edit the HUD via the HUD Editor.",
  T_44_XXJ_WS_HUDTOUCHPAD: "HUD Touchpad Widget",
  T_44_XXJ_WS_HUDTOUCHPAD_D: "The HUD Touchpad widget that players can edit in the HUD editor",
  T_44_XXJ_WS_HUDWIDGETORCUSTOMHUD: "Custom HUD or HUD Widget",
  T_44_XXJ_WS_ICON: "Icon",
  T_44_XXJ_WS_ICONISALWAYSSHOWN: "Always Show Mark",
  T_44_XXJ_WS_ICONISALWAYSSHOWN_D: "Always show marks on the compass",
  T_44_XXJ_WS_INACTIVATEDALPHA: "Unactivated Alpha",
  T_44_XXJ_WS_INACTIVATEDALPHA_D: "Unactivated alpha",
  T_44_XXJ_WS_INVOKE_ARGS_MISMATCH: "When calling, the number of actual parameters does not match that of formal parameters. The expected number is {0}, while the actual is {1}.",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE: "Is Dynamic Obstacle",
  T_44_XXJ_WS_ISDYNAMICOBSTACLE_D: "Is a dynamic obstacle for NavMesh",
  T_44_XXJ_WS_ISEND: "Is End",
  T_44_XXJ_WS_ISEND_D: "IsEnd",
  T_44_XXJ_WS_ISSERVERDRIVEN: "Is Server-Driven",
  T_44_XXJ_WS_ISSERVERDRIVEN_D: "If false, then custom objects cannot be controlled by the APIs.",
  T_44_XXJ_WS_ISSUC_D: "Return execution result",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS: "Joystick Drag Radius",
  T_44_XXJ_WS_JOYSTICKCAPDRAGRADIUS_D: "Joystick drag radius",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE: "Joystick Image",
  T_44_XXJ_WS_JOYSTICKCAPIMAGE_D: "Joystick image",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS: "Joystick Radius",
  T_44_XXJ_WS_JOYSTICKCAPRADIUS_D: "Joystick radius",
  T_44_XXJ_WS_LISTT_PLAYERSKILLID: "Character Skill ID List",
  T_44_XXJ_WS_LOOPTYPE_D: "Loop type",
  T_44_XXJ_WS_MIDGAMEEXITCONFIG: "Quit Midway Config",
  T_44_XXJ_WS_MOUNTABLE: "Hierarchical",
  T_44_XXJ_WS_MOUNTABLE_D: "Entity capable of mounting child nodes",
  T_44_XXJ_WS_MOVEMENT: "Movement",
  T_44_XXJ_WS_NAME_D: "Name",
  T_44_XXJ_WS_NATURALCONST: "Natural Constant",
  T_44_XXJ_WS_NATURALCONST_D: "Enum of natural constants to reduce redundant definitions",
  T_44_XXJ_WS_NOTIFYICONANIMATION_D: "Play icon animation",
  T_44_XXJ_WS_OFFSET_D: "Default base offset",
  T_44_XXJ_WS_ONFIRE_D: "Triggers the event each time the player shoots, attacks with fists, or attacks with melee weapons.",
  T_44_XXJ_WS_ONPLAYERSTANDUP_D: "Trigger the event when the player stands up from prone/crouching",
  T_44_XXJ_WS_ONSTARTFIRE_D: "Trigger the event when the player taps the fire button",
  T_44_XXJ_WS_OPTION: "Options",
  T_44_XXJ_WS_PASSIVESKILLHUD: "Passive Skill HUD",
  T_44_XXJ_WS_PHYSICALMOVER: "Physical Mover",
  T_44_XXJ_WS_PHYSICALMOVER_D: "Players on this platform will automatically follow movement and rotation",
  T_44_XXJ_WS_PHYSICALOBJECT: "Physical Object",
  T_44_XXJ_WS_PHYSICALOBJECT_D: "Can apply force to it",
  T_44_XXJ_WS_PI: "Pi",
  T_44_XXJ_WS_PI_D: "The mathematical constant π (Pi) ",
  T_44_XXJ_WS_PLAYERS: "Player List",
  T_44_XXJ_WS_PLAYERS_D: "Player list",
  T_44_XXJ_WS_PLAYERSKILLID: "Character Skill ID",
  T_44_XXJ_WS_PLAYERSKILLID_D: "The character skill ID in AvatarSkill.csv",
  T_44_XXJ_WS_PREPHYSXPOSE_D: "The previous pose before the player stands up",
  T_44_XXJ_WS_PRINT: "Print",
  T_44_XXJ_WS_PRINTERROR: "Print Error",
  T_44_XXJ_WS_PRINTERROR_D: "Print target data as an error to the console",
  T_44_XXJ_WS_PRINTWARNING: "Print Warning",
  T_44_XXJ_WS_PRINTWARNING_D: "Print target data as a warning to the console",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN: "Prioritize Player Skin Config",
  T_44_XXJ_WS_PRIORITIZEPLAYERSKIN_D: "Prioritize the out-of-match player skin configuration",
  T_44_XXJ_WS_READCSVROWBYKEY_D: "Read the content in cells of a  row by the column number and key",
  T_44_XXJ_WS_REMOVEBAGSKINID_D: "Clear player backpack skin configuration",
  T_44_XXJ_WS_REMOVECOMPONENT_D: "Remove a component from an entity. Only supports custom components.",
  T_44_XXJ_WS_RESETBAGSKINID_D: "Reset player backpack skin configuration to its out-of-match configuration",
  T_44_XXJ_WS_SETBAGSKINID_D: "Set player backpack skin configuration",
  T_44_XXJ_WS_SETPARENTCLIENT_D: "Entity supporting the Transform, SkeletonPart, Player, and MountPoint components",
  T_44_XXJ_WS_SHOWBACKGROUND: "Show Background",
  T_44_XXJ_WS_SKINID_D: "Backpack skin ID and skin configuration",
  T_44_XXJ_WS_SPEED_D: "Playback speed",
  T_44_XXJ_WS_TARGET: "Target",
  T_44_XXJ_WS_TARGET_D: "Target object",
  T_44_XXJ_WS_TITLE: "Title",
  T_44_XXJ_WS_TYPEID_D: "Component type ID. Only supports custom components.",
  T_44_XXJ_WS_UPLOADMATCHRESULT_D: "Upload custom match results",
  T_44_XXJ_WS_WARNINGCSVTYPE: "Type mismatch. Unable to read the table content.",
  T_44_XXJ_WS_X_D: "X-axis coordinate",
  T_44_XXJ_WS_Y_D: "Y-axis coordinate",
  T_44_XYL_WS_CTZSAFEZONE: "Custom Safe Zone",
  T_44_XYL_WS_CTZSAFEZONEDESC: "Generates the start and end point of a Safe Zone based on the set positions and properties",
  T_44_XYL_WS_HEMISPHERICALSHELL: "Hemispherical Shell",
  T_44_XYL_WS_QUARTERCYLINDER: "Quarter Cylinder",
  T_44_XYL_WS_SQUAREPYRAMID: "Square Pyramid",
  T_44_XYL_WS_TORUS: "Torus",
  T_44_XYL_WS_TRIANGULARPYRAMID: "Triangular Pyramid",
  T_44_YU_WS_ADDGAMEEVENTLOGMAP: "Add Game Event Log Map",
  T_44_YU_WS_ADDUSEREVENTLOGMAP: "Add User Event Log",
  T_44_YU_WS_ADDUSEREVENTLOGMAP_D: "The custom match event log used for UX data analysis",
  T_44_YU_WS_ITEM366: "Military Wall A",
  T_44_YU_WS_ITEM367: "Military Wall B",
  T_44_YU_WS_ITEM368: "Military Wall C",
  T_44_YU_WS_ITEM369: "Military Wall D",
  T_44_YU_WS_ITEM370: "Military Window A",
  T_44_YU_WS_ITEM371: "Military Window B",
  T_44_YU_WS_ITEM372: "Military Window C",
  T_44_YU_WS_ITEM373: "Military Door A",
  T_44_YU_WS_ITEM374: "Military Door B",
  T_44_YU_WS_ITEM375: "Military Angled Roof A",
  T_44_YU_WS_ITEM376: "Military Angled Roof B",
  T_44_YU_WS_ITEM377: "Military Stairs A",
  T_44_YU_WS_ITEM378: "Military Stairs B",
  T_44_YU_WS_ITEM379: "Military Pillar A",
  T_44_YU_WS_ITEM380: "Military Handrail A",
  T_45_C_WEAPON_CUST_ENTRANCE: "Customize",
  T_45_CJ_TREATMENTGUN_Y_N: "Heal Pistol-Y",
  T_45_H_CHARACTER_ELECTRICGIRL_N: "Kassie",
  T_45_H_EMOTE_MVPDANCE_N: "Champion's Walk",
  "T_45_HH_GOLD_MAC10-I": "MAC10-I",
  "T_45_HH_GOLD_MAC10-II": "MAC10-II",
  "T_45_HH_GOLD_MAC10-III": "MAC10-III",
  T_45_HJ_CAMERA_INSPECTOR: "Inspect",
  T_45_HL_Moderation_fail_1: "Unfortunately, your submitted project did not pass the review.",
  T_45_HL_Moderation_fail_2: "involves",
  T_45_HL_Moderation_fail_3: "Reasons included:",
  T_45_HL_Moderation_fail_Location_1: "Game Content",
  T_45_HL_Moderation_fail_reason_1: "Toxic Content",
  T_45_HL_Moderation_fail_reason_10: "Community Guideline Violation",
  T_45_HL_Moderation_fail_reason_11: "Negative Impacts on In-Game Economies and Virtual Property Infringement",
  T_45_HL_Moderation_fail_reason_2: "Inappropriate Content",
  T_45_HL_Moderation_fail_reason_3: "Politically Sensitivity",
  T_45_HL_Moderation_fail_reason_4: "False Information",
  T_45_HL_Moderation_fail_reason_5: "Copyright Infringement",
  T_45_HL_Moderation_fail_reason_6: "Privacy Violation",
  T_45_HL_Moderation_fail_reason_7: "Security Concerns",
  T_45_HL_Moderation_fail_reason_8: "Hate Speech",
  T_45_HL_Moderation_fail_reason_9: "Spam",
  T_45_HL_Moderation_fail_reason_999: "Other Issues",
  T_45_JH_WS_CLEMPTYOBJECT: "Object Group",
  T_45_JH_WS_PETSWITCH1: "Whether to show pets in the match",
  T_45_QL_CSFPP_DES: "Eliminate all opponents through the first-person perspective in this special CS mode!",
  T_45_QL_CSFPP_NAME: "Clash Squad: FPP",
  T_45_QL_CSFPP_RANKNAME: "First-Person",
  T_45_SJ_WS_REVIEW_23: "Game Content",
  T_45_SJ_WS_REVIEW_24: "{0} involves {1}",
  T_45_SJ_WS_REVIEW_25: "{0} {1} involves {2}",
  T_45_SJ_WS_REVIEW_26: "[FFBA00]Tap to view details >>[-]",
  T_45_SJ_WS_REVIEW_27: "Not Approved",
  T_45_SJ_WS_REVIEW_28: "Review Feedback",
  T_45_SJ_WS_REVIEW_29: "The content involves {0} violation(s)",
  T_45_SJ_WS_REVIEW_31: "Not Approved",
  T_45_SJ_WS_REVIEW_32: "The review failed due to server exceptions",
  T_45_SJ_WS_REVIEW_TITLE: "Details of Violation",
  T_45_SJ_WS_VAULTTRIGGER_DES: "Triggers vaulting (jumping over obstacles)",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE: "Vault Distance",
  T_45_SJ_WS_VAULTTRIGGER_DISTANCE_DES: "Modifies the distance of vaulting",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT: "Vault Height",
  T_45_SJ_WS_VAULTTRIGGER_HEIGHT_DES: "Controls the height of moving up and down when vaulting",
  T_45_SJ_WS_VAULTTRIGGER_NAME: "Vault Trigger",
  T_45_TYC_CL_TEMPLATE_WS: `An elimination mode where players take out all opposing teams in a chaotic battle to win.
You can set the gameplay rules and edit the gameplay parameters as you like.`,
  T_45_W_SPEEDMODE_FLIGHT_N: "Skyblaster",
  T_45_XXJ_WS_ACTIONTYPE_D: "0 = auto attack, 1 = defensive attack, 2 = do not attack",
  T_45_XXJ_WS_ADDFRIEND: "Add Friend",
  T_45_XXJ_WS_API: "API",
  T_45_XXJ_WS_AUTO: "Auto",
  T_45_XXJ_WS_BASEDATA: "Base Data",
  T_45_XXJ_WS_BOTH: "Both",
  T_45_XXJ_WS_BYHIERARCHY: "By Hierarchy",
  T_45_XXJ_WS_BYPRIORITYHIGHTOLOW: "By Priority High to Low",
  T_45_XXJ_WS_BYPRIORITYLOWTOHIGH: "By Priority Low to High",
  T_45_XXJ_WS_CAMERA: "Camera",
  T_45_XXJ_WS_CAMERATYPE: "Camera Type",
  T_45_XXJ_WS_CENTERINVISIBLE: "Center Invisible",
  T_45_XXJ_WS_CLIENT: "Client",
  T_45_XXJ_WS_COLLIDERID: "Collider ID",
  T_45_XXJ_WS_COLLIDERID_D: "The collider ID",
  T_45_XXJ_WS_COMPONENT: "Component",
  T_45_XXJ_WS_CURRENTCAMERA: "Current Camera",
  T_45_XXJ_WS_CUSTOMPUSHFORCE: "Custom Push Force",
  T_45_XXJ_WS_DOUBLE: "Double",
  T_45_XXJ_WS_DUMP: "Throw",
  T_45_XXJ_WS_ENABLEMOVEINMIDAIR: "Enable Move in Midair",
  T_45_XXJ_WS_ENABLEROTATEWITHGRAVITY: "Enable Rotate with Gravity",
  T_45_XXJ_WS_ENUM: "Enum",
  T_45_XXJ_WS_EVENT: "Event",
  T_45_XXJ_WS_FILLAMOUNT: "Fill Amount",
  T_45_XXJ_WS_FILLDIR: "Fill Direction",
  T_45_XXJ_WS_FIRETYPE: "Fire Type",
  T_45_XXJ_WS_FIRETYPE_D: "The firing type",
  T_45_XXJ_WS_FIXEDDELTATIME: "Fixed Delta Time",
  T_45_XXJ_WS_FIXEDDELTATIME_D: "The fixed time interval for frame updates in milliseconds",
  T_45_XXJ_WS_FORWARD: "Forward",
  T_45_XXJ_WS_FORWARD_D: "The direction of the z-axis in the local coordinate system",
  T_45_XXJ_WS_FUNCTIONTYPE: "Function Type",
  T_45_XXJ_WS_FUNCTIONTYPE_D: "The function type",
  T_45_XXJ_WS_GETLOCALAIMDIRECTION_D: "The aiming direction of the local player",
  T_45_XXJ_WS_GETLOCALTIMESTAMP_D: "Get the local timestamp",
  T_45_XXJ_WS_GRADIENT: "Gradient",
  T_45_XXJ_WS_GRADIENTBOTTOM: "Gradient Bottom",
  T_45_XXJ_WS_GRADIENTBOTTOMALPHA: "Gradient Bottom Alpha",
  T_45_XXJ_WS_GRADIENTTOP: "Gradient Top",
  T_45_XXJ_WS_GRADIENTTOPALPHA: "Gradient Top Alpha",
  T_45_XXJ_WS_HITPOSITION_D: "The world position of the target hit by bullets",
  T_45_XXJ_WS_HUDSOCIALBUTTONWIDGET: "UI Social Button Widget",
  T_45_XXJ_WS_INVERTFILL: "Invert Fill",
  T_45_XXJ_WS_ISGROUNDED: "Is Grounded",
  T_45_XXJ_WS_ISSILENCE: "Is Silence",
  T_45_XXJ_WS_ISSILENCE_D: "If it is silenced or not",
  T_45_XXJ_WS_ISSINGLESHOT: "Is Single Shot",
  T_45_XXJ_WS_ISSINGLESHOT_D: "If it is single-shot or not",
  T_45_XXJ_WS_JUMPHEIGHT: "Jump Height",
  T_45_XXJ_WS_JUMPHEIGHT_D: "The jump height",
  T_45_XXJ_WS_LAYOUTSORTTYPE: "Layout Sort Type",
  T_45_XXJ_WS_LIGHT_D: "Lights",
  T_45_XXJ_WS_LOCAL: "Local",
  T_45_XXJ_WS_MAXMULTIJUMPNUM: "Max. Jump Count",
  T_45_XXJ_WS_MODULE: "Module",
  T_45_XXJ_WS_NONE: "None",
  T_45_XXJ_WS_ONBEFOREHURT_D: "Execute the command each time before the entity deals damage",
  T_45_XXJ_WS_ONDISABLE_D: "Execute when the entity is disabled",
  T_45_XXJ_WS_ONEACHLOOP_D: "Execute each time Playable is looped. Only effective on the client side for entities such as Sound Effect and Special Effect.",
  T_45_XXJ_WS_ONENABLE_D: "Execute when the entity is enabled",
  T_45_XXJ_WS_ONFIXEDUPDATE_D: "When entering a frame at a fixed rate of 30 FPS",
  T_45_XXJ_WS_ONFRIENDRELATIONCHANGE_D: "Trigger the client event when the player adds or deletes a friend",
  T_45_XXJ_WS_ONGAMEPAUSE_D: "Trigger the event when the game is paused due to the called API",
  T_45_XXJ_WS_ONGAMERESUME_D: "Trigger the event when the game resumes due to the called API",
  T_45_XXJ_WS_ONPLAYERSTOPDASH_D: "When the player stops sprinting",
  T_45_XXJ_WS_ONPLAYERSTOPSWIMSURFING_D: "When the player stops surfing",
  T_45_XXJ_WS_ONPLAYERSWIMSURFING_D: "When the player is surfing",
  T_45_XXJ_WS_PHYSICALLAYER_D: "The custom physical layer within a range of 0 to 31",
  T_45_XXJ_WS_PLATFORMTYPE: "Platform Type",
  T_45_XXJ_WS_PLATFORMTYPE_D: "The platform type",
  T_45_XXJ_WS_PLAYER: "Player",
  T_45_XXJ_WS_PLAYERCCT: "Player CCT",
  T_45_XXJ_WS_PLAYERCCT_D: "A character controller with physical effects and used for Free Fire characters only",
  T_45_XXJ_WS_PRIORITY: "Priority",
  T_45_XXJ_WS_REMAINMULTINUM: "Remain Jump Count",
  T_45_XXJ_WS_REPORT: "Report",
  T_45_XXJ_WS_RIGHT: "Right",
  T_45_XXJ_WS_RIGHT_D: "The direction of the x-axis in the local coordinate system",
  T_45_XXJ_WS_SERVER: "Server",
  T_45_XXJ_WS_SINGLE: "Single",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE: "Social Button Style Type",
  T_45_XXJ_WS_SOCIALBUTTONSTYLETYPE_D: "The social button style",
  T_45_XXJ_WS_SOCIALBUTTONTYPE: "Social Button Type",
  T_45_XXJ_WS_SOCIALBUTTONTYPE_D: "The social button type",
  T_45_XXJ_WS_SORTTYPE_D: "Sort types: non-zero ascending, descending, and ascending",
  T_45_XXJ_WS_SPEEDWHILEAIMING: "Move Speed While ADS",
  T_45_XXJ_WS_SPEEDWHILEAIMING_D: "The movement speed while aiming down sight",
  T_45_XXJ_WS_STRINGORLOCSTRING: "String or Localized String",
  T_45_XXJ_WS_TRIPLE: "Triple",
  T_45_XXJ_WS_UP: "Up",
  T_45_XXJ_WS_UP_D: "The direction of the y-axis in the local coordinate system",
  T_45_XXJ_WS_USECUSTOMPUSHFORCE: "Use Custom Push Force",
  T_45_XXJ_WS_Z: "Z",
  T_45_XXJ_WS_Z_D: "Z",
  T_45_ZD_VEHICLEDROP_R_DESC: "Throw a signal flare towards the designated area to summon a random vehicle",
  T_45_ZD_VEHICLEDROP_R_NAME: "Mystery Vehicle",
  T_46_H_CHARACTER_MISCHIEFGIRL_N: "Lila",
  T_46_HJ_SHARE_GAMEDURATION: "Time Played",
  T_46_HJ_WS_SHAREBY: "By {0}",
  T_46_HJ_WS_SHAREGAMEMODE: "Game Mode",
  T_46_HJ_WS_SHARETEAM: "Team",
  T_46_HJ_WS_SHARETEAMVS: "{0} vs {1}",
  T_46_HX_B_SCHOOL_VN: "Top of Class (Bottom)",
  T_46_HX_H_SCHOOL_VN: "Top of Class (Head)",
  T_46_HX_S_SCHOOL_VN: "Top of Class (Shoes)",
  T_46_HX_T_SCHOOL_VN: "Top of Class (Top)",
  T_46_JH_WS_CLGUIDE_TUTORIAL: "Tutorial",
  T_46_LYF_RANKBOARD_TIPS_OTHERS: "Others",
  T_46_XXJ_WS_ACTUALPOSITION: "Actual Position",
  T_46_XXJ_WS_ADDSPECIALFOLLOW_D: "Add the object to monitor with AOI synchronization beyond line of sight",
  T_46_XXJ_WS_APPEARANCE: "Appearance",
  T_46_XXJ_WS_APPEARANCERES: "Appearance Resource",
  T_46_XXJ_WS_BECOME: "Activate",
  T_46_XXJ_WS_BRAKETORQUE_D: "The horsepower given to the vehicle when Brake/Reverse is used",
  T_46_XXJ_WS_CAMERAVIEWINGANGLERESTRICTIONTYPE: "Camera Rotate Angle Restriction Type",
  T_46_XXJ_WS_CLEANSPECIALFOLLOW_D: "Clear all monitored objects of the target",
  T_46_XXJ_WS_CRASHMAXDAMAGE_D: "The maximum crash damage used for damage calculation",
  T_46_XXJ_WS_CRASHMAXSPEED: "Crash Max. Speed",
  T_46_XXJ_WS_CRASHMAXSPEED_D: "Used for crash damage calculation. Once exceeding this speed, no more damage will be added.",
  T_46_XXJ_WS_CRASHMESSFACTOR: "Crash Mass Factor",
  T_46_XXJ_WS_CRASHMESSFACTOR_D: "A parameter used in the damage formula for crash damage calculation",
  T_46_XXJ_WS_CRASHMINDAMAGE_D: "The minimum crash damage used for damage calculation",
  T_46_XXJ_WS_DB_OVERLIMIT_D: "Read and write limit of data storage has been exceeded",
  T_46_XXJ_WS_DB_PARAMERROR_D: "Parameter exception",
  T_46_XXJ_WS_DB_TIMEOUT_D: "Data storage timeout. Mainly applies to read and write now.",
  T_46_XXJ_WS_DELTA: "Delta",
  T_46_XXJ_WS_EDITNPCCOLLIDERTIPS: "Edit Appearance",
  T_46_XXJ_WS_ENDVALUE_D: "The destination value",
  T_46_XXJ_WS_ENGINETORQUE_D: "The horsepower given to the vehicle when the gas pedal is used",
  T_46_XXJ_WS_ERRORCODE_D: "The error code enum",
  T_46_XXJ_WS_EULARANGLETOVECTOR3: "Euler Angle to Vector3",
  T_46_XXJ_WS_EULARANGLETOVECTOR3_D: "Convert the Eular angle to a 3D vector",
  T_46_XXJ_WS_EXPIRE: "Expire",
  T_46_XXJ_WS_FEMALEAVATAR: "Female Character",
  T_46_XXJ_WS_GETPREMIUMEXPIREDATE: "Get Membership Expire Date",
  T_46_XXJ_WS_HASSPECIALFOLLOW_D: "If the observer is monitoring an object or not",
  T_46_XXJ_WS_HELICOPTER: "Skyblaster",
  T_46_XXJ_WS_HELICOPTER_D: "A type of flying vehicle",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE: "High-Speed Steer Restriction",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLE_D: "The maximum steering angle while in a high-speed state",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED: "High-Speed Steer Angle at Speed",
  T_46_XXJ_WS_HIGHSPEEDSTEERANGLEATSPEED_D: "The speed threshold for the maximum high-speed steering angle",
  T_46_XXJ_WS_IDLE: "Idle Animation",
  T_46_XXJ_WS_IDLEBRAKEINPUT: "Idle Brake Input",
  T_46_XXJ_WS_IDLEBRAKEINPUT_D: "When not driving a vehicle, decelerate it by (Idle Brake Input) x (Brake Torque).",
  T_46_XXJ_WS_INTTOFLOAT: "Int to Float",
  T_46_XXJ_WS_INTTOFLOAT_D: "Convert an integer to a floating-point number",
  T_46_XXJ_WS_ISPREMIUM: "Is Membership",
  T_46_XXJ_WS_LEADERBOARDNAME_D: "The leaderboard name in the database",
  T_46_XXJ_WS_MALEAVATAR: "Male Character",
  T_46_XXJ_WS_MODULE_AICHARACTOR: "AI Persona",
  T_46_XXJ_WS_NEWUMAAPPEARANCE: "New UMA Appearance",
  T_46_XXJ_WS_NONE_D: "No error",
  T_46_XXJ_WS_NPC: "NPC",
  T_46_XXJ_WS_NPC_D: "The NPC object",
  T_46_XXJ_WS_NPCCOLLIDERTIPS: "Tips: Humanoid NPCs usually have a collision model with a capsule that is 1.4m tall and 0.25m in radius. Pet NPCs usually have a collision model with a capsule that is 1m tall and 0.4m in radius.",
  T_46_XXJ_WS_OBSERVER_D: "The observer that is monitoring objects",
  T_46_XXJ_WS_ONPLAYERENTERPREMIUMCENTER: "On Enter Craftland Membership",
  T_46_XXJ_WS_ONPLAYERLEAVEPREMIUMCENTER: "On Quit Craftland Membership",
  T_46_XXJ_WS_OPENPREMIUMCENTER: "Open Craftland Membership",
  T_46_XXJ_WS_PERSONA: "Persona",
  T_46_XXJ_WS_PERSONACENTER: "Persona Center",
  T_46_XXJ_WS_PET: "Pet",
  T_46_XXJ_WS_PLAYERORTRANSFORM: "Player or Transform",
  T_46_XXJ_WS_PLAYERORTRANSFORM_D: "An alias for the Player and Transform entity",
  T_46_XXJ_WS_PREMIUM: "Membership",
  T_46_XXJ_WS_PREMIUMSTATUS: "Membership Status",
  T_46_XXJ_WS_PROXYOBSERVER: "Proxy Observer",
  T_46_XXJ_WS_PROXYOBSERVER_D: "The proxy observer",
  T_46_XXJ_WS_REMOVESPECIALFOLLOW_D: "Remove the monitored object and cancel the AOI synchronization beyond line of sight",
  T_46_XXJ_WS_RENEWAL: "Renew",
  T_46_XXJ_WS_ROTATEVECTOR: "Rotate Vector",
  T_46_XXJ_WS_ROTATEVECTOR_D: "Rotate a vector based on quaternions",
  T_46_XXJ_WS_SKIN: "Gear",
  T_46_XXJ_WS_STARTVALUE_D: "The source value",
  T_46_XXJ_WS_STATUS: "Status",
  T_46_XXJ_WS_SWITCHUSERPROXYOBSERVER_D: "Switch the proxy observer of the User",
  T_46_XXJ_WS_TARGET_D: "The target that is monitored",
  T_46_XXJ_WS_USER_D: "The user",
  T_46_XXJ_WS_VALUE: "Value",
  T_46_XXJ_WS_VALUE_D: "Vector",
  T_46_XYL_WS_CTZSAFEZONEEND: "Safe Zone End Point",
  T_46_XYL_WS_RESOURCETYPE1: "Basic Structures",
  T_46_XYL_WS_RESOURCETYPE1_1: "Geometrics",
  T_46_XYL_WS_RESOURCETYPE1_2: "Visual & Audio",
  T_46_XYL_WS_RESOURCETYPE2: "Scene Items",
  T_46_XYL_WS_RESOURCETYPE2_2: "Battle Supplies",
  T_46_XYL_WS_RESOURCETYPE3: "Nature",
  T_46_XYL_WS_RESOURCETYPE4: "Modular Component",
  T_46_XYL_WS_TYPEOTHERPROP: "Miscellaneous",
  T_46_XYL_WS_TYPEOTHERPROPBOX: "Containers & Boxes",
  T_47_CJ_FOREGRIP_SOFT_N: "Light Foregrip",
  T_47_CJ_MAGEZINE_FAST_N: "Fast Mag",
  T_47_CJ_STOCK_FAST_N: "Power Stock",
  T_47_GT_WS_USERMANUAL: "User Manual",
  T_47_HJ_WS_VFX_FOG: "Fog VFX",
  T_47_HJ_WS_VFX_LIGHTING: "Lighting VFX",
  T_47_HJ_WS_VFX_TRAILING: "Trailing VFX",
  T_47_HL_CL_CREATOR_LABEL1: "Community Talent",
  T_47_HL_CL_MAP_LABEL1: "Selected Works by Community Talents",
  T_47_JH_WS_MODERATION_REASON12: "Gambling-related",
  T_47_RW_NB_GP_GAMEAFFIX_HINT1: "NARUTO SHIPPUDEN collaboration",
  T_47_SD_RES_MATERIAL: "Material file",
  T_47_SD_RES_MESH: "Mesh",
  T_47_SD_WS_MAPTAG_AI: "AI Map Generate",
  T_47_WT_W_NB_GP_KA_EXPLODE_DESC: "A special knife that sticks to the point of impact after being thrown, triggering a fiery explosion after a short delay to deal burn damage.",
  T_47_WT_W_NB_GP_KA_EXPLODE_NAME: "Fiery Kunai",
  T_47_WT_W_NB_GP_KA_THUNDER_DESC: "A special knife that sticks to the point of impact after being thrown, triggering a Lightning strike after a short delay to paralyze the target.",
  T_47_WT_W_NB_GP_KA_THUNDER_NAME: "Lightning Kunai",
  T_47_WT_W_NB_GP_KA_WIND_DESC: "A special knife that sticks to the point of impact after being thrown, triggering a windstorm after a short delay to slow down the target moving towards its center.",
  T_47_WT_W_NB_GP_KA_WIND_NAME: "Wind Kunai",
  T_47_WT_W_NB_GP_SRK_HEAVY_DESC: "A type of shuriken suitable for mid-to-long-range combat. One throw launches one piece quickly, dealing a great amount of damage.",
  T_47_WT_W_NB_GP_SRK_HEAVY_NAME: "Heavy Shuriken",
  T_47_WT_W_NB_GP_SRK_LIGHT_DESC: "A type of shuriken suitable for close-to-mid-range combat with two attack modes. One throw launches three pieces, dealing a small amount of damage.",
  T_47_WT_W_NB_GP_SRK_LIGHT_NAME: "Light Shuriken",
  T_47_XXJ_WS_ACTION: "Action",
  T_47_XXJ_WS_AOISETTING: "AOI Setting",
  T_47_XXJ_WS_BAGSKINTYPE: "Backpack Skin Type",
  T_47_XXJ_WS_CLEARMEMORY: "Clear Memory",
  T_47_XXJ_WS_CLNPC: "Advanced NPC",
  T_47_XXJ_WS_CLOTHTYPE: "Outfit Skin Type",
  T_47_XXJ_WS_COMMON_ERROR: "Common Error",
  T_47_XXJ_WS_CONTENT: "Content",
  T_47_XXJ_WS_CREATERANDOMSEED: "Create Random Seed",
  T_47_XXJ_WS_ELAPSEDPERCENTAGE: "Elapsed Percentage",
  T_47_XXJ_WS_ENABLEUGCFOGFEATURE: "Enable Fog Feature",
  T_47_XXJ_WS_ENABLEUGCLIGHTROTATEFEATURE: "Enable Light Rotation Feature",
  T_47_XXJ_WS_ERRORCODE: "Error Code",
  T_47_XXJ_WS_EXPONENTIAL: "Exponential",
  T_47_XXJ_WS_EXPONENTIALSQUARED: "Exponential Squared",
  T_47_XXJ_WS_FAILED_INVALIDALLIDSONCREATE: "Failed to create room: no valid Persona IDs",
  T_47_XXJ_WS_FOG: "Fog",
  T_47_XXJ_WS_FOGDENSITY: "Fog Density",
  T_47_XXJ_WS_FOGENDDISTANCE: "Fog End Distance",
  T_47_XXJ_WS_FOGMODE: "Fog Mode",
  T_47_XXJ_WS_FOGMODETYPE: "Fog Mode Type",
  T_47_XXJ_WS_FOGSTARTDISTANCE: "Fog Start Distance",
  T_47_XXJ_WS_HEIGHTSCALE: "Height Scale",
  T_47_XXJ_WS_ISVISIBLE: "Is Visible",
  T_47_XXJ_WS_JOINNEWTEAM: "Join New Team",
  T_47_XXJ_WS_JOINTEAM: "Join Team",
  T_47_XXJ_WS_LIGHTROTATE: "Light Rotation",
  T_47_XXJ_WS_LINEAR: "Linear",
  T_47_XXJ_WS_LLMCHATHUD: "UI Persona Chat",
  T_47_XXJ_WS_NEWTEAM: "New Team",
  T_47_XXJ_WS_NEXT: "Next",
  T_47_XXJ_WS_NPC_TIP: "You can edit NPC's appearance and make NPC play animation",
  T_47_XXJ_WS_OBSERVERS: "Observers",
  T_47_XXJ_WS_ONHUDSENDMESSAGETOPERSONA: "On Player Send Message by UI Persona Chat",
  T_47_XXJ_WS_ONPREMIUMCHANGE: "On Membership Status Changed",
  T_47_XXJ_WS_ONRECEIVEACTIONFROMPERSONA: "On Receive Action From Persona",
  T_47_XXJ_WS_ONRECEIVECONTENTFROMPERSONA: "On Receive Content From Persona",
  T_47_XXJ_WS_ONRECEIVEFINISHFROMPERSONA: "On Receive Finish From Persona",
  T_47_XXJ_WS_ONRECEIVESTATUSFROMPERSONA: "On Receive Status From Persona",
  T_47_XXJ_WS_PARTICLESID: "Particles ID",
  T_47_XXJ_WS_PERSONAAVATAR: "Persona Avatar",
  T_47_XXJ_WS_PERSONAID: "Persona ID",
  T_47_XXJ_WS_PERSONANICKNAME: "Persona Nickname",
  T_47_XXJ_WS_PLAYERORNPC: "Player or NPC",
  T_47_XXJ_WS_PREMIUM_CLOSED: "Membership Closed",
  T_47_XXJ_WS_RANDOM: "Random",
  T_47_XXJ_WS_SEED: "Seed",
  T_47_XXJ_WS_SENDER: "Sender",
  T_47_XXJ_WS_SETPERSONAOBSERVER: "Set Persona Observer",
  T_47_XXJ_WS_SETPLAYERCANQUITMIDWAY: "Set Player Can Quit Midway",
  T_47_XXJ_WS_SHOULDREPLY: "Should Reply",
  T_47_XXJ_WS_SHOWSYSTEMREPLY: "Show System Reply",
  T_47_XXJ_WS_SPOTANGLE: "Spot Angle",
  T_47_XXJ_WS_SPOTLIGHT: "Spotlight",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONA: "Send System Message To Persona",
  T_47_XXJ_WS_SYSTEMMESSAGETOPERSONASTREAM: "Stream System Messages to Persona",
  T_47_XXJ_WS_TARGETTEAM: "Target Team",
  T_47_XXJ_WS_THISENTITY: "This Entity",
  T_47_XXJ_WS_USERAVATAR: "User Avatar",
  T_47_XXJ_WS_USERMESSAGETOPERSONA: "Send User Message To Persona",
  T_47_XXJ_WS_USERMESSAGETOPERSONASTREAM: "Stream User Messages to Persona",
  T_47_XXJ_WS_USERNICKNAME: "User Nickname",
  T_47_XXJ_WS_VEHICLESKINTYPE: "Vehicle Skin Type",
  T_47_XXJ_WS_WEAPONSKINTYPE: "Weapon Skin Type",
  T_47_XYL_NB_UGC_EFFECT001: "Rasengan VFX",
  T_47_XYL_NB_UGC_EFFECT002: "Chidori VFX",
  T_47_XYL_NB_UGC_EFFECT003: "Cherry Blossom Clash VFX",
  T_47_XYL_NB_UGC_EFFECT004: "Fireball Jutsu VFX",
  T_47_XYL_NB_UGC_EFFECT005: "Water Dragon Jutsu VFX",
  T_47_XYL_NB_UGC_EFFECT006: "Great Breach VFX",
  T_47_XYL_NB_UGC_EFFECT007: "Tailed Beast Bomb VFX",
  T_47_XYL_NB_UGC_EFFECT008: "Reanimation Curse Mark VFX",
  T_47_XYL_UGC_CRAFTLANDSHOP: "Asset Store",
  T_47_XYL_UGC_DONKEYCART: "Donkey Cart",
  T_47_XYL_UGC_SPOTLIGHT: "Spotlight",
  T_47_XYL_UGC_SPOTLIGHTANGLE: "Spotlight Angle",
  T_48_H_EMOTE_WATERFEST25_N: "Swift Steps",
  T_48_H_VEHICLESKIN_MOTOBIKE_WATERFEST25_N: "Motorbike - Sea Foam",
  T_48_HJ_AC_STATENOTEXIST: "The state {0} does not exist in the animation controller",
  T_48_HL_CODESCRIPT: "Code Script",
  T_48_HL_GLOBAL_VAR: "Global Variable Name",
  T_48_HL_GRAPH: "Block",
  T_48_HL_HUD: "HUD",
  T_48_HL_LEADERBOARD_NAME: "Leaderboard",
  T_48_HL_LOCAL_VAR: "Local Variable Name",
  T_48_HL_LOCALIZATION: "Localization Name",
  T_48_HL_OPEN_ATTRIBUTES: "Open Attribute Name",
  T_48_HX_A_WATERFEST25: "Sea Foam (Mask)",
  T_48_HX_B_WATERFEST25: "Sea Foam (Bottom)",
  T_48_HX_F_B_BLACKDRESS: "Antimatter (Bottom)",
  T_48_HX_F_H_BLACKDRESS: "Antimatter (Head)",
  T_48_HX_F_HA_BLACKDRESS: "Antimatter (Facepaint)",
  T_48_HX_F_S_BLACKDRESS: "Antimatter (Shoes)",
  T_48_HX_F_T_BLACKDRESS: "Antimatter (Top)",
  T_48_HX_H_WATERFEST25: "Sea Foam (Head)",
  T_48_HX_HA_WATERFEST25: "Sea Foam (Facepaint)",
  T_48_HX_M_A_BLACKDRESS: "Dark Matter (Mask)",
  T_48_HX_M_B_BLACKDRESS: "Dark Matter (Bottom)",
  T_48_HX_M_H_BLACKDRESS: "Dark Matter (Head)",
  T_48_HX_M_HA_BLACKDRESS: "Dark Matter (Facepaint)",
  T_48_HX_M_S_BLACKDRESS: "Dark Matter (Shoes)",
  T_48_HX_M_T_BLACKDRESS: "Dark Matter (Top)",
  T_48_HX_S_WATERFEST25: "Sea Foam (Shoes)",
  T_48_HX_T_WATERFEST25: "Sea Foam (Top)",
  T_48_JH_WS_STRINGDESC: "Enter a paragraph of text or other strings. Some widgets can display rich text. Add color to text with rich text using the following format: [#XXXXXX] text text [-]. “#XXXXXX” is the color you wish to display. Please note that the text color of the related widget must be set to white.",
  T_48_M_WS_P_ICON: "Avatar",
  T_48_META_API_10001: "Find Entity by ID",
  T_48_META_API_10001_P0: "Entity ID",
  T_48_META_API_1098: "Batch Read Database Sheet Value",
  T_48_META_API_1098_D: "Batch read multiple data entries from a specified database sheet, where the entries of the unique player ID list correspond one-to-one with those of the key list.",
  T_48_META_API_1098_P1: "Account IDs",
  T_48_META_API_1098_P1_D: "The list of unique player IDs, which reads the data corresponding to the keys at the same index in the key list.",
  T_48_META_API_1098_P2: "Keys",
  T_48_META_API_1098_P2_D: "The list of keys, which reads the data corresponding to the unique player IDs at the same index in the ID list.",
  T_48_META_API_1098_P5: "Status Codes",
  T_48_META_API_1098_P5_D: "The list of status codes",
  T_48_META_API_1105: "Notify Start Plot",
  T_48_META_API_1105_D: "Start playing the specified plot for the triggering player",
  T_48_META_API_1105_P1_D: "The plot ID",
  T_48_META_API_1108: "Get Local Language",
  T_48_META_API_1500_P0: "Vector",
  T_48_META_API_1505_P1: "Z",
  T_48_META_API_3300: "Set Body Part Weight",
  T_48_META_API_3300_D: "Set the weight of the target body part when blending it with other lower-priority animations",
  T_48_META_API_3300_P0_D: "The addable animation controller component that the body part belongs to",
  T_48_META_API_3300_P1: "Body Part Name",
  T_48_META_API_3300_P1_D: "The body part name",
  T_48_META_API_3300_P2: "Weight",
  T_48_META_API_3300_P2_D: "Weight with a value range of [0, 1], representing the degree of blending with lower-priority animations.",
  T_48_META_API_3315: "Play Character Animation Clip Override",
  T_48_META_API_3315_D: "Play a character animation clip with the option to override the game's default animation",
  T_48_META_API_3315_P3: "Override Gameplay Control",
  T_48_META_API_3315_P3_D: "Whether to override the default animation of the game",
  T_48_META_API_3316: "Stop Animation",
  T_48_META_API_3316_D: "Stop playing the animation for the target in the specified status",
  T_48_META_API_90_P1: "Can Quit Midway",
  T_48_META_API_93: "Create Along Path Motion",
  T_48_META_API_93_D: "Create an interpolated movement along a path to make the object move along the specified path",
  T_48_META_API_93_P1: "Path",
  T_48_META_API_93_P1_D: "The path of motion",
  T_48_META_API_93_P3_D: "The magnitude of velocity",
  T_48_META_API_93_P4: "Tangent Facing",
  T_48_META_API_93_P4_D: "Whether the object is facing the direction of movement. This property remains unchanged even if the object's orientation is forcibly modified by other means.",
  T_48_META_API_96: "Instantiate Prefab",
  T_48_META_API_96_D: "Create a prefab instance with the option to process it asynchronously",
  T_48_META_API_96_P2: "Async Load",
  T_48_META_API_96_P2_D: "Whether loading is asynchronous",
  T_48_META_EVT_3140: "On Change Team",
  T_48_META_EVT_3140_D: "Triggers when the team of the current entity changes",
  T_48_META_EVT_3140_P0: "Former Team",
  T_48_META_EVT_3140_P0_D: "The team one belonged to before the change",
  T_48_META_EVT_3140_P1: "Current Team",
  T_48_META_EVT_3140_P1_D: "The team one belongs to after the change",
  T_48_META_EVT_3141: "On Plot Start",
  T_48_META_EVT_3141_D: "Triggers when the plot starts to play",
  T_48_META_EVT_3141_P1: "Plot ID",
  T_48_META_EVT_3141_P1_D: "The plot ID",
  T_48_META_EVT_3142: "On Plot End",
  T_48_META_EVT_3142_D: "Triggers when the plot ends",
  T_48_META_EVT_3142_P0_D: "The triggering player",
  T_48_META_EVT_3142_P1_D: "The plot ID",
  T_48_META_EVT_3143: "On Trigger Plot Option",
  T_48_META_EVT_3143_D: "Triggers when an option is selected in the plot",
  T_48_META_EVT_3143_P1_D: "The plot ID",
  T_48_META_EVT_3143_P2: "Option ID",
  T_48_META_EVT_3143_P2_D: "The ID of the option selected",
  T_48_META_TYP_409_I10: "Change Team Failed_Invalid Team",
  T_48_META_TYP_409_I11: "Change Team Failed_Eliminated",
  T_48_META_TYP_409_I12: "Change Team Failed_In Vehicle",
  T_48_META_TYP_409_I7: "Change Team Failed_Not Supported",
  T_48_META_TYP_409_I8: "Change Team Failed_Already In Team",
  T_48_META_TYP_409_I9: "Change Team Failed_Invalid Target",
  T_48_META_TYP_41_I19: "Disable Collider",
  T_48_META_TYP_417: "Particles",
  T_48_META_TYP_428: "Player Transform or NPC Outfit",
  T_48_META_TYP_431: "Along Path Motion",
  T_48_META_TYP_431_I1: "Path",
  T_48_META_TYP_432: "Custom Curve Path Waypoint",
  T_48_META_TYP_432_I0: "Roll",
  T_48_META_TYP_432_I1: "Tangent",
  T_48_META_TYP_433: "Custom Curve Path Type",
  T_48_META_TYP_433_I0: "Linear",
  T_48_META_TYP_433_I1: "Smooth",
  T_48_META_TYP_433_I2: "Custom",
  T_48_META_TYP_434: "Custom Curve Path",
  T_48_META_TYP_434_I2: "Closed Loop",
  T_48_META_TYP_434_I3: "Waypoints",
  T_48_META_TYP_437_I5: "Score Type Names",
  T_48_META_TYP_437_I6: "Left Score Content",
  T_48_META_TYP_437_I7: "Right Score Content",
  T_48_META_TYP_438_I1: "Players",
  T_48_META_TYP_438_I2: "Ranks",
  T_48_META_TYP_438_I3: "Total Scores",
  T_48_META_TYP_438_I4: "Score Type Names",
  T_48_META_TYP_438_I5: "Colors",
  T_48_META_TYP_438_I6: "Scores",
  T_48_META_TYP_439: "Group",
  T_48_META_TYP_442_I1: "Left Score",
  T_48_META_TYP_442_I10: "Right Eliminated Icon",
  T_48_META_TYP_442_I2: "Right Score",
  T_48_META_TYP_442_I3: "Left Alive Number",
  T_48_META_TYP_442_I4: "Right Alive Number",
  T_48_META_TYP_442_I5: "Left Eliminated Number",
  T_48_META_TYP_442_I6: "Right Eliminated Number",
  T_48_META_TYP_442_I7: "Left Alive Icon",
  T_48_META_TYP_442_I8: "Right Alive Icon",
  T_48_META_TYP_442_I9: "Left Eliminated Icon",
  T_48_META_TYP_444: "Language Type",
  T_48_META_TYP_444_I0: "English",
  T_48_META_TYP_444_I1: "Simplified Chinese",
  T_48_META_TYP_444_I10: "French",
  T_48_META_TYP_444_I11: "German",
  T_48_META_TYP_444_I12: "Turkish",
  T_48_META_TYP_444_I13: "Hindi",
  T_48_META_TYP_444_I14: "Japanese",
  T_48_META_TYP_444_I15: "Romanian",
  T_48_META_TYP_444_I16: "Arabic",
  T_48_META_TYP_444_I17: "Burmese",
  T_48_META_TYP_444_I18: "Urdu",
  T_48_META_TYP_444_I19: "Bengali",
  T_48_META_TYP_444_I2: "Traditional Chinese",
  T_48_META_TYP_444_I3: "Thai",
  T_48_META_TYP_444_I4: "Vietnamese",
  T_48_META_TYP_444_I5: "Indonesian",
  T_48_META_TYP_444_I6: "Portuguese",
  T_48_META_TYP_444_I7: "Spanish",
  T_48_META_TYP_444_I8: "Russian",
  T_48_META_TYP_444_I9: "Korean",
  T_48_SD_ERROR_DIVISOR: "Divisor cannot be 0",
  T_48_SD_ERROR_KEY_NOTINMAP: "The specified key does not exist in map: {0}",
  T_48_SD_ERROR_LIST_OUTRANGE: "List index out of range: {0}",
  T_48_SD_SK_WARNING: "Did not found {1} in {0}",
  T_48_TYC_WS_WARNING_SERVER_DRIVEN_DISABLED: 'Since the attribute "IsServerDriven" of the Craftland character controller {0} is disabled, the related server API does not take effect.',
  T_48_XXJ_WS_PARENTERROR: "Failed to set parent",
  T_48_XXJ_WS_PERFORMANCE: "Performance",
  T_48_XXJ_WS_TANGENT: "Tangent",
  T_48_XXJ_WS_WAYPOINT: "Waypoint",
  T_48_XYL_UGC_COMPOSITEOJBECTLIST: "List of objects",
  T_48_XYL_UGC_CUSTOMIZEMINIMAP: "Use Custom Minimap",
  T_48_XYL_UGC_HIDEMINIMAP: "Hide Minimap HUD",
  T_48_XYL_WS_BASICCUSTOMSURFACE: "Basic Custom Surface",
  T_48_XYL_WS_BASICCYLINDERCUTOUT: "Cylinder Cutout",
  T_48_XYL_WS_BASICHEMISPHERE: "Basic Hemisphere",
  T_48_XYL_WS_BASICQUARTERROUNDEDTORUS: "Quarter Torus",
  T_48_XYL_WS_BASICQUARTERTORUS: "Quarter Square Torus",
  T_48_XYL_WS_BASICROUNDEDTORUS: "Torus",
  T_48_XYL_WS_BASICTRIANGLE: "Triangle Surface",
  T_48_XYL_WS_MAPPLAYERSTIPS: "Match players = Number of teams x Number of players per team. The more match players, the longer the matchmaking time",
  T_48_XYL_WS_MAPPLAYERSWARNING: "A high number of match players may lead to longer matchmaking time",
  T_49_HL_CL_CREATOR_LABEL2: "Craftland Community Talent",
  T_49_HL_CL_MAPS_LABEL2: "Map Winner",
  T_49_HL_CL_MAPS_LABEL3: "Gameplay Winner",
  T_49_HX_T_TUNG: "Tung Tung Tung",
  T_49_HZY_CONTROLLER_TRAJECTORY: "Trajectory",
  T_49_JH_WS_SKILLKASSIE: "Electro Therapy (Kassie)",
  T_49_JH_WS_SKILLKODA: "Aurora Vision (Koda)",
  T_49_JH_WS_SKILLOSCAR: "Valiant Dash (Oscar)",
  T_49_LXW_EIGHTHB_EDIT_AITRAIN_ENTRANCE: "Generate with AI",
  T_49_META_API_10065: "Switch Custom Camera",
  T_49_META_API_10067: "Get Current Custom Camera",
  T_49_META_API_10069: "Create Custom Camera",
  T_49_META_API_10070: "Set Custom Camera Culling Mask",
  T_49_META_API_10070_D: "Set the culling mask of the target camera to control visibility across all layers",
  T_49_META_API_10071: "Get Custom Camera Culling Mask",
  T_49_META_API_10071_D: "Get the culling mask of the target camera",
  T_49_META_API_10072: "Set Custom Camera Culling Mask Layer",
  T_49_META_API_10072_D: "Set the visibility of the target camera for a specific layer",
  T_49_META_API_10073: "Capture Screenshot",
  T_49_META_API_10073_D: "Capture screenshot (for internal testing)",
  T_49_META_API_106: "Get Server Timestamp (ms)",
  T_49_META_API_106_D: "Get the server timestamp with millisecond precision",
  T_49_META_API_107: "Timestamp to Localized String (ms)",
  T_49_META_API_107_D: "Convert timestamps (in ms) into strings based on certain formats",
  T_49_META_API_107_P0: "Timestamp (ms)",
  T_49_META_API_107_P0_D: "A timestamp in millisecond",
  T_49_META_API_108: "Lerp Vector3",
  T_49_META_API_108_D: "Perform linear interpolation from the 3D vector A to vector B",
  T_49_META_API_1089_P2: "Request ID",
  T_49_META_API_109: "Update Context to Persona",
  T_49_META_API_109_D: "Update the model context of a specified persona in the current room and overwrite the original context after execution.The context will influence the persona's interpretation of the background, history, or certain parameters for the current dialogue.",
  T_49_META_API_109_P1: "Context",
  T_49_META_API_109_P1_D: "Details of the context",
  T_49_META_API_110: "Feedback on Persona Response",
  T_49_META_API_110_D: "Submit feedback on the response content of a persona, which will be used to optimize our model.",
  T_49_META_API_110_P1: "Is Liked",
  T_49_META_API_110_P1_D: "Whether the response is liked or not. True = like.",
  T_49_META_API_1109: "Set Local Player Position",
  T_49_META_API_1109_D: "When the player is using classic game characters, this API can set the player's position.",
  T_49_META_API_1109_P0_D: "The target position",
  T_49_META_API_111: "Slerp Vector3",
  T_49_META_API_111_D: "Perform spherical interpolation from the 3D vector A to vector B for smooth rotation",
  T_49_META_API_1110: "Set Local Player Forward",
  T_49_META_API_1110_D: "When the player is using classic game characters, this API can set the direction the player is facing.",
  T_49_META_API_1110_P0_D: "The forward vector",
  T_49_META_API_112: "Roll Back Persona Memory",
  T_49_META_API_112_D: "Roll back the memory of a persona to before the specific response ID. All memory of the dialogues including and after the response will be cleared.",
  T_49_META_API_113: "Play One-Shot Sound",
  T_49_META_API_113_D: "Play a one-shot sound effect with adjustable volume",
  T_49_META_API_113_P0_D: "The sound effect resource ID to be played",
  T_49_META_API_113_P1: "Volume",
  T_49_META_API_113_P1_D: "The playback volume for the sound effect, ranging from 0 to 1.",
  T_49_META_API_97: "Create Skeleton Part Look-at Controller",
  T_49_META_API_97_D: "After creating a skeleton part look-at controller entity, you can use this entity to control the specified skeleton part and make it always face a specific target.",
  T_49_META_API_97_P0_D: "The skeleton part look-at controller entity. If the entity is destroyed, the look-at functionality will cease.",
  T_49_META_API_97_P1_D: "The skeleton part that is being controlled",
  T_49_META_API_97_P2_D: "The target that is being looked at",
  T_49_META_API_98: "Projection",
  T_49_META_API_98_D: "Calculate the projection of vector A onto vector B",
  T_49_META_API_99: "Get Local Timestamp (ms)",
  T_49_META_API_99_D: "Get the local timestamp with millisecond precision",
  T_49_META_EVT_16_P1_D: "Starting from 0, each outgoing request will consume a sequential numeric ID, such as for creating a room and clearing memory.",
  T_49_META_EVT_16_P2: "Response ID",
  T_49_META_EVT_16_P2_D: "Each complete response will have a unique ID",
  T_49_META_TYP_122_I19: "Custom Material",
  T_49_META_TYP_122_I19_D: "Allow for replacing the skybox with a custom material",
  T_49_META_TYP_14_I78_D: "Get or set the camera entity that is currently rendering the scene on the player's client. Note: The camera entity essentially represents the configuration data for controlling the client-side camera.",
  T_49_META_TYP_335_I9: "Elapsed Time (ms)",
  T_49_META_TYP_335_I9_D: "The playback duration of the sound effect in milliseconds. This property can only be accessed on the client side.",
  T_49_META_TYP_409_I13: "LLM_OK",
  T_49_META_TYP_409_I13_D: "LLM_OK",
  T_49_META_TYP_409_I14: "LLM_Failed",
  T_49_META_TYP_409_I14_D: "LLM_Failed",
  T_49_META_TYP_409_I15: "LLM_Timeout",
  T_49_META_TYP_409_I15_D: "LLM_Timeout",
  T_49_META_TYP_409_I16: "LLM_Invalid_Persona",
  T_49_META_TYP_409_I16_D: "LLM_Invalid_PersonaOrRoom",
  T_49_META_TYP_409_I17: "LLM_Token_Limit",
  T_49_META_TYP_409_I17_D: "LLM_Token_Limit",
  T_49_META_TYP_409_I18: "LLM_Violation",
  T_49_META_TYP_409_I18_D: "LLM_Frequent_Request",
  T_49_META_TYP_409_I19: "LLM_Frequent_Request",
  T_49_META_TYP_409_I19_D: "LLM_Frequent_Request",
  T_49_META_TYP_441: "Performance ID",
  T_49_META_TYP_445: "Playable Controller ID",
  T_49_META_TYP_446: "Playable Controller Attachable",
  T_49_META_TYP_446_I0: "Playable Controller",
  T_49_META_TYP_447: "Skeleton Part Controller",
  T_49_META_TYP_448: "Skeleton Part Look-at Controller",
  T_49_META_TYP_448_I0: "Controlled Target",
  T_49_META_TYP_448_I1: "Look-at Target",
  T_49_META_TYP_449: "Custom Camera",
  T_49_META_TYP_449_I2: "Orthographic Size",
  T_49_META_TYP_449_I2_D: "Control the size of the area visible to the camera",
  T_49_META_TYP_450: "Timestamp Localized String (ms)",
  T_49_META_TYPE_449_D: "A custom camera is fully controlled by the developer and determines what the player sees during gameplay",
  T_49_META_TYPE_450_D: "Format a millisecond-level timestamp into a readable text format",
  T_49_SD_SEARCH_ICONDESC: "Smart Association",
  T_49_SD_SEARCHKEY_ACTION: "Action",
  T_49_SD_SEARCHKEY_ANICLIPID: "Animation clip ID",
  T_49_SD_SEARCHKEY_AS: "As",
  T_49_SD_SEARCHKEY_ATTACHMENTENUM: "Attachment ID",
  T_49_SD_SEARCHKEY_AUDIOENUM: "Sound effect type",
  T_49_SD_SEARCHKEY_BAGSKINID: "Backpack skin ID",
  T_49_SD_SEARCHKEY_BEZIER: "Bezier curve",
  T_49_SD_SEARCHKEY_BOOL: "Boolean",
  T_49_SD_SEARCHKEY_BREAK: "Break",
  T_49_SD_SEARCHKEY_BTREEID: "Behavior Tree ID",
  T_49_SD_SEARCHKEY_BUTTONCLICK: "On button clicked",
  T_49_SD_SEARCHKEY_BUTTONDOUBLECLICK: "On button double clicked",
  T_49_SD_SEARCHKEY_BUTTONPRESS: "On Button pressed",
  T_49_SD_SEARCHKEY_BUTTONRELEASE: "On button release",
  T_49_SD_SEARCHKEY_CLOTHENUM: "Outfit type",
  T_49_SD_SEARCHKEY_COLOR: "Color",
  T_49_SD_SEARCHKEY_COMMENT: "Comment note",
  T_49_SD_SEARCHKEY_COMPARER: "= > < ≠",
  T_49_SD_SEARCHKEY_COMPONENTENUM: "Component enum",
  T_49_SD_SEARCHKEY_CONCANT: "Connect",
  T_49_SD_SEARCHKEY_CONTINUE: "Continue",
  T_49_SD_SEARCHKEY_CUSTOMHUD: "Custom HUD",
  T_49_SD_SEARCHKEY_CUSTOMHUDWIDGET: "Custom hud widget",
  T_49_SD_SEARCHKEY_DYNAMICITEMENUM: "dynamic create level object type",
  T_49_SD_SEARCHKEY_E: "E",
  T_49_SD_SEARCHKEY_EFFECTENUM: "Visual effects type",
  T_49_SD_SEARCHKEY_ENTITY: "Select scene object",
  T_49_SD_SEARCHKEY_FLOAT: "Float",
  T_49_SD_SEARCHKEY_FOR: "For index",
  T_49_SD_SEARCHKEY_FOREACH: "For each",
  T_49_SD_SEARCHKEY_FUNCTION: "Function",
  T_49_SD_SEARCHKEY_GETCSV: "Get CSV",
  T_49_SD_SEARCHKEY_GETREGISTERED: "Get registered asset by key",
  T_49_SD_SEARCHKEY_GETVALUE: "Get property value",
  T_49_SD_SEARCHKEY_GLOBALVARGET: "Get global variable",
  T_49_SD_SEARCHKEY_GLOBALVARSET: "Set Global Variable",
  T_49_SD_SEARCHKEY_IF: "If",
  T_49_SD_SEARCHKEY_IFELSE: "If else",
  T_49_SD_SEARCHKEY_IMGENUM: "Sprite Type",
  T_49_SD_SEARCHKEY_INT: "Integer",
  T_49_SD_SEARCHKEY_INTERNALHUD: "HUD type",
  T_49_SD_SEARCHKEY_ITEMENUM: "Item Type",
  T_49_SD_SEARCHKEY_LISTAPPEND: "List append",
  T_49_SD_SEARCHKEY_LISTAPPENDRANGE: "List append range",
  T_49_SD_SEARCHKEY_LISTCLEAR: "List clear",
  T_49_SD_SEARCHKEY_LISTCLONE: "List clone",
  T_49_SD_SEARCHKEY_LISTCONTAIN: "List contain",
  T_49_SD_SEARCHKEY_LISTCREATE: "List create",
  T_49_SD_SEARCHKEY_LISTDELETE: "Delete List",
  T_49_SD_SEARCHKEY_LISTGET: "Get list",
  T_49_SD_SEARCHKEY_LISTINDEXOF: "List index of",
  T_49_SD_SEARCHKEY_LISTINSERT: "List insert",
  T_49_SD_SEARCHKEY_LISTLASTINDEXOF: "List last index of",
  T_49_SD_SEARCHKEY_LISTLENGTH: "List length",
  T_49_SD_SEARCHKEY_LISTREVERSE: "List reverse",
  T_49_SD_SEARCHKEY_LISTSET: "Set list",
  T_49_SD_SEARCHKEY_LISTSHUFFLE: "List shuffle",
  T_49_SD_SEARCHKEY_LOCALKEY: "Localized key",
  T_49_SD_SEARCHKEY_LOCALVAR: "Local variable",
  T_49_SD_SEARCHKEY_LOGICAL: "And or",
  T_49_SD_SEARCHKEY_LOGINFO: "Log info print",
  T_49_SD_SEARCHKEY_MAPALLKEYS: "dict get all keys map get all keys",
  T_49_SD_SEARCHKEY_MAPCLEAR: "clear dict clear map",
  T_49_SD_SEARCHKEY_MAPCONTAIN: "dict contain key map contain key",
  T_49_SD_SEARCHKEY_MAPCREATE: "create dict create map",
  T_49_SD_SEARCHKEY_MAPGET: "get dict value by key get map value by key",
  T_49_SD_SEARCHKEY_MAPLENGTH: "dict length map length",
  T_49_SD_SEARCHKEY_MAPREMOVE: "remove dict remove map",
  T_49_SD_SEARCHKEY_MAPSET: "set dict value set map value",
  T_49_SD_SEARCHKEY_MATH: "add subtract multiply divide",
  T_49_SD_SEARCHKEY_NEWLIST: "New list",
  T_49_SD_SEARCHKEY_NULL: "Null",
  T_49_SD_SEARCHKEY_NUMTOSTRING: "Number to string",
  T_49_SD_SEARCHKEY_PARTICLESENUM: "Particles properties",
  T_49_SD_SEARCHKEY_PERSONA: "Persona",
  T_49_SD_SEARCHKEY_PI: "PI",
  T_49_SD_SEARCHKEY_PLAYERDATAID: "Player Data ID",
  T_49_SD_SEARCHKEY_PLAYERSKILLENUM: "Character skill type",
  T_49_SD_SEARCHKEY_PREEFFECT: "Special sticker type",
  T_49_SD_SEARCHKEY_PREFAB: "Prefab",
  T_49_SD_SEARCHKEY_RAWID: "Raw ID",
  T_49_SD_SEARCHKEY_READSTATIS: "Read accumulated data",
  T_49_SD_SEARCHKEY_RESOURCEENUM: "Resource uuid",
  T_49_SD_SEARCHKEY_RETURN: "Return",
  T_49_SD_SEARCHKEY_SCENEENUM: "Scene file",
  T_49_SD_SEARCHKEY_SCRIPTID: "Script",
  T_49_SD_SEARCHKEY_SETVALUE: "Set property value",
  T_49_SD_SEARCHKEY_SPECIALITEMENUM: "Special item ID type",
  T_49_SD_SEARCHKEY_TEXT: "Text",
  T_49_SD_SEARCHKEY_TEXTUREID: "Texture type",
  T_49_SD_SEARCHKEY_THISENTITY: "This Entity",
  T_49_SD_SEARCHKEY_TIMELINE: "Timeline",
  T_49_SD_SEARCHKEY_TYPEENUM: "Any type",
  T_49_SD_SEARCHKEY_V2VCREATE: "Create Vector2",
  T_49_SD_SEARCHKEY_V2VGET: "Get Vector2 components",
  T_49_SD_SEARCHKEY_V2VOPERATION: "Vector2 operation add subtract multiply dot product  distance angle",
  T_49_SD_SEARCHKEY_V2VSET: "Set Vector2 components",
  T_49_SD_SEARCHKEY_V3VCREATE: "Create Vector3",
  T_49_SD_SEARCHKEY_V3VGET: "Get Vector3 components",
  T_49_SD_SEARCHKEY_V3VOPERATION: "Vector3 operation add subtract multiply dot product cross product distance angle",
  T_49_SD_SEARCHKEY_V3VSET: "Set Vector3 components",
  T_49_SD_SEARCHKEY_VEHICLEENUM: "Vehicle skin ID",
  T_49_SD_SEARCHKEY_WEAPONSKINENUM: "Weapon Skin ID",
  T_49_SD_SEARCHKEY_WHILE: "While",
  T_49_SD_SEARCHKEY_WRITESTATIS: "Write accumulated database offset",
  T_49_SD_SEARCHKEY_WRITESTATISCROSS: "Write accumulated database offset by map code",
  T_49_XXJ_WS_DURATIONS: "Duration (s)",
  T_49_XXJ_WS_EDITPERFORMANCE: "Edit Performance",
  T_49_XXJ_WS_PERFORMANCE: "Performance",
  T_49_XXJ_WS_PERFORMANCE_DELETE: "Delete Performance",
  T_49_XXJ_WS_PERFORMANCE_DELETECONFIRM: "Deleted performance cannot be restored, continue?",
  T_49_XXJ_WS_PERFORMANCE_EDITING: "Editing {0}",
  T_49_XXJ_WS_PERFORMANCE_NAME_EXCEPTION: "This name has already been used, please change it and try again",
  T_49_XXJ_WS_PERFORMANCENAME: "Performance Name",
  T_49_XXJ_WS_TIMELINE_ADD_KEYFRAME: "Add Key Frame",
  T_49_XXJ_WS_TIMELINE_ADD_SUB_TRACK: "Add Sub-Track",
  T_49_XXJ_WS_TIMELINE_ADD_TRACK: "Add Track",
  T_49_XXJ_WS_TIMELINE_DEL_TRACK: "Delete Track",
  T_49_XXJ_WS_TIMELINE_ENTITY_TRACK: "Actor Track",
  T_49_XXJ_WS_TIMELINE_EVENT_TRACK: "Event Track",
  T_49_XXJ_WS_TIMELINE_EXISTED_KEYFRAME: "Key Frame already exists",
  T_49_XXJ_WS_TIMELINE_EXISTED_TRACK: "The corresponding actor track already exists",
  T_49_XXJ_WS_TIMELINE_FRAME_SETTING: "Content",
  T_49_XXJ_WS_TIMELINE_NAME_EXCEPTION: "Duplicate track names detected. Please change them and try again.",
  T_49_XXJ_WS_TIMELINE_OPEN_RECORD: "Please start recording or choose a key frame first",
  T_49_XXJ_WS_TIMELINE_RECORDING: "Recording...",
  T_49_XXJ_WS_TIMELINE_REMOVE_KEYFRAME: "Delete Key Frame",
  T_49_XXJ_WS_TIMELINE_SCENE_EDIT_MODE: "Scene View",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP: "Select an object to create a track or tap the add-track button directly",
  T_49_XXJ_WS_TIMELINE_SELECT_OBJECT_TIP_1: "Tap the add-track button to create a new track",
  T_49_XXJ_WS_TIMELINE_SUB_TRACK_TITLE: "Sub-Track",
  T_49_XXJ_WS_TIMELINE_TRACK: "Track",
  T_49_XXJ_WS_TIMELINE_TRACK_EDIT_MODE: "Track View",
  T_49_XYL_WS_DAILYPROPS: "Basic",
  T_49_XYL_WS_STOREGAMPLAY: "Gameplay",
  T_49_YU_QCITEM_ALL_11: "Tung Tung Tung Sahur!",
  T_50_H_M4A1_VA_N: "M4A1 - Trouble Academy",
  T_50_H_MACHETE_VA_N: "Parang - Trouble Academy",
  T_50_HJ_LEADERBOARD_SETTING_HEADER: "Leaderboard Fields",
  T_50_HJ_OVERFLOW_RESIZEFREELY: "Overflow",
  T_50_HJ_OVERFLOW_RESIZEHEIGHT: "Wrap around",
  T_50_HJ_OVERFLOW_SHRINKCONTENT: "Shrink font",
  T_50_HJ_SEARCHKEY_TUPLECREATE: "Create Tuple",
  T_50_HJ_SEARCHKEY_TUPLEGET: "Get Tuple",
  T_50_HJ_SEARCHKEY_TUPLESET: "Set Tuple",
  T_50_HJ_TEXTOBGJ_H: "Height",
  T_50_HJ_TEXTOBGJ_OVERFLOW: "Overflow Options",
  T_50_HJ_TEXTOBGJ_W: "Width",
  T_50_HZY_REVIEW_TEXTOBJ: "Text object content",
  T_50_JH_WS_HIDEMAPERROR: "Cannot hide minimap without a custom cover image",
  T_50_JH_WS_HIDEMAPTIP: "When minimap is hidden, it will no longer be used as the cover image",
  T_50_JH_WS_HIDEMINIMAP: "Hide Minimap",
  T_50_META_API_10073_P0: "File Name",
  T_50_META_API_10073_P0_D: "The file name",
  T_50_META_API_10073_P1_D: "The result of the execution. Check the Status Code enum.",
  T_50_META_API_1102: "Read Database Sheet Column Value",
  T_50_META_API_1102_D: "Read the value of a specific column for a given key from a standard database table",
  T_50_META_API_1102_P3: "Column Index",
  T_50_META_API_1102_P3_D: "The column index of the database table (0 = the first column)",
  T_50_META_API_1106: "Create Performance",
  T_50_META_API_1106_D: "Create a performance entity",
  T_50_META_API_1106_P0_D: "The performance asset",
  T_50_META_API_1111: "Read Database Leaderboard Association Value",
  T_50_META_API_1111_D: "Read the combination of values from a leaderboard table and its associated table in the database",
  T_50_META_API_1111_P5: "Association Status Code",
  T_50_META_API_1111_P5_D: "Association Error Code",
  T_50_META_API_1112: "Read Database Leaderboard Association Values by Range",
  T_50_META_API_1112_D: "Read values from the leaderboard table within a specified rank range, read the corresponding values by retrieved keys from the associated table, and combine them.",
  T_50_META_API_1112_P6: "Association Status Code",
  T_50_META_API_1112_P6_D: "Association Error Code",
  T_50_META_API_1113: "Write Database Leaderboard Association Value",
  T_50_META_API_1113_D: "Write the value for a given key into the leaderboard table and its related table in the database",
  T_50_META_API_1113_P5: "Association Status Code",
  T_50_META_API_1113_P5_D: "Association Error Code",
  T_50_META_API_114_D: "Create custom UI",
  T_50_META_API_114_P0_D: "The code is used as the parameter name for creating a UI entity, and its corresponding local variable value represents the created UI entity.",
  T_50_META_API_114_P1_D: "The player entity it belongs to, only visible to the player.",
  T_50_META_API_114_P2: "UI Asset ID",
  T_50_META_API_114_P2_D: "The custom UI asset ID",
  T_50_META_API_115_D: "Create the specified custom UI",
  T_50_META_API_116: "Set Level Object Highlight",
  T_50_META_API_116_D: "Set the highlight status of the object. It may be affected by other in-game logics.",
  T_50_META_API_116_P0_D: "Target Object",
  T_50_META_API_116_P1_D: "Highlight status",
  T_50_META_API_117: "Bitwise Common",
  T_50_META_API_117_D: "Bitwise and/or/xor/left shift/right shift",
  T_50_META_API_117_P0_D: "Left value",
  T_50_META_API_117_P1_D: "Right value",
  T_50_META_API_117_P2_D: "Operation Type",
  T_50_META_API_118: "Bitwise Not",
  T_50_META_API_118_D: "Bitwise NOT, also known as bitwise complement.",
  T_50_META_API_118_P0_D: "Value",
  T_50_META_API_119: "Bitwise List to Int",
  T_50_META_API_119_D: "Perform bitwise OR operation on all list elements and transform the output to an integer value.",
  T_50_META_API_119_P0: "Bit Array",
  T_50_META_API_119_P0_D: "Bitwise array",
  T_50_META_API_120: "Bitwise Int to List",
  T_50_META_API_120_D: "Covert the decimal values represented by bits at position 1 of an integer in its binary form to a list",
  T_50_META_API_120_P0_D: "Integer",
  T_50_META_API_121: "Quaternion Angle",
  T_50_META_API_121_D: "Calculate the angle between two quaternions",
  T_50_META_API_121_P0_D: "Quaternion 1",
  T_50_META_API_121_P1_D: "Quaternion 2",
  T_50_META_API_122: "Quaternion Dot",
  T_50_META_API_122_D: "Calculate the dot product of two quaternions",
  T_50_META_API_123: "Quaternion Inverse",
  T_50_META_API_123_D: "Calculate the inverse of a quaternion",
  T_50_META_API_123_P0_D: "Quaternion",
  T_50_META_API_124: "Quaternion From To Rotation",
  T_50_META_API_124_D: 'Calculate rotation quaternion from "from" to "to"',
  T_50_META_API_124_P0_D: "The start point",
  T_50_META_API_124_P1_D: "The end point",
  T_50_META_API_125: "Quaternion Rotate Towards",
  T_50_META_API_125_D: 'Calculate the rotation quaternion from "from" to "to". Max Degrees Delta is the max. rotation angle.',
  T_50_META_API_125_P0: "From",
  T_50_META_API_125_P0_D: "Initial quaternion",
  T_50_META_API_125_P1: "To",
  T_50_META_API_125_P1_D: "The target quaternion",
  T_50_META_API_125_P2: "Max. Degree Delta",
  T_50_META_API_125_P2_D: "The max. rotation angle",
  T_50_META_API_126: "Get Gyroscope Orientation",
  T_50_META_API_126_D: "Device orientation in 3D space, representing rotation angles around the three axes.",
  T_50_META_API_127: "Get Gyroscope Gravity",
  T_50_META_API_127_D: "The gravity component detected by the sensor on your device",
  T_50_META_API_128: "Get Gyroscope Rotation Rate",
  T_50_META_API_128_D: "This refers to the rotation rate of a device. It is a term related to the gyroscope sensors that describes the device's rotational movement speed in a three-dimensional space.",
  T_50_META_API_129: "Get Gyroscope Rotation Unbiased",
  T_50_META_API_129_D: "Describes the device's rotation rate and provides a more precise result by compensating for the noise or bias of the device's sensors.",
  T_50_META_API_130: "Get Gyroscope User Acceleration",
  T_50_META_API_130_D: "The part of the device's acceleration with the gravity component removed, which is the acceleration caused by user actions or external forces.",
  T_50_META_API_131: "Get Touch Info",
  T_50_META_API_131_D: "Get the specified index screen touch information (including position,  displacement, and change time).",
  T_50_META_API_131_P0_D: "Distribute touch point IDs, starting from 0",
  T_50_META_API_131_P1_D: "Touch position",
  T_50_META_API_131_P2: "Delta Position",
  T_50_META_API_131_P2_D: "The shift in position compared to the last frame",
  T_50_META_API_131_P3: "Delta Time",
  T_50_META_API_131_P3_D: "Time elapsed since last frame",
  T_50_META_API_132: "Get Screen Touch Count",
  T_50_META_API_132_D: "Get the current number of touch points on the screen",
  T_50_META_API_133: "Vibrate Device",
  T_50_META_API_133_D: "Make the device vibrate once",
  T_50_META_API_134_D: "Notify the target player device to play the audio",
  T_50_META_API_134_P0_D: "The target player",
  T_50_META_API_134_P1_D: "The audio asset",
  T_50_META_API_134_P2_D: "The playback speed (valid range: 0.1~3.0; 1 = normal, <1 = slow down, >1 = speed up)",
  T_50_META_API_135_D: "Play the one-time audio file",
  T_50_META_API_135_P0_D: "Audio resources",
  T_50_META_API_135_P1_D: "Play Speed",
  T_50_META_API_136: "Format String",
  T_50_META_API_136_D: "Format the strings",
  T_50_META_API_136_P0_D: "Formatted strings that use Go formatting verb controls",
  T_50_META_API_136_P1: "Parameters Array",
  T_50_META_API_136_P1_D: "Parameter List",
  T_50_META_API_137: "Paste Component",
  T_50_META_API_137_D: "Copy or add component data",
  T_50_META_API_137_P0: "Source",
  T_50_META_API_137_P0_D: "The source entity",
  T_50_META_API_137_P1_D: "Target Entity",
  T_50_META_API_137_P2: "Component Type",
  T_50_META_API_137_P2_D: "Component Type",
  T_50_META_API_137_P3: "Is Success",
  T_50_META_API_137_P3_D: "Whether it is successful or not",
  T_50_META_API_138: "Revive At Next Frame",
  T_50_META_API_138_D: "Revive at the next frame",
  T_50_META_API_139: "Eliminate at Next Frame",
  T_50_META_API_139_D: "Eliminate the battle entity at the next frame",
  T_50_META_API_139_P0_D: "The battle entity",
  T_50_META_API_140: "Quit Game at Next Frame",
  T_50_META_API_140_D: "Exit the game at the next frame",
  T_50_META_API_141: "Get Microphone Volume",
  T_50_META_API_141_D: "Get the microphone volume. Return the status when the player's microphone is off or no access is granted.",
  T_50_META_API_141_P0: "Volume",
  T_50_META_API_141_P0_D: "The microphone volume",
  T_50_META_API_141_P1_D: "Microphone is turned on or off",
  T_50_META_API_142: "Get Render Quality",
  T_50_META_API_142_D: "Get the current rendering quality (enum: Low/Medium/High/Ultra)",
  T_50_META_API_143: "Get Render Resolution",
  T_50_META_API_143_D: "Get the current render resolution",
  T_50_META_API_144: "Bind Custom Player",
  T_50_META_API_144_D: "Dynamically set the target that this player binds to that will override existing bindings. Returns false if failed.",
  T_50_META_API_144_P0: "Custom Player",
  T_50_META_API_144_P0_D: "After binding this Custom Player to the player, data such as position and direction will be automatically synced",
  T_50_META_API_144_P1_D: "Target Player",
  T_50_META_API_145: "Unbind Custom Player",
  T_50_META_API_145_D: "Cancel the binding. Returns false if failed.",
  T_50_META_API_145_P0: "Custom Player",
  T_50_META_API_145_P0_D: "Clear all bindings for this target. After unbinding, data such as position and direction will no longer be automcatically synced.",
  T_50_META_API_146_P0_D: "A custom player",
  T_50_META_API_147: "Set Custom Player State",
  T_50_META_API_147_D: "Automatically upload to the sever and sync with all clients. Returns false if failed.",
  T_50_META_API_147_P0: "Custom Player",
  T_50_META_API_147_P1: "State",
  T_50_META_API_147_P1_D: "Usually used to save the animation states. Get the synced state with Get Custom Player State.",
  T_50_META_API_148: "Get Custom Player State",
  T_50_META_API_148_D: "The state data is automatically synced to the server. Returns false if failed.",
  T_50_META_API_148_P0: "Custom Player",
  T_50_META_API_148_P1: "State",
  T_50_META_API_148_P1_D: "Set the state with Set Custom Player State",
  T_50_META_API_149: "Set Distance Volumes",
  T_50_META_API_149_D: "Set the distance ranges between players to dynamically set audio volume.",
  T_50_META_API_149_P0: "Distance List",
  T_50_META_API_149_P0_D: "A list of distance ranges, each corresponding to an element in the volume list.",
  T_50_META_API_149_P1: "Volume List",
  T_50_META_API_149_P1_D: "A list of volumes, each corresponding to an element in the distance list.",
  T_50_META_API_150: "Get Friends",
  T_50_META_API_150_D: "Get the list of the player's friend IDs",
  T_50_META_API_151: "Get Default UI Info",
  T_50_META_API_151_D: "Get the default UI location of the player",
  T_50_META_API_151_P0_D: "The default interface",
  T_50_META_API_151_P1_D: "Status",
  T_50_META_API_151_P2_D: "UI Position",
  T_50_META_API_151_P3: "Size",
  T_50_META_API_151_P3_D: "UI Size",
  T_50_META_API_152: "Broadcast Custom Event",
  T_50_META_API_152_D: "Broadcast a custom event for any entity to receive (listen to) this event",
  T_50_META_API_153: "Dispatch Event to Entity",
  T_50_META_API_153_D: "Send the custom event to the target entity",
  T_50_META_EVT_17: "On Screen Touch Begin",
  T_50_META_EVT_17_D: "Start the event when the screen is touched",
  T_50_META_EVT_17_P0: "Touch Index",
  T_50_META_EVT_17_P0_D: "Touch point index",
  T_50_META_EVT_17_P1_D: "Touch position",
  T_50_META_EVT_18: "On Screen Touch End",
  T_50_META_EVT_18_D: "End the event when the screen is touched",
  T_50_META_EVT_18_P0: "Touch Index",
  T_50_META_EVT_18_P0_D: "Touch point index",
  T_50_META_EVT_18_P1_D: "Touch positions on the screen",
  T_50_META_EVT_19: "On Receive Persona Create Room Result",
  T_50_META_EVT_19_D: "Receive the corresponding result when failed to create the persona chat room",
  T_50_META_EVT_19_P1: "Room ID",
  T_50_META_EVT_19_P1_D: "The room ID",
  T_50_META_EVT_20: "On User Quit or User Match End",
  T_50_META_EVT_20_D: "Trigger when the user quits the match or when the match ends",
  T_50_META_TYP_11_I44: "Distance Volumes",
  T_50_META_TYP_11_I44_D: "Dynamically adjust the audio volume based on the distance between players",
  T_50_META_TYP_22_I9_D: "The asset ID used to create the UI",
  T_50_META_TYP_244_I12_D: "The text box width",
  T_50_META_TYP_244_I13_D: "The text box height",
  T_50_META_TYP_244_I14_D: "The overflow type",
  T_50_META_TYP_335_I10_D: "The playback speed (valid value > 0, default = 1)",
  T_50_META_TYP_409_I20: "IO_Create_File_Failed",
  T_50_META_TYP_409_I20_D: "IO operation failed: an error occurred while creating the file.",
  T_50_META_TYP_409_I21: "IO_Invalid_File_Name",
  T_50_META_TYP_409_I21_D: "IO operation failed. Invalid file name.",
  T_50_META_TYP_448_I0_D: "The controlled skeleton part",
  T_50_META_TYP_448_I1_D: "The target that the skeleton part is looking at",
  T_50_META_TYP_451: "Overflow Type",
  T_50_META_TYP_451_D: "The method for handling text overflow",
  T_50_META_TYP_452: "Custom UI Asset ID",
  T_50_META_TYP_452_D: "The ID that describes the custom HUD asset",
  T_50_META_TYP_453: "Render Quality Type",
  T_50_META_TYP_453_D: "The rendering quality enum",
  T_50_META_TYPE_448_D: "This entity is used to control the skeleton part to look at a target",
  T_50_SD_WS_MAPTAG_AI3DGEN: "3D Object Generate Map",
  T_50_SD_WS_MAPTAG_AIRACING: "Racing AI Generate Map",
  T_50_XXJ_WS_ANIMATIONSTATENAME: "Animation state name enum",
  T_50_XXJ_WS_DISABLEFOOTSTEP: "Disable Footsteps Vibration",
  T_50_XXJ_WS_NOPERFORMANCE: "No performance file yet",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS: "Beta version",
  T_50_XXJ_WS_PERFORMANCE_BATETIPS_DESC: "Dear creators, the performance editor is still in the testing phase. It may contain bugs or lack essential features. Please use it with caution.",
  T_50_XXJ_WS_PERFORMANCE_NEW: "Add Performance",
  T_50_XXJ_WS_TIMELINE_ADD_KEYCLIP: "Add Key Clip",
  T_50_XXJ_WS_TIMELINE_ALONGPATH_TRACK: "Along Path Track",
  T_50_XXJ_WS_TIMELINE_ANIMATION_CLIP: "Animation",
  T_50_XXJ_WS_TIMELINE_ANIMATION_TRACK: "Animation Track",
  T_50_XXJ_WS_TIMELINE_AUDIO_TRACK: "Audio Track",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_HOLD: "Hold",
  T_50_XXJ_WS_TIMELINE_CLIP_LOOP_TYPE_LOOPFOREVER: "Loop Forever",
  T_50_XXJ_WS_TIMELINE_DURATION: "Duration: {0}s",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_AVATAR: "Mismatch between animation and model",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_CLIP_OVERLAP: "Key clip overlap",
  T_50_XXJ_WS_TIMELINE_ERROR_CODE_ENTITY_MISSING: "Bound entity missing",
  T_50_XXJ_WS_TIMELINE_NAME_EMPTY: "The track name cannot be empty",
  T_50_XXJ_WS_TIMELINE_NPC_TRACK: "NPC Track",
  T_50_XXJ_WS_TIMELINE_PROP_TRACK: "Property Track",
  T_50_XXJ_WS_TIMELINE_REMOVE_KEYCLIP: "Remove Key Clip",
  T_50_XXJ_WS_TIMELINE_TIME_SUFFIX: "{0}s",
  T_50_XXJ_WS_TIMELINE_TRACK_MAX_LIMIT: "Track count limit exceeded",
  T_50_XYL_WS_AIGETERATESHOW: "Building Blocks",
  T_50_YU_F_B_VA_WITCH: "Mystic Trouble (Bottom)",
  T_50_YU_F_H_VA_WITCH: "Mystic Trouble (Head)",
  T_50_YU_F_HA_VA_WITCH: "Mystic Trouble (Facepaint)",
  T_50_YU_F_S_VA_WITCH: "Mystic Trouble (Shoes)",
  T_50_YU_F_T_VA_WITCH: "Mystic Trouble (Top)",
  T_50_ZCS_CLCUSTOMEVE_CUSTOMEVENT: "Custom Event",
  T_51_GT_WS_BASIC: "Basic",
  T_51_GT_WS_GLOBALEVENT: "Global Event",
  T_51_GT_WS_PRIVATEEVENT: "Private Event",
  T_51_GT_WS_STORY: "Story",
  T_51_GT_WS_UI: "UI",
  T_51_JH_WS_MINTIP1: "",
  T_51_META_API_1114: "User Message To Persona Voice Response",
  T_51_META_API_1114_D: "Send persona user's message and get a voice response from persona",
  T_51_META_API_1114_P2_D: "If true, the voice response will automically play when received; else, an API is required to play it",
  T_51_META_API_1115: "System Message To Persona Voice Response",
  T_51_META_API_1115_D: "Send persona system message and get a voice response from persona",
  T_51_META_API_1116: "Play Stored Voice From Persona",
  T_51_META_API_1116_D: "Play stored voice reponses from persona. Can store up to 10 responses.",
  T_51_META_API_144_P2_D: "Whether the execution is successful",
  T_51_META_API_154: "Get Type Name",
  T_51_META_API_154_D: "Return the name of the target object's type",
  T_51_META_API_154_P0_D: "The target object to get type name for",
  T_51_META_API_155: "Get Bounding Box",
  T_51_META_API_155_D: "Get the Bounding Box of the scene object",
  T_51_META_API_155_P0_D: "The scene object to get the bounding box for",
  T_51_META_API_155_P1_D: "The center of the bounding box",
  T_51_META_API_155_P2: "Size",
  T_51_META_API_155_P2_D: "The size of the bounding box",
  T_51_META_API_156: "Create Entity",
  T_51_META_API_156_D: "Create an entity. You can specify an owner (a specific player client). In combination with the AddComponent API, you can synchronize data targeted to that particular client.",
  T_51_META_API_156_P0_D: "The target entity to be created",
  T_51_META_API_156_P1_D: "The type of the created custom component",
  T_51_META_API_156_P2_D: "The owner of the entity",
  T_51_META_API_156_P3: "Flag",
  T_51_META_API_156_P3_D: "Entity flag. See Entity Flag enum for more details. Can be used in combination.",
  T_51_META_API_157: "Set Material Property",
  T_51_META_API_157_D: "This API allows you to modify certain properties of an object's material.",
  T_51_META_API_157_P0_D: "The target object to get the material property for",
  T_51_META_API_157_P1: "Property Name",
  T_51_META_API_157_P1_D: "Set the name of the property",
  T_51_META_API_157_P2: "Property Value",
  T_51_META_API_157_P2_D: "Set the value of the property",
  T_51_META_API_157_P3: "Success",
  T_51_META_API_157_P3_D: "Set whether it's successful or not",
  T_51_META_API_158: "Clear Material Property",
  T_51_META_API_158_D: "Clear the set properties",
  T_51_META_API_158_P0_D: "The target object to clear the material property for",
  T_51_META_EVT_21: "On Custom Property Change",
  T_51_META_EVT_21_D: "When a monitored custom property changes, this event will trigger. Note: if a custom property is modified multiple times within a single frame, this event is only triggered once. When the server modifies a custom property, the event is sent to both endpoints; when a client modifies a local entity's custom property, the event is only delivered locally.",
  T_51_META_EVT_21_P0: "Property Index",
  T_51_META_EVT_21_P0_D: "The property's index",
  T_51_META_EVT_21_P1_D: "The property's new value",
  T_51_META_EVT_22: "On Custom Player State Changed",
  T_51_META_EVT_22_D: "This event will trigger when the state of the custom player changes",
  T_51_META_EVT_22_P0: "Custom Player State",
  T_51_META_EVT_22_P0_D: "The state of the custom player",
  T_51_META_EVT_23: "On Receive Voice Response From Persona",
  T_51_META_EVT_23_D: "Trigger this event when persona's voice response is received",
  T_51_META_EVT_24: "On Play Voice Finish From Persona",
  T_51_META_EVT_24_D: "Trigger this event when persona's voice response has finished playing",
  T_51_META_TYP_14_I79: "Bound Custom Player",
  T_51_META_TYP_14_I79_D: "When bound to a Custom Player, the classic character model is hidden, and the target object's position, rotation (facing), and other data are synchronized to it.",
  T_51_META_TYP_15_I6: "Is Show Teammate Name",
  T_51_META_TYP_15_I6_D: "Whether to show teammates' names on the top of their heads",
  T_51_META_TYP_247_I31: "Help Up",
  T_51_META_TYP_247_I31_D: "Help Up",
  T_51_META_TYP_247_I32: "Give Up",
  T_51_META_TYP_247_I32_D: "Give Up",
  T_51_META_TYP_247_I33: "Attack 2",
  T_51_META_TYP_247_I33_D: "Attack 2",
  T_51_META_TYP_247_I34: "Combine Weapon",
  T_51_META_TYP_247_I34_D: "Combine Weapon",
  T_51_META_TYP_247_I35: "Surfboard",
  T_51_META_TYP_247_I35_D: "Surfboard",
  T_51_META_TYP_313_I2_D: "Out-of-zone damage per second",
  T_51_META_TYP_409_I22: "Parameter Error",
  T_51_META_TYP_409_I22_D: "Parameter error",
  T_51_META_TYP_440_I1_D: "Performance asset ID",
  T_51_META_TYP_454: "Material Property",
  T_51_META_TYP_454_D: "Use to set the material property for an object",
  T_51_META_TYP_455: "Entity Flag",
  T_51_META_TYP_455_D: "The property flag for a specific entity, can be used in combination",
  T_51_META_TYP_455_I0_D: "Default property",
  T_51_META_TYP_455_I1: "Static",
  T_51_META_TYP_455_I1_D: "Static entity",
  T_51_META_TYP_455_I2: "Local",
  T_51_META_TYP_455_I2_D: "Localy entity",
  T_51_META_TYP_455_I3: "Render Only",
  T_51_META_TYP_455_I3_D: "Render only",
  T_51_MX_WS_ACTION_BITE: "Crispy Bite",
  T_51_MX_WS_ACTION_BOUNCE: "",
  T_51_MX_WS_ACTION_DOOR_CREAK: "",
  T_51_MX_WS_ACTION_FALL_HIT: "Ground Slam",
  T_51_MX_WS_ACTION_GULP: "",
  T_51_MX_WS_ACTION_RUNAWAY_DUST: "",
  T_51_MX_WS_ACTION_RUNNING_STEPS: "",
  T_51_MX_WS_ACTION_SPIN_LOOP: "",
  T_51_MX_WS_ACTION_STOMACH_GROWL: "Stomach Growling",
  T_51_MX_WS_AMBIENT_BIRDS: "Bird Chirping",
  T_51_MX_WS_AMBIENT_CAFE_AMBIENCE: "Cafe Atmosphere",
  T_51_MX_WS_AMBIENT_CLASSROOM_OFFICE: "Classroom Ambience",
  T_51_MX_WS_AMBIENT_NIGHT_CRICKETS: "",
  T_51_MX_WS_AMBIENT_RAIN: "Raining",
  T_51_MX_WS_AMBIENT_STREET_TRAFFIC: "Street Traffic",
  T_51_MX_WS_AMBIENT_WAVES: "",
  T_51_MX_WS_ATMOSPHERE_APPLAUSE_LAUGH: "",
  T_51_MX_WS_ATMOSPHERE_BASS_DRUM: "",
  T_51_MX_WS_ATMOSPHERE_BELL: "Bell Ringing",
  T_51_MX_WS_ATMOSPHERE_JINGLE: "Bell Jingling",
  T_51_MX_WS_ATMOSPHERE_WIND: "Howling Wind",
  T_51_MX_WS_COMEDY_AIR_WHIP: "",
  T_51_MX_WS_COMEDY_CAMERA_CLICK: "Camera Click",
  T_51_MX_WS_COMEDY_FAIL_WAHWAH: "",
  T_51_MX_WS_COMEDY_FART: "Funny Fart",
  T_51_MX_WS_COMEDY_FUNNY_LAUGH: "Laughter",
  T_51_MX_WS_COMEDY_HEAD_SLAP: "",
  T_51_MX_WS_COMEDY_IDEA_DING: "",
  T_51_MX_WS_COMEDY_RECORD_SCRATCH: "",
  T_51_MX_WS_COMEDY_VICTORY_DING: "",
  T_51_MX_WS_EMOTION_AWKWARD: "",
  T_51_MX_WS_EMOTION_BLINK_SWITCH: "",
  T_51_MX_WS_EMOTION_CONFIDENT_VICTORY: "",
  T_51_MX_WS_EMOTION_CONFUSED: "",
  T_51_MX_WS_EMOTION_HAPPY_NOTIFICATION: "",
  T_51_MX_WS_EMOTION_HEARTBEAT_LOVE: "Heart Beating",
  T_51_MX_WS_EMOTION_PHONE_VIBRATION: "",
  T_51_MX_WS_EMOTION_SIGH_SAD: "Sigh",
  T_51_MX_WS_EMOTION_SNORT: "",
  T_51_MX_WS_EMOTION_SPARKLE: "",
  T_51_MX_WS_EMOTION_SURPRISE_SHOCK: "",
  T_51_MX_WS_EMOTION_TEETH_CHATTER: "Teeth Chattering",
  T_51_MX_WS_FANTASY_MAGIC_CAST: "",
  T_51_MX_WS_FANTASY_TRANSFORM: "",
  T_51_MX_WS_FX_EXPLOSION: "Explosion Impace",
  T_51_MX_WS_FX_FIRE_BURN: "Crackling Flames",
  T_51_MX_WS_FX_ICE_CRACK: "",
  T_51_MX_WS_FX_LIGHTNING: "Lightning",
  T_51_MX_WS_FX_SPLASH: "Splash",
  T_51_MX_WS_MECHANIC_BOX_OPEN: "Unboxing",
  T_51_MX_WS_MECHANIC_GEAR_SPIN: "Gear Rotating",
  T_51_MX_WS_MECHANIC_LOCK_UNLOCK: "",
  T_51_MX_WS_MECHANIC_OPEN_CLOSE: "",
  T_51_MX_WS_MECHANIC_POURING: "",
  T_51_MX_WS_RHYTHM_BREAK_BEAT: "",
  T_51_MX_WS_RHYTHM_CLAP: "Clapping",
  T_51_MX_WS_RHYTHM_DRUM_BEAT: "",
  T_51_MX_WS_SOUNDTYPE_INTERACTION: "",
  T_51_MX_WS_TRANSITION_GLITCH: "",
  T_51_MX_WS_TRANSITION_POPUP: "Window Pop-up",
  T_51_MX_WS_TRANSITION_REVERSE_SUCTION: "",
  T_51_MX_WS_TRANSITION_WHOOSH: "",
  T_51_MX_WS_TRANSPORT_AIRCRAFT: "",
  T_51_MX_WS_TRANSPORT_BIKE_SKATE: "",
  T_51_MX_WS_TRANSPORT_CAR_DRIVE: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_HIGHDECEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOOP: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWACCEL: "",
  T_51_MX_WS_TRANSPORT_CAR_ENGINE_LOWDECEL: "",
  T_51_MX_WS_TRANSPORT_STREAM_FLOW: "Rushing Water",
  T_51_MX_WS_TRANSPORT_TRAIN_BEEP: "",
  T_51_MX_WS_UI_ACHIEVEMENT_UNLOCK: "",
  T_51_MX_WS_UI_BUTTON_CLICK: "Button Click",
  T_51_MX_WS_UI_CANCEL: "",
  T_51_MX_WS_UI_CONFIRM: "",
  T_51_MX_WS_UI_LIST_SCROLL: "",
  T_51_MX_WS_UI_LOADING: "Loading Progress",
  T_51_TYC_API_OUTLINE: "Set Entity Outline",
  T_51_TYC_API_OUTLINE_ALPHA: "Outline Transparency",
  T_51_TYC_API_OUTLINE_ALPHA_D: "Value between 0 and 1 (0 = fully transparent,1 = fully opaque)",
  T_51_TYC_API_OUTLINE_COLOR: "Outline Color",
  T_51_TYC_API_OUTLINE_COLOR_D: "The color used for drawing the outline",
  T_51_TYC_API_OUTLINE_D: "Specifies an entity to highlight its edges. Supported types include Player, Custom Render, NPC, Appearance, and Basic Appearance.",
  T_51_TYC_API_OUTLINE_TARGET: "Target Entity",
  T_51_TYC_API_OUTLINE_TARGET_D: "The entity to be outlined",
  T_51_TYC_API_OUTLINE_TOPMOST: "Always on Top",
  T_51_TYC_API_OUTLINE_TOPMOST_D: "Makes the outline render through all objects, always visible on top.",
  T_51_TYC_API_OUTLINE_WIDTH: "Outline Width",
  T_51_TYC_API_OUTLINE_WIDTH_D: "Value between 0 and 1 (0 = no outline, 1 = max. outline thickness)",
  T_51_XJ_WS_BASIC_SETTING: "Basic Settings",
  T_51_XJ_WS_GAME_START_TIME_UNIT: "Second",
  T_51_XJ_WS_GMSTART_TIME: "Preparation time before game starts",
  T_51_ZCS_SPAWNPOINT_NAME: "",
  T_OB47_M_WS_READ: "Read-only Property",
  TXT_AVATAR_FEMALE_JACKET_BLACK: "Black Leather Jacket (زنانہ)",
  TXT_AVATAR_FEMALE_PANTS_MARIO: "مشروم کا شکاری",
  TXT_AVATAR_FEMALE_SHOE_COS_HOODSHIRT_BLACK: "Black Activewear (جوتے)",
  TXT_AVATAR_FEMALE_SHORTPANT_COS_GSL_BLACK: "GW2018 Hotpants (زنانہ)",
  TXT_AVATAR_FEMALE_SKIRT_COS_GSL_BLACK: "GW2018 Skirt (زنانہ)",
  TXT_AVATAR_FEMALE_TOP_COS_HOODSHIRT_BLACK: "Black Activewear (ہڈی)",
  TXT_AVATAR_FEMALE_TOP_COS_SONGKRAN_2018: "سونگ کران ٹاپ (بلیک)",
  TXT_AVATAR_FEMALE_TSHIRT_MARIO: "پلمبر ٹاپ (زنانہ)",
  TXT_AVATAR_FEMALE_VEST_COS_GSL_BLACK: "GW2018 Singlet (زنانہ)",
  TXT_AVATAR_MALE_BOTTOM_COS_CNY_RED: "White Prosperity (باٹم)",
  TXT_AVATAR_MALE_BOTTOM_COS_GANGS_BLACK: "Black Trackpants (مردانہ)",
  TXT_AVATAR_MALE_BOTTOM_COS_MOB_YELLOW: "شکاری",
  TXT_AVATAR_MALE_BOTTOM_COS_OUTDOOR_BLACK: "بچانے والی پتلونیں",
  TXT_AVATAR_MALE_PANTS_MARIO: "مامایا",
  TXT_AVATAR_MALE_SHOE_COS_CANVAS_BLACK: "زندہ بچ جانے والے جوتے",
  TXT_AVATAR_MALE_SHOE_RED: "سرخ جوتے (مردانہ)",
  TXT_AVATAR_MALE_TOP_COS_CNY_RED: "White Prosperity (ٹاپ)",
  TXT_AVATAR_MALE_TOP_COS_GANGS_BLACK: "Black Baseball Jersey (مردانہ)",
  TXT_AVATAR_MALE_TOP_COS_HOODIE_BRICKR: "باغی ہوڈی",
  TXT_AVATAR_MALE_TOP_COS_HOODSHIRT_BLACK: "Cool Activewear (ہوڈی)",
  TXT_AVATAR_MALE_TOP_COS_MOB_DGREEN: "بادشاہ کھوپڑی کی بلٹ پروف جیکٹ",
  TXT_AVATAR_MALE_TOP_COS_OUTDOOR_GREY: "زندہ بچ جانے والی شرٹ",
  TXT_AVATAR_MALE_TSHIRT_MARIO: "پلمبر ٹاپ (مردانہ)",
  TXT_AVATAR_OB10_LZW_FEMALE_TOP_COS_SPONSOR: "ریسر جیکٹ (زنانہ)",
  TXT_AVATAR_OB10_LZW_MALE_HAIR_COS_CLOWN: "Night Clown (ہیڈ)",
  TXT_AVATAR_OB10_LZW_MALE_TOP_COS_SPONSOR: "ریسر جیکٹ (مردانہ)",
  TXT_AVATAR_OB10_LZW_TOP_SLEEVELESS: "Sleeveless Jacket (گرین)",
  TXT_AVATAR_OB11_LZW_COS_NYARUKO: "Mr. Squido",
  TXT_AVATAR_OB11_LZW_MALE_ACCESSORY_COS_ZOMBIE: "Zombified Samurai (ماسک)",
  TXT_AVATAR_OB11_LZW_MALE_TOP_COS_PINK_JAZZ: "Full Arm Tattoo",
  "TXT_AVATAR_OB7_LZW_FEMALE_A-SKIRT_BLACK": "گلے لگاؤ",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_CNY_RED_OBT7TH: "وکٹوریہ",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "اسٹائلش ریٹرو",
  TXT_AVATAR_OB7_LZW_FEMALE_BOTTOM_COS_JAPANESESTYLE_PINK: "کٹسون پتلون",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_COS_JAPANESESTYLE_PINK: "کٹسون جوتے",
  TXT_AVATAR_OB7_LZW_FEMALE_SHOE_SPORTS_08: "Sports Shoes (بلیو)",
  TXT_AVATAR_OB7_LZW_FEMALE_SHORTPANTS_FLAP_BLUE: "Denim Shorts (زنانہ)",
  TXT_AVATAR_OB7_LZW_FEMALE_TOP_COS_JAPANESESTYLE_PINK: "کٹسون روب",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_BATTLE_BROWN: "Combat Pants (مردانہ)",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_DOWNJACKET_OBT7TH: "Angelic pants",
  TXT_AVATAR_OB7_LZW_MALE_BOTTOM_COS_JAPANESESTYLE_PURPLE: "بشیڈو Bottom",
  TXT_AVATAR_OB7_LZW_MALE_HOODIE_ZIPPER_GREY: "Grey Zipper Hoodie",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_CASUAL: "Hipster shoes",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_JAPANESESTYLE_PURPLE: "بشیڈو Footwear",
  TXT_AVATAR_OB7_LZW_MALE_SHOE_COS_TECHWEAR_OBT7TH: "Astro shoes",
  TXT_AVATAR_OB7_LZW_MALE_SHORTPANTS_FLAP_BLUE: "Denim Shorts (مردانہ)",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_BATTLE_BROWN: "Combat Vest (مردانہ)",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_CASUAL: "ہپسٹر ٹاپ",
  TXT_AVATAR_OB7_LZW_MALE_TOP_COS_JAPANESESTYLE_PURPLE: "وے آف دی بوشیڈو",
  TXT_AVATAR_OB8_LZW_BALLPANTS_WHITE: "White Hurricane",
  TXT_AVATAR_OB8_LZW_FEMALE_BOTTOM_COS_BASEBALL_GREEN: "Baseballer (ٹائٹس)",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_ASUS_JACKET: "Rider Jacket (زنانہ)",
  TXT_AVATAR_OB8_LZW_FEMALE_TOP_COS_BASEBALL_GREEN: "Baseballer ( جیکٹ)",
  TXT_AVATAR_OB8_LZW_MALE_BOTTOM_COS_BASEBALL_YELLOW: "Cool Captain (پتلونیں)",
  "TXT_AVATAR_OB8_LZW_MALE_HAIR_COS_HIP-HOP": "سٹریٹس (ہیڈ)",
  TXT_AVATAR_OB8_LZW_MALE_SHOE_COS_BASEBALL_YELLOW: "Cool Captain (جوتے)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_ASUS_JACKET: "Rider Jacket (مردانہ)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_BASEBALL_YELLOW: "Cool Captain (جیکٹ)",
  TXT_AVATAR_OB8_LZW_MALE_TOP_COS_DINOSAUR_GREEN: "Dino",
  TXT_AVATAR_OB8_LZW_SHOE_SOCCER_SILVER: "سلور بوٹ",
  TXT_AVATAR_OB8_LZW_TSHIRT_ENGLAND_B: "تین شیر",
  TXT_AVATAR_OB9_LZW_MALE_ACCESSORY_COS_TUXEDO: "Tuxedo (ماسک)",
  TXT_AVATAR_OB9_LZW_MALE_HAIR_COS_TUXEDO: "Tuxedo (ہیڈ)",
  TXT_AVATAR_PARACHUTE_8: "مسکراہٹ",
  TXT_AVATAR_SHIRT_PLAID_2: "پروگرامرزکا پسندیدہ (سرخ)",
  TXT_AVATAR_SHOES_1: "Sneakers (سفید)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_2: "Schoolgirl (اورنج)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_3: "اسکول کی طالبہ (ریڈ)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_4: "Schoolgirl (ییلو)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_5: "Schoolgirl (پنک)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_6: "Schoolgirl (جیسمین)",
  TXT_AVATAR_SUIT_FEMALE_TOP_1_7: "Schoolgirl (بلیو)",
  TXT_AVATAR_TSHIRT_WEEK_007: "STARRY SUN",
  TXT_BANNER_NAME_MISHA: "سپیڈ",
  TXT_CHARACTER_ADAM_NAME: "پرائمس",
  TXT_CHARACTER_BODYGUARD_NAME: "نکیتا",
  TXT_CHARACTER_COP_NAME: "اینڈریو",
  TXT_CHARACTER_EVA_NAME: "نولا",
  TXT_CHARACTER_NURSE_NAME: "اولیویا",
  TXT_CHARACTER_RACERGIRL_NAME: "میشا",
  TXT_CHARACTER_RUNNER_NAME: "کیلی",
  TXT_CHARACTER_SEAMAN_NAME: "فورڈ",
  TXT_CLAN_NAME: "نام",
  TXT_COLLECTION_DESCRIPTION: "تفصیل",
  TXT_COLLECTION_HEADPORTRAIT: "اواتار",
  TXT_INVENTORY_TITLE_EQUIPMENT: "سازو سامان",
  TXT_ITEM_AK: "AK47",
  TXT_ITEM_ARAMMO: "AR بارود",
  TXT_ITEM_AWM: "AWM",
  TXT_ITEM_BAG1: "بیگ لیول 1",
  TXT_ITEM_BAG2: "بیگ لیول 2",
  TXT_ITEM_BAG3: "بیگ لیول 3",
  TXT_ITEM_BASEBALLPOLE: "بلا",
  TXT_ITEM_BOWAMMO: "Crossbow Bolt",
  TXT_ITEM_CHANGUO: "فرائی پین",
  TXT_ITEM_CROSSBOW: "کراسبو",
  TXT_ITEM_DESC_FLASH: "ایک دھماکہ خیز آلہ جو دشمن کے حواس کو عارضی طور پر خراب کرسکتا ہے۔",
  TXT_ITEM_EAGLE: "صحرائی عقاب",
  TXT_ITEM_FAK: "میڈ کٹ",
  TXT_ITEM_FAMAS: "FAMAS",
  TXT_ITEM_FIST: "مکا",
  TXT_ITEM_FLASH: "Flashbang",
  TXT_ITEM_FOREGRIP1: "فورگریپ لیول 1",
  TXT_ITEM_FOREGRIP2: "فورگریپ لیول 2",
  TXT_ITEM_FOREGRIP3: "فورگریپ لیول 3",
  TXT_ITEM_G18: "G18",
  TXT_ITEM_GRENADE: "گرینیڈ",
  TXT_ITEM_GROZA: "GROZA",
  TXT_ITEM_HANDCANNON: "ہینڈ کینن",
  TXT_ITEM_HEATSIGHT: "تھرمل اسکوپ",
  TXT_ITEM_HELMET1: "ہیلمیٹ لیول 1",
  TXT_ITEM_HELMET2: "ہیلمیٹ لیول 2",
  TXT_ITEM_HELMET3: "ہیلمیٹ لیول 3",
  TXT_ITEM_HGAMMO: "HG بارود",
  TXT_ITEM_KAR98K: "Kar98k",
  TXT_ITEM_LANUNCHERAMMO: "40mmSR",
  TXT_ITEM_M1014: "M1014",
  TXT_ITEM_M14: "M14",
  TXT_ITEM_M1873: "M1873",
  TXT_ITEM_M249: "M249",
  TXT_ITEM_M4A1: "M4A1",
  TXT_ITEM_M500: "M500",
  TXT_ITEM_M79: "M79",
  TXT_ITEM_MACHETE: "چاقو",
  TXT_ITEM_MAGEZINE1: "میگزین لیول 1",
  TXT_ITEM_MAGEZINE2: "میگزین لیول 2",
  TXT_ITEM_MAGEZINE3: "میگزین لیول 3",
  TXT_ITEM_MP40: "MP40",
  TXT_ITEM_MP5: "MP5",
  TXT_ITEM_MUZZLE1: "تھو تھنی لیول 1",
  TXT_ITEM_MUZZLE2: "تھو تھنی لیول 2",
  TXT_ITEM_MUZZLE3: "تھو تھنی لیول 3",
  TXT_ITEM_SCAR: "سکار",
  TXT_ITEM_SGAMMO: "SG بارود",
  TXT_ITEM_SIGHT2: "2x اسکوپ",
  TXT_ITEM_SIGHT4: "4x اسکوپ",
  TXT_ITEM_SILENCER1: "سلنسر",
  TXT_ITEM_SKS: "SKS",
  TXT_ITEM_SMGAMMO: "ایس_ایم_جی بارود",
  TXT_ITEM_SNAMMO: "سنائیپر بارود",
  TXT_ITEM_SPAS12: "SPAS12",
  TXT_ITEM_SVD: "SVD",
  TXT_ITEM_UMP: "UMP",
  TXT_ITEM_USP: "USP",
  TXT_ITEM_VEST1: "ویسٹ لیول 1",
  TXT_ITEM_VEST2: "ویسٹ لیول 2",
  TXT_ITEM_VEST3: "ویسٹ لیول 3",
  TXT_ITEM_VSS: "VSS",
  TXT_ITEM_XM8: "XM8",
  TXT_MATCHRESULT_TITLE: "نتیجہ",
  TXT_MESSAGEBOX_ERROR: "خرابی",
  TXT_OB10_HQW_ITEM_BIPOD: "Bipod",
  TXT_OB10_HQW_ITEM_M60: "M60",
  TXT_OB10_JRW_CAMOUFLAGE_OILDRUM_NAME: "آئل بیرل",
  TXT_OB10_JRW_CHARACTER_BRAZILSOLDIER_NAME: "میگوئل",
  TXT_OB10_JRW_SKILL_NAME_BRAZILSOLDIER: "پاگل خونی",
  TXT_OB10_ZXR_BASEBALLBAT_CORN_NAME: "Mexican Grilled Corn",
  TXT_OB10_ZXR_GRENADESKIN_RANGE: "دھماکے کی حد",
  TXT_OB10_ZXR_MACHETE_RANKMASTER_NAME: "جلاد",
  TXT_OB11_HQW_ITEM_MGL140: "MGL140",
  TXT_OB11_HQW_ITEM_P90: "P90",
  TXT_OB11_HQW_LANDMINE: "بارودی سرنگ",
  TXT_OB11_HQW_LANDMINE_DESC: "ایک ایسی سرنگ جو زمین پر لگائی جاسکتی ہے۔ انتبا، خود اس پر قدم نہ رکھیں!",
  TXT_OB11_JRW_CHARACTER_RICHGIRL_NAME: "کیرولین",
  TXT_OB11_JRW_EMOTE_CLAP_NAME: "تالیاں",
  TXT_OB11_JRW_EMOTE_DAB_NAME: "ڈب",
  TXT_OB11_JRW_EMOTE_FUNKYCHICKEN_NAME: "چکن",
  TXT_OB11_JRW_EMOTE_HELLO_NAME: "ہیلو!",
  TXT_OB11_JRW_EMOTE_LOL_NAME: "زور کی ہنسی",
  TXT_OB11_JRW_EMOTE_PROVOKE_NAME: "اکسانا",
  TXT_OB11_JRW_SKILL_DESC_RICHGIRL: "جب شاٹگن پکڑی ہوتی ہے تو نقل و حرکت کی رفتار میں {0}٪ اضافہ ہو جاتا ہے",
  TXT_OB11_JRW_SKILL_NAME_RICHGIRL: "چپلتا",
  TXT_OB11_ZXR_SCAR_CHEETAH_NAME: "چیتا: فینگ",
  TXT_OB11_ZXR_SCAR_TOPGAMER_NAME: "مستقبل یافتہ",
  TXT_OB16_Q_ITEM_ARMORREPAIR: "مرمت کٹ",
  TXT_OB5_HISTORY_HEADSHOOT: "ہیڈ شاٹس",
  TXT_OB5_HISTORY_LIVE: "سروائیول",
  TXT_OB7_JRW_CHARACTER_FOODIEBOY_NAME: "میکسم",
  TXT_OB7_JRW_SKILL_DESC_FOODIEBOY: "مشروم کھانا اور میڈ کٹس کا استعمال تیزی سے {0}%",
  TXT_OB7_JRW_SKILL_NAME_FOODIEBOY: "پیٹو",
  TXT_OB7_ZC_CLAN_NICKNAME: "عرفیت",
  TXT_OB7_ZJS_HISTORY_TIME: "وقت",
  TXT_OB8_HQW_NEWLOADOUT_BONFIRE: "بون فائر",
  TXT_OB8_JYF_PARACHUTE_THUNDER_NAME: "بولٹ",
  TXT_OB8_SQ_CHARACTER_THAIBOXER_NAME: "کلا",
  TXT_OB8_SQ_SKILL_DESC_THAIBOXER: "مکے کے نقصان میں {0}٪ اضافہ ہوا",
  TXT_OB8_SQ_SKILL_NAME_THAIBOXER: "موئے تھائی",
  TXT_OB8_ZXR_AWM_CAMO_NAME: "جامنی گھاس کا میدان",
  TXT_OB8_ZXR_G18_CAMO_NAME: "ایٹم اسپلٹر",
  TXT_OB8_ZXR_M249_CAMO_NAME: "مرجھایا ہوا",
  TXT_OB8_ZXR_M79_CAMO_NAME: "Skysplitter",
  TXT_OB8_ZXR_USP_CAMO_NAME: "برفانی چیتا",
  TXT_OB9_JRW_CHARACTER_ARMSDEALER_NAME: "پلوما",
  TXT_OB9_JRW_SKILL_NAME_ARMSDEALER: "اسلحہ-لین دین",
  TXT_OB9_JYF_SKYBOARD_BOOYAH_NAME: "گرین اسٹار",
  TXT_OB9_SQ_ITEM_GLOOSHIELD: "گلو وال",
  TXT_OB9_ZXR_AK47_DIGI_CAMO_NAME: "ڈیجیٹل کیموفلاج",
  TXT_OB9_ZXR_FAMAS_RED_NAME: "خونی مریم",
  TXT_OB9_ZXR_G18_CAMO_02_NAME: "صحرا کا شکاری",
  TXT_OB9_ZXR_GROZA_CAMO_NAME: "نیلا شعلہ",
  TXT_OB9_ZXR_M1014_CAMO_02_NAME: "جامنی پریڈ",
  TXT_OB9_ZXR_M14_CAMO_NAME: "لائف اسٹریم",
  TXT_OB9_ZXR_M1873_NAME: "گہرا نیلا سمندر",
  TXT_OB9_ZXR_MACHETE_FISH_NAME: "سورڈفش",
  TXT_OB9_ZXR_MP5_CAMO_NAME: "ہارویسٹر",
  TXT_OB9_ZXR_SCAR_CAMO_BLUE_NAME: "جامنی کوارٹز",
  TXT_OB9_ZXR_SKS_CAMO_NAME: "جھلسی ہوئی زمین",
  TXT_OPTION_HIGH_BRIGHTNESS: "روشن",
  TXT_PLAYER_RANK: "درجہ",
  TXT_ROOM_LOBBY_ID: "ID",
  TXT_ROOM_MAP_PARADISE: "برمودا",
  TXT_SETTING_CHANGEWEAPON: "Quick Weapon Switch Button",
  TXT_SETTING_OB4_NOTREAL: "گہرا",
  TXT_SKILL_DESC_COP: "آرمر کے استحکام میں {0}٪ کمی",
  TXT_SKILL_DESC_RUNNER: "بھاگنے کی رفتار 10% سے برھ گئی",
  TXT_SKILL_NAME_COP: "آرمر کا ماہر",
  TXT_SKILL_NAME_NURSE: "شفا بخش ٹچ",
  TXT_SKILL_NAME_RACERGIRL: "آفٹر برنر",
  TXT_SKILL_NAME_RUNNER: "تیز بھاگنا",
  TXT_SKILL_NAME_SEAMAN: "فولادی قوت ارادی",
  TXT_TUTORIAL_HUD: "HUD",
  TXT_TUTORIAL_HUD_LABEL10: "Sprint",
  TXT_TUTORIAL_PICKUP_LABEL0: "ہتھیار",
  T_34_M_WS_VFXTYPE: "VFX کی قسم",
  T_40_XXJ_WS_MONSTERATTACKTARGETTYPE_NAMEKEY: "حملے کا ہدف",
  T_40_XXJ_WS_PLAYERUISWITCHTYPE_NAMEKEY: "پلیئر UI کی قسم",
  T_41_XXJ_WS_MONSTERSKILLTYPE: "مونسٹر کی مہارت کی قسم",
  T_45_META_WS_DESCRIPTIVECOLOR: "Descriptive Color",
  T_45_META_WS_GAMETIME: "Game Time",
  T_45_META_WS_PROPERTY: "Property",
  T_45_XXJ_WS_UISOCIALBUTTONSTYLETYPE: "بٹن کے انداز کی قسم",
  T_45_XXJ_WS_UISOCIALBUTTONTYPE: "بٹن کی قسم",
  T_46_META_WS_A_A: "A",
  T_46_META_WS_A_ACCELERATION: "تیز کرنا",
  T_46_META_WS_A_ACCOUNTID: "اکاؤنٹ کی شناخت",
  T_46_META_WS_A_ACTIONTYPE: "عمل کی قسم",
  T_46_META_WS_A_ACTIVE: "فعال ہے",
  T_46_META_WS_A_ANGLE: "زاویہ",
  T_46_META_WS_A_ANY: "کوئی بھی",
  T_46_META_WS_A_APPEARANCEGROUP: "ظاہری گروپ",
  T_46_META_WS_A_ASSERTIONEXPRESSION: "اظہار دعویٰ",
  T_46_META_WS_A_ATTACHMENT: "اٹیچمنٹ",
  T_46_META_WS_A_ATTACHMENTS: "اٹیچمنٹ کی فہرست",
  T_46_META_WS_A_ATTACKABLE: "حملہ آور",
  T_46_META_WS_A_ATTACKER: "حملہ آور",
  T_46_META_WS_A_ATTACKTARGET: "حملہ ہدف",
  T_46_META_WS_A_AUTOPLAY: "خودکار پلے",
  T_46_META_WS_A_AXIS: "محور",
  T_46_META_WS_A_B: "B",
  T_46_META_WS_A_BASE: "بنیاد",
  T_46_META_WS_A_BOUNDTARGET: "باؤنڈ ہدف",
  T_46_META_WS_A_BTREE: "رویے کا درخت",
  T_46_META_WS_A_BUFF: "بَف",
  T_46_META_WS_A_CAMERA: "کیمرہ",
  T_46_META_WS_A_CAPICITY: "صلاحیت",
  T_46_META_WS_A_CENTER: "مرکز",
  T_46_META_WS_A_CHANGEROTATION: "گردش کو تبدیل کریں",
  T_46_META_WS_A_CHANNEL: "چینل",
  T_46_META_WS_A_CHASEENEMY: "دشمن کا پیچھا کریں",
  T_46_META_WS_A_CHILD: "بچہ",
  T_46_META_WS_A_COLOR: "رنگ",
  T_46_META_WS_A_COLUMN: "کالم",
  T_46_META_WS_A_COLUMNNAME: "کالم کا نام",
  T_46_META_WS_A_COMEBACK: "واپس آنا",
  T_46_META_WS_A_COMPONENT: "جزو",
  T_46_META_WS_A_CONTENT: "مواد",
  T_46_META_WS_A_COORDINATESYSTEM: "نقاطی نظام",
  T_46_META_WS_A_COUNT: "تعداد",
  T_46_META_WS_A_COUNTS: "گنتی",
  T_46_META_WS_A_CREATEDENTITY: "پیدا کردہ ہستی",
  T_46_META_WS_A_CROSSPLATFORM: "کراس پلیٹ فارم",
  T_46_META_WS_A_CULLINGMASK: "کلنگ ماسک",
  T_46_META_WS_A_CURVE: "منحنی",
  T_46_META_WS_A_CUSTOMTAG: "حسبِ خواہ ٹیگ",
  T_46_META_WS_A_CUTRADIUS: "کاٹنے کا نصف قطر",
  T_46_META_WS_A_DAMAGE: "نقصان",
  T_46_META_WS_A_DAMAGESEGMENTS: "نقصان کے حصے",
  T_46_META_WS_A_DEGREE: "ڈگری",
  T_46_META_WS_A_DELTA: "ڈیلٹا",
  T_46_META_WS_A_DEPTH: "گہرائی",
  T_46_META_WS_A_DESTVAL: "منزل قدر",
  T_46_META_WS_A_DIFFICULTY: "مشکل",
  T_46_META_WS_A_DIRECTION: "سمت",
  T_46_META_WS_A_DISABLE: "غیر فعال ہے",
  T_46_META_WS_A_DISPLACEMENT: "بے دخلی",
  T_46_META_WS_A_DISTANCE: "فاصلہ",
  T_46_META_WS_A_DIVINGMAXSPEED: "ڈائیونگ کی زیادہ سے زیادہ رفتار",
  T_46_META_WS_A_DOTWEEN: "ٹوئن کریں",
  T_46_META_WS_A_DURATION: "دورانیہ (سیکنڈ)",
  T_46_META_WS_A_EMOTE: "ایموٹ",
  T_46_META_WS_A_ENABLE: "فعال کریں",
  T_46_META_WS_A_ENDAREACENTER: "اختتامی علاقے کا مرکز",
  T_46_META_WS_A_ENDAREARANGE: "اختتامی علاقے کی حد",
  T_46_META_WS_A_ENDPOSITION: "اختتامی پوزیشن",
  T_46_META_WS_A_ENDRANK: "اختتامی رینک",
  T_46_META_WS_A_EQUIPMENTS: "سامان",
  T_46_META_WS_A_EVENTID: "ایونٹ آئی ڈی",
  T_46_META_WS_A_EXPONENT: "طاقت",
  T_46_META_WS_A_FACTION: "دھڑا",
  T_46_META_WS_A_FACTORTYPE: "عنصر کی قسم",
  T_46_META_WS_A_FILTERTYPE: "فلٹر کی قسم",
  T_46_META_WS_A_FINALRADIUS: "حتمی نصف قطر",
  T_46_META_WS_A_FINDVALUE: "قیمت تلاش کریں",
  T_46_META_WS_A_FIXEDRANGE: "مقررہ رینج",
  T_46_META_WS_A_FOLLOWTARGET: "ہدف کا تعاقب کریں",
  T_46_META_WS_A_FONTCOLOR: "فونٹ کا رنگ",
  T_46_META_WS_A_FONTSIZE: "فونٹ کا سائز",
  T_46_META_WS_A_FOOTBALL: "فٹبال",
  T_46_META_WS_A_FORCE: "فورس",
  T_46_META_WS_A_FORCEDPARACHUTEHEIGHT: "جبراً پیراشوٹ کی اونچائی",
  T_46_META_WS_A_FORCEMODE: "فورس موڈ",
  T_46_META_WS_A_FORWARD: "سمت",
  T_46_META_WS_A_G: "G",
  T_46_META_WS_A_GAMEID: "کھیل کی شناخت",
  T_46_META_WS_A_HALFEXTENTS: "نصف حصے",
  T_46_META_WS_A_HEIGHT: "اونچائی",
  T_46_META_WS_A_HEIGHTSEGMENTS: "اونچائی کے حصے",
  T_46_META_WS_A_HITDISTANCE: "ہٹ فاصلہ",
  T_46_META_WS_A_HITDISTANCES: "ہٹ فاصلہ",
  T_46_META_WS_A_HITENTITIES: "ہٹ ہونے والی ہستی",
  T_46_META_WS_A_HITENTITY: "ہٹ موجودگی",
  T_46_META_WS_A_HITNORMAL: "ہٹ نورمل",
  T_46_META_WS_A_HITNORMALS: "ہٹ نارمل",
  T_46_META_WS_A_HITPOINTS: "ہٹ پوائنٹ",
  T_46_META_WS_A_HITPOSITION: "ہٹ پوزیشن",
  T_46_META_WS_A_INCLUDETRIGGER: "ٹریگر شامل کریں",
  T_46_META_WS_A_INDEX: "انڈیکس",
  T_46_META_WS_A_INDEXS: "انڈیکس",
  T_46_META_WS_A_INITIALVELOCITY: "ابتدائی رفتار",
  T_46_META_WS_A_INITRADIUS: "ابتدائی نصف قطر",
  T_46_META_WS_A_INWALLET: "ان بٹوہ",
  T_46_META_WS_A_ISBOTTOMCOLLIDING: "کیا نیچے ٹکراؤ ہے",
  T_46_META_WS_A_ISEXIST: "موجود ہے",
  T_46_META_WS_A_ISLOOP: "لوپ ہے",
  T_46_META_WS_A_ISMAPPEDINSCREEN: "اسکرین پر نقشہ بند ہے یا نہیں",
  T_46_META_WS_A_ISPAUSE: "وقفہ",
  T_46_META_WS_A_ISSIDECOLLIDING: "کیا طرف ٹکراؤ ہے",
  T_46_META_WS_A_ISSUCCESS: "کامیاب",
  T_46_META_WS_A_ISTOPCOLLIDING: "کیا اوپر ٹکراؤ ہے",
  T_46_META_WS_A_ITEM: "آئٹم",
  T_46_META_WS_A_ITEMID: "آئٹم کی شناخت",
  T_46_META_WS_A_ITEMS: "آئٹمز",
  T_46_META_WS_A_ITEMTYPE: "آئٹم کی قسم",
  T_46_META_WS_A_JERSEYTYPE: "جرسی کی قسم",
  T_46_META_WS_A_KEEPVELOCITY: "رفتار کو برقرار رکھیں",
  T_46_META_WS_A_KEY: "کلید",
  T_46_META_WS_A_KEYCOLUMN: "کلیدی کالم",
  T_46_META_WS_A_KEYS: "کلیدیں",
  T_46_META_WS_A_LAYER: "پرت",
  T_46_META_WS_A_LAYERMASK: "لیئر ماسک",
  T_46_META_WS_A_LEFT: "بائیں",
  T_46_META_WS_A_LEFTVALUE: "بائیں قیمت",
  T_46_META_WS_A_LENGTH: "لمبائی",
  T_46_META_WS_A_LEVELOBJECT: "سطح کی چیز",
  T_46_META_WS_A_LOG: "لاگ",
  T_46_META_WS_A_LOOKATTARGET: "ہدف پر نظر رکھیں",
  T_46_META_WS_A_LOOPTYPE: "لوپ کی قسم",
  T_46_META_WS_A_MAINCOLOR1: "مرکزی رنگ1",
  T_46_META_WS_A_MAINCOLOR2: "مرکزی رنگ2",
  T_46_META_WS_A_MAPCODE: "نقشے کا کوڈ",
  T_46_META_WS_A_MAPPEDPOSITION: "نقشہ بند پوزیشن",
  T_46_META_WS_A_MAX: "زیادہ سے زیادہ",
  T_46_META_WS_A_MAXDISPLACEMENT: "زیادہ سے زیادہ جگہ کی تبدیلی",
  T_46_META_WS_A_MAXDISTANCE: "زیادہ سے زیادہ فاصلہ",
  T_46_META_WS_A_MIN: "کم از کم",
  T_46_META_WS_A_MISSIONID: "مشن آئی ڈی",
  T_46_META_WS_A_MISSIONPROGRESS: "مشن کی پیشرفت",
  T_46_META_WS_A_MODIFYTYPE: "ترمیم کی قسم",
  T_46_META_WS_A_MONEYTYPE: "رقم کی قسم",
  T_46_META_WS_A_MUST: "لازمی",
  T_46_META_WS_A_NAME: "نام",
  T_46_META_WS_A_NEWVALUE: "نئی قیمت",
  T_46_META_WS_A_NODE: "نوڈ",
  T_46_META_WS_A_NORMAL: "عمومی",
  T_46_META_WS_A_NOT: "نہیں",
  T_46_META_WS_A_OBSERVER: "نگران",
  T_46_META_WS_A_OFFSET: "آفسٹ",
  T_46_META_WS_A_OLDVALUE: "پرانی قیمت",
  T_46_META_WS_A_OPERATIOMETHOD: "آپریشن کا طریقہ",
  T_46_META_WS_A_OPTIONS: "اختیارات",
  T_46_META_WS_A_OTHERCOLOR: "دیگر رنگ",
  T_46_META_WS_A_OUTFIT: "لباس",
  T_46_META_WS_A_OUTFITS: "لباس کی فہرست",
  T_46_META_WS_A_OUTWALLET: "آؤٹ بٹوہ",
  T_46_META_WS_A_OWNER: "مالک",
  T_46_META_WS_A_PARACHUTINGMAXSPEED: "پیراشوٹنگ کی زیادہ سے زیادہ رفتار",
  T_46_META_WS_A_PARAMS: "پیرامیٹرز",
  T_46_META_WS_A_PARENT: "والدین",
  T_46_META_WS_A_PARENTWIDGET: "والدین ویجیٹ",
  T_46_META_WS_A_PATH: "راستہ",
  T_46_META_WS_A_PATHPOINTS: "راستہ پوائنٹس",
  T_46_META_WS_A_PHASEINDEX: "مرحلہ انڈیکس",
  T_46_META_WS_A_PLATFORM: "پلیٹ فارم",
  T_46_META_WS_A_PLAYER: "کھلاڑی",
  T_46_META_WS_A_PLAYSPEED: "پلے کی رفتار",
  T_46_META_WS_A_POSITION: "مقام",
  T_46_META_WS_A_POSITIONS: "مقامات",
  T_46_META_WS_A_POSTION: "مقام",
  T_46_META_WS_A_PREFAB: "پری فیب",
  T_46_META_WS_A_PROPERTY: "پراپرٹی",
  T_46_META_WS_A_PROPERTYID: "پراپرٹی آئی ڈی",
  T_46_META_WS_A_PURSUITTARGET: "تعاقب ہدف",
  T_46_META_WS_A_R: "R",
  T_46_META_WS_A_RADIUS: "نصف قطر",
  T_46_META_WS_A_RANDOMDECAY: "تصادفی زوال",
  T_46_META_WS_A_RANDOMRANGE: "تصادفی حد",
  T_46_META_WS_A_RANDOMRATIO: "تصادفی تناسب",
  T_46_META_WS_A_RANGE: "رینج",
  T_46_META_WS_A_RANK: "درجہ",
  T_46_META_WS_A_REALCOIN: "حقیقی سکہ",
  T_46_META_WS_A_REALNUMBER: "حقیقی نمبر",
  T_46_META_WS_A_RESET: "ری سیٹ کریں",
  T_46_META_WS_A_RESOURCE: "وسیلہ",
  T_46_META_WS_A_RESULT: "نتیجہ",
  T_46_META_WS_A_RIGHT: "دائیں",
  T_46_META_WS_A_RIGHTVALUE: "دائیں قیمت",
  T_46_META_WS_A_ROTATION: "گردش",
  T_46_META_WS_A_ROW: "قطار",
  T_46_META_WS_A_SAMPLEPOINT: "نمونہ پوائنٹ",
  T_46_META_WS_A_SCALE: "پیمانہ",
  T_46_META_WS_A_SCENEID: "منظر کی شناخت",
  T_46_META_WS_A_SCORE: "اسکور",
  T_46_META_WS_A_SCORENAME: "اسکور کا نام",
  T_46_META_WS_A_SCREENPOSITION: "اسکرین پوزیشن",
  T_46_META_WS_A_SCRIPT: "اسکرپٹ",
  T_46_META_WS_A_SEAT: "سیٹ",
  T_46_META_WS_A_SEP: "جداکار",
  T_46_META_WS_A_SEPSTR: "جداکار",
  T_46_META_WS_A_SHEETNAME: "شیٹ کا نام",
  T_46_META_WS_A_SHOPITEM: "دکان کا آئٹم",
  T_46_META_WS_A_SHOWBACKGROUND: "پس منظر دکھائیں",
  T_46_META_WS_A_SHOWMATCHRESULT: "کھیل کا نتیجہ دکھائیں",
  T_46_META_WS_A_SHOWMESSAGEWHENCANCEL: "منسوخ کرنے پر پیغام دکھائیں",
  T_46_META_WS_A_SKILL: "مہارت",
  T_46_META_WS_A_SKILLS: "مہارتیں",
  T_46_META_WS_A_SKILLTARGET: "مہارت کا ہدف",
  T_46_META_WS_A_SKIN: "جلد",
  T_46_META_WS_A_SLOT: "سلاٹ",
  T_46_META_WS_A_SRCVAL: "ماخذ قدر",
  T_46_META_WS_A_SRCVALUE: "ماخذ قیمت",
  T_46_META_WS_A_STARTAREACENTER: "آغاز علاقے کا مرکز",
  T_46_META_WS_A_STARTAREARANGE: "آغاز علاقے کی حد",
  T_46_META_WS_A_STARTINDEX: "ابتدائی انڈیکس",
  T_46_META_WS_A_STARTPOSITION: "ابتدائی مقام",
  T_46_META_WS_A_STARTRANK: "آغاز کی رینک",
  T_46_META_WS_A_STATE: "حالت",
  T_46_META_WS_A_STATUS: "حیثیت",
  T_46_META_WS_A_STATUSCODE: "حالت کا کوڈ",
  T_46_META_WS_A_STYLE: "انداز",
  T_46_META_WS_A_SURFINGMAXSPEED: "سرفنگ کی زیادہ سے زیادہ رفتار",
  T_46_META_WS_A_TARGET: "ہدف",
  T_46_META_WS_A_TARGETPOSITION: "ہدف مقام",
  T_46_META_WS_A_TEAMSEQ: "ٹیم تسلسل",
  T_46_META_WS_A_THRESHOLD: "حد",
  T_46_META_WS_A_TIMESTAMP: "وقت کا ٹکسٹمپ",
  T_46_META_WS_A_TIPS: "تجاویز",
  T_46_META_WS_A_TITLE: "عنوان",
  T_46_META_WS_A_TOKENCOUNT: "ٹوکن کی تعداد",
  T_46_META_WS_A_TOKENID: "ٹوکن آئی ڈی",
  T_46_META_WS_A_TORQUE: "ٹارک",
  T_46_META_WS_A_TOUCHPOINT: "ٹچ پوائنٹ",
  T_46_META_WS_A_TRANSITIONTIME: "ٹرانزیشن کا وقت (ms)",
  T_46_META_WS_A_TRANSITIONTYPE: "ٹرانزیشن کی قسم",
  T_46_META_WS_A_TRIGGER: "ٹریگر",
  T_46_META_WS_A_TYPE: "قسم",
  T_46_META_WS_A_UI: "UI",
  T_46_META_WS_A_UIID: "UI آئی ڈی",
  T_46_META_WS_A_UPWARD: "اوپر کی طرف",
  T_46_META_WS_A_VALUE: "قیمت",
  T_46_META_WS_A_VALUEA: "قیمت A",
  T_46_META_WS_A_VALUEB: "قیمت B",
  T_46_META_WS_A_VALUES: "اقدار",
  T_46_META_WS_A_VALUET: "قدر T",
  T_46_META_WS_A_VALUETYPE: "ویلیو ٹائپ",
  T_46_META_WS_A_VEHICLE: "گاڑی",
  T_46_META_WS_A_VEHICLESKIN: "گاڑی کی جلد",
  T_46_META_WS_A_VELOCITY: "رفتار",
  T_46_META_WS_A_VELOCITYXZ: "ایکس زیڈ رفتار",
  T_46_META_WS_A_VELOCITYY: "وائی رفتار",
  T_46_META_WS_A_VISIBLE: "نظر آنے والا",
  T_46_META_WS_A_WAITTIME: "انتظار کا وقت (سیکنڈ)",
  T_46_META_WS_A_WALLET: "بٹوہ",
  T_46_META_WS_A_WEAPON: "ہتھیار",
  T_46_META_WS_A_WEAPONSKIN: "ہتھیار کی جلد",
  T_46_META_WS_A_WIDGETID: "ویجیٹ آئی ڈی",
  T_46_META_WS_A_WIDGETTYPE: "ویجیٹ کی قسم",
  T_46_META_WS_A_WIDTH: "چوڑائی",
  T_46_META_WS_A_WORLDPOSITION: "عالمی پوزیشن",
  T_46_META_WS_A_WORLDPOSITIONSTAYS: "عالمی پوزیشن برقرار ہے",
  T_46_META_WS_A_X: "X",
  T_46_META_WS_A_Y: "Y",
  T_46_META_WS_ABS: "مطلق قدر",
  T_46_META_WS_ACOS: "Acos",
  T_46_META_WS_ADDAOISPECIALFOLLOW: "AOI خاص پیروی شامل کریں",
  T_46_META_WS_ADDATTACHMENTS: "اضافات شامل کریں",
  T_46_META_WS_ADDBUFF: "بفی شامل کریں",
  T_46_META_WS_ADDCOMPONENT: "کمپوننٹ شامل کریں",
  T_46_META_WS_ADDFOOTBALLVELOCITY: "فٹ بال کی رفتار شامل کریں",
  T_46_META_WS_ADDFORCE: "قوت شامل کریں",
  T_46_META_WS_ADDFORCEATPOSITION: "کسی مقام پر قوت شامل کریں",
  T_46_META_WS_ADDFORMULAPROPERTYFACTOR: "فارمولا پروپرٹی فیکٹر شامل کریں",
  T_46_META_WS_ADDGAMEEVENTLOG: "کھیل کے ایونٹ لاگ شامل کریں",
  T_46_META_WS_ADDHP: "HP شامل کریں",
  T_46_META_WS_ADDITEM: "آئٹم شامل کریں",
  T_46_META_WS_ADDITEMINSCENE: "منظر میں آئٹم بنائیں",
  T_46_META_WS_ADDITEMTOSHOPITEM: "شے کو شے میں شامل کریں",
  T_46_META_WS_ADDMONEY: "پیسہ شامل کریں",
  T_46_META_WS_ADDSCRIPT: "اسکرپٹ شامل کریں",
  T_46_META_WS_ADDTAG: "ٹیگ شامل کریں",
  T_46_META_WS_ADDTOKEN: "ٹوکن شامل کریں",
  T_46_META_WS_ADDTORQUE: "ٹارک شامل کریں",
  T_46_META_WS_ADDUSEREVENTLOG: "صارف ایونٹ لاگ شامل کریں",
  T_46_META_WS_ANGEL: "زاویہ",
  T_46_META_WS_APPEND: "ضم کریں",
  T_46_META_WS_APPENDRANGE: "رینج شامل کریں",
  T_46_META_WS_APPLYQUITMIDWAYUICONFIG: "درمیان سے چھوڑنے کی UI ترتیب لاگو کریں",
  T_46_META_WS_ASIN: "Asin",
  T_46_META_WS_ASSERT: "تصدیق کریں",
  T_46_META_WS_ASSISTPLAYER: "مددگار کھلاڑی",
  T_46_META_WS_ATAN2: "ATan2",
  T_46_META_WS_ATTACKER: "حملہ آور",
  T_46_META_WS_ATTACKTARGET: "حملہ کا ہدف",
  T_46_META_WS_AXISANGLETOQUATERNION: "محور زاویے کو کوارٹرنئن میں تبدیل کریں",
  T_46_META_WS_BOXCAST: "باکس کاسٹ",
  T_46_META_WS_BOXOVERLAP: "باکس اوورلیپ",
  T_46_META_WS_BUTTONNAME: "بٹن کا نام",
  T_46_META_WS_C_ACTIONTYPE: "عمل کی قسم",
  T_46_META_WS_C_AIMABLE: "قابلِ نشانہ بنایا جا سکتا ہے",
  T_46_META_WS_C_AIMASSISTABLE: "قابلِ نشانہ بنایا جا سکتا ہے",
  T_46_META_WS_C_AIMASSISTTYPE: "مقصد کی مدد کی قسم",
  T_46_META_WS_C_AIRDROP: "فضائی ڈراپ",
  T_46_META_WS_C_AMMO: "گولہ بارود",
  T_46_META_WS_C_AMMOTYPE: "قسم الذخيرة",
  T_46_META_WS_C_AMPHIBIAN: "امفیبین",
  T_46_META_WS_C_ANIMATIONCLIP: "اینیمیشن کلپ",
  T_46_META_WS_C_ANIMATIONCLIPID: "اینیمیشن کلپ ID",
  T_46_META_WS_C_ANIMATIONCONTROLLER: "اینیمیشن کنٹرولر",
  T_46_META_WS_C_ANIMATIONCONTROLLERATTACHABLE: "اینیمیشن کنٹرولر جڑنے کے قابل",
  T_46_META_WS_C_ANIMATIONCONTROLLERID: "اینیمیشن کنٹرولر آئی ڈی",
  T_46_META_WS_C_ANIMATIONSTATE: "اینیمیشن اسٹیٹ",
  T_46_META_WS_C_ANIMATIONTRIGGER: "اینیمیشن ٹرگر",
  T_46_META_WS_C_APPEARENCE: "ظاہری شکل",
  T_46_META_WS_C_ASSETCONFIGID: "اثاث کنفیگ آئی ڈی",
  T_46_META_WS_C_ASSETID: "اثاث آئی ڈی",
  T_46_META_WS_C_ATTACHMENT: "اٹیچمنٹ",
  T_46_META_WS_C_ATTACKABLETYPE: "حملے کی قسم",
  T_46_META_WS_C_AUDIOID: "آڈیو ID",
  T_46_META_WS_C_BACKPACK: "بیگ",
  T_46_META_WS_C_BACKPACKSKINID: "بیگ کی جلد کا آئی ڈی",
  T_46_META_WS_C_BASEDATAALIAS: "بنیادی ڈیٹا عرفیت",
  T_46_META_WS_C_BASICAPPEARANCE: "بنیادی شکل",
  T_46_META_WS_C_BASICCYLINDER: "بنیادی سلنڈر یا مخروط",
  T_46_META_WS_C_BASICSCALABLE: "بنیادی اسکیل ایبل",
  T_46_META_WS_C_BASICSPHERE: "بنیادی گولا",
  T_46_META_WS_C_BATCHCOMBINERENDER: "بیچ کومبائن رینڈرنگ کمپوننٹ",
  T_46_META_WS_C_BEVTREE: "بیہیویر ٹری",
  T_46_META_WS_C_BEVTREEATTACHABLE: "بیہیویر ٹری اٹیچ ایبل",
  T_46_META_WS_C_BEVTREECUSTOMNODE: "بیہیویر ٹری کسٹم نوڈ",
  T_46_META_WS_C_BEVTREEID: "بیہیویر ٹری ID",
  T_46_META_WS_C_BEVTREENODESTATUS: "بیہیویر ٹری نوڈ کی حیثیت",
  T_46_META_WS_C_BEVTREENODETYPE: "بیہیویر ٹری نوڈ کی قسم",
  T_46_META_WS_C_BEZIERCURVE: "بیزیئر وکر",
  T_46_META_WS_C_BOOL: "بولین",
  T_46_META_WS_C_BOTDIFFICULTYTYPE: "بوٹ کی دشواری کی قسم",
  T_46_META_WS_C_BOUNCINGTIRE: "باؤنسنگ ٹائر",
  T_46_META_WS_C_BUFFABLE: "قابل بوف",
  T_46_META_WS_C_BUFFGENERATOR: "بفیجینیٹر",
  T_46_META_WS_C_BUFFTYPE: "بفی نوع",
  T_46_META_WS_C_BUILTINRENDER: "بلٹ ان رینڈر",
  T_46_META_WS_C_BUILTINUI: "بلٹ ان UI",
  T_46_META_WS_C_BUILTINUITYPE: "بلٹ ان UI قسم",
  T_46_META_WS_C_CAMERA: "کیمرہ",
  T_46_META_WS_C_CAMERABLOCKMODE: "کیمرہ بلاک موڈ",
  T_46_META_WS_C_CAMERAPROJECTIONMODE: "کیمرہ پروجیکشن موڈ",
  T_46_META_WS_C_CAMERARAYCASTUI: "کیمرہ رے کاسٹ UI",
  T_46_META_WS_C_CAMERATRANSITIONTYPE: "کیمرہ تبدیلی کی قسم",
  T_46_META_WS_C_CAMERATYPE: "کیمرا کی قسم",
  T_46_META_WS_C_CAMERAVIEWINGANGLERESTRICTIONTYPE: "کیمرہ دیکھنے کے زاویے کی پابندی کی قسم",
  T_46_META_WS_C_CAPSULETRIGGER: "کیپسول ٹرگر",
  T_46_META_WS_C_CAR: "کار",
  T_46_META_WS_C_CHARACTERCONTROLLER: "کیریکٹر کنٹرولر",
  T_46_META_WS_C_CHATCHANNEL: "چیٹ چینل",
  T_46_META_WS_C_CHATCHANNELTYPE: "چیٹ چینل کی قسم",
  T_46_META_WS_C_CHECKPOINTTRIGGER: "چیک پوائنٹ ٹرگر",
  T_46_META_WS_C_COINGENERATOR: "سکے جنریٹر",
  T_46_META_WS_C_COLLECTIONID: "مجموعہ آئی ڈی",
  T_46_META_WS_C_COLLIDER: "کولائیڈر",
  T_46_META_WS_C_COLLIDERCOLLECTION: "کولائیڈر شکل",
  T_46_META_WS_C_COLLIDERCOLLECTIONID: "کولیڈر مجموعہ ID",
  T_46_META_WS_C_COLORDRUM: "رنگین ڈرم",
  T_46_META_WS_C_COMBATABLE: "قابل لڑائی",
  T_46_META_WS_C_COMPONENT: "جز",
  T_46_META_WS_C_CONDITION: "شرط",
  T_46_META_WS_C_CONTAINER: "کنٹینر",
  T_46_META_WS_C_COORDINATESYSTEMTYPE: "نظام کی قسم",
  T_46_META_WS_C_CROSSBOW: "کراسبو بم",
  T_46_META_WS_C_CSVID: "سی ایس وی آئی ڈی",
  T_46_META_WS_C_CUSTOMIZETRIGGER: "حسب ضرورت ٹرگر",
  T_46_META_WS_C_CUSTOMLEVELOBJECT: "حسب ضرورت آبجیکٹ",
  T_46_META_WS_C_CUSTOMPATH: "حسب ضرورت راستہ",
  T_46_META_WS_C_CUSTOMUI: "حسب ضرورت UI",
  T_46_META_WS_C_CUSTOMUIID: "حسب ضرورت UI ID",
  T_46_META_WS_C_CUSTOMUIORWIDGET: "حسب ضرورت UI یا ویجیٹ",
  T_46_META_WS_C_CUSTOMUIWIDGETID: "حسب ضرورت UI وِجِٹ ID",
  T_46_META_WS_C_DAMAGEDBODYPARTTYPE: "جسمانی نقصان قسم",
  T_46_META_WS_C_DAMAGETYPE: "قسم نقصان",
  T_46_META_WS_C_DEATHORINVINCIBILITYTRIGGER: "موت یا ناقابل تسخیر ٹرگر",
  T_46_META_WS_C_DESTRUCTIBLELEVELOBJECT: "تباہ کن آبجیکٹ",
  T_46_META_WS_C_DICE: "ڈائس",
  T_46_META_WS_C_DOUBLEJUMPSHOES: "ڈبل جمپ جوتے",
  T_46_META_WS_C_DRUMMUSIC: "ڈرم میوزک",
  T_46_META_WS_C_DUALWIELDWEAPONTYPE: "دوہری ہتھیار کی قسم",
  T_46_META_WS_C_DUMMYLEVELOBJECT: "عام سطح کا آبجیکٹ",
  T_46_META_WS_C_DYNAMICCREATELEVELOBJECTTYPE: "متحرک تخلیق سطح کا آبجیکٹ کی قسم",
  T_46_META_WS_C_DYNAMICFENCE: "متحرک باڑ",
  T_46_META_WS_C_EFFECT: "اثر",
  T_46_META_WS_C_EFFECTCONTAINER: "ایفیکٹ کنٹینر",
  T_46_META_WS_C_EFFECTID: "اثرات ID",
  T_46_META_WS_C_EMOTETYPE: "قسم إيموت",
  T_46_META_WS_C_ENDPOINTTRIGGER: "اختتامی نقطہ ٹرگر",
  T_46_META_WS_C_ENTITY: "موجودیت",
  T_46_META_WS_C_ENTITYORPREFABID: "مخلوق یا پری فاب آئی ڈی",
  T_46_META_WS_C_EQUIPMENTATTACHMENT: "ساز و سامان کی ملحقات",
  T_46_META_WS_C_EQUIPMENTSLOTTYPE: "سازوسامان سلاٹ کی قسم",
  T_46_META_WS_C_EQUIPMENTTYPE: "سازوسامان کی قسم",
  T_46_META_WS_C_EVENTID: "شناختی واقعہ",
  T_46_META_WS_C_FACTION: "فرقہ",
  T_46_META_WS_C_FILLDIRECTIONTYPE: "بھرنے کی سمت کی قسم",
  T_46_META_WS_C_FILLTYPE: "بھرنے کی قسم",
  T_46_META_WS_C_FIRETYPE: "قسم النار",
  T_46_META_WS_C_FLOAT: "فلوٹ",
  T_46_META_WS_C_FOLDWING: "فولڈنگ پंख",
  T_46_META_WS_C_FOLLOW: "پیروی کریں",
  T_46_META_WS_C_FONTTYPE: "فونٹ کی قسم",
  T_46_META_WS_C_FOOTBALL: "فٹ بال",
  T_46_META_WS_C_FORCETYPE: "فورس قسم",
  T_46_META_WS_C_FORMULABLE: "قابل فارمولہ",
  T_46_META_WS_C_FRAMESELFRELATIVE: "فریم خود نسبتی",
  T_46_META_WS_C_GAMERESULTTYPE: "کھیل کے نتائج کی قسم",
  T_46_META_WS_C_GENDERTYPE: "جنس",
  T_46_META_WS_C_GENERALSPAWNPOINT: "عمومی اسپاون پوائنٹ",
  T_46_META_WS_C_GRENADEDEICEWALL: "آئس وال ڈی-گرینیڈ",
  T_46_META_WS_C_GRENADEFLASHBANG: "فلیش بین",
  T_46_META_WS_C_GRENADEFROZEN: "منجمد دستی بمب",
  T_46_META_WS_C_GRENADELAUNCHER: "دستی بم فائرنگ کرنے والا",
  T_46_META_WS_C_GRENADESMOKE: "دھواں گرینیڈ",
  T_46_META_WS_C_GRENADEWEAPON: "دستی بم کی بنیاد",
  T_46_META_WS_C_GRID: "گرڈ",
  T_46_META_WS_C_HANDCANNON: "ہینڈ کینن بم",
  T_46_META_WS_C_HELMET: "ہیلمٹ",
  T_46_META_WS_C_HIERARCHICAL: "درختی",
  T_46_META_WS_C_HOOKGUN: "ہُک گن",
  T_46_META_WS_C_HORIZALINE: "افقی لائن",
  T_46_META_WS_C_HUDTRANSFORM_DEPRECATED: "UI ٹرانسفارمر",
  T_46_META_WS_C_HUMANMODELID: "انسانی ماڈل کا آئی ڈی",
  T_46_META_WS_C_ICEWALL: "دیوار برف",
  T_46_META_WS_C_ICEWALLCREATED: "بنائی گئی برف کی دیوار",
  T_46_META_WS_C_ICEWALLMAKER: "برف کی دیوار بنانے والا",
  T_46_META_WS_C_ICON: "آئیکن اینٹیٹی",
  T_46_META_WS_C_ICONTYPE: "قسم الأيقونة",
  T_46_META_WS_C_INHALER: "انہیلر",
  T_46_META_WS_C_INT: "عدد صحیح",
  T_46_META_WS_C_INT64: "64 بٹ عدد صحیح",
  T_46_META_WS_C_INTEGERMAPTEMPLATE: "عدد صحیح کا نقشہ ٹیمپलेट",
  T_46_META_WS_C_INTORINTLIST: "عدد یا عددوں کی فہرست",
  T_46_META_WS_C_INVENTORYTYPE: "انوکھا قسم",
  T_46_META_WS_C_ITEMBASE: "آئٹم بیس",
  T_46_META_WS_C_ITEMCONTAINER: "آئٹم کنٹینر",
  T_46_META_WS_C_ITEMID: "آئٹم آئی ڈی",
  T_46_META_WS_C_ITEMIDTYPE: "قسم معرّف العنصر",
  "T_46_META_WS_C_JERSEY STYLE": "جرس کے انداز",
  T_46_META_WS_C_JERSEYMACHINE: "جर्सی مشین",
  T_46_META_WS_C_JETSHOES: "جیٹ جوتے",
  T_46_META_WS_C_KEYBOARD: "کی بورڈ",
  T_46_META_WS_C_KNOCKDOWNTYPE: "نزلنے کی قسم",
  T_46_META_WS_C_LANDMINE: "بارودی سرنگ",
  T_46_META_WS_C_LANDMINECREATED: "بنائی گئی بارودی سرنگ",
  "T_46_META_WS_C_LAUNCH PAD LEVEL OBJECT": "لانچ پیڈ لیول آبجیکٹ",
  T_46_META_WS_C_LAUNCHPAD: "لانچ پیڈ",
  T_46_META_WS_C_LAYOUTSORTTYPE: "لے آؤٹ ترتیب کی قسم",
  T_46_META_WS_C_LEAD1MUSIC: "لیڈ1 میوزک",
  T_46_META_WS_C_LEAD2MUSIC: "لیڈ2 میوزک",
  T_46_META_WS_C_LEAD3MUSIC: "لیڈ3 میوزک",
  T_46_META_WS_C_LEVELOBJECTID: "سطح آبجیکٹ آئی ڈی",
  T_46_META_WS_C_LEVELOBJECTTYPE: "لیول آبجیکٹ قسم",
  T_46_META_WS_C_LIST: "فہرست",
  T_46_META_WS_C_LISTORMAP: "فہرست یا نقشہ",
  T_46_META_WS_C_LISTT: "فہرست کا نمونہ",
  T_46_META_WS_C_LISTT_BOOL: "بولین کی فہرست",
  T_46_META_WS_C_LISTT_CONDITION: "فہرست حالات",
  T_46_META_WS_C_LISTT_ENTITY: "موجودات کی فہرست",
  T_46_META_WS_C_LISTT_FLOAT: "فلوٹ لسٹ",
  T_46_META_WS_C_LISTT_INT: "عدد کی فہرست",
  T_46_META_WS_C_LISTT_ITEMGOODSIDTYPE: "اشیاء کی فہرست",
  T_46_META_WS_C_LISTT_LEVELOBJECT: "سطح کی فہرست",
  T_46_META_WS_C_LISTT_LOCKEY: "مقامی سازی کی کلید لسٹ",
  T_46_META_WS_C_LISTT_PLAYABLE: "قابل عمل فہرست",
  T_46_META_WS_C_LISTT_PLAYER: "کھلاڑیوں کی فہرست",
  T_46_META_WS_C_LISTT_SKILLID: "ہنر کی فہرست",
  T_46_META_WS_C_LISTT_SOUNDEFFECT: "صوتی اثرات کی فہرست",
  T_46_META_WS_C_LISTT_STRING: "سٹرنگ لسٹ",
  T_46_META_WS_C_LISTT_TEAM: "ٹیم کی فہرست",
  T_46_META_WS_C_LISTT_TYPE: "اقسام کی فہرست",
  T_46_META_WS_C_LISTT_VECTOR3: "ویکٹر3 لسٹ",
  T_46_META_WS_C_LOCKEY: "لوكالائزیشن کی چابی",
  T_46_META_WS_C_LOOKAT: "دیکھیں",
  T_46_META_WS_C_LOOPABLE: "قابل لوپ",
  T_46_META_WS_C_LOOPTYPE: "لوپ ٹائپ",
  T_46_META_WS_C_LOOTAMMOTYPE: "لوٹ گولیوں کی قسم",
  T_46_META_WS_C_LOOTARMOR: "لوٹ باڈی آرمور",
  T_46_META_WS_C_LOOTARMORTYPE: "لوٹ باڈی آرمور کی قسم",
  T_46_META_WS_C_LOOTCONSUMABLE: "لوٹ مصرف کی چیز",
  T_46_META_WS_C_LOOTCONSUMABLETYPE: "لوٹ مصرف کی چیزوں کی قسم",
  T_46_META_WS_C_LOOTIAMMO: "لوٹ گولیاں",
  T_46_META_WS_C_LOOTITEMBOXSOCCER: "لوٹ فٹ بال آئٹم باکس",
  T_46_META_WS_C_LOOTSCOPE: "لوٹ اسکوپ",
  T_46_META_WS_C_LOOTSCOPETYPE: "لوٹ اسکوپ کی قسم",
  T_46_META_WS_C_LOOTSOCCERTYPE: "لوٹ فٹ بال کا قسم",
  T_46_META_WS_C_LOOTTHROWABLE: "لوٹ پھینکنے والی چیز",
  T_46_META_WS_C_LOOTTHROWABLETYPE: "لوٹ پھینکنے والی چیز کی قسم",
  T_46_META_WS_C_LOOTWEAPON: "لوٹ ہتھیار",
  T_46_META_WS_C_LOOTWEAPONTYPE: "لوٹ ہتھیار کی قسم",
  T_46_META_WS_C_LOWGRAVITY: "کم کشش ثقل کا علاقہ",
  T_46_META_WS_C_MAP: "نقشہ",
  T_46_META_WS_C_MAPT: "نقشہ سانچہ",
  T_46_META_WS_C_MATERIALID: "مواد ID",
  T_46_META_WS_C_MEDKIT: "طبی کٹ",
  T_46_META_WS_C_MESHID: "میش آئی ڈی",
  T_46_META_WS_C_MIDGAMEEXITCONFIG: "کھیل کے وسط میں باہر نکلنے کی ترتیب",
  T_46_META_WS_C_MINIMAP: "منی میپ",
  T_46_META_WS_C_MINIMAPICON: "منی میپ آئیکن",
  T_46_META_WS_C_MINIMAPPIXELRENDERER: "منی میپ پکسل رینڈرر",
  T_46_META_WS_C_MINISENTRY: "منی سینٹری",
  T_46_META_WS_C_MINISENTRYATTACKRANGETYPE: "منی سینٹری اٹیک رینج ٹائپ",
  T_46_META_WS_C_MINISENTRYCREATED: "منی سینٹری تخلیق شدہ",
  T_46_META_WS_C_MONEY: "پیسہ",
  T_46_META_WS_C_MONEYTYPE: "پیسہ کی قسم",
  T_46_META_WS_C_MONSTER: "مونسٹر",
  T_46_META_WS_C_MONSTERSPAWN: "مونسٹر اسپان",
  T_46_META_WS_C_MONSTERTYPE: "قسم الوحش",
  T_46_META_WS_C_MORPHABLEOBJECT: "مورف کرنے کے قابل آبجیکٹ",
  T_46_META_WS_C_MORPHOBJECT: "مورف آبجیکٹ",
  T_46_META_WS_C_MOTOBIKE: "موٹر سائیکل",
  T_46_META_WS_C_MOVEPLATFORM: "موو پلیٹ فارم",
  T_46_META_WS_C_MOVEPLATFORMTYPE: "موو پلیٹ فارم کی قسم",
  T_46_META_WS_C_MUSHROOM: "مشروم",
  T_46_META_WS_C_NATURALCONSTANTTYPE: "قدرتی مستقل",
  T_46_META_WS_C_NPC: "NPC",
  T_46_META_WS_C_NUMBER: "نمبر",
  T_46_META_WS_C_OBJECT: "شے",
  T_46_META_WS_C_OILDRUM: "تیل کا ڈھکن",
  T_46_META_WS_C_OUTFITID: "لباس کا آئی ڈی",
  T_46_META_WS_C_OUTFITSLOTTYPE: "لباس کی جگہ کی قسم",
  T_46_META_WS_C_PATHPOINT: "پوائنٹ آف پاتھ",
  T_46_META_WS_C_PATROLSTYLETYPE: "قسم اسلوب الدورية",
  T_46_META_WS_C_PATROLTYPE: "قسم الدورية",
  T_46_META_WS_C_PERSONA: "شخصیت",
  T_46_META_WS_C_PHASE: "مرحلہ",
  T_46_META_WS_C_PHYSICALMOVER: "فزیکل موور",
  T_46_META_WS_C_PHYSICALOBJECT: "فزیکل آبجیکٹ",
  T_46_META_WS_C_PLATFORMTYPE: "پلیٹ فارم کی قسم",
  T_46_META_WS_C_PLAYABLE: "قابل کھیلنے",
  T_46_META_WS_C_PLAYABLEORPLAYABLES: "پلے ایبل یا پلے ایبلز کا سیٹ",
  T_46_META_WS_C_PLAYER: "کھلاڑی",
  T_46_META_WS_C_PLAYERBACKPACK: "کھلاڑی کے بیگ",
  T_46_META_WS_C_PLAYERBEHAVIORSTATUSTYPE: "کھلاڑی کے رویے کی حیثیت کی قسم",
  T_46_META_WS_C_PLAYERBEHAVIORTYPE: "کھلاڑی کا رویہ کی قسم",
  T_46_META_WS_C_PLAYERCCT: "FF کردار کے لیے کیریکٹر کنٹرولر",
  T_46_META_WS_C_PLAYERDATAID: "پری سیٹ کردار کی قسم",
  T_46_META_WS_C_PLAYERORTRANSFORM: "کھلاڑی یا تبدیلی",
  T_46_META_WS_C_PLAYERORVEHICLE: "کھلاڑی یا گاڑی",
  T_46_META_WS_C_PLAYEROUTFIT: "کھلاڑی کی پوشاک",
  T_46_META_WS_C_PLAYERPOSETYPE: "کھلاڑی کی پوز کی قسم",
  T_46_META_WS_C_PLAYERREVIVESOURCETYPE: "کھلاڑی کی دوبارہ زندہ رہنے کا ماخذ",
  T_46_META_WS_C_PLAYERSTATETYPE: "کھلاڑی کی حالت کی قسم",
  T_46_META_WS_C_POINTLIGHT: "پوائنٹ لائٹ",
  T_46_META_WS_C_PORTAL: "پورٹل",
  T_46_META_WS_C_PREFABID: "پری فاب آئی ڈی",
  T_46_META_WS_C_PRESENTEFFECTGENERATOR_DEPRECATED: "پریزنٹ ایفیکٹ جنریٹر",
  T_46_META_WS_C_PRESENTEFFECTTEXTURETYPE_DEPRECATED: "اثر ٹیکسچر قسم",
  T_46_META_WS_C_PROFILEPICTUREWIDGET: "پروفائل پکچر ویجیٹ",
  T_46_META_WS_C_PROPERTY: "پراپرٹی",
  T_46_META_WS_C_PROPERTYFORMULA: "پراپرٹی فارمولا",
  T_46_META_WS_C_PROPERTYFORMULAFACTORTYPE: "پراپرٹی فارمولا فیکٹر کی قسم",
  T_46_META_WS_C_PROPERTYMODIFYTYPE: "پراپرٹی میں تبدیلی کی قسم",
  T_46_META_WS_C_QUATERNION: "کواٹرنین",
  T_46_META_WS_C_RANKABLE: "رتبable",
  T_46_META_WS_C_RAYCASTLAYERTYPE: "رے کاسٹ لیئر کی قسم",
  T_46_META_WS_C_REPAIRKIT: "مرمت کٹ",
  T_46_META_WS_C_RESETABLE: "قابل ری سیٹ",
  T_46_META_WS_C_RIGIDBODY: "رگڈ باڈی",
  T_46_META_WS_C_RIGIDBODYCONSTRAINTYPE: "رگڈ باڈی کنسٹرین قسم",
  T_46_META_WS_C_RIGIDBODYTYPE: "رگڈ باڈی قسم",
  T_46_META_WS_C_ROUND: "راؤنڈ",
  T_46_META_WS_C_SAFEZONE: "محفوظ علاقے",
  T_46_META_WS_C_SCOREABLE: "اسکور کرنے کے قابل",
  T_46_META_WS_C_SCRIPTID: "اسکرپٹ ID",
  T_46_META_WS_C_SEATTYPE: "سیٹ کی قسم",
  T_46_META_WS_C_SELFRELATIVE: "خود نسبتی",
  T_46_META_WS_C_SHOP: "شاپ",
  T_46_META_WS_C_SHOPITEM: "شاپ آئٹم",
  T_46_META_WS_C_SHOPSHELF: "شاپ شیلف",
  T_46_META_WS_C_SKATEBOARD: "اسکیٹ بورڈ",
  T_46_META_WS_C_SKELETON: "کھوکھلی ہڈی",
  T_46_META_WS_C_SKELETONPART: "ہڈی کا حصہ",
  T_46_META_WS_C_SKILLID: "مہارت کا شناختی کارڈ",
  T_46_META_WS_C_SKYBLASTER: "پرواز کرنے والا آل",
  T_46_META_WS_C_SKYBOX: "آسمان باکس",
  T_46_META_WS_C_SKYBOXTYPE: "نوع السماء",
  T_46_META_WS_C_SOCIALISLANDSNOWBALL: "سماجی جزیرہ برف کا گولا",
  T_46_META_WS_C_SORTTYPE: "قسم الترتيب",
  T_46_META_WS_C_SOUNDDRUMTYPE: "ڈرم کی قسم کی آواز",
  T_46_META_WS_C_SOUNDEFFECT: "صوتی اثر",
  T_46_META_WS_C_SOUNDEFFECTORSOUNDEFFECTLIST: "صوتی اثر یا صوتی اثرات کی فہرست",
  T_46_META_WS_C_SOUNDEFFECTTYPE: "قسم التأثير الصوتي",
  T_46_META_WS_C_SOUNDLEAD1TYPE: "لیڈ 1 کی قسم کی آواز",
  T_46_META_WS_C_SOUNDLEAD2TYPE: "لیڈ 2 کی قسم کی آواز",
  T_46_META_WS_C_SOUNDLEAD3TYPE: "لیڈ 3 کی قسم کی آواز",
  T_46_META_WS_C_SOUNDPIANOTYPE: "پیانو کی قسم کی آواز",
  T_46_META_WS_C_SPAWN: "اسپان",
  T_46_META_WS_C_SPAWNABLE: "قابل اسپورن",
  T_46_META_WS_C_SPAWNBOX: "اسپان باکس",
  T_46_META_WS_C_SPAWNPOSITION: "اسپان پوائنٹ",
  T_46_META_WS_C_SPECIALITEMIDTYPE: "خصوصی آئٹم ID کی قسم",
  T_46_META_WS_C_SPHERETRIGGER: "گیند کا ٹرگر",
  T_46_META_WS_C_SPORTSCAR: "اسپورٹس کار",
  T_46_META_WS_C_SPRAYCOLOR: "اسپرے رنگ",
  T_46_META_WS_C_SPRAYGUN: "اسپرے گن",
  T_46_META_WS_C_SPRAYRESULTUI: "اسپرے رزلٹ UI",
  T_46_META_WS_C_SPRAYRIFLE: "اسپرے رائفل",
  T_46_META_WS_C_SPRITEID: "اسپرائٹ ID",
  T_46_META_WS_C_STATICSCRIPTID: "اسٹیٹک اسکرپٹ ID",
  T_46_META_WS_C_STRING: "سٹرنگ",
  T_46_META_WS_C_STRINGORLOCSTRING: "سٹرنگ یا مقامی کردہ سٹرنگ",
  T_46_META_WS_C_SUPPLYBOXTRIGGER: "سپلائی باکس ٹرگر",
  T_46_META_WS_C_SWINGGUN: "جھولنے والا گن",
  T_46_META_WS_C_SWITCHEQUIPSLOT: "سوئچ سازوسامان کا خانہ",
  T_46_META_WS_C_TEAM: "ٹیم",
  T_46_META_WS_C_TERRAIN: "زمین",
  T_46_META_WS_C_TEXT: "ٹیکسٹ اینٹیٹی",
  T_46_META_WS_C_TEXTUREID: "ٹیکسچر ID",
  T_46_META_WS_C_TEXTURETYPE: "آبجیکٹ ٹیکسچر",
  T_46_META_WS_C_TIMER: "ٹائمر",
  T_46_META_WS_C_TIMESTAMPFORMATSTYLETYPE: "وقت کی مہربند اسٹائل کی قسم",
  T_46_META_WS_C_TIMESTAMPLOCSTRING: "ٹائم اسٹیمپ مقامی نوع",
  T_46_META_WS_C_TRAJECTORY: "راہ",
  T_46_META_WS_C_TRANSFORM: "تبدیلی",
  T_46_META_WS_C_TUKTUK: "ٹک ٹک",
  T_46_META_WS_C_TURRET: "ٹورٹ",
  T_46_META_WS_C_TWEEN: "ٹوئن",
  T_46_META_WS_C_TWEENCURVE_DEPRECATED: "ٹوئن وکر",
  T_46_META_WS_C_TWEENSTYLE: "ٹوئن اسٹائل ٹائپ",
  T_46_META_WS_C_TYPE: "نوع",
  T_46_META_WS_C_TYPEENUM: "نوع اینم",
  T_46_META_WS_C_TYPEORTYPELIST: "قسم یا قسم کی فہرست",
  T_46_META_WS_C_UIADDSCORE: "UI اسکور شامل کریں",
  T_46_META_WS_C_UIANITRIGGERHUD: "UI اینیمیشن ٹریگر HUD",
  T_46_META_WS_C_UIBUILTINSWITCH: "UI بلٹ ان سوئچ",
  T_46_META_WS_C_UIBUILTINUISWITCHCONTROLLER: "بلٹ ان UI سوئچ کنٹرولر",
  T_46_META_WS_C_UICARDSELECTIONPANEL: "UI کارڈ سلیکشن پینل",
  T_46_META_WS_C_UICHECKPOINTINDICATOR: "UI چیک پوائنٹ انڈیکیٹر",
  T_46_META_WS_C_UICOMPASS: "UI قطب نما",
  T_46_META_WS_C_UICOUNTDOWN5: "UI پانچ سیکنڈ کا کاؤنٹ ڈاؤن",
  T_46_META_WS_C_UICOUNTDOWNHINT: "UI کاؤنٹ ڈاؤن ہنٹ",
  T_46_META_WS_C_UICOUNTDOWNREMINDER: "UI کاؤنٹ ڈاؤن یاد دہانی",
  T_46_META_WS_C_UIFOLLOWHEADLTHBAR: "کردار کے سر کے اوپر صحت کی پٹی",
  T_46_META_WS_C_UIHEALTHBAR: "UI صحت کی بار",
  T_46_META_WS_C_UIHEARTBEAT: "UI دل کی دھڑکن",
  T_46_META_WS_C_UIICONNOTIFICATION: "UI آئیکن اطلاع",
  T_46_META_WS_C_UIIDENTITYNOTIFICATION: "UI شناخت کی اطلاع",
  T_46_META_WS_C_UIINTERACTIONBUTTON: "UI انٹرایکشن بٹن",
  T_46_META_WS_C_UILEADERBOARDBUTTON: "UI لیڈر بورڈ بٹن",
  T_46_META_WS_C_UIMATCHSUBTITLE: "UI میچ سب ٹائٹل",
  T_46_META_WS_C_UIMONSTERLEVEL: "UI مونسٹر کی سطح",
  T_46_META_WS_C_UIMONSTERUI: "UI مونسٹر UI",
  T_46_META_WS_C_UIMULTIPLETEAMLEADERBOARD: "UI ملٹی ٹیم لیڈر بورڈ",
  T_46_META_WS_C_UIMULTITEAMRESULTPANEL: "UI ملٹی ٹیم نتیجہ پینل",
  T_46_META_WS_C_UIOPENINGBANNER: "UI اوپننگ بینر",
  T_46_META_WS_C_UIPANEL: "UI پینل",
  T_46_META_WS_C_UIPANELEMPTY: "خالی UI پینل",
  T_46_META_WS_C_UIPHASETIMER: "UI مرحلہ ٹائمر",
  T_46_META_WS_C_UIPROGRESSBAR: "UI پروگریس بار",
  T_46_META_WS_C_UIPROGRESSCIRCLE: "UI پروگریس سرکل",
  T_46_META_WS_C_UIPROGRESSSKILLBUTTON: "UI پروگریس اسکل بٹن",
  T_46_META_WS_C_UIREQUESTPURCHASETYPE: "UI خریداری کی درخواست کی قسم",
  T_46_META_WS_C_UIROUNDINFOBANNER: "UI راؤنڈ معلومات کا بینر",
  T_46_META_WS_C_UIROUNDNUMBER: "UI راؤنڈ نمبر",
  T_46_META_WS_C_UIROUNDRESULTBANNER: "UI راؤنڈ نتیجہ بینر",
  T_46_META_WS_C_UIROUNDSTARTBANNER: "UI راؤنڈ اسٹارٹ بینر",
  T_46_META_WS_C_UIROUNDTRANSITION: "UI راؤنڈ ٹرانزیشن",
  T_46_META_WS_C_UISCOREBAR: "UI اسکور بار",
  T_46_META_WS_C_UISCROLLPANEL: "UI اسکرول پینل",
  T_46_META_WS_C_UISIMPLEROUNDSCOREBANNER: "UI سادہ راؤنڈ اسکور بینر",
  T_46_META_WS_C_UISIMPLEROUNDSTARTBANNER: "UI سادہ راؤنڈ اسٹارٹ بینر",
  T_46_META_WS_C_UISIMPLETIP: "سادہ UI ٹپ",
  T_46_META_WS_C_UISIMPLEVERSUSBANNER: "UI سادہ مقابلہ بینر",
  T_46_META_WS_C_UISKILLBUTTON: "UI اسکل بٹن",
  T_46_META_WS_C_UISOCIALBUTTONWIDGET: "سماجی فنکشن کے لیے بٹن وجیٹ",
  T_46_META_WS_C_UISOLOLEADERBOARD: "UI سولو لیڈر بورڈ",
  T_46_META_WS_C_UISTORE: "UI اسٹور UI",
  T_46_META_WS_C_UITEAMMATCHINFO: "UI ٹیم میچ کی معلومات",
  T_46_META_WS_C_UITEXTTIP: "UI ٹیکسٹ ٹپ",
  T_46_META_WS_C_UITIMERINFO: "UI ٹائمر معلومات",
  T_46_META_WS_C_UITIPBUTTON: "UI ٹپ بٹن",
  T_46_META_WS_C_UITITLEBANNER: "UI ٹائٹل بینر",
  T_46_META_WS_C_UITWEENTIP: "UI ٹوئن ٹپ",
  T_46_META_WS_C_UITWOTEAMBRIEFINFO: "UI دو ٹیموں کی مختصر معلومات",
  T_46_META_WS_C_UITWOTEAMINFO: "UI دو ٹیموں کی معلومات",
  T_46_META_WS_C_UITWOTEAMLEADERBOARD: "UI دو ٹیموں کی لیڈر بورڈ",
  T_46_META_WS_C_UITWOTEAMRESULTPANEL: "UI دو ٹیموں کا نتیجہ پینل",
  T_46_META_WS_C_UITWOTEAMROUNDSCOREBANNER: "UI دو ٹیموں کا راؤنڈ اسکور بینر",
  T_46_META_WS_C_UITWOTEAMSCOREPANEL: "UI دو ٹیموں کا اسکور پینل",
  T_46_META_WS_C_UIVERSUSBANNER: "UI مقابلہ بینر",
  T_46_META_WS_C_UIWIDGET: "UI ویجیٹ",
  T_46_META_WS_C_UIWIDGETBUTTON: "UI ویجیٹ بٹن",
  T_46_META_WS_C_UIWIDGETCONTAINER: "UI ویجیٹ کنٹینر",
  T_46_META_WS_C_UIWIDGETEMPTY: "خالی UI ویجیٹ",
  T_46_META_WS_C_UIWIDGETIMAGE: "UI ویجیٹ تصویر",
  T_46_META_WS_C_UIWIDGETINPUTLABLE: "UI ویجیٹ انپٹ لیبل",
  T_46_META_WS_C_UIWIDGETJOYSTICK: "UI ویجیٹ جوائس اسٹک",
  T_46_META_WS_C_UIWIDGETLABEL: "UI ویجیٹ لیبل",
  T_46_META_WS_C_UIWIDGETLAYOUT: "UI ویجیٹ لے آؤٹ",
  T_46_META_WS_C_UIWIDGETPROFILE: "UI ویجیٹ پروفائل",
  T_46_META_WS_C_UIWIDGETTEXTURE: "UI ویجیٹ ٹیکسچر",
  T_46_META_WS_C_UIWIDGETTOGGLE: "UI ویجیٹ ٹوگل",
  T_46_META_WS_C_UIWIDGETTOUCHPAD: "UI ویجیٹ ٹچ پیڈ",
  T_46_META_WS_C_UIWINORLOSEBANNER: "UI جیت یا ہار کا بینر",
  T_46_META_WS_C_UNITSPAWN: "یونٹ اسپاون",
  T_46_META_WS_C_UUID: "UUID",
  T_46_META_WS_C_VAULTTRIGGER: "کھڑکی چڑھنے کی منطق کی اشیاء",
  T_46_META_WS_C_VECTOR2: "ویكتور 2",
  T_46_META_WS_C_VECTOR3: "ویكتور 3",
  T_46_META_WS_C_VEHICLE: "گاڑی",
  T_46_META_WS_C_VEHICLEIDTYPE: "گاڑی کا آئی ڈی ٹائپ",
  T_46_META_WS_C_VEHICLESKINID: "گاڑی کی جلد کا ID",
  T_46_META_WS_C_VENDINGMACHINE: "وینڈنگ مشین",
  T_46_META_WS_C_VEST: "جَیْلِٹ",
  T_46_META_WS_C_VFXREPLACETEXTPRESENT: "VFX قابل تبدیل ٹیکسچر اینٹیٹی",
  T_46_META_WS_C_VFXTEXTURE: "VFX ٹیکسچر",
  T_46_META_WS_C_VISIBILITY: "نظر آنا",
  T_46_META_WS_C_WALLET: "بگھتہ",
  T_46_META_WS_C_WALLETHUD: "بگھتہ UI",
  T_46_META_WS_C_WATERZONE: "پانی کا علاقہ",
  T_46_META_WS_C_WAVECOUNTTYPE: "قسم الموجة",
  T_46_META_WS_C_WAVEINTERVALTYPE: "قسم الفاصل الزمني للموجة",
  T_46_META_WS_C_WEAPON: "ہتھیار",
  T_46_META_WS_C_WEAPONGENERATOR: "ہتھیار جنریٹر",
  T_46_META_WS_C_WEAPONSKINID: "ہتھیار کی جلد کا آئی ڈی",
  T_46_META_WS_C_WEAPONTYPE: "ہتھیار کی قسم",
  T_46_META_WS_C_WIDGETTYPE: "ویجٹ کی قسم",
  T_46_META_WS_C_ZIPLINE: "زپ لائن",
  T_46_META_WS_CAMERADIRECTION: "کیمرے کی سمت",
  T_46_META_WS_CAMERAPOSITION: "کیمرے کی پوزیشن",
  T_46_META_WS_CAPSULECAST: "کیپسول کاسٹ",
  T_46_META_WS_CAPSULEOVERLAP: "کیپسول اوورلیپ",
  T_46_META_WS_CEIL: "اوپر گول کریں",
  T_46_META_WS_CHATCHANNEL: "چیٹ چینل",
  T_46_META_WS_CHECKTRIGGERBYORDER: "ترتیب کے مطابق ٹرگر کی جانچ کریں",
  T_46_META_WS_CLAMP: "کلمپ",
  T_46_META_WS_CLEAR: "صاف کریں",
  T_46_META_WS_CLEARALLCHILDREN: "تمام بچوں کو صاف کریں",
  T_46_META_WS_CLEARAOISPECIALFOLLOW: "AOI خاص پیروی صاف کریں",
  T_46_META_WS_CLEARBACKPACK: "بیگ خالی کریں",
  T_46_META_WS_CLEARFORMULAPROPERTYFACTOR: "فارمولا پروپرٹی فیکٹر صاف کریں",
  T_46_META_WS_CLEARRESIDUALLEVELOBJECTS: "باقی بچنے والے لیول کے آبجیکٹس صاف کریں",
  T_46_META_WS_CLIPNAME: "کلپ کا نام",
  T_46_META_WS_CLONE: "کلون",
  T_46_META_WS_COLLIDEDENTITY: "ٹکرانے والی ہستی",
  T_46_META_WS_COLORGET: "رنگ حاصل کریں",
  T_46_META_WS_COMPLETECUSTOMMISSION: "حسب ضرورت مشن مکمل کریں",
  T_46_META_WS_CONNECT: "جوڑیں",
  T_46_META_WS_CONSUMABLEID: "آئٹم کی شناخت",
  T_46_META_WS_CONTAIN: "شامل ہے",
  T_46_META_WS_CONTAINKEY: "چابی موجود ہے",
  T_46_META_WS_COPYTOMORPH: "تبدیلی کی کاپی بنائیں",
  T_46_META_WS_COS: "Cos",
  T_46_META_WS_COSTMONEY: "پیسہ خرچ کریں",
  T_46_META_WS_COSTTOKEN: "ٹوکن خرچ کریں",
  T_46_META_WS_CREATEAIRDROP: "ایئر ڈراپ بنائیں",
  T_46_META_WS_CREATEBOT: "بوٹس بنائیں",
  T_46_META_WS_CREATEBUILTINUI: "بلٹ ان UI بنائیں",
  T_46_META_WS_CREATEBUILTINUICLIENT: "بلٹ ان UI بنائیں",
  T_46_META_WS_CREATECAMERA: "کیمرہ بنائیں",
  T_46_META_WS_CREATECURVE: "وکر بنائیں",
  T_46_META_WS_CREATECUSTOMUI: "حسب ضرورت UI بنائیں",
  T_46_META_WS_CREATECUSTOMUICLIENT: "حسب ضرورت UI بنائیں",
  T_46_META_WS_CREATECUSTOMUIWIDGET: "حسب ضرورت UI ویجیٹ بنائیں",
  T_46_META_WS_CREATEDAMAGENUM: "نقصان نمبر بنائیں",
  T_46_META_WS_CREATEEFFECT: "اثر بنائیں",
  T_46_META_WS_CREATEEFFECTCLIENT: "اثر بنائیں",
  T_46_META_WS_CREATEFACTION: "فیکشن بنائیں",
  T_46_META_WS_CREATEFOLLOW: "پیروی بنائیں",
  T_46_META_WS_CREATEFRAMESELFRELATIVE: "ہر فریم میں خود سے متعلق بنائیں",
  T_46_META_WS_CREATEFROMPREFAB: "پریفیب سے بنائیں",
  T_46_META_WS_CREATELEVELOBJECT: "لیول کا آبجیکٹ بنائیں",
  T_46_META_WS_CREATELOOKAT: "دیکھیں بنائیں",
  T_46_META_WS_CREATEMINIMAPICON: "منی میپ آئیکن بنائیں",
  T_46_META_WS_CREATEMINIMAPPIXEL: "منی میپ پکسل بنائیں",
  T_46_META_WS_CREATEMONSTER: "مونسٹر بنائیں",
  T_46_META_WS_CREATEMORPH: "تبدیلی بنائیں",
  T_46_META_WS_CREATESELFRELATIVE: "خود سے متعلق بنائیں",
  T_46_META_WS_CREATESHOP: "دکان بنائیں",
  T_46_META_WS_CREATESHOPITEM: "شے بنائیں",
  T_46_META_WS_CREATESHOPSHELF: "دکان کی شیلف بنائیں",
  T_46_META_WS_CREATESOUND: "آواز بنائیں",
  T_46_META_WS_CREATESOUNDCLIENT: "آواز بنائیں",
  T_46_META_WS_CREATETOKENINSCENE: "منظر میں ٹوکن بنائیں",
  T_46_META_WS_CREATETRAJECTORY: "راستہ بنائیں",
  T_46_META_WS_CREATETWEEN: "ٹوئن بنائیں",
  T_46_META_WS_CREATEWALLET: "والٹ بنائیں",
  T_46_META_WS_CROSS: "کراس",
  T_46_META_WS_CSVCOLUMNNAMETOINT: "CSV کالم نام کو عددی میں تبدیل کریں",
  T_46_META_WS_CURRENTAMMOCOUNT: "موجودہ گولہ بارود کی تعداد",
  T_46_META_WS_DAMAGE: "نقصان",
  T_46_META_WS_DAMAGEDBODYPART: "نقصان زدہ جسم کا حصہ",
  T_46_META_WS_DAMAGEDPLAYERS: "نقصان زدہ کھلاڑی",
  T_46_META_WS_DAMAGETYPE: "نقصان کی قسم",
  T_46_META_WS_DEALDAMAGE: "نقصان پہنچائیں",
  T_46_META_WS_DELETE: "حذف کریں",
  T_46_META_WS_DELETEAT: "حذف کریں",
  T_46_META_WS_DELETECUSTOMUI: "حسب ضرورت UI کو حذف کریں",
  T_46_META_WS_DELETEFROMDATABASE: "ڈیٹا بیس سے حذف کریں",
  T_46_META_WS_DELETEFROMDATASTORE: "ڈیٹا اسٹور سے حذف کریں",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYKEY: "کلید کے ذریعہ لیڈربورڈ ڈیٹا بیس سے حذف کریں",
  T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYRANK: "رینک کے ذریعہ لیڈربورڈ ڈیٹا بیس سے حذف کریں",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYKEY: "کلید کے ذریعہ لیڈربورڈ ڈیٹا اسٹور سے حذف کریں",
  T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYRANK: "رینک کے ذریعہ لیڈربورڈ ڈیٹا اسٹور سے حذف کریں",
  T_46_META_WS_DELETETAG: "ٹیگ ہٹائیں",
  T_46_META_WS_DELTA: "ڈیلٹا",
  T_46_META_WS_DESTROY: "تباہ کریں",
  T_46_META_WS_DESTROYBOT: "بوٹس تباہ کریں",
  T_46_META_WS_DESTROYBUILTINUI: "بلٹ ان UI کو تباہ کریں",
  T_46_META_WS_DESTROYEQUIPMENT: "ساز و سامان تباہ کریں",
  T_46_META_WS_DESTROYITEM: "آئٹم تباہ کریں",
  T_46_META_WS_DIRECTIONTOEULERANGLE: "سمت کو یولر زاویے میں تبدیل کریں",
  T_46_META_WS_DISABLESAFEZONE: "محفوظ علاقے کو غیر فعال کریں",
  T_46_META_WS_DISPATCHEVENT: "ایونٹ بھیجیں",
  T_46_META_WS_DISPATCHEVENTWITHPLATFORM: "پلیٹ فارم کے ساتھ ایونٹ بھیجیں",
  T_46_META_WS_DISTANCE: "فاصلہ",
  T_46_META_WS_DOT: "نقطہ",
  T_46_META_WS_DROPITEM: "اشیاء گرا دیں",
  T_46_META_WS_DYEATAREA: "علاقے پر رنگ کریں",
  T_46_META_WS_DYEATPLANE: "ہوائی جہاز پر رنگ کریں",
  T_46_META_WS_DYEATPOSITION: "مقام پر رنگ کریں",
  T_46_META_WS_E_ABNORMALGRAVZONE: "کم گراوٹی ایریا",
  T_46_META_WS_E_AC80: "AC80",
  T_46_META_WS_E_ACCELERATION: "تَسارُع",
  T_46_META_WS_E_ACTIONNODE: "عمل نوڈ",
  T_46_META_WS_E_ACTIVE: "فعال",
  T_46_META_WS_E_ACTIVESKILL: "فعال مہارت",
  T_46_META_WS_E_ADBOARD: "اشتہار بورڈ",
  T_46_META_WS_E_ADD: "شامل کریں",
  T_46_META_WS_E_ADDFRIEND: "دوست شامل کریں",
  T_46_META_WS_E_AGENCYFB: "AgencyFB",
  T_46_META_WS_E_AIM: "نشانہ",
  T_46_META_WS_E_AIR: "ہوا",
  T_46_META_WS_E_AIRCONDITIONERA: "ایئر کنڈیشنر",
  T_46_META_WS_E_AIRDROP: "فضائی گرپ، زومبی خودکش",
  T_46_META_WS_E_AK: "AK",
  T_46_META_WS_E_AK2: "AK2",
  T_46_META_WS_E_ALIVE: "متحرک",
  T_46_META_WS_E_AMMO: "ہتھیار کی گولی کے اثرات",
  T_46_META_WS_E_AMPHIBIANCAR: "امفیبیان گاڑی",
  T_46_META_WS_E_AN94: "AN94",
  T_46_META_WS_E_APPARITION: "بچے کھیل رہے ہیں",
  T_46_META_WS_E_AR: "رائفل",
  T_46_META_WS_E_AR15: "AR15",
  T_46_META_WS_E_ARAMMO: "AR گولی",
  T_46_META_WS_E_ARMAGAZINE: "اے آر میگزین",
  T_46_META_WS_E_ARMOR: "بکتر",
  T_46_META_WS_E_ARMORBUFF: "بفیٹ بفر",
  T_46_META_WS_E_ARMORLV1: "جسمانی Lv1",
  T_46_META_WS_E_ARMORLV2: "جسمانی Lv2",
  T_46_META_WS_E_ARMORLV3: "جسمانی Lv3",
  T_46_META_WS_E_ARMORPIERCING: "آرمور کو توڑنا",
  T_46_META_WS_E_ARMORSPECIALIST: "مہارت 1",
  T_46_META_WS_E_ARROW: "تیر",
  T_46_META_WS_E_ASC: "بڑھتی ہوئی ترتیب",
  T_46_META_WS_E_ASCIGNOREZERO: "بڑھتی ہوئی ترتیب صفر کو چھوڑ دیتی ہے",
  T_46_META_WS_E_ATMOSPHEREEXPLOSION: "طوفانی گیس کا دھماکہ",
  T_46_META_WS_E_ATTACHMENT1FORCOMPATIBILITY: "مطابقت کے لیے اٹیچمنٹ1",
  T_46_META_WS_E_ATTACHMENT4FORCOMPATIBILITY: "مطابقت کے لیے اٹیچمنٹ4",
  T_46_META_WS_E_ATTACHMENT5FORCOMPATIBILITY: "مطابقت کے لیے اٹیچمنٹ5",
  T_46_META_WS_E_ATTACHMENT6FORCOMPATIBILITY: "مطابقت کے لیے اٹیچمنٹ6",
  T_46_META_WS_E_ATTACHMENT8FORCOMPATIBILITY: "مطابقت کے لیے اٹیچمنٹ8",
  T_46_META_WS_E_ATTACK: "حملہ",
  T_46_META_WS_E_ATTACKGRENADE: "حملہ گرینیڈ",
  T_46_META_WS_E_AUG: "AUG",
  T_46_META_WS_E_AUTO: "خودکار",
  T_46_META_WS_E_AWM: "AWM",
  T_46_META_WS_E_AWM2: "AWM2",
  T_46_META_WS_E_BACK: "واپس آنا",
  T_46_META_WS_E_BACKANDFORTH: "آگے پیچھے",
  T_46_META_WS_E_BAG: "بیگ",
  T_46_META_WS_E_BAG1: "بیگ1",
  T_46_META_WS_E_BAG2: "بیگ2",
  T_46_META_WS_E_BAG3: "بیگ3",
  T_46_META_WS_E_BAMBOOA: "بامبو A",
  T_46_META_WS_E_BANANATREE: "کیلا کے درخت",
  T_46_META_WS_E_BASEBALLPOLE: "BaseballPole",
  T_46_META_WS_E_BASECOEFFICIENT: "بنیادی ضریب",
  T_46_META_WS_E_BASIC: "بنیادی",
  T_46_META_WS_E_BASICCONE: "بنیادی مخروط",
  T_46_META_WS_E_BASICCYLINDER: "بنیادی سلنڈر",
  T_46_META_WS_E_BASICSPHERE: "بنیادی گیند",
  T_46_META_WS_E_BATTLEINSTYLE: "جنگ کی فضا",
  T_46_META_WS_E_BELL: "گھنٹی",
  T_46_META_WS_E_BENCH: "بینچ",
  T_46_META_WS_E_BIGHEADHAMMER: "BigHeadHammer",
  T_46_META_WS_E_BILLBOARD: "بڑی اسکرین",
  T_46_META_WS_E_BIPOD: "بائی پوڈ",
  T_46_META_WS_E_BISGRAFFITIWALL: "BIS تھیم دیوار",
  T_46_META_WS_E_BIZON: "Bizon",
  T_46_META_WS_E_BLACKHOLE: "بلیک ہول دھماکہ VFX",
  T_46_META_WS_E_BLACKHOLEBOOM: "کرسٹل بال VFX",
  T_46_META_WS_E_BLAST: "دھماکہ",
  T_46_META_WS_E_BLOCK: "مربع",
  T_46_META_WS_E_BLOODBALL: "بلیک ہول کے اثرات",
  T_46_META_WS_E_BLT: "BLT",
  T_46_META_WS_E_BLT2: "BLT2",
  T_46_META_WS_E_BLUE: "نیلا",
  T_46_META_WS_E_BLUEDOLL: "برف کی گڑیا",
  T_46_META_WS_E_BOARD: "متحرک پلیٹ فارم",
  T_46_META_WS_E_BODY: "جسم",
  T_46_META_WS_E_BOMBINDICATION: "بم کی انتباہ",
  T_46_META_WS_E_BOMBPLIERS: "بم پلائرز",
  T_46_META_WS_E_BONFIRE: "جلتی ہوئی آگ",
  T_46_META_WS_E_BOOM: "حلقہ",
  T_46_META_WS_E_BOOYAH: "فتح",
  T_46_META_WS_E_BOTH: "دونوں",
  T_46_META_WS_E_BOUNCETIRE: "ٹائر",
  T_46_META_WS_E_BOWAMMO: "تیر کمان گولی",
  T_46_META_WS_E_BREAKABLEBOX: "تباہ کن لکڑی کا ڈبہ",
  T_46_META_WS_E_BREAKABLECONTAINER: "قابل تبذیر کنٹینر",
  T_46_META_WS_E_BREAKABLEFENCE: "قابل تبذیر باڑ",
  T_46_META_WS_E_BRICKA: "اینٹ A",
  T_46_META_WS_E_BRICKB: "اینٹ B",
  T_46_META_WS_E_BRICKC: "اینٹ C",
  T_46_META_WS_E_BRICKHOUSEA: "چھوٹا گھر A",
  T_46_META_WS_E_BRIGHT: "روشن",
  T_46_META_WS_E_BUBBLE: "بلبل",
  T_46_META_WS_E_BUFFGENERATOR: "بفر جنریٹر",
  T_46_META_WS_E_BULLETBUFF: "گولی بفر",
  T_46_META_WS_E_BULLETHITTING: "گولی کا لگنا",
  T_46_META_WS_E_BUMPERCAR: "بمپر کار",
  T_46_META_WS_E_BUMPERCARFACTORY: "بامپر کار بنانے والا",
  T_46_META_WS_E_BURNING: "گاڑی کے دھماکے کے بعد جلنے والا نقصان",
  T_46_META_WS_E_BUSHES: "جھاڑیاں",
  T_46_META_WS_E_BUSSTOP: "بس اسٹاپ",
  T_46_META_WS_E_BUTTOM: "نیچے کے کپڑے",
  T_46_META_WS_E_BUTTONWIDGET: "بٹن ویجٹ",
  T_46_META_WS_E_BYHIERARCHY: "مطابق درجہ بندی",
  T_46_META_WS_E_CABINET: "کابینہ",
  T_46_META_WS_E_CACTUS: "کیکٹس",
  T_46_META_WS_E_CAMOUFLAGE: "مہارت 6",
  T_46_META_WS_E_CAPSULETRIGGER: "کیپسول ٹرگر",
  T_46_META_WS_E_CARDIOTONIC: "کارڈیوٹونک",
  T_46_META_WS_E_CASUALGAMEBGM: "تفریحی کھیل بی جی ایم",
  T_46_META_WS_E_CEMENTA: "سیمنٹ A",
  T_46_META_WS_E_CG15: "CG15",
  T_46_META_WS_E_CHANNELA: "چینل A",
  T_46_META_WS_E_CHANNELB: "چینل B",
  T_46_META_WS_E_CHANNELC: "چینل C",
  T_46_META_WS_E_CHANNELD: "چینل D",
  T_46_META_WS_E_CHANNELE: "چینل E",
  T_46_META_WS_E_CHANNELF: "چینل F",
  T_46_META_WS_E_CHARACTERSKILL: "کردار کی مہارت",
  T_46_META_WS_E_CHARACTOR: "کردار",
  T_46_META_WS_E_CHARGE: "چارج 1",
  T_46_META_WS_E_CHARGEBUSTER: "ChargeBuster",
  T_46_META_WS_E_CHECKPOINT: "چیک پوائنٹ",
  T_46_META_WS_E_CHEER: "حوصلہ افزائی",
  T_46_META_WS_E_CHERRYBLOSSOM: "چیری بلاسم ٹری",
  T_46_META_WS_E_CIRCLE: "دائرہ",
  T_46_META_WS_E_CIRCLEBACK: "لوپ",
  T_46_META_WS_E_CIRCLEOFHEAT: "پاؤں کے نیچے روشنی",
  T_46_META_WS_E_CITY: "شہر",
  T_46_META_WS_E_CLAPS: "تالیاں",
  T_46_META_WS_E_CLEAR: "صاف",
  T_46_META_WS_E_CLIENT: "کلائنٹ",
  T_46_META_WS_E_CLONE: "شکل بدلنا",
  T_46_META_WS_E_CLONEKILL: "نقل کا موت",
  T_46_META_WS_E_CLOSE: "بند کریں",
  T_46_META_WS_E_CLOTHES: "کپڑے",
  T_46_META_WS_E_COINGENERATOR: "سونا جنریٹر",
  T_46_META_WS_E_COLDAIR: "سردی",
  T_46_META_WS_E_COLORBLOCK: "رنگین بلاک",
  T_46_META_WS_E_COLOROILBARREL: "رنگین تیل کا ڈھول",
  T_46_META_WS_E_COMBINEALL: "سب سے جوڑنا",
  T_46_META_WS_E_COMBINESELF: "خود سے جوڑنا",
  T_46_META_WS_E_COMBOKEYA1: "موسیقی نوٹس - سنٹھیسائزر A",
  T_46_META_WS_E_COMBOKEYA2: "موسیقی نوٹس - سنٹھیسائزر A",
  T_46_META_WS_E_COMBOKEYB1: "موسیقی نوٹس - سنٹھیسائزر B",
  T_46_META_WS_E_COMBOKEYB2: "موسیقی نوٹس - سنٹھیسائزر B",
  T_46_META_WS_E_COMBOKEYC1: "موسیقی نوٹس - سنٹھیسائزر C",
  T_46_META_WS_E_COMBOKEYC2: "موسیقی نوٹس - سنٹھیسائزر C",
  T_46_META_WS_E_CONCRETEPILLAR: "کنکریٹ کا ستون",
  T_46_META_WS_E_CONDITIONNODE: "حالت نوڈ",
  T_46_META_WS_E_CONTAINERA: "کنٹینر A",
  T_46_META_WS_E_CONTAINERB: "شپنگ کنٹینر بی",
  T_46_META_WS_E_CONTAINERC: "شپنگ کنٹینر سی",
  T_46_META_WS_E_CONTAINERWIDGET: "کنٹینر ویجٹ",
  T_46_META_WS_E_CONTINUOUS: "مسلسل",
  T_46_META_WS_E_COUNTDOWN: "گنتی",
  T_46_META_WS_E_COUNTDOWNDENGDENG: "کاؤنٹ ڈاؤن",
  T_46_META_WS_E_COUNTDOWNDIDI: "گنتی کی آواز",
  T_46_META_WS_E_COUNTDOWNMECHANICAL: "کاؤنٹ ڈاؤن",
  T_46_META_WS_E_COUNTDOWNWITHINGAME: "کاؤنٹ ڈاؤن 3",
  T_46_META_WS_E_CROSS: "صلیب",
  T_46_META_WS_E_CROSSBOW: "کراس باو",
  T_46_META_WS_E_CROSSHAIR: "کراس ہیئر",
  T_46_META_WS_E_CROSSHAIRS: "نشانہ",
  T_46_META_WS_E_CROUCH: "بیٹھنا",
  T_46_META_WS_E_CROUCHING: "بیٹھنا",
  T_46_META_WS_E_CROWCAW: "کوا کی کڑکڑاہٹ",
  T_46_META_WS_E_CROWN: "تاج",
  T_46_META_WS_E_CUBE: "بلاک مکینزم",
  T_46_META_WS_E_CURSE: "تالو",
  T_46_META_WS_E_CURSEEXPLOSION: "تالو کا دھماکہ",
  T_46_META_WS_E_CUSTOM: "حسب ضرورت کیمرہ",
  T_46_META_WS_E_CUSTOMTRIGGER: "حسب ضرورت ٹرگر",
  T_46_META_WS_E_CUSTOMWATERZONE: "حسب ضرورت پانی کی جگہ",
  T_46_META_WS_E_CYCLICCOMBUSTION: "مسلسل جلنا",
  T_46_META_WS_E_CYLIC: "دائروی",
  T_46_META_WS_E_DAGGER: "تھروئنگ نائف",
  T_46_META_WS_E_DAMAGEDTRUCK: "خراب ٹرک",
  T_46_META_WS_E_DAMAGEZONE: "نقصان کا علاقہ",
  T_46_META_WS_E_DANGERALARM: "خطرہ 2",
  T_46_META_WS_E_DANGERVIBRATING: "خطرہ 1",
  T_46_META_WS_E_DARK: "تاریک",
  T_46_META_WS_E_DARKNESS: "اندھیرا",
  T_46_META_WS_E_DASHATTACK: "ڈیش اٹیک",
  T_46_META_WS_E_DATASTORAGELIMITEXCEEDED: "ڈیٹا اسٹوریج حد تجاوز",
  T_46_META_WS_E_DATASTORAGEPARAMETERERROR: "ڈیٹا اسٹوریج پیرامیٹر کی غلطی",
  T_46_META_WS_E_DATASTORAGETIMEOUT: "ڈیٹا اسٹوریج ٹائم آؤٹ",
  T_46_META_WS_E_DATETIME: "تاریخ اور وقت",
  T_46_META_WS_E_DAY: "دن",
  T_46_META_WS_E_DEAD: "موت",
  T_46_META_WS_E_DEATH: "مُردہ",
  T_46_META_WS_E_DEFAULT: "ڈیفالٹ",
  T_46_META_WS_E_DEFAULTFIST: "مٹھی",
  T_46_META_WS_E_DEFENCEGRENADE: "دفاعی گرینیڈ",
  T_46_META_WS_E_DESC: "کم ہوتی ہوئی ترتیب",
  T_46_META_WS_E_DIALOGUE: "مکالمہ",
  T_46_META_WS_E_DIAMOND: "ہیرا",
  T_46_META_WS_E_DIRECTIONSIGN: "علامت",
  T_46_META_WS_E_DIRVEVEHICLE: "گاڑی چلانا",
  T_46_META_WS_E_DISABLE: "غیر فعال کریں",
  T_46_META_WS_E_DISABLED: "غیر فعال",
  T_46_META_WS_E_DISAPPEARNOTIFICATION: "غائب ہونے کا پیغام",
  T_46_META_WS_E_DISCONNECT: "منقطع ہونا",
  T_46_META_WS_E_DISGUISE: "نقل",
  T_46_META_WS_E_DOGHOUSE: "کتے کا گھر",
  T_46_META_WS_E_DOOR: "دروازہ",
  T_46_META_WS_E_DOUBLE: "ڈبل",
  T_46_META_WS_E_DOUBLEDOOR: "ڈبل دروازہ",
  T_46_META_WS_E_DOUBLEJUMPSHOE: "ڈبل جمپ شوز",
  T_46_META_WS_E_DOUBLEMAGEZINE: "ڈبل میگزین",
  T_46_META_WS_E_DRAW: "برابری",
  T_46_META_WS_E_DRILLZOMBIE: "ڈرل زومبی",
  T_46_META_WS_E_DRIVE: "گاڑی چلائیں",
  T_46_META_WS_E_DRIVER: "ڈرائیور",
  T_46_META_WS_E_DROPBEAT: "مہارت 4",
  T_46_META_WS_E_DRUMKEY1: "موسیقی نوٹس - ڈھول",
  T_46_META_WS_E_DRUMKEY2: "موسیقی نوٹس - ڈھول",
  T_46_META_WS_E_DUEL: "جنگ",
  T_46_META_WS_E_DUMMY: "ڈمی",
  T_46_META_WS_E_DUMMYGRENADE: "ڈمی گرینیڈ",
  T_46_META_WS_E_DUMP: "پھینک دینا",
  T_46_META_WS_E_DUSK: "شام",
  T_46_META_WS_E_DUST: "دھواں اور مٹی",
  T_46_META_WS_E_DYNAMIC: "متحرك",
  T_46_META_WS_E_E: "قدرتی مستقل",
  T_46_META_WS_E_EAGLE: "EAGLE",
  T_46_META_WS_E_EASY: "آسان",
  T_46_META_WS_E_ELECTRICSHOCK: "بجلی کا جھٹکا",
  T_46_META_WS_E_ELECTRICSURFBOARD: "الیکٹرک سرف بورڈ",
  T_46_META_WS_E_ELECTRICZONE: "زہر کا دائرہ",
  T_46_META_WS_E_ELECTRONICBGM: "پیاری الیکٹرانک فینٹسی بی جی ایم",
  T_46_META_WS_E_ELIMINATEDBOSS: "گیلمڈ لیڈر کو مواخذہ",
  T_46_META_WS_E_ELIMINATIONNOTIFICATION: "قتل کی اطلاع",
  T_46_META_WS_E_EMOTE: "جذبات",
  T_46_META_WS_E_ENABLE: "فعال کریں",
  T_46_META_WS_E_ENERGETIC: "توانائی سے بھرپور",
  T_46_META_WS_E_ENTERVEHICLE: "گاڑی میں داخل ہوں",
  T_46_META_WS_E_EP: "توانائی (EP)",
  T_46_META_WS_E_EXCLAMATIONMARK: "تعجب کا نشان",
  T_46_META_WS_E_EXIT: "باہر نکلنا",
  T_46_META_WS_E_EXITVEHICLE: "گاڑی سے نکلیں",
  T_46_META_WS_E_EXPLODE: "خودکش حملہ",
  T_46_META_WS_E_EXPLOSION: "دھماکہ کے اثرات",
  T_46_META_WS_E_EXPLOSIVEBLAZE: "دھماکہ کی آگ",
  T_46_META_WS_E_EXPLOSIVEPAINTSKILL: "توانائی کی گیند کی مہارت",
  T_46_META_WS_E_EXPLOSIVEZOMBIE: "دھماکہ کرنے والا زومبی",
  T_46_META_WS_E_EYE: "چشمہ",
  T_46_META_WS_E_FACEPAINT: "چہرے کی پینٹنگ",
  T_46_META_WS_E_FACTION: "فریق",
  T_46_META_WS_E_FALLING: "گرنا",
  T_46_META_WS_E_FALLINGSTAR: "استعمال کی اشیاء حاصل کریں",
  T_46_META_WS_E_FALSE: "نہیں",
  T_46_META_WS_E_FAMAS: "FAMAS",
  T_46_META_WS_E_FAN: "پروپیلر مکینزم",
  T_46_META_WS_E_FAR: "دور",
  T_46_META_WS_E_FEATHER: "پر",
  T_46_META_WS_E_FEMALE: "عورت",
  T_46_META_WS_E_FENCE: "باڑ",
  T_46_META_WS_E_FGL24: "FGL24",
  T_46_META_WS_E_FIGHTINGENTITY: "لڑائی کی اکائی",
  T_46_META_WS_E_FILLED: "بھرا ہوا",
  T_46_META_WS_E_FINISH: "ختم",
  T_46_META_WS_E_FINISHINGPOINT: "اختتامی نقطہ",
  T_46_META_WS_E_FINISHLINEARCH: "فینیش بینر",
  T_46_META_WS_E_FIRE: "آگ",
  T_46_META_WS_E_FIRECHARGE: "آگ کا گولا",
  T_46_META_WS_E_FIREWORK: "آتشبازی",
  T_46_META_WS_E_FIRINGEFFECT: "ہتھیار کے فائر کے اثرات",
  T_46_META_WS_E_FIRSTPERSON: "فرسٹ پرسن کیمرہ",
  T_46_META_WS_E_FIRSTPERSONCLASSIC: "فرسٹ پرسن کیمرہ (کلاسک)",
  T_46_META_WS_E_FIST: "مکا",
  T_46_META_WS_E_FIT: "فٹ",
  T_46_META_WS_E_FLAG: "جھنڈا",
  T_46_META_WS_E_FLAME: "آگ",
  T_46_META_WS_E_FLAMEGUN: "فلیم گن",
  T_46_META_WS_E_FLAMETHROWER: "فلیم تھروئر",
  T_46_META_WS_E_FLASH: "فلیش بینک",
  T_46_META_WS_E_FLASHBANG: "Flashbang",
  T_46_META_WS_E_FLASHBANGSPARKS: "چمکدار دھماکہ",
  T_46_META_WS_E_FLASHFREEZE: "فلیش فریز",
  T_46_META_WS_E_FLEXWALL: "قابلِ توسیع دیوار",
  T_46_META_WS_E_FLICKER: "چمک",
  T_46_META_WS_E_FLOWER: "پھول",
  T_46_META_WS_E_FLYBOMBBEE: "فلائنگ بم مکھی",
  T_46_META_WS_E_FLYPAN: "فرائنگ پین مکینزم",
  T_46_META_WS_E_FLYSHOE: "فلائی شوز",
  T_46_META_WS_E_FOLDER: "فولڈر",
  T_46_META_WS_E_FOLDWINGS: "فولڈ ونگز",
  T_46_META_WS_E_FOODTRUCK: "کھانے کا ٹرک",
  T_46_META_WS_E_FOODTRUCKB: "کھانے کا ٹرک B",
  T_46_META_WS_E_FOOTBALL: "فٹ بال",
  T_46_META_WS_E_FOOTBALLGUN: "فٹ بال گن",
  T_46_META_WS_E_FOOTBALLICE: "FootballIce",
  T_46_META_WS_E_FOOTBALLSHIELD: "FootballShield",
  T_46_META_WS_E_FOOTBALLSHOOTER: "فٹ بال شوٹر",
  T_46_META_WS_E_FORCE: "قوت",
  T_46_META_WS_E_FOREGRIP_MR: "فورگرپ ایم آر",
  T_46_META_WS_E_FOREGRIP1: "فورگرپ1",
  T_46_META_WS_E_FOREGRIP2: "فورگرپ2",
  T_46_META_WS_E_FOREGRIP3: "فورگرپ3",
  T_46_META_WS_E_FORWARD: "آگے بڑھیں",
  T_46_META_WS_E_FOUNTAIN: "فوارہ",
  T_46_META_WS_E_FREE: "فری کیمرہ",
  T_46_META_WS_E_FREEZEALL: "سب کچھ جامد",
  T_46_META_WS_E_FREEZEPOSITION: "تمام پوزیشن جمنا",
  T_46_META_WS_E_FREEZEPOSITIONX: "X پوزیشن جمنا",
  T_46_META_WS_E_FREEZEPOSITIONY: "Y پوزیشن جمنا",
  T_46_META_WS_E_FREEZEPOSITIONZ: "Z پوزیشن جمنا",
  T_46_META_WS_E_FREEZEROTATION: "تمام گردش منجمد",
  T_46_META_WS_E_FREEZEROTATIONX: "X گردش منجمد",
  T_46_META_WS_E_FREEZEROTATIONY: "Y گردش منجمد",
  T_46_META_WS_E_FREEZEROTATIONZ: "Z گردش منجمد",
  T_46_META_WS_E_FREEZEZONE: "منجمد علاقہ",
  "T_46_META_WS_E_FROST GALAXY": "قطب ستارے",
  T_46_META_WS_E_FROZEN: "منجمد",
  T_46_META_WS_E_FROZENGRENADE: "منجمد ہینڈ گن",
  T_46_META_WS_E_FUNCTIONALITEMS: "فنکشنل آئٹمز",
  T_46_META_WS_E_FZLANTINGHEI: "FZLanTingHei",
  T_46_META_WS_E_G18: "G18",
  T_46_META_WS_E_G36: "G36",
  T_46_META_WS_E_GAME: "کھیل",
  T_46_META_WS_E_GAMEOVER: "کھیل ختم 2",
  T_46_META_WS_E_GAMESTART: "کھیل شروع",
  T_46_META_WS_E_GARAGE: "گیراج",
  T_46_META_WS_E_GATLING: "Gatling",
  T_46_META_WS_E_GEARSWITCHEDON: "مکینزم فعال",
  T_46_META_WS_E_GENTLETAP: "ہلکا سا ٹپ",
  T_46_META_WS_E_GETITEM: "استعمال کی اشیاء حاصل کریں 2",
  T_46_META_WS_E_GFFLATIN: "GFFLatin",
  T_46_META_WS_E_GHOST: "بھوت",
  T_46_META_WS_E_GIANTDICE: "ڈائس",
  T_46_META_WS_E_GIANTLOLLIPOP: "بڑا لالیپاپ",
  T_46_META_WS_E_GIFT: "تحفہ",
  T_46_META_WS_E_GLOOWALL: "گلو دیوار",
  T_46_META_WS_E_GOLD_HEATGUN_I: "GOLD_HEATGUN_I",
  T_46_META_WS_E_GOLD_HEATGUN_II: "GOLD_HEATGUN_II",
  T_46_META_WS_E_GOLD_HEATGUN_III: "GOLD_HEATGUN_III",
  T_46_META_WS_E_GOLD_M1014_I: "GOLD_M1014_I",
  T_46_META_WS_E_GOLD_M1014_II: "GOLD_M1014_II",
  T_46_META_WS_E_GOLD_M1014_III: "GOLD_M1014_III",
  T_46_META_WS_E_GOLD_SCAR_I: "GOLD_SCAR_I",
  T_46_META_WS_E_GOLD_SCAR_II: "GOLD_SCAR_II",
  T_46_META_WS_E_GOLD_SCAR_III: "GOLD_SCAR_III",
  T_46_META_WS_E_GOLDAWM: "GoldAWM",
  T_46_META_WS_E_GOLDFAMAS_I: "GoldFamas_I",
  T_46_META_WS_E_GOLDFAMAS_II: "GoldFamas_II",
  T_46_META_WS_E_GOLDFAMAS_III: "GoldFamas_III",
  T_46_META_WS_E_GOLDGROZA: "GoldGroza",
  T_46_META_WS_E_GOLDKAR98K_I: "GoldKar98K_I",
  T_46_META_WS_E_GOLDKAR98K_II: "GoldKar98K_II",
  T_46_META_WS_E_GOLDKAR98K_III: "GoldKar98K_III",
  T_46_META_WS_E_GOLDKAR98K_III_FORINFECTION: "GoldKar98K_III_ForInfection",
  T_46_META_WS_E_GOLDM14_I: "GoldM14_I",
  T_46_META_WS_E_GOLDM14_II: "GoldM14_II",
  T_46_META_WS_E_GOLDM14_III: "GoldM14_III",
  T_46_META_WS_E_GOLDM14_III_FORINFECTION: "GoldM14_III_ForInfection",
  T_46_META_WS_E_GOLDM4A1_I: "GoldM4A1_I",
  T_46_META_WS_E_GOLDM4A1_II: "GoldM4A1_II",
  T_46_META_WS_E_GOLDM4A1_III: "GoldM4A1_III",
  T_46_META_WS_E_GOLDM4A1_III_FORINFECTION: "GoldM4A1_III_ForInfection",
  T_46_META_WS_E_GOLDM60_I: "GoldM60_I",
  T_46_META_WS_E_GOLDM60_II: "GoldM60_II",
  T_46_META_WS_E_GOLDM60_III: "GoldM60_III",
  T_46_META_WS_E_GOLDM60_III_FORINFECTION: "GoldM60_III_ForInfection",
  T_46_META_WS_E_GOLDMP5_I: "GoldMP5_I",
  T_46_META_WS_E_GOLDMP5_II: "GoldMP5_II",
  T_46_META_WS_E_GOLDMP5_III: "GoldMP5_III",
  T_46_META_WS_E_GOLDMP5_III_FORINFECTION: "GoldMP5_III_ForInfection",
  T_46_META_WS_E_GOLDSVD: "GoldSVD",
  T_46_META_WS_E_GOLDVSS_I: "GoldVSS_I",
  T_46_META_WS_E_GOLDVSS_II: "GoldVSS_II",
  T_46_META_WS_E_GOLDVSS_III: "GoldVSS_III",
  T_46_META_WS_E_GRAFFITIFLOWERBED: "BIS تھیم پھول بستر",
  T_46_META_WS_E_GRAFFITIWALL: "گرافٹی دیوار",
  T_46_META_WS_E_GRAPPLINGHOOKGUN: "ہک گن",
  T_46_META_WS_E_GREATCONDUCTOR: "عظیم کمانڈر",
  T_46_META_WS_E_GREEN: "سبز",
  T_46_META_WS_E_GRENADE: "دستی بم",
  T_46_META_WS_E_GRID: "گرڈ",
  T_46_META_WS_E_GROZA: "GROZA",
  T_46_META_WS_E_GROZA2: "GROZA2",
  T_46_META_WS_E_GUARDTOWER: "نگرانی ٹاور",
  T_46_META_WS_E_GUILD: "گیلڈ",
  T_46_META_WS_E_GUN: "اسلحہ",
  T_46_META_WS_E_GUNFIRE: "فائرنگ",
  T_46_META_WS_E_HALO: "ہالہ",
  T_46_META_WS_E_HAMMER: "دیو ہتھوڑا مکینزم",
  T_46_META_WS_E_HANDCANNON: "HandCannon",
  T_46_META_WS_E_HANGER: "خشک کرنے والا ریک",
  T_46_META_WS_E_HARD: "مشکل",
  T_46_META_WS_E_HATTRICK: "مہارت 8",
  T_46_META_WS_E_HAYSTACK: "تنکے کا گود",
  T_46_META_WS_E_HEAD: "سر کی پوشاک",
  T_46_META_WS_E_HEADSHOOT: "ہیڈ شاٹ",
  T_46_META_WS_E_HEALINGGUN_SNIPER: "Healinggun_Sniper",
  T_46_META_WS_E_HEALINGPISTOL_X: "HealingPistol_X",
  T_46_META_WS_E_HEALPISTOL: "علاج کرنے والا گن",
  T_46_META_WS_E_HEART: "دل",
  T_46_META_WS_E_HEARTBEAT: "دل کی دھڑکن",
  T_46_META_WS_E_HEATGUN: "HeatGun",
  T_46_META_WS_E_HEAVYWEAPON: "بھاری ہتھیار",
  T_46_META_WS_E_HELL: "بہت مشکل",
  T_46_META_WS_E_HELMET: "ہیلمیٹ",
  T_46_META_WS_E_HELMET1: "ہیلمیٹ1",
  T_46_META_WS_E_HELMET2: "ہیلمیٹ2",
  T_46_META_WS_E_HELMET3: "ہیلمیٹ3",
  T_46_META_WS_E_HEXAGON: "چھ کونہ",
  T_46_META_WS_E_HGAMMO: "HG گولی",
  T_46_META_WS_E_HIDEANDSEEKFLAMETHROWER: "چھپنے والا فلیم تھروئر",
  T_46_META_WS_E_HIDERKILL: "چھپنے والے کو ہلاک کرنا",
  T_46_META_WS_E_HIHATS: "ہائی-ہیٹ",
  T_46_META_WS_E_HINDSILIGURI: "HindSiliguri",
  T_46_META_WS_E_HITBLUNT: "مدھم ہٹ",
  T_46_META_WS_E_HITEFFECT: "گولی کے نشانے کے اثرات",
  T_46_META_WS_E_HITFEEDBACK: "شوٹنگ کی رائے",
  T_46_META_WS_E_HOOK: "ہُک",
  T_46_META_WS_E_HOOKGUN: "HookGun",
  T_46_META_WS_E_HOOKGUNAMMO: "ہک گن ایمو",
  T_46_META_WS_E_HORIZALINE: "افق",
  T_46_META_WS_E_HORIZONTAL: "افقی",
  T_46_META_WS_E_HORN: "اسپیکر",
  T_46_META_WS_E_HORROR: "خوفناک",
  T_46_META_WS_E_HOURGLASS: "ریت کا گھڑا",
  T_46_META_WS_E_HOUSE: "گھر",
  T_46_META_WS_E_HOUSEA: "ایک منزلہ گھر",
  T_46_META_WS_E_HOUSEB: "دو منزلہ گھر",
  T_46_META_WS_E_HOUSEC: "تین منزلہ گھر",
  T_46_META_WS_E_HP: "صحت (HP)",
  T_46_META_WS_E_HPBUFF: "HP بفر",
  T_46_META_WS_E_HUT: "کیبن",
  T_46_META_WS_E_ICEA: "برف A",
  T_46_META_WS_E_ICEGUN: "IceGun",
  T_46_META_WS_E_ICEWALLMAKER: "آئس وال میکر",
  T_46_META_WS_E_ICONOBJECT: "آئیکن",
  T_46_META_WS_E_IMAGEWIDGET: "امیج ویجٹ",
  T_46_META_WS_E_IMPULSE: "دھچکا",
  T_46_META_WS_E_INHALER: "انسولين",
  T_46_META_WS_E_INJUREDFEMALE: "ہٹ پر عورت کی چیخ",
  T_46_META_WS_E_INJUREDMALE: "ہٹ پر مرد کی چیخ",
  T_46_META_WS_E_INK: "سیاہی کے اثرات",
  T_46_META_WS_E_INPUTLABLEWIDGET: "ان پٹ لیبل ویجٹ",
  T_46_META_WS_E_INSECTCHIRPING: "کیڑے کی چہچہاہٹ",
  T_46_META_WS_E_INTERVAL10SECONDS: "10 سیکنڈ",
  T_46_META_WS_E_INTERVAL15SECONDS: "15 سیکنڈ",
  T_46_META_WS_E_INTERVAL30SECONDS: "30 سیکنڈ",
  T_46_META_WS_E_INTERVAL3SECONDS: "3 سیکنڈ",
  T_46_META_WS_E_INTERVAL5SECONDS: "5 سیکنڈ",
  T_46_META_WS_E_INTERVAL9999SECONDS: "9999 سیکنڈ",
  T_46_META_WS_E_INVISIBLE: "غائب",
  T_46_META_WS_E_IPIPE: "پائپ I",
  T_46_META_WS_E_IRONFENCE: "باڑ",
  T_46_META_WS_E_IRONFENCEB: "باڑ B",
  T_46_META_WS_E_IRONPLATFORM: "لوہا پلیٹ فارم",
  T_46_META_WS_E_ITEMENTITY: "کھپت کا جنریٹر",
  T_46_META_WS_E_JEEP: "جیپ",
  T_46_META_WS_E_JERRYCAN: "تیل کا ڈھول",
  T_46_META_WS_E_JERSEYMACHINE: "جرسی مشین",
  T_46_META_WS_E_JOINEDGAMEDULL: "لڑائی میں شامل ہوں",
  T_46_META_WS_E_JOINGAME: "کھیل میں شامل ہوں",
  T_46_META_WS_E_JOYSTICKWIDGET: "جوائسٹس ویجٹ",
  T_46_META_WS_E_JUMP: "چھلانگ",
  T_46_META_WS_E_JUMPATTACK: "چھلانگ حملہ",
  T_46_META_WS_E_JUSTPATROL: "صرف گشت",
  T_46_META_WS_E_KAR98K: "Kar98K",
  T_46_META_WS_E_KATANA: "Katana",
  T_46_META_WS_E_KEY: "چابی",
  T_46_META_WS_E_KICK: "باس ڈرم",
  T_46_META_WS_E_KILLINGTIPS: "قتل کی تجاویز",
  T_46_META_WS_E_KILLZONE: "موت کا علاقہ",
  T_46_META_WS_E_KINEMATIC: "काइनेमेटिक",
  T_46_META_WS_E_KNIFE: "Knife",
  T_46_META_WS_E_KNOCKDOWN: "گر گیا",
  T_46_META_WS_E_KNOCKEDDOWN: "گرا دیا",
  T_46_META_WS_E_KORD: "Kord",
  T_46_META_WS_E_LABELWIDGET: "لیبل ویجٹ",
  T_46_META_WS_E_LANDINGA: "سیڑھی کا لینڈنگ A",
  T_46_META_WS_E_LANDINGB: "سیڑھی کا لینڈنگ B",
  T_46_META_WS_E_LANDINGC: "سیڑھی کا لینڈिंग C",
  T_46_META_WS_E_LANDMINE: "لینڈ مائن",
  T_46_META_WS_E_LANUNCHERAMMO: "لانچر ایمو",
  T_46_META_WS_E_LASER: "لیزر کے اثرات",
  T_46_META_WS_E_LASERSKILL: "لیزر مہارت",
  T_46_META_WS_E_LATTICESCREEN: "اسکرین",
  T_46_META_WS_E_LAWNA: "گھاس A",
  T_46_META_WS_E_LAWNB: "گھاس B",
  T_46_META_WS_E_LAYOUTWIDGET: "لے آؤٹ ویجٹ",
  T_46_META_WS_E_LEAD1A2: "Lead1A2",
  T_46_META_WS_E_LEAD1A2SHARP: "Lead1A2#",
  T_46_META_WS_E_LEAD1B2: "Lead1B2",
  T_46_META_WS_E_LEAD1C2: "Lead1C2",
  T_46_META_WS_E_LEAD1C2SHARP: "Lead1C2#",
  T_46_META_WS_E_LEAD1D2: "Lead1D2",
  T_46_META_WS_E_LEAD1D2SHARP: "Lead1D2#",
  T_46_META_WS_E_LEAD1E2: "Lead1E2",
  T_46_META_WS_E_LEAD1F2: "Lead1F2",
  T_46_META_WS_E_LEAD1F2SHARP: "Lead1F2#",
  T_46_META_WS_E_LEAD1G2: "Lead1G2",
  T_46_META_WS_E_LEAD1G2SHARP: "Lead1G2#",
  T_46_META_WS_E_LEAD2A2: "Lead2A2",
  T_46_META_WS_E_LEAD2A2SHARP: "Lead2A2#",
  T_46_META_WS_E_LEAD2B2: "Lead2B2",
  T_46_META_WS_E_LEAD2C2: "Lead2C2",
  T_46_META_WS_E_LEAD2C2SHARP: "Lead2C2#",
  T_46_META_WS_E_LEAD2D2: "Lead2D2",
  T_46_META_WS_E_LEAD2D2SHARP: "Lead2D2#",
  T_46_META_WS_E_LEAD2E2: "Lead2E2",
  T_46_META_WS_E_LEAD2F2: "Lead2F2",
  T_46_META_WS_E_LEAD2F2SHARP: "Lead2F2#",
  T_46_META_WS_E_LEAD2G2: "Lead2G2",
  T_46_META_WS_E_LEAD2G2SHARP: "Lead2G2#",
  T_46_META_WS_E_LEAD3A2: "Lead3A2",
  T_46_META_WS_E_LEAD3A2SHARP: "Lead3A2#",
  T_46_META_WS_E_LEAD3B2: "Lead3B2",
  T_46_META_WS_E_LEAD3C2: "Lead3C2",
  T_46_META_WS_E_LEAD3C2SHARP: "Lead3C2#",
  T_46_META_WS_E_LEAD3D2: "Lead3D2",
  T_46_META_WS_E_LEAD3D2SHARP: "Lead3D2#",
  T_46_META_WS_E_LEAD3E2: "Lead3E2",
  T_46_META_WS_E_LEAD3F2: "Lead3F2",
  T_46_META_WS_E_LEAD3F2SHARP: "Lead3F2#",
  T_46_META_WS_E_LEAD3G2: "Lead3G2",
  T_46_META_WS_E_LEAD3G2SHARP: "Lead3G2#",
  T_46_META_WS_E_LEAFLESSTREE: "مردہ لکڑی",
  T_46_META_WS_E_LEVELMAXED: "زیادہ سے زیادہ سطح",
  T_46_META_WS_E_LEVELUP: "رینک اپ",
  T_46_META_WS_E_LEVELUPDISCARDED: "رینک بڑھانا",
  T_46_META_WS_E_LIGHTBEAM: "روشنی کی شعاع",
  T_46_META_WS_E_LIGHTBEAMPREDISCARDED: "روشنی کی شعاع",
  T_46_META_WS_E_LIGHTEFFECT: "روشنی کا اثر",
  T_46_META_WS_E_LIGHTNING: "بجلی",
  T_46_META_WS_E_LIMB: "اعضاء",
  T_46_META_WS_E_LINE: "لائن",
  T_46_META_WS_E_LIQUID: "مائع",
  T_46_META_WS_E_LOCAL: "مقامی",
  T_46_META_WS_E_LOCALPOSITION: "مقامی مقام",
  T_46_META_WS_E_LOCK: "تالا",
  T_46_META_WS_E_LONGBOX: "لمبا لکڑی کا ڈبہ",
  T_46_META_WS_E_LOOP: "لوپ",
  T_46_META_WS_E_LOOTITEMBOX: "لوٹ ہتھیار",
  T_46_META_WS_E_LOOTITEMBOXAMMO: "لوٹ گولیاں",
  T_46_META_WS_E_LOOTITEMBOXARMOR: "لوٹ آرمور",
  T_46_META_WS_E_LOOTITEMBOXCONSUMABLEITEM: "لوٹ قابلِ خرچ اشیاء",
  T_46_META_WS_E_LOOTITEMBOXPROJECTILE: "لوٹ قابلِ پھینکنے والی چیزیں",
  T_46_META_WS_E_LOOTITEMBOXSIGHT: "لوٹ اسکوپ",
  T_46_META_WS_E_LOOTITEMBOXSOCCER: "Loot Soccer",
  T_46_META_WS_E_LOOTSOCCERICE: "آئس گرینیڈ",
  T_46_META_WS_E_LOOTSOCCERRANDOM: "تصادفی فٹ بال لوٹ",
  T_46_META_WS_E_LOOTSOCCERSHIELD: "فٹ بال شیلڈ",
  T_46_META_WS_E_LOOTWEAPONRANDOM: "بے ترتیب ہتھیار لوٹ",
  T_46_META_WS_E_LOSE: "شکست",
  T_46_META_WS_E_LOUDSPEAKER: "اسپیکر",
  T_46_META_WS_E_LOWFALLING: "کمزوری",
  T_46_META_WS_E_M1014: "M1014",
  T_46_META_WS_E_M10142: "M10142",
  T_46_META_WS_E_M14: "M14",
  T_46_META_WS_E_M1873: "M1873",
  T_46_META_WS_E_M1887: "M1887",
  T_46_META_WS_E_M18872: "M18872",
  T_46_META_WS_E_M1887X: "M1887X",
  T_46_META_WS_E_M1917: "M1917",
  T_46_META_WS_E_M21A5: "M21A5",
  T_46_META_WS_E_M24: "M24",
  T_46_META_WS_E_M249: "M249",
  T_46_META_WS_E_M2492: "M2492",
  T_46_META_WS_E_M4A1: "M4A1",
  T_46_META_WS_E_M500: "M500",
  T_46_META_WS_E_M60: "M60",
  T_46_META_WS_E_M79: "M79",
  T_46_META_WS_E_M79AMMO: "ایم79 گرینیڈ",
  T_46_META_WS_E_M79AMMO_EXCLUSIVE: "ایم79 اسپیشلائزڈ گرینیڈ",
  T_46_META_WS_E_MAC10: "MAC10",
  T_46_META_WS_E_MACHETE: "Machete",
  T_46_META_WS_E_MACHINEGUN: "SMG",
  T_46_META_WS_E_MAG7: "MAG7",
  T_46_META_WS_E_MAG72: "MAG72",
  T_46_META_WS_E_MAGEZINE1: "میگزین1",
  T_46_META_WS_E_MAGEZINE2: "میگزین2",
  T_46_META_WS_E_MAGEZINE3: "میگزین3",
  T_46_META_WS_E_MAGMAA: "مادہ A",
  T_46_META_WS_E_MAGNIFYINGGLASS: "ہلکا کرنے والا",
  T_46_META_WS_E_MALE: "مرد",
  T_46_META_WS_E_MARK: "نشان",
  T_46_META_WS_E_MARKER: "نشان",
  T_46_META_WS_E_MASK: "چہرے کی آرائش",
  T_46_META_WS_E_MAXVALUE: "زیادہ سے زیادہ قیمت",
  T_46_META_WS_E_MECHANICAL: "تیز کلک 2",
  T_46_META_WS_E_MECHANICALDEVICEECHO: "مکینیکل ڈیوائس کا گونج",
  T_46_META_WS_E_MEDICALPROPS: "طبی سامان",
  T_46_META_WS_E_MEDICALTENT: "طبی ٹینٹ",
  T_46_META_WS_E_MEDIUMHEARTBEAT: "درمیانہ دل کی دھڑکن",
  T_46_META_WS_E_MEDKIT: "طبی کٹ",
  T_46_META_WS_E_MELEE: "قریبی لڑائی کا ہتھیار",
  T_46_META_WS_E_MELEEWEAPONS: "نزدیک جنگی ہتھیار",
  T_46_META_WS_E_MGL140: "MGL140",
  T_46_META_WS_E_MICROPHONE: "مائیکروفون",
  T_46_META_WS_E_MIDDLE: "درمیانہ",
  T_46_META_WS_E_MINIHANDLE: "منی ہینڈل",
  T_46_META_WS_E_MINIMAP: "منی نقشہ",
  T_46_META_WS_E_MINISENTRY: "چھوٹا سپاہی",
  T_46_META_WS_E_MINVALUE: "کم از کم قیمت",
  T_46_META_WS_E_MISSILEEXPLODE: "میزائل قسم کا ہتھیار",
  T_46_META_WS_E_MISSIONCOMPLETE: "مشن کی کامیابی 1",
  T_46_META_WS_E_MISTAKE: "غلطی",
  T_46_META_WS_E_MODERATE: "درمیانہ",
  T_46_META_WS_E_MONEY: "پیسہ",
  T_46_META_WS_E_MONSTER: "زومبی",
  T_46_META_WS_E_MONSTERSPAWN: "عفریت کا پیدا ہونے والا مقام",
  T_46_META_WS_E_MONSTERTRUCK: "مونسٹر ٹرک",
  T_46_META_WS_E_MOON: "چاند",
  T_46_META_WS_E_MOSQUITO: "مچھردانی",
  T_46_META_WS_E_MOTIONTRAIL: "ٹکر",
  T_46_META_WS_E_MOTOBIKE: "موٹر بائیک",
  T_46_META_WS_E_MOTORBIKE: "موٹر سائیکل",
  T_46_META_WS_E_MOVE: "منتقل کرنا",
  T_46_META_WS_E_MOVEMENT: "حرکت کریں",
  T_46_META_WS_E_MOVINGJOYSTICK: "حرکت جوائے اسٹک",
  T_46_META_WS_E_MP40: "MP40",
  T_46_META_WS_E_MP402: "MP402",
  T_46_META_WS_E_MP5: "MP5",
  T_46_META_WS_E_MRV: "مسٹر وی",
  T_46_META_WS_E_MULTIPLIER: "ضرب کرنے والا",
  T_46_META_WS_E_MULTIPLY: "ضرب",
  T_46_META_WS_E_MULTIPLYACCUMULATE: "ضرب اور جمع",
  T_46_META_WS_E_MUSHROOM1: "مشروم1",
  T_46_META_WS_E_MUSHROOM2: "مشروم2",
  T_46_META_WS_E_MUSHROOM3: "مشروم3",
  T_46_META_WS_E_MUSHROOM4: "مشروم4",
  T_46_META_WS_E_MUSHSHADE: "بڑا مشروم क्लस्टर",
  T_46_META_WS_E_MUSIC: "موسیقی",
  T_46_META_WS_E_MUZZLE1: "مزل1",
  T_46_META_WS_E_MUZZLE2: "مزل2",
  T_46_META_WS_E_MUZZLE3: "مزل3",
  T_46_META_WS_E_NEAR: "قریب",
  T_46_META_WS_E_NIGHT: "رات",
  T_46_META_WS_E_NOATTACK: "کوئی حملہ نہیں",
  T_46_META_WS_E_NODUALWIELDING: "دوہرے ہتھیار کا استعمال نہیں",
  T_46_META_WS_E_NOERROR: "کوئی خرابی نہیں",
  T_46_META_WS_E_NONE: "کوئی نہیں",
  T_46_META_WS_E_NORMAL: "معمولی",
  T_46_META_WS_E_NOSKIPKNOCKDOWN: "مجبور گراؤٹ",
  T_46_META_WS_E_NOTONASTALIQURDU: "NotoNastaliqUrdu",
  T_46_META_WS_E_NUTTYMOVEMENT: "مہارت 7",
  T_46_META_WS_E_OBTAINEDCOINS: "درمیانہ سونا حاصل کریں",
  T_46_META_WS_E_OBTAINEDMANYCOINS: "بڑا سونا حاصل کریں",
  T_46_META_WS_E_OBTAINEDSOMECOINS: "چھوٹا سونا حاصل کریں",
  T_46_META_WS_E_OILDRUMEXPLODE: "تیل کے ڈرم کا دھماکہ",
  T_46_META_WS_E_ONCE: "ایک بار",
  T_46_META_WS_E_ONEWAY: "ایک طرفہ",
  T_46_META_WS_E_OPENFOLDER: "کھلا فولڈر",
  T_46_META_WS_E_OPENHIHATS: "کھلا ہائی-ہیٹ",
  T_46_META_WS_E_OPENINGBOX: "باکس کھولیں",
  T_46_META_WS_E_OPENINGGUILDSUPPLY: "گیلمڈ سپلائی",
  T_46_META_WS_E_OPENINGWARCHEST: "گودام محفوظ کریں",
  T_46_META_WS_E_ORANGE: "سن Orange",
  T_46_META_WS_E_ORTHOGONAL: "عمودی",
  T_46_META_WS_E_OUTPOST: "گارڈ ہاؤس",
  T_46_META_WS_E_P90: "P90",
  T_46_META_WS_E_P902: "P902",
  T_46_META_WS_E_PAINTEDWALLS: "پینٹ شدہ دیوار",
  T_46_META_WS_E_PAINTSHIELDSKILL: "خون کے تالاب کی مہارت",
  T_46_META_WS_E_PALM: "کاغذ",
  T_46_META_WS_E_PANEL: "پینل",
  T_46_META_WS_E_PARAFAL: "PARAFAL",
  T_46_META_WS_E_PARAFAL2: "PARAFAL2",
  T_46_META_WS_E_PASSENGERA: "مسافر A",
  T_46_META_WS_E_PASSENGERB: "مسافر B",
  T_46_META_WS_E_PASSENGERC: "مسافر C",
  T_46_META_WS_E_PASSIVE: "غیر فعال",
  T_46_META_WS_E_PASSIVESKILL: "غیر فعال مہارت",
  T_46_META_WS_E_PATROLWHILEATTACK: "گشت اور حملہ",
  T_46_META_WS_E_PERSONALUAV: "ذاتی یو اے وی",
  T_46_META_WS_E_PERSPECTIVE: "منظر",
  T_46_META_WS_E_PETTABBG: "پالتو جانور",
  T_46_META_WS_E_PHASESTART: "مرحلہ شروع",
  T_46_META_WS_E_PHONEBOOTH: "ٹیلیفون بوتھ",
  T_46_META_WS_E_PI: "Π",
  T_46_META_WS_E_PIANOA3: "PianoA3",
  T_46_META_WS_E_PIANOA3SHARP: "PianoA3#",
  T_46_META_WS_E_PIANOA4: "PianoA4",
  T_46_META_WS_E_PIANOA4SHARP: "PianoA4#",
  T_46_META_WS_E_PIANOB3: "PianoB3",
  T_46_META_WS_E_PIANOB4: "PianoB4",
  T_46_META_WS_E_PIANOC3: "PianoC3",
  T_46_META_WS_E_PIANOC3SHARP: "PianoC3#",
  T_46_META_WS_E_PIANOC4: "PianoC4",
  T_46_META_WS_E_PIANOC4SHARP: "PianoC4#",
  T_46_META_WS_E_PIANOD3: "PianoD3",
  T_46_META_WS_E_PIANOD3SHARP: "PianoD3#",
  T_46_META_WS_E_PIANOD4: "PianoD4",
  T_46_META_WS_E_PIANOD4SHARP: "PianoD4#",
  T_46_META_WS_E_PIANOE3: "PianoE3",
  T_46_META_WS_E_PIANOE4: "PianoE4",
  T_46_META_WS_E_PIANOF3: "PianoF3",
  T_46_META_WS_E_PIANOF3SHARP: "PianoF3#",
  T_46_META_WS_E_PIANOF4: "PianoF4",
  T_46_META_WS_E_PIANOF4SHARP: "PianoF4#",
  T_46_META_WS_E_PIANOG3: "PianoG3",
  T_46_META_WS_E_PIANOG3SHARP: "PianoG3#",
  T_46_META_WS_E_PIANOG4: "PianoG4",
  T_46_META_WS_E_PIANOG4SHARP: "PianoG4#",
  T_46_META_WS_E_PIANOKEY1: "موسیقی نوٹس - پیانو",
  T_46_META_WS_E_PIANOKEY2: "موسیقی نوٹس - پیانو",
  T_46_META_WS_E_PICKUPS: "چیزیں اٹھانا",
  T_46_META_WS_E_PICKUPTRUCK: "ایس یو وی",
  T_46_META_WS_E_PILLAR: "بتنی کالم",
  T_46_META_WS_E_PIN: "کال آؤٹ",
  T_46_META_WS_E_PINGPONG: "پنگ پونگ",
  T_46_META_WS_E_PIPECORNER: "کونے کا پائپ",
  T_46_META_WS_E_PIPEINTERSECTION: "کراس پائپ",
  T_46_META_WS_E_PISTOL: "پستول",
  T_46_META_WS_E_PISTOLAMMO: "پستول ایمو",
  T_46_META_WS_E_PLAIDAMUSEMENTPARKCUBE: "चेकर्ड एम्यूज़मेंट पार्क ब्लॉक",
  T_46_META_WS_E_PLASMA_X: "PLASMA_X",
  T_46_META_WS_E_PLAYER: "کھلاڑی",
  T_46_META_WS_E_PLUS: "جمع",
  T_46_META_WS_E_PODIUM: "پوڈیم",
  T_46_META_WS_E_POISONGAS: "زہریلی گیس",
  T_46_META_WS_E_POISONGASPREDISCARDED: "زہریلی گیس",
  T_46_META_WS_E_PORTAL: "گیٹ",
  T_46_META_WS_E_POSTACCUMULATOR: "بعد از جمع کرنے والا",
  T_46_META_WS_E_POT: "Pot",
  T_46_META_WS_E_POUNDINGHEART: "تیز دل کی دھڑکن",
  T_46_META_WS_E_PREACCUMULATOR: "قبل از جمع کرنے والا",
  T_46_META_WS_E_PRIMARYWEAPONA: "بنیادی ہتھیار A",
  T_46_META_WS_E_PRIMARYWEAPONB: "بنیادی ہتھیار B",
  T_46_META_WS_E_PRIOREXPLOSION: "بم دھماکے سے پہلے",
  T_46_META_WS_E_PROFILEWIDGET: "پروفائل ویجٹ",
  T_46_META_WS_E_PRONE: "لیٹنا",
  T_46_META_WS_E_PUMPKIN: "کدو",
  T_46_META_WS_E_PURPLE: "جامنی",
  T_46_META_WS_E_QUADRILATERAL: "چوکور",
  T_46_META_WS_E_QUESTIONMARK: "سوالیہ نشان",
  T_46_META_WS_E_QUICKCHAT: "فوری چیٹ",
  T_46_META_WS_E_QUICKCHATSHOW: "فوری چیٹ دکھائیں",
  T_46_META_WS_E_RADIAL180: "شعاعی 180°",
  T_46_META_WS_E_RADIAL360: "شعاعی 360°",
  T_46_META_WS_E_RADIAL90: "شعاعی 90°",
  T_46_META_WS_E_RAMPAGE: "جنون",
  T_46_META_WS_E_RANDOM: "تصادفی",
  T_46_META_WS_E_RANDOMBUFF: "بے ترتیب بفر",
  T_46_META_WS_E_RANKDOWN: "رینک کم کرنا",
  T_46_META_WS_E_REACTION: "جواب دیں",
  T_46_META_WS_E_RECOVER: "حلقہ",
  T_46_META_WS_E_RECYCLE: "ری سائیکل",
  T_46_META_WS_E_RED: "سرخ",
  T_46_META_WS_E_REFINERYTANK: "پانی کا مٹکا",
  T_46_META_WS_E_REFLECTIVECUBE: "عاكس اللون الصلب الأساسي 1",
  T_46_META_WS_E_REFRESH: "تازہ کریں",
  T_46_META_WS_E_RELEASINGSKILL: "مہارت کے اثرات",
  T_46_META_WS_E_RELOAD: "دوبارہ لوڈ کریں",
  T_46_META_WS_E_REMINDER: "یاد دہانی",
  T_46_META_WS_E_REPAIR: "مرمت",
  T_46_META_WS_E_REPAIREQUIP: "سامان کی مرمت",
  T_46_META_WS_E_REPAIRKIT: "مرمت کٹ",
  T_46_META_WS_E_REPLACER: "ریپلیسر",
  T_46_META_WS_E_REPORT: "رپورٹ کریں",
  T_46_META_WS_E_REST: "آرام",
  T_46_META_WS_E_RG550: "RG550",
  T_46_META_WS_E_RIDES: "رائڈ",
  T_46_META_WS_E_RIDICULE: "مذاق",
  T_46_META_WS_E_RIDICULEFUNNY: "عجیب مذاق",
  T_46_META_WS_E_RIFLE: "رائفل",
  T_46_META_WS_E_RIFLEAMMO: "رائفل ایمو",
  T_46_META_WS_E_RIGHT: "درست",
  T_46_META_WS_E_RIGHTTRAPEZOID: "دائیں زاویے کا ٹریپیزیم",
  T_46_META_WS_E_RING: "انگوٹھیاں مکینزم",
  T_46_META_WS_E_RINGPREDISCARDED: "حلقہ",
  T_46_META_WS_E_RIPTIDERHYTHM: "مہارت 9",
  T_46_META_WS_E_RISINGPARTICLE: "اوپر کی طرف بڑھتے ذرات",
  T_46_META_WS_E_ROADBLOCK: "رکاوٹ",
  T_46_META_WS_E_ROTATE: "گھومنا",
  T_46_META_WS_E_RUNNING: "چل رہا ہے",
  T_46_META_WS_E_RUSHTIME: "دھماکہ",
  T_46_META_WS_E_SAMURAI: "سامورائی",
  T_46_META_WS_E_SANDA: "ریت A",
  T_46_META_WS_E_SANDSTRUCTURE: "ریت مجسمہ",
  T_46_META_WS_E_SCALE: "پیمانہ",
  T_46_META_WS_E_SCAR: "SCAR",
  T_46_META_WS_E_SCAR2: "SCAR2",
  T_46_META_WS_E_SCARECROW: "ڈراونا آدمی",
  T_46_META_WS_E_SCISSORS: "قینچی",
  T_46_META_WS_E_SCOPE2X: "2x اسکوپ",
  T_46_META_WS_E_SCOPE4X: "4x اسکوپ",
  T_46_META_WS_E_SCROLLPANEL: "اسکرول پینل",
  T_46_META_WS_E_SECONDARYWEAPON: "ثانوی ہتھیار",
  T_46_META_WS_E_SENSESSHOCKWAVE: "مہارت 10",
  T_46_META_WS_E_SERVER: "سرور",
  T_46_META_WS_E_SET: "باڈی سوٹ",
  T_46_META_WS_E_SETTING: "ترتیبات",
  T_46_META_WS_E_SETTINGS: "سیٹنگز",
  T_46_META_WS_E_SG: "شاٹ گن",
  T_46_META_WS_E_SGAMMO: "SN گولی",
  T_46_META_WS_E_SHARPMECHANICAL: "تیز کلک 1",
  T_46_META_WS_E_SHIELD: "دفاع",
  T_46_META_WS_E_SHIELDBROKEN: "ڈھال ٹوٹ گئی",
  T_46_META_WS_E_SHIELDGUN: "ShieldGun",
  T_46_META_WS_E_SHIELDUP: "ڈھال اٹھاؤ",
  T_46_META_WS_E_SHOCKWAVE: "جھٹکا لہریں",
  T_46_META_WS_E_SHOES: "جوتے",
  T_46_META_WS_E_SHOOTINGTARGET: "متحرک ہدف",
  T_46_META_WS_E_SHORTDATE: "مختصر تاریخ",
  T_46_META_WS_E_SHORTDATETIME: "مختصر تاریخ اور وقت",
  T_46_META_WS_E_SHORTTIME: "مختصر وقت",
  T_46_META_WS_E_SHOTGUN: "شاٹ گن",
  T_46_META_WS_E_SHOTGUNAMMO: "شاٹ گن کی گولیاں",
  T_46_META_WS_E_SHOTGUNMUZZLE: "شاٹ گن مزل",
  T_46_META_WS_E_SHOW: "دکھائیں",
  T_46_META_WS_E_SHRUB: "جھاڑی سے ڈھانپا ہوا لمبا لکڑی کا ڈبہ",
  T_46_META_WS_E_SICKLE: "Sickle",
  T_46_META_WS_E_SIDESCROLLING: "سائیڈ اسکرولنگ کیمرہ",
  T_46_META_WS_E_SIGNAL: "سگنل",
  T_46_META_WS_E_SIGNOUT: "باہر نکلیں",
  T_46_META_WS_E_SILENCER: "سائلنسر",
  T_46_META_WS_E_SIMPLE: "سادہ",
  T_46_META_WS_E_SIMPLEWIDGET: "سادہ ویجٹ",
  T_46_META_WS_E_SIMPLIFIEDARABIC: "SimplifiedArabic",
  T_46_META_WS_E_SINGLE: "سنگل",
  T_46_META_WS_E_SITEHUT: "کنٹینر ہاؤس",
  T_46_META_WS_E_SKILLCHARGINGCOMPLETE: "مہارت چارج مکمل",
  T_46_META_WS_E_SKILLRECOVER: "مہارت کی بحالی",
  T_46_META_WS_E_SKIPKNOCKDOWN: "گراؤٹ کو چھوڑنا",
  T_46_META_WS_E_SKS: "SKS",
  T_46_META_WS_E_SLICED: "ٹکڑا",
  T_46_META_WS_E_SLOPE: "ڈھلوان",
  T_46_META_WS_E_SLOWHEARTBEAT: "سست دل کی دھڑکن",
  T_46_META_WS_E_SMG: "ایس ایم جی",
  T_46_META_WS_E_SMGAMMO: "SMG گولی",
  T_46_META_WS_E_SMGMUZZLE: "ایس ایم جی مزل",
  T_46_META_WS_E_SMILEY: "مسکراتا چہرہ",
  T_46_META_WS_E_SMOKE: "دھواں",
  T_46_META_WS_E_SMOKEGRENADE: "دھواں بم",
  T_46_META_WS_E_SMOKEY: "دھواں",
  T_46_META_WS_E_SMOOTH: "ہموار",
  T_46_META_WS_E_SNAMMO: "SN گولی",
  T_46_META_WS_E_SNARES: "اسنار ڈرم",
  T_46_META_WS_E_SNEAKERS: "رننگ شو کے اثرات",
  T_46_META_WS_E_SNIPER: "اسنائپر رائفل",
  T_46_META_WS_E_SNIPERAMMO: "سنائپر رائفل کی گولیاں",
  T_46_META_WS_E_SNOWA: "برف A",
  T_46_META_WS_E_SNOWFLAKE: "برف کے ٹکڑے",
  T_46_META_WS_E_SOCCER: "فٹ بال",
  T_46_META_WS_E_SOCIALBUTTONWIDGET: "سوشل بٹن",
  T_46_META_WS_E_SOLARPANEL: "سولر پینل",
  T_46_META_WS_E_SORTBYPRIORITYHIGHTOLOW: "ترجیحا سے اونچا کے نیچے",
  T_46_META_WS_E_SORTBYPRIORITYLOWTOHIGH: "ترجیحا سے نیچے کے اوپر",
  T_46_META_WS_E_SPAS12: "SPAS12",
  T_46_META_WS_E_SPAS122: "SPAS122",
  T_46_META_WS_E_SPAWNPOINT: "دوبارہ پیدائش کے اثرات",
  T_46_META_WS_E_SPEAKER: "اسپیکر",
  T_46_META_WS_E_SPECIALFIRINGSOUND: "خاص گن کی آواز",
  T_46_META_WS_E_SPECIALGUN: "خصوصی بندوق",
  T_46_META_WS_E_SPHERE: "گولا",
  T_46_META_WS_E_SPHERETRIGGER: "گیند ٹکراؤ ٹرگر",
  T_46_META_WS_E_SPIDERWEB: "مہارت کے اثرات",
  T_46_META_WS_E_SPORTSCAR: "اسپورٹس کار",
  T_46_META_WS_E_SPOTLIGHT: "روشنی",
  T_46_META_WS_E_SPREADOFPOISONGAS: "زہریلی گیس کا پھیلاؤ",
  T_46_META_WS_E_SPRINT: "تیز حرکت",
  T_46_META_WS_E_SQUARE: "مربع",
  T_46_META_WS_E_SQUAREBOX: "اسکوئر لکڑی کا ڈبہ",
  T_46_META_WS_E_SR: "سنائپر رائفل",
  T_46_META_WS_E_STABLE: "گھاس کی چھت کا کمرہ",
  T_46_META_WS_E_STAIRS: "سیڑھی",
  T_46_META_WS_E_STANDING: "کھڑا ہونا",
  T_46_META_WS_E_STAR: "ستارہ",
  T_46_META_WS_E_STATIC: "جامد",
  T_46_META_WS_E_STATUSTRIGGER: "موت یا ناقابل تسخیر ٹرگر",
  T_46_META_WS_E_STEP: "قدم کی آواز",
  T_46_META_WS_E_STEPTRIGGER: "میکانزم کو فعال کریں",
  T_46_META_WS_E_STOCK_S: "اسٹاک ایس",
  T_46_META_WS_E_STOCK_SR: "اسٹاک ایس آر",
  T_46_META_WS_E_STOCK1: "اسٹاک1",
  T_46_META_WS_E_STOCK2: "اسٹاک2",
  T_46_META_WS_E_STOCK3: "اسٹاک3",
  T_46_META_WS_E_STONE: "چٹان",
  T_46_META_WS_E_STONEBRIDGE: "پتھر کا محراب پل",
  T_46_META_WS_E_STONELANTERN: "محلّاتی لیمپ",
  T_46_META_WS_E_STONESPLASH: "پتھر کے ٹکڑے اڑنا",
  T_46_META_WS_E_STORE: "اسٹور",
  T_46_META_WS_E_STREETLAMP: "سٹریٹ لائٹ",
  T_46_META_WS_E_STYLEA: "انداز A",
  T_46_META_WS_E_STYLEB: "انداز B",
  T_46_META_WS_E_STYLEC: "انداز C",
  T_46_META_WS_E_SUBMACHINEGUN: "ایس ایم جی",
  T_46_META_WS_E_SUBMACHINEGUNAMMO: "ایس ایم جی کی گولیاں",
  T_46_META_WS_E_SUCCESSFULHIT: "ہٹ",
  T_46_META_WS_E_SUN: "سورج",
  T_46_META_WS_E_SUNSHADE: "چھت کے ساتھ پیٹیو سیٹ",
  T_46_META_WS_E_SUPERCAR: "اسپورٹس کار",
  T_46_META_WS_E_SUPERMARKET: "سپر مارکیٹ",
  T_46_META_WS_E_SURPRISEFIND: "حیرت کا پتہ لگائیں",
  T_46_META_WS_E_SUV: "SUV",
  T_46_META_WS_E_SVD: "SVD",
  T_46_META_WS_E_SVD2: "SVD2",
  T_46_META_WS_E_SWEAPWEAPONQUICK: "فوری ہتھیار تبدیل کریں",
  T_46_META_WS_E_SWIMRING: "تیرنے کی انگوٹھی",
  T_46_META_WS_E_SWORD: "تلوار",
  T_46_META_WS_E_SYMBOLIC: "زمین کا نشان",
  T_46_META_WS_E_TANKZOMBIE: "ٹینک زومبی",
  T_46_META_WS_E_TAP: "ٹپ کریں",
  T_46_META_WS_E_TAPPINGBUTTON: "بٹن کو ٹپ کریں",
  T_46_META_WS_E_TAPPINGDISABLEDBUTTON: "ٹپ ڈس ایبل بٹن",
  T_46_META_WS_E_TEAM: "ٹیم",
  T_46_META_WS_E_TEAMMATESINFO: "ساتھیوں کی معلومات",
  T_46_META_WS_E_TELEPORT: "حلقہ",
  T_46_META_WS_E_TELEPORTCORRECT: "درست منزل پر بیکننگ",
  T_46_META_WS_E_TELEPORTWRONG: "غلط منزل پر بیکننگ",
  T_46_META_WS_E_TEXT: "متن",
  T_46_META_WS_E_TEXTOBJECT: "متن",
  T_46_META_WS_E_TEXTUREWIDGET: "ٹেক্সچر ویجٹ",
  T_46_META_WS_E_THERMALSCOPE: "تھرمل اسکوپ",
  T_46_META_WS_E_THIRDPERSON: "تھرڈ پرسن کیمرہ",
  T_46_META_WS_E_THIRDPERSONCLASSIC: "تھرڈ پرسن کیمرہ (کلاسک)",
  T_46_META_WS_E_THIRDPERSONLOCK: "تھرڈ پرسن لاک کیمرہ",
  T_46_META_WS_E_THOMPSON: "THOMPSON",
  T_46_META_WS_E_THOMPSON2: "THOMPSON2",
  T_46_META_WS_E_THOWINGKNIFE2FORCOMPATIBILITY: "مطابقت کے لیے تھروئنگ نائف2",
  T_46_META_WS_E_THRILLBATTLE: "مہارت 5",
  T_46_META_WS_E_THROWATTACK: "گرینیڈ پھینکیں",
  T_46_META_WS_E_THROWINGKNIFE: "ThrowingKnife",
  T_46_META_WS_E_THROWREDZOMBIE: "سرخ تھرو کرنے والا زومبی",
  T_46_META_WS_E_THROWZOMBIE: "تھرو کرنے والا زومبی",
  T_46_META_WS_E_THUMBSUP: "لائیک",
  T_46_META_WS_E_THUNDER: "برقی جھٹکا",
  T_46_META_WS_E_TILEA: "ٹائل A",
  T_46_META_WS_E_TILEB: "ٹائل B",
  T_46_META_WS_E_TILEC: "ٹائل C",
  T_46_META_WS_E_TILED: "ٹائلڈ",
  T_46_META_WS_E_TIPSSOUND: "تجاویز دکھائیں",
  T_46_META_WS_E_TOGGLEWIDGET: "ٹوگل ویجٹ",
  T_46_META_WS_E_TOILETBOWL: "ٹॉयلیٹ",
  T_46_META_WS_E_TONEA: "ٹون A",
  T_46_META_WS_E_TOP: "اوپر کے کپڑے",
  T_46_META_WS_E_TOPDOWN: "اوپر سے دیکھنے والا کیمرہ",
  T_46_META_WS_E_TORII: "توڑی",
  T_46_META_WS_E_TOUCHPADWIDGET: "ٹچ پیڈ ویجٹ",
  T_46_META_WS_E_TOWER: "قلعہ",
  T_46_META_WS_E_TPIPE: "پائپ T",
  T_46_META_WS_E_TRACINGSTEPS: "مہارت 3",
  T_46_META_WS_E_TRAILER: "ٹریلر",
  T_46_META_WS_E_TRANSFORMATION: "نظر بدلنا",
  T_46_META_WS_E_TRANSPARENT: "شفاف",
  T_46_META_WS_E_TRAPEZOID: "ٹریپیزیم",
  T_46_META_WS_E_TRASHCAN: "کچرا دانا",
  T_46_META_WS_E_TRIANGLE: "مثلث",
  T_46_META_WS_E_TRIGGERS: "ٹریگر",
  T_46_META_WS_E_TRIPLE: "ٹرپل",
  T_46_META_WS_E_TROPHY: "ٹرافی",
  T_46_META_WS_E_TRUE: "ہاں",
  T_46_META_WS_E_TUKTUK: "ٹک ٹک",
  T_46_META_WS_E_TUTUCAR: "ٹک ٹک",
  T_46_META_WS_E_TYRANTZOMBIE: "ظالم زومبی",
  T_46_META_WS_E_UAVLITE: "یو اے وی لائٹ",
  T_46_META_WS_E_UIFINISH: "اختتام",
  T_46_META_WS_E_UITAP: "UI ٹپ",
  T_46_META_WS_E_UMP: "UMP",
  T_46_META_WS_E_UMP2: "UMP2",
  T_46_META_WS_E_UNITGENERATOR: "یونٹ جنریٹر",
  T_46_META_WS_E_UPWARDTURBULENCE: "اوپر کی ہوا",
  T_46_META_WS_E_USP: "USP",
  T_46_META_WS_E_USP_2: "USP_2",
  T_46_META_WS_E_UZI: "UZI",
  T_46_META_WS_E_VAULTOVER: "اوپر چڑھنا",
  T_46_META_WS_E_VECTOR: "VECTOR",
  T_46_META_WS_E_VEHICLE: "گاڑی",
  T_46_META_WS_E_VEHICLEEXPLODE: "گاڑی کا دھماکہ",
  T_46_META_WS_E_VELOCITY: "رفتار",
  T_46_META_WS_E_VENDINGMACHINE: "وینڈنگ مشین",
  T_46_META_WS_E_VERTICAL: "عمودی",
  T_46_META_WS_E_VEST: "ویسٹ",
  T_46_META_WS_E_VEST1: "Vest1",
  T_46_META_WS_E_VEST2: "Vest2",
  T_46_META_WS_E_VEST3: "Vest3",
  T_46_META_WS_E_VEST4: "ویسٹ4",
  T_46_META_WS_E_VISUALEFFECTS: "بصری اثرات",
  T_46_META_WS_E_VSK94: "VSK94",
  T_46_META_WS_E_VSS: "VSS",
  T_46_META_WS_E_WALLA: "دیوار A",
  T_46_META_WS_E_WALLBRAWL: "مہارت 2",
  T_46_META_WS_E_WARNING: "انتباہ",
  T_46_META_WS_E_WATERRING: "پانی کی چھنکار",
  T_46_META_WS_E_WAVE1: "ویو1",
  T_46_META_WS_E_WAVE2: "ویو2",
  T_46_META_WS_E_WAVE3: "ویو3",
  T_46_META_WS_E_WEAPONGENERATOR: "ہتھیار",
  T_46_META_WS_E_WEAPONSLOT: "ہتھیار کا سلاٹ",
  T_46_META_WS_E_WHISTLE: "دشمن کو شکست دیں",
  T_46_META_WS_E_WIDERANGE: "وسیع رینج",
  T_46_META_WS_E_WIN: "فتح",
  T_46_META_WS_E_WINDATTACK: "ہوا کا حملہ",
  T_46_META_WS_E_WOODA: "لکڑی A",
  T_46_META_WS_E_WOODCUTZOMBIE: "لکڑی کاٹنے والا زومبی",
  T_46_META_WS_E_WOODENPLANK: "پلوں کے پل",
  T_46_META_WS_E_WORLDPOSITION: "عالمی نقاط",
  T_46_META_WS_E_WRECKEDBUS: "تباہ شدہ بس",
  T_46_META_WS_E_WRECKEDCAR: "تباہ شدہ گاڑی",
  T_46_META_WS_E_WRONG: "غلط",
  T_46_META_WS_E_XM8: "XM8",
  T_46_META_WS_E_XM82: "XM82",
  T_46_META_WS_E_ZOMBIE: "زومبی",
  T_46_META_WS_E_ZOMBIES: "زومبی",
  T_46_META_WS_E_ZOOM: "زوم",
  T_46_META_WS_ELIMINATE: "ختم کریں",
  T_46_META_WS_ELIMINATEDENTITY: "ختم شدہ ہستی",
  T_46_META_WS_ELIMINATEDPLAYER: "ختم شدہ کھلاڑی",
  T_46_META_WS_ENABLEDEFAULTBTREE: "ڈیفالٹ بیہیویئر ٹری کو فعال کریں",
  T_46_META_WS_ENABLEMOVINGSAFEZONE: "متحرک محفوظ علاقے کو فعال کریں",
  T_46_META_WS_ENABLESAFEZONE: "محفوظ علاقے کو فعال کریں",
  T_46_META_WS_ENDCURRENTPHASE: "موجودہ مرحلہ ختم کریں",
  T_46_META_WS_ENDMORPH: "تبدیلی ختم کریں",
  T_46_META_WS_ENDPOSITION: "اختتامی مقام",
  T_46_META_WS_ENTERVEHICLE: "گاڑی میں داخل ہوں",
  T_46_META_WS_ENTITY: "ہستی",
  T_46_META_WS_EQUIPMENTID: "آلات کی شناخت",
  T_46_META_WS_EULERANGLETOQUATERNION: "یولر زاویے کو کوارٹرنئن میں تبدیل کریں",
  T_46_META_WS_EXITVEHICLE: "گاڑی سے باہر نکلیں",
  T_46_META_WS_EXPONENTIATION: "طاقت کا حساب",
  T_46_META_WS_FILTERENTITY: "شے کو فلٹر کریں",
  T_46_META_WS_FILTERLEVELOBJECTS: "لیول کے آبجیکٹس کو فلٹر کریں",
  T_46_META_WS_FIND: "تلاش کریں",
  T_46_META_WS_FINDAT: "تلاش کریں مقام",
  T_46_META_WS_FINDPATH: "راستہ تلاش کریں",
  T_46_META_WS_FLOOR: "نیچے گول کریں",
  T_46_META_WS_FOOTBALLGOAL: "فٹ بال کا گول",
  T_46_META_WS_FORMAT: "فارمیٹ",
  T_46_META_WS_GETALLKEYS: "تمام چابیاں حاصل کریں",
  T_46_META_WS_GETALLPLAYERS: "تمام کھلاڑیوں کو حاصل کریں",
  T_46_META_WS_GETALLSHOPS: "تمام دکانیں حاصل کریں",
  T_46_META_WS_GETALLTEAMS: "تمام ٹیموں کو حاصل کریں",
  T_46_META_WS_GETATTACKABLEENTITY: "حملہ قابل شے حاصل کریں",
  T_46_META_WS_GETATTACKABLEFACTIONS: "حملہ قابل فیکشن حاصل کریں",
  T_46_META_WS_GETBACKPACKSKIN: "بیگ کی جلد حاصل کریں",
  T_46_META_WS_GETBLACKBOARDVALUE: "بلیک بورڈ ویلیو حاصل کریں",
  T_46_META_WS_GETBUFFS: "بفی حاصل کریں",
  T_46_META_WS_GETCHATCHANNEL: "چیٹ چینل حاصل کریں",
  T_46_META_WS_GETCHILDBYINDEX: "انڈیکس کے ذریعہ بچہ حاصل کریں",
  T_46_META_WS_GETCHILDBYNAME: "نام کے ذریعہ بچہ حاصل کریں",
  T_46_META_WS_GETCHILDREN: "تمام بچوں کو حاصل کریں",
  T_46_META_WS_GETCOLORCHANNEL: "رنگ چینل حاصل کریں",
  T_46_META_WS_GETCONSUMABLES: "استعمال کی اشیاء حاصل کریں",
  T_46_META_WS_GETCULLINGMASK: "کُلنگ ماسک حاصل کریں",
  T_46_META_WS_GETCURRENTCAMERA: "موجودہ کیمرہ حاصل کریں",
  T_46_META_WS_GETCURRENTCHATCHANNEL: "موجودہ چیٹ چینل حاصل کریں",
  T_46_META_WS_GETCUSTOMMISSIONPROGRESS: "حسب ضرورت مشن کی ترقی حاصل کریں",
  T_46_META_WS_GETDYEDCOUNT: "رنگائی کی تعداد حاصل کریں",
  T_46_META_WS_GETDYEDSTATUS: "رنگائی کی حالت حاصل کریں",
  T_46_META_WS_GETEQUIPMENTS: "سازوسامان حاصل کریں",
  T_46_META_WS_GETFACTION: "فیکشن حاصل کریں",
  T_46_META_WS_GETGLOBALSLEEPTHRESHOLD: "عالمی سونے کی حد حاصل کریں",
  T_46_META_WS_GETITEMCOUNT: "آئٹم کی تعداد حاصل کریں",
  T_46_META_WS_GETLOADEDSCENES: "لوڈ کی گئی مناظر حاصل کریں",
  T_46_META_WS_GETLOCALAIMDIRECTION: "مقامی ہدف کی سمت حاصل کریں",
  T_46_META_WS_GETLOCALPLAYER: "مقامی کھلاڑی حاصل کریں",
  T_46_META_WS_GETLOCALTIMESTAMP: "مقامی وقت کا اسٹیمپ حاصل کریں",
  T_46_META_WS_GETMAPID: "نقشہ ID حاصل کریں",
  T_46_META_WS_GETMINIMAP: "منی میپ حاصل کریں",
  T_46_META_WS_GETMONEY: "پیسہ حاصل کریں",
  T_46_META_WS_GETMONEYCOUNT: "پیسہ کی تعداد حاصل کریں",
  T_46_META_WS_GETMORPH: "تبدیلی حاصل کریں",
  T_46_META_WS_GETNODEVARIABLE: "نوڈ ویری ایبل حاصل کریں",
  T_46_META_WS_GETOUTFIT: "لباس حاصل کریں",
  T_46_META_WS_GETOWNER: "مالک حاصل کریں",
  T_46_META_WS_GETPARENT: "والدین حاصل کریں",
  T_46_META_WS_GETPOSITIONNEARTEAMMATE: "ٹیم کے ساتھی کے قریب مقام حاصل کریں",
  T_46_META_WS_GETRANDOMSPAWNPOSITION: "تصادفی طور پر پیدا ہونے والی جگہ حاصل کریں",
  T_46_META_WS_GETRESULTFROMCURVE: "کرف سے نتیجہ حاصل کریں",
  T_46_META_WS_GETSCENESKYBOX: "سین کی اسکائی باکس حاصل کریں",
  T_46_META_WS_GETSERVERREGION: "سرور کا علاقہ حاصل کریں",
  T_46_META_WS_GETSERVERTIMESTAMP: "سرور کا ٹائم اسٹیمپ حاصل کریں",
  T_46_META_WS_GETSKELETONPARTBYNAME: "ہڈی کا حصہ نام سے حاصل کریں",
  T_46_META_WS_GETSKILLS: "مہارتیں حاصل کریں",
  T_46_META_WS_GETSLEEPTHRESHOLD: "سونے کی حد حاصل کریں",
  T_46_META_WS_GETTOKENCOUNT: "ٹوکن کی تعداد حاصل کریں",
  T_46_META_WS_GETTOKENCOUNTTODAY: "آج کے ٹوکن کی تعداد حاصل کریں",
  T_46_META_WS_GETTYPE: "قسم حاصل کریں",
  T_46_META_WS_GETVEHICLESKIN: "گاڑی کی جلد حاصل کریں",
  T_46_META_WS_GETWALLET: "والٹ حاصل کریں",
  T_46_META_WS_GETWEAPONSKIN: "ہتھیار کی جلد حاصل کریں",
  T_46_META_WS_GETWIDGETBYPATH: "راستے کے ذریعے ویجیٹ حاصل کریں",
  T_46_META_WS_GETWIDGETFROMCUSTOMUI: "حسب ضرورت UI سے ویجیٹ حاصل کریں",
  T_46_META_WS_GIVEJAILBREAKITEM: "جیل بریک آئٹم دیں",
  T_46_META_WS_GIVEJAILBREAKREWARD: "جیل بریک انعام دیں",
  T_46_META_WS_HASAOISPECIALFOLLOW: "AOI خاص پیروی ہے یا نہیں",
  T_46_META_WS_HASCOMPONENT: "کمپوننٹ موجود ہے",
  T_46_META_WS_HASSCRIPT: "اسکرپٹ موجود ہے یا نہیں",
  T_46_META_WS_HASTAG: "ٹیگ موجود ہے یا نہیں",
  T_46_META_WS_HELPEDPLAYER: "مدد حاصل کرنے والا کھلاڑی",
  T_46_META_WS_HELPPLAYER: "مددگار کھلاڑی",
  T_46_META_WS_HIDEAPPEARANCEGROUP: "ظاہری شکل گروپ چھپائیں",
  T_46_META_WS_HITENTITY: "مارنے والی ہستی",
  T_46_META_WS_HITFLY: "اُچھالنا",
  T_46_META_WS_HITNORMAL: "مارنے کا عمومی",
  T_46_META_WS_HITOBJECT: "مارنے والی شے",
  T_46_META_WS_HITPOSITION: "مارنے کی جگہ",
  T_46_META_WS_INDEXOF: "عنصر کی پہلی موجودگی حاصل کریں",
  T_46_META_WS_INFECTIONZOMBIEGROWUP: "انفیکشن زومبی بڑھنا",
  T_46_META_WS_INSERT: "داخل کریں",
  T_46_META_WS_ISATTACKABLE: "حملہ قابل ہے یا نہیں",
  T_46_META_WS_ISCHATCHANNELEMPTY: "کیا چیٹ چینل خالی ہے",
  T_46_META_WS_ISEQUAL: "مساوی ہے",
  T_46_META_WS_ISFRIEND: "دوست ہے یا نہیں",
  T_46_META_WS_ISHIT: "کیا مارا گیا",
  T_46_META_WS_ISINSIDEBOX: "باکس میں ہے",
  T_46_META_WS_ISINSIDECYLINDER: "سلنڈر میں ہے",
  T_46_META_WS_ISINSIDESECTOR: "سیکٹر میں ہے",
  T_46_META_WS_ISINSIDESPHERE: "گیند میں ہے",
  T_46_META_WS_ISSLEEPING: "کیا سوتا ہے",
  T_46_META_WS_ISSUBTYPEOF: "ذیلی قسم ہے",
  T_46_META_WS_ITEM: "ہستی",
  T_46_META_WS_ITEMID: "آئٹم کی شناخت",
  T_46_META_WS_JOIN: "جوڑیں",
  T_46_META_WS_JOINCHATCHANNEL: "چیٹ چینل میں شامل ہوں",
  T_46_META_WS_JOINFACTION: "فیکشن میں شامل ہوں",
  T_46_META_WS_LASTINDEXOF: "عنصر کی آخری موجودگی حاصل کریں",
  T_46_META_WS_LENGTH: "لمبائی",
  T_46_META_WS_LERP: "لیپ",
  T_46_META_WS_LOADSCENE: "منظر لوڈ کریں",
  T_46_META_WS_LOGARITHM: "لاگرتھم",
  T_46_META_WS_LOGERROR: "خرابی کا لاگ کریں",
  T_46_META_WS_LOGINFO: "معلومات لاگ کریں",
  T_46_META_WS_LOGWARNING: "انتباہ لاگ کریں",
  T_46_META_WS_LOOKROTATION: "مقصد کی طرف گھومنے کا زاویہ بنائیں",
  T_46_META_WS_MAGNITUDE: "مقدار",
  T_46_META_WS_MAKER: "خالق",
  T_46_META_WS_MAX: "زیادہ سے زیادہ",
  T_46_META_WS_MECHANISM: "میکانزم",
  T_46_META_WS_MIN: "کم سے کم",
  T_46_META_WS_MONSTERUSESKILL: "مہارت استعمال کریں",
  T_46_META_WS_MORPHOBJECT: "مورفنگ آبجیکٹ",
  T_46_META_WS_MORPHTO: "تبدیل کریں",
  T_46_META_WS_MORPHTOBYITEMID: "شے ID کے ذریعے تبدیل کریں",
  T_46_META_WS_MOVECCT: "CCT کو حرکت دیں",
  T_46_META_WS_MOVEPOSITION: "جسمانی مقام کو حرکت دیں",
  T_46_META_WS_MOVEROTATION: "جسمانی گردش کو حرکت دیں",
  T_46_META_WS_MULTIPLYQUATERNION: "کوآٹرنئین ضرب",
  T_46_META_WS_MULTIRAYCAST: "ملٹی-ریکاسٹ",
  T_46_META_WS_NEGATE: "منفی",
  T_46_META_WS_NEW: "نیا",
  T_46_META_WS_NODENAME: "نوڈ کا نام",
  T_46_META_WS_NORMALIZE: "معمول پر لائیں",
  T_46_META_WS_NOTIFYPLAYEFFECT: "اثرات چلانے کی اطلاع دیں",
  T_46_META_WS_NOTIFYPLAYICONANIMATION: "آئیکن انیمیشن نوٹیفائی کریں",
  T_46_META_WS_NOTIFYPLAYSOUND: "آواز چلانے کی اطلاع دیں",
  T_46_META_WS_NOTIFYSHOWTIPS: "تجاویز دکھانے کی اطلاع دیں",
  T_46_META_WS_NUMTOSTRING: "نمبر کو اسٹرنگ میں تبدیل کریں",
  T_46_META_WS_ONACCESSEQUIPMENT: "سامان تک رسائی حاصل کریں",
  T_46_META_WS_ONACCESSITEM: "آئٹم تک رسائی حاصل کریں",
  T_46_META_WS_ONACCESSWEAPON: "ہتھیار تک رسائی حاصل کریں",
  T_46_META_WS_ONACE: "ACE کیا گیا",
  T_46_META_WS_ONAIMED: "نشانہ لیا گیا",
  T_46_META_WS_ONAIMING: "نشانہ لے رہے ہیں",
  T_46_META_WS_ONASSIST: "مدد",
  T_46_META_WS_ONATTACK: "حملہ",
  T_46_META_WS_ONATTACKSTOP: "حملہ روکا",
  T_46_META_WS_ONAWAKE: "بیدار",
  T_46_META_WS_ONBEKNOCKEDDOWN: "گرایا گیا",
  T_46_META_WS_ONBOUNCEDBYTIRE: "ٹائر سے اچھلا",
  T_46_META_WS_ONBOUNCEENTITY: "انٹیٹی اچھلی",
  T_46_META_WS_ONBUILTINBUTTONTAPPED: "بلٹ ان UI بٹن دبایا گیا",
  T_46_META_WS_ONBULLETHIT: "گولی لگی",
  T_46_META_WS_ONCAMERARAYCAST: "کیمرہ ریکاسٹ",
  T_46_META_WS_ONCHARACTERCONTROLLERHIT: "کریکٹر کنٹرولر کو مارا گیا",
  T_46_META_WS_ONCHASE: "پیچھا",
  T_46_META_WS_ONCHASESTOP: "پیچھا روکا",
  T_46_META_WS_ONCLIPEND: "کلپ ختم",
  T_46_META_WS_ONCOLLISIONENTER: "تصادم شروع",
  T_46_META_WS_ONCOLLISIONEXIT: "تصادم ختم",
  T_46_META_WS_ONCOUNTDOWNFINISHED: "الٹی گنتی ختم",
  T_46_META_WS_ONCREEP: "رینگنا",
  T_46_META_WS_ONCROUCH: "جھکنا",
  T_46_META_WS_ONDEALDAMAGE: "نقصان پہنچائیں",
  T_46_META_WS_ONDESTROY: "تباہ کریں",
  T_46_META_WS_ONDISABLE: "غیر فعال کریں",
  T_46_META_WS_ONDISCONNECT: "منقطع",
  T_46_META_WS_ONDOUBLETAPPED: "ڈبل ٹیپ کیا گیا",
  T_46_META_WS_ONDRAG: "ڈریگ کیا گیا",
  T_46_META_WS_ONDRAGEND: "ڈریگ ختم ہوا",
  T_46_META_WS_ONDRAGSTART: "ڈریگ شروع ہوا",
  T_46_META_WS_ONDRIVED: "چلایا گیا",
  T_46_META_WS_ONDRIVEVEHICLE: "گاڑی چلائیں",
  T_46_META_WS_ONDROPCONSUMABLE: "قابل استعمال گرایا گیا",
  T_46_META_WS_ONDROPPED: "گرایا گیا",
  T_46_META_WS_ONDROPWEAPON: "ہتھیار گرایا گیا",
  T_46_META_WS_ONEACHLOOP: "ہر لوپ",
  T_46_META_WS_ONELIMINATE: "ختم کریں",
  T_46_META_WS_ONELIMINATED: "ختم",
  T_46_META_WS_ONENABLE: "فعال کریں",
  T_46_META_WS_ONEND: "ختم",
  T_46_META_WS_ONENTERED: "داخل ہوا",
  T_46_META_WS_ONENTERVEHICLE: "گاڑی میں داخل ہوں",
  T_46_META_WS_ONENTITYENTER: "انٹیٹی نے داخلہ کیا",
  T_46_META_WS_ONENTITYEXIT: "انٹیٹی نے چھوڑا",
  T_46_META_WS_ONEQUIPARMOR: "آرمر پہنیں",
  T_46_META_WS_ONEQUIPED: "لیس کیا گیا",
  T_46_META_WS_ONEQUIPWEAPON: "ہتھیار پہنیں",
  T_46_META_WS_ONEXPLODE: "دھماکہ",
  T_46_META_WS_ONFALL: "گرنے پر",
  T_46_META_WS_ONFALLSTOP: "گرنے پر رکیں",
  T_46_META_WS_ONFIRE: "فائر کریں",
  T_46_META_WS_ONFIXEDUPDATE: "مستقل اپ ڈیٹ",
  T_46_META_WS_ONFOOTBALLCOLLIDED: "فٹ بال سے ٹکرایا",
  T_46_META_WS_ONFRIENDSUPDATE: "دوستی کی حیثیت کو اپ ڈیٹ کریں ",
  T_46_META_WS_ONGAMEEND: "گیم ختم",
  T_46_META_WS_ONGAMEPAUSE: "گیم کو روکا گیا",
  T_46_META_WS_ONGAMERESUME: "گیم دوبارہ شروع کریں",
  T_46_META_WS_ONGAMESTART: "گیم شروع",
  T_46_META_WS_ONGOAL: "گول",
  T_46_META_WS_ONHITBYBULLET: "گولی لگی",
  T_46_META_WS_ONHITFLY: "اڑان میں مارا",
  T_46_META_WS_ONHITFLYENTITY: "اڑتی ہوئی انٹیٹی کو مارا",
  T_46_META_WS_ONHOOKGUNFIRE: "ہک گن فائر",
  T_46_META_WS_ONIDLE: "آرام",
  T_46_META_WS_ONJAILBREAKAREABEGIN: "جیل بریک ایریا شروع",
  T_46_META_WS_ONJAILBREAKAREAEND: "جیل بریک ایریا ختم",
  T_46_META_WS_ONJAILBREAKPLAYERJOIN: "جیل بریک کھلاڑی شامل ہوا",
  T_46_META_WS_ONJAILBREAKPLAYERQUIT: "جیل بریک کھلاڑی نے چھوڑا",
  T_46_META_WS_ONJOINCHATCHANNELSUCCESSFULLY: "چیٹ چینل میں کامیابی سے شامل ہوا",
  T_46_META_WS_ONJOYSTICKMOVE: "جوائسٹرک حرکت",
  T_46_META_WS_ONJOYSTICKPRESSED: "دبایا گیا",
  T_46_META_WS_ONJOYSTICKRELEASED: "چھوڑا گیا",
  T_46_META_WS_ONJUMP: "چھلانگ",
  T_46_META_WS_ONJUMPSTOP: "کودنے پر رکیں",
  T_46_META_WS_ONLANDMINEACTIVE: "بارودی سرنگ فعال",
  T_46_META_WS_ONLANDMINETRIGGER: "بارودی سرنگ کا ٹریگر",
  T_46_META_WS_ONLEAVECHATCHANNEL: "چیٹ چینل چھوڑا",
  T_46_META_WS_ONLEAVEVEHICLE: "گاڑی سے باہر نکلیں",
  T_46_META_WS_ONLEFT: "چھوڑا",
  T_46_META_WS_ONLEVELOBJECTBEMORPHED: "سطح کی چیز تبدیل ہوئی",
  T_46_META_WS_ONMOVE: "چلنا",
  T_46_META_WS_ONNODEENTER: "نوڈ میں داخل",
  T_46_META_WS_ONNODEEXIT: "نوڈ سے باہر نکلا",
  T_46_META_WS_ONPAUSE: "وقفہ",
  T_46_META_WS_ONPHASEEND: "مرحلہ ختم",
  T_46_META_WS_ONPHASESTART: "مرحلہ شروع",
  T_46_META_WS_ONPICKEDUP: "اٹھایا گیا",
  T_46_META_WS_ONPLAYERASSIST: "کھلاڑی کی مدد",
  T_46_META_WS_ONPLAYERBEELIMINATED: "کھلاڑی کو ختم کیا گیا",
  T_46_META_WS_ONPLAYERBEKNOCKEDDOWN: "کھلاڑی کو گرایا گیا",
  T_46_META_WS_ONPLAYERDEALDAMAGE: "کھلاڑی نے نقصان پہنچایا",
  T_46_META_WS_ONPLAYERELIMINATE: "کھلاڑی نے ختم کیا",
  T_46_META_WS_ONPLAYERENTER: "کھلاڑی نے داخلہ کیا",
  T_46_META_WS_ONPLAYERJOIN: "کھلاڑی شامل ہوا",
  T_46_META_WS_ONPLAYERJOINCHATCHANNELFAILURE: "چیٹ چینل میں شامل ہونا ناکام",
  T_46_META_WS_ONPLAYERLEAVE: "کھلاڑی نے چھوڑا",
  T_46_META_WS_ONPLAYERPURCHASEREQUEST: "کھلاڑی نے خریداری کی درخواست کی",
  T_46_META_WS_ONPLAYERQUIT: "کھلاڑی چھوڑ گیا",
  T_46_META_WS_ONPLAYERRANKCHANGE: "کھلاڑی کی رینک تبدیل ہوئی",
  T_46_META_WS_ONPLAYERREQUESTFORPURCHASEFULFILLED: "کھلاڑی کی خریداری کی درخواست پوری ہوئی",
  T_46_META_WS_ONPLAYERREVIVED: "کھلاڑی کو دوبارہ زندہ کیا گیا",
  T_46_META_WS_ONPLAYERREVIVEDINSPAWNPOS: "کھلاڑی کو سپون پوزیشن میں دوبارہ زندہ کیا گیا",
  T_46_META_WS_ONPLAYERSCORECHANGE: "کھلاڑی کا اسکور تبدیل ہوا",
  T_46_META_WS_ONPLAYERSWITCHSCENE: "کھلاڑی نے منظر تبدیل کیا",
  T_46_META_WS_ONPREDEALDAMAGE: "نقصان پہنچانے سے پہلے",
  T_46_META_WS_ONPREPURCHASE: "خریداری سے پہلے",
  T_46_META_WS_ONPRESSED: "دبایا گیا",
  T_46_META_WS_ONPRETAKEDAMAGE: "نقصان وصول کرنے سے پہلے",
  T_46_META_WS_ONPURCHASE: "خریداری",
  T_46_META_WS_ONRANKCHANGED: "انٹیٹی کی رینک تبدیل ہوئی",
  T_46_META_WS_ONRECONNECT: "دوبارہ جڑا",
  T_46_META_WS_ONRELEASED: "چھوڑا گیا",
  T_46_META_WS_ONRELOAD: "ری لوڈ کریں",
  T_46_META_WS_ONRESUME: "دوبارہ شروع",
  T_46_META_WS_ONREVIVED: "دوبارہ زندہ کیا گیا",
  T_46_META_WS_ONROUNDEND: "راؤنڈ ختم",
  T_46_META_WS_ONROUNDSTART: "راؤنڈ شروع",
  T_46_META_WS_ONSCENELOAD: "منظر لوڈ کیا گیا",
  T_46_META_WS_ONSCENESWITCH: "منظر تبدیل",
  T_46_META_WS_ONSCORECHANGE: "انٹیٹی کا اسکور تبدیل ہوا",
  T_46_META_WS_ONSHOTBYFOOTBALLSHOOTER: "فٹ بال شوٹر نے مارا",
  T_46_META_WS_ONSLEEP: "نیند",
  T_46_META_WS_ONSPAWN: "سپون ہوا",
  T_46_META_WS_ONSPRAY: "اسپرے",
  T_46_META_WS_ONSPRAYED: "اسپرے کیا گیا",
  T_46_META_WS_ONSPRINT: "دوڑ",
  T_46_META_WS_ONSPRINTSTOP: "دوڑ روکیں",
  T_46_META_WS_ONSTANDUP: "کھڑے ہوں",
  T_46_META_WS_ONSTART: "شروع",
  T_46_META_WS_ONSTARTFIRE: "حملہ",
  T_46_META_WS_ONSTATEEND: "حالت ختم",
  T_46_META_WS_ONSURFING: "سرفنگ",
  T_46_META_WS_ONSURFINGSTOP: "سرفنگ روکی",
  T_46_META_WS_ONSWITCHHANDHELD: "ہینڈ ہیلڈ تبدیل کریں",
  T_46_META_WS_ONTAKEDAMAGE: "نقصان وصول کریں",
  T_46_META_WS_ONTAPPED: "ٹیپ کیا گیا",
  T_46_META_WS_ONTEAMACE: "ٹیم مکمل طور پر ختم",
  T_46_META_WS_ONTEAMADD: "ٹیم کو شامل کیا گیا",
  T_46_META_WS_ONTEAMREMOVE: "ٹیم کو ہٹایا گیا",
  T_46_META_WS_ONTEAMROUNDRANKCHANGE: "ٹیم کی رینک تبدیل ہوئی",
  T_46_META_WS_ONTEAMSCORECHANGE: "ٹیم کا اسکور تبدیل ہوا",
  T_46_META_WS_ONTELEPORTENTITY: "انٹیٹی کو ٹیلی پورٹ کریں",
  T_46_META_WS_ONTEXTCHANGE: "متن تبدیل ہوا",
  T_46_META_WS_ONTHROWABLEEXPLODE: "پھینکنے والی چیز پھٹی",
  T_46_META_WS_ONTOGGLE: "ٹگل کریں",
  T_46_META_WS_ONTOUCHDOWN: "ٹچ ڈاؤن",
  T_46_META_WS_ONTOUCHUP: "ٹچ اپ",
  T_46_META_WS_ONUIHIDE: "UI چھپائیں",
  T_46_META_WS_ONUISHOW: "UI دکھائیں",
  T_46_META_WS_ONUPDATE: "اپ ڈیٹ کریں",
  T_46_META_WS_ONUSEAVATARSKILL: "اوتار کی مہارت استعمال کریں",
  T_46_META_WS_ONUSECONSUMABLE: "قابل استعمال کا استعمال",
  T_46_META_WS_ONUSED: "استعمال کیا گیا",
  T_46_META_WS_ONUSEPORTAL: "پورٹل کا استعمال کریں",
  T_46_META_WS_ONWAKEUP: "بیدار",
  T_46_META_WS_ONWEAPONBEEQUIPED: "ہتھیار سے لیس",
  T_46_META_WS_ONWEAPONDEALDAMAGE: "ہتھیار سے نقصان پہنچایا",
  T_46_META_WS_ONWEAPONELIMINATE: "ہتھیار نے ختم کیا",
  T_46_META_WS_ONWEAPONSTOPFIRING: "ہتھیار کی فائرنگ روکی گئی",
  T_46_META_WS_OWNER: "مالک",
  T_46_META_WS_P_ACCELERATE: "تیز رفتار",
  T_46_META_WS_P_ACCELERATION: "تیز رفتاری",
  T_46_META_WS_P_ACCOUNTID: "اکاؤنٹ ID",
  T_46_META_WS_P_ACCURACY: "درستگی",
  T_46_META_WS_P_ACTIONTYPE: "عمل کا نوع",
  T_46_META_WS_P_ACTIVATEDALPHA: "فعال الفا",
  T_46_META_WS_P_ACTIVE: "فعال",
  T_46_META_WS_P_ACTIVEINHIERARCHY: "ہائیرارکی میں فعال",
  T_46_META_WS_P_ACTIVESELF: "فعال خود",
  T_46_META_WS_P_ACTIVETEXT: "فعال ٹیکسٹ",
  T_46_META_WS_P_ACTUALPOSITION: "اصل مقام",
  T_46_META_WS_P_AFTERACCUMULATOR: "بعد ازاں اکھٹا",
  T_46_META_WS_P_AIMASSISTCENTEROFFSET: "مدد کے لیے مرکز شفٹ",
  T_46_META_WS_P_AIMASSISTDISTANCE: "مدد کے لیے فاصلے",
  T_46_META_WS_P_AIMASSISTTYPE: "نشانے کی مدد",
  T_46_META_WS_P_AIRDROPSTATE: "ایئر ڈراپ اسٹیٹ",
  T_46_META_WS_P_ALIGNMENTHORIZONTAL: "افقی صف بندی",
  T_46_META_WS_P_ALIGNMENTVERTICAL: "عمودی صف بندی",
  T_46_META_WS_P_ALLITEMS: "تمام اشیاء",
  T_46_META_WS_P_ALLMEMBERS: "تمام اراکین",
  T_46_META_WS_P_ALLOWLOCKBYAIMASSIST: "معاونت سے لاک کی اجازت",
  T_46_META_WS_P_ALLOWPRESSEDOUTSIDE: "باہر دبانے کی اجازت",
  T_46_META_WS_P_ALLPLAYERS: "تمام کھلاڑی",
  T_46_META_WS_P_ALLTEAMMATES: "تمام ساتھی",
  T_46_META_WS_P_ALPHA: "الفا",
  T_46_META_WS_P_ALWAYSSHOWMARK: "ہمیشہ مارک دکھائیں",
  T_46_META_WS_P_AMBIENTCOLOR: "ماحول کا رنگ",
  T_46_META_WS_P_AMMOCLIPSIZE: "گولیوں کی کلپ کا سائز",
  T_46_META_WS_P_AMMOMAGSIZE: "گولیوں کا میگ سائز",
  T_46_META_WS_P_AMMOPERSHOT: "ہر شاٹ کے لیے گولیوں کی تعداد",
  T_46_META_WS_P_AMMOTYPE: "گولہ بارود کی قسم",
  T_46_META_WS_P_ANCHORMAX: "اینکر زیادہ سے زیادہ",
  T_46_META_WS_P_ANCHORMIN: "اینکر کم از کم",
  T_46_META_WS_P_ANCHOROBJECT: "اینکر آبجیکٹ",
  T_46_META_WS_P_ANCHORPOSITION: "اینکر پوزیشن",
  T_46_META_WS_P_ANCHORTYPE: "UITweener اسکرپٹ فعال ہے",
  T_46_META_WS_P_ANGLE: "زاویہ",
  T_46_META_WS_P_ANGLEDOWN: "نیچے کا زاویہ",
  T_46_META_WS_P_ANGLEUP: "اوپر کا زاویہ",
  T_46_META_WS_P_ANGULARDRAG: "زاویائی رگڑ",
  T_46_META_WS_P_ANGULARSPEED: "زاویائی رفتار",
  T_46_META_WS_P_ANGULARVELOCITY: "زاویائی رفتار (ریڈیئن/سیکنڈ)",
  T_46_META_WS_P_ANIMATIONCLIP: "اینیمیشن کا نام",
  T_46_META_WS_P_ANIMATIONCONTROLLER: "اینیمیشن کنٹرولر",
  T_46_META_WS_P_ANIMATIONCONTROLLERRESID: "اینیمیشن کنٹرولر ریسورس آئی ڈی",
  T_46_META_WS_P_ARMORPENETRATION: "زره پينٹريشن",
  T_46_META_WS_P_ARMORPENETRATIONFACTOR: "آرمر پینٹریشن فیکٹر",
  T_46_META_WS_P_ARMORTYPE: "زرہ کی قسم",
  T_46_META_WS_P_ARROWOFFSET: "تیر آفسیٹ",
  T_46_META_WS_P_ARROWSIZE: "تیر کا سائز",
  T_46_META_WS_P_ARROWSPRITE: "تیر اسپرائٹ",
  T_46_META_WS_P_ASKBUYTARGET: "خریداری کے لئے ہدف کی درخواست",
  T_46_META_WS_P_ATTACHTARGET: "ہدف",
  T_46_META_WS_P_ATTACKABLEFACTIONS: "حملہ کرنے کے قابل گروہ",
  T_46_META_WS_P_ATTACKDAMAGE: "حملہ نقصان",
  T_46_META_WS_P_ATTACKINTERVAL: "حملے کا وقفہ",
  T_46_META_WS_P_ATTACKRANGE: "حملے کی رینج",
  T_46_META_WS_P_ATTACKTARGET: "حملہ ہدف",
  T_46_META_WS_P_ATTTACKABLETARGETS: "حملے کے قابل ہدف",
  T_46_META_WS_P_AUTOPLAY: "خودکار پلے اسٹیٹس",
  T_46_META_WS_P_AVAILABLEPOINT: "دستیاب پوائنٹ",
  T_46_META_WS_P_AVATAR: "اوتار",
  T_46_META_WS_P_AVATARID: "اوتار ID",
  T_46_META_WS_P_BACKGROUND: "پس منظر",
  T_46_META_WS_P_BACKGROUNDALPHA: "پس منظر کا الفا",
  T_46_META_WS_P_BACKGROUNDCOLOR: "پس منظر کا رنگ",
  T_46_META_WS_P_BACKGROUNDCOLOR1: "پس منظر کا رنگ 1",
  T_46_META_WS_P_BACKGROUNDCOLOR2: "پس منظر کا رنگ 2",
  T_46_META_WS_P_BACKGROUNDFILL: "پس منظر بھرنا",
  T_46_META_WS_P_BACKGROUNDICONNAME: "پس منظر آئیکن کا نام",
  T_46_META_WS_P_BACKGROUNDNAME: "پس منظر کا نام",
  T_46_META_WS_P_BACKGROUNDOFFSET: "پس منظر آفسیٹ",
  T_46_META_WS_P_BACKGROUNDRADIUS: "پس منظر کی ریڈیئس",
  T_46_META_WS_P_BACKGROUNDSIZEDELTA: "پس منظر کے سائز میں تبدیلی",
  T_46_META_WS_P_BACKGROUNDSPRITE: "پس منظر اسپرائٹ",
  T_46_META_WS_P_BACKPACK: "بیگ",
  T_46_META_WS_P_BACKPACKSKINID: "بیگ اسکن آئی ڈی",
  T_46_META_WS_P_BACKWARDSPEED: "پیچھے کی رفتار",
  T_46_META_WS_P_BANNERID: "بینر ID",
  T_46_META_WS_P_BASEHORIZONTALSPEED: "بنیادی افقی رفتار",
  T_46_META_WS_P_BASEMULTIPLIER: "بنیادی ضرب",
  T_46_META_WS_P_BASETIME: "بنیادی وقت",
  T_46_META_WS_P_BASEVERTICALSPEED: "بنیادی عمودی رفتار",
  T_46_META_WS_P_BEFOREACCUMULATOR: "قبل ازاں اکھٹا",
  T_46_META_WS_P_BEVTREEID: "رویہ درخت کی شناخت",
  T_46_META_WS_P_BINDPROPERTYID: "بائنڈ پراپرٹی آئی ڈی",
  T_46_META_WS_P_BODY: "دھڑ",
  T_46_META_WS_P_BODYDAMAGEFACTOR: "جسمانی نقصان کا عنصر",
  T_46_META_WS_P_BONEPOSITION: "ہڈی کی پوزیشن",
  T_46_META_WS_P_BONESCALE: "ہڈی کا سکیلنگ",
  T_46_META_WS_P_BOOSTCD: "بوسٹ کا کُل ڈاؤن",
  T_46_META_WS_P_BOOSTDURATION: "بوسٹ کی مدت",
  T_46_META_WS_P_BOOSTSPEED: "بوسٹ کی رفتار",
  T_46_META_WS_P_BORDERLR: "بائیں اور دائیں بارڈر",
  T_46_META_WS_P_BORDERTB: "اوپر اور نیچے بارڈر",
  T_46_META_WS_P_BOTTOMALPHA: "نیچے کا الفا",
  T_46_META_WS_P_BOUNDWALLET: "HUD اینکر کی قسم",
  T_46_META_WS_P_BRAKEHORSEPOWER: "بریک کی طاقت",
  T_46_META_WS_P_BRAKETORQUE: "بریک ٹارک",
  T_46_META_WS_P_BRRANK: "BR رینک",
  T_46_META_WS_P_BUFFTYPE: "بفر کی قسم",
  T_46_META_WS_P_BURNDAMAGE: "جلنے کی نقصان",
  T_46_META_WS_P_BURNINGDAMAGEINTERVAL: "جلنے کی نقصان کا وقفہ",
  T_46_META_WS_P_BURNTIME: "جلنے کا وقت",
  T_46_META_WS_P_BUTTOM: "نچلا حصہ",
  T_46_META_WS_P_BUTTONCOLORS: "بٹن کے رنگ",
  T_46_META_WS_P_BUTTONNAMES: "بٹن کے نام",
  T_46_META_WS_P_BUTTONSTYLE: "بٹن کا اسٹائل",
  T_46_META_WS_P_CAMERABLOCKMODE: "کیمرہ بلاک موڈ",
  T_46_META_WS_P_CAMERAPROJECTIONMODE: "کیمرہ پروجیکشن موڈ",
  T_46_META_WS_P_CAMERATYPE: "کیمرہ",
  T_46_META_WS_P_CANCELDRAGIFFITS: "اگر فٹ ہو جائے تو کھینچنا منسوخ کریں",
  T_46_META_WS_P_CANCOSTDURABILITY: "پائیداری کی قیمت کر سکتے ہیں",
  T_46_META_WS_P_CANDAMAGED: "نقصان پہنچ سکتا ہے",
  T_46_META_WS_P_CANDESTROY: "تباہ کیا جا سکتا ہے",
  T_46_META_WS_P_CANDESTROYED: "تباہ ہو سکتا ہے",
  T_46_META_WS_P_CANSELFTRIGGER: "خود ٹرگر کر سکتا ہے",
  T_46_META_WS_P_CANTEAMTRIGGER: "ٹیم کے ذریعہ ٹرگر کیا جا سکتا ہے",
  "T_46_META_WS_P_CANTRIGGEREDBY SELF": "خود سے متحرک کیا جا سکتا ہے",
  "T_46_META_WS_P_CANTRIGGEREDBY TEAM": "ٹیم کے ذریعے متحرک کیا جا سکتا ہے",
  "T_46_META_WS_P_CANTRIGGEREDBY VEHICLE": "گاڑی کے ذریعے متحرک کیا جا سکتا ہے",
  T_46_META_WS_P_CANVEHICLETRIGGER: "گاڑی کے ذریعہ ٹرگر کیا جا سکتا ہے",
  T_46_META_WS_P_CELLSIZE: "سیل کا سائز",
  T_46_META_WS_P_CELLSPACE: "سیل کی جگہ",
  T_46_META_WS_P_CENTER: "مرکز",
  T_46_META_WS_P_CENTERINVISIBLE: "مرکز ناقابلِ دید",
  T_46_META_WS_P_CENTEROFFSET: "مرکز آفسیٹ",
  T_46_META_WS_P_CENTEROFMASS: "ماس کا مرکز",
  T_46_META_WS_P_CENTERRANGE: "مرکزی دائرہ",
  T_46_META_WS_P_CENTRALFLASHTIME: "کنار کی چمک کا وقت",
  T_46_META_WS_P_CENTRALLINEACTIVE: "مرکزی لائن فعال",
  T_46_META_WS_P_CENTRALLINEPOSITION: "مرکزی لائن کا مقام",
  T_46_META_WS_P_CHANNELID: "چیٹ چینل ID",
  T_46_META_WS_P_CHARGEMAX: "زیادہ سے زیادہ چارج",
  T_46_META_WS_P_CHASETARGET: "تعقیب ہدف",
  T_46_META_WS_P_CHATCHANNEL: "چیٹ چینل",
  T_46_META_WS_P_CHECKPOINTID: "چیک پوائنٹ آئی ڈی",
  T_46_META_WS_P_CHILDINDEX: "بچے کی انڈیکس",
  T_46_META_WS_P_CHIPEXP: "چپ تجربہ",
  T_46_META_WS_P_CLICKSIZE: "کلک کا سائز",
  T_46_META_WS_P_CLIPLENGTH: "کلپ کی لمبائی",
  T_46_META_WS_P_CLIPPINGTYPE: "کلپنگ کی قسم",
  T_46_META_WS_P_COLLIDERID: "کولیڈر ID",
  T_46_META_WS_P_CONSTRAIN: "پابندی",
  T_46_META_WS_P_CONSTRAINT: "پابندی",
  T_46_META_WS_P_CONSTRAINTCOUNT: "پابندی کی تعداد",
  T_46_META_WS_P_CONSUMABLETYPE: "کھپت کی قسم",
  T_46_META_WS_P_CONTENT: "مواد",
  T_46_META_WS_P_CONTENTORIGIN: "مواد کی ابتدا",
  T_46_META_WS_P_CONTROLPOINTS: "کنٹرول پوائنٹس",
  T_46_META_WS_P_COORDINATESYSTEM: "کوآرڈینیٹ سسٹم",
  T_46_META_WS_P_COUNT: "مقدار",
  T_46_META_WS_P_COUNTDOWNENDTIME: "کاؤنٹ ڈاؤن کے اختتام کا وقت (s)",
  T_46_META_WS_P_COUNTDOWNKEY: "کاؤنٹ ڈاؤن کلید",
  T_46_META_WS_P_COUNTDOWNTIME: "کاؤنٹ ڈاؤن وقت",
  T_46_META_WS_P_COUNTPERWAVE: "ہر لہر کی تعداد",
  T_46_META_WS_P_CRASHMAXDAMAGE: "زیادہ سے زیادہ تصادم کی نقصان",
  T_46_META_WS_P_CRASHMAXSPEED: "تصادم کی زیادہ سے زیادہ رفتار",
  T_46_META_WS_P_CRASHMESSFACTOR: "تصادم ماس فیکٹر",
  T_46_META_WS_P_CRASHMINDAMAGE: "کم از کم تصادم کی نقصان",
  T_46_META_WS_P_CRAWLSPEEDSCALE: "کراول کی رفتار پیمائش",
  T_46_META_WS_P_CREATEDENTITY: "بنائی گئی اکائی",
  T_46_META_WS_P_CROUCHWALKSPEEDSCALE: "بیٹھنے کی حرکت کی رفتار پیمائش",
  T_46_META_WS_P_CSRANK: "CS رینک",
  "T_46_META_WS_P_CURRENT AMMO": "موجودہ گولیاں",
  T_46_META_WS_P_CURRENTANIMATIONRESOURCE: "موجودہ متحرکات وسائل",
  T_46_META_WS_P_CURRENTCLIP: "موجودہ کلپ",
  T_46_META_WS_P_CURRENTCLIPPROGRESS: "موجودہ کلپ کی ترقی",
  T_46_META_WS_P_CURRENTDURABILITY: "موجودہ استقامت",
  T_46_META_WS_P_CURRENTENERGY: "موجودہ توانائی",
  T_46_META_WS_P_CURRENTHANDHELDITEM: "موجودہ ہاتھ میں شے",
  T_46_META_WS_P_CURRENTHP: "موجودہ HP",
  T_46_META_WS_P_CURRENTPHASEINDEX: "موجودہ مرحلہ انڈیکس",
  T_46_META_WS_P_CURRENTPROGRESS: "موجودہ پیش رفت",
  T_46_META_WS_P_CURRENTROUNDINDEX: "موجودہ راؤنڈ انڈیکس",
  T_46_META_WS_P_CURRENTSTATE: "موجودہ حالت",
  T_46_META_WS_P_CURRENTVALUE: "موجودہ قدر",
  T_46_META_WS_P_CURRENTWAVE: "موجودہ لہر",
  T_46_META_WS_P_CUSTOMCHARACTERRESOURCE: "حسب ضرورت کردار کا مواد",
  T_46_META_WS_P_CUSTOMGAMERESULT: "کسٹم گیم کا نتیجہ",
  T_46_META_WS_P_CUSTOMGRAVITY: "حسب ضرورت کشش ثقل",
  T_46_META_WS_P_CUSTOMPUSHFORCE: "حسب ضرورت دھکا فورس",
  T_46_META_WS_P_CUSTOMXY: "حسب ضرورت XY",
  T_46_META_WS_P_DAMAGE: "نقصان",
  "T_46_META_WS_P_DAMAGE RANGE": "حد",
  T_46_META_WS_P_DAMAGEFACTOR: "نقصان کا عنصر",
  T_46_META_WS_P_DAMAGEINTERVAL: "نقصان وقفہ (ms)",
  T_46_META_WS_P_DAMAGERADIUS: "نقصان کا دائرہ",
  T_46_META_WS_P_DAMAGERATIOHEAD: "سر کو نقصان کا تناسب",
  T_46_META_WS_P_DAMAGERATIOLIMB: "اعضاء کو نقصان کا تناسب",
  T_46_META_WS_P_DAMAGEREDUCTIONFACTOR: "نقصان کم کرنے کا عنصر",
  T_46_META_WS_P_DAMAGETAKENPCT: "نقصان کا فیصد",
  T_46_META_WS_P_DAMAGETAKENPERCENT: "حاصل کردہ نقصان کا فیصد",
  T_46_META_WS_P_DAMAGEVALUE: "نقصان کی قیمت",
  T_46_META_WS_P_DARKNESS: "تاریکی",
  T_46_META_WS_P_DECELERATIONPERCENT: "رفتار میں کمی کا فیصد",
  T_46_META_WS_P_DEFAULTTEXT: "ڈیفالٹ ٹیکسٹ",
  T_46_META_WS_P_DEFENSE: "دفاع کی شرح",
  T_46_META_WS_P_DEFENSERATE: "دفاع کی شرح",
  T_46_META_WS_P_DELTA: "ڈیلٹا",
  T_46_META_WS_P_DELTATIME: "ڈیٹا ٹائم",
  T_46_META_WS_P_DELTAVALUE: "ڈیلٹا قدر",
  T_46_META_WS_P_DEPTH: "گہرائی",
  T_46_META_WS_P_DESC: "وضاحت",
  T_46_META_WS_P_DESCRIPTION: "تفصیل",
  T_46_META_WS_P_DESCRIPTIONKEY: "تفصیل کی کلید",
  T_46_META_WS_P_DESCRIPTIONPARAMS: "تجاویز کی تفصیل کے پیرامیٹر",
  T_46_META_WS_P_DESTVAL: "منزل قدر",
  T_46_META_WS_P_DETECTRANGE: "پتہ لگانے کی حد",
  T_46_META_WS_P_DIFFUSEALPHA: "پھیلاؤ الفا",
  T_46_META_WS_P_DIFFUSECOLOR: "پھیلاؤ رنگ",
  T_46_META_WS_P_DIFFUSETEXTURE: "پھیلاؤ ٹیکسچر",
  T_46_META_WS_P_DISABLECOLOR: "غیر فعال رنگ",
  T_46_META_WS_P_DISABLEFALLDAMAGE: "گرنے کے دوران نقصان بند کریں",
  T_46_META_WS_P_DISABLEITEMDROP: "اشیاء گرانا بند کریں",
  T_46_META_WS_P_DISABLEITEMPICKUP: "اشیاء اٹھانا بند کریں",
  T_46_META_WS_P_DISABLEMANUALCLOSING: "دستی بندش کو غیر فعال کریں",
  T_46_META_WS_P_DISABLEQUICKCHAT: "تیز چیٹ کو بند کریں",
  T_46_META_WS_P_DISABLERECIPROCATING: "واپس جانے والی حرکت کو غیر فعال کریں",
  T_46_META_WS_P_DISABLEVOICECHAT: "وائس چیٹ کو بند کریں",
  T_46_META_WS_P_DISTANCE: "فاصلہ",
  T_46_META_WS_P_DOUBLEGUNTYPE: "ڈبل گن قسم",
  T_46_META_WS_P_DOWNEDCRAWLSPEEDSCALE: "کراول کی رفتار پیمائش",
  T_46_META_WS_P_DOWNSPEED: "نیچے کی رفتار",
  T_46_META_WS_P_DRAG: "رگڑ",
  T_46_META_WS_P_DRIVER: "ڈرائیور",
  T_46_META_WS_P_DROPITEMS: "ڈراپ آئٹمز",
  T_46_META_WS_P_DURABILITY: "پائیداری",
  T_46_META_WS_P_DURABILITYRECOVERY: "پائیداری کی بازیابی",
  T_46_META_WS_P_DURATION: "دورانیہ",
  T_46_META_WS_P_EDGEFLASHTIME: "فلیش بینک ہٹ اثر سوئچ",
  T_46_META_WS_P_EFFECTACTIVE: "اثر فعال",
  T_46_META_WS_P_EFFECTCOLOR: "اثر رنگ",
  T_46_META_WS_P_EFFECTDURATION: "ٹرگر وقت",
  T_46_META_WS_P_EFFECTIVETIMEINTERVAL: "مؤثر وقت کا وقفہ",
  T_46_META_WS_P_EFFECTRESID: "اثر کا وسائل کا راستہ",
  T_46_META_WS_P_ENABLE: "فعال کریں",
  T_46_META_WS_P_ENABLEATTACK: "حملے کو فعال کریں",
  T_46_META_WS_P_ENABLEBOTREVIVE: "بوٹ کی بحالی فعال کریں",
  T_46_META_WS_P_ENABLEDEPTHMAP: "ڈیپتھ میپ فعال کریں",
  T_46_META_WS_P_ENABLEDROPONDEATH: "موت پر گرنے کا عمل فعال ہے یا نہیں",
  T_46_META_WS_P_ENABLELOCALIZATION: "مقامی کاری فعال کریں",
  T_46_META_WS_P_ENABLEMOVEINMIDAIR: "ہوا میں حرکت کرنے کی اجازت ہے",
  T_46_META_WS_P_ENABLEPLAYERREVIVE: "کھلاڑی کو دوبارہ زندہ کرنے کی اجازت دیں",
  T_46_META_WS_P_ENABLEPLAYERVIEW: "کھلاڑی کے نقطہ نظر کو فعال کریں",
  T_46_META_WS_P_ENABLEROTATEWITHGRAVITY: "کشش ثقل کے ساتھ گردش کو فعال کریں",
  T_46_META_WS_P_ENABLESKINATTRIBUTES: "جلد کی خصوصیات کو فعال کریں",
  T_46_META_WS_P_ENABLESWINGING: "جھولنے کو فعال کریں",
  T_46_META_WS_P_ENABLETRACTION: "ٹریکشن کو فعال کریں",
  T_46_META_WS_P_ENDPOSITION: "اختتامی مقام",
  T_46_META_WS_P_ENDRADIUS: "اختتامی رداس",
  T_46_META_WS_P_ENDTIME: "اختتامی وقت (ms)",
  T_46_META_WS_P_ENDTIMES: "اختتامی وقت",
  T_46_META_WS_P_ENDVALUE: "اختتامی قدر",
  T_46_META_WS_P_ENERGY: "توانائی",
  T_46_META_WS_P_ENERGYCOST: "توانائی کی قیمت",
  T_46_META_WS_P_ENERGYRECOVERY: "توانائی کی بحالی",
  T_46_META_WS_P_ENGINEHORSEPOWER: "انجن کی طاقت",
  T_46_META_WS_P_ENGINETORQUE: "انجن ٹارک",
  T_46_META_WS_P_EP: "EP",
  T_46_META_WS_P_EPMAX: "زیادہ سے زیادہ EP",
  T_46_META_WS_P_EPRECOVERYAMOUNT: "EP کی بحالی کی مقدار",
  T_46_META_WS_P_EVENTS: "ایونٹس",
  T_46_META_WS_P_EXPLODEDAMAGE: "دھماکے کی نقصان",
  T_46_META_WS_P_EXPLODEDAMAGEREDUCTIONFACTOR: "دھماکہ خیز نقصان کم کرنے کا عنصر",
  T_46_META_WS_P_EXPLODEDELAY: "دھماکے کی تاخیر",
  T_46_META_WS_P_EXPLODERANGE: "دھماکے کی رینج",
  T_46_META_WS_P_EXPLOSIONDELAY: "مرکزی چمک کا وقت",
  T_46_META_WS_P_EXPLOSIONRANGE: "دھماکہ کا دائرہ",
  T_46_META_WS_P_EXPLOSIONTIME: "دھماکہ تاخیر",
  T_46_META_WS_P_EXPPERDAMAGE: "فی نقصان پر تجربہ",
  T_46_META_WS_P_EXPPERMOVEMILE: "فی حرکت میل پر تجربہ",
  T_46_META_WS_P_EXPPERSECOND: "فی سیکنڈ پر تجربہ",
  T_46_META_WS_P_EXTRABACKPACKCAPACITY: "اضافی بیک پیک کی صلاحیت",
  T_46_META_WS_P_EXTRABAGCAPACITY: "اضافی बैग की जगह",
  T_46_META_WS_P_EXTRAHPRATIO: "اضافی HP کا تناسب",
  T_46_META_WS_P_FACEPAINT: "چہرے کی پینٹنگ",
  T_46_META_WS_P_FACTION: "فریق",
  T_46_META_WS_P_FALLINGDAMAGERATIO: "گرنے کا نقصان کا تناسب",
  T_46_META_WS_P_FALLSPEED: "گرنے کی رفتار",
  T_46_META_WS_P_FASTAUTORELOADSPEED: "خودکار دوبارہ لوڈ کرنے کی رفتار",
  T_46_META_WS_P_FILEID: "فائل آئی ڈی",
  T_46_META_WS_P_FILL: "بھرنا",
  T_46_META_WS_P_FILLAMOUNT: "بھرنے کی مقدار",
  T_46_META_WS_P_FILLDIRECTION: "بھرنے کی سمت",
  T_46_META_WS_P_FILLTYPE: "بھرنے کی قسم",
  T_46_META_WS_P_FIREANGLELIMIT: "آگ کی زاویائی حد",
  T_46_META_WS_P_FIRETYPE: "فائر ٹائپ",
  T_46_META_WS_P_FIRSTSCOREPARAMS: "پہلا اسکور پیرامیٹر",
  T_46_META_WS_P_FIRSTSCORETITLE: "پہلا اسکور عنوان",
  T_46_META_WS_P_FIRSTSCOREVALUE: "پہلا اسکور قیمت",
  T_46_META_WS_P_FIXEDDELTATIME: "فکسڈ ڈیلٹا وقت",
  T_46_META_WS_P_FLASHBANGHITEFFECTSWITCH: "اثر کی مدت",
  T_46_META_WS_P_FLIP: "پلٹائیں",
  T_46_META_WS_P_FLIPTYPE: "پلٹائیں کی قسم",
  T_46_META_WS_P_FLYMAXHEIGHT: "زیادہ سے زیادہ اڑان کی اونچائی",
  T_46_META_WS_P_FLYSPEEDHORIZONTAL: "افقی پرواز کی رفتار",
  T_46_META_WS_P_FLYSPEEDVERTICAL: "عمودی پرواز کی رفتار",
  T_46_META_WS_P_FOGCOLOR: "کہر کا رنگ",
  T_46_META_WS_P_FOLLOWTARGET: "ہدف کا پیچھا کریں",
  T_46_META_WS_P_FONT: "فونٹ",
  T_46_META_WS_P_FONTSIZE: "فونٹ کا سائز",
  T_46_META_WS_P_FONTSTYLE: "فونٹ اسٹائل",
  T_46_META_WS_P_FONTTYPE: "فونٹ کی قسم",
  T_46_META_WS_P_FORCESYNCTOCLIENT: "کلائنٹ کے ساتھ زبردستی ہم وقت سازی",
  T_46_META_WS_P_FORWARD: "آگے",
  T_46_META_WS_P_FORWARDSPEED: "آگے کی رفتار",
  T_46_META_WS_P_FOV: "دیکھنے کا میدان",
  T_46_META_WS_P_FREEZEDURATION: "فریز کی مدت (سیکنڈ)",
  T_46_META_WS_P_FRIENDFACTIONS: "دوست گروہ",
  T_46_META_WS_P_FRIENDLYPLAYERS: "دوستانہ کھلاڑی",
  T_46_META_WS_P_FULLDAMAGEDISTANCE: "مکمل نقصان کی دوری",
  T_46_META_WS_P_FUNCTIONTYPE: "فنکشن کی قسم",
  T_46_META_WS_P_GAINHPCOLOR: "HP اضافہ رنگ",
  T_46_META_WS_P_GAMEFRAMECOUNT: "فریموں کی تعداد",
  T_46_META_WS_P_GAMETIMECOUNT: "کھیل کا وقت",
  T_46_META_WS_P_GEARSHIFTINGDELAY: "گیئر شفٹنگ تاخیر",
  T_46_META_WS_P_GENDER: "جنس",
  T_46_META_WS_P_GETONBOOSTCD: "بوسٹ پر چڑھنے کا کُول ڈاؤن",
  T_46_META_WS_P_GETONBOOSTCDSWITCH: "بوسٹ پر چڑھنے کا کُول ڈاؤن سوئچ",
  T_46_META_WS_P_GETONSKATEBOARDCD: "اسکیٹ بورڈ پر چڑھنے کا کُول ڈاؤن",
  T_46_META_WS_P_GRADIENT: "گریڈینٹ",
  T_46_META_WS_P_GRADIENTBOTTOM: "گریڈینٹ نیچے",
  T_46_META_WS_P_GRADIENTTOP: "گریڈینٹ اوپر",
  T_46_META_WS_P_GRAVITY: "کشش ثقل",
  T_46_META_WS_P_GRENADEMAXDAMAGE: "گرینیڈ زیادہ نقصان",
  T_46_META_WS_P_GRENADEMINDAMAGE: "گرینیڈ کم نقصان",
  T_46_META_WS_P_GRENADERANGE: "گرینیڈ رینج",
  T_46_META_WS_P_GROUPID: "گروپ ID",
  T_46_META_WS_P_HEAD: "سر",
  T_46_META_WS_P_HEADDAMAGEFACTOR: "سر کا نقصان عنصر",
  T_46_META_WS_P_HEADSHOTDAMAGEREDUCTION: "ہیڈ شاٹ نقصان میں کمی",
  T_46_META_WS_P_HEIGHT: "اونچائی",
  T_46_META_WS_P_HELMET: "ہیلمٹ",
  T_46_META_WS_P_HIGHESTBRRANK: "سب سے اعلی BR رینک",
  T_46_META_WS_P_HIGHESTCSRANK: "سب سے اعلی CS رینک",
  T_46_META_WS_P_HIGHSHOOTANGLEMIN: "کم از کم اونچائی زاویہ",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLE: "تیز رفتار اسٹیئرنگ کی حد",
  T_46_META_WS_P_HIGHSPEEDSTEERANGLEATSPEED: "تیز رفتار اسٹیئرنگ کی حد کا تھریشولڈ",
  T_46_META_WS_P_HITPOINTEFFECT: "ہٹ پوائنٹ کا اثر",
  T_46_META_WS_P_HORIZONTALBAR: "افقی بار",
  T_46_META_WS_P_HORIZONTALOFFSET: "افقی آفسیٹ",
  T_46_META_WS_P_HOSTILETEAMS: "دشمن ٹیمیں",
  T_46_META_WS_P_HOSTTEAM: "میزبان ٹیم",
  T_46_META_WS_P_HP: "HP",
  T_46_META_WS_P_HPMAX: "زیادہ سے زیادہ HP",
  T_46_META_WS_P_HPRECOVERYAMOUNT: "HP کی بحالی کی مقدار",
  T_46_META_WS_P_HPRECOVERYSPEED: "HP بحالی کی رفتار (ملی سیکنڈ)",
  T_46_META_WS_P_ICON: "آئیکن",
  T_46_META_WS_P_ICONCOLOR: "آئیکن رنگ",
  T_46_META_WS_P_ICONNAME: "آئیکن کا نام",
  T_46_META_WS_P_ICONRESOURCE: "آئیکن ریسورس",
  T_46_META_WS_P_ID: "آئی ڈی",
  "T_46_META_WS_P_IDAMAGE NTERVAL": "نقصان کا وقفہ (سیکنڈ)",
  T_46_META_WS_P_IDLEBRAKEINPUT: "آئیڈل بریک ان پٹ",
  T_46_META_WS_P_INACTIVATEDALPHA: "غیر فعال الفا",
  T_46_META_WS_P_INDEX: "اشاریہ",
  T_46_META_WS_P_INITIALMAGCOUNT: "ابتدائی میگ کی تعداد",
  T_46_META_WS_P_INITIALSPEED: "ابتدائی رفتار",
  T_46_META_WS_P_INITIALVALUE: "ابتدائی قیمت",
  T_46_META_WS_P_INITIALWORLDPOSITION: "ابتدائی عالمی مقام",
  T_46_META_WS_P_INSCENE: "منظر میں",
  T_46_META_WS_P_INSTANCEID: "انسٹانس آئی ڈی",
  T_46_META_WS_P_INTENSITY: "شدت",
  T_46_META_WS_P_INVERTFILL: "بھرنا پلٹائیں",
  T_46_META_WS_P_INVINCIBLE: "ناقابلِ شکست",
  "T_46_META_WS_P_IS SHOW": "دکھا رہا ہے یا نہیں",
  T_46_META_WS_P_IS3D: "3D ہے یا نہیں",
  T_46_META_WS_P_ISACE: "کیا ACE ہے؟",
  T_46_META_WS_P_ISACED: "مکمل طور پر شکست",
  T_46_META_WS_P_ISAI: "کیا یہ AI ہے؟",
  T_46_META_WS_P_ISALWAYSINSCREEN: "ہمیشہ اسکرین پر",
  T_46_META_WS_P_ISAPPLYSHADOW: "سائے لگائیں",
  T_46_META_WS_P_ISATTACKABLE: "قابل حمل",
  T_46_META_WS_P_ISAUTOCHASEENEMY: "خودکار دشمن کا پیچھا کرنا",
  T_46_META_WS_P_ISAUTOPLAY: "خودکار پلے",
  T_46_META_WS_P_ISAUTOTELEPORT: "خودکار ٹیلیپورٹ ہے یا نہیں",
  T_46_META_WS_P_ISBILLBOARD: "ہمیشہ ویڈیو میں",
  T_46_META_WS_P_ISBOLD: "بولڈ",
  T_46_META_WS_P_ISBOTTOMCOLLIDING: "نیچے ٹکرا رہا ہے",
  T_46_META_WS_P_ISCENTERPOS: "مرکز پوزیشن ہے",
  T_46_META_WS_P_ISCONSUMEAMMO: "گولیوں کا استعمال",
  T_46_META_WS_P_ISCONTINUOUS: "مسلسل ہے یا نہیں",
  T_46_META_WS_P_ISCOUNTDOWN: "کاؤنٹ ڈاؤن ہے",
  T_46_META_WS_P_ISCURRENTANIMATIONLOOP: "کیا موجودہ متحرکات لوپ ہے؟",
  T_46_META_WS_P_ISDEADDROP: "موت کی مدد",
  T_46_META_WS_P_ISDEATHTRIGGER: "موت کا ٹرگر ہے یا نہیں",
  T_46_META_WS_P_ISDEBUG: "BTree ڈیبگ فعال کریں",
  T_46_META_WS_P_ISDEFAULTSPAWNPOINT: "ڈیفالٹ اسپاؤن پوائنٹ ہے یا نہیں",
  T_46_META_WS_P_ISDROPONELIMINATED: "موت پر تمام سازوسامان گم ہو جاتا ہے",
  T_46_META_WS_P_ISEND: "اختتام",
  T_46_META_WS_P_ISFEBUTTON: "FE بٹن ہے",
  T_46_META_WS_P_ISGREY: "سرمئی ہے",
  T_46_META_WS_P_ISGROUNDED: "زمین پر ہے",
  T_46_META_WS_P_ISIGNOREDEPTH: "گہرائی کو نظرانداز کریں",
  T_46_META_WS_P_ISINVINCIBLE: "ناقابل شکست ہے",
  T_46_META_WS_P_ISITALIC: "اٹالک",
  T_46_META_WS_P_ISLASTROUND: "آخری دور ہے",
  T_46_META_WS_P_ISLOCALPOS: "مقامی ہم آہنگی نظام فعال",
  T_46_META_WS_P_ISLOOP: "کیا لوپنگ ہے",
  T_46_META_WS_P_ISMATCHPOINT: "میچ پوائنٹ ہے",
  T_46_META_WS_P_ISMOVEABLE: "حرکت کر سکتا ہے",
  T_46_META_WS_P_ISOCCUPIED: "زیرِ استعمال ہے یا نہیں",
  T_46_META_WS_P_ISOPENTWEEN: "HP تبدیلی اثر فعال",
  T_46_META_WS_P_ISPLAYING: "چل رہا ہے",
  T_46_META_WS_P_ISPURCHASABLE: "اسٹور آئٹمز",
  T_46_META_WS_P_ISREVERSE: "الٹائیں",
  T_46_META_WS_P_ISSERVERDRIVEN: "سرور کے ذریعے چلایا گیا ہے",
  T_46_META_WS_P_ISSHOW: "دکھائیں",
  T_46_META_WS_P_ISSHOWHUDNAME: "HUD نام دکھائیں",
  T_46_META_WS_P_ISSHOWMAPINFO: "نقشے کی معلومات دکھائیں",
  T_46_META_WS_P_ISSHOWQUICKMESSAGE: "فوری پیغام دکھائیں",
  T_46_META_WS_P_ISSHOWSCAN: "اسکین دکھائیں",
  T_46_META_WS_P_ISSHOWTAG: "ٹیگ دکھائیں",
  T_46_META_WS_P_ISSIDECOLLIDING: "سائڈ ٹکرا رہا ہے",
  T_46_META_WS_P_ISSILENCE: "خاموش ہے",
  T_46_META_WS_P_ISSINGLESHOT: "سنگل شاٹ ہے",
  T_46_META_WS_P_ISSKIPSTAGGERANIMATION: "گرنے کی متحرکات کو نظر انداز کریں",
  T_46_META_WS_P_ISSLIDING: "سلائڈنگ ہے",
  T_46_META_WS_P_ISTOPCOLLIDING: "اوپر ٹکرا رہا ہے",
  T_46_META_WS_P_ISUNDERLINE: "لائن کے نیچے",
  T_46_META_WS_P_ISVISIBLE: "ظاہر ہے",
  T_46_META_WS_P_ITEMBACKGROUNDCOLORS: "آئٹم پس منظر رنگ",
  T_46_META_WS_P_ITEMBACKGROUNDS: "آئٹم پس منظر اسپریٹ",
  T_46_META_WS_P_ITEMCOUNTS: "خریدنے کے قابل ہے یا نہیں",
  T_46_META_WS_P_ITEMDESCRIPTIONS: "آئٹم کی تفصیل",
  T_46_META_WS_P_ITEMICONS: "آئٹم آئیکن",
  T_46_META_WS_P_ITEMID: "آئٹم ID",
  T_46_META_WS_P_ITEMIDS: "آئٹم کی شناختیں",
  T_46_META_WS_P_ITEMNAMES: "آئٹم نام",
  T_46_META_WS_P_ITEMPICKUPBANLIST: "ممنوع اشیاء کی فہرست",
  T_46_META_WS_P_JOYSTICKDRAGRADIUS: "جوائس اسٹک کیپ ڈریگ کی ریڈیئس",
  T_46_META_WS_P_JOYSTICKIMAGE: "جوائس اسٹک کیپ امیج",
  T_46_META_WS_P_JOYSTICKRADIUS: "جوائس اسٹک کیپ کی ریڈیئس",
  T_46_META_WS_P_JUMPCD: "جمپ کُولڈاؤن",
  T_46_META_WS_P_JUMPHEIGHT: "چھلانگ کی اونچائی",
  T_46_META_WS_P_JUMPHEIGHTSCALE: "جمپ کی اونچائی پیمانہ",
  T_46_META_WS_P_KNOCKDOWNDAMAGEBONUS: "گرا کر نقصان کا بونس",
  T_46_META_WS_P_KNOCKDOWNSTATUS: "ناک ڈاؤن کا اسٹیٹس",
  T_46_META_WS_P_LABEL: "لیبل",
  T_46_META_WS_P_LABELCOLOR: "لیبل کا رنگ",
  T_46_META_WS_P_LABELKEY: "لیبل کلید",
  T_46_META_WS_P_LABELPARAMS: "لیبل پیرامیٹر",
  T_46_META_WS_P_LASTCHECKPOINTID: "موجودہ چیک پوائنٹ آئی ڈی",
  T_46_META_WS_P_LASTSURVIVALTIME: "آخری بقا کا وقت",
  T_46_META_WS_P_LAYERTYPE: "پرت کی قسم",
  T_46_META_WS_P_LAYOUTTYPE: "لے آؤٹ کی قسم",
  T_46_META_WS_P_LEFTARM: "بایاں بازو",
  T_46_META_WS_P_LEFTBACKGROUNDCOLOR: "بائیں پس منظر کا رنگ",
  T_46_META_WS_P_LEFTCOLOR: "بائیں رنگ",
  T_46_META_WS_P_LEFTDESCRIPTION: "بائیں ٹیم کی تفصیل",
  T_46_META_WS_P_LEFTEFFECTACTIVE: "بائیں اثر فعال",
  T_46_META_WS_P_LEFTFIRINGARCANGLE: "بائیں جانب فائرنگ آرک زاویہ",
  T_46_META_WS_P_LEFTFOOT: "بایاں پاؤں",
  T_46_META_WS_P_LEFTHAND: "بایاں ہاتھ",
  T_46_META_WS_P_LEFTICON: "بائیں آئیکن",
  T_46_META_WS_P_LEFTICONNAME: "بائیں آئیکن کا نام",
  T_46_META_WS_P_LEFTLEG: "بایاں ٹانگ",
  T_46_META_WS_P_LEFTPLAYERS: "بائیں کھلاڑی",
  T_46_META_WS_P_LEFTSCORE: "بایاں اسکور",
  T_46_META_WS_P_LEFTSCOREAFTER: "بایاں آخری اسکور",
  T_46_META_WS_P_LEFTSCORETEXT: "بائیں اسکور",
  T_46_META_WS_P_LEFTTEAM: "دائیں ٹیم",
  T_46_META_WS_P_LEFTTEAMINDEX: "بائیں ٹیم کا انڈیکس",
  T_46_META_WS_P_LEFTTEAMMATEALIVENUM: "بائیں ساتھی کی زندہ تعداد",
  T_46_META_WS_P_LEFTTEAMMATEFLAGCOUNT: "بائیں ٹیم کا جھنڈا شمار",
  T_46_META_WS_P_LEFTTEAMMATESTATES: "بائیں ٹیم کے اراکین کی حالت",
  T_46_META_WS_P_LEFTTEAMNAME: "بائیں ٹیم کا نام",
  T_46_META_WS_P_LEFTTEAMSCORE: "بائیں ٹیم کا اسکور",
  T_46_META_WS_P_LEFTTEXT: "بائیں ٹیکسٹ",
  T_46_META_WS_P_LENGTH: "لمبائی",
  T_46_META_WS_P_LENSFLARE: "لینس فلیئر",
  T_46_META_WS_P_LEVEL: "سطح",
  T_46_META_WS_P_LIFETIME: "زندگی کا وقت (سیکنڈ)",
  T_46_META_WS_P_LIGHTCOLOR: "روشنی کا رنگ",
  T_46_META_WS_P_LIGHTINTENSITY: "روشنی کی شدت",
  T_46_META_WS_P_LIMBDAMAGEFACTOR: "اعضاء کا نقصان عنصر",
  T_46_META_WS_P_LINESPACING: "لائن اسپیسنگ",
  T_46_META_WS_P_LOCALPOSITION: "مقامی مقام",
  T_46_META_WS_P_LOCALROTATION: "مقامی گردش",
  T_46_META_WS_P_LOCALROTATIONQ: "مقامی گردش کوآٹیرنین",
  T_46_META_WS_P_LOCALSCALE: "مقامی پیمانہ",
  T_46_META_WS_P_LOCKEY: "لوکلائزیشن کلید",
  T_46_META_WS_P_LOOPCOUNT: "لوپ کی تعداد",
  T_46_META_WS_P_LOOTSOCCER: "لूट فٹ بال",
  T_46_META_WS_P_LOSEHPCOLOR: "HP کم رنگ",
  T_46_META_WS_P_LOSEMVPS: "ہارنے والے MVPs",
  T_46_META_WS_P_LOSETEXT: "ہار کا متن",
  "T_46_META_WS_P_MAIN CAMERA": "مرکزی کیمرہ",
  T_46_META_WS_P_MAINCOLOR: "بنیادی رنگ",
  T_46_META_WS_P_MAINSCORELIST: "مرکزی اسکور",
  T_46_META_WS_P_MAINSCORETITLE: "مرکزی اسکور عنوان",
  T_46_META_WS_P_MAINWEAPON: "بنیادی ہتھیار",
  T_46_META_WS_P_MAPSIZE: "نقشہ کا سائز",
  T_46_META_WS_P_MASK: "ماسک",
  T_46_META_WS_P_MASKNAME: "ماسک کا نام",
  T_46_META_WS_P_MASS: "ماس (کلوگرام)",
  T_46_META_WS_P_MATCHTITLELEFT: "میچ کا عنوان بائیں",
  T_46_META_WS_P_MATCHTITLERIGHT: "میچ کا عنوان دائیں",
  T_46_META_WS_P_MAXCAPACITY: "زیادہ سے زیادہ گنجائش",
  T_46_META_WS_P_MAXCOUNT: "زیادہ سے زیادہ گنتی",
  T_46_META_WS_P_MAXDAMAGE: "زیادہ سے زیادہ نقصان",
  T_46_META_WS_P_MAXDEPRESSIONANGLE: "زیادہ سے زیادہ ڈپریشن زاویہ",
  T_46_META_WS_P_MAXDISPLACEMENT: "زیادہ سے زیادہ منتقل",
  T_46_META_WS_P_MAXDISTANCE: "زیادہ سے زیادہ فاصلہ",
  T_46_META_WS_P_MAXDURABILITY: "زیادہ سے زیادہ استقامت",
  T_46_META_WS_P_MAXDURABILITYRATIO: "زیادہ سے زیادہ پائیداری کا تناسب",
  T_46_META_WS_P_MAXENERGY: "زیادہ سے زیادہ توانائی",
  T_46_META_WS_P_MAXEP: "زیادہ سے زیادہ توانائی",
  T_46_META_WS_P_MAXHP: "زیادہ سے زیادہ HP",
  T_46_META_WS_P_MAXJUMPCOUNT: "زیادہ سے زیادہ چھلانگ کی تعداد",
  T_46_META_WS_P_MAXJUMPHEIGHT: "زیادہ سے زیادہ چھلانگ کی اونچائی",
  T_46_META_WS_P_MAXLENGTH: "زیادہ سے زیادہ لمبائی",
  T_46_META_WS_P_MAXPROGRESS: "زیادہ سے زیادہ پیش رفت",
  T_46_META_WS_P_MAXSCATTERRATIO: "زیادہ سے زیادہ بکھرنے کا تناسب",
  T_46_META_WS_P_MAXSPEED: "زیادہ سے زیادہ رفتار",
  T_46_META_WS_P_MAXTURRETCOUNT: "زیادہ سے زیادہ ٹرٹل کی تعداد",
  T_46_META_WS_P_MAXVALUE: "زیادہ سے زیادہ قدر",
  T_46_META_WS_P_MAXWIDGETID: "MaxWidgetID",
  T_46_META_WS_P_MINDAMAGE: "کم سے کم نقصان",
  T_46_META_WS_P_MINDAMAGEDISTANCE: "کم سے کم نقصان کا فاصلہ",
  T_46_META_WS_P_MINDISTANCE: "کم از کم فاصلہ",
  T_46_META_WS_P_MINELEVATIONANGLE: "کم از کم اونچائی کا زاویہ",
  T_46_META_WS_P_MINENDHEIGHT: "کم از کم اختتامی اونچائی",
  T_46_META_WS_P_MINFLYHEIGHT: "کم از کم پرواز کی اونچائی",
  T_46_META_WS_P_MINMOVEDISTANCE: "کم سے کم حرکت کی دوری",
  T_46_META_WS_P_MINVALUE: "کم از کم قیمت",
  T_46_META_WS_P_MISSILEMAXDAMAGE: "میزائل کا زیادہ سے زیادہ نقصان",
  T_46_META_WS_P_MISSILEMINDAMAGE: "میزائل کا کم سے کم نقصان",
  T_46_META_WS_P_MISSILERANGE: "میزائل کی رینج",
  T_46_META_WS_P_MODEL: "ماڈل",
  T_46_META_WS_P_MODELVISIBILITY: "ماڈل کی مرئیت",
  T_46_META_WS_P_MODELVISIBLE: "ماڈل کی نمائش",
  T_46_META_WS_P_MONEY: "پیسے",
  T_46_META_WS_P_MONEYLIST: "پیسوں کی فہرست",
  T_46_META_WS_P_MONEYS: "باؤنڈ والیٹ",
  T_46_META_WS_P_MONEYTYPE: "کرنسی کی قسم",
  T_46_META_WS_P_MONSTERTYPE: "عفریت کی قسم",
  T_46_META_WS_P_MOTIONTYPE: "حرکت کی قسم",
  T_46_META_WS_P_MOTIONVALUEX: "X محور پر حرکت کی قیمت",
  T_46_META_WS_P_MOTIONVALUEY: "Y محور پر حرکت کی قیمت",
  T_46_META_WS_P_MOTIONVALUEZ: "Z محور پر حرکت کی قیمت",
  T_46_META_WS_P_MOVEMENTDURATION: "حرکت کی مدت",
  T_46_META_WS_P_MULTIPLIER: "ضرب",
  T_46_META_WS_P_MUSICELEMENTTYPE: "موسیقی کا عنصر کی قسم",
  T_46_META_WS_P_MUZZLEVELOCITY: "نالی کی رفتار",
  T_46_META_WS_P_MVP: "ایم وی پی",
  T_46_META_WS_P_NAME: "نام",
  T_46_META_WS_P_NEXTROUNDINDEX: "اگلے دور کی انڈیکس",
  T_46_META_WS_P_NICKNAME: "عرفیت",
  T_46_META_WS_P_NORMALCOLOR: "عام رنگ",
  T_46_META_WS_P_NORMALIZEDPOSITION: "معیاری مقام",
  T_46_META_WS_P_NUMBERINFACTION: "فریکشن میں نمبر",
  T_46_META_WS_P_OBJECTID: "آبجیکٹ آئی ڈی",
  T_46_META_WS_P_OFFSET: "آفسیٹ",
  T_46_META_WS_P_OPTIONS: "اختیارات",
  T_46_META_WS_P_OTHERDAMAGEFACTOR: "دوسرے نقصان کا عنصر",
  T_46_META_WS_P_OUTFIT: "کھلاڑی کا لباس",
  T_46_META_WS_P_OVERFLOW: "اوورفلو",
  T_46_META_WS_P_OVERHEIGHTFALLSPEED: "اونچائی سے تجاوز کرنے کے بعد کی رفتار",
  T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION: "کھلاڑی کی ترتیب کی ترجیح",
  T_46_META_WS_P_OWNER: "مالک",
  T_46_META_WS_P_PARAMS: "پیرامیٹر",
  T_46_META_WS_P_PARENT: "والدین",
  T_46_META_WS_P_PARENTID: "والدین ID",
  T_46_META_WS_P_PARENTUI: "والدین UI",
  T_46_META_WS_P_PARENTWIDGETENTITYID: "والدین ویجیٹ کی شناخت",
  T_46_META_WS_P_PARENTWIDGETFILEID: "والدین ویجٹ فائل آئی ڈی",
  T_46_META_WS_P_PARTMASKA: "حصہ ماسک 1",
  T_46_META_WS_P_PASSENGERS: "مسافر",
  T_46_META_WS_P_PATHID: "راستے کی شناخت",
  T_46_META_WS_P_PAUSEEVENT: "ایونٹ کو ملتوی کریں",
  T_46_META_WS_P_PERSONAID: "پرسنہ ID",
  T_46_META_WS_P_PHASEDURATION: "دورانیہ (ملی سیکنڈ)",
  T_46_META_WS_P_PHASEENDTIME: "اختتام وقت (ملی سیکنڈ)",
  T_46_META_WS_P_PHYSICALLAYER: "جسمانی سطح",
  T_46_META_WS_P_PINID: "پن ID",
  T_46_META_WS_P_PITCH: "پچ",
  T_46_META_WS_P_PIVOT: "محور",
  T_46_META_WS_P_PLAYER: "کھلاڑی",
  T_46_META_WS_P_PLAYERAIMINGSPEEDFACTOR: "کھلاڑی کا نشانہ لگانے کی رفتار کا عنصر",
  T_46_META_WS_P_PLAYERLIST: "کھلاڑیوں کی فہرست",
  T_46_META_WS_P_PLAYERNAME: "کھلاڑی کا نام",
  T_46_META_WS_P_PLAYERRANK: "کھلاڑی کی درجہ بندی",
  T_46_META_WS_P_PLAYERRANKS: "کھلاڑی رینکس",
  T_46_META_WS_P_PLAYERS: "کھلاڑی",
  T_46_META_WS_P_PLAYERSCORETYPES: "کھلاڑی اسکور کی اقسام",
  T_46_META_WS_P_PLAYERSPEEDFACTOR: "کھلاڑی کی رفتار کا عنصر",
  T_46_META_WS_P_PLAYERSPEEDFACTORWHILEFIRING: "فائرنگ کے دوران کھلاڑی کی رفتار کا عنصر",
  T_46_META_WS_P_PLAYERSTATUS: "کھلاڑی کی حالت",
  T_46_META_WS_P_PLAYERTRACTIONSPEED: "کھلاڑی کی ٹریکشن کی رفتار",
  T_46_META_WS_P_PLAYINGSTATUS: "پلے اسٹیٹس",
  T_46_META_WS_P_PLAYSPEED: "کھیل کی رفتار",
  T_46_META_WS_P_POINTPOSITION: "پوائنٹ کی پوزیشن",
  T_46_META_WS_P_POINTS: "پوائنٹس",
  T_46_META_WS_P_POSITION: "مقام",
  T_46_META_WS_P_PREFABID: "پری فاب ID",
  T_46_META_WS_P_PRESSEDCOLOR: "دبایا ہوا رنگ",
  T_46_META_WS_P_PRESSEDSPRITE: "دبایا ہوا اسپرائٹ",
  T_46_META_WS_P_PRESSEDSPRITETYPE: "دبایا ہوا اسپرائٹ کی قسم",
  T_46_META_WS_P_PRICE: "قیمت",
  T_46_META_WS_P_PRIORITY: "ترجیح",
  T_46_META_WS_P_PROFILEINFO: "پروفائل معلومات",
  T_46_META_WS_P_PROGRESS: "پروگریس [0,1]",
  T_46_META_WS_P_PROGRESSICON: "پیش رفت آئیکن",
  T_46_META_WS_P_PROGRESSICONNAME: "پیش رفت آئیکن نام",
  T_46_META_WS_P_PROPID: "پراپرٹی ID",
  T_46_META_WS_P_PURCHASELIMIT: "خریداری کی حد",
  T_46_META_WS_P_RADIUS: "رداس",
  T_46_META_WS_P_RANGE: "حد",
  T_46_META_WS_P_RANK: "رینک",
  T_46_META_WS_P_RATIOSELFFACTOR: "اپنے آپ کا نقصان کا تناسب",
  T_46_META_WS_P_RATIOTEAMMATEFACTOR: "ساتھی کا نقصان کا تناسب",
  T_46_META_WS_P_RATIOVEHICLEFACTOR: "گاڑی کا نقصان کا تناسب",
  T_46_META_WS_P_REFRESHTIME: "بفر کی تازگی کا وقت (سیکنڈ میں)",
  T_46_META_WS_P_RELOADSPEED: "دوبارہ لوڈ کرنے کی رفتار",
  T_46_META_WS_P_RELOADSPEEDFACTOR: "ری لوڈ کی رفتار کا عنصر",
  T_46_META_WS_P_REMAINJUMPCOUNT: "باقی چھلانگ کی تعداد",
  T_46_META_WS_P_REMAINQUANTITY: "باقی مقدار",
  T_46_META_WS_P_RENDERTYPE: "رینڈر کی قسم",
  T_46_META_WS_P_REPEATTIMES: "دہرانے کا وقت",
  T_46_META_WS_P_REPLACEMENTPRIORITY: "تبدیلی کی ترجیح",
  T_46_META_WS_P_REQUESTEDITEMLIST: "ٹرگر کھلاڑی آئی ڈی",
  T_46_META_WS_P_REQUESTTYPE: "درخواست شدہ آئٹمز کی فہرست",
  T_46_META_WS_P_RESETPERROUND: "ہر راؤنڈ پر ری سیٹ کریں",
  T_46_META_WS_P_RESETPOSITION: "ری سیٹ مقام",
  T_46_META_WS_P_RESETTIME: "ری سیٹ کا وقت",
  T_46_META_WS_P_RESOURCE: "وسائل",
  T_46_META_WS_P_RESOURCEID: "وسائل کا شناختی نمبر",
  T_46_META_WS_P_RESTRICTWITHINPANEL: "پینل کے اندر محدود کریں",
  T_46_META_WS_P_RESULT: "نتیجہ",
  T_46_META_WS_P_RESULTTYPE: "نتیجہ کی قسم",
  T_46_META_WS_P_REVIVALPOINT: "نیا پیدائش پوائنٹ",
  T_46_META_WS_P_REVIVECD: "بحالی کا وقت",
  T_46_META_WS_P_RIGHT: "دائیں",
  T_46_META_WS_P_RIGHTARM: "دایاں بازو",
  T_46_META_WS_P_RIGHTBACKGROUNDCOLOR: "دائیں پس منظر کا رنگ",
  T_46_META_WS_P_RIGHTCOLOR: "دائیں رنگ",
  T_46_META_WS_P_RIGHTDESCRIPTION: "دائیں ٹیم کی تفصیل",
  T_46_META_WS_P_RIGHTEFFECTACTIVE: "دائیں اثر فعال",
  T_46_META_WS_P_RIGHTFIRINGARCANGLE: "دائیں جانب فائرنگ آرک زاویہ",
  T_46_META_WS_P_RIGHTFOOT: "دایاں پاؤں",
  T_46_META_WS_P_RIGHTHAND: "دایاں ہاتھ",
  T_46_META_WS_P_RIGHTICON: "دائیں آئیکن",
  T_46_META_WS_P_RIGHTICONNAME: "دائیں آئیکن کا نام",
  T_46_META_WS_P_RIGHTLEG: "دایاں ٹانگ",
  T_46_META_WS_P_RIGHTPLAYERS: "دائیں کھلاڑی",
  T_46_META_WS_P_RIGHTSCORE: "دایاں اسکور",
  T_46_META_WS_P_RIGHTSCOREAFTER: "دایاں آخری اسکور",
  T_46_META_WS_P_RIGHTSCORETEXT: "دائیں اسکور",
  T_46_META_WS_P_RIGHTTEAM: "عنوانات",
  T_46_META_WS_P_RIGHTTEAMINDEX: "دائیں ٹیم کا انڈیکس",
  T_46_META_WS_P_RIGHTTEAMMATEALIVENUM: "دائیں ساتھی کی زندہ تعداد",
  T_46_META_WS_P_RIGHTTEAMMATEFLAGCOUNT: "دائیں ساتھی کا جھنڈا شمار",
  T_46_META_WS_P_RIGHTTEAMMATESTATES: "دائیں ٹیم کے اراکین کی حالت",
  T_46_META_WS_P_RIGHTTEAMNAME: "دائیں ٹیم کا نام",
  T_46_META_WS_P_RIGHTTEAMSCORE: "دائیں ٹیم کا اسکور",
  T_46_META_WS_P_RIGHTTEXT: "دائیں ٹیکسٹ",
  T_46_META_WS_P_RIMALPHA: "کنار الفا",
  T_46_META_WS_P_RIMCOLOR: "کنار کا رنگ",
  T_46_META_WS_P_RIMTEXTURE: "کنار کا ٹیکسچر",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFF: "رگڑ کا کوفیشیئنٹ",
  T_46_META_WS_P_ROLLINGFRICTIONCOEFFRUSHING: "بھاگتے وقت رگڑ کا عنصر",
  T_46_META_WS_P_ROTATION: "گردش",
  T_46_META_WS_P_ROTATIONANGLE: "گھماؤ کا زاویہ",
  T_46_META_WS_P_ROTATIONQ: "گردش کوآٹیرنین",
  T_46_META_WS_P_ROUNDINCOME: "دورانیہ کی آمدنی",
  T_46_META_WS_P_ROUNDINCOMEDETAILNUMS: "راؤنڈ کی آمدنی کی تفصیلات کے نمبر",
  T_46_META_WS_P_ROUNDINCOMEDETAILTITLES: "راؤنڈ کی آمدنی کی تفصیلات کے عنوانات",
  T_46_META_WS_P_ROUNDINCOMETITLE: "دورانیہ کی آمدنی کا عنوان",
  T_46_META_WS_P_ROUNDNUM: "راؤنڈ نمبر",
  T_46_META_WS_P_ROUNDNUMKEY: "راؤنڈ نمبر کی کلید",
  T_46_META_WS_P_ROUNDNUMLOCKEYPARAMS: "راؤنڈ نمبر لوکلائزیشن کی پیرامیٹرز",
  T_46_META_WS_P_RUNSPEED: "دوڑنے کی رفتار",
  T_46_META_WS_P_RUNSPEEDSCALE: "دوڑ کی رفتار پیمانہ",
  T_46_META_WS_P_RUSHDISTANCE: "رش کی دوری",
  T_46_META_WS_P_RUSHENERGYCOST: "رش توانائی کی قیمت",
  T_46_META_WS_P_RUSHVERTICALSPEED: "رش عمودی رفتار",
  T_46_META_WS_P_SCALE: "پیمانہ",
  T_46_META_WS_P_SCATTERINCREASESPEED: "بکھرنے کی رفتار",
  T_46_META_WS_P_SCATTERMAX: "زیادہ سے زیادہ بکھراؤ",
  T_46_META_WS_P_SCATTERMULTIPLIERWHILEMOVING: "حرکت کے دوران بکھرنے کا ضارب",
  T_46_META_WS_P_SCATTERRECOVERSPEED: "بکھرنے کی بحالی کی رفتار",
  T_46_META_WS_P_SCATTERSPEED: "بکھرنے کی رفتار",
  T_46_META_WS_P_SCATTERSPEEDCROUCHPRONE: "جھکنے/لیٹنے کی حالت میں بکھرنے کی رفتار",
  T_46_META_WS_P_SCATTERTHRESHOLD: "بکھرنے کی حد",
  T_46_META_WS_P_SCOPETYPE: "اسکوپ کی قسم",
  T_46_META_WS_P_SCORE: "اسکور",
  T_46_META_WS_P_SCORES1: "اسکورز 1",
  T_46_META_WS_P_SCORES2: "اسکورز 2",
  T_46_META_WS_P_SCORES3: "اسکورز 3",
  T_46_META_WS_P_SCORES4: "اسکورز 4",
  T_46_META_WS_P_SCORES5: "اسکورز 5",
  T_46_META_WS_P_SCORETEXTKEY: "اسکور ٹیکسٹ کلید",
  T_46_META_WS_P_SCORETEXTKEYPARAMS: "اسکور ٹیکسٹ کلید کے پیرامیٹر",
  T_46_META_WS_P_SCROLLCONTINUITY: "اسکرول کی تسلسل",
  T_46_META_WS_P_SCROLLDIRECTION: "اسکرول سمت",
  T_46_META_WS_P_SCROLLEFFECT: "اسکرول اثر",
  T_46_META_WS_P_SCROLLWHEELSPEED: "اسکرول وہیل کی رفتار",
  T_46_META_WS_P_SECONDSCORETITLE: "دوسرا اسکور عنوان",
  T_46_META_WS_P_SECONDSCOREVALUE: "دوسرا اسکور قیمت",
  T_46_META_WS_P_SECONDSCOREVALUEPARAMS: "دوسرا اسکور پیرامیٹر",
  T_46_META_WS_P_SELECTEDCOLOR: "منتخب رنگ",
  T_46_META_WS_P_SELECTEDINDEX: "منتخب شدہ انڈیکس",
  T_46_META_WS_P_SELECTEDSPRITE: "منتخب اسپرائٹ",
  T_46_META_WS_P_SELECTEDTYPE: "منتخب قسم",
  T_46_META_WS_P_SELF: "خود",
  T_46_META_WS_P_SELFDAMAGEFACTOR: "خود نقصان کا عنصر",
  T_46_META_WS_P_SET: "سیٹ",
  T_46_META_WS_P_SHADERNAME: "شیڈر کا نام",
  T_46_META_WS_P_SHADOWCOLOR: "سائے کا رنگ",
  T_46_META_WS_P_SHADOWOFFSET: "سائے کا آفسیٹ",
  T_46_META_WS_P_SHADOWSTRENGTH: "سائے کی طاقت",
  T_46_META_WS_P_SHELFS: "دستی طور پر بند کرنا غیر فعال ہے یا نہیں",
  T_46_META_WS_P_SHOES: "جوتے",
  T_46_META_WS_P_SHOOTANGLEMAX: "زیادہ سے زیادہ شوٹنگ زاویہ",
  T_46_META_WS_P_SHOOTANGLEMIN: "کم از کم شوٹنگ زاویہ",
  T_46_META_WS_P_SHOP: "دکان",
  T_46_META_WS_P_SHOPITEMS: "شیلف",
  T_46_META_WS_P_SHOWADDFRIEND: "دوست شامل کریں دکھائیں",
  T_46_META_WS_P_SHOWATTACKGRENADE: "حملہ آور گرینیڈ کو دکھائیں",
  T_46_META_WS_P_SHOWBACKGROUND: "پس منظر دکھائیں",
  T_46_META_WS_P_SHOWCROUCH: "جھکنے کو دکھائیں",
  T_46_META_WS_P_SHOWDAMAGENUMBER: "نقصان نمبر دکھائیں",
  T_46_META_WS_P_SHOWDEFENCEGRENADE: "دفاعی گرینیڈ کو دکھائیں",
  T_46_META_WS_P_SHOWECCONOMY: "غیر متصل معیشت دکھائیں",
  T_46_META_WS_P_SHOWECONOMY: "غیر متصل معیشت دکھائیں",
  T_46_META_WS_P_SHOWFIRE: "فائر کو دکھائیں",
  T_46_META_WS_P_SHOWFRAME: "فریم دکھائیں",
  T_46_META_WS_P_SHOWGIFT: "تحفے دکھائیں",
  T_46_META_WS_P_SHOWHITPOINTEFFECT: "ہٹ پوائنٹ کا اثر دکھائیں",
  T_46_META_WS_P_SHOWJUMP: "چھلانگ لگانے کو دکھائیں",
  T_46_META_WS_P_SHOWLIKE: "پسندیدہ دکھائیں",
  T_46_META_WS_P_SHOWLOBBY: "لابی دکھائیں",
  T_46_META_WS_P_SHOWMAPEVALUATE: "نقشے کی تشخیص دکھائیں",
  T_46_META_WS_P_SHOWMATCHDETAIL: "میچ کی تفصیل دکھائیں",
  T_46_META_WS_P_SHOWMOVINGJOYSTICK: "موونگ جوائس اسٹک کو دکھائیں",
  T_46_META_WS_P_SHOWNAME: "نک نیم دکھائیں",
  T_46_META_WS_P_SHOWPIN: "پِن دکھائیں",
  T_46_META_WS_P_SHOWPRONE: "لیٹنے کو دکھائیں",
  T_46_META_WS_P_SHOWRANK: "رینک دکھائیں",
  T_46_META_WS_P_SHOWREPLAY: "دوبارہ دیکھیں دکھائیں",
  T_46_META_WS_P_SHOWREPORT: "رپورٹ دکھائیں",
  T_46_META_WS_P_SHOWSHARE: "شیئر کریں دکھائیں",
  T_46_META_WS_P_SHOWSPRINT: "اسپرنٹ کو دکھائیں",
  T_46_META_WS_P_SHOWTAG: "ٹیگ دکھائیں",
  T_46_META_WS_P_SHOWTEAMMATESINFO: "ساتھیوں کی معلومات دکھائیں",
  T_46_META_WS_P_SHOWTEAMMATESTATE: "ٹیم کے اراکین کی حالت دکھائیں",
  T_46_META_WS_P_SHOWTEAMSCORE: "ٹیم کے اسکور کو دکھائیں",
  T_46_META_WS_P_SHOWTIMETYPE: "وقت کی قسم دکھائیں",
  T_46_META_WS_P_SHOWTWOTEAMSCORE: "دو ٹیموں کے اسکور دکھائیں",
  T_46_META_WS_P_SHRINKDURATION: "سکڑنے کا دورانیہ (ms)",
  T_46_META_WS_P_SHRINKENDTIME: "سکڑنے کا اختتامی وقت (ms)",
  T_46_META_WS_P_SHRINKSPEED: "اجتماع کی شرح",
  T_46_META_WS_P_SHRINKSTARTTIME: "سکڑنے کا شروع وقت (ms)",
  T_46_META_WS_P_SIGHTAIMASSIST: "ADS نشانہ معاونت کی اجازت دیں",
  T_46_META_WS_P_SIGHTAIMASSISTDISTFALLOFF: "نشانہ معاونت کے فاصلے کی کمی کا تناسب (0-1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOCOEF: "نشانہ معاونت کے فاصلے کی ترجیحی اثر تناسب (>=1)",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMAX: "نشانہ معاونت کے فاصلے کو ترجیح دینے کے لئے زیادہ سے زیادہ فاصلہ",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMIN: "نشانہ معاونت کے فاصلے کو ترجیح دینے کے لئے کم از کم فاصلہ",
  T_46_META_WS_P_SIGHTAIMASSISTDISTPRIORITY: "نشانہ معاونت کے فاصلے کو ترجیح دینے کی اجازت دیں",
  T_46_META_WS_P_SIGHTAIMASSISTSNAPRANGE: "نشانہ معاونت کا اسکرین رینج کشش تناسب (0-1)",
  T_46_META_WS_P_SIGHTAMPLIFYRATIO: "سائٹ کا بڑھاو تناسب",
  T_46_META_WS_P_SIGHTFOVAMPLIFYRATIO: "FOV کا بڑھاو",
  T_46_META_WS_P_SIGHTROTSENSITIVENESS: "ADS گھماؤ کی حساسیت",
  T_46_META_WS_P_SIGHTSHOOTMINDAMAGE: "ADS کم از کم نقصان کے فاصلے کی درستگی کا تناسب",
  T_46_META_WS_P_SIGHTUIACTIONEXPAND: "ADS کا بڑھاو کا وقت (سیکنڈ)",
  T_46_META_WS_P_SIGHTUIACTIONRATIO: "ADS کا بڑھاو",
  T_46_META_WS_P_SIGHTUIACTIONRECOVERY: "ADS کی بحالی کا وقت (سیکنڈ)",
  T_46_META_WS_P_SIZE: "سائز",
  T_46_META_WS_P_SIZEDELTA: "سائز کا فرق",
  T_46_META_WS_P_SKELETON: "ہڈی",
  T_46_META_WS_P_SKIN: "جلد",
  T_46_META_WS_P_SKINID: "جلد کی شناخت",
  T_46_META_WS_P_SKINWIDTH: "جلد کی چوڑائی",
  T_46_META_WS_P_SKYBOXENV: "آسمان کا باکس",
  T_46_META_WS_P_SKYBOXRESOURCE: "آسمان باکس وسائل",
  T_46_META_WS_P_SLOPELIMIT: "ڈھلوان کی حد",
  T_46_META_WS_P_SMOOTHSCROLLSTART: "ہموار اسکرول شروع کریں",
  T_46_META_WS_P_SOFTNESS: "نرمی",
  T_46_META_WS_P_SORTTYPE: "ترتیب کی قسم",
  T_46_META_WS_P_SPAWNCOUNTPERWAVE: "ہر لہر کے لئے پیداوار کی تعداد",
  T_46_META_WS_P_SPAWNPOINT: "اسپاون پوائنٹ",
  T_46_META_WS_P_SPAWNPOINTCOUNT: "اسپاؤن پوائنٹ کی تعداد",
  T_46_META_WS_P_SPAWNPOSITION: "اسپان کی پوزیشن",
  T_46_META_WS_P_SPEED: "رفتار",
  T_46_META_WS_P_SPEEDWHILEAIMING: "ای ڈی ایس حرکت کی رفتار",
  T_46_META_WS_P_SPRAYCOLOR: "اسپرے رنگ",
  T_46_META_WS_P_SPRINTENERGYCOST: "اسپرنٹ توانائی کی قیمت",
  T_46_META_WS_P_SPRINTHORIZONTALSPEED: "اسپرنٹ افقی رفتار",
  T_46_META_WS_P_SPRINTSPEEDSCALE: "دوڑنے کی رفتار پیمائش",
  T_46_META_WS_P_SPRITENAME: "اسپرائٹ کی شکل",
  T_46_META_WS_P_SPRITERESOURCE: "اسپرائٹ وسائل",
  T_46_META_WS_P_SRCVAL: "ماخذ قدر",
  T_46_META_WS_P_STARTDROPTIME: "ڈراپ کا وقت (ms)",
  T_46_META_WS_P_STARTEVENT: "ایونٹ شروع کریں",
  T_46_META_WS_P_STARTPOSITION: "ابتدائی مقام",
  T_46_META_WS_P_STARTRADIUS: "شروع کا رداس",
  T_46_META_WS_P_STARTSPAWNTIME: "اسپاؤن کا آغاز وقت (سیکنڈ میں)",
  T_46_META_WS_P_STARTTIME: "شروع وقت",
  T_46_META_WS_P_STARTVALUE: "ابتدائی قدر",
  T_46_META_WS_P_STATICICONCOLORS: "جامد آئیکن رنگ",
  T_46_META_WS_P_STATICICONS: "جامد آئیکنز",
  T_46_META_WS_P_STATUS: "مائنِ سینٹری کی حالت",
  T_46_META_WS_P_STEPOFFSET: "قدم کا آفسیٹ",
  T_46_META_WS_P_STOPDURATION: "رکنے کی مدت",
  T_46_META_WS_P_STOPEVENT: "ایونٹ روکیں",
  T_46_META_WS_P_STORE: "اسٹور",
  T_46_META_WS_P_STROPID: "اسٹروپ ID",
  T_46_META_WS_P_STYLE: "اسٹائل",
  T_46_META_WS_P_SUBTITLE: "ذیلی عنوان",
  T_46_META_WS_P_SUMMULTIPLIER: "مجموعی ضرب",
  T_46_META_WS_P_SWINGEXITACCELERATION: "جھول سے باہر نکلنے کی رفتار",
  T_46_META_WS_P_SWINGINGSPEED: "جھولنے کی رفتار",
  T_46_META_WS_P_TAGS: "ٹیگ",
  T_46_META_WS_P_TARGETCHECKPOINTID: "ہدف چیک پوائنٹ آئی ڈی",
  T_46_META_WS_P_TARGETICONCOLORS: "ہدف آئیکن رنگ",
  T_46_META_WS_P_TARGETICONS: "ہدف آئیکنز",
  T_46_META_WS_P_TARGETID: "ہدف آئی ڈی",
  T_46_META_WS_P_TARGETITEMID: "ہدف اشیاء ID",
  T_46_META_WS_P_TARGETROTATION: "ہدف کی گردش",
  T_46_META_WS_P_TARGETSCALE: "ہدف کا اسکیل",
  T_46_META_WS_P_TEAMCOLOR: "ٹیم کا رنگ",
  T_46_META_WS_P_TEAMCOLORS: "ٹیم رنگ",
  T_46_META_WS_P_TEAMINDEXS: "ٹیم انڈیکس",
  T_46_META_WS_P_TEAMMATEDAMAGEFACTOR: "ساتھی نقصان عنصر",
  T_46_META_WS_P_TEAMMEMBERNUM: "ٹیم کے اراکین کی تعداد",
  T_46_META_WS_P_TEAMNUM: "ٹیموں کی تعداد",
  T_46_META_WS_P_TEAMRANK: "ٹیم کی درجہ بندی",
  T_46_META_WS_P_TEAMRANKDISPLAY: "ٹیم کی درجہ بندی کی نمائش",
  T_46_META_WS_P_TEAMRANKS: "ٹیم رینکس",
  T_46_META_WS_P_TEAMSCORES: "ٹیم اسکور",
  T_46_META_WS_P_TEAMSEQ: "ٹیم کا سلسلہ",
  T_46_META_WS_P_TEMPLATEENTITY: "ٹیمپلیٹ کی شناخت",
  T_46_META_WS_P_TEMPORARYSHIELDPOINTS: "عارضی شیلڈ پوائنٹس",
  T_46_META_WS_P_TERRAINWETNESS: "زمین کی نمی",
  T_46_META_WS_P_TEXT: "ٹیکسٹ",
  T_46_META_WS_P_TEXTCOLOR: "ٹیکسٹ رنگ",
  T_46_META_WS_P_TEXTKEY: "متن کی کلید",
  T_46_META_WS_P_TEXTKEYPARAMS: "متن کی کلید کے پیرامیٹرز",
  T_46_META_WS_P_TEXTURERESOURCE: "ٹیکسچر وسائل",
  T_46_META_WS_P_THEMECOLOR: "تھیم کا رنگ",
  T_46_META_WS_P_THROWABLETYPE: "پھینکنے کی قسم",
  T_46_META_WS_P_THROWINGSPEED: "پھینکنے کی رفتار",
  T_46_META_WS_P_THROWSPEED: "پھینکنے کی رفتار",
  T_46_META_WS_P_TICKINTERVAL: "ٹِک وقفہ",
  T_46_META_WS_P_TIMEREQUIRED: "مطلوبہ وقت (ملی سیکنڈ)",
  T_46_META_WS_P_TIPSTYPE: "تجاویز کی قسم",
  T_46_META_WS_P_TITLE: "عنوان",
  T_46_META_WS_P_TITLELIST: "عنوانات",
  T_46_META_WS_P_TITLES: "اسکور1",
  T_46_META_WS_P_TOP: "اوپر",
  T_46_META_WS_P_TOPALPHA: "اوپر کا الفا",
  T_46_META_WS_P_TOTALHP: "کل HP",
  T_46_META_WS_P_TOTALLEVEL: "کل سطح",
  T_46_META_WS_P_TOTALROUNDCOUNT: "کل راؤنڈز کی تعداد",
  T_46_META_WS_P_TOWSPEED: "ٹو کی رفتار",
  T_46_META_WS_P_TRANSITIONSTAGE: "منتقلی کا مرحلہ",
  T_46_META_WS_P_TRANSITIONTYPE: "منتقلی کی قسم",
  T_46_META_WS_P_TRIGGERPLAYERID: "پیسہ",
  T_46_META_WS_P_TRIGGERRADIUS: "ٹرگر رینج",
  T_46_META_WS_P_TRIGGERRANGE: "ٹرگر کی رینج",
  T_46_META_WS_P_TRIGGERTIME: "ٹرگر وقت",
  T_46_META_WS_P_TURNSPEED: "مڑنے کی رفتار",
  T_46_META_WS_P_TWEENERENABLED: "بائیں ٹیم",
  T_46_META_WS_P_TWEENSTYLE: "ٹوئین اسٹائل",
  T_46_META_WS_P_TYPE: "قسم",
  T_46_META_WS_P_UNSELECTEDCOLOR: "غیر منتخب رنگ",
  T_46_META_WS_P_UNSELECTEDSPRITE: "غیر منتخب اسپرائٹ",
  T_46_META_WS_P_UNSELECTEDTYPE: "غیر منتخب قسم",
  T_46_META_WS_P_UP: "اوپر",
  T_46_META_WS_P_UPDATETYPE: "اپ ڈیٹ کی قسم",
  T_46_META_WS_P_UPENERGYCOST: "اوپر توانائی کی قیمت",
  T_46_META_WS_P_UPSPEED: "اوپر کی رفتار",
  T_46_META_WS_P_USECUSTOMPUSHFORCE: "حسب ضرورت دھکا فورس کا استعمال کریں",
  T_46_META_WS_P_USECUSTOMRESOURCE: "حسب ضرورت وسائل استعمال کریں",
  T_46_META_WS_P_USEDCAPACITY: "استعمال شدہ گنجائش",
  T_46_META_WS_P_USEGRAVITY: "کشش ثقل کا استعمال کریں",
  T_46_META_WS_P_USEPHYSICALCCT: "جسمانی CCT کا استعمال کریں",
  T_46_META_WS_P_USERUID: "صارف UID",
  T_46_META_WS_P_UVOFFSET: "UV آفسیٹ",
  T_46_META_WS_P_UVSIZE: "UV کا سائز",
  T_46_META_WS_P_VALUE: "قدر",
  T_46_META_WS_P_VAULTDISTANCE: "اوپر چڑھنے کا فاصلہ",
  T_46_META_WS_P_VAULTHEIGHT: "اوپر چڑھنے کی اونچائی",
  T_46_META_WS_P_VEHICLEDAMAGEFACTOR: "گاڑی کا نقصان عنصر",
  T_46_META_WS_P_VEHICLESKINID: "گاڑی کی جلد آئی ڈی",
  T_46_META_WS_P_VEHICLESKINIDS: "گاڑی کی جلد ID",
  T_46_META_WS_P_VELOCITY: "رفتار (میٹر/سیکنڈ)",
  T_46_META_WS_P_VELOCITYXZ: "XZ رفتار",
  T_46_META_WS_P_VELOCITYY: "Y رفتار",
  T_46_META_WS_P_VERTICALBAR: "عمودی بار",
  T_46_META_WS_P_VERTICALOFFSET: "عمودی آفسیٹ",
  T_46_META_WS_P_VEST: "بلٹ پروف جیکٹ",
  T_46_META_WS_P_VFXTEXTURETYPE: "VFX ٹیکسچر کی قسم",
  T_46_META_WS_P_VIEWINGANGLERESTRICTION: "دیکھنے کے زاویے کی حد",
  T_46_META_WS_P_VISIBILITYLAYER: "نظر آنے والی سطح",
  T_46_META_WS_P_VISIBLE: "نظر آنے والا",
  T_46_META_WS_P_VISIBLEONBACK: "پیٹھ پر نظر آنے والا",
  T_46_META_WS_P_VISIBLEPLAYERS: "نظر آنے والے کھلاڑی",
  T_46_META_WS_P_VOLUME: "حجم",
  T_46_META_WS_P_WALLETID: "والیٹ کی شناخت",
  T_46_META_WS_P_WANDERRANGE: "بھٹکنے کی حد",
  T_46_META_WS_P_WAVECOUNT: "لہر کی تعداد",
  T_46_META_WS_P_WAVEINTERVAL: "لہر کا وقفہ",
  T_46_META_WS_P_WEAPONDAMAGERATE: "ہتھیار کا نقصان کی شرح",
  T_46_META_WS_P_WEAPONSKINIDS: "ہتھیار کی جلد ID",
  T_46_META_WS_P_WEAPONSUBTYPE: "ہتھیار ذیلی قسم",
  T_46_META_WS_P_WEAPONTYPE: "ہتھیار کی قسم",
  T_46_META_WS_P_WIDTH: "چوڑائی",
  T_46_META_WS_P_WINMVPS: "جیتنے والے MVPs",
  T_46_META_WS_P_WINTEXT: "جیت کا متن",
  T_46_META_WS_P_WORDWRAP: "لفظ لپیٹنا",
  T_46_META_WS_P_WORLDPOSITION: "عالمی مقام",
  T_46_META_WS_P_YAW: "یاو",
  T_46_META_WS_PATROLALONG: "گشت کے راستے",
  T_46_META_WS_PATROLTO: "گشت پر جائیں",
  T_46_META_WS_PAUSE: "عارضی طور پر روکیں",
  T_46_META_WS_PAUSEEMOTE: "ایموٹ کو روکیں",
  T_46_META_WS_PAUSEFIXEDUPDATE: "مقررہ فریم اپ ڈیٹ کو روکیں",
  T_46_META_WS_PHASE: "مرحلہ",
  T_46_META_WS_PLAY: "چلائیں",
  T_46_META_WS_PLAYANIMATION: "اینیمیشن چلائیں",
  T_46_META_WS_PLAYCHARACTERANIMATIONCLIP: "کردار کی اینیمیشن کلپ چلائیں",
  T_46_META_WS_PLAYEMOTE: "ایموٹ چلائیں",
  T_46_META_WS_PLAYER: "کھلاڑی",
  T_46_META_WS_PORTAL: "پورٹل",
  T_46_META_WS_POSE: "پوز",
  T_46_META_WS_POSITION: "مقام",
  T_46_META_WS_PREPOSE: "پہلے کا پوز ",
  T_46_META_WS_PROFANITYFILTER: "گالیوں کا فلٹر",
  T_46_META_WS_PURSUITTARGET: "تعاقب کا ہدف",
  T_46_META_WS_QUATERNIONTOAXISANGLE: "کوارٹرنئن کو محور زاویے میں تبدیل کریں",
  T_46_META_WS_QUATERNIONTOEULERANGLE: "کوارٹرنئن کو یولر زاویے میں تبدیل کریں",
  T_46_META_WS_QUITCHATCHANNEL: "چیٹ چینل سے باہر نکلیں",
  T_46_META_WS_QUITFACTION: "فیکشن سے باہر نکلیں",
  T_46_META_WS_QUITGAME: "کھیل چھوڑیں",
  T_46_META_WS_QUITJAILBREAKMINIGAME: "جیل بریک مِنی گیم سے باہر نکلیں",
  T_46_META_WS_RANDOMFLOAT: "تصادفی فلوٹ",
  T_46_META_WS_RANDOMINT: "تصادفی عدد",
  T_46_META_WS_RANK: "درجہ",
  T_46_META_WS_READCSV: "CSV پڑھیں",
  T_46_META_WS_READCSVCELL: "CSV کا سیل پڑھیں",
  T_46_META_WS_READCSVCELLBYNAME: "صف نمبر اور کالم نام کے ذریعے CSV کا سیل پڑھیں",
  T_46_META_WS_READCSVCELLFROMSERVER: "سرور سے CSV کا سیل پڑھیں",
  T_46_META_WS_READCSVCOLUMN: "CSV کا کالم پڑھیں",
  T_46_META_WS_READCSVCOLUMNFROMSERVER: "سرور سے CSV کا کالم پڑھیں",
  T_46_META_WS_READCSVFROMSERVER: "سرور سے CSV پڑھیں",
  T_46_META_WS_READCSVROW: "CSV کی صف پڑھیں",
  T_46_META_WS_READCSVROWBYKEY: "کلید کے ذریعے CSV کی صف پڑھیں",
  T_46_META_WS_READCSVROWFROMSERVER: "سرور سے CSV کی صف پڑھیں",
  T_46_META_WS_READFROMACCUMULATEDDATASTORE: "جمع شدہ ڈیٹا اسٹور سے پڑھیں",
  T_46_META_WS_READFROMDATASTORE: "ڈیٹا اسٹور سے پڑھیں",
  T_46_META_WS_READFROMLEADBOARDDATASTORE: "لیڈربورڈ ڈیٹا اسٹور سے پڑھیں",
  T_46_META_WS_READFROMLEADBOARDDATASTOREBYRANK: "رینک کے ذریعہ لیڈربورڈ ڈیٹا اسٹور سے پڑھیں",
  T_46_META_WS_REMOVEAOISPECIALFOLLOW: "AOI خاص پیروی ہٹائیں",
  T_46_META_WS_REMOVEBACKPACKSKIN: "بیگ کی جلد ہٹائیں",
  T_46_META_WS_REMOVEBUFF: "بفی ہٹائیں",
  T_46_META_WS_REMOVECOMPONENT: "کمپوننٹ ہٹائیں",
  T_46_META_WS_REMOVEFORMULAPROPERTYFACTOR: "فارمولا پروپرٹی فیکٹر ہٹائیں",
  T_46_META_WS_REMOVEOUTFIT: "لباس ہٹائیں",
  T_46_META_WS_REMOVESCRIPT: "اسکرپٹ ہٹائیں",
  T_46_META_WS_REMOVEVEHICLESKIN: "گاڑی کی جلد ہٹائیں",
  T_46_META_WS_REMOVEWEAPONSKIN: "ہتھیار کی جلد ہٹائیں",
  T_46_META_WS_REPLACE: "تبدیل کریں",
  T_46_META_WS_REQUESTMATCHMAKING: "میچ میکنگ کی درخواست کریں",
  T_46_META_WS_RESET: "دوبارہ ترتیب دیں",
  T_46_META_WS_RESETBACKPACKSKIN: "بیگ کی جلد کو ری سیٹ کریں",
  T_46_META_WS_RESETDYEING: "رنگائی دوبارہ ترتیب دیں",
  T_46_META_WS_RESETJERSEY: "جرسی دوبارہ ترتیب دیں",
  T_46_META_WS_RESETOUTFIT: "لباس دوبارہ ترتیب دیں",
  T_46_META_WS_RESETVEHICLESKIN: "گاڑی کی جلد کو ری سیٹ کریں",
  T_46_META_WS_RESETWEAPONSKIN: "ہتھیار کی جلد دوبارہ ترتیب دیں",
  T_46_META_WS_RESUMEFIXEDUPDATE: "مقررہ فریم اپ ڈیٹ کو دوبارہ شروع کریں",
  T_46_META_WS_REVERSE: "الٹائیں",
  T_46_META_WS_REVIVALSOURCE: "احیاء کا ذریعہ",
  T_46_META_WS_REVIVE: "زندہ کریں",
  T_46_META_WS_ROUND: "گول کریں",
  T_46_META_WS_ROUNDINDEX: "راؤنڈ انڈیکس",
  T_46_META_WS_SAMPLEONCURVE: "کرف پر نمونہ لیں",
  T_46_META_WS_SCENENAME: "منظر کا نام",
  T_46_META_WS_SCORE: "اسکور",
  T_46_META_WS_SCORER: "گول کرنے والا",
  T_46_META_WS_SCORETYPE: "اسکور کی قسم",
  T_46_META_WS_SCREENMULTIRAYCAST: "اسکرین ملٹی ریزکاسٹ",
  T_46_META_WS_SCREENSINGLERAYCAST: "اسکرین سنگل ریزکاسٹ",
  T_46_META_WS_SCREENTOUCHRAY: "اسکرین ٹچ ریز",
  T_46_META_WS_SCREENTOWORLDPOINT: "اسکرین سے ورلڈ",
  T_46_META_WS_SENDEVENT: "ایونٹ بھیجیں",
  T_46_META_WS_SETACTIVE: "فعال سیٹ کریں",
  T_46_META_WS_SETALLPLAYERSMOVESTATUS: "تمام کھلاڑیوں کی حرکت کی حیثیت مرتب کریں",
  T_46_META_WS_SETATTACKABLEENTITY: "حملہ قابل شے سیٹ کریں",
  T_46_META_WS_SETATTACKABLEFACTION: "حملہ قابل فیکشن سیٹ کریں",
  T_46_META_WS_SETATTACKABLETEAM: "حملہ قابل ٹیم سیٹ کریں",
  T_46_META_WS_SETBACKPACKSKIN: "بیگ کی جلد سیٹ کریں",
  T_46_META_WS_SETBEHAVIORSTATUS: "رویے کی حیثیت سیٹ کریں",
  T_46_META_WS_SETBLACKBOARDVALUE: "بلیک بورڈ ویلیو سیٹ کریں",
  T_46_META_WS_SETBUNDLE: "پیکج سیٹ کریں",
  T_46_META_WS_SETCAMERAFOCUS: "کیمرے کی توجہ سیٹ کریں",
  T_46_META_WS_SETCAMERAFOLLOW: "کیمرے کی پیروی سیٹ کریں",
  T_46_META_WS_SETCHARACTER: "کردار سیٹ کریں",
  T_46_META_WS_SETCULLINGMASK: "کُلنگ ماسک سیٹ کریں",
  T_46_META_WS_SETCULLINGMASKLAYER: "کُلنگ ماسک لیئر سیٹ کریں",
  T_46_META_WS_SETDEFAULTUISTATUS: "ڈیفالٹ UI اسٹیٹس سیٹ کریں",
  T_46_META_WS_SETDROPSTATUS: "چھوڑنے کی حالت سیٹ کریں",
  T_46_META_WS_SETFALLINGDAMAGE: "گراوٹ کا نقصان سیٹ کریں",
  T_46_META_WS_SETFOOTBALLPOSITION: "فٹ بال کی حالت سیٹ کریں",
  T_46_META_WS_SETFORMULAPROPERTYABSOLUTE: "فارمولا پروپرٹی کو مطلق طور پر سیٹ کریں",
  T_46_META_WS_SETFORMULAPROPERTYRELATIVE: "فارمولا پروپرٹی کو نسبتی طور پر سیٹ کریں",
  T_46_META_WS_SETFORWARD: "سمت سیٹ کریں",
  T_46_META_WS_SETGLOBALSLEEPTHRESHOLD: "عالمی سونے کی حد سیٹ کریں",
  T_46_META_WS_SETINVINCIBILITY: "ناقابل شکست حالت مرتب کریں",
  T_46_META_WS_SETJERSEY: "جرسی سیٹ کریں",
  T_46_META_WS_SETOUTFIT: "لباس سیٹ کریں",
  T_46_META_WS_SETPARENT: "والدین سیٹ کریں",
  T_46_META_WS_SETPARENTCLIENT: "والدین سیٹ کریں",
  T_46_META_WS_SETPICKUPSTATUS: "پک اپ کی حالت سیٹ کریں",
  T_46_META_WS_SETPLAYERQUICKMESSAGESTATUS: "کھلاڑی کے فوری پیغام کی حالت سیٹ کریں",
  T_46_META_WS_SETPLAYERVOICESTATUS: "کھلاڑی کی آواز کی حالت سیٹ کریں",
  T_46_META_WS_SETPROPERTYSMOOTHLY: "پراپرٹی کو ہموار طور پر سیٹ کریں",
  T_46_META_WS_SETSKILLS: "مہارتیں سیٹ کریں",
  T_46_META_WS_SETSKYBOX: "اسکائی باکس مرتب کریں",
  T_46_META_WS_SETSLEEPTHRESHOLD: "سونے کی حد سیٹ کریں",
  T_46_META_WS_SETSPECIALITEMSTATUS: "خصوصی آئٹم کی حیثیت مرتب کریں",
  T_46_META_WS_SETVEHICLESKIN: "گاڑی کی جلد سیٹ کریں",
  T_46_META_WS_SETWEAPONSKIN: "ہتھیار کی جلد سیٹ کریں",
  T_46_META_WS_SETWIDGETPARENT: "ویجیٹ کا والدین سیٹ کریں",
  T_46_META_WS_SHOPITEM: "دکان کا آئٹم",
  T_46_META_WS_SHOWAPPEARANCEGROUP: "ظاہری شکل گروپ دکھائیں",
  T_46_META_WS_SHUFFLE: "شفل کریں",
  T_46_META_WS_SIN: "Sin",
  T_46_META_WS_SINGLERAYCAST: "سنگل ریکاسٹ",
  T_46_META_WS_SKILL: "مہارت",
  T_46_META_WS_SLEEP: "سونا",
  T_46_META_WS_SLERPQUATERNION: "کوآٹرنئین سلرپ",
  T_46_META_WS_SPAWNABLES: "پیدا ہونے والی اشیاء",
  T_46_META_WS_SPAWNEDITEM: "پیدا شدہ آئٹم",
  T_46_META_WS_SPAWNNEXTWAVE: "اگلی لہر پیدا کریں",
  T_46_META_WS_SPHERECAST: "گیند کاسٹ",
  T_46_META_WS_SPHEREOVERLAP: "گیند اوورلیپ",
  T_46_META_WS_SPLIT: "تقسیم کریں",
  T_46_META_WS_SQRT: "جڑاؤ",
  T_46_META_WS_STARTPARACHUTE: "پیراشوٹ شروع کریں",
  T_46_META_WS_STARTPOSITION: "آغاز کی جگہ",
  T_46_META_WS_STATENAME: "حالت کا نام",
  T_46_META_WS_STATUS: "حالت",
  T_46_META_WS_STRINGTOFLOAT: "اسٹرنگ کو فلوٹ میں تبدیل کریں",
  T_46_META_WS_STRINGTOINT: "اسٹرنگ کو انٹیجر میں تبدیل کریں",
  T_46_META_WS_STRIP: "سٹرنگ کے کناروں سے خالی جگہ ہٹائیں",
  T_46_META_WS_SUB: "منفی کریں",
  T_46_META_WS_SWITCHAOIPROXYOBSERVER: "AOI پروکسی مبصر تبدیل کریں",
  T_46_META_WS_SWITCHAPPEARANCEGROUP: "ظاہری شکل گروپ تبدیل کریں",
  T_46_META_WS_SWITCHAREA: "علاقے کو تبدیل کریں",
  T_46_META_WS_SWITCHCAMERA: "کیمرہ تبدیل کریں",
  T_46_META_WS_SWITCHPHASE: "مرحلہ تبدیل کریں",
  T_46_META_WS_SWITCHSCENE: "منظر تبدیل کریں",
  T_46_META_WS_SWITCHWEAPON: "ہتھیار بدلیں",
  T_46_META_WS_TAN: "Tan",
  T_46_META_WS_TARGET: "ہدف",
  T_46_META_WS_TEAM: "ٹیم",
  T_46_META_WS_TELEPORT: "ٹیلی پورٹ کریں",
  T_46_META_WS_TELEPORTCCT: "CCT کو ٹیلی پورٹ کریں",
  T_46_META_WS_TEXT: "متن",
  "T_46_META_WS_TIMESTAMPTO LOCALSTRING": "ٹائم اسٹیمپ کو مقامی اسٹرنگ میں تبدیل کریں",
  T_46_META_WS_TIRE: "ٹائر",
  T_46_META_WS_TOLOWER: "چھوٹے حروف میں تبدیل کریں",
  T_46_META_WS_TOSTRING: "سٹرنگ میں تبدیل کریں",
  T_46_META_WS_TOUPPER: "بڑے حروف میں تبدیل کریں",
  T_46_META_WS_TRANSFERMONEY: "پیسہ منتقل کریں",
  T_46_META_WS_TRIGGER: "ٹریگر",
  T_46_META_WS_TYPEIS: "قسم ہے",
  T_46_META_WS_UNLOADSCENE: "منظر ان لوڈ کریں",
  T_46_META_WS_UPDATEJAILBREAKMISSION: "جیل بریک مشن کو اپ ڈیٹ کریں",
  T_46_META_WS_UPLOADGAMERESULT: "کھیل کا نتیجہ اپ لوڈ کریں",
  T_46_META_WS_VALUE: "نقصان",
  T_46_META_WS_VECTOR2ANGLE: "2D وییکٹر زاویہ",
  T_46_META_WS_VECTOR2DISTANCE: "2D وییکٹر فاصلہ",
  T_46_META_WS_VECTOR2DOT: "2D وییکٹر ڈاٹ",
  T_46_META_WS_VECTOR2MAGNITUDE: "2D وییکٹر مقدار",
  T_46_META_WS_VECTOR2NORMALIZE: "2D وییکٹر معمول",
  T_46_META_WS_VECTOR2REFLECT: "2D وییکٹر عکاسی",
  T_46_META_WS_VECTOR2TOVECTOR3: "2D سے 3D وییکٹر",
  T_46_META_WS_VECTOR3REFLECT: "3D وییکٹر عکاسی",
  T_46_META_WS_VECTOR3TOVECTOR2: "3D سے 2D وییکٹر",
  T_46_META_WS_VEHICLE: "گاڑی",
  T_46_META_WS_VELOCITY: "رفتار",
  T_46_META_WS_WAITFORMILESECOND: "ملی سیکنڈ کا انتظار کریں",
  T_46_META_WS_WAITFORNEXTFRAME: "اگلے فریم کا انتظار کریں",
  T_46_META_WS_WAKEUP: "جاگنا",
  T_46_META_WS_WAVES: "لہریں",
  T_46_META_WS_WEAPON: "ہتھیار",
  T_46_META_WS_WORLDTOSCREENPOINT: "ورلڈ سے اسکرین",
  T_46_META_WS_WRITETOACCUMULATEDDATASTORE: "جمع شدہ ڈیٹا اسٹور میں لکھیں",
  T_46_META_WS_WRITETODATASTORE: "ڈیٹا اسٹور میں لکھیں",
  T_46_META_WS_WRITETOLEADBOARDDATASTORE: "لیڈربورڈ ڈیٹا اسٹور میں لکھیں",
  T_48_META_API_1_D: "موجودہ گیم میں تمام کھلاڑی حاصل کریں اور پلیئر لسٹ پر واپس جائیں۔",
  T_48_META_API_1_R_D: "کھلاڑیوں کی فہرست",
  T_48_META_API_10_D: "منظر کی اشیاء حاصل کریں۔",
  T_48_META_API_10_P0_D: "کس قسم کے سین آبجیکٹ کو فلٹر کرنا ہے۔",
  T_48_META_API_10_R_D: "منظر آبجیکٹ کی فہرست",
  T_48_META_API_100_D: "لوڈنگ مناظر پہلے سے بھرے ہوئے مناظر کو خود بخود ان لوڈ نہیں کریں گے۔",
  T_48_META_API_100_P0_D: "لوڈ کرنے کے لیے منظر کی ID",
  T_48_META_API_10000_D: "موجودہ اسکرپٹ پر پابند ہستی کو لوٹاتا ہے۔",
  T_48_META_API_10000_R_D: "موجودہ اسکرپٹ کی پابند ہستی",
  T_48_META_API_10001_D: "متعلقہ ہستی کو تلاش کرنے کے لیے entity ID کا استعمال کریں اس API کو صارف کی جانب سے استعمال کرنا اس کی مطابقت کی ضمانت نہیں دے سکتا، جیسے کہ ہٹانا یا ایڈجسٹ کرنا۔",
  T_48_META_API_10001_P0_D: "ہدف ہستی ID",
  T_48_META_API_10001_R_D: "ہستی",
  T_48_META_API_10002_D: "گیم کی عالمی ہستی حاصل کریں۔",
  T_48_META_API_10002_R_D: "عالمی ادارہ",
  T_48_META_API_10003_D: "کھلاڑی کو مخصوص نقاط پر ٹیلی پورٹ کریں (متروک، براہ کرم ٹیلی پورٹ استعمال کریں)",
  T_48_META_API_10003_P0_D: "ٹیلی پورٹڈ پلیئر",
  T_48_META_API_10003_P1_D: "ٹیلی پورٹڈ پوائنٹ کے نقاط",
  T_48_META_API_10004_D: "ٹیم کے ساتھیوں کے قریب پوزیشن حاصل کریں اور ان کھلاڑیوں کی پوزیشن سے بچیں جو کھڑے نہیں ہوسکتے ہیں (متروک، براہ کرم GetTeammateNearPosition استعمال کریں)",
  T_48_META_API_10004_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_10004_R_D: "ٹیم کے ساتھیوں کے قریب کوآرڈینیٹ",
  T_48_META_API_10005_D: "وہ کھلاڑی حاصل کریں جو ہستی کا مالک ہو۔",
  T_48_META_API_10005_P0_D: "ٹارگٹ ہستی، ہستی صرف اس کھلاڑی کے ساتھ مطابقت پذیر ہوگی جس سے اس کا تعلق ہے۔",
  T_48_META_API_10005_R_D: "وہ کھلاڑی جس کا ہدف ہستی کا ہے۔",
  T_48_META_API_10006_D: "کھلاڑی کو ناقابل تسخیر بنائیں",
  T_48_META_API_10006_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_10006_P1_D: "ناقابل تسخیر اثر کی مدت، سیکنڈوں میں",
  T_48_META_API_10007_D: "منتخب ہستی اور اس کی تمام خصوصیات کو اس کے اصل مقام پر کلون کریں۔",
  T_48_META_API_10007_P0_D: "ہستی بنائی گئی۔",
  T_48_META_API_10007_P1_D: "کلون ہونے والی ہستی",
  T_48_META_API_10008_D: "کھلاڑی کو نقصان پہنچانے کا کوئی ذریعہ منتخب نہیں کیا جاتا ہے، ہدف کو سسٹم سے نقصان پہنچے گا۔",
  T_48_META_API_10008_P0_D: "تباہ شدہ گیم ہستی",
  T_48_META_API_10008_P1_D: "گیم کی ہستی جو نقصان کا باعث بنتی ہے۔",
  T_48_META_API_10008_P2_D: "نقصان کی قسم",
  T_48_META_API_10008_P3_D: "نقصان پہنچانا",
  T_48_META_API_10009_D: "نامزد کھلاڑی کی قیامت",
  T_48_META_API_10009_P0_D: "زندہ ہونے والا کھلاڑی",
  T_48_META_API_1001_D: "اگر شرائط پوری ہو جائیں تو IF کے تحت نوڈ چلایا جائے گا۔ جب شرائط پوری نہیں ہوتی ہیں، اگر ELSE ہے، تو ELSE کے نیچے نوڈ چلائیں، بصورت دیگر IF بیان ختم کریں۔",
  T_48_META_API_1001_P0_D: "شرط کی فہرست کو ذیلی عمل کی فہرستوں (منطقی شاخ کی فہرستوں) کی تعداد کے ساتھ مطابقت رکھنے کی ضرورت ہے۔",
  T_48_META_API_10010_D: "ایک مخصوص جگہ پر آئٹم یا آئٹمز کی فہرست بناتا ہے۔",
  T_48_META_API_10010_P0_D: "آئٹم بنانے کا مقام",
  T_48_META_API_10010_P1_D: "تخلیق کردہ شے یا اشیاء کی فہرست",
  T_48_META_API_10010_P2_D: "آئٹم کی فہرست بناتے وقت، آپ کو آئٹم کی فہرست کی ترتیب کے مطابق آئٹم کی مقدار بھرنے کی ضرورت ہوتی ہے۔",
  T_48_META_API_10011_D: "AI ادارہ ٹارگٹ پوائنٹ پر گشت کرتا ہے۔",
  T_48_META_API_10011_P0_D: "ہدف AI ادارہ",
  T_48_META_API_10011_P1_D: "متحرک ہدف پوائنٹ",
  T_48_META_API_10011_P2_D: "آیا نقطہ آغاز پر واپس جانا ہے۔",
  T_48_META_API_10011_P3_D: "آیا گشت کے دوران دشمن اہداف کا پتہ لگانا اور ان پر حملہ کرنا ہے۔",
  T_48_META_API_10012_D: "AI ادارے کوآرڈینیٹ لسٹ کے مطابق ترتیب سے گشت کرتے ہیں۔",
  T_48_META_API_10012_P0_D: "ہدف AI ادارہ",
  T_48_META_API_10012_P1_D: "کوآرڈینیٹ پوائنٹ کی فہرست کو منتقل کرنا",
  T_48_META_API_10012_P2_D: "گشت کی قسم، آپ سنگل، راؤنڈ ٹرپ یا سائیکل کا انتخاب کر سکتے ہیں۔",
  T_48_META_API_10012_P3_D: "آیا گشت کے دوران دشمن اہداف کا پتہ لگانا اور ان پر حملہ کرنا ہے۔",
  T_48_META_API_10013_D: "جنریٹر یونٹ اداروں کی اگلی لہر کو فوری طور پر تازہ کرتا ہے۔",
  T_48_META_API_10013_P0_D: "جنریٹر ہستی",
  T_48_META_API_10014_D: "حسابی صفات کے لیے شامل کیے گئے حسابی عوامل عوامل پر مشتمل فارمولے کے ذریعے حتمی نتیجہ کا حساب لگائیں گے۔",
  T_48_META_API_10014_P0_D: "ہدف ہستی",
  T_48_META_API_10014_P1_D: "کمپیوٹیبل پراپرٹی کی اقسام",
  T_48_META_API_10014_P2_D: "عنصر کی قسم کا حساب لگائیں۔",
  T_48_META_API_10014_P3_D: "عنصر کی قدروں کا حساب لگائیں۔",
  T_48_META_API_10015_D: "کیلکولیشن کی گئی خصوصیات کے لیے حسابی عوامل کو صاف کریں۔",
  T_48_META_API_10015_P0_D: "ہدف ہستی",
  T_48_META_API_10015_P1_D: "کمپیوٹیبل پراپرٹی کی اقسام",
  T_48_META_API_10016_D: "ٹارگٹ ہستی کی تمام حسابی خصوصیات کے لیے تمام حسابی عوامل کو صاف کرتا ہے۔",
  T_48_META_API_10016_P0_D: "ہدف ہستی",
  T_48_META_API_10017_D: "خصوصیات میں ترمیم کریں۔",
  T_48_META_API_10017_P0_D: "ہدف ہستی",
  T_48_META_API_10017_P1_D: "پراپرٹی کی قسم",
  T_48_META_API_10017_P2_D: "ترمیم کا طریقہ",
  T_48_META_API_10017_P3_D: "قدر",
  T_48_META_API_10018_D: "کمپیوٹیڈ پراپرٹی کی ویلیو سیٹ کریں۔",
  T_48_META_API_10018_P0_D: "ہدف ہستی",
  T_48_META_API_10018_P1_D: "پراپرٹی کی قسم",
  T_48_META_API_10018_P2_D: "قدر",
  T_48_META_API_10019_D: "ایک واحد شمار شدہ پراپرٹی ترمیم کو صاف کریں۔",
  T_48_META_API_10019_P0_D: "ہدف ہستی",
  T_48_META_API_10019_P1_D: "پراپرٹی کی قسم",
  T_48_META_API_1002_D: "پیرامیٹر i کم سے کم قدر سے شروع ہوتا ہے، اور ہر بار جب نچلا نوڈ چلایا جاتا ہے، i اس قدم کی قدر کو بڑھاتا ہے جب تک کہ i زیادہ سے زیادہ قدر سے زیادہ یا اس کے برابر نہ ہو جائے۔",
  T_48_META_API_1002_P0_D: "لوپ انڈیکس کا نام، جسے لوکل متغیر پر لوپ انڈیکس ویلیو حاصل کرنے کے لیے استعمال کیا جا سکتا ہے",
  T_48_META_API_1002_P1_D: "لوپ کی ابتدائی قدر",
  T_48_META_API_1002_P2_D: "لوپ اینڈ ویلیو",
  T_48_META_API_1002_P3_D: "لوپ سٹیپ سائز، جب ابتدائی قدر اختتامی قدر سے کم ہوتی ہے، تو قدم کا سائز 0 سے زیادہ ہونا چاہیے؛ جب ابتدائی قدر اختتامی قدر سے زیادہ ہوتی ہے، تو قدم کا سائز 0 سے کم ہونا چاہیے۔",
  T_48_META_API_10020_D: "گیم میں تمام اداروں کو حاصل کریں جو فلٹر کی شرائط کو پورا کرتی ہیں۔",
  T_48_META_API_10020_P0_D: "فلٹر کے نتائج میں اس پیرامیٹر میں درج قسم کا ہونا ضروری ہے۔",
  T_48_META_API_10020_P1_D: "فلٹر کے نتائج میں اس پیرامیٹر میں درج کی گئی قسم نہیں ہونی چاہیے۔",
  T_48_META_API_10020_P2_D: "فلٹر کے نتائج اس پیرامیٹر میں درج کی گئی اقسام میں سے کم از کم ایک پر مشتمل ہیں۔",
  T_48_META_API_10020_R_D: "فلٹر نتیجہ ہستی کی فہرست",
  T_48_META_API_10021_D: "فٹ بال میں ایک رفتار شامل کریں اسی سمت میں تیز ہونے کی وجہ سے رفتار بدل جائے گی۔",
  T_48_META_API_10021_P0_D: "گول فٹ بال",
  T_48_META_API_10021_P1_D: "3D جگہ کی رفتار شامل کی گئی۔",
  T_48_META_API_10022_D: "مخصوص ہستی کو تباہ کریں۔",
  T_48_META_API_10022_P0_D: "جس ہدف کو تباہ کرنا ہے۔",
  T_48_META_API_10023_D: "اداروں میں ٹیگ شامل کریں۔",
  T_48_META_API_10023_P0_D: "ہدف ہستی",
  T_48_META_API_10023_P1_D: "حسب ضرورت لیبلز",
  T_48_META_API_10024_D: "اداروں سے لیبلز کو ہٹا دیں۔",
  T_48_META_API_10024_P0_D: "ہدف ہستی",
  T_48_META_API_10024_P1_D: "حسب ضرورت لیبلز",
  T_48_META_API_10025_D: "اس بات کا تعین کریں کہ آیا ہدف ہستی میں مخصوص ٹیگ موجود ہے۔",
  T_48_META_API_10025_P0_D: "ہدف ہستی",
  T_48_META_API_10025_P1_D: "حسب ضرورت لیبلز",
  T_48_META_API_10025_R_D: "آیا مخصوص ٹیگ شامل کرنا ہے۔",
  T_48_META_API_10026_D: "فٹ بال کی پوزیشن طے کریں۔",
  T_48_META_API_10026_P0_D: "فٹ بال ہستی",
  T_48_META_API_10026_P1_D: "مقام",
  T_48_META_API_10026_P2_D: "رفتار کو برقرار رکھیں",
  T_48_META_API_10027_D: "ٹارگٹ پلیئر کے ذریعہ فی الحال استعمال شدہ کیمرہ ہستی حاصل کریں۔",
  T_48_META_API_10027_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_10027_R_D: "فی الحال استعمال شدہ کیمرہ ہستی",
  T_48_META_API_10028_D: "ٹارگٹ پلیئر کے کیمرہ کو ٹارگٹ کیمرے پر سوئچ کریں،",
  T_48_META_API_10028_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_10028_P1_D: "ہدف کیمرے",
  T_48_META_API_10028_P2_D: "سوئچنگ موڈ، آپ اصل منطق یا ترقی پسند رکھنے کا انتخاب کر سکتے ہیں۔",
  T_48_META_API_10028_P3_D: "سوئچنگ ٹائم کیمروں کو پروگریسو موڈ میں سوئچ کرنے کا وقت ہے۔",
  T_48_META_API_10029_D: "ایک کیمرہ بنائیں",
  T_48_META_API_10029_P0_D: "کیمرے کی قسم بنائی گئی۔",
  T_48_META_API_10029_P1_D: "کیمرہ ہستی بنائی",
  T_48_META_API_1003_D: "ڈیٹا کنٹینر کے ٹراورسل کو نافذ کریں، ہر ذیلی عنصر کو حاصل کریں، اور ذیلی عمل پر مشتمل لوپ باڈی ذیلی عمل ہے۔",
  T_48_META_API_1003_P0_D: "چائلڈ ایلیمنٹ کے نام پر جائیں، آپ اسے مقامی متغیر پر چائلڈ ایلیمنٹ ویلیو حاصل کرنے کے لیے استعمال کر سکتے ہیں",
  T_48_META_API_1003_P1_D: "لوپ انڈیکس کا نام، جسے لوکل متغیر پر لوپ انڈیکس ویلیو حاصل کرنے کے لیے استعمال کیا جا سکتا ہے",
  T_48_META_API_1003_P2_D: "ڈیٹا کنٹینر جس کو عبور کرنا ہے فی الحال درج ذیل اقسام کو سپورٹ کرتا ہے: array type",
  T_48_META_API_10030_D: "لڑنے والے اداروں کو مار ڈالو",
  T_48_META_API_10030_P0_D: "ہدف ہستی، ایک لڑاکا ادارہ ہونا چاہیے۔",
  T_48_META_API_10031_D: "ٹارگٹ ہستی اور اس کے چائلڈ نوڈس کی سرگرمی کی حیثیت سیٹ کریں غیر فعال اشیاء کی دستیابی، مرئیت، تصادم وغیرہ کو بند کر دیا جائے گا۔",
  T_48_META_API_10031_P0_D: "ہدف ہستی",
  T_48_META_API_10031_P1_D: "کیا یہ فعال ہے؟",
  T_48_META_API_10032_D: "ہمیشہ ہدف والے ہستی کی پیروی کرنے کے لیے کیمرہ ہستی کی پوزیشن سیٹ کریں۔",
  T_48_META_API_10032_P0_D: "ہدف کیمرہ ہستی",
  T_48_META_API_10032_P1_D: "پیروی کرنے کے لئے ہدف ہستی",
  T_48_META_API_10032_P2_D: "ہدف ہستی کے نقاط سے آفسیٹ",
  T_48_META_API_10032_P3_D: "آفسیٹ کوآرڈینیٹ سسٹم",
  T_48_META_API_10033_D: "کیمرہ ہستی کو ہمیشہ ہدف والی ہستی کا سامنا کرنے کے لیے سیٹ کریں۔",
  T_48_META_API_10033_P0_D: "ہدف کیمرہ ہستی",
  T_48_META_API_10033_P1_D: "ہدف ہستی",
  T_48_META_API_10033_P2_D: "ہدف کوآرڈینیٹس سے فکسیشن پوائنٹ کا آفسیٹ",
  T_48_META_API_10033_P3_D: "آفسیٹ کوآرڈینیٹ سسٹم",
  T_48_META_API_10034_D: "Tweens بنائیں",
  T_48_META_API_10034_P0_D: "ہدف ہستی",
  T_48_META_API_10034_P1_D: "پراپرٹی کی شناخت",
  T_48_META_API_10034_P2_D: "SrcVal",
  T_48_META_API_10034_P3_D: "ڈیسٹ وال",
  T_48_META_API_10034_P4_D: "انداز",
  T_48_META_API_10034_P5_D: "وکر",
  T_48_META_API_10034_P6_D: "دورانیہ",
  T_48_META_API_10034_P7_D: "tween ہستی",
  T_48_META_API_10035_D: "پیرنٹ نوڈ سیٹ کریں، جس میں والدین اور بچے دونوں کو ٹرانسفارم اجزاء کی ضرورت ہوتی ہے۔",
  T_48_META_API_10035_P0_D: "پیرنٹ نوڈ",
  T_48_META_API_10035_P1_D: "چائلڈ نوڈ",
  T_48_META_API_10035_P2_D: "آیا موجودہ عالمی پوزیشن کو برقرار رکھنا ہے، چائلڈ نوڈس کی گردش اور اسکیلنگ UI سیٹ کرتے وقت غلط ہے۔",
  T_48_META_API_10036_D: "NewCurve (فرسودہ، براہ کرم CreateTweenCurve استعمال کریں)",
  T_48_META_API_10036_P0_D: "کنٹرول پوائنٹس",
  T_48_META_API_10036_R_D: "TwennCurveEntity",
  T_48_META_API_10037_D: "ٹارگٹ ہستی کو چلانے کی کوششیں، جس میں کھیلنے کے قابل اجزاء ہونے چاہئیں",
  T_48_META_API_10037_P0_D: "ہدف چلانے کے قابل ادارہ",
  T_48_META_API_10037_P1_D: `چاہے دوبارہ چلائیں
سچ: دوبارہ چلائیں
غلط: کھیلنا جاری رکھیں`,
  T_48_META_API_10038_D: "چلنے کے قابل ہستی کو روکیں۔",
  T_48_META_API_10038_P0_D: "ہدف چلانے کے قابل ادارہ",
  T_48_META_API_10039_D: "بیلسٹک حرکت بنائیں، جو ہدف کے وجود کو ابتدائی رفتار اور سمت کے ساتھ سرعت دے گی۔",
  T_48_META_API_10039_P0_D: "ہدف ہستی",
  T_48_META_API_10039_P1_D: "حرکت کی ابتدائی رفتار",
  T_48_META_API_10039_P2_D: "تحریک سرعت",
  T_48_META_API_10039_P3_D: "زیادہ سے زیادہ نقل مکانی کا فاصلہ",
  T_48_META_API_10039_P4_D: "بیلسٹک موشن ہستی بنائی",
  T_48_META_API_10039_P5_D: "آیا تخلیق کے بعد خود بخود چلنا شروع کیا جائے۔",
  T_48_META_API_1004_D: "موجودہ لوپ کے عمل کو روکیں اور لوپ سے باہر نکلیں۔",
  T_48_META_API_10040_D: "حرکت کے بعد پوزیشن بنائیں، ہدف ہستی مخصوص آبجیکٹ کی حرکت کی پیروی کرے گی۔",
  T_48_META_API_10040_P0_D: "ہدف ہستی",
  T_48_META_API_10040_P1_D: "آبجیکٹ ادارے جو حرکت کی پیروی کرتے ہیں۔",
  T_48_META_API_10040_P2_D: "فاصلہ ہدف کے نقاط کے آفسیٹ کے بعد ہوتا ہے۔",
  T_48_META_API_10040_P3_D: "کوآرڈینیٹ سسٹم استعمال کیا گیا۔",
  T_48_META_API_10040_P4_D: "مندرجہ ذیل حرکت ہستی کو بنایا گیا۔",
  T_48_META_API_10040_P5_D: "آیا تخلیق کے بعد خود بخود چلنا شروع کیا جائے۔",
  T_48_META_API_10041_D: "نظروں کی پیروی کرنے والی حرکت بنائیں جہاں ہدف کا وجود مخصوص شے کی طرف رہے گا۔",
  T_48_META_API_10041_P0_D: "ہدف ہستی",
  T_48_META_API_10041_P1_D: "جس چیز کو دیکھا جا رہا ہے۔",
  T_48_META_API_10041_P2_D: "آبجیکٹ ہستی سے نظر کے نقطہ کا آفسیٹ",
  T_48_META_API_10041_P3_D: "کوآرڈینیٹ سسٹم استعمال کیا گیا۔",
  T_48_META_API_10041_P4_D: "نگاہوں کی پیروی کرنے والی حرکت کی ہستی بنائی",
  T_48_META_API_10041_P5_D: "آیا تخلیق کے بعد خود بخود چلنا شروع کیا جائے۔",
  T_48_META_API_10042_D: "فرسودہ",
  T_48_META_API_10042_P0_D: "کھلاڑی ہستی",
  T_48_META_API_10042_P1_D: "میچ کا نتیجہ",
  T_48_META_API_10042_P2_D: "فرسودہ",
  T_48_META_API_10042_P3_D: "فرسودہ",
  T_48_META_API_10042_P4_D: "فرسودہ",
  T_48_META_API_10043_D: "ٹارگٹ ہستی کی خصوصیات کو آسانی سے سیٹ کریں خصوصیات فوری طور پر تبدیل ہو جائیں گی، لیکن کلائنٹ ایک ہموار منتقلی کی کارکردگی کا مظاہرہ کرے گا۔",
  T_48_META_API_10043_P0_D: "ہدف ہستی",
  T_48_META_API_10043_P1_D: "ہدف والے ادارے کی ایک خصوصیت",
  T_48_META_API_10043_P2_D: "جب انتساب کی وضاحت کی جاتی ہے تو ہدف کی قدر کو مطلوبہ قسم کے مطابق ہونا ضروری ہے۔",
  T_48_META_API_10044_D: "کرن کا پتہ لگائیں اور شعاع کی سمت میں ہٹ ہونے والی پہلی ہستی کو واپس کریں",
  T_48_META_API_10044_P0_D: "پوزیشن کوآرڈینیٹ شروع کریں۔",
  T_48_META_API_10044_P1_D: "رے کا پتہ لگانے کی سمت",
  T_48_META_API_10044_P2_D: "رے کا پتہ لگانے کا فاصلہ، صرف مثبت اقدار کو قبول کیا جاتا ہے۔",
  T_48_META_API_10044_P3_D: "رے ڈیٹیکشن لیئر ماسک، صرف بھرے ہوئے لیولز اسکین میں حصہ لیں گے، خالی چھوڑنے کا مطلب ہے کہ تمام لیول اسکین میں حصہ لیں گے۔",
  T_48_META_API_10044_P4_D: "کیا محرکات کو اسکین کرنا ممکن ہے؟",
  T_48_META_API_10044_P5_D: "ہستی کو مارو",
  T_48_META_API_10044_P6_D: "ہٹ پوائنٹ کوآرڈینیٹ",
  T_48_META_API_10044_P7_D: "ہٹ پوائنٹ سے نقطہ آغاز تک کا فاصلہ",
  T_48_META_API_10044_P8_D: "عام سطح کو مارو",
  T_48_META_API_10045_D: "کرن کا پتہ لگائیں اور قریب سے دور تک شعاع کی سمت میں ہٹنے والے تمام اداروں کو واپس کریں۔",
  T_48_META_API_10045_P0_D: "پوزیشن کوآرڈینیٹ شروع کریں۔",
  T_48_META_API_10045_P1_D: "رے کا پتہ لگانے کی سمت",
  T_48_META_API_10045_P2_D: "رے کا پتہ لگانے کا فاصلہ، صرف مثبت اقدار کو قبول کیا جاتا ہے۔",
  T_48_META_API_10045_P3_D: "پرتوں کا ماسک، صرف بھری ہوئی پرتیں اسکین میں حصہ لیں گی، خالی چھوڑنے کا مطلب ہے کہ تمام پرتیں اسکین میں حصہ لیں گی۔",
  T_48_META_API_10045_P4_D: "کیا محرکات کا پتہ لگانا ممکن ہے؟",
  T_48_META_API_10045_P5_D: "متاثرہ اداروں کی فہرست",
  T_48_META_API_10045_P6_D: "ہٹ لسٹ",
  T_48_META_API_10045_P7_D: "پوائنٹ فاصلے شروع پوائنٹ فاصلے کی فہرست کو مارو",
  T_48_META_API_10045_P8_D: "عام سطح کو مارو",
  T_48_META_API_10046_D: "پری فیبس کا استعمال کرتے ہوئے ٹیمپلیٹس کے لیے ادارے بنائیں",
  T_48_META_API_10046_P0_D: "ہستی بنائی گئی۔",
  T_48_META_API_10046_P1_D: "پری فیب ID",
  T_48_META_API_10047_D: "رنگنے",
  T_48_META_API_10047_P0_D: "آبجیکٹ کو نارمل سیٹ کریں۔",
  T_48_META_API_10047_P1_D: "رنگنے کے پوائنٹس سیٹ کریں۔",
  T_48_META_API_10047_P2_D: "رنگ",
  T_48_META_API_10048_D: "داغ کی حیثیت",
  T_48_META_API_10048_P0_D: "رنگنے کے پوائنٹس سیٹ کریں۔",
  T_48_META_API_10048_P1_D: "سمت متعین کریں۔",
  T_48_META_API_10048_P2_D: "فاصلہ طے کریں۔",
  T_48_META_API_10048_R_D: "کلر ڈیسک",
  T_48_META_API_10049_D: "داغدار اعدادوشمار",
  T_48_META_API_10049_P0_D: "رنگ",
  T_48_META_API_10049_R_D: "رنگنے کی مقدار",
  T_48_META_API_1005_D: "باقی لوپ مواد کو چھوڑیں اور براہ راست اگلے لوپ پر جائیں۔",
  T_48_META_API_10050_D: "پلانر رینج سٹیننگ",
  T_48_META_API_10050_P0_D: "آبجیکٹ کو نارمل سیٹ کریں۔",
  T_48_META_API_10050_P1_D: "رنگنے کے پوائنٹس سیٹ کریں۔",
  T_48_META_API_10050_P2_D: "رنگنے کی حد مقرر کریں۔",
  T_48_META_API_10050_P3_D: "رنگ",
  T_48_META_API_10050_P4_D: "رنگنے کی مقدار",
  T_48_META_API_10051_D: "علاقے کا داغ",
  T_48_META_API_10051_P0_D: "آبجیکٹ کو نارمل سیٹ کریں۔",
  T_48_META_API_10051_P1_D: "رنگنے کے پوائنٹس سیٹ کریں۔",
  T_48_META_API_10051_P2_D: "رنگنے کی حد مقرر کریں۔",
  T_48_META_API_10051_P3_D: "رنگ",
  T_48_META_API_10051_P4_D: "فکسڈ داغ والا علاقہ",
  T_48_META_API_10051_P5_D: "بے ترتیب گتانک",
  T_48_META_API_10051_P6_D: "بے ترتیب کشینن گتانک",
  T_48_META_API_10051_P7_D: "رنگنے کی مقدار",
  T_48_META_API_10052_D: "ٹارگٹ پیرنٹ نوڈ ہستی کے تمام چائلڈ نوڈس حاصل کریں۔",
  T_48_META_API_10052_P0_D: "پیرنٹ نوڈ ہستی",
  T_48_META_API_10052_R_D: "چائلڈ نوڈس کی فہرست",
  T_48_META_API_10053_D: "انڈیکس کی بنیاد پر ٹارگٹ پیرنٹ نوڈ ہستی کا مخصوص چائلڈ نوڈ حاصل کریں۔",
  T_48_META_API_10053_P0_D: "پیرنٹ نوڈ ہستی",
  T_48_META_API_10053_P1_D: "چائلڈ نوڈ انڈیکس",
  T_48_META_API_10053_R_D: "چائلڈ نوڈ ہستی",
  T_48_META_API_10054_D: "ہدف چائلڈ نوڈ ہستی کا پیرنٹ نوڈ حاصل کریں۔",
  T_48_META_API_10054_P0_D: "چائلڈ نوڈ ہستی",
  T_48_META_API_10054_R_D: "پیرنٹ نوڈ ہستی",
  T_48_META_API_10055_D: "مخصوص پیرنٹ نوڈ ہستی کے تحت تمام چائلڈ نوڈز کو حذف کریں نوڈ میں ایک ٹرانسفارم جزو ہونا ضروری ہے۔",
  T_48_META_API_10055_P0_D: "پیرنٹ نوڈ ہستی",
  T_48_META_API_10056_D: "مخصوص مقام پر ٹیلی پورٹ کا ہدف",
  T_48_META_API_10056_P0_D: "یونٹ کو ٹیلی پورٹ کیا جا رہا ہے۔",
  T_48_META_API_10056_P1_D: "ٹیلی پورٹ پوائنٹ کوآرڈینیٹ",
  T_48_META_API_10056_P2_D: "ٹیلی پورٹیشن کے بعد یونٹ کی واقفیت",
  T_48_META_API_10057_D: "بے ترتیب ٹیم کے ساتھیوں کے قریب مقام حاصل کریں، ٹیم کے ساتھی نہ ہونے پر اپنے قریب کوآرڈینیٹ واپس کریں، اور ایسے کھلاڑیوں کے مقام سے گریز کریں جو کھڑے نہیں ہو سکتے۔",
  T_48_META_API_10057_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_10057_R_D: "ہدف والے کھلاڑی کے ساتھی ساتھیوں کے قریب کوآرڈینیٹ",
  T_48_META_API_10058_D: "داغ کی کیفیت کو صاف کریں۔",
  T_48_META_API_10059_D: "مخصوص ساؤنڈ ایفیکٹ چلائیں اگر مزید اوصاف ہیں جن کو سیٹ کرنے کی ضرورت ہے تو اس کی ہستی کے اوصاف کو مزید سیٹ کریں۔",
  T_48_META_API_10059_P0_D: "کوڈ کو رسمی پیرامیٹر کے نام کی نمائندگی کرنے کے لیے استعمال کیا جاتا ہے جو صوتی اثر ہستی کو تخلیق کرتا ہے، اور اس کی متعلقہ مقامی متغیر قدر وہ ہستی ہے جو آواز کا اثر پیدا کرتی ہے۔",
  T_48_META_API_10059_P1_D: "یہ جس کھلاڑی کی ہستی سے تعلق رکھتا ہے، صرف اس کھلاڑی کو دکھائی دیتا ہے۔",
  T_48_META_API_10059_P2_D: "صوتی اثر کی قسم، صوتی اثرات کی وہ قسم جسے کھلاڑی منتخب کر سکتے ہیں۔",
  T_48_META_API_1006_D: "موجودہ عمل کو ختم کریں اور براہ راست کال کرنے والے مقام پر واپس جائیں آپ ڈیٹا کے ساتھ واپس آ سکتے ہیں۔",
  T_48_META_API_1006_P0_D: "ڈیٹا کال کرنے کے مقام پر واپس آنے کی توقع ہے۔",
  T_48_META_API_10060_D: "کھیل سے ہدف کے کھلاڑی کو کک کریں۔",
  T_48_META_API_10060_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_10060_P1_D: "بلنگ کی معلومات کو ظاہر کرنا ہے یا نہیں۔",
  T_48_META_API_10061_D: "ہدف والا کھلاڑی مخصوص نقشے سے ملنے کی درخواست کرتا ہے۔",
  T_48_META_API_10061_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_10061_P1_D: "میدان جنگ کوڈ",
  T_48_META_API_10061_P2_D: "آیا میچ منسوخ کرتے وقت ایک پاپ اپ ونڈو آپ کو اصل گیم پر واپس جانے کا اشارہ کرتی ہے۔",
  T_48_META_API_10062_D: "چلنے والے ساؤنڈ ایفیکٹ ہستی میں خلل ڈالیں۔",
  T_48_META_API_10062_P0_D: "ساؤنڈ ایفیکٹ ہستی جسے موقوف کرنے کی ضرورت ہے۔",
  T_48_META_API_10063_D: "صوتی اثر کو چلانا جاری رکھیں، آپ انتخاب کر سکتے ہیں کہ آیا شروع سے کھیلنا شروع کیا جائے۔",
  T_48_META_API_10063_P0_D: "صوتی اثر والے ادارے جنہیں موقوف ہونے کے بعد کھیل جاری رکھنے کی ضرورت ہے۔",
  T_48_META_API_10063_P1_D: "چاہے شروع سے شروع کیا جائے۔",
  T_48_META_API_10064_D: "ایئر ڈراپ بنائیں: 1. تیاری، 2. گرنا، 3. ایئر ڈراپ کی خصوصیات کو صرف حالت 1 میں تبدیل کیا جا سکتا ہے۔",
  T_48_META_API_10064_P0_D: "ایئر ڈراپ باکس ہستی بنائی گئی۔",
  T_48_META_API_1007_D: "ایک لوپ کو لاگو کریں جو کنڈیشن کے درست ہونے کی بنیاد پر عمل درآمد جاری رکھے، جب تک کہ کنڈیشن غلط نہ ہو اور لوپ ختم نہ ہو جائے۔",
  T_48_META_API_1007_P0_D: "جب شرط صحیح ہے، لوپ جاری رہتا ہے، اور جب شرط غلط ہے، لوپ ختم ہوجاتا ہے.",
  T_48_META_API_1008_D: `اگلے منطقی فریم کے آغاز تک انتظار کریں
سرور پر، اگر کم فریم ریٹ موڈ فعال ہے، تو انتظار طویل ہو جائے گا
کلائنٹ پر، انتظار کا وقت آلہ کی کارکردگی اور موجودہ فریم کی منطقی پیچیدگی سے متاثر ہوتا ہے
استعمال کریں یہ API فنکشن کو async قرار دینے کی ضرورت ہے۔`,
  T_48_META_API_1009_D: "ایک خاص مدت تک انتظار کرنے کے بعد، اس API کو استعمال کرنے والے فنکشن کو async قرار دینے کی ضرورت ہے۔",
  T_48_META_API_1009_P0_D: "انتظار کا وقت، ملی سیکنڈ میں",
  T_48_META_API_101_D: "مخصوص منظر کو ان انسٹال کریں۔",
  T_48_META_API_101_P0_D: "سین آئی ڈی کو ان انسٹال کرنا ہے۔",
  T_48_META_API_1010: "Event Callback",
  T_48_META_API_1010_D: "جب کوئی واقعہ پیش آتا ہے تو ایک کارروائی شروع ہوتی ہے۔",
  T_48_META_API_1010_P0: "Event Parameter Names",
  T_48_META_API_1010_P0_D: "ایونٹ پیرامیٹر کا رسمی پیرامیٹر نام، جس کے ذریعے مقامی متغیر پر پیرامیٹر کی اصل قدر حاصل کی جا سکتی ہے",
  T_48_META_API_1011: "Code Block",
  T_48_META_API_1011_D: "کوڈ کا ایک بلاک جو APIs کا مجموعہ رکھتا ہے۔",
  T_48_META_API_1011_P0: "Parameter Names",
  T_48_META_API_1011_P0_D: "رسمی پیرامیٹر کے نام جب کوڈ بلاک ایک حسب ضرورت فنکشن ہوتا ہے۔",
  T_48_META_API_1012: "Find and Invoke Custom API with Serial",
  T_48_META_API_1012_D: "کسٹم فنکشن کو سیریل طریقے سے کال کریں اگر کسٹم فنکشن میں انتظار ہے تو کالنگ لوکیشن بھی انتظار کرے گی۔",
  T_48_META_API_1012_P0_D: "وہ ہستی جہاں کسٹم فنکشن رہتا ہے۔",
  T_48_META_API_1012_P1: "Graph ID",
  T_48_META_API_1012_P1_D: "اسکرپٹ ID جہاں کسٹم فنکشن واقع ہے۔",
  T_48_META_API_1012_P2: "Function ID",
  T_48_META_API_1012_P2_D: "فنکشن ID جس کو ہدف نے بلایا ہے۔",
  T_48_META_API_1012_P3_D: "اپنی مرضی کے فنکشن کو بھیجے گئے دلائل کی فہرست",
  T_48_META_API_1013: "Find and Invoke Custom API with Parallel",
  T_48_META_API_1013_D: "کسی حسب ضرورت فنکشن کو متوازی طور پر کال کریں، قطع نظر اس کے کہ کسٹم فنکشن میں کوئی انتظار ہے، یہ فوری طور پر کال کرنے والے مقام پر واپس آجائے گا اور اس پر عمل درآمد جاری رکھے گا۔",
  T_48_META_API_1013_P0_D: "وہ ہستی جہاں کسٹم فنکشن رہتا ہے۔",
  T_48_META_API_1013_P1: "Graph ID",
  T_48_META_API_1013_P1_D: "اسکرپٹ ID جہاں کسٹم فنکشن واقع ہے۔",
  T_48_META_API_1013_P2: "Function ID",
  T_48_META_API_1013_P2_D: "فنکشن ID جس کو ہدف نے بلایا ہے۔",
  T_48_META_API_1013_P3_D: "اپنی مرضی کے فنکشن کو بھیجے گئے دلائل کی فہرست",
  T_48_META_API_1014: "Find and Invoke Self Custom API with Serial",
  T_48_META_API_1014_D: "اپنی مرضی کے فنکشن کو موجودہ اسکرپٹ میں سیریل موڈ میں کال کریں اگر کسٹم فنکشن میں انتظار ہے تو کال کرنے کا مقام بھی انتظار کرے گا۔",
  T_48_META_API_1014_P0: "Function ID",
  T_48_META_API_1014_P0_D: "فنکشن ID جس کو ہدف نے بلایا ہے۔",
  T_48_META_API_1014_P1_D: "اپنی مرضی کے فنکشن کو بھیجے گئے دلائل کی فہرست",
  T_48_META_API_1015: "Find and Invoke Self Custom API with Parallel",
  T_48_META_API_1015_D: "کسی حسب ضرورت فنکشن کو متوازی طور پر کال کریں، قطع نظر اس کے کہ کسٹم فنکشن میں کوئی انتظار ہے، یہ فوری طور پر کال کرنے والے مقام پر واپس آجائے گا اور اس پر عمل درآمد جاری رکھے گا۔",
  T_48_META_API_1015_P0: "Set Local Variable by Index",
  T_48_META_API_1015_P0_D: "فنکشن ID جس کو ہدف نے بلایا ہے۔",
  T_48_META_API_1015_P1_D: "اپنی مرضی کے فنکشن کو بھیجے گئے دلائل کی فہرست",
  T_48_META_API_1016_D: "اس API کو کال کرتے وقت ہدف کی قسم حاصل کرتا ہے۔",
  T_48_META_API_1016_P0_D: "جس ہدف سے پوچھ گچھ کی جا رہی ہے۔",
  T_48_META_API_1016_R_D: "متغیر کی قسم",
  T_48_META_API_1017_D: "اس بات کا تعین کریں کہ آیا ہدف متغیر مخصوص قسم کا ہے۔",
  T_48_META_API_1017_P0_D: "جس ہدف سے پوچھ گچھ کی جا رہی ہے۔",
  T_48_META_API_1017_P1_D: "جس قسم کا موازنہ کیا جا رہا ہے۔",
  T_48_META_API_1017_R_D: "کیا یہ مطابقت رکھتا ہے؟",
  T_48_META_API_1018_D: "اس بات کا تعین کریں کہ آیا ہدف متغیر کسی خاص قسم کا ذیلی طبقہ ہے، اور واپسی کی قیمت ایک بولین قدر ہے",
  T_48_META_API_1018_P0_D: "ہدف متغیر سے استفسار کیا جا رہا ہے۔",
  T_48_META_API_1018_P1_D: "جس قسم کا موازنہ کیا جا رہا ہے۔",
  T_48_META_API_1018_R_D: "چاہے وہ ذیلی طبقہ ہو۔",
  T_48_META_API_1019_D: "ٹارگٹ ہستی کو مخصوص حسب ضرورت ایونٹ کو متحرک کرنے کی وجہ بنائیں",
  T_48_META_API_1019_P0_D: "حسب ضرورت ایونٹ ID بھیج دی گئی۔",
  T_48_META_API_1019_P1_D: "ہدف ہستی",
  T_48_META_API_1019_P2_D: "پیرامیٹر کی فہرست",
  T_48_META_API_102_D: "مخصوص منظر پر سوئچ کرنے سے دیگر بھاری بھرکم مناظر ان لوڈ ہو جائیں گے۔",
  T_48_META_API_102_P0_D: "منظر ID جس پر سوئچ کرنا ہے۔",
  T_48_META_API_1020_D: "کنٹینر کے ٹراورسل کو لاگو کریں اور ہر کلیدی قدر جوڑی حاصل کریں، بشمول سب پروسیسز لوپ باڈی ذیلی عمل ہے۔",
  T_48_META_API_1020_P0_D: "کلید کے نام پر جائیں، آپ اسے مقامی متغیر پر کلیدی قدر حاصل کرنے کے لیے استعمال کر سکتے ہیں۔",
  T_48_META_API_1020_P1_D: "قدر کے نام پر جائیں، جسے مقامی متغیر پر قدر حاصل کرنے کے لیے استعمال کیا جا سکتا ہے۔",
  T_48_META_API_1020_P2_D: "گزرنے کے لیے کنٹینر",
  T_48_META_API_1021_D: "بوٹ کو حذف کریں۔",
  T_48_META_API_1021_P0_D: "بوٹ پلیئر ہستی کو حذف کریں۔",
  T_48_META_API_1022_D: "ہدف والے کھلاڑی کو گاڑی چھوڑنے پر مجبور کریں۔",
  T_48_META_API_1022_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_1023_D: "نقصان جمپ لفظ بنائیں",
  T_48_META_API_1023_P0_D: "لفظی مواد کو چھوڑیں۔",
  T_48_META_API_1023_P1_D: "فونٹ سائز",
  T_48_META_API_1023_P2_D: "فونٹ کا رنگ",
  T_48_META_API_1023_P3_D: "قیام کا دورانیہ ملی سیکنڈ میں",
  T_48_META_API_1023_P4_D: "نقصان پہنچانے والا ادارہ",
  T_48_META_API_1023_P5_D: "ٹارگٹ ہستی کے عالمی نقاط سے متعلق نقصان کے جمپ لفظ کا آفسیٹ",
  T_48_META_API_1023_P6_D: "نقصان کی چھلانگ کی پوزیشن پر دوبارہ بے ترتیب پوزیشن کی اصلاح کی حد کا سائز",
  T_48_META_API_1023_P7_D: "چاہے درمیان اینیمیشن کرنا ہے۔",
  T_48_META_API_1024_D: "فرسودہ",
  T_48_META_API_1024_P0_D: "فرسودہ",
  T_48_META_API_1024_P1_D: "ہدف ہستی",
  T_48_META_API_1024_P2_D: "منتخب کرنے کے بعد، اگر سرور پر بلایا جاتا ہے، تو اسے کلائنٹ کو بھیجا جائے گا، اگر کلائنٹ کو بلایا جائے تو اسے سرور کو بھیجا جائے گا۔",
  T_48_META_API_1024_P3_D: "پیرامیٹر کی فہرست",
  T_48_META_API_1025_D: "حسب ضرورت کام کی پیشرفت سے استفسار کریں۔",
  T_48_META_API_1025_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_1025_P1_D: "حسب ضرورت ٹاسک ID",
  T_48_META_API_1025_R_D: "کام کی پیشرفت",
  T_48_META_API_1026_D: "ہدف والے کھلاڑی کے بیگ کی جلد حاصل کریں۔",
  T_48_META_API_1026_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_1026_R_D: "بیگ کی جلد کی شناخت",
  T_48_META_API_1027_D: "ہدف والے کھلاڑی کے بیگ کی جلد کو سیٹ کریں۔",
  T_48_META_API_1027_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_1027_P1_D: "بیگ کی جلد کی شناخت",
  T_48_META_API_1028_D: "ٹارگٹ پلیئر کے بیگ کی جلد کو ڈیفالٹ بیرونی کنفیگریشن میں بحال کریں۔",
  T_48_META_API_1028_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_1029_D: "ہدف والے کھلاڑی کے بیگ کی جلد کو صاف کریں۔",
  T_48_META_API_1029_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_103_D: "کھیل کے اسکائی باکس ماحول کے انداز کو تبدیل کریں، آپ دن، شام، رات وغیرہ کا انتخاب کر سکتے ہیں۔",
  T_48_META_API_103_P0_D: "اسکائی باکس کی قسم",
  T_48_META_API_1030_D: "نام کے ذریعہ ہڈی کے پھانسی کی جگہ کا مقام حاصل کریں۔",
  T_48_META_API_1030_P0_D: "ہدف ہستی",
  T_48_META_API_1030_P1_D: "ہڈی کے لٹکنے والے مقام کا نام",
  T_48_META_API_1030_R_D: "ہڈی کی نقطہ",
  T_48_META_API_1031_D: "آبجیکٹ ہستی کا پیرنٹ نوڈ سیٹ کریں، ٹرانسفارم، سکیلیٹن پارٹ، پلیئر، اور ماؤنٹ پوائنٹ کے اجزاء کے ساتھ نصب معاون اداروں کو۔",
  T_48_META_API_1031_P0_D: "پیرنٹ نوڈ",
  T_48_META_API_1031_P1_D: "چائلڈ نوڈ",
  T_48_META_API_1031_P2_D: "آیا موجودہ عالمی پوزیشن کو برقرار رکھنا ہے، چائلڈ نوڈس کی گردش اور اسکیلنگ اگر UI کے ذریعے سیٹ کی گئی ہو تو یہ آئٹم غلط ہے۔",
  T_48_META_API_1032_D: "آئیکن اینیمیشن ایفیکٹ چلائیں، آئیکن پلے بیک کی رفتار سے ابتدائی پوزیشن سے اختتامی پوزیشن میں ترجمہ کرتا ہے",
  T_48_META_API_1032_P0_D: "آئیکن ریسورس ID",
  T_48_META_API_1032_P1_D: "رنگ",
  T_48_META_API_1032_P2_D: "آئیکن زوم",
  T_48_META_API_1032_P3_D: "ابتدائی پوزیشن مرکز",
  T_48_META_API_1032_P4_D: "شروع ہونے والے علاقے کی حد",
  T_48_META_API_1032_P5_D: "اختتامی پوزیشن کا مرکز",
  T_48_META_API_1032_P6_D: "اختتامی پوزیشن کی حد",
  T_48_META_API_1032_P7_D: "پلے بیک کی رفتار وہ فاصلہ فی سیکنڈ ہے جو آئیکن حرکت کرتا ہے۔",
  T_48_META_API_1033_D: "زاویہ حاصل کرنے کے لیے آرکٹینجنٹ آپریشن کریں۔",
  T_48_META_API_1033_P0_D: "Y محور کوآرڈینیٹ",
  T_48_META_API_1033_P1_D: "ایکس محور کوآرڈینیٹ",
  T_48_META_API_1033_R_D: "زاویہ، حد (-180، 180]",
  T_48_META_API_1034_D: "اداروں میں اجزاء شامل کریں صرف صارف کے بنائے ہوئے حسب ضرورت اجزاء کی حمایت کی جاتی ہے۔",
  T_48_META_API_1034_P0_D: "ہدف ہستی",
  T_48_META_API_1034_P1_D: "اجزاء کی قسم ID، صرف صارف کے تخلیق کردہ حسب ضرورت اجزاء کو سپورٹ کرتی ہے۔",
  T_48_META_API_1034_P2_D: "چاہے اسے کامیابی کے ساتھ شامل کیا جائے، موجودہ اجزاء یا غیر حسب ضرورت اجزاء شامل کیے جانے میں ناکام رہیں گے۔",
  T_48_META_API_1035_D: "اداروں سے اجزاء کو ہٹا دیں اور صرف حسب ضرورت اجزاء کو سپورٹ کریں۔",
  T_48_META_API_1035_P0_D: "ہدف ہستی",
  T_48_META_API_1035_P1_D: "اجزاء کی قسم ID، صرف صارف کے تخلیق کردہ حسب ضرورت اجزاء کو سپورٹ کرتی ہے۔",
  T_48_META_API_1035_P2_D: "چاہے ہٹانا کامیاب ہے یا غیر موجود اجزاء یا غیر حسب ضرورت اجزاء کو ہٹانا ناکام ہو جائے گا۔",
  T_48_META_API_1036_D: "پلیئر ایگزٹ انٹرفیس کو وسط میں حسب ضرورت بنائیں",
  T_48_META_API_1036_P0_D: "عنوان",
  T_48_META_API_1036_P1_D: "مواد",
  T_48_META_API_1036_P2_D: "اختیارات",
  T_48_META_API_1036_P3_D: "پس منظر کو ظاہر کرنا ہے یا نہیں۔",
  T_48_META_API_1037_D: "فی الحال بھرے ہوئے تمام مناظر حاصل کریں۔",
  T_48_META_API_1037_R_D: "منظر کی فہرست",
  T_48_META_API_1038_D: "کھلاڑی کی مقامی ہدف کی سمت حاصل کریں۔",
  T_48_META_API_1038_R_D: "ہدف کی سمت",
  T_48_META_API_1039_D: "مقامی ٹائم اسٹیمپ حاصل کریں۔",
  T_48_META_API_1039_R_D: "ٹائم اسٹیمپ",
  T_48_META_API_104_D: "پلیئر کو مخصوص منظر کی مخصوص پوزیشن پر سوئچ کریں ان لوڈ کیے گئے مناظر خود بخود لوڈ ہو جائیں گے، اور لوڈ کیے گئے مناظر خود بخود ان لوڈ نہیں ہوں گے۔",
  T_48_META_API_104_P0_D: "کھلاڑی",
  T_48_META_API_104_P1_D: "لوڈ کرنے کے لیے منظر کی ID",
  T_48_META_API_104_P2_D: "نئے منظر میں کھلاڑی کی پوزیشن",
  T_48_META_API_104_P3_D: "نئے منظر میں کھلاڑی کی واقفیت",
  T_48_META_API_1040_D: "موجودہ پلیٹ فارم کی فکسڈ فریم اپڈیٹ کو موقوف کریں توقف کے بعد، پلیٹ فارم کا فکسڈ فریم اپ ڈیٹ ٹرگر نہیں ہوگا۔",
  T_48_META_API_1041_D: "موجودہ پلیٹ فارم کی فکسڈ فریم اپ ڈیٹ کو دوبارہ شروع کریں بحالی کے بعد، پلیٹ فارم کا فکسڈ فریم اپ ڈیٹ دوبارہ شروع ہوتا ہے۔",
  T_48_META_API_1042_D: "ٹارگٹ پلیئر اور موجودہ کلائنٹ پلیئر کے درمیان دوستی کا رشتہ طے کریں موجودہ کلائنٹ خود موجودہ کلائنٹ کا دوست نہیں ہے۔",
  T_48_META_API_1042_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_1042_R_D: "چاہے آپ موجودہ کلائنٹ کے ساتھ دوست ہوں۔",
  T_48_META_API_1043_D: "حسب ضرورت ایونٹ کو متحرک کریں۔",
  T_48_META_API_1043_P0_D: "حسب ضرورت ایونٹ ID",
  T_48_META_API_1043_P1_D: "ہدف ہستی",
  T_48_META_API_1043_P2_D: "چلنے والا پلیٹ فارم سرور یا کلائنٹ ہے۔",
  T_48_META_API_1043_P3_D: "پیرامیٹر کی فہرست",
  T_48_META_API_1044_D: "اسکائی ڈائیونگ شروع کریں۔",
  T_48_META_API_1044_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_1044_P1_D: "اس اونچائی سے نیچے پیراشوٹ کو کھولنے پر مجبور کیا جائے گا۔",
  T_48_META_API_1044_P2_D: "وہ رفتار جب گلائیڈنگ کرتی ہے، X جزو افقی رفتار کی نمائندگی کرتا ہے، اور Y جزو عمودی رفتار کی نمائندگی کرتا ہے، جب Y جزو منفی ہوتا ہے، کھلاڑی نیچے کی طرف اترتا ہے۔",
  T_48_META_API_1044_P3_D: "ڈائیونگ کرتے وقت رفتار، X جزو افقی رفتار کی نمائندگی کرتا ہے، اور Y جزو عمودی رفتار کی نمائندگی کرتا ہے، جب Y جزو منفی ہوتا ہے، کھلاڑی نیچے کی طرف گرتا ہے۔",
  T_48_META_API_1044_P4_D: "چھتری کو کھولتے وقت، X کا جزو افقی رفتار کی نمائندگی کرتا ہے، اور Y جزو عمودی رفتار کو ظاہر کرتا ہے، جب Y جزو منفی ہوتا ہے، کھلاڑی نیچے کی طرف اترتا ہے۔",
  T_48_META_API_1045_D: "ڈیٹا ٹیبل میں مخصوص شناخت کنندہ سے متعلقہ قدر پڑھیں",
  T_48_META_API_1045_P0_D: "ڈیٹا بیس میں ٹیبل کا نام",
  T_48_META_API_1045_P1_D: "پلیئر کی منفرد شناخت",
  T_48_META_API_1045_P2_D: "شناخت کنندہ کی وضاحت کریں۔",
  T_48_META_API_1045_P3_D: "نتائج پڑھیں",
  T_48_META_API_1045_P4_D: "ڈیٹا بیس سے مماثل میدان جنگ کا کوڈ، جسے خالی جگہوں میں بھرا جا سکتا ہے، موجودہ نقشے کے میدان جنگ کوڈ کی نمائندگی کرتا ہے۔",
  T_48_META_API_1045_P5_D: "غلطی کا کوڈ",
  T_48_META_API_1046_D: "درجہ بندی کے ڈیٹا ٹیبل میں مخصوص شناخت کنندہ سے متعلقہ قدر پڑھیں",
  T_48_META_API_1046_P0_D: "ڈیٹا بیس میں درجہ بندی ٹیبل کا نام",
  T_48_META_API_1046_P1_D: "شناخت کنندہ کی وضاحت کریں۔",
  T_48_META_API_1046_P2_D: "نتائج پڑھیں",
  T_48_META_API_1046_P3_D: "ڈیٹا بیس سے مماثل میدان جنگ کا کوڈ، جسے خالی جگہوں میں بھرا جا سکتا ہے، موجودہ نقشے کے میدان جنگ کوڈ کی نمائندگی کرتا ہے۔",
  T_48_META_API_1046_P4_D: "غلطی کا کوڈ",
  T_48_META_API_1047_D: "درجہ بندی ڈیٹا ٹیبل میں مخصوص درجہ بندی وقفہ کی قدر پڑھیں",
  T_48_META_API_1047_P0_D: "ڈیٹا بیس میں درجہ بندی ٹیبل کا نام",
  T_48_META_API_1047_P1_D: "ابتدائی درجہ ختم ہونے والے درجے سے کم یا اس کے برابر ہونا چاہیے، اور درجہ 1 سے شروع ہوتا ہے۔",
  T_48_META_API_1047_P2_D: "آخری درجہ بندی",
  T_48_META_API_1047_P3_D: "نتائج پڑھیں",
  T_48_META_API_1047_P4_D: "ڈیٹا بیس سے مماثل میدان جنگ کا کوڈ، جسے خالی جگہوں میں بھرا جا سکتا ہے، موجودہ نقشے کے میدان جنگ کوڈ کی نمائندگی کرتا ہے۔",
  T_48_META_API_1047_P5_D: "غلطی کا کوڈ",
  T_48_META_API_1048_D: "مجموعی ڈیٹا ٹیبل میں مخصوص شناخت کنندہ سے متعلقہ قدر پڑھیں",
  T_48_META_API_1048_P0_D: "ڈیٹا بیس میں جمع کردہ ڈیٹا ٹیبل کا نام",
  T_48_META_API_1048_P1_D: "شناخت کنندہ کی وضاحت کریں۔",
  T_48_META_API_1048_P2_D: "نتائج پڑھیں",
  T_48_META_API_1048_P3_D: "ڈیٹا بیس سے مماثل میدان جنگ کا کوڈ، جسے خالی جگہوں میں بھرا جا سکتا ہے، موجودہ نقشے کے میدان جنگ کوڈ کی نمائندگی کرتا ہے۔",
  T_48_META_API_1048_P4_D: "غلطی کا کوڈ",
  T_48_META_API_1049_D: "ڈیٹا ٹیبل میں مخصوص شناخت کنندہ کے مطابق قدر لکھیں۔",
  T_48_META_API_1049_P0_D: "ڈیٹا بیس میں ٹیبل کا نام",
  T_48_META_API_1049_P1_D: "پلیئر کی منفرد شناخت",
  T_48_META_API_1049_P2_D: "شناخت کنندہ کی وضاحت کریں۔",
  T_48_META_API_1049_P3_D: "قیمت لکھی ہے",
  T_48_META_API_1049_P4_D: "ڈیٹا بیس سے مماثل میدان جنگ کا کوڈ، جسے خالی جگہوں میں بھرا جا سکتا ہے، موجودہ نقشے کے میدان جنگ کوڈ کی نمائندگی کرتا ہے۔",
  T_48_META_API_1049_P5_D: "غلطی کا کوڈ",
  T_48_META_API_105_D: "منظر کا اسکائی باکس حاصل کریں۔",
  T_48_META_API_105_P0_D: "منظر کی شناخت",
  T_48_META_API_105_R_D: "اسکائی باکس",
  T_48_META_API_1050_D: "فہرست میں عناصر کی تعداد حاصل کریں۔",
  T_48_META_API_1050_P0_D: "ہدف کی فہرست",
  T_48_META_API_1050_R_D: "عناصر کی تعداد",
  T_48_META_API_1051_D: "فہرست میں مخصوص انڈیکس پر عنصر کی قدر حاصل کریں۔",
  T_48_META_API_1051_P0_D: "ہدف کی فہرست",
  T_48_META_API_1051_P1_D: "اشاریہ کی قدر، 0 سے شروع ہوتی ہے۔",
  T_48_META_API_1051_R_D: "عنصر کی قدر",
  T_48_META_API_1052_D: "فہرست میں مخصوص انڈیکس کے مطابق عنصر کی قدر سیٹ کرتا ہے۔",
  T_48_META_API_1052_P0_D: "ہدف کی فہرست",
  T_48_META_API_1052_P1_D: "اشاریہ کی قدر، 0 سے شروع ہوتی ہے۔",
  T_48_META_API_1052_P2_D: "عنصر کی قدر",
  T_48_META_API_1053_D: "فہرست کے آخر میں عناصر کو شامل کریں۔",
  T_48_META_API_1053_P0_D: "ہدف کی فہرست",
  T_48_META_API_1053_P1_D: "شامل کرنے کے لئے عناصر",
  T_48_META_API_1054_D: "فہرست سے مخصوص انڈیکس سے متعلقہ عنصر کو ہٹاتا ہے۔",
  T_48_META_API_1054_P0_D: "ہدف کی فہرست",
  T_48_META_API_1054_P1_D: "اشاریہ کی قدر، 0 سے شروع ہوتی ہے۔",
  T_48_META_API_1055_D: "فہرست میں موجود تمام عناصر کو صاف کریں۔",
  T_48_META_API_1055_P0_D: "ہدف کی فہرست",
  T_48_META_API_1056_D: "مخصوص فہرست کو ریورس کریں فہرست میں عناصر کی ترتیب کو الٹ دیا جائے گا۔",
  T_48_META_API_1056_P0_D: "ہدف کی فہرست",
  T_48_META_API_1057_D: "ایک فہرست کاپی کریں",
  T_48_META_API_1057_P0_D: "ہدف کی فہرست",
  T_48_META_API_1057_R_D: "نئی فہرست کاپی کی گئی۔",
  T_48_META_API_1058_D: "فہرست میں مخصوص انڈیکس پوزیشن پر ایک نیا عنصر داخل کریں اصل انڈیکس پوزیشن پر اور اس کے بعد کے عناصر کو باری باری ایک پوزیشن پر منتقل کیا جائے گا۔",
  T_48_META_API_1058_P0_D: "ہدف کی فہرست",
  T_48_META_API_1058_P1_D: "انڈیکس کی پوزیشن جو داخل کی جانی ہے، انڈیکس کا حساب 0 سے کیا جاتا ہے۔",
  T_48_META_API_1058_P2_D: "داخل کرنے کے لیے عنصر کی نئی قدر",
  T_48_META_API_1059_D: "فہرست میں عناصر کو تصادفی طور پر دوبارہ ترتیب دیں۔",
  T_48_META_API_1059_P0_D: "ہدف کی فہرست",
  T_48_META_API_1060_D: "دونوں اطراف کے پیرامیٹرز کا موازنہ کریں اور صحیح یا غلط واپس کریں۔",
  T_48_META_API_1060_P0_D: "lvalue موازنہ کے لیے استعمال کیا جاتا ہے۔",
  T_48_META_API_1060_P1_D: "موازنہ کا طریقہ درج ذیل طریقوں کی حمایت کرتا ہے: >,>=,==,!=,<=,<,اور (محدود بول قسم)، یا (محدود بول قسم)",
  T_48_META_API_1060_P2_D: "lvalue موازنہ کے لیے استعمال کیا جاتا ہے۔",
  T_48_META_API_1060_R_D: "نتائج کا موازنہ کریں۔",
  T_48_META_API_1061_D: "چار بنیادی ریاضی کی کارروائیوں میں شامل، گھٹاؤ، ضرب، تقسیم اور باقی شامل ہیں۔ بقیہ آپریشن صرف انٹیجرز کو سپورٹ کرتا ہے، اور باقی آپریشنز انٹیجرز یا ڈیسیملز کو سپورٹ کرتے ہیں۔",
  T_48_META_API_1061_P0_D: "آپریشن کی قدر",
  T_48_META_API_1061_P1_D: "چار قسم کی ریاضی کی کارروائیاں، بشمول جوڑ، گھٹاؤ، ضرب، تقسیم اور بقیہ عمل اعشاریہ کی حمایت نہیں کرتا ہے۔",
  T_48_META_API_1061_P2_D: "آپریشن کی قدر",
  T_48_META_API_1061_R_D: "حساب کا نتیجہ",
  T_48_META_API_1062_D: "تصادفی طور پر سب سے چھوٹے عدد (شامل) اور سب سے بڑے عدد (خصوصی) کے درمیان ایک عدد عدد پیدا کرتا ہے۔",
  T_48_META_API_1062_P0_D: "بے ترتیب حد کے بائیں وقفہ سے، تصادفی طور پر بھری ہوئی قدر تک پہنچنا ممکن ہے۔",
  T_48_META_API_1062_P1_D: "بے ترتیب رینج کا صحیح وقفہ بھری ہوئی قدر کے لیے بے ترتیب نہیں ہوگا۔",
  T_48_META_API_1062_R_D: "بے ترتیب نتیجہ، عدد",
  T_48_META_API_1063_D: "تصادفی طور پر سب سے چھوٹی اعشاریہ قدر (شامل) اور سب سے بڑی اعشاریہ قدر (خصوصی) کے درمیان ایک اعشاریہ تیار کرتا ہے۔",
  T_48_META_API_1063_P0_D: "رینڈم رینج کا بایاں وقفہ، اس بات کا بہت کم امکان ہے کہ بھری ہوئی قدر بے ترتیب ہو گی۔",
  T_48_META_API_1063_P1_D: "بے ترتیب رینج کا صحیح وقفہ بھری ہوئی قدر کے لیے بے ترتیب نہیں ہوگا۔",
  T_48_META_API_1063_R_D: "بے ترتیب نتیجہ، اعشاریہ، 7 اعشاریہ تک درست",
  T_48_META_API_1064_D: "اس بات کا تعین کریں کہ آیا اعتراض خالی ہے۔",
  T_48_META_API_1064_P0_D: "جس اعتراض کو خالی سمجھا جائے۔",
  T_48_META_API_1064_R_D: "کیا یہ خالی ہے؟",
  T_48_META_API_1065_D: "منطقی نفی، ان پٹ قدر: درست یا غلط، واپسی کی قدر: غلط یا درست",
  T_48_META_API_1065_P0_D: "غیر کی قدر تلاش کرنے کی ضرورت ہے۔",
  T_48_META_API_1065_R_D: "منفی نتیجہ",
  T_48_META_API_1066_D: "مطلق قدر لیں، عدد اور اعشاریہ کو سپورٹ کرتا ہے۔",
  T_48_META_API_1066_P0_D: "قدر کی مطلق قدر تلاش کرنے کی ضرورت ہے۔",
  T_48_META_API_1066_R_D: "مطلق قدر لینے کا نتیجہ",
  T_48_META_API_1067_D: "مربع جڑ کا حساب لگائیں۔",
  T_48_META_API_1067_P0_D: "قدر کا مربع جڑ تلاش کرنے کی ضرورت ہے۔",
  T_48_META_API_1067_R_D: "مربع جڑ تلاش کرنے کا نتیجہ",
  T_48_META_API_1068_D: "منفی اقدار کا حساب لگائیں۔",
  T_48_META_API_1068_P0_D: "منفی قدر تلاش کرنے کی ضرورت ہے۔",
  T_48_META_API_1068_R_D: "منفی نتیجہ",
  T_48_META_API_1069_D: "دو تاروں کو ایک ساتھ جوڑیں۔",
  T_48_META_API_1069_P0_D: "سٹرنگ کی قدر",
  T_48_META_API_1069_P1_D: "سٹرنگ کی قدر",
  T_48_META_API_1069_R_D: "سٹرنگ کنکٹنیشن کا نتیجہ",
  T_48_META_API_1070_D: "تار کی لمبائی حاصل کریں۔",
  T_48_META_API_1070_P0_D: "تار",
  T_48_META_API_1070_R_D: "تار کی لمبائی",
  T_48_META_API_1071_D: "متعین قدر کو قریب ترین عدد تک گول کرتا ہے۔",
  T_48_META_API_1071_P0_D: "وہ قدر جس کو گول کرنے کی ضرورت ہے۔",
  T_48_META_API_1071_R_D: "گول کرنے کا نتیجہ",
  T_48_META_API_1072_D: "متعین قدر کو قریب ترین عدد تک گول کرتا ہے۔",
  T_48_META_API_1072_P0_D: "وہ قدر جس کو جمع کرنے کی ضرورت ہے۔",
  T_48_META_API_1072_R_D: "راؤنڈ اپ کا نتیجہ",
  T_48_META_API_1073_D: "متعین قدر کو ایک عدد میں گول کرتا ہے۔",
  T_48_META_API_1073_P0_D: "وہ اقدار جن کو گول کرنے کی ضرورت ہے۔",
  T_48_META_API_1073_R_D: "گول نتیجہ",
  T_48_META_API_1074_D: "ٹارگٹ سٹرنگ میں تمام مخصوص سٹرنگز کو تبدیل کرنے کے بعد، نئی سٹرنگ آؤٹ پٹ کریں۔",
  T_48_META_API_1074_P0_D: "ہدف کی تار",
  T_48_META_API_1074_P1_D: "پرانی تار جس کو بدلنا ہے۔",
  T_48_META_API_1074_P2_D: "نئی تار جس کے ساتھ تبدیل کرنا ہے۔",
  T_48_META_API_1074_R_D: "مکمل سٹرنگ کو تبدیل کریں۔",
  T_48_META_API_1075_D: "کسی مخصوص سٹرنگ کی پہلی موجودگی کے لیے ٹارگٹ سٹرنگ تلاش کریں۔",
  T_48_META_API_1075_P0_D: "ہدف کی تار",
  T_48_META_API_1075_P1_D: "تلاش کرنے کے لیے مخصوص سٹرنگ",
  T_48_META_API_1075_P2_D: "سٹارٹنگ پوزیشن سے سٹرنگ تلاش کریں، سٹرنگ پوزیشن کا حساب 0 سے کیا جاتا ہے۔",
  T_48_META_API_1075_R_D: "ٹارگٹ سٹرنگ میں سٹرنگ کی پہلی موجودگی کی پوزیشن کو بتاتا ہے سٹرنگ پوزیشن کو 0 سے شمار کیا جاتا ہے۔",
  T_48_META_API_1076_D: "مخصوص پوزیشن سے شروع ہونے والی مخصوص لمبائی کی تار کو روکنے کے بعد، ایک نئی سٹرنگ آؤٹ پٹ کریں۔",
  T_48_META_API_1076_P0_D: "ہدف کی تار",
  T_48_META_API_1076_P1_D: "وہ پوزیشن جہاں سے انٹرسیپشن شروع ہوتا ہے اسٹرنگ پوزیشن کو 0 سے شمار کیا جاتا ہے۔",
  T_48_META_API_1076_P2_D: "پہلے سے طے شدہ طور پر، یہ تار کے آخر تک کاٹتا ہے۔",
  T_48_META_API_1076_R_D: "روکا ہوا تار",
  T_48_META_API_1077_D: "موازنہ کرتا ہے کہ آیا دو فہرستوں کے عناصر بالکل ایک جیسے ہیں۔",
  T_48_META_API_1077_P0_D: "موازنہ کے لیے استعمال ہونے والی قدروں کی فہرست بنائیں",
  T_48_META_API_1077_P1_D: "موازنہ کے لیے استعمال ہونے والے rvalues کی فہرست بنائیں",
  T_48_META_API_1077_R_D: "نتائج کا موازنہ کرتے ہوئے، اگر مشمولات ایک جیسے ہیں، تو سچ واپس کر دیا جائے گا؛ اگر مواد متضاد ہیں، تو غلط واپس کر دیا جائے گا۔",
  T_48_META_API_1078_D: "مخصوص سٹرنگ کو ڈیلیمیٹر کے طور پر استعمال کرتے ہوئے، ٹارگٹ سٹرنگ کو کئی سلائسز میں کاٹیں اور ایک نئی سٹرنگ کو N-1 آدھی چوڑائی والی جگہوں میں کاٹ کر سٹرنگ لسٹ عناصر کے طور پر آؤٹ پٹ کر دیا جائے گا۔",
  T_48_META_API_1078_P0_D: "ہدف کی تار",
  T_48_META_API_1078_P1_D: "حد بندی کرنے والی تار",
  T_48_META_API_1078_R_D: "آؤٹ پٹ سٹرنگ کی فہرست ہمیشہ آدھی چوڑائی والے خلائی عنصر کے ساتھ ختم ہوتی ہے۔",
  T_48_META_API_1079_D: "سٹرنگ پوزیشن لسٹ کے مطابق حروف کو نکالیں اور انہیں ایک نئی سٹرنگ آؤٹ پٹ میں جوڑیں۔",
  T_48_META_API_1079_P0_D: "ہدف کی تار",
  T_48_META_API_1079_P1_D: "سٹرنگ پوزیشنز کی فہرست، سٹرنگ پوزیشنز کا حساب 0 سے شروع ہوتا ہے۔",
  T_48_META_API_1079_R_D: "آؤٹ پٹ سٹرنگ",
  T_48_META_API_1080_D: "ٹارگٹ سٹرنگ حروف کو تمام بڑے حروف میں تبدیل کریں۔",
  T_48_META_API_1080_P0_D: "ہدف کی تار",
  T_48_META_API_1080_R_D: "آؤٹ پٹ سٹرنگ",
  T_48_META_API_1081_D: "تمام ٹارگٹ سٹرنگ حروف کو چھوٹے میں تبدیل کریں۔",
  T_48_META_API_1081_P0_D: "ہدف کی تار",
  T_48_META_API_1081_R_D: "آؤٹ پٹ سٹرنگ",
  T_48_META_API_1082_D: "پہلے نان اسپیس کریکٹر سے پہلے اور ٹارگٹ سٹرنگ کے آخری غیر اسپیس کریکٹر کے بعد تمام اسپیس کو ہٹا دیں۔",
  T_48_META_API_1082_P0_D: "ہدف کی تار",
  T_48_META_API_1082_R_D: "آؤٹ پٹ سٹرنگ",
  T_48_META_API_1083_D: "مخصوص شناخت کنندہ کے ساتھ لنک کرنے کے بعد ایک نئی سٹرنگ آؤٹ پٹ کرتا ہے۔",
  T_48_META_API_1083_P0_D: "ہدف کے تار کی فہرست",
  T_48_META_API_1083_P1_D: "مخصوص شناخت کنندہ تاروں کو جوڑنے کے لیے استعمال کیا جاتا ہے۔",
  T_48_META_API_1083_R_D: "آؤٹ پٹ سٹرنگ",
  T_48_META_API_1084_D: "درجہ بندی کے ڈیٹا ٹیبل میں مخصوص شناخت کنندہ کے مطابق قدر لکھیں۔",
  T_48_META_API_1084_P0_D: "ڈیٹا بیس میں درجہ بندی ٹیبل کا نام",
  T_48_META_API_1084_P1_D: "شناخت کنندہ کی وضاحت کریں۔",
  T_48_META_API_1084_P2_D: "قیمت لکھی ہے",
  T_48_META_API_1084_P3_D: "ڈیٹا بیس سے مماثل میدان جنگ کا کوڈ، جسے خالی جگہوں میں بھرا جا سکتا ہے، موجودہ نقشے کے میدان جنگ کوڈ کی نمائندگی کرتا ہے۔",
  T_48_META_API_1084_P4_D: "غلطی کا کوڈ",
  T_48_META_API_1085_D: "مجموعی ڈیٹا ٹیبل میں مخصوص شناخت کنندہ کے مطابق آفسیٹ ویلیو لکھیں",
  T_48_META_API_1085_P0_D: "ڈیٹا بیس میں جمع کردہ ڈیٹا ٹیبل کا نام",
  T_48_META_API_1085_P1_D: "شناخت کنندہ کی وضاحت کریں۔",
  T_48_META_API_1085_P2_D: "ریاضی کے عمل کی چار اقسام",
  T_48_META_API_1085_P3_D: "آفسیٹ ویلیو لکھا ہے۔",
  T_48_META_API_1085_P4_D: "ڈیٹا بیس سے مماثل میدان جنگ کا کوڈ، جسے خالی جگہوں میں بھرا جا سکتا ہے، موجودہ نقشے کے میدان جنگ کوڈ کی نمائندگی کرتا ہے۔",
  T_48_META_API_1085_P5_D: "غلطی کا کوڈ",
  T_48_META_API_1086_D: "ڈیٹا ٹیبل میں مخصوص شناخت کنندہ سے متعلقہ قدر کو حذف کریں۔",
  T_48_META_API_1086_P0_D: "ڈیٹا بیس میں ٹیبل کا نام",
  T_48_META_API_1086_P1_D: "پلیئر کی منفرد شناخت",
  T_48_META_API_1086_P2_D: "شناخت کنندہ کی وضاحت کریں۔",
  T_48_META_API_1086_P3_D: "ڈیٹا بیس سے مماثل میدان جنگ کا کوڈ، جسے خالی جگہوں میں بھرا جا سکتا ہے، موجودہ نقشے کے میدان جنگ کوڈ کی نمائندگی کرتا ہے۔",
  T_48_META_API_1086_P4_D: "غلطی کا کوڈ",
  T_48_META_API_1087_D: "درجہ بندی کے ڈیٹا ٹیبل میں مخصوص شناخت کنندہ سے متعلقہ قدر کو حذف کریں۔",
  T_48_META_API_1087_P0_D: "ڈیٹا بیس میں درجہ بندی ٹیبل کا نام",
  T_48_META_API_1087_P1_D: "شناخت کنندہ کی وضاحت کریں۔",
  T_48_META_API_1087_P2_D: "ڈیٹا بیس سے مماثل میدان جنگ کا کوڈ، جسے خالی جگہوں میں بھرا جا سکتا ہے، موجودہ نقشے کے میدان جنگ کوڈ کی نمائندگی کرتا ہے۔",
  T_48_META_API_1087_P3_D: "غلطی کا کوڈ",
  T_48_META_API_1088_D: "درجہ بندی کے ڈیٹا ٹیبل میں مخصوص درجہ بندی کے مطابق قدر کو حذف کریں۔",
  T_48_META_API_1088_P0_D: "ڈیٹا بیس میں درجہ بندی ٹیبل کا نام",
  T_48_META_API_1088_P1_D: "درجہ بندی کی وضاحت کریں۔",
  T_48_META_API_1088_P2_D: "ڈیٹا بیس سے مماثل میدان جنگ کا کوڈ، جسے خالی جگہوں میں بھرا جا سکتا ہے، موجودہ نقشے کے میدان جنگ کوڈ کی نمائندگی کرتا ہے۔",
  T_48_META_API_1088_P3_D: "غلطی کا کوڈ",
  T_48_META_API_1089_D: "صارف کا پیغام Persona کو بھیجیں۔",
  T_48_META_API_1089_P0_D: "ٹارگٹ PersonaID",
  T_48_META_API_1089_P1_D: "پیغام کا مواد",
  T_48_META_API_1090_D: "Persona کو سسٹم پیغامات بھیجیں۔",
  T_48_META_API_1090_P0_D: "ٹارگٹ PersonaID",
  T_48_META_API_1090_P1_D: "پیغام کا مواد",
  T_48_META_API_1091_D: "پرسونا میموری کو صاف کریں۔",
  T_48_META_API_1091_P0_D: "غلطی کا کوڈ",
  T_48_META_API_1092_D: "اراؤس ممبر سینٹر",
  T_48_META_API_1092_P0_D: "غلطی کا کوڈ",
  T_48_META_API_1093_D: "رکنیت کی میعاد ختم ہونے کا ٹائم اسٹیمپ حاصل کریں۔",
  T_48_META_API_1093_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_1093_P1_D: "ٹائم اسٹیمپ",
  T_48_META_API_1093_P2_D: "غلطی کا کوڈ",
  T_48_META_API_1094_D: "اس بات کا تعین کریں کہ آیا کھلاڑی ممبر ہے۔",
  T_48_META_API_1094_P0_D: "غلطی کا کوڈ",
  T_48_META_API_1094_P1_D: "کیا آپ ممبر ہیں؟",
  T_48_META_API_1095_D: "رکنیت کی میعاد ختم ہونے کا ٹائم اسٹیمپ حاصل کریں۔",
  T_48_META_API_1095_P0_D: "ٹائم اسٹیمپ",
  T_48_META_API_1095_P1_D: "غلطی کا کوڈ",
  T_48_META_API_1096_D: "اس بات کا تعین کریں کہ آیا کھلاڑی ممبر ہے۔",
  T_48_META_API_1096_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_1096_P1_D: "غلطی کا کوڈ",
  T_48_META_API_1096_P2_D: "کیا آپ ممبر ہیں؟",
  T_48_META_API_1097_D: "اراؤس ممبر سینٹر",
  T_48_META_API_1097_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_1097_P1_D: "غلطی کا کوڈ",
  T_48_META_API_1099_D: "ایک Persona مبصر مقرر کریں، اور Persona کے ساتھ بعد کی بات چیت بھی مبصر کو بھیجی جائے گی۔",
  T_48_META_API_1099_P0_D: "ٹارگٹ PersonaID",
  T_48_META_API_1099_P1_D: "مبصر کی فہرست",
  T_48_META_API_11_D: "موجودہ مرحلے کو ختم کریں اور اگلے مرحلے میں داخل ہوں۔",
  T_48_META_API_1100_D: "اسٹریمنگ کا استعمال کرتے ہوئے صارف کے پیغامات Persona کو بھیجیں۔",
  T_48_META_API_1100_P0_D: "ٹارگٹ PersonaID",
  T_48_META_API_1100_P1_D: "پیغام کا مواد",
  T_48_META_API_1101_D: "سٹریمنگ کا استعمال کرتے ہوئے Persona کو سسٹم پیغامات بھیجیں۔",
  T_48_META_API_1101_P0_D: "ٹارگٹ PersonaID",
  T_48_META_API_1101_P1_D: "پیغام کا مواد",
  T_48_META_API_1101_P2_D: "جواب دینا چاہیے۔",
  T_48_META_API_1103_D: "بے ترتیب بیج بنائیں",
  T_48_META_API_1103_P0_D: "بیج",
  T_48_META_API_1103_R_D: "بے ترتیب نمبر جنریٹر",
  T_48_META_API_1104_D: "مخصوص رینڈم نمبر جنریٹر سے اگلا رینڈم نمبر حاصل کریں، زیادہ سے زیادہ قیمت 32767 ہے",
  T_48_META_API_1104_P0_D: "بے ترتیب نمبر جنریٹر",
  T_48_META_API_1104_P1_D: "رینج کم از کم",
  T_48_META_API_1104_P2_D: "رینج زیادہ سے زیادہ",
  T_48_META_API_1104_R_D: "بے ترتیب نمبر",
  T_48_META_API_1108_D: "Get the client language used by the player ",
  T_48_META_API_12_D: "کنسول پر لاگ پرنٹ کریں۔",
  T_48_META_API_12_P0_D: "کیا پرنٹ کرنے کی ضرورت ہے",
  T_48_META_API_13_D: "پیرامیٹرز کے ساتھ سٹرنگ آؤٹ پٹ کریں۔",
  T_48_META_API_13_P0_D: "ایک پیرامیٹر کی نمائندگی کرنے کے لیے %v پلیس ہولڈر کا استعمال کریں اور %v کی تعداد کو ہم آہنگ کرنے کی ضرورت ہے۔",
  T_48_META_API_13_P1_D: "آؤٹ پٹ میں حصہ لینے والے پیرامیٹر کی فہرست کو فارمیٹ کی تفصیل میں %v کی تعداد کے مطابق ہونا ضروری ہے۔",
  T_48_META_API_13_R_D: "آؤٹ پٹ سٹرنگ",
  T_48_META_API_14_D: "نقشہ آبجیکٹ کی باقیات کو صاف کریں، بشمول موت کے خانے، تخلیق کردہ اشیاء، رکھی ہوئی اشیاء، پرکشیپی باقیات وغیرہ۔",
  T_48_META_API_15_D: "صارف کے تجربے کے ڈیٹا کے تجزیہ کے لیے مسابقتی پوائنٹس لاگ کو حسب ضرورت بنائیں",
  T_48_META_API_15_P0_D: "رپورٹ کیے جانے والے فیلڈ کے ناموں کی فہرست",
  T_48_META_API_15_P1_D: "رپورٹ کیے جانے والے فیلڈ ویلیوز کی فہرست",
  T_48_META_API_1500_D: "تین جہتی ویکٹر کا X جزو حاصل کریں۔",
  T_48_META_API_1500_P0_D: "3D ویکٹر",
  T_48_META_API_1500_R_D: "تین جہتی ویکٹر X جزو",
  T_48_META_API_1501_D: "تین جہتی ویکٹر کا Y جزو حاصل کریں۔",
  T_48_META_API_1501_P0_D: "3D ویکٹر",
  T_48_META_API_1501_R_D: "سہ جہتی ویکٹر Y جزو",
  T_48_META_API_1502_D: "تین جہتی ویکٹر کا Z جزو حاصل کریں۔",
  T_48_META_API_1502_P0_D: "3D ویکٹر",
  T_48_META_API_1502_R_D: "سہ جہتی ویکٹر Z جزو",
  T_48_META_API_1503_D: "تین جہتی ویکٹر کا X جزو سیٹ کرتا ہے۔",
  T_48_META_API_1503_P0_D: "3D ویکٹر",
  T_48_META_API_1503_P1_D: "ایکس جزو",
  T_48_META_API_1504_D: "تین جہتی ویکٹر کا Y جزو سیٹ کرتا ہے۔",
  T_48_META_API_1504_P0_D: "3D ویکٹر",
  T_48_META_API_1504_P1_D: "Y جزو",
  T_48_META_API_1505_D: "تین جہتی ویکٹر کا Z جزو سیٹ کرتا ہے۔",
  T_48_META_API_1505_P0_D: "3D ویکٹر",
  T_48_META_API_1505_P1_D: "Z جزو",
  T_48_META_API_1506_D: "دو تین جہتی ویکٹر شامل کریں۔",
  T_48_META_API_1506_P0_D: "لہذا",
  T_48_META_API_1506_P1_D: "لہذا",
  T_48_META_API_1506_R_D: "تین جہتی ویکٹر کے اضافے کا نتیجہ",
  T_48_META_API_1507_D: "دو تین جہتی ویکٹر کو گھٹائیں۔",
  T_48_META_API_1507_P0_D: "لہذا",
  T_48_META_API_1507_P1_D: "لہذا",
  T_48_META_API_1507_R_D: "تین جہتی ویکٹر کی lvalue سے rvalue کو گھٹانے کا نتیجہ",
  T_48_META_API_1508_D: "تین جہتی ویکٹر کی پیمائش کرنا",
  T_48_META_API_1508_P0_D: "3D ویکٹر کی پیمائش کی جائے گی۔",
  T_48_META_API_1508_P1_D: "3D ویکٹر اسکیلنگ کی رقم",
  T_48_META_API_1508_R_D: "3D ویکٹر اسکیلنگ کے نتائج",
  T_48_META_API_1509_D: "ڈاٹ پروڈکٹ دو تین جہتی ویکٹر، ڈاٹ پروڈکٹ کا نتیجہ ایک اسکیلر ہے۔",
  T_48_META_API_1509_P0_D: "لہذا",
  T_48_META_API_1509_P1_D: "لہذا",
  T_48_META_API_1509_R_D: "ڈاٹ ضرب کا نتیجہ",
  T_48_META_API_1510_D: "دو تین جہتی ویکٹروں کو کراس ضرب کا نتیجہ ایک ویکٹر ہے، اس جہاز کے لئے کھڑا ہے جہاں دو ویکٹر واقع ہیں۔",
  T_48_META_API_1510_P0_D: "لہذا",
  T_48_META_API_1510_P1_D: "لہذا",
  T_48_META_API_1510_R_D: "کراس پروڈکٹ کا نتیجہ، سمت ہوائی جہاز کی سیدھا ہے جہاں آپریشن میں شامل دو ویکٹر واقع ہیں۔",
  T_48_META_API_1511_D: "تین جہتی ویکٹر کو معمول بنائیں",
  T_48_META_API_1511_P0_D: "3D ویکٹر",
  T_48_META_API_1511_R_D: "ایک نیا نارملائزڈ ویکٹر لوٹاتا ہے۔ سڑنا کی لمبائی 1 ہے۔",
  T_48_META_API_1512_D: "ماڈیولو ایک تین جہتی ویکٹر",
  T_48_META_API_1512_P0_D: "3D ویکٹر",
  T_48_META_API_1512_R_D: "ماڈیولو نتیجہ ویکٹر ماڈیولس کی لمبائی ہے۔",
  T_48_META_API_1513_D: "دو تین جہتی ویکٹروں کے یوکلیڈین فاصلے کا حساب لگائیں۔",
  T_48_META_API_1513_P0_D: "لہذا",
  T_48_META_API_1513_P1_D: "لہذا",
  T_48_META_API_1513_R_D: "دو ویکٹر کو گھٹانے کے بعد، نتیجے میں آنے والے ویکٹر کے ماڈیول کی لمبائی",
  T_48_META_API_1514_D: "دو تین جہتی ویکٹروں کے درمیان زاویہ کا حساب لگائیں۔",
  T_48_META_API_1514_P0_D: "لہذا",
  T_48_META_API_1514_P1_D: "لہذا",
  T_48_META_API_1514_R_D: "ویکٹر زاویہ، زاویہ کی حد 0-180",
  T_48_META_API_1515_D: "ایک 3D ویکٹر بنائیں",
  T_48_META_API_1515_P0_D: "تین جہتی ویکٹر کا X جزو",
  T_48_META_API_1515_P1_D: "تین جہتی ویکٹر کا Y جزو",
  T_48_META_API_1515_P2_D: "تین جہتی ویکٹر کا Z جزو",
  T_48_META_API_1515_R_D: "تین جہتی ویکٹر بنایا",
  T_48_META_API_1516_D: "ایک نیا تعمیر شدہ سمت نقطہ حاصل کریں (فرسودہ، استعمال نہ کریں)",
  T_48_META_API_1516_P0_D: "مقام",
  T_48_META_API_1516_P1_D: "کی طرف",
  T_48_META_API_1516_R_D: "ڈائریکٹ پوائنٹ",
  T_48_META_API_1517_D: "سمت پوائنٹ پوزیشن حاصل کریں (متروک، براہ کرم استعمال نہ کریں)",
  T_48_META_API_1517_P0_D: "سمت نقطہ",
  T_48_META_API_1517_R_D: "پوزیشن",
  T_48_META_API_1518_D: "سمت نقطہ کی واقفیت حاصل کریں (متروک، براہ کرم استعمال نہ کریں)",
  T_48_META_API_1518_P0_D: "سمت نقطہ",
  T_48_META_API_1518_R_D: "آگے",
  T_48_META_API_1519_D: "ایک فہرست بنائیں",
  T_48_META_API_1519_P0_D: "فہرست کی ابتدائی لمبائی ابتدائی گنجائش سے کم یا اس کے برابر ہونی چاہیے۔",
  T_48_META_API_1519_P1_D: "فہرست کی ابتدائی گنجائش ابتدائی لمبائی سے زیادہ یا اس کے برابر ہونی چاہیے۔ صلاحیت کو متحرک طور پر بڑھایا جا سکتا ہے، لیکن یہ کارکردگی کی ایک خاص مقدار استعمال کرے گا جب تعمیر کرتے وقت مناسب قیمت مقرر کرنے کی سفارش کی جاتی ہے۔",
  T_48_META_API_1519_R_D: "فہرست بنائی",
  T_48_META_API_1520_D: "چیک کرتا ہے کہ آیا فہرست میں مخصوص عنصر شامل ہے۔",
  T_48_META_API_1520_P0_D: "ہدف کی فہرست",
  T_48_META_API_1520_P1_D: "چیک کرنے کے لیے مخصوص عنصر",
  T_48_META_API_1520_R_D: "آیا مخصوص عنصر کو شامل کرنا ہے۔",
  T_48_META_API_1521_D: "ہدف کی فہرست کے آخر میں متعدد عناصر کو شامل کریں۔",
  T_48_META_API_1521_P0_D: "ہدف کی فہرست",
  T_48_META_API_1521_P1_D: "فہرست شامل کریں",
  T_48_META_API_1522_D: "فہرست سے مخصوص عنصر کو ہٹاتا ہے۔",
  T_48_META_API_1522_P0_D: "ہدف کی فہرست",
  T_48_META_API_1522_P1_D: "ہٹانے کے لیے عنصر کی قدر",
  T_48_META_API_1523_D: "پوزیشن انڈیکس حاصل کریں جہاں فہرست میں عنصر پہلے ظاہر ہوتا ہے اگر فہرست میں کوئی ہدف عنصر نہیں ہے، تو -1 واپس آ جاتا ہے۔",
  T_48_META_API_1523_P0_D: "ہدف کی فہرست",
  T_48_META_API_1523_P1_D: "عنصر کی قدر",
  T_48_META_API_1523_R_D: "مقام انڈیکس",
  T_48_META_API_1524_D: "فہرست میں عنصر کی آخری موجودگی کا انڈیکس حاصل کرتا ہے اگر فہرست میں کوئی ہدف عنصر نہیں ہے، تو -1 لوٹایا جاتا ہے۔",
  T_48_META_API_1524_P0_D: "ہدف کی فہرست",
  T_48_META_API_1524_P1_D: "عنصر کی قدر",
  T_48_META_API_1524_R_D: "مقام انڈیکس",
  T_48_META_API_1525_D: "زاویہ کی سائن تلاش کریں۔",
  T_48_META_API_1525_P0_D: "زاویہ، 360 360 ڈگری کی نمائندگی کرتا ہے۔",
  T_48_META_API_1525_R_D: "سائن ویلیو",
  T_48_META_API_1526_D: "زاویہ کا کوزائن تلاش کریں۔",
  T_48_META_API_1526_P0_D: "زاویہ، 360 360 ڈگری کی نمائندگی کرتا ہے۔",
  T_48_META_API_1526_R_D: "کوزائن",
  T_48_META_API_1527_D: "زاویہ کا مماس تلاش کریں۔",
  T_48_META_API_1527_P0_D: "زاویہ، 360 360 ڈگری کی نمائندگی کرتا ہے۔",
  T_48_META_API_1527_R_D: "ٹینجنٹ",
  T_48_META_API_1528_D: "اعشاریہ 255 پر طے شدہ شفافیت کے ساتھ ایک کلر ویلیو بنائیں۔ پہلے ہر 8 بٹس کو ایک چینل کی نمائندگی کرتا ہے اور پھر بائنری نمبر کو Int32 قسم میں تبدیل کریں۔ اسے واپس کرو.",
  T_48_META_API_1528_P0_D: "رنگ کی سرخ چینل ویلیو، ویلیو رینج ہے [0,255] اگر یہ رینج سے زیادہ ہے، تو اسے قانونی قدر میں بند کر دیا جائے گا۔",
  T_48_META_API_1528_P1_D: "رنگ کی گرین چینل ویلیو، ویلیو رینج [0,255] ہے اگر یہ رینج سے زیادہ ہے تو اسے قانونی قدر کے ساتھ بند کر دیا جائے گا۔",
  T_48_META_API_1528_P2_D: "رنگ کی نیلی چینل ویلیو، ویلیو رینج [0,255] ہے اگر یہ رینج سے زیادہ ہے، تو اسے قانونی قدر میں بند کر دیا جائے گا۔",
  T_48_META_API_1528_R_D: "تعمیر شدہ رنگ کی قیمت",
  T_48_META_API_1529_D: "زاویہ حاصل کرنے کے لیے آرکسین آپریشن کریں۔",
  T_48_META_API_1529_P0_D: "آرکسین آپریشن کے لیے قدر، قدر کی حد ہے [-1,1]",
  T_48_META_API_1529_R_D: "زاویہ",
  T_48_META_API_1530_D: "زاویہ حاصل کرنے کے لیے آرک کوسائن آپریشن کریں۔",
  T_48_META_API_1530_P0_D: "آرک کوزائن آپریشن کی قدر، قدر کی حد [-1,1] ہے",
  T_48_META_API_1530_R_D: "زاویہ",
  T_48_META_API_1531_D: "زاویہ حاصل کرنے کے لیے آرکٹینجنٹ آپریشن کریں۔",
  T_48_META_API_1531_P0_D: "قدر جس پر آرکٹینجنٹ آپریشن کرنا ہے۔",
  T_48_META_API_1531_R_D: "زاویہ",
  T_48_META_API_1532_D: "اس بات کا تعین کریں کہ آیا ٹارگٹ ہستی مخصوص دائرہ کار کے اندر ہے اگر ہستی کے پاس پوزیشن کا انتساب نہیں ہے تو غلط کو واپس کر دیا جائے گا۔",
  T_48_META_API_1532_P0_D: "ہدف ہستی",
  T_48_META_API_1532_P1_D: "کرہ کے مرکز کی وضاحت کرتا ہے۔",
  T_48_META_API_1532_P2_D: "کرہ کا رداس بتاتا ہے۔",
  T_48_META_API_1532_R_D: "فیصلے کا نتیجہ",
  T_48_META_API_1533_D: "اس بات کا تعین کریں کہ آیا ٹارگٹ ہستی مخصوص سلنڈر رینج کے اندر ہے اگر ہستی کے پاس پوزیشن کا انتساب نہیں ہے تو غلط واپس کر دیا جائے گا۔",
  T_48_META_API_1533_P0_D: "ہدف ہستی",
  T_48_META_API_1533_P1_D: "سلنڈر کے سینٹر پوائنٹ کی وضاحت کرتا ہے۔",
  T_48_META_API_1533_P2_D: "سلنڈر کے کراس سیکشنل رداس کی وضاحت کرتا ہے۔",
  T_48_META_API_1533_P3_D: "سلنڈر کی اونچائی بتاتا ہے۔",
  T_48_META_API_1533_P4_D: "سینٹر پوائنٹ کے ارد گرد سلنڈر کی گردش کے تین جہتی یولر زاویہ کی وضاحت کرتا ہے",
  T_48_META_API_1533_R_D: "فیصلے کا نتیجہ",
  T_48_META_API_1534_D: "اس بات کا تعین کریں کہ آیا ہدف ہستی مخصوص کیوب رینج کے اندر ہے۔",
  T_48_META_API_1534_P0_D: "ہدف ہستی",
  T_48_META_API_1534_P1_D: "مکعب کا مرکز نقطہ بیان کرتا ہے۔",
  T_48_META_API_1534_P2_D: "مکعب کی لمبائی بتاتا ہے۔",
  T_48_META_API_1534_P3_D: "مکعب کی چوڑائی بتاتا ہے۔",
  T_48_META_API_1534_P4_D: "مکعب کی اونچائی بتاتا ہے۔",
  T_48_META_API_1534_P5_D: "مرکز نقطہ کے ارد گرد کیوب کے تین جہتی گردش Euler زاویہ کی وضاحت کرتا ہے",
  T_48_META_API_1534_R_D: "فیصلے کا نتیجہ",
  T_48_META_API_1535_D: "اس بات کا تعین کریں کہ آیا ہدف کا ادارہ مخصوص سیکٹر سلنڈر کی حد کے اندر ہے۔",
  T_48_META_API_1535_P0_D: "ہدف ہستی",
  T_48_META_API_1535_P1_D: "سیکٹر کے سائز کے سلنڈر کے وسط سیکشن کا مرکز بتاتا ہے۔",
  T_48_META_API_1535_P2_D: "سیکٹر کے سائز کے سلنڈر کے وسط سیکشن کا رداس بتاتا ہے۔",
  T_48_META_API_1535_P3_D: "سیکٹر کے سائز کے سلنڈر کا کراس سیکشن رداس جس کی جانچ نہیں کی گئی ہے، مرکز کے نقطہ کے ساتھ دائرے کے مرکز کے طور پر، چھوٹے سیکٹر کے سائز کے سلنڈر کے علاقے کی جانچ نہیں کی جائے گی، صرف مخصوص سیکٹر کے سائز کے سلنڈر اور کے درمیان فرق چھوٹے شعبے کی شکل والی تھی",
  T_48_META_API_1535_P4_D: "سیکٹر سلنڈر کی اونچائی بتاتا ہے۔",
  T_48_META_API_1535_P5_D: "پتہ لگانے کے لیے سیکٹر کے سائز کے سلنڈر کے سیکشن کا مرکزی زاویہ اگر یہ 360 سے زیادہ ہے، تو یہ 0 سے کم ہونے کی صورت میں پتہ لگایا جائے گا۔",
  T_48_META_API_1535_P6_D: "سینٹر پوائنٹ کے ارد گرد سیکٹر سلنڈر کی گردش کے تین جہتی یولر زاویہ کی وضاحت کرتا ہے",
  T_48_META_API_1535_R_D: "فیصلے کا نتیجہ",
  T_48_META_API_1536_D: "دو نمبروں کی قدروں کا موازنہ کرتا ہے اور بڑے کو لوٹاتا ہے۔",
  T_48_META_API_1536_P0_D: "لہذا",
  T_48_META_API_1536_P1_D: "لہذا",
  T_48_META_API_1536_R_D: "بڑی تعداد",
  T_48_META_API_1537_D: "فہرست میں زیادہ سے زیادہ قدر لوٹاتا ہے۔",
  T_48_META_API_1537_P0_D: "ہدف کی فہرست، صرف فہرست کے عنصر کی قسم کو بطور نمبر قبول کرتی ہے۔",
  T_48_META_API_1537_P1_D: "موازنہ کے نتائج اگر فہرست میں غیر ہندسے ہیں، تو موازنہ ناکام ہو جاتا ہے اور غلط ہو جاتا ہے۔",
  T_48_META_API_1537_P2_D: "اگر موازنہ کامیاب ہو جاتا ہے تو فہرست میں سب سے بڑی قدر لوٹاتا ہے، اور اگر موازنہ ناکام ہو جاتا ہے تو 0 لوٹاتا ہے۔",
  T_48_META_API_1538_D: "دو نمبروں کی قدروں کا موازنہ کرتا ہے اور چھوٹے کو لوٹاتا ہے۔",
  T_48_META_API_1538_P0_D: "لہذا",
  T_48_META_API_1538_P1_D: "لہذا",
  T_48_META_API_1538_R_D: "چھوٹی تعداد",
  T_48_META_API_1539_D: "فہرست میں کم از کم قدر لوٹاتا ہے۔",
  T_48_META_API_1539_P0_D: "ہدف کی فہرست، صرف فہرست کے عنصر کی قسم کو بطور نمبر قبول کرتی ہے۔",
  T_48_META_API_1539_P1_D: "موازنہ کے نتائج اگر فہرست میں غیر ہندسے ہیں، تو موازنہ ناکام ہو جاتا ہے اور غلط ہو جاتا ہے۔",
  T_48_META_API_1539_P2_D: "اگر موازنہ کامیاب ہو جاتا ہے تو فہرست میں سب سے چھوٹی قدر لوٹاتا ہے، اور اگر موازنہ ناکام ہو جاتا ہے تو 0 لوٹاتا ہے۔",
  T_48_META_API_1540_D: "لکیری انٹرپولیشن، ابتدائی قدر اور ہدف کی قدر کے درمیان انٹرپولیشن کی پیشرفت کے مطابق قدر لوٹاتا ہے، انٹرپولیشن گتانک [0,1]",
  T_48_META_API_1540_P0_D: "لکیری انٹرپولیشن کی ابتدائی قدر اس وقت لوٹائی جاتی ہے جب انٹرپولیشن کی پیشرفت 0 ہوتی ہے۔",
  T_48_META_API_1540_P1_D: "لکیری انٹرپولیشن ٹارگٹ ویلیو، یہ قدر اس وقت لوٹائی جاتی ہے جب انٹرپولیشن پروگریس 1 ہو۔",
  T_48_META_API_1540_P2_D: "انٹرپولیشن پروگریس، ویلیو رینج [0,1]، جب ویلیو 0 ہوتی ہے، تو اسٹارٹ ویلیو واپس کی جاتی ہے، جب ویلیو 1 ہوتی ہے، ٹارگٹ ویلیو واپس کی جاتی ہے، جب ویلیو 0.5 ہوتی ہے، تو اسٹارٹ ویلیو کی اوسط اور ہدف قدر واپس آ جاتی ہے۔",
  T_48_META_API_1540_R_D: "لکیری انٹرپولیشن ریٹرن ویلیو",
  T_48_META_API_1541_D: "ہدف کی قدر کی حد کو محدود کریں اور تین ان پٹ پیرامیٹرز میں سے درمیانی قدر حاصل کریں؛ اگر ہدف کی قدر کم از کم قدر سے کم ہے تو اسے واپس کر دیا جائے گا۔ ہدف کی قدر زیادہ سے زیادہ قدر سے بڑی ہے، حد میں ہونے پر زیادہ سے زیادہ قدر واپس آ جائے گی۔",
  T_48_META_API_1541_P0_D: "ہدف کی قیمت",
  T_48_META_API_1541_P1_D: "محدود رینج کی کم از کم قدر",
  T_48_META_API_1541_P2_D: "محدود رینج کی زیادہ سے زیادہ قدر",
  T_48_META_API_1541_R_D: "پابندی کے بعد قیمت واپس کریں۔",
  T_48_META_API_1542_D: "ٹارگٹ کلر کی چینل ویلیوز حاصل کریں۔",
  T_48_META_API_1542_P0_D: "ہدف کا رنگ",
  T_48_META_API_1542_P1_D: "رنگ کی قدر، حد [0، 255]",
  T_48_META_API_1542_P2_D: "رنگ کی G قدر، حد [0، 255]",
  T_48_META_API_1542_P3_D: "رنگ کی بی قدر، حد [0، 255]",
  T_48_META_API_1542_P4_D: "رنگ کی قدر، حد [0، 255]",
  T_48_META_API_1543_D: "وضاحت",
  T_48_META_API_1543_P0_D: "بنیادی عدد",
  T_48_META_API_1543_P1_D: "انڈیکس",
  T_48_META_API_1543_R_D: "حساب کا نتیجہ",
  T_48_META_API_1544_D: "لوگاریتھمک آپریشنز",
  T_48_META_API_1544_P0_D: "بنیادی عدد",
  T_48_META_API_1544_P1_D: "حقیقی نمبر",
  T_48_META_API_1544_R_D: "حساب کا نتیجہ",
  T_48_META_API_1545_D: "ڈائریکشن ویکٹر سے یولر زاویہ",
  T_48_META_API_1545_P0_D: "سمت ویکٹر",
  T_48_META_API_1545_R_D: "یولر زاویہ",
  T_48_META_API_1546_D: "یولر زاویہ گردش سمت ویکٹر",
  T_48_META_API_1546_P0_D: "یولر زاویہ",
  T_48_META_API_1546_R_D: "سمت ویکٹر",
  T_48_META_API_1547_D: "فلوٹنگ پوائنٹ نمبر سے انٹیجر",
  T_48_META_API_1547_P0_D: "عدد",
  T_48_META_API_1547_R_D: "فلوٹنگ پوائنٹ نمبر",
  T_48_META_API_1548_D: "ٹارگٹ ویکٹر کو quaternion کے مطابق گھمائیں۔",
  T_48_META_API_1548_P0_D: "ہدف ویکٹر",
  T_48_META_API_1548_P1_D: "Quaternion کو گھمائیں۔",
  T_48_META_API_1548_R_D: "گھمایا ہوا ویکٹر",
  T_48_META_API_1549_D: "ٹارگٹ نمبر کو سٹرنگ میں تبدیل کریں۔",
  T_48_META_API_1549_P0_D: "ٹارگٹ نمبر جس کو سٹرنگ میں تبدیل کیا جانا ہے۔",
  T_48_META_API_1549_P1_D: "آؤٹ پٹ عددی سٹرنگ فارمیٹ",
  T_48_META_API_1549_R_D: "تار",
  T_48_META_API_1598_D: "سرور ٹائم اسٹیمپ حاصل کریں۔",
  T_48_META_API_1598_R_D: "1 جنوری 1970 کو 0:00:00 سے سیکنڈز کی تعداد لوٹاتا ہے۔",
  T_48_META_API_1599_D: "سرور ایریا حاصل کریں۔",
  T_48_META_API_1599_R_D: "خطے کا مخفف لوٹاتا ہے (BR, SAC, ID, NA, US, IND, SG, BD, VN, TH, ME, RU, EU, PK, TW)",
  T_48_META_API_16_D: "صارف کے تجربے کے ڈیٹا کے تجزیہ کے لیے حسب ضرورت صارف ٹریکنگ لاگز",
  T_48_META_API_16_P0_D: "کھلاڑیوں کی اطلاع دی جائے۔",
  T_48_META_API_16_P1_D: "رپورٹ کیے جانے والے فیلڈ کے ناموں کی فہرست",
  T_48_META_API_16_P2_D: "رپورٹ کیے جانے والے فیلڈ ویلیوز کی فہرست",
  T_48_META_API_1601_D: "ایک لغت بنائیں",
  T_48_META_API_1601_R_D: "ڈکشنری بنائی",
  T_48_META_API_1602_D: "لغت میں مخصوص کلید کے مطابق قدر حاصل کریں۔",
  T_48_META_API_1602_P0_D: "ہدف کی لغت",
  T_48_META_API_1602_P1_D: "کلید",
  T_48_META_API_1602_R_D: "قیمت",
  T_48_META_API_1603_D: "لغت میں مخصوص کلید کے مطابق قدر سیٹ کرتا ہے۔",
  T_48_META_API_1603_P0_D: "ہدف کی لغت",
  T_48_META_API_1603_P1_D: "کلید",
  T_48_META_API_1603_P2_D: "قیمت",
  T_48_META_API_1604_D: "لغت سے مخصوص کلیدی قدر کے جوڑے کو ہٹا دیں۔",
  T_48_META_API_1604_P0_D: "ہدف کی لغت",
  T_48_META_API_1604_P1_D: "کلید",
  T_48_META_API_1605_D: "ڈکشنری میں کلیدی قدر کے تمام جوڑوں کو صاف کریں۔",
  T_48_META_API_1605_P0_D: "ہدف کی لغت",
  T_48_META_API_1606_D: "لغت میں کلیدی قدر کے جوڑوں کی تعداد حاصل کریں۔",
  T_48_META_API_1606_P0_D: "ہدف کی لغت",
  T_48_META_API_1606_R_D: "لغت کی لمبائی",
  T_48_META_API_1607_D: "اس بات کا تعین کریں کہ آیا لغت میں کلید موجود ہے۔",
  T_48_META_API_1607_P0_D: "ہدف کی لغت",
  T_48_META_API_1607_P1_D: "کلید",
  T_48_META_API_1607_R_D: "کیا موجود ہے",
  T_48_META_API_1608_D: "لغت کی تمام چابیاں حاصل کرتا ہے، ایک فہرست کے طور پر واپس آیا",
  T_48_META_API_1608_P0_D: "ہدف کی لغت",
  T_48_META_API_1608_R_D: "تمام کلیدی اقدار کی فہرست",
  T_48_META_API_17_D: "پتہ لگانے کے لیے لکیری حرکت کا ایک باکس کے سائز کا علاقہ استعمال کریں، اور قریب سے دور تک باکس کی شکل والے علاقے کے راستے پر آنے والے تمام اداروں کو واپس کریں، اگر وہ باکس کے سائز کی حد کے اندر ہیں، تو ان کا پتہ نہیں چل سکے گا۔ .",
  T_48_META_API_17_P0_D: "باکس کے علاقے کے تین اطراف کی نصف لمبائی، صرف مثبت اقدار کو قبول کیا جاتا ہے",
  T_48_META_API_17_P1_D: "باکس ایریا کا مرکز نقطہ",
  T_48_META_API_17_P2_D: "باکس کے علاقے کی گردش",
  T_48_META_API_17_P3_D: "باکس ایریا سفر کی سمت",
  T_48_META_API_17_P4_D: "باکس کے علاقے کے سفر کا فاصلہ، صرف مثبت اقدار کو قبول کیا جاتا ہے",
  T_48_META_API_17_P5_D: "پرتوں کا ماسک، صرف بھری ہوئی پرتیں اسکین میں حصہ لیں گی، خالی چھوڑنے کا مطلب ہے کہ تمام پرتیں اسکین میں حصہ لیں گی۔",
  T_48_META_API_17_P6_D: "کیا محرکات کا پتہ لگانا ممکن ہے؟",
  T_48_META_API_17_P7_D: "متاثرہ اداروں کی فہرست",
  T_48_META_API_1700_D: "مخصوص سٹرنگ کو ایک عدد میں تبدیل کریں۔",
  T_48_META_API_1700_P0_D: "ہدف کی تار",
  T_48_META_API_1700_P1_D: "نتیجہ کا عدد",
  T_48_META_API_1700_P2_D: "کیا تبدیلی کامیاب ہے؟",
  T_48_META_API_1701_D: "مخصوص سٹرنگ کو فلوٹنگ پوائنٹ نمبر میں تبدیل کریں۔",
  T_48_META_API_1701_P0_D: "ہدف کی تار",
  T_48_META_API_1701_P1_D: "نتیجہ فلوٹ",
  T_48_META_API_1701_P2_D: "کیا تبدیلی کامیاب ہے؟",
  T_48_META_API_18_D: "پتہ لگانے کے لیے ایک سیدھی لائن حرکت پذیر کروی علاقے کا استعمال کریں، اور کروی علاقے کے راستے پر قریب سے دور تک آنے والی تمام ہستیوں کو واپس کریں، اگر وہ کروی علاقے کے اندر ہیں، تو ان کا پتہ نہیں چل سکے گا۔",
  T_48_META_API_18_P0_D: "کروی علاقے کے رداس، صرف مثبت اقدار کو قبول کیا جاتا ہے",
  T_48_META_API_18_P1_D: "کروی علاقے کا مرکز نقطہ",
  T_48_META_API_18_P2_D: "کروی علاقے کے سفر کی سمت",
  T_48_META_API_18_P3_D: "کروی علاقے سے طے شدہ فاصلہ، صرف مثبت اقدار کو قبول کیا جاتا ہے۔",
  T_48_META_API_18_P4_D: "پرتوں کا ماسک، صرف بھری ہوئی پرتیں اسکین میں حصہ لیں گی، خالی چھوڑنے کا مطلب ہے کہ تمام پرتیں اسکین میں حصہ لیں گی۔",
  T_48_META_API_18_P5_D: "کیا محرکات کا پتہ لگانا ممکن ہے؟",
  T_48_META_API_18_P6_D: "متاثرہ اداروں کی فہرست",
  T_48_META_API_19_D: "پتہ لگانے کے لیے ایک لکیری حرکت پذیر کیپسول ایریا کا استعمال کریں، اور کیپسول ایریا کے راستے پر آنے والی تمام ہستیوں کو واپس کر دیں، ابتدائی طور پر، اگر وہ کیپسول کے علاقے میں ہیں، تو ان کا پتہ نہیں چل سکے گا۔",
  T_48_META_API_19_P0_D: "کیپسول کے علاقے کے دونوں سروں پر نصف کرہ کا رداس، صرف مثبت اقدار کو قبول کیا جاتا ہے",
  T_48_META_API_19_P1_D: "کیپسول ایریا کے دونوں سروں پر نصف کرہ کے مراکز کے درمیان فاصلہ یہ قدر دونوں سروں پر نصف کرہ کے رداس سے دوگنا زیادہ ہونا چاہیے۔",
  T_48_META_API_19_P2_D: "کیپسول کے علاقے کا مرکز نقطہ",
  T_48_META_API_19_P3_D: "کیپسول کے علاقے کی گردش",
  T_48_META_API_19_P4_D: "کیپسول کے علاقے کے سفر کی سمت",
  T_48_META_API_19_P5_D: "کیپسل کے علاقے میں سفر شدہ فاصلہ، صرف مثبت قیمات کو قبول کیا جاتا ہے۔",
  T_48_META_API_19_P6_D: "پرتوں کا ماسک، صرف بھری ہوئی پرتیں اسکین میں حصہ لیں گی، خالی چھوڑنے کا مطلب ہے کہ تمام پرتیں اسکین میں حصہ لیں گی۔",
  T_48_META_API_19_P7_D: "کیا محرکات کا پتہ لگانا ممکن ہے؟",
  T_48_META_API_19_P8_D: "متاثرہ اداروں کی فہرست",
  T_48_META_API_2_D: "موجودہ کھیل میں تمام ٹیموں کو حاصل کریں اور ٹیم کی فہرست میں واپس جائیں۔",
  T_48_META_API_2_R_D: "ٹیم کی فہرست",
  T_48_META_API_20_D: "پتہ لگانے کے لیے ایک اسٹیشنری باکس کے سائز کا علاقہ استعمال کریں اور باکس کی شکل والے علاقے کے اندر موجود تمام اداروں کو واپس کریں۔",
  T_48_META_API_20_P0_D: "باکس کے علاقے کے تین اطراف کی نصف لمبائی، صرف مثبت اقدار کو قبول کیا جاتا ہے",
  T_48_META_API_20_P1_D: "باکس ایریا کا مرکز نقطہ",
  T_48_META_API_20_P2_D: "باکس کے علاقے کی گردش",
  T_48_META_API_20_P3_D: "پرتوں کا ماسک، صرف بھری ہوئی پرتیں اسکین میں حصہ لیں گی، خالی چھوڑنے کا مطلب ہے کہ تمام پرتیں اسکین میں حصہ لیں گی۔",
  T_48_META_API_20_P4_D: "کیا محرکات کا پتہ لگانا ممکن ہے؟",
  T_48_META_API_20_P5_D: "متاثرہ اداروں کی فہرست",
  T_48_META_API_2000_D: "ہدف کی ہستی کی انتساب کی قدر متعین کریں، جس کے لیے ضروری ہے کہ وصف کی وضاحت کی گئی ہو۔",
  T_48_META_API_2000_P0_D: "ہدف ہستی",
  T_48_META_API_2000_P1_D: "ہدف والے ادارے کی ایک خصوصیت",
  T_48_META_API_2000_P2_D: "جب انتساب کی وضاحت کی جاتی ہے تو ہدف کی قدر کو مطلوبہ قسم کے مطابق ہونا ضروری ہے۔",
  T_48_META_API_2000_P3_D: "آپریشن موڈ، تمام اقسام معاون تفویض، اور عددی قسمیں بھی خود کے اضافے، خود گھٹاؤ، خود ضرب، خود تقسیم، اور خود باقی رہنے کی حمایت کرتی ہیں۔",
  T_48_META_API_2001_D: "کسی ہستی کی خصوصیت کی قدر حاصل کریں۔",
  T_48_META_API_2001_P0_D: "ہدف ہستی",
  T_48_META_API_2001_P1_D: "ہستی کی ایک انتساب ID",
  T_48_META_API_2001_R_D: "خصوصیت کی قدر",
  T_48_META_API_2002: "Set Graph Property",
  T_48_META_API_2002_D: "اسکرپٹ متغیرات مرتب کریں۔",
  T_48_META_API_2002_P0_D: "ہدف ہستی",
  T_48_META_API_2002_P1: "Graph ID",
  T_48_META_API_2002_P1_D: "ٹارگٹ اسکرپٹ ID",
  T_48_META_API_2002_P2: "Property ID",
  T_48_META_API_2002_P2_D: "اسکرپٹ میں بیان کردہ ممبر انتساب ID",
  T_48_META_API_2002_P3: "Property Value",
  T_48_META_API_2002_P3_D: "جب انتساب کی وضاحت کی جاتی ہے تو ہدف کی قدر کو مطلوبہ قسم کے مطابق ہونا ضروری ہے۔",
  T_48_META_API_2002_P4_D: "آپریشن موڈ، تمام اقسام معاون تفویض، اور عددی قسمیں بھی خود کے اضافے، خود گھٹاؤ، خود ضرب، خود تقسیم، اور خود باقی رہنے کی حمایت کرتی ہیں۔",
  T_48_META_API_2003: "Get Graph Property",
  T_48_META_API_2003_D: "اسکرپٹ متغیرات حاصل کریں۔",
  T_48_META_API_2003_P0_D: "ہدف ہستی",
  T_48_META_API_2003_P1: "Graph ID",
  T_48_META_API_2003_P1_D: "ٹارگٹ اسکرپٹ ID",
  T_48_META_API_2003_P2: "Property ID",
  T_48_META_API_2003_P2_D: "ٹارگٹ ایٹریبیوٹ ID",
  T_48_META_API_2003_R_D: "خصوصیت کی قدر",
  T_48_META_API_2004_D: "مقامی متغیر کی وضاحت کریں اور شروع کریں مقامی متغیر کا دائرہ بیان کے بلاک کے اختتام تک ہے۔",
  T_48_META_API_2004_P0_D: "متغیر نام",
  T_48_META_API_2004_P1_D: "متغیر ابتدائی قدر",
  T_48_META_API_2004_P2_D: "متغیر اعلامیہ کی قسم کو ایک قدر تفویض کرتے وقت، اسے اعلان کردہ قسم کے مطابق ہونا ضروری ہے۔",
  T_48_META_API_2005_D: "مقامی متغیر کی قدر مقرر کریں ایک مقامی متغیر کا دائرہ بیان کے بلاک کے اختتام تک ہے۔",
  T_48_META_API_2005_P0_D: "متغیر نام",
  T_48_META_API_2005_P1: "Variable Value",
  T_48_META_API_2005_P1_D: "متغیر قدر",
  T_48_META_API_2005_P2_D: "آپریشن موڈ، تمام اقسام معاون تفویض، اور عددی قسمیں بھی خود کے اضافے، خود گھٹاؤ، خود ضرب، خود تقسیم، اور خود باقی رہنے کی حمایت کرتی ہیں۔",
  T_48_META_API_2006: "Get Local Variable",
  T_48_META_API_2006_D: "مقامی متغیر کی قدر حاصل کریں ایک مقامی متغیر کا دائرہ بیان کے بلاک کے اختتام تک ہے۔",
  T_48_META_API_2006_P0: "Variable Name",
  T_48_META_API_2006_P0_D: "متغیر نام",
  T_48_META_API_2006_R_D: "متغیر قدر",
  T_48_META_API_2009: "Find and Invoke Global Custom API with Serial",
  T_48_META_API_2009_D: "عالمی کسٹم فنکشن کو سیریل طریقے سے کال کریں اگر کسٹم فنکشن میں انتظار ہے تو کال کرنے کا مقام بھی انتظار کرے گا۔",
  T_48_META_API_2009_P0: "Graph ID",
  T_48_META_API_2009_P0_D: "اسکرپٹ ID جہاں کسٹم فنکشن واقع ہے۔",
  T_48_META_API_2009_P1: "Function ID",
  T_48_META_API_2009_P1_D: "کسٹم فنکشن ID کو بلایا گیا۔",
  T_48_META_API_2009_P2_D: "حسب ضرورت فنکشن کو بھیجے گئے پیرامیٹرز کی فہرست",
  T_48_META_API_2010: "Find and Invoke Global Custom API with Parallel",
  T_48_META_API_2010_D: "عالمی کسٹم فنکشن کو متوازی طور پر کال کریں۔",
  T_48_META_API_2010_P0: "Graph ID",
  T_48_META_API_2010_P0_D: "اسکرپٹ ID جہاں کسٹم فنکشن واقع ہے۔",
  T_48_META_API_2010_P1: "Function ID",
  T_48_META_API_2010_P1_D: "کسٹم فنکشن ID کو بلایا گیا۔",
  T_48_META_API_2010_P2_D: "حسب ضرورت فنکشن کو بھیجے گئے پیرامیٹرز کی فہرست",
  T_48_META_API_2013: "Set Self Graph Property",
  T_48_META_API_2013_D: "موجودہ اسکرپٹ کے لیے متغیرات مرتب کریں۔",
  T_48_META_API_2013_P0: "Property ID",
  T_48_META_API_2013_P0_D: "ٹارگٹ ایٹریبیوٹ ID",
  T_48_META_API_2013_P1: "Property Value",
  T_48_META_API_2013_P1_D: "ہدف کی قیمت",
  T_48_META_API_2013_P2_D: "آپریشن موڈ، تمام اقسام معاون تفویض، اور عددی قسمیں بھی خود کے اضافے، خود گھٹاؤ، خود ضرب، خود تقسیم، اور خود باقی رہنے کی حمایت کرتی ہیں۔",
  T_48_META_API_2014: "Get Self Graph Property",
  T_48_META_API_2014_D: "موجودہ اسکرپٹ کے متغیرات حاصل کریں۔",
  T_48_META_API_2014_P0: "Property ID",
  T_48_META_API_2014_P0_D: "ٹارگٹ ایٹریبیوٹ ID",
  T_48_META_API_2014_R_D: "خصوصیت کی قدر",
  T_48_META_API_21_D: "پتہ لگانے کے لیے ایک اسٹیشنری کروی علاقہ استعمال کریں اور کروی علاقے کے اندر موجود تمام اداروں کو واپس کریں۔",
  T_48_META_API_21_P0_D: "کروی علاقے کے رداس، صرف مثبت اقدار کو قبول کیا جاتا ہے",
  T_48_META_API_21_P1_D: "کروی علاقے کا مرکز نقطہ",
  T_48_META_API_21_P2_D: "پرتوں کا ماسک، صرف بھری ہوئی پرتیں اسکین میں حصہ لیں گی، خالی چھوڑنے کا مطلب ہے کہ تمام پرتیں اسکین میں حصہ لیں گی۔",
  T_48_META_API_21_P3_D: "کیا محرکات کا پتہ لگانا ممکن ہے؟",
  T_48_META_API_21_P4_D: "متاثرہ اداروں کی فہرست",
  T_48_META_API_22_D: "پتہ لگانے کے لیے اسٹیشنری کیپسول ایریا کا استعمال کریں اور کیپسول ایریا کے اندر موجود تمام اداروں کو واپس کریں۔",
  T_48_META_API_22_P0_D: "کیپسول کے علاقے کے دونوں سروں پر نصف کرہ کا رداس، صرف مثبت اقدار کو قبول کیا جاتا ہے",
  T_48_META_API_22_P1_D: "کیپسول ایریا کے دونوں سروں پر نصف کرہ کے مراکز کے درمیان فاصلہ یہ قدر دونوں سروں پر نصف کرہ کے رداس سے دوگنا زیادہ ہونا چاہیے۔",
  T_48_META_API_22_P2_D: "کیپسول کے علاقے کا مرکز نقطہ",
  T_48_META_API_22_P3_D: "کیپسول کے علاقے کی گردش",
  T_48_META_API_22_P4_D: "پرتوں کا ماسک، صرف بھری ہوئی پرتیں اسکین میں حصہ لیں گی، خالی چھوڑنے کا مطلب ہے کہ تمام پرتیں اسکین میں حصہ لیں گی۔",
  T_48_META_API_22_P5_D: "کیا محرکات کا پتہ لگانا ممکن ہے؟",
  T_48_META_API_22_P6_D: "متاثرہ اداروں کی فہرست",
  T_48_META_API_23_D: "کھلاڑی کے لیے خصوصی آئٹم کی حیثیت سیٹ کریں آپ کے پاس صرف ایک خاص آئٹم ہو سکتا ہے۔",
  T_48_META_API_23_P0_D: "کھلاڑی",
  T_48_META_API_23_P1_D: "آئٹم کی شناخت",
  T_48_META_API_23_P2_D: "آیا اس آئٹم کو فعال کرنا ہے۔",
  T_48_META_API_23_P3_D: "خصوصی آئٹم ہستی",
  T_48_META_API_24_D: "ہدف پر ایک قوت لگائیں، جو کہ ایک جسمانی چیز ہونی چاہیے۔",
  T_48_META_API_24_P0_D: "جسمانی شے کو نشانہ بنائیں",
  T_48_META_API_24_P1_D: "قوت ویکٹر",
  T_48_META_API_24_P2_D: "طاقت کی قسم",
  T_48_META_API_25_D: "کسی خاص مقام پر ایک بار طاقت لگائیں، ہدف ایک سخت جسم ہونا چاہیے۔",
  T_48_META_API_25_P0_D: "ہدف سخت جسم",
  T_48_META_API_25_P1_D: "قوت ویکٹر",
  T_48_META_API_25_P2_D: "زبردستی درخواست کی پوزیشن",
  T_48_META_API_25_P3_D: "طاقت کی قسم",
  T_48_META_API_26_D: "ہدف پر ٹارک لگائیں، جس کا جسم سخت ہونا چاہیے۔",
  T_48_META_API_26_P0_D: "ہدف سخت جسم",
  T_48_META_API_26_P1_D: "ٹارک",
  T_48_META_API_26_P2_D: "فورس کی قسم",
  T_48_META_API_27_D: "ہدف کے سخت جسم کو مخصوص پوزیشن پر منتقل کریں۔",
  T_48_META_API_27_P0_D: "ہدف سخت جسم",
  T_48_META_API_27_P1_D: "مقام کی وضاحت کریں۔",
  T_48_META_API_28_D: "ہدف کے سخت جسم کو گھمائیں۔",
  T_48_META_API_28_P0_D: "ہدف سخت جسم",
  T_48_META_API_28_P1_D: "Quaternion کو گھمائیں۔",
  T_48_META_API_29_D: "انٹرپولیٹڈ موشن بنائیں، اور ٹارگٹ ہستی کی مخصوص صفات سیٹنگز کے مطابق آسانی سے حرکت کریں گی۔",
  T_48_META_API_29_P0_D: "ہدف ہستی",
  T_48_META_API_29_P1_D: "انتساب ID جسے تبدیل کرنے کی ضرورت ہے۔",
  T_48_META_API_29_P2_D: "انتساب شروع ہونے والی قدر",
  T_48_META_API_29_P3_D: "انتساب اختتامی قدر",
  T_48_META_API_29_P4_D: `آپ سنگل، سائیکل اور ری سیپروکیٹنگ میں سے انتخاب کر سکتے ہیں۔ 
لوپ کا مطلب ہے کہ ہر حرکت مکمل ہونے کے بعد، ہستی دوبارہ شروع ہونے والی قدر سے منتقل ہو جائے گی۔ Reciprocation کا مطلب یہ ہے کہ سٹارٹنگ ویلیو سے ٹارگٹ ویلیو تک حرکت مکمل ہونے کے بعد، ہستی ہدف ک`,
  T_48_META_API_29_P5_D: "بیزیئر وکر کنٹرول پوائنٹس",
  T_48_META_API_29_P6_D: "تبدیلی کا دورانیہ، ملی سیکنڈ میں",
  T_48_META_API_29_P7_D: "انٹرپولیٹڈ موشن ہستی بنائی",
  T_48_META_API_29_P8_D: "آیا تخلیق کے بعد خود بخود چلنا شروع کیا جائے۔",
  T_48_META_API_3_D: "کھیل کو ہدف کے مرحلے میں تبدیل کریں، اور راؤنڈ بھی ایک خاص مرحلہ ہے۔ موڑ کے اندر کسی مرحلے پر سوئچ کرتے وقت، موڑ کی گنتی 0 ہوتی ہے۔",
  T_48_META_API_3_P0_D: "ہدف کے گول یا مرحلے کا اشاریہ",
  T_48_META_API_30_D: "ہدف والے کھلاڑی کو مقرر کردہ گاڑی میں داخل ہونے پر مجبور کریں۔",
  T_48_META_API_30_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_30_P1_D: "گاڑی کا ادارہ",
  T_48_META_API_30_P2_D: "سیٹ نمبر",
  T_48_META_API_30_P3_D: "آیا کھلاڑی کو کامیابی کے ساتھ گاڑی میں داخل ہونے کی اجازت ہے۔",
  T_48_META_API_3001_D: "ہدف والے کھلاڑی کو اشیاء چھوڑنے کا سبب بنتا ہے۔",
  T_48_META_API_3001_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3001_P1_D: "آئٹم ہستی",
  T_48_META_API_3002_D: "فی الحال دستیاب رینڈم اسپن پوائنٹ کے اندر دستیاب نقاط حاصل کریں جو مکمل طور پر قابض نہیں ہے (متروک، براہ کرم GetRandomSpawnPosition استعمال کریں)",
  T_48_META_API_3002_P0_D: "وہ کھلاڑی جنہیں سپون ایریا تفویض کرنے کی ضرورت ہے۔",
  T_48_META_API_3002_R_D: "بے ترتیب طور پر تفویض کردہ بے ترتیب پوائنٹ کوآرڈینیٹ",
  T_48_META_API_3003_D: "کھلاڑی کے مخصوص پوائنٹ کی قسم کے کل پوائنٹس کی قیمت حاصل کریں۔",
  T_48_META_API_3003_P0_D: "کھلاڑی",
  T_48_META_API_3003_P1_D: "پوائنٹ کی قسم",
  T_48_META_API_3003_R_D: "پوائنٹس کی قدر",
  T_48_META_API_3004_D: "کھلاڑی کے مخصوص پوائنٹ کی قسم کے لیے راؤنڈ پوائنٹ ویلیو سیٹ کریں۔",
  T_48_META_API_3004_P0_D: "کھلاڑی ہستی",
  T_48_META_API_3004_P1_D: "پوائنٹ کی قسم",
  T_48_META_API_3004_P2_D: "پوائنٹس کی قدر",
  T_48_META_API_3005_D: "ٹیم کے لیے مخصوص پوائنٹ کی قسم کی کل پوائنٹس کی قیمت حاصل کریں۔",
  T_48_META_API_3005_P0_D: "ٹیم ہستی",
  T_48_META_API_3005_P1_D: "پوائنٹ کی قسم",
  T_48_META_API_3005_R_D: "پوائنٹس کی قدر",
  T_48_META_API_3006_D: "ٹیم کے مخصوص پوائنٹ کی قسم کے لیے راؤنڈ پوائنٹ ویلیو سیٹ کریں۔",
  T_48_META_API_3006_P0_D: "ٹیم ہستی",
  T_48_META_API_3006_P1_D: "پوائنٹ کی قسم",
  T_48_META_API_3006_P2_D: "پوائنٹس کی قدر",
  T_48_META_API_3007_D: "مخصوص راؤنڈ اور پوائنٹ کی قسم کے لیے کھلاڑی کے پوائنٹس حاصل کریں۔",
  T_48_META_API_3007_P0_D: "کھلاڑی ہستی",
  T_48_META_API_3007_P1_D: "گول انڈیکس",
  T_48_META_API_3007_P2_D: "پوائنٹ کی قسم",
  T_48_META_API_3007_R_D: "پوائنٹس کی قدر",
  T_48_META_API_3008_D: "مخصوص راؤنڈ اور پوائنٹ کی قسم کے لیے ٹیم کے پوائنٹس حاصل کریں۔",
  T_48_META_API_3008_P0_D: "ٹیم ہستی",
  T_48_META_API_3008_P1_D: "گول انڈیکس",
  T_48_META_API_3008_P2_D: "پوائنٹ کی قسم",
  T_48_META_API_3008_R_D: "پوائنٹس کی قدر",
  T_48_META_API_3009_D: "کھلاڑی کی کل گیم رینکنگ حاصل کریں۔",
  T_48_META_API_3009_P0_D: "کھلاڑی ہستی",
  T_48_META_API_3009_R_D: "درجہ بندی",
  T_48_META_API_3011_D: "ٹیم کے کھیل کی مجموعی درجہ بندی حاصل کریں۔",
  T_48_META_API_3011_P0_D: "فرسودہ",
  T_48_META_API_3011_R_D: "درجہ بندی",
  T_48_META_API_3013_D: "کھلاڑی کی مخصوص راؤنڈ رینکنگ حاصل کریں۔",
  T_48_META_API_3013_P0_D: "کھلاڑی ہستی",
  T_48_META_API_3013_P1_D: "گول انڈیکس",
  T_48_META_API_3013_R_D: "درجہ بندی",
  T_48_META_API_3014_D: "ٹیم کی نامزد راؤنڈ رینکنگ حاصل کریں۔",
  T_48_META_API_3014_P0_D: "فرسودہ",
  T_48_META_API_3014_P1_D: "گول انڈیکس",
  T_48_META_API_3014_R_D: "درجہ بندی",
  T_48_META_API_3015_D: "ہدف والے ادارے کا پرس حاصل کریں۔",
  T_48_META_API_3015_P0_D: "ہدف ہستی",
  T_48_META_API_3015_P1_D: "کیا پرس موجود ہے؟",
  T_48_META_API_3015_P2_D: "پرس کی ہستی حاصل کی گئی۔",
  T_48_META_API_3016_D: "ٹارگٹ پلیئر کے لیے ایک پرس بنائیں اگر کھلاڑی کے پاس پہلے سے پرس ہے تو یہ غلط ہو جائے گا۔",
  T_48_META_API_3016_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3016_P1_D: "پرس کا پابند ہستی، پرس کا مالک",
  T_48_META_API_3016_P2_D: "پرس ہستی",
  T_48_META_API_3017_D: "مخصوص والیٹ میں کرنسی شامل کریں۔",
  T_48_META_API_3017_P0_D: "ہدف پرس",
  T_48_META_API_3017_P1_D: "شامل کرنسی کی اقسام",
  T_48_META_API_3017_P2_D: "کرنسی کی رقم میں اضافہ",
  T_48_META_API_3018_D: "مخصوص بٹوے کے لیے کرنسی کم کریں۔",
  T_48_META_API_3018_P0_D: "ہدف پرس",
  T_48_META_API_3018_P1_D: "کم شدہ کرنسی کی اقسام",
  T_48_META_API_3018_P2_D: "رقم کی کمی",
  T_48_META_API_3019_D: "ایک بٹوے سے دوسرے میں کرنسی منتقل کریں۔",
  T_48_META_API_3019_P0_D: "سے کرنسی کی منتقلی کے لیے والیٹ",
  T_48_META_API_3019_P1_D: "کرنسی کی منتقلی کی قسم",
  T_48_META_API_3019_P2_D: "کرنسی کی منتقلی کی رقم",
  T_48_META_API_3019_P3_D: "کرنسی کی منتقلی کے لیے والیٹ",
  T_48_META_API_3020_D: "مخصوص والیٹ میں مخصوص قسم کی کرنسی کی رقم حاصل کریں۔",
  T_48_META_API_3020_P0_D: "ہدف پرس",
  T_48_META_API_3020_P1_D: "استفسار کرنسی کی قسم",
  T_48_META_API_3020_R_D: "کرنسی کی مقدار",
  T_48_META_API_3021_D: "مخصوص والیٹ میں مخصوص قسم کی کرنسی کی ہستی حاصل کریں۔",
  T_48_META_API_3021_P0_D: "ہدف پرس",
  T_48_META_API_3021_P1_D: "استفسار کرنسی کی قسم",
  T_48_META_API_3021_R_D: "مالیاتی ادارہ",
  T_48_META_API_3022_D: "گیم میں تمام اسٹورز حاصل کریں، ایک فہرست کے طور پر واپس آئے",
  T_48_META_API_3022_R_D: "اسٹور ہستی کی فہرست",
  T_48_META_API_3023_D: "ٹارگٹ پلیئر کی ظاہری شکل کو مخصوص سین آبجیکٹ کی ظاہری شکل سے بدل دیں۔",
  T_48_META_API_3023_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3023_P1_D: "متبادل ہدف منظر آبجیکٹ",
  T_48_META_API_3023_P2_D: "پلیئر ٹرانسفارمیشن چھپانے والا جزو متبادل کے بعد بنایا گیا۔",
  T_48_META_API_3024_D: "کھلاڑی کی بھیس بدلنے والی حالت کو منسوخ کریں۔",
  T_48_META_API_3024_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3025_D: "ٹارگٹ پلیئر پر منظر کی ہستی کا کلون بنائیں",
  T_48_META_API_3025_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3025_P1_D: "اوتار کے لیے استعمال ہونے والی منظر کی ہستی",
  T_48_META_API_3025_P2_D: "کلون ہستی بنائی",
  T_48_META_API_3026_D: "کھلاڑی کی بھیس والی ہستی حاصل کریں۔",
  T_48_META_API_3026_P0_D: "کھلاڑی",
  T_48_META_API_3026_R_D: "کھلاڑی کا بھیس بدلنے والی ہستی",
  T_48_META_API_3027_D: "انڈیکس کی بنیاد پر چیٹ چینل ہستی حاصل کریں۔",
  T_48_META_API_3027_P0_D: "چیٹ چینل انڈیکس، رینج [1,8]",
  T_48_META_API_3027_R_D: "چیٹ چینل ہستی",
  T_48_META_API_3028_D: "چیٹ چینل کی ہستی حاصل کریں جہاں مخصوص کھلاڑی فی الحال موجود ہے۔",
  T_48_META_API_3028_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3028_R_D: "چیٹ چینل ہستی",
  T_48_META_API_3029_D: "کھلاڑی کو مخصوص چیٹ چینل میں شامل ہونے دیں اگر کھلاڑی پہلے سے کسی دوسرے چیٹ چینل میں ہے، تو وہ ہدف والے چینل پر چلا جائے گا۔",
  T_48_META_API_3029_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3029_P1_D: "چیٹ چینل ہستی",
  T_48_META_API_3030_D: "کھلاڑی کو موجودہ چینل سے باہر نکلنے کا سبب بنتا ہے اور پھر کسی بھی چیٹ چینل میں نہ ہونے کی حالت میں ہوتا ہے۔",
  T_48_META_API_3030_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3031_D: "فرسودہ",
  T_48_META_API_3031_P0_D: "چیٹ چینل ہستی، خالی جب چینل میں کوئی کھلاڑی نہ ہو۔",
  T_48_META_API_3032_D: "کھلاڑی کے رویے کی حالت طے کریں۔",
  T_48_META_API_3032_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3032_P1_D: "کھلاڑی کے رویے کی قسم",
  T_48_META_API_3032_P2_D: `فعال: HUD بٹن ہے اور اسے عام طور پر استعمال کیا جا سکتا ہے
غیر فعال: HUD بٹن غیر فعال ہے اور فعال یا غیر فعال طور پر رویے کی حالت میں داخل نہیں ہو سکتا
شیلڈ: HUD بٹن پوشیدہ ہے اور فعال طور پر رویے کی حالت میں داخل نہیں ہو سکتا، لیکن غیر فعال طور پر داخل`,
  T_48_META_API_3033_D: "کھلاڑی ایک مخصوص منظر آبجیکٹ میں تبدیل ہوتا ہے۔",
  T_48_META_API_3033_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3033_P1_D: "جس چیز میں تبدیل ہونا ہے۔",
  T_48_META_API_3033_P2_D: "تبدیلی کے بعد وجود میں آیا",
  T_48_META_API_3034_D: "کھلاڑی خود کا کلون بناتے ہیں۔",
  T_48_META_API_3034_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3034_P1_D: "کلون ہستی بنائی",
  T_48_META_API_3035_D: "ایک حسب ضرورت اسٹور بنائیں جہاں اسٹور کی اگلی سطح شیلفز ہو۔",
  T_48_META_API_3035_P0_D: "اسٹور ہستی بنائی",
  T_48_META_API_3036_D: "اپنی مرضی کے مطابق شیلف بنائیں شیلف کی اوپری سطح اسٹور ہے اور اگلی سطح پروڈکٹ ہے۔",
  T_48_META_API_3036_P0_D: "شیلف ہستی بنائی گئی۔",
  T_48_META_API_3037_D: "اپنی مرضی کے مطابق پروڈکٹ بنائیں جو آئٹمز کو شامل کر سکے۔",
  T_48_META_API_3037_P0_D: "پروڈکٹ کا ادارہ بنایا",
  T_48_META_API_3038_D: "ایک پروڈکٹ میں ایک سے زیادہ آئٹمز شامل کریں اس پرائمیٹ کو متعدد بار استعمال کر کے ایک پروڈکٹ میں شامل کیا جا سکتا ہے۔",
  T_48_META_API_3038_P0_D: "اجناس کی ہستی",
  T_48_META_API_3038_P1_D: "شامل کرنے کے لیے اشیاء",
  T_48_META_API_3038_P2_D: "آئٹم کی مقدار",
  T_48_META_API_3039_D: "جیل بریک انعامات دیں۔",
  T_48_META_API_3039_P0_D: "کھلاڑی ہستی",
  T_48_META_API_3039_P1_D: "مقدار",
  T_48_META_API_3039_P2_D: "حقیقی رقم",
  T_48_META_API_3040_D: "باگنی کے کاموں کو اپ ڈیٹ کیا گیا۔",
  T_48_META_API_3040_P0_D: "کھلاڑی ہستی",
  T_48_META_API_3040_P1_D: "ٹاسک ID",
  T_48_META_API_3040_P2_D: "قدر",
  T_48_META_API_3041_D: "بے ترتیب سپون پوائنٹ کوآرڈینیٹ حاصل کرنا صرف دستیاب سپون پوائنٹس سے بے ترتیب ہو گا جو مکمل طور پر قبضے میں نہیں ہیں۔",
  T_48_META_API_3041_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3041_R_D: "رینڈم برتھ پوائنٹ کوآرڈینیٹ اگر شرائط پر پورا اترنے والا کوئی نقطہ پیدائش نہیں ہے تو (0، 0، 0) کے قریب پوزیشن واپس کر دی جائے گی۔",
  T_48_META_API_3042_D: "جیل بریک منی گیم سے باہر نکلیں۔",
  T_48_META_API_3042_P0_D: "کھلاڑی ہستی",
  T_48_META_API_3042_P1_D: "ٹاسک ID",
  T_48_META_API_3043_D: "باگنی کے سہارے پر مبنی",
  T_48_META_API_3043_P0_D: "کھلاڑی ہستی",
  T_48_META_API_3043_P1_D: "سہارے کی قسم",
  T_48_META_API_3043_P2_D: "پروپ ID",
  T_48_META_API_31_D: "رشتہ دار سیلف موشن بنائیں، اور ٹارگٹ ہستی ہر بار اپنی موجودہ انتساب کی قدر کے مطابق بدل جاتی ہے۔",
  T_48_META_API_31_P0_D: "ہدف ہستی",
  T_48_META_API_31_P1_D: "وہ صفات جن کے لیے حرکت میں تبدیلی کی ضرورت ہوتی ہے۔",
  T_48_META_API_31_P2_D: "فی تحریک تبدیلی کی رقم",
  T_48_META_API_31_P3_D: "بیزیئر وکر کنٹرول پوائنٹس",
  T_48_META_API_31_P4_D: `سنگل: روکیں جب وصف ڈیلٹا کی رقم کو تبدیل کرے
لوپ: حرکت کو دہرائیں، ہر بار جب وصف ڈیلٹا کی رقم کو تبدیل کرے`,
  T_48_META_API_31_P5_D: "تبدیلی کا دورانیہ، ملی سیکنڈ میں",
  T_48_META_API_31_P6_D: "تخلیق کردہ رشتہ دار خود حرکت پذیر ہستی",
  T_48_META_API_31_P7_D: "آیا تخلیق کے بعد خود بخود چلنا شروع کیا جائے۔",
  T_48_META_API_3100_D: "ہدف مخصوص حالت میں اینیمیشن چلاتا ہے۔",
  T_48_META_API_3100_P0_D: "ایک ہستی کا جزو جسے اینیمیشن چلانے کے لیے اینیمیشن کنٹرولر کے ساتھ نصب کیا جا سکتا ہے۔",
  T_48_META_API_3100_P1_D: "اینیمیشن کنٹرولر کی مخصوص حالت",
  T_48_META_API_3100_P2_D: "حرکت پذیری پلے بیک اسپیڈ اسکیلنگ",
  T_48_META_API_3100_P3_D: "لوپ کی قسم، آپ اینیمیشن کی اصل منطق رکھ سکتے ہیں، اسے صرف ایک بار چلا سکتے ہیں یا اسے لوپ میں چلا سکتے ہیں۔",
  T_48_META_API_3101_D: "کریکٹر اینیمیشن کھیلیں اور حسب ضرورت اینیمیشن وسائل کی حمایت کریں۔",
  T_48_META_API_3101_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3101_P1_D: "حسب ضرورت اینیمیشن ریسورس ID",
  T_48_META_API_3101_P2_D: "چاہے لوپ کرنا ہے۔",
  T_48_META_API_3102_D: "مخصوص کھلاڑی کے کردار کے وسائل مرتب کریں۔",
  T_48_META_API_3102_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3102_P1_D: "حسب ضرورت رول ریسورس ID",
  T_48_META_API_3109_D: "اس محفوظ علاقے کو آن کریں جو اختتامی نقطہ تک آسانی سے منتقل ہوجائے",
  T_48_META_API_3109_P0_D: "سیف زون کی ابتدائی پوزیشن",
  T_48_META_API_3109_P1_D: "سیفٹی زون کے اختتامی مقام",
  T_48_META_API_3109_P2_D: "محفوظ زون کا ابتدائی رداس",
  T_48_META_API_3109_P3_D: "محفوظ زون کا آخری رداس",
  T_48_META_API_3109_P4_D: "محفوظ زون کو اپنی آخری حالت تک پہنچنے کے لیے سیکنڈوں میں درکار وقت",
  T_48_META_API_3109_P5_D: "محفوظ زون سے باہر فی سیکنڈ میں ہونے والے نقصان کی مقدار",
  T_48_META_API_3110_D: "کریکٹر ظاہری گروپ کو تبدیل کریں۔",
  T_48_META_API_3110_P0_D: "ہدف",
  T_48_META_API_3110_P1_D: "ظاہری گروپ",
  T_48_META_API_3111_D: "کردار کی ظاہری شکل کا گروپ دکھائیں۔",
  T_48_META_API_3111_P0_D: "ہدف",
  T_48_META_API_3111_P1_D: "ظاہری گروپ",
  T_48_META_API_3112_D: "کردار کی ظاہری شکل کا گروپ چھپائیں۔",
  T_48_META_API_3112_P0_D: "ہدف",
  T_48_META_API_3112_P1_D: "ظاہری گروپ",
  T_48_META_API_3121_D: "Craftland Studio PC کے اعدادوشمار کے استعمال پر دعوے کے نتائج بھیجیں۔",
  T_48_META_API_3121_P0_D: "دعوے کا اظہار",
  T_48_META_API_3121_P1_D: "اشارہ",
  T_48_META_API_32_D: "کھلاڑی کا آج کا ٹوکن ڈیٹا حاصل کریں۔",
  T_48_META_API_32_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_32_P1_D: "tokenID",
  T_48_META_API_32_P2_D: "ٹوکنز کی تعداد",
  T_48_META_API_32_P3_D: "آیا پرائمیٹ کو کامیابی سے بلایا گیا ہے۔",
  T_48_META_API_3200_D: "پلیئر میں آئٹمز شامل کریں اور جاری کردہ آئٹمز کی فہرست واپس کریں۔",
  T_48_META_API_3200_P0_D: "کھلاڑی",
  T_48_META_API_3200_P1_D: "آئٹم کی شناخت",
  T_48_META_API_3200_P2_D: "آئٹم کی مقدار",
  T_48_META_API_3200_P3_D: "کھلاڑی کے لیے شامل کیے گئے آئٹمز کی فہرست، ایک فہرست کے طور پر واپس کی گئی چاہے صرف ایک آئٹم شامل کیا گیا ہو۔",
  T_48_META_API_3201_D: "خون کے حجم کی اوپری حد سے تجاوز کیے بغیر مخصوص پلیئر کے خون کے حجم کو بحال کریں۔",
  T_48_META_API_3201_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3201_P1_D: "پلیئر میں خون شامل کرنے کی قیمت صرف مثبت نمبروں کو قبول کیا جاتا ہے۔",
  T_48_META_API_3202_D: "ہدف والے کھلاڑی کی مہارت کی فہرست مرتب کریں۔",
  T_48_META_API_3202_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3202_P1_D: "ہنر کی فہرست",
  T_48_META_API_3203_D: "ہدف والے کھلاڑی کی مہارت کی فہرست حاصل کریں۔",
  T_48_META_API_3203_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3203_R_D: "ہنر کی فہرست",
  T_48_META_API_3205_D: "کھلاڑی سے آئٹمز کی ایک مخصوص تعداد کو حذف کریں۔",
  T_48_META_API_3205_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3205_P1_D: "حذف کرنے کے لیے آئٹم کی قسم",
  T_48_META_API_3205_P2_D: "حذف کی جانے والی مقدار، اگر یہ کھلاڑی کے پاس رکھی ہوئی مقدار سے زیادہ ہے، تو صرف رکھی ہوئی اشیاء کو حذف کیا جائے گا۔",
  T_48_META_API_3206_D: "کھلاڑی کے پاس رکھی گئی مخصوص اشیاء کی تعداد حاصل کریں۔",
  T_48_META_API_3206_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3206_P1_D: "آئٹم کی قسم",
  T_48_META_API_3206_R_D: "کھلاڑی کے پاس رکھی ہوئی رقم",
  T_48_META_API_3207_D: "چیک کریں کہ آیا کھلاڑی موجودہ چوکی کو متحرک کرسکتا ہے۔",
  T_48_META_API_3207_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3207_P1_D: "ٹریجر",
  T_48_META_API_3207_R_D: "درست: متحرک کیا جا سکتا ہے، غلط: متحرک نہیں کیا جا سکتا",
  T_48_META_API_3208_D: "انفیکشن موڈ زومبی ارتقاء",
  T_48_META_API_3208_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3209_D: "AI ادارے پہلے سے طے شدہ رویے کے درخت کو روکتے ہیں/اس پر عمل درآمد کرتے ہیں۔",
  T_48_META_API_3209_P0_D: "رویے کے درخت کے مقاصد کو فعال کرنے کے لئے",
  T_48_META_API_3209_P1_D: "آیا پہلے سے طے شدہ برتاؤ کے درخت پر عمل درآمد کرنا ہے۔",
  T_48_META_API_3210_D: "AI ادارے نامزد اہداف کا تعاقب کرتے ہیں۔",
  T_48_META_API_3210_P0_D: "AI ہستی جو تعاقب کرتی ہے۔",
  T_48_META_API_3210_P1_D: "جس ہدف کا تعاقب کیا جا رہا ہے۔",
  T_48_META_API_3211_D: "پلیئر آئٹمز کو تباہ کریں (فرسودہ، Delete Equipment استعمال کریں)",
  T_48_META_API_3211_P0_D: "وہ کھلاڑی جس کا آئٹم تباہ ہو گیا تھا۔",
  T_48_META_API_3211_P1_D: "تباہ شدہ شے کی قسم",
  T_48_META_API_3211_P2_D: "ہتھیاروں کی سلاٹ، صرف ہتھیاروں کے لیے موثر",
  T_48_META_API_3212_D: "جرسی تبدیل کریں۔",
  T_48_META_API_3212_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3212_P1_D: "لباس کا انداز",
  T_48_META_API_3212_P2_D: "اہم رنگ ایک",
  T_48_META_API_3212_P3_D: "اہم رنگ دو",
  T_48_META_API_3212_P4_D: "کنفیگریشن",
  T_48_META_API_3213_D: "کھلاڑی کی جرسی کو اس کی اصل حالت میں بحال کریں۔",
  T_48_META_API_3213_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3214_D: "پلیئر وائس چیٹ کو آن اور آف کریں۔",
  T_48_META_API_3214_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3214_P1_D: "آیا صوتی چیٹ کو بند کرنا ہے، درست: بند کریں غلط: آن کریں۔",
  T_48_META_API_3215_D: "پلیئر فوری چیٹ سوئچ کریں۔",
  T_48_META_API_3215_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3215_P1_D: "فوری چیٹ بند کرنا ہے یا نہیں، درست: بند کریں غلط: کھولیں۔",
  T_48_META_API_3216_D: "سیٹ کریں کہ آیا ہدف والا کھلاڑی آئٹمز اٹھا سکتا ہے۔",
  T_48_META_API_3216_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3216_P1_D: "آیا اشیاء اٹھانے سے منع کیا جائے، درست: اشیاء اٹھانے سے منع کیا گیا، غلط: اٹھایا جا سکتا ہے",
  T_48_META_API_3217_D: "سیٹ کریں کہ آیا ٹارگٹ پلیئر آئٹمز چھوڑ سکتا ہے۔",
  T_48_META_API_3217_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3217_P1_D: "آیا اشیاء کو گرانے سے منع کیا جائے، درست: اٹھانے سے منع کیا گیا، غلط: اٹھایا جا سکتا ہے",
  T_48_META_API_3218_D: "کھلاڑی کے مقرر کردہ سلاٹ میں ہتھیار کو تباہ کریں۔",
  T_48_META_API_3218_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3218_P1_D: "تباہ کرنے کے لیے ہتھیار کی سلاٹ",
  T_48_META_API_3218_P2_D: "تباہ کرنے کی مقدار",
  T_48_META_API_3218_P3_D: "چاہے یہ کامیابی سے تباہ ہو یا نہ ہو اگر ہتھیاروں کی سلاٹ میں کوئی ہتھیار نہ ہو تو تباہی ناکام ہو جائے گی۔",
  T_48_META_API_3219_D: "ہدف والے کھلاڑی کے بیگ سے تمام اشیاء کو صاف کریں، بشمول لیس اشیاء",
  T_48_META_API_3219_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3220_D: "پلیئر کی سمت طے کریں۔",
  T_48_META_API_3220_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3220_P1_D: "کھلاڑی کی سمت",
  T_48_META_API_3221_D: "(فرسودہ، براہ کرم اسے استعمال نہ کریں۔ متعلقہ معلومات کے لیے، وصف دیکھیں <Player>:Skeleton)",
  T_48_META_API_3221_P0_D: "کھلاڑی ہستی",
  T_48_META_API_3221_P1_D: "زوم حصہ",
  T_48_META_API_3221_P2_D: "زوم قدر",
  T_48_META_API_3222_D: "کھلاڑی کو ایک پھسلانے کا اثر دے، مقصد کے کھلاڑی کو ثابت تیزی سے گرنا ہے، اور ہوا میں تصادم کے بعد پھسلانے کو مجبوری طور پر روک دیں گے.",
  T_48_META_API_3222_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3222_P1_D: "پرواز کی سمت",
  T_48_META_API_3222_P2_D: "دستک کا دورانیہ",
  T_48_META_API_3222_P3_D: "اڑتے وقت Y-axis کی ابتدائی رفتار",
  T_48_META_API_3222_P4_D: "اڑتے وقت XZ طیارے کی ابتدائی رفتار",
  T_48_META_API_3222_P5_D: "چاہے کھلاڑی کا رخ تبدیل کیا جائے۔",
  T_48_META_API_3223_D: "ٹارگٹ پلیئر یا NPC کے لباس کی شناخت حاصل کریں۔",
  T_48_META_API_3223_P0_D: "ٹارگٹ پلیئر یا NPC",
  T_48_META_API_3223_P1_D: "لباس کی قسم",
  T_48_META_API_3223_R_D: "لباس کی شناخت",
  T_48_META_API_3224_D: "ٹارگٹ پلیئر یا NPC کے لباس کی شناخت سیٹ کریں۔",
  T_48_META_API_3224_P0_D: "ٹارگٹ پلیئر یا NPC",
  T_48_META_API_3224_P1_D: "لباس کی شناخت",
  T_48_META_API_3225_D: "ٹارگٹ پلیئر کے ڈیفالٹ لباس کو بحال کرتا ہے، جسے NPCs پر لاگو نہیں کیا جا سکتا۔",
  T_48_META_API_3225_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3226_D: "AI ہستی نے مقررہ ہدف پر حملہ کیا۔",
  T_48_META_API_3226_P0_D: "AI ہستی جو حملہ کرتی ہے۔",
  T_48_META_API_3226_P1_D: "حملے کا ہدف",
  T_48_META_API_3227_D: "کھلاڑی کے ہتھیار کو مخصوص سلاٹ میں ہتھیار میں تبدیل کریں۔",
  T_48_META_API_3227_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3227_P1_D: "سوئچ کرنے کے لیے ہتھیار کی سلاٹ",
  T_48_META_API_3227_P2_D: "چاہے سوئچ کامیاب ہو یا نہ ہو اگر ہتھیار کی سلاٹ میں کوئی ہتھیار نہیں ہے تو سوئچ ناکام ہو جائے گا۔",
  T_48_META_API_3228_D: "ٹارگٹ پلیئر یا این پی سی کے ہتھیار کی جلد حاصل کریں۔",
  T_48_META_API_3228_P0_D: "ٹارگٹ پلیئر یا NPC",
  T_48_META_API_3228_P1_D: "ہتھیار کی جلد کی شناخت",
  T_48_META_API_3228_R_D: "ہتھیار کی جلد کی شناخت",
  T_48_META_API_3229_D: "ٹارگٹ پلیئر یا این پی سی کے ہتھیار کی جلد سیٹ کریں۔",
  T_48_META_API_3229_P0_D: "ٹارگٹ پلیئر یا NPC",
  T_48_META_API_3229_P1_D: "ہتھیار کی جلد کی شناخت",
  T_48_META_API_3230_D: "ہدف والے کھلاڑی کی ڈیفالٹ ہتھیار کی جلد کو بحال کرتا ہے، جسے NPCs پر لاگو نہیں کیا جا سکتا۔",
  T_48_META_API_3230_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3230_P1_D: "ہتھیار کی شناخت",
  T_48_META_API_3231_D: "کھلاڑیوں کی تنظیمیں ترتیب دیں۔",
  T_48_META_API_3231_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3231_P1_D: "لباس کی فہرست",
  T_48_META_API_3232_D: "ٹارگٹ پلیئر یا NPC سے مخصوص لباس کی قسم کے تمام لباس ہٹاتا ہے۔",
  T_48_META_API_3232_P0_D: "ٹارگٹ پلیئر یا NPC",
  T_48_META_API_3232_P1_D: "لباس کی قسم",
  T_48_META_API_3233_D: "کھلاڑی یا این پی سی کے ذریعہ بیان کردہ ہتھیار کی جلد کو ہٹا دیں۔",
  T_48_META_API_3233_P0_D: "ٹارگٹ پلیئر یا NPC",
  T_48_META_API_3233_P1_D: "ہتھیار کی شناخت",
  T_48_META_API_3234_D: "ہدف میں بف شامل کریں۔",
  T_48_META_API_3234_P0_D: "ہدف والی ہستی ایک ایسی ہستی ہونی چاہیے جو بفس کو شامل کر سکے۔",
  T_48_META_API_3234_P1_D: "بف آئی ڈی",
  T_48_META_API_3235_D: "ہدف سے بف کو ہٹا دیں۔",
  T_48_META_API_3235_P0_D: "ہدف والی ہستی ایک ایسی ہستی ہونی چاہیے جو بفس کو شامل کر سکے۔",
  T_48_META_API_3235_P1_D: "بف آئی ڈی",
  T_48_META_API_3236_D: "ہدف کا موجودہ بف حاصل کریں۔",
  T_48_META_API_3236_P0_D: "ہدف والی ہستی ایک ایسی ہستی ہونی چاہیے جو بفس کو شامل کر سکے۔",
  T_48_META_API_3236_R_D: "بف فہرست",
  T_48_META_API_3237_D: "ہدف والے کھلاڑی کے بیگ کی انوینٹری میں اشیاء حاصل کریں۔",
  T_48_META_API_3237_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3237_P1_D: "سہارے کی فہرست",
  T_48_META_API_3238_D: "مخصوص سلاٹ میں ایسیسریز شامل کریں جو سلاٹ سے مماثل نہیں ہوں گی لیکن ڈپلیکیٹ لوازمات کھلاڑی کے بیگ کے بھر جانے پر بھیجے جائیں گے۔ ، اصل لوازمات کھلاڑی کے موجودہ مقام پر ڈالے جائیں گے۔",
  T_48_META_API_3238_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3238_P1_D: "سامان کی سلاٹ",
  T_48_META_API_3238_P2_D: "لوازمات",
  T_48_META_API_3238_P3_D: `آیا لوازمات کو کامیابی کے ساتھ شامل کیا گیا تھا
سچ: لوازمات کو متعلقہ سلاٹ میں ہتھیار سے لیس کیا گیا ہے
غلط: لوازمات شامل کرنے میں ناکام رہا اور کھلاڑی کے بیگ میں ظاہر نہیں ہوگا۔`,
  T_48_META_API_3238_P4_D: "شامل کردہ لوازمات، ناکام ہونے پر خالی",
  T_48_META_API_3239_D: "سامان کو بیگ کے سامان کے کالم میں حاصل کریں۔",
  T_48_META_API_3239_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3239_P1_D: "سامان کی سلاٹ",
  T_48_META_API_3239_P2_D: "مخصوص سلاٹ میں سامان نہیں ہے تو، یہ خالی ہو جائے گا.",
  T_48_META_API_3239_P3_D: "اس سامان کے لیے تمام لوازمات",
  T_48_META_API_3240_D: "دو جہتی ویکٹر کا X جزو لیں۔",
  T_48_META_API_3240_P0_D: "2D ویکٹر",
  T_48_META_API_3240_R_D: "دو جہتی ویکٹر X جزو",
  T_48_META_API_3241_D: "دو جہتی ویکٹر کا Y جزو لیں۔",
  T_48_META_API_3241_P0_D: "2D ویکٹر",
  T_48_META_API_3241_R_D: "دو جہتی ویکٹر Y جزو",
  T_48_META_API_3242_D: "2D ویکٹر X جزو کو سیٹ کرتا ہے۔",
  T_48_META_API_3242_P0_D: "2D ویکٹر",
  T_48_META_API_3242_P1_D: "دو جہتی ویکٹر X جزو",
  T_48_META_API_3243_D: "2D ویکٹر Y جزو سیٹ کرتا ہے۔",
  T_48_META_API_3243_P0_D: "2D ویکٹر",
  T_48_META_API_3243_P1_D: "دو جہتی ویکٹر Y جزو",
  T_48_META_API_3244_D: "دو 2D ویکٹر شامل کریں۔",
  T_48_META_API_3244_P0_D: "لہذا",
  T_48_META_API_3244_P1_D: "لہذا",
  T_48_META_API_3244_R_D: "دو جہتی ویکٹر کے اضافے کا نتیجہ",
  T_48_META_API_3245_D: "دو 2D ویکٹر کو گھٹائیں۔",
  T_48_META_API_3245_P0_D: "لہذا",
  T_48_META_API_3245_P1_D: "لہذا",
  T_48_META_API_3245_R_D: "دو جہتی ویکٹر گھٹاؤ نتیجہ",
  T_48_META_API_3246_D: "دو جہتی ویکٹر کو ضرب دیں۔",
  T_48_META_API_3246_P0_D: "2D ویکٹر",
  T_48_META_API_3246_P1_D: "2D ویکٹر اسکیلنگ ویلیو",
  T_48_META_API_3246_R_D: "دو جہتی ویکٹر ضرب کا نتیجہ",
  T_48_META_API_3247_D: "ڈاٹ پروڈکٹ دو دو جہتی ویکٹر ڈاٹ پروڈکٹ کا نتیجہ ایک اسکیلر ہے، جو دو ویکٹروں کے درمیان زاویہ کی نمائندگی کرتا ہے۔",
  T_48_META_API_3247_P0_D: "لہذا",
  T_48_META_API_3247_P1_D: "لہذا",
  T_48_META_API_3247_R_D: "ڈاٹ ضرب کا نتیجہ",
  T_48_META_API_3248_D: "دو 2D ویکٹر کے یوکلیڈین فاصلے کا حساب لگائیں۔",
  T_48_META_API_3248_P0_D: "لہذا",
  T_48_META_API_3248_P1_D: "لہذا",
  T_48_META_API_3248_R_D: "دو ویکٹر کو گھٹانے کے بعد، نتیجے میں آنے والے ویکٹر کے ماڈیول کی لمبائی",
  T_48_META_API_3249_D: "دو دو جہتی ویکٹروں کے درمیان زاویہ کا حساب لگائیں۔",
  T_48_META_API_3249_P0_D: "لہذا",
  T_48_META_API_3249_P1_D: "لہذا",
  T_48_META_API_3249_R_D: "ویکٹر زاویہ، زاویہ کی حد 0-180",
  T_48_META_API_3250_D: "2D ویکٹر کو معمول بنائیں",
  T_48_META_API_3250_P0_D: "2D ویکٹر",
  T_48_META_API_3250_R_D: "عام نتیجہ ایک ویکٹر ہے جس کی لمبائی ایک ہی سمت میں 1 میٹر ہے۔",
  T_48_META_API_3251_D: "ماڈیولو ایک دو جہتی ویکٹر",
  T_48_META_API_3251_P0_D: "2D ویکٹر",
  T_48_META_API_3251_R_D: "ماڈیولو نتیجہ ویکٹر کی لمبائی ہے۔",
  T_48_META_API_3252_D: "ایک عام عمودی سیدھی لکیر سے منعکس ہونے والے دو جہتی ویکٹر کے ویکٹر کا حساب لگائیں۔",
  T_48_META_API_3252_P0_D: "واقعہ 2D ویکٹر",
  T_48_META_API_3252_P1_D: "عام 2D ویکٹر",
  T_48_META_API_3252_R_D: "ریفلیکشن 2D ویکٹر",
  T_48_META_API_3253_D: "ایک تین جہتی ویکٹر کے ویکٹر کا حساب لگائیں جو ہوائی جہاز سے معمول پر کھڑا ہوتا ہے",
  T_48_META_API_3253_P0_D: "واقعہ سہ جہتی ویکٹر",
  T_48_META_API_3253_P1_D: "عام 3D ویکٹر",
  T_48_META_API_3253_R_D: "ریفلیکشن تھری ڈی ویکٹر",
  T_48_META_API_3254_D: "تین جہتی ویکٹر کو دو جہتی ویکٹر میں تبدیل کریں اور سہ جہتی ویکٹر کے Z جزو کو حذف کریں",
  T_48_META_API_3254_P0_D: "ہدف 3D ویکٹر",
  T_48_META_API_3254_R_D: "تبدیل شدہ دو جہتی ویکٹر",
  T_48_META_API_3255_D: "دو جہتی ویکٹر کو تین جہتی ویکٹر میں تبدیل کریں، اور سہ جہتی ویکٹر کے Z جزو کو 0 پر سیٹ کریں",
  T_48_META_API_3255_P0_D: "ہدف 2D ویکٹر",
  T_48_META_API_3255_R_D: "تبدیل شدہ تین جہتی ویکٹر",
  T_48_META_API_3256_D: "ایک 2D ویکٹر بنائیں",
  T_48_META_API_3256_P0_D: "دو جہتی ویکٹر کا X جزو",
  T_48_META_API_3256_P1_D: "دو جہتی ویکٹر کا Y جزو",
  T_48_META_API_3256_R_D: "دو جہتی ویکٹر بنایا",
  T_48_META_API_3257_D: "صارف کے تجربے کے ڈیٹا کے تجزیہ کے لیے مسابقتی پوائنٹس لاگ کو حسب ضرورت بنائیں",
  T_48_META_API_3257_P0_D: "لاگ",
  T_48_META_API_3258_D: "صارف کے تجربے کے ڈیٹا کے تجزیہ کے لیے مسابقتی پوائنٹس لاگ کو حسب ضرورت بنائیں",
  T_48_META_API_3258_P0_D: "کھلاڑیوں کی اطلاع دی جائے۔",
  T_48_META_API_3258_P1_D: "لاگ",
  T_48_META_API_33_D: "گندا لفظ فلٹر",
  T_48_META_API_33_P0_D: "اصل متن جسے گندے الفاظ کے لیے فلٹر کرنے کی ضرورت ہے۔",
  T_48_META_API_33_R_D: "فلٹر شدہ متن",
  T_48_META_API_3301_D: "کیمپ کا ادارہ بنائیں",
  T_48_META_API_3301_P0_D: "دھڑے کی ہستی",
  T_48_META_API_3302_D: "ہدف کا ادارہ مخصوص کیمپ میں شامل ہوتا ہے۔",
  T_48_META_API_3302_P0_D: "ہدف ہستی",
  T_48_META_API_3302_P1_D: "دھڑے کی ہستی",
  T_48_META_API_3303_D: "کیمپ کا حملہ آور کیمپ حاصل کریں۔",
  T_48_META_API_3303_P0_D: "کیمپ پر حملہ",
  T_48_META_API_3303_R_D: "دھڑے کی ہستی کی فہرست",
  T_48_META_API_3304_D: "کیمپ کا حملہ آور کیمپ قائم کریں۔",
  T_48_META_API_3304_P0_D: "کیمپ پر حملہ",
  T_48_META_API_3304_P1_D: "ہدف کیمپ",
  T_48_META_API_3304_P2_D: "کیا یہ حملہ آور ہے؟",
  T_48_META_API_3305_D: "کھلاڑیوں پر حملہ کرنے کے لیے ترتیب دیں۔",
  T_48_META_API_3305_P0_D: "کھلاڑی",
  T_48_META_API_3305_P1_D: "کھلاڑیوں پر حملہ کر سکتے ہیں۔",
  T_48_META_API_3305_P2_D: "کیا یہ حملہ آور ہے؟",
  T_48_META_API_3306_D: "ٹیم کی حملہ آور ٹیمیں مقرر کریں۔",
  T_48_META_API_3306_P0_D: "حملہ آور ٹیم",
  T_48_META_API_3306_P1_D: "ہدف ٹیم",
  T_48_META_API_3306_P2_D: "کیا یہ حملہ آور ہے؟",
  T_48_META_API_3307_D: "فرسودہ",
  T_48_META_API_3307_P0_D: "فرسودہ",
  T_48_META_API_3307_R_D: "پلیئر ہستی کی فہرست",
  T_48_META_API_3308_D: "مخصوص ہستی موجودہ کیمپ سے باہر نکلتی ہے۔",
  T_48_META_API_3308_P0_D: "ہدف ہستی",
  T_48_META_API_3309_D: "ہدف کا دھڑا حاصل کریں۔",
  T_48_META_API_3309_P0_D: "ہدف ہستی",
  T_48_META_API_3309_R_D: "دھڑے کی ہستی",
  T_48_META_API_3310_D: "اس بات کا تعین کریں کہ آیا ہدف پر حملہ کیا جا سکتا ہے۔",
  T_48_META_API_3310_P0_D: "حملہ آور",
  T_48_META_API_3310_P1_D: "ہدف ہستی",
  T_48_META_API_3310_R_D: "کیا یہ حملہ آور ہے؟",
  T_48_META_API_3311_D: "اداروں کے لیے قابل حملہ اہداف مقرر کریں۔",
  T_48_META_API_3311_P0_D: "حملہ آور",
  T_48_META_API_3311_P1_D: "ہدف ہستی",
  T_48_META_API_3311_P2_D: "کیا یہ حملہ آور ہے؟",
  T_48_META_API_3312_D: "کسی ہستی کے قابل حملہ آور اہداف حاصل کرتا ہے۔",
  T_48_META_API_3312_P0_D: "حملہ آور",
  T_48_META_API_3312_R_D: "حملہ آور اداروں کی فہرست",
  T_48_META_API_34_D: "اس بات کا تعین کریں کہ آیا ہدف والے ادارے کے اجزاء ہیں یا نہیں۔",
  T_48_META_API_34_P0_D: "ہدف ہستی",
  T_48_META_API_34_P1_D: "اجزاء کی قسم",
  T_48_META_API_34_R_D: "کیا موجود ہے",
  T_48_META_API_35_D: "بوٹ شامل کریں۔",
  T_48_META_API_35_P0_D: "بوٹ مشکل کی سطح",
  T_48_META_API_35_P1_D: "بوٹ جس ٹیم سے تعلق رکھتا ہے۔",
  T_48_META_API_35_P2_D: "بوٹ پلیئر کی تخلیق کردہ ہستی",
  T_48_META_API_3500_D: "پلیئر ٹوکن ڈیٹا حاصل کریں۔",
  T_48_META_API_3500_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3500_P1_D: "tokenID",
  T_48_META_API_3500_P2_D: "ٹوکنز کی تعداد",
  T_48_META_API_3500_P3_D: "کیا یہ کامیاب ہے؟",
  T_48_META_API_3501_D: "کھلاڑیوں میں ٹوکن ڈیٹا شامل کریں۔",
  T_48_META_API_3501_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3501_P1_D: "tokenID",
  T_48_META_API_3501_P2_D: "ٹوکنز کی تعداد",
  T_48_META_API_3501_P3_D: "آیا پرائمیٹ کو کامیابی سے بلایا گیا ہے۔",
  T_48_META_API_3502_D: "ٹارگٹ پلیئر ٹوکن استعمال کریں۔",
  T_48_META_API_3502_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3502_P1_D: "tokenID",
  T_48_META_API_3502_P2_D: "ٹوکنز کی تعداد",
  T_48_META_API_3502_P3_D: "آیا پرائمیٹ کو کامیابی سے بلایا گیا ہے۔",
  T_48_META_API_3503_D: "مخصوص جگہ پر ٹوکن شامل کریں۔",
  T_48_META_API_3503_P0_D: "مقام",
  T_48_META_API_3503_P1_D: "tokenID",
  T_48_META_API_3503_P2_D: "ٹوکنز کی تعداد",
  T_48_META_API_3503_P3_D: "آیا پرائمیٹ کو کامیابی سے بلایا گیا ہے۔",
  T_48_META_API_3504_D: "ہدف AI مخصوص مہارتوں کو جاری کرتا ہے۔",
  T_48_META_API_3504_P0_D: "ہدف AI",
  T_48_META_API_3504_P1_D: "ہنر",
  T_48_META_API_3504_P2_D: "مہارت کا ہدف",
  T_48_META_API_3504_P3_D: "چاہے مہارت کامیابی سے جاری کی گئی ہو۔",
  T_48_META_API_3505_D: "نقطہ آغاز سے اختتامی نقطہ تک پاتھ فائنڈنگ کا راستہ بنائیں، جو رکاوٹوں کو نظرانداز کرے گا اور اسے AI پاتھ فائنڈنگ کے لیے استعمال کیا جا سکتا ہے۔",
  T_48_META_API_3505_P0_D: "نقطہ آغاز کے نقاط",
  T_48_META_API_3505_P1_D: "اختتامی نقطہ نقاط",
  T_48_META_API_3505_P2_D: "آیا پاتھ فائنڈنگ کا راستہ کامیابی کے ساتھ قائم کیا گیا تھا۔",
  T_48_META_API_3505_P3_D: "راستہ تلاش کرنے والے پوائنٹ کا مجموعہ",
  T_48_META_API_3506_D: "طرز عمل کے درخت کے بلیک بورڈ متغیرات کو سیٹ کریں۔",
  T_48_META_API_3506_P0_D: "ہدف سلوک کا درخت",
  T_48_META_API_3506_P1_D: "متغیر نام",
  T_48_META_API_3506_P2_D: "متغیر قدر",
  T_48_META_API_3507_D: "سلوک کے درخت کے بلیک بورڈ کے متغیرات حاصل کریں۔",
  T_48_META_API_3507_P0_D: "ہدف سلوک کا درخت",
  T_48_META_API_3507_P1_D: "متغیر نام",
  T_48_META_API_3507_P2_D: "متغیر قدر",
  T_48_META_API_3508_D: "برتاؤ کے درخت نوڈ پیرامیٹرز حاصل کریں",
  T_48_META_API_3508_P0_D: "ہدف سلوک درخت نوڈ",
  T_48_META_API_3508_P1_D: "پیرامیٹر کا نام",
  T_48_META_API_3508_P2_D: "پیرامیٹر کی قدر",
  T_48_META_API_3509_D: "ٹارگٹ پلیئر کی گاڑی کی جلد حاصل کریں۔",
  T_48_META_API_3509_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3509_P1_D: "گاڑی کی شناخت",
  T_48_META_API_3509_R_D: "گاڑی کی جلد",
  T_48_META_API_3510_D: "ٹارگٹ پلیئر کی گاڑی کی جلد سیٹ کریں۔",
  T_48_META_API_3510_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3510_P1_D: "گاڑی کی جلد کی شناخت",
  T_48_META_API_3511_D: "ہدف کھلاڑی کی مخصوص گاڑی کی جلد صاف کریں",
  T_48_META_API_3511_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3511_P1_D: "گاڑی کی شناخت",
  T_48_META_API_3512_D: "ٹارگٹ پلیئر کی ڈیفالٹ گاڑی کی جلد کو بحال کریں۔",
  T_48_META_API_3512_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_3512_P1_D: "گاڑی کی شناخت",
  T_48_META_API_36_D: "نیند کا ہدف، صرف ڈائنامک قسم کے سخت جسموں کے لیے استعمال کیا جا سکتا ہے۔",
  T_48_META_API_36_P0_D: "ہدف سخت جسم",
  T_48_META_API_37_D: "ہدف کو بیدار کریں، صرف ڈائنامک قسم کے سخت جسموں کے لیے استعمال کیا جا سکتا ہے۔",
  T_48_META_API_37_P0_D: "ہدف سخت جسم",
  T_48_META_API_38_D: "چیک کریں کہ آیا ہدف کا سخت جسم سو رہا ہے۔",
  T_48_META_API_38_P0_D: "ہدف سخت جسم",
  T_48_META_API_38_R_D: "کیا یہ سو رہا ہے؟",
  T_48_META_API_39_D: "نیند کی حد مقرر کریں۔",
  T_48_META_API_39_P0_D: "ہدف سخت جسم",
  T_48_META_API_39_P1_D: "نیند کی حد اس وقت نیند کی حالت میں داخل ہوتی ہے جب اس کی حرکت اور گردش اس قدر سے کم ہوتی ہے نیند کی حالت میں سخت جسم اب جسمانی حساب کتاب نہیں کرتا ہے۔",
  T_48_META_API_4_D: "سیٹ کریں کہ آیا تمام کھلاڑی حرکت کر سکتے ہیں۔",
  T_48_META_API_4_P0_D: `درست: منتقل کیا جا سکتا ہے
غلط: منتقل نہیں کیا جا سکتا`,
  T_48_META_API_40_D: "نیند کی حد حاصل کریں۔",
  T_48_META_API_40_P0_D: "ہدف سخت جسم",
  T_48_META_API_40_R_D: "نیند کی حد اس وقت نیند کی حالت میں داخل ہوتی ہے جب اس کی حرکت اور گردش اس قدر سے کم ہوتی ہے نیند کی حالت میں سخت جسم اب جسمانی حساب کتاب نہیں کرتا ہے۔",
  T_48_META_API_4000_D: "پورے جدول کے مندرجات کو پڑھیں اور قطار کی ترتیب میں دو جہتی سرنی واپس کریں۔",
  T_48_META_API_4000_P0_D: "ٹیبل کا نام",
  T_48_META_API_4000_R_D: "ٹیبل کے مواد",
  T_48_META_API_4001_D: "ٹیبل کی قطار کے مندرجات کو پڑھیں اور ایک صف واپس کریں۔",
  T_48_META_API_4001_P0_D: "ٹیبل کا نام",
  T_48_META_API_4001_P1_D: "پڑھنے کے لیے قطاروں کی تعداد، 1 سے شروع ہوتی ہے۔",
  T_48_META_API_4001_R_D: "جدول قطار کے مواد کی وضاحت کرتا ہے۔",
  T_48_META_API_4002_D: "ٹیبل کے کالم کے مواد کو پڑھیں اور ایک صف واپس کریں۔",
  T_48_META_API_4002_P0_D: "ٹیبل کا نام",
  T_48_META_API_4002_P1_D: "پڑھنے کے لیے کالموں کی تعداد، 1 سے شروع",
  T_48_META_API_4002_R_D: "جدول کالم کے مواد کی وضاحت کرتا ہے۔",
  T_48_META_API_4003_D: "ٹیبل سیل کے مواد کو پڑھیں",
  T_48_META_API_4003_P0_D: "ٹیبل کا نام",
  T_48_META_API_4003_P1_D: "پڑھنے کے لیے قطاروں کی تعداد، 1 سے شروع ہوتی ہے۔",
  T_48_META_API_4003_P2_D: "پڑھنے کے لیے کالموں کی تعداد، 1 سے شروع",
  T_48_META_API_4003_R_D: "ٹیبل میں مخصوص سیل کے مشمولات",
  T_48_META_API_4004_D: "قطار نمبر اور کالم کے نام سے ٹیبل میں کسی مخصوص سیل کے مواد کو پڑھیں",
  T_48_META_API_4004_P0_D: "ٹیبل کا نام",
  T_48_META_API_4004_P1_D: "پڑھنے کے لیے قطاروں کی تعداد، 1 سے شروع ہوتی ہے۔",
  T_48_META_API_4004_P2_D: "پڑھنے کے لیے کالم کا نام",
  T_48_META_API_4004_R_D: "ٹیبل میں مخصوص سیل کے مشمولات",
  T_48_META_API_4005_D: "پورے جدول کے مندرجات کو پڑھیں اور دو جہتی سرنی واپس کریں۔",
  T_48_META_API_4005_P0_D: "ٹیبل کا نام",
  T_48_META_API_4005_R_D: "جدول کے مشمولات، دو جہتی صف",
  T_48_META_API_4006_D: "پورے ٹیبل کی ایک مخصوص قطار کے مندرجات کو پڑھیں اور ایک صف واپس کریں۔",
  T_48_META_API_4006_P0_D: "ٹیبل کا نام",
  T_48_META_API_4006_P1_D: "پڑھنے کے لیے قطاروں کی تعداد، 1 سے شروع ہوتی ہے۔",
  T_48_META_API_4006_R_D: "ٹیبل ایک قطار، ایک صف کے مواد کی وضاحت کرتا ہے۔",
  T_48_META_API_4007_D: "پورے ٹیبل کے کالم کے مواد کو پڑھیں اور ایک صف واپس کریں۔",
  T_48_META_API_4007_P0_D: "ٹیبل کا نام",
  T_48_META_API_4007_P1_D: "پڑھنے کے لیے کالموں کی تعداد، 1 سے شروع",
  T_48_META_API_4007_R_D: "ٹیبل ایک کالم، ایک صف کے مواد کی وضاحت کرتا ہے۔",
  T_48_META_API_4008_D: "ٹیبل سیل کے مواد کو پڑھیں",
  T_48_META_API_4008_P0_D: "ٹیبل کا نام",
  T_48_META_API_4008_P1_D: "پڑھنے کے لیے قطاروں کی تعداد، 1 سے شروع ہوتی ہے۔",
  T_48_META_API_4008_P2_D: "پڑھنے کے لیے کالموں کی تعداد، 1 سے شروع",
  T_48_META_API_4008_R_D: "ٹیبل میں مخصوص سیل کے مشمولات",
  T_48_META_API_4009_D: "کالم نمبر اور سیل ویلیو کے لحاظ سے مخصوص قطار تلاش کریں۔",
  T_48_META_API_4009_P0_D: "ٹیبل کا نام",
  T_48_META_API_4009_P1_D: "پڑھنے کے لیے کالموں کی تعداد",
  T_48_META_API_4009_P2_D: "سیل کی قیمت جس کو تلاش کرنا ہے۔",
  T_48_META_API_4009_R_D: "ملی قطار کا مواد، صف",
  T_48_META_API_4010_D: "کالم کے نام سے کالم نمبر حاصل کریں۔",
  T_48_META_API_4010_P0_D: "ٹیبل کا نام",
  T_48_META_API_4010_P1_D: "سیریل نمبر چیک کرنے کے لیے کالم کا نام",
  T_48_META_API_4010_R_D: "کالموں کی تعداد، 1 سے گنتی",
  T_48_META_API_41_D: "عالمی نیند کی حد متعین کریں، جو کہ صرف نئے تیار کردہ ڈائنامک قسم کے سخت جسموں کے لیے درست ہے۔",
  T_48_META_API_41_P0_D: "نیند کی حد اس وقت نیند کی حالت میں داخل ہوتی ہے جب اس کی حرکت اور گردش اس قدر سے کم ہوتی ہے نیند کی حالت میں سخت جسم اب جسمانی حساب کتاب نہیں کرتا ہے۔",
  T_48_META_API_42_D: "عالمی نیند کی حد حاصل کریں۔",
  T_48_META_API_42_R_D: "نیند کی حد، پہلے سے طے شدہ 0.005 ہے جب حرکت اور گردش اس قدر سے کم ہوتی ہے تو نیند کی حالت میں سخت جسم جسمانی حساب کتاب نہیں کرے گا۔",
  T_48_META_API_43_D: "دیے گئے کواٹرنیئن کو یولر زاویوں میں تبدیل کریں اگر quaternion میں پاس کیا گیا ہے تو واپس کریں (0,0,0)۔",
  T_48_META_API_43_P0_D: "ان پٹ quaternion",
  T_48_META_API_43_R_D: "یولر کے زاویے لوٹائے گئے۔",
  T_48_META_API_44_D: "دیے گئے یولر زاویوں کو quaternions میں تبدیل کریں۔",
  T_48_META_API_44_P0_D: "ان پٹ یولر زاویہ",
  T_48_META_API_44_R_D: "Quaternion واپس آ گیا",
  T_48_META_API_45_D: "محور زاویہ سے ظاہر ہونے والی گردش کو کواٹرنیئن میں تبدیل کریں۔",
  T_48_META_API_45_P0_D: "گردش کا محور",
  T_48_META_API_45_P1_D: "گردش کے محور کے گرد گھڑی کی سمت گردش کا زاویہ",
  T_48_META_API_45_R_D: "Quaternion واپس آ گیا",
  T_48_META_API_46_D: "quaternion کو محور زاویہ کی نمائندگی میں تبدیل کریں۔",
  T_48_META_API_46_P0_D: "ان پٹ quaternion",
  T_48_META_API_46_P1_D: "گردش کا محور",
  T_48_META_API_46_P2_D: "گردش کے محور کے گرد گھڑی کی سمت گردش کا زاویہ",
  T_48_META_API_47_D: "حسب ضرورت کام کی تکمیل کی پیشرفت سیٹ کریں۔",
  T_48_META_API_47_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_47_P1_D: "ٹاسک ID",
  T_48_META_API_47_P2_D: "تکمیل کی پیشرفت، منفی نمبروں کی اجازت نہیں ہے۔",
  T_48_META_API_48_D: "ایک Bezier وکر بنائیں جو حرکت کو انٹرپولیٹ کرنے کے لیے استعمال کیا جا سکے۔",
  T_48_META_API_48_P0_D: "وکر کنٹرول پوائنٹس",
  T_48_META_API_48_R_D: "Bezier وکر",
  T_48_META_API_49_D: "منظر کے نقشے کی شناخت حاصل کریں۔",
  T_48_META_API_49_P0_D: "منظر کی شناخت",
  T_48_META_API_49_R_D: "نقشہ کی شناخت",
  T_48_META_API_5_D: "منظر میں رکھی ہوئی اشیاء کو حذف کریں (متروک، براہ کرم DeleteEntity استعمال کریں)",
  T_48_META_API_5_P0_D: "آبجیکٹ ہستی جسے حذف کرنا ہے۔",
  T_48_META_API_50_D: "ہر فریم کے مطابق ایک حرکت پیدا کرتی ہے، ہدف کی ہستی ہر فریم میں ایک بار اپنی صفات کو تبدیل کرتی ہے، اور ہر بار اس کی موجودہ انتساب کی قدر کے مطابق تبدیل ہوتی ہے۔",
  T_48_META_API_50_P0_D: "ہدف ہستی",
  T_48_META_API_50_P1_D: "وہ صفات جن کے لیے حرکت میں تبدیلی کی ضرورت ہوتی ہے۔",
  T_48_META_API_50_P2_D: "فی تحریک تبدیلی کی رقم",
  T_48_META_API_50_P3_D: `کنفیگریشن جب دوسرے موشن موڈز کے ساتھ مل کر استعمال کیا جائے
True: Related Motion کے ساتھ مل کر استعمال کیا جا سکتا ہے
False: absolute motion کے ساتھ مل کر استعمال کیا جا سکتا ہے`,
  T_48_META_API_50_P4_D: "فی فریم خود سے متعلق تخلیق کردہ حرکت ہستی",
  T_48_META_API_50_P5_D: "آیا تخلیق کے بعد خود بخود چلنا شروع کیا جائے۔",
  T_48_META_API_5000_D: "ڈیٹا بیس میں ایک ٹیبل میں کلید سے متعلق قدر پڑھیں",
  T_48_META_API_5000_P0_D: "ڈیٹا بیس میں ٹیبل کا نام",
  T_48_META_API_5000_P1_D: "کھلاڑیوں کو نشان زد کریں اور ہم آہنگی کے حالات کو ہینڈل کریں۔",
  T_48_META_API_5000_P2_D: "ڈیٹا کی شناخت کے لیے استعمال ہونے والا حسب ضرورت نام",
  T_48_META_API_5000_P3_D: "پڑھا ہوا نتیجہ واپس کریں۔",
  T_48_META_API_5000_P4_D: "ڈیٹا بیس کے مطابق جنگی میدان کوڈ",
  T_48_META_API_5001_D: "ڈیٹا بیس میں ایک ٹیبل میں کلید کے مطابق قیمت لکھیں۔",
  T_48_META_API_5001_P0_D: "ڈیٹا بیس میں ٹیبل کا نام",
  T_48_META_API_5001_P1_D: "کھلاڑیوں کو نشان زد کریں اور ہم آہنگی کے حالات کو ہینڈل کریں۔",
  T_48_META_API_5001_P2_D: "ڈیٹا کی شناخت کے لیے استعمال ہونے والا حسب ضرورت نام",
  T_48_META_API_5001_P3_D: "قیمت لکھی ہے",
  T_48_META_API_5001_P4_D: "ڈیٹا بیس سے مماثل میدان جنگ کا کوڈ، جسے خالی جگہوں میں بھرا جا سکتا ہے، موجودہ نقشے کے میدان جنگ کوڈ کی نمائندگی کرتا ہے۔",
  T_48_META_API_5002_D: "ڈیٹا بیس میں ایک مخصوص ٹیبل میں کسی خاص کلید سے متعلق قدر کو حذف کریں۔",
  T_48_META_API_5002_P0_D: "ڈیٹا بیس میں ٹیبل کا نام",
  T_48_META_API_5002_P1_D: "کھلاڑیوں کو نشان زد کریں اور ہم آہنگی کے حالات کو ہینڈل کریں۔",
  T_48_META_API_5002_P2_D: "ڈیٹا کی شناخت کے لیے استعمال ہونے والا حسب ضرورت نام",
  T_48_META_API_5002_P3_D: "ڈیٹا بیس کے مطابق جنگی میدان کوڈ",
  T_48_META_API_5003_D: "ڈیٹا بیس میں رینکنگ ٹیبل میں کلید سے متعلق قدر پڑھیں",
  T_48_META_API_5003_P0_D: "ڈیٹا بیس میں درجہ بندی ٹیبل کا نام",
  T_48_META_API_5003_P1_D: "ڈیٹا کی شناخت کے لیے استعمال ہونے والا حسب ضرورت نام",
  T_48_META_API_5003_P2_D: "پڑھا ہوا نتیجہ واپس کریں۔",
  T_48_META_API_5003_P3_D: "ڈیٹا بیس کے مطابق جنگی میدان کوڈ",
  T_48_META_API_5004_D: "ڈیٹا بیس میں رینکنگ ٹیبل میں کلید کے مطابق قیمت لکھیں۔",
  T_48_META_API_5004_P0_D: "ڈیٹا بیس میں درجہ بندی ٹیبل کا نام",
  T_48_META_API_5004_P1_D: "ڈیٹا کی شناخت کے لیے استعمال ہونے والا حسب ضرورت نام",
  T_48_META_API_5004_P2_D: "قیمت لکھی ہے",
  T_48_META_API_5004_P3_D: "ڈیٹا بیس کے مطابق جنگی میدان کوڈ",
  T_48_META_API_5005_D: "ڈیٹا بیس میں رینکنگ ٹیبل میں کلید سے متعلق قدر کو حذف کریں۔",
  T_48_META_API_5005_P0_D: "ڈیٹا بیس میں ٹیبل کا نام",
  T_48_META_API_5005_P1_D: "ڈیٹا کی شناخت کے لیے استعمال ہونے والا حسب ضرورت نام",
  T_48_META_API_5005_P2_D: "ڈیٹا بیس کے مطابق جنگی میدان کوڈ",
  T_48_META_API_5006_D: "ڈیٹا بیس میں رینکنگ ٹیبل میں کسی خاص رینکنگ کے مطابق قدر کو حذف کریں",
  T_48_META_API_5006_P0_D: "ڈیٹا بیس میں ٹیبل کا نام",
  T_48_META_API_5006_P1_D: "لیڈر بورڈ میں پوزیشن",
  T_48_META_API_5006_P2_D: "ڈیٹا بیس کے مطابق جنگی میدان کوڈ",
  T_48_META_API_5007_D: "ڈیٹا بیس میں رینکنگ ٹیبل میں ایک خاص درجہ بندی سے ایک خاص درجہ بندی تک کی قدروں کو پڑھیں",
  T_48_META_API_5007_P0_D: "ڈیٹا بیس میں ٹیبل کا نام",
  T_48_META_API_5007_P1_D: "ابتدائی درجہ",
  T_48_META_API_5007_P2_D: "آخری درجہ بندی",
  T_48_META_API_5007_P3_D: "پڑھا ہوا نتیجہ واپس کریں۔",
  T_48_META_API_5007_P4_D: "ڈیٹا بیس کے مطابق جنگی میدان کوڈ",
  T_48_META_API_5008_D: "مجموعی ڈیٹا بیس میں ٹیبل میں کلید کے مطابق قدر پڑھیں",
  T_48_META_API_5008_P0_D: "ڈیٹا بیس میں ٹیبل کا نام",
  T_48_META_API_5008_P1_D: "ڈیٹا کی شناخت کے لیے استعمال ہونے والا حسب ضرورت نام",
  T_48_META_API_5008_P2_D: "پڑھا ہوا نتیجہ واپس کریں۔",
  T_48_META_API_5008_P3_D: "ڈیٹا بیس کے مطابق جنگی میدان کوڈ",
  T_48_META_API_5009_D: "مجموعی ڈیٹا بیس میں ٹیبل میں کلید کے مطابق آفسیٹ ویلیو لکھیں",
  T_48_META_API_5009_P0_D: "ڈیٹا بیس میں ٹیبل کا نام",
  T_48_META_API_5009_P1_D: "ڈیٹا کی شناخت کے لیے استعمال ہونے والا حسب ضرورت نام",
  T_48_META_API_5009_P2_D: "چار قسم کی ریاضی کی کارروائیاں فی الحال درج ذیل اقسام کو سپورٹ کرتی ہیں: Int قسم اضافے، گھٹاؤ، ضرب، تقسیم اور باقی کو سپورٹ کرتی ہے۔",
  T_48_META_API_5009_P3_D: "آفسیٹ ویلیو لکھا ہے۔",
  T_48_META_API_5009_P4_D: "ڈیٹا بیس کے مطابق جنگی میدان کوڈ",
  T_48_META_API_51_D: "پلے کے قابل ہستی کو دوبارہ ترتیب دیں اور پلے بیک حالت کو تبدیل کیے بغیر پلے ایبل ہستی کو اس کی ابتدائی شکل میں بحال کریں۔",
  T_48_META_API_51_P0_D: "ہدف چلانے کے قابل ادارہ",
  T_48_META_API_52_D: "دو quaternions کو ضرب کریں A*B کا مطلب ہے پہلے A کو گھمانے اور پھر B کو گھمائیں۔",
  T_48_META_API_52_P0_D: "lvalue quaternion",
  T_48_META_API_52_P1_D: "rvalue quaternion",
  T_48_META_API_52_R_D: "رزلٹ quaternion",
  T_48_META_API_53_D: "مخصوص سمت کا سامنا کرتے ہوئے ایک گھومنے والا quaternion بناتا ہے۔",
  T_48_META_API_53_P0_D: "سمت کی وضاحت کریں۔",
  T_48_META_API_53_P1_D: "اوپر کی سمت",
  T_48_META_API_53_R_D: "مخصوص سمت میں سیدھ میں لانے کے لیے درکار گردش کی مقدار",
  T_48_META_API_54_D: "A سے B تک Quaternion کروی انٹرپولیشن",
  T_48_META_API_54_P0_D: "ایک قدر",
  T_48_META_API_54_P1_D: "بی قدر",
  T_48_META_API_54_P2_D: "انٹرپولیشن پروگریس، ویلیو رینج [0,1]، جب ویلیو 0 ہوتی ہے، تو شروع ہونے والی ویلیو واپس کی جاتی ہے، جب ویلیو 1 ہوتی ہے، تو ہدف کی قیمت لوٹائی جاتی ہے۔",
  T_48_META_API_54_R_D: "رزلٹ quaternion",
  T_48_META_API_57_D: "کنسول پر ٹارگٹ ڈیٹا کو بطور وارننگ پرنٹ کریں۔",
  T_48_META_API_57_P0_D: "کیا پرنٹ کرنے کی ضرورت ہے",
  T_48_META_API_58_D: "ٹارگٹ ڈیٹا کو غلطی کی شکل میں کنسول پر پرنٹ کریں۔",
  T_48_META_API_58_P0_D: "کیا پرنٹ کرنے کی ضرورت ہے",
  T_48_META_API_59_D: "وکر پر قدر حاصل کریں۔",
  T_48_META_API_59_P0_D: "وکر",
  T_48_META_API_59_P1_D: "نمونہ لینے کا نقطہ، قدر کی حد [0,1]",
  T_48_META_API_59_R_D: "نتیجہ",
  T_48_META_API_6_D: "مخصوص نقاط پر منظر کی اشیاء بنائیں",
  T_48_META_API_6_P0_D: "منظر آبجیکٹ ہستی بنائی گئی۔",
  T_48_META_API_6_P1_D: "وہ مقام جہاں آبجیکٹ تیار ہوتا ہے۔",
  T_48_META_API_6_P2_D: "کوڈ اسکرپٹس میں تخلیق کردہ آبجیکٹ ٹائپ ID کا استعمال کرتے وقت، آپ کو پہلے سے اثاثہ رجسٹریشن میں سطح آبجیکٹ کی گنتی کا اندراج کرنا ہوگا۔",
  T_48_META_API_60_D: "منحنی خطوط سے انٹرپولیٹ",
  T_48_META_API_60_P0_D: "قدر کی قسم",
  T_48_META_API_60_P1_D: "ابتدائی قدر",
  T_48_META_API_60_P2_D: "ہدف کی قیمت",
  T_48_META_API_60_P3_D: "وکر",
  T_48_META_API_60_P4_D: "نمونہ لینے کا نقطہ، قدر کی حد [0,1]",
  T_48_META_API_60_R_D: "نتیجہ",
  T_48_META_API_6000_D: "ہدف ہستی کے لیے اسکرپٹ شامل کریں۔",
  T_48_META_API_6000_P0_D: "ہدف ہستی",
  T_48_META_API_6000_P1_D: "اسکرپٹ ID",
  T_48_META_API_6001_D: "ہدف ہستی کے لیے اسکرپٹ اَن انسٹال کریں۔",
  T_48_META_API_6001_P0_D: "ہدف ہستی",
  T_48_META_API_6001_P1_D: "اسکرپٹ ID",
  T_48_META_API_6002_D: "چیک کریں کہ آیا مخصوص اسکرپٹ ہدف کے وجود میں موجود ہے۔",
  T_48_META_API_6002_P0_D: "ہدف ہستی",
  T_48_META_API_6002_P1_D: "اسکرپٹ ID",
  T_48_META_API_6002_R_D: "آیا مخصوص اسکرپٹ موجود ہے۔",
  T_48_META_API_61_D: "UI کنٹرول کا پیرنٹ نوڈ سیٹ کریں۔",
  T_48_META_API_61_P0_D: "پیرنٹ نوڈ، آپ UI کنٹرولز یا کسٹم UI کی وضاحت کر سکتے ہیں۔",
  T_48_META_API_61_P1_D: "چائلڈ نوڈ",
  T_48_META_API_62_D: "فرسودہ",
  T_48_META_API_62_P0_D: "فرسودہ",
  T_48_META_API_62_P1_D: "فرسودہ",
  T_48_META_API_62_P2_D: "فرسودہ",
  T_48_META_API_62_P3_D: "فرسودہ",
  T_48_META_API_62_P4_D: "فرسودہ",
  T_48_META_API_63_D: "موجودہ کیمرے سے اسکرین ٹچ پوائنٹ تک ایک کرن بناتا ہے۔",
  T_48_META_API_63_P0_D: "اسکرین ٹچ پوائنٹس",
  T_48_META_API_63_P1_D: "نقطہ آغاز",
  T_48_META_API_63_P2_D: "کرن کی سمت",
  T_48_META_API_64_D: "اپنی مرضی کے مطابق بلنگ کی معلومات اپ لوڈ کریں۔",
  T_48_META_API_64_P0_D: "کھلاڑی ہستی",
  T_48_META_API_64_P1_D: "میچ کا نتیجہ",
  T_48_META_API_64_P2_D: "پوائنٹس کا عنوان",
  T_48_META_API_64_P3_D: "پوائنٹس کی قدر",
  T_48_META_API_65_D: "مخصوص ساؤنڈ ایفیکٹ چلائیں۔",
  T_48_META_API_65_P0_D: "صوتی اثر کا ادارہ بنایا",
  T_48_META_API_65_P1_D: "ٹارگٹ پلیئر، صرف ٹارگٹ پلیئر ہی صوتی اثر کو سن سکتا ہے۔",
  T_48_META_API_65_P2_D: "صوتی اثر کی قسم",
  T_48_META_API_65_P3_D: "لوپ کی قسم",
  T_48_META_API_65_P4_D: "چاہے فوری طور پر کھیلنا ہے۔",
  T_48_META_API_66_D: "ایک مخصوص بصری اثر بنائیں اگر مزید خصوصیات ہیں جن کو سیٹ کرنے کی ضرورت ہے، تو آپ اس کی ہستی کی خصوصیات کو سیٹ کر سکتے ہیں۔",
  T_48_META_API_66_P0_D: "خصوصی اثرات کا ادارہ بنایا",
  T_48_META_API_66_P1_D: "ٹارگٹ پلیئر، صرف ٹارگٹ پلیئر ہی نظر آتا ہے۔",
  T_48_META_API_66_P2_D: "خاص اثر کی قسم",
  T_48_META_API_66_P3_D: "لوپ کی قسم",
  T_48_META_API_66_P4_D: "چاہے فوری طور پر کھیلنا ہے۔",
  T_48_META_API_67_D: "مخصوص صوتی اثر بنائیں اگر مزید خصوصیات ہیں جن کو سیٹ کرنے کی ضرورت ہے، تو آپ اس کی ہستی کی خصوصیات کو سیٹ کر سکتے ہیں۔",
  T_48_META_API_67_P0_D: "صوتی اثر کا ادارہ بنایا",
  T_48_META_API_67_P1_D: "صوتی اثر کی قسم",
  T_48_META_API_67_P2_D: "لوپ کی قسم",
  T_48_META_API_67_P3_D: "چاہے فوری طور پر کھیلنا ہے۔",
  T_48_META_API_68_D: "عالمی نقاط کو اسکرین کوآرڈینیٹ میں تبدیل کریں۔",
  T_48_META_API_68_P0_D: "دنیا کوآرڈینیٹ",
  T_48_META_API_68_P1_D: "اسکرین پر نقشہ بنانا ہے یا نہیں۔",
  T_48_META_API_68_P2_D: "نقشہ محل وقوع",
  T_48_META_API_69_D: "اسکرین کوآرڈینیٹ کو عالمی نقاط میں تبدیل کریں۔",
  T_48_META_API_69_P0_D: "اسکرین کوآرڈینیٹ",
  T_48_META_API_69_P1_D: "اسکرین سے فاصلہ",
  T_48_META_API_69_P2_D: "دنیا کوآرڈینیٹ",
  T_48_META_API_7_D: "ہدف کی قدر کو سٹرنگ میں تبدیل کریں۔",
  T_48_META_API_7_P0_D: "ہدف کی قدر جس کو سٹرنگ میں تبدیل کیا جانا ہے۔",
  T_48_META_API_7_R_D: "تار",
  T_48_META_API_70_D: "اسکرین ٹچ کے ذریعے رے کا پتہ لگائیں اور پہلی ہٹ ہستی کو واپس کریں۔",
  T_48_META_API_70_P0_D: "ہوم اسکرین ٹچ",
  T_48_META_API_70_P1_D: "پتہ لگانے کا فاصلہ",
  T_48_META_API_70_P2_D: "پرتوں کا ماسک، صرف بھری ہوئی پرتیں اسکین میں حصہ لیں گی، خالی چھوڑنے کا مطلب ہے کہ تمام پرتیں اسکین میں حصہ لیں گی۔",
  T_48_META_API_70_P3_D: "کیا محرکات کا پتہ لگانا ممکن ہے؟",
  T_48_META_API_70_P4_D: "ہستی کو مارو",
  T_48_META_API_70_P5_D: "ہٹ پوائنٹ کوآرڈینیٹ",
  T_48_META_API_70_P6_D: "ہٹ پوائنٹ سے نقطہ آغاز تک کا فاصلہ",
  T_48_META_API_70_P7_D: "عام سطح کو مارو",
  T_48_META_API_71_D: "اسکرین ٹچ کے ذریعے رے کا پتہ لگانا، تمام ہٹ ہستیوں کو واپس کرنا",
  T_48_META_API_71_P0_D: "ہوم اسکرین ٹچ",
  T_48_META_API_71_P1_D: "پتہ لگانے کا فاصلہ",
  T_48_META_API_71_P2_D: "پرتوں کا ماسک، صرف بھری ہوئی پرتیں اسکین میں حصہ لیں گی، خالی چھوڑنے کا مطلب ہے کہ تمام پرتیں اسکین میں حصہ لیں گی۔",
  T_48_META_API_71_P3_D: "کیا محرکات کا پتہ لگانا ممکن ہے؟",
  T_48_META_API_71_P4_D: "متاثرہ اداروں کی فہرست",
  T_48_META_API_71_P5_D: "پوائنٹ کوآرڈینیٹ لسٹ کو دبائیں",
  T_48_META_API_71_P6_D: "ہٹ پوائنٹ اور سٹارٹ پوائنٹ کے درمیان فاصلوں کی فہرست",
  T_48_META_API_71_P7_D: "سطح عام فہرست کو مارو",
  T_48_META_API_72_D: "ایک مخصوص بصری اثر بنائیں اگر مزید خصوصیات ہیں جن کو سیٹ کرنے کی ضرورت ہے، تو آپ اس کی ہستی کی خصوصیات کو سیٹ کر سکتے ہیں۔",
  T_48_META_API_72_P0_D: "خصوصی اثرات کا ادارہ بنایا",
  T_48_META_API_72_P1_D: "خاص اثر کی قسم",
  T_48_META_API_72_P2_D: "لوپ کی قسم",
  T_48_META_API_72_P3_D: "چاہے فوری طور پر کھیلنا ہے۔",
  T_48_META_API_73_D: "ایک بلٹ ان UI بنائیں جو دوسرے کلائنٹس کے ساتھ مطابقت پذیر نہ ہو۔",
  T_48_META_API_73_P0_D: "بلٹ ان UI اداروں کو بنایا گیا۔",
  T_48_META_API_73_P1_D: "بلٹ ان UI اقسام",
  T_48_META_API_74_D: "ایک حسب ضرورت UI بنائیں جو دوسرے کلائنٹس کے ساتھ مطابقت پذیر نہ ہو۔",
  T_48_META_API_74_P0_D: "حسب ضرورت UI اداروں کو بنایا گیا۔",
  T_48_META_API_74_P1_D: "حسب ضرورت UI انڈیکس",
  T_48_META_API_75_D: "موجودہ کلائنٹ کے مطابق کھلاڑی حاصل کریں۔",
  T_48_META_API_75_R_D: "کھلاڑی ہستی",
  T_48_META_API_76_D: "AI راکشس بنائیں",
  T_48_META_API_76_P0_D: "ہدف AI",
  T_48_META_API_76_P1_D: "مقام بنائیں",
  T_48_META_API_76_P2_D: "AI قسم",
  T_48_META_API_76_P3_D: "ٹیم",
  T_48_META_API_76_P4_D: "چاہے خود بخود دشمنوں کو تلاش کیا جائے۔",
  T_48_META_API_76_P5_D: "حملہ موڈ",
  T_48_META_API_76_P6_D: "سفر کا راستہ",
  T_48_META_API_77_D: "ویکٹر کا پہلا جزو سیٹ کریں۔",
  T_48_META_API_77_P0_D: "ویکٹر",
  T_48_META_API_77_P1_D: "پہلی جزو کی قیمت",
  T_48_META_API_77_R_D: "پہلے جزو میں ترمیم کرنے کے بعد ویکٹر",
  T_48_META_API_78_D: "ویکٹر کا دوسرا جزو سیٹ کرتا ہے۔",
  T_48_META_API_78_P0_D: "ویکٹر",
  T_48_META_API_78_P1_D: "دوسرے اجزاء کی قدر",
  T_48_META_API_78_R_D: "دوسرے جزو میں ترمیم کرنے کے بعد ویکٹر",
  T_48_META_API_79_D: "ویکٹر کا تیسرا جزو سیٹ کرتا ہے۔",
  T_48_META_API_79_P0_D: "ویکٹر",
  T_48_META_API_79_P1_D: "تیسرے جزو کی قدر",
  T_48_META_API_79_R_D: "تیسرے جزو میں ترمیم کرنے کے بعد ویکٹر",
  T_48_META_API_8_D: "اس محفوظ علاقے کو آن کریں جو سنٹرل کوآرڈینیٹ پوائنٹ تک سکڑ جائے گا۔",
  T_48_META_API_8_P0_D: "محفوظ زون کا مرکز نقطہ",
  T_48_META_API_8_P1_D: "محفوظ زون کا رداس",
  T_48_META_API_8_P2_D: "انتظار کا وقت، سیکنڈوں میں، جس کے بعد محفوظ زون سینٹر پوائنٹ کی طرف سکڑنا شروع ہو جائے گا۔",
  T_48_META_API_8_P3_D: "محفوظ علاقے کے سینٹر پوائنٹ تک سکڑ جانے کے لیے سیکنڈوں میں درکار وقت",
  T_48_META_API_8_P4_D: "محفوظ زون سے باہر فی سیکنڈ میں ہونے والے نقصان کی مقدار",
  T_48_META_API_80_D: "دو جہتی ویکٹر کا پہلا جزو سیٹ کرتا ہے۔",
  T_48_META_API_80_P0_D: "2D ویکٹر",
  T_48_META_API_80_P1_D: "پہلی جزو کی قیمت",
  T_48_META_API_80_R_D: "پہلے جزو میں ترمیم کرنے کے بعد دو جہتی ویکٹر",
  T_48_META_API_81_D: "2D ویکٹر کا دوسرا جزو سیٹ کرتا ہے۔",
  T_48_META_API_81_P0_D: "2D ویکٹر",
  T_48_META_API_81_P1_D: "دوسرے اجزاء کی قدر",
  T_48_META_API_81_R_D: "دوسرے جزو میں ترمیم کرنے کے بعد دو جہتی ویکٹر",
  T_48_META_API_82_D: "کریکٹر کنٹرولر کو مخصوص پوزیشن پر لے جائیں اگر یہ کھلاڑی کو متاثر کرتا ہے، تو کھلاڑی کو پلیئر کنٹرولر کو آن کرنا چاہیے جو اثر کرنے کے لیے جسمانی اثرات کا استعمال کرتا ہے۔",
  T_48_META_API_82_P0_D: "ٹارگٹ کریکٹر کنٹرولر",
  T_48_META_API_82_P1_D: "مقام کی وضاحت کریں۔",
  T_48_META_API_83_D: "اس کے نام کی بنیاد پر ٹارگٹ پیرنٹ نوڈ ہستی کا مخصوص چائلڈ نوڈ حاصل کریں۔",
  T_48_META_API_83_P0_D: "پیرنٹ نوڈ ہستی",
  T_48_META_API_83_P1_D: "چائلڈ نوڈ کا نام",
  T_48_META_API_83_R_D: "چائلڈ نوڈ ہستی",
  T_48_META_API_84_D: "AOI خصوصی توجہ شامل کریں، فاصلے سے قطع نظر ہمیشہ مطابقت پذیر",
  T_48_META_API_84_P0_D: "خصوصی تشویش کے اہداف",
  T_48_META_API_84_P1_D: "مبصر",
  T_48_META_API_85_D: "AOI خصوصی توجہ ہٹائیں اور نظر سے باہر AOI مطابقت پذیری کو منسوخ کریں۔",
  T_48_META_API_85_P0_D: "خصوصی تشویش کے اہداف",
  T_48_META_API_85_P1_D: "مبصر",
  T_48_META_API_86_D: "خصوصی توجہ کے تمام AOI کو صاف کریں۔",
  T_48_META_API_86_P0_D: "خصوصی تشویش کے اہداف",
  T_48_META_API_87_D: "اس بات کا تعین کریں کہ آیا AOI کی خصوصی تشویش ہے۔",
  T_48_META_API_87_P0_D: "خصوصی تشویش کے اہداف",
  T_48_META_API_87_P1_D: "فرسودہ",
  T_48_META_API_87_R_D: "کیا موجود ہے",
  T_48_META_API_88_D: "کھلاڑی کے پراکسی مبصر کو ٹوگل کریں۔",
  T_48_META_API_88_P0_D: "کھلاڑی",
  T_48_META_API_88_P1_D: "پراکسی مبصر",
  T_48_META_API_89_D: "کریکٹر کنٹرولر کو ایک بار ہٹا دیں اگر یہ کھلاڑی کو متاثر کرتا ہے، تو کھلاڑی کو پلیئر کنٹرولر کو آن کرنا چاہیے جو اثر کرنے کے لیے جسمانی اثرات کا استعمال کرتا ہے۔",
  T_48_META_API_89_P0_D: "ٹارگٹ آبجیکٹ، اگر یہ ایک کھلاڑی ہے، تو کھلاڑی کو اثر کرنے کے لیے فزکس کا استعمال کرتے ہوئے پلیئر کنٹرولر کو آن کرنا چاہیے۔",
  T_48_META_API_89_P1_D: "نقل مکانی ویکٹر",
  T_48_META_API_9_D: "سیف زون میکانزم کو بند کر دیں جب سیف زون کو کم سے کم کر دیا جائے گا، تو سیف زون سے باہر کے کھلاڑیوں کو نقصان ہوتا رہے گا۔",
  T_48_META_API_90_D: "سیٹ کریں کہ آیا کھلاڑی آزادانہ طور پر باہر نکل سکتے ہیں۔",
  T_48_META_API_90_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_90_P1_D: "کیا آزادانہ طور پر باہر نکلنا ممکن ہے؟",
  T_48_META_API_9000_D: "ایک بلٹ ان UI بنائیں جسے صرف نامزد کھلاڑی ہی دیکھ سکیں",
  T_48_META_API_9000_P0_D: "بلٹ ان UI اداروں کو بنایا گیا۔",
  T_48_META_API_9000_P1_D: "کھلاڑی کی ہستی جس سے UI کا تعلق ہے، صرف اس کھلاڑی کو دکھائی دیتا ہے۔",
  T_48_META_API_9000_P2_D: "بلٹ ان UI اقسام",
  T_48_META_API_9001_D: "بلٹ ان گیم UI کو ہٹا دیں۔",
  T_48_META_API_9001_P0_D: "ہٹانے کے لیے بلٹ ان UI ہستی",
  T_48_META_API_9002_D: "مخصوص آئیکن کی قسم کا استعمال کرتے ہوئے ایک آئیکن بنائیں اگر مزید خصوصیات ہیں جو سیٹ کرنے کی ضرورت ہے، ہستی کے ذریعے اس کی ہستی کی خصوصیات کو مزید سیٹ کریں (متروک، براہ کرم CreateLevelObject استعمال کریں)",
  T_48_META_API_9002_P0_D: "کوڈ کو رسمی پیرامیٹر کے نام کی نمائندگی کرنے کے لیے استعمال کیا جاتا ہے جو آئیکن ہستی کو تخلیق کرتا ہے، اور اس کی متعلقہ مقامی متغیر قدر وہ ہستی ہے جو آئیکن کو تخلیق کرتی ہے۔",
  T_48_META_API_9002_P1_D: "یہ جس کھلاڑی کی ہستی سے تعلق رکھتا ہے، صرف اس کھلاڑی کو دکھائی دیتا ہے۔",
  T_48_META_API_9002_P2_D: "ریسورس پاتھ، ریسورس پاتھ جو کھلاڑی کے منتخب کردہ آئیکن سے مطابقت رکھتا ہے۔",
  T_48_META_API_9003_D: "مخصوص آئیکن کو ہٹا دیں (فرسودہ، براہ کرم DeleteEntity استعمال کریں)",
  T_48_META_API_9003_P0_D: "ہٹانے کے لیے آئیکن ہستی",
  T_48_META_API_9004_D: "مخصوص متن کے مواد کا استعمال کرتے ہوئے ایک متن بنائیں اگر مزید خصوصیات ہیں جو سیٹ کرنے کی ضرورت ہے، ہستی کے ذریعے اس کی ہستی کی خصوصیات کو مزید سیٹ کریں (متروک، براہ کرم CreateLevelObject استعمال کریں)",
  T_48_META_API_9004_P0_D: "کوڈ کو رسمی پیرامیٹر کے نام کی نمائندگی کرنے کے لیے استعمال کیا جاتا ہے جو ٹیکسٹ ہستی کو تخلیق کرتا ہے، اور اس کی متعلقہ مقامی متغیر قدر وہ ہستی ہے جو متن کو تخلیق کرتی ہے۔",
  T_48_META_API_9004_P1_D: "یہ جس کھلاڑی کی ہستی سے تعلق رکھتا ہے، صرف اس کھلاڑی کو دکھائی دیتا ہے۔",
  T_48_META_API_9004_P2_D: "متن کا مواد پیش کیا جانا ہے۔",
  T_48_META_API_9005_D: "مخصوص متن کو ہٹا دیں (فرسودہ، براہ کرم DeleteEntity استعمال کریں)",
  T_48_META_API_9005_P0_D: "ہٹانے کے لیے ٹیکسٹ ہستی",
  T_48_META_API_9006_D: "مخصوص اثر کی قسم کا استعمال کرتے ہوئے ایک آئیکن بنائیں اگر مزید خصوصیات ہیں جو سیٹ کرنے کی ضرورت ہے، ہستی کے ذریعے اس کی ہستی کی خصوصیات کو مزید سیٹ کریں (متروک، براہ کرم CreateEffect استعمال کریں)",
  T_48_META_API_9006_P0_D: "کوڈ کو رسمی پیرامیٹر کے نام کی نمائندگی کرنے کے لیے استعمال کیا جاتا ہے جو اسپیشل ایفیکٹ ہستی کو تخلیق کرتا ہے، اور اس کی متعلقہ مقامی متغیر قدر وہ ہستی ہے جو خصوصی اثر پیدا کرتی ہے۔",
  T_48_META_API_9006_P1_D: "یہ جس کھلاڑی کی ہستی سے تعلق رکھتا ہے، صرف اس کھلاڑی کو دکھائی دیتا ہے۔",
  T_48_META_API_9006_P2_D: "خصوصی اثر کی قسم، خصوصی اثرات کی قسم جسے کھلاڑی منتخب کر سکتے ہیں۔",
  T_48_META_API_9007_D: "مخصوص اثر کو ہٹا دیں (فرسودہ، براہ کرم DeleteEntity استعمال کریں)",
  T_48_META_API_9007_P0_D: "اثر ہستی کو ہٹانا ہے۔",
  T_48_META_API_9008_D: "ایک حسب ضرورت UI بنائیں جسے صرف نامزد کھلاڑی ہی دیکھ سکیں",
  T_48_META_API_9008_P0_D: "حسب ضرورت UI اداروں کو بنایا گیا۔",
  T_48_META_API_9008_P1_D: "کھلاڑی کی ہستی جس سے UI کا تعلق ہے، صرف اس کھلاڑی کو دکھائی دیتا ہے۔",
  T_48_META_API_9008_P2_D: "حسب ضرورت UI انڈیکس",
  T_48_META_API_9009_D: "حسب ضرورت گیم UI کو ہٹا دیں۔",
  T_48_META_API_9009_P0_D: "ہٹانے کے لیے حسب ضرورت UI ہستی",
  T_48_META_API_9010_D: "حسب ضرورت UI سے UI کنٹرول حاصل کریں۔",
  T_48_META_API_9010_P0_D: "پلیئر ہستی جس سے UI تعلق رکھتا ہے۔",
  T_48_META_API_9010_P1_D: "حسب ضرورت UI ادارے",
  T_48_META_API_9010_P2_D: "منفرد انڈیکس کو کنٹرول کریں۔",
  T_48_META_API_9010_R_D: "UI کنٹرول ادارہ",
  T_48_META_API_9011_D: "مخصوص صوتی اثر کو چلائیں اگر مزید خصوصیات ہیں جو سیٹ کرنے کی ضرورت ہے، اس کی ہستی کی خصوصیات کو ہستی کے ذریعے مزید سیٹ کریں (متروک، براہ کرم CreateSound استعمال کریں)",
  T_48_META_API_9011_P0_D: "کوڈ کو رسمی پیرامیٹر کے نام کی نمائندگی کرنے کے لیے استعمال کیا جاتا ہے جو صوتی اثر ہستی کو تخلیق کرتا ہے، اور اس کی متعلقہ مقامی متغیر قدر وہ ہستی ہے جو آواز کا اثر پیدا کرتی ہے۔",
  T_48_META_API_9011_P1_D: "یہ جس کھلاڑی کی ہستی سے تعلق رکھتا ہے، صرف اس کھلاڑی کو دکھائی دیتا ہے۔",
  T_48_META_API_9011_P2_D: "صوتی اثر کی قسم، صوتی اثرات کی وہ قسم جسے کھلاڑی منتخب کر سکتے ہیں۔",
  T_48_META_API_9012_D: "مخصوص صوتی اثر کو ہٹا دیں (فرسودہ، براہ کرم DeleteEntity استعمال کریں)",
  T_48_META_API_9012_P0_D: "صوتی ہستی جسے ہٹانا ہے۔",
  T_48_META_API_9013_D: "حسب ضرورت UI سے راستہ استعمال کرتے ہوئے UI کنٹرول حاصل کریں۔",
  T_48_META_API_9013_P0_D: "پلیئر ہستی جس سے UI تعلق رکھتا ہے۔",
  T_48_META_API_9013_P1_D: "حسب ضرورت UI",
  T_48_META_API_9013_P2_D: "کنٹرول کا راستہ",
  T_48_META_API_9013_R_D: "UI کنٹرول ادارہ",
  T_48_META_API_9014_D: "چلنے والی آواز کی ہستی میں خلل ڈالیں (فرسودہ، براہ کرم PauseSound استعمال کریں)",
  T_48_META_API_9014_P0_D: "ساؤنڈ ایفیکٹ ہستی جسے موقوف کرنے کی ضرورت ہے۔",
  T_48_META_API_9015_D: "ساؤنڈ ایفیکٹ چلانا جاری رکھیں، آپ انتخاب کر سکتے ہیں کہ آیا شروع سے ہی کھیلنا شروع کیا جائے (متروک، براہ کرم ResumeSound استعمال کریں)",
  T_48_META_API_9015_P0_D: "صوتی اثر والے ادارے جنہیں موقوف ہونے کے بعد کھیل جاری رکھنے کی ضرورت ہے۔",
  T_48_META_API_9015_P1_D: "چاہے شروع سے شروع کیا جائے۔",
  T_48_META_API_9016_D: "حسب ضرورت UI کنٹرولز بنائیں",
  T_48_META_API_9016_P0_D: "اپنی مرضی کے مطابق کنٹرول ادارہ بنایا",
  T_48_META_API_9016_P1_D: "کنٹرول کی قسم بنائی گئی۔",
  T_48_META_API_9016_P2_D: "UI ہستی سے تعلق رکھتا ہے۔",
  T_48_META_API_9016_P3_D: "پیرنٹ کنٹرول جس سے یہ تعلق رکھتا ہے اگر اسے خالی چھوڑ دیا جائے تو وہ UI ہستی جس سے یہ تعلق رکھتا ہے پیرنٹ نوڈ ہو گا۔",
  T_48_META_API_9017_D: "ٹارگٹ کیمرہ لیئر ماسک سیٹ کریں۔",
  T_48_META_API_9017_P0_D: "ہدف کیمرہ ہستی",
  T_48_META_API_9017_P1_D: "پرتوں کا ماسک، ٹارگٹ کیمرہ میں صرف بھری ہوئی تہوں کو دکھایا جائے گا، خالی چھوڑنے کا مطلب ہے کہ تمام پرتیں ظاہر ہوں گی۔",
  T_48_META_API_9018_D: "ٹارگٹ کیمرہ لیئر ماسک حاصل کریں۔",
  T_48_META_API_9018_P0_D: "ہدف کیمرہ ہستی",
  T_48_META_API_9018_R_D: "لیئر ماسک، صرف لیئر ماسک کے اندر موجود پرتیں ٹارگٹ کیمرے میں دکھائی دیں گی۔",
  T_48_META_API_9019_D: "سیٹ کریں کہ آیا مخصوص لیول ٹارگٹ کیمرہ کو نظر آتا ہے۔",
  T_48_META_API_9019_P0_D: "ہدف کیمرہ ہستی",
  T_48_META_API_9019_P1_D: "مرئیت کی سطح",
  T_48_META_API_9019_P2_D: "نظر آتا ہے یا نہیں؟",
  T_48_META_API_9020_D: "ٹارگٹ پلیئر کی ڈیفالٹ انٹرفیس کی مرئیت کی حالت سیٹ کریں۔",
  T_48_META_API_9020_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_9020_P1_D: "پلیئر انٹرفیس کی قسم پلیئر انٹرفیس کی قسم پلیئرز اور پلیئر سے متعلق مواد کو کنٹرول کرنے کے لیے استعمال ہونے والا UI عنصر ہے۔",
  T_48_META_API_9020_P2_D: "سوئچ ویلیو پلیئر انٹرفیس کی مرئیت کا تعین کرتی ہے۔",
  T_48_META_API_9021_D: "ٹائم اسٹیمپ لوکلائزڈ سٹرنگ بنائیں",
  T_48_META_API_9021_P0_D: "ٹائم اسٹیمپ",
  T_48_META_API_9021_P1_D: "فارمیٹنگ کا انداز",
  T_48_META_API_9021_R_D: "ٹائم اسٹیمپ لوکلائزیشن سٹرنگ",
  T_48_META_API_9022_D: "منی میپ آئیکن بنائیں",
  T_48_META_API_9022_P0_D: "منی میپ آئیکن ہستی بنائی گئی۔",
  T_48_META_API_9022_P1_D: "پلیئر سے تعلق رکھتا ہے بنایا گیا منی میپ آئیکن صرف اس کھلاڑی کو نظر آتا ہے۔",
  T_48_META_API_9022_P2_D: "منی میپ آئیکن ریسورس پاتھ",
  T_48_META_API_9023_D: "مخصوص اسپیشل ایفیکٹ ٹائپ کا استعمال کرتے ہوئے ایک آئیکن بنائیں اگر مزید پراپرٹیز سیٹ کرنے کی ضرورت ہے تو اس کی ہستی کی خصوصیات کو مزید سیٹ کریں۔",
  T_48_META_API_9023_P0_D: "کوڈ کو رسمی پیرامیٹر کے نام کی نمائندگی کرنے کے لیے استعمال کیا جاتا ہے جو اسپیشل ایفیکٹ ہستی کو تخلیق کرتا ہے، اور اس کی متعلقہ مقامی متغیر قدر وہ ہستی ہے جو خصوصی اثر پیدا کرتی ہے۔",
  T_48_META_API_9023_P1_D: "یہ جس کھلاڑی کی ہستی سے تعلق رکھتا ہے، صرف اس کھلاڑی کو دکھائی دیتا ہے۔",
  T_48_META_API_9023_P2_D: "خصوصی اثر کی قسم، خصوصی اثرات کی قسم جسے کھلاڑی منتخب کر سکتے ہیں۔",
  T_48_META_API_9024_D: "مخصوص اثر کو ہٹا دیں (فرسودہ، براہ کرم DeleteEntity استعمال کریں)",
  T_48_META_API_9024_P0_D: "اثر ہستی کو ہٹانا ہے۔",
  T_48_META_API_9025_D: "ٹارگٹ آبجیکٹ کے لیے نقشے پر جامد پکسلز بنائیں۔",
  T_48_META_API_9025_P0_D: "جامد پکسل ہستی بنائی گئی۔",
  T_48_META_API_9025_P1_D: "کھلاڑی سے تعلق رکھتا ہے، بنایا گیا جامد پکسل صرف کھلاڑی کو نظر آتا ہے۔",
  T_48_META_API_9025_P2_D: "ہدف آبجیکٹ ہستی",
  T_48_META_API_9026_D: "ہدف والے کھلاڑی کی minimap ہستی حاصل کریں۔",
  T_48_META_API_9026_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_9026_R_D: "موجودہ پلیئر کا چھوٹا نقشہ",
  T_48_META_API_9027_D: "کھلاڑی کے زوال کے نقصان کو اونچائی کے مطابق مقرر کیا جاسکتا ہے۔",
  T_48_META_API_9027_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_9027_P1_D: "انتہائی منقسم فہرست",
  T_48_META_API_9027_P2_D: "نقصان والے حصے کی فہرست",
  T_48_META_API_91_D: "ہدف کو مخصوص ٹیم میں شامل کرنے سے ہدف اصل ٹیم سے نکل جائے گا۔",
  T_48_META_API_91_P0_D: "اہداف جو ٹیم میں شامل کرنے کی ضرورت ہے۔",
  T_48_META_API_91_P1_D: "شامل ہونے والی ٹیمیں۔",
  T_48_META_API_91_P2_D: "کیا یہ کامیاب ہے؟",
  T_48_META_API_92_D: "ہدف کو نئی ٹیم میں شامل کرنے سے ہدف اصل ٹیم کو چھوڑ دے گا۔",
  T_48_META_API_92_P0_D: "اہداف جو ٹیم میں شامل کرنے کی ضرورت ہے۔",
  T_48_META_API_92_P1_D: "نئی ٹیم کا نام",
  T_48_META_API_92_P2_D: "کیا یہ کامیاب ہے؟",
  T_48_META_API_94_D: "Set the value of a local variable by index; before setting, the variable must be defined in the current call process ",
  T_48_META_API_94_P0: "Index",
  T_48_META_API_94_P0_D: "Get a variable by index ",
  T_48_META_API_94_P1: "Variable Value",
  T_48_META_API_94_P1_D: "Target variable value ",
  T_48_META_API_94_P2: "Arithmetic Type",
  T_48_META_API_94_P2_D: "Operation method; all types support assignment, and numeric types also support increment, decrement, multiplication, division, and modulus operations ",
  T_48_META_API_94_P3: "Variable Name",
  T_48_META_API_94_P3_D: "Target variable name. Used only for error output ",
  T_48_META_API_95: "Get Local Variable by Index",
  T_48_META_API_95_D: "Get the value of a local variable; before getting, the variable must be defined in the current call process ",
  T_48_META_API_95_P0: "Index",
  T_48_META_API_95_P0_D: "Variable index ",
  T_48_META_API_95_P1: "Variable Name",
  T_48_META_API_95_P1_D: "Target variable name. Used only for error output ",
  T_48_META_API_9500_D: "ٹارگٹ پلیئر کے کلائنٹ کو اسپیشل ایفیکٹ کھیلنے کے لیے مطلع کریں۔",
  T_48_META_API_9500_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_9500_P1_D: "خصوصی اثرات کے وسائل کا راستہ",
  T_48_META_API_9500_P2_D: "رنگ",
  T_48_META_API_9500_P3_D: "زوم سائز، ڈیفالٹ 1 ہے۔",
  T_48_META_API_9500_P4_D: "بائنڈنگ آبجیکٹ، خصوصی اثرات اس کے چائلڈ نوڈس کے طور پر منسلک ہوں گے۔",
  T_48_META_API_9500_P5_D: "باؤنڈ آبجیکٹ کے نسبت ورلڈ کوآرڈینیٹ آفسیٹ",
  T_48_META_API_9501_D: "ٹارگٹ پلیئر کے کلائنٹ کو ساؤنڈ ایفیکٹ چلانے کے لیے مطلع کرتا ہے۔",
  T_48_META_API_9501_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_9501_P1_D: "صوتی اثر کی قسم",
  T_48_META_API_9502_D: 'ٹارگٹ پلیئر کے کلائنٹ کو لفظ "تیرتا" ظاہر کرنے کے لیے مطلع کریں',
  T_48_META_API_9502_P0_D: "ہدف والے کھلاڑی",
  T_48_META_API_9502_P1_D: "پیاؤزی مواد",
  T_48_META_API_9502_P2_D: "تیرتے لفظ کا رنگ، قسم رنگ ہے۔",
  T_48_META_API_9502_P3_D: "ملی سیکنڈز میں تیرتے ہوئے حروف کا دورانیہ",
  T_48_META_API_9503_D: "ٹارگٹ یونٹ کو ایک بار ایموٹ ایکشن ایکسپریشن چلانے کا سبب بنتا ہے۔",
  T_48_META_API_9503_P0_D: "ایموٹ کھیلنے کا مقصد",
  T_48_META_API_9503_P1_D: "جذباتی قسم",
  T_48_META_API_9504_D: "یونٹ کے ایموٹ ایکشن ایکسپریشن کو موقوف/دوبارہ شروع کریں۔",
  T_48_META_API_9504_P0_D: "ایموٹ اہداف کو موقوف/دوبارہ شروع کریں۔",
  T_48_META_API_9504_P1_D: "درست: پلے بیک موقوف کریں، غلط: پلے بیک دوبارہ شروع کریں۔",
  T_48_META_EVT_1_D: "گیم شروع ہونے پر ٹرگر کیا جاتا ہے، سرور کلائنٹ سے کچھ دیر پہلے تیار ہو جائے گا۔",
  T_48_META_EVT_10_D: "موجودہ ہستی کو نقصان پہنچانے سے پہلے محرکات",
  T_48_META_EVT_10_P0_D: "حملہ آور ہستی، خالی ہو سکتی ہے۔",
  T_48_META_EVT_10_P1_D: "نقصان کی قسم",
  T_48_META_EVT_10_P2_D: "نقصان کی مقدار",
  T_48_META_EVT_10_P3_D: "زخمی حصہ",
  T_48_META_EVT_1000_D: "پلیئر پوائنٹس تبدیل ہونے پر متحرک ہوتا ہے۔",
  T_48_META_EVT_1000_P0_D: "وہ کھلاڑی جن کے پوائنٹس بدل گئے ہیں۔",
  T_48_META_EVT_1000_P1_D: "تبدیلی پوائنٹس کی قسم",
  T_48_META_EVT_1000_P2_D: "لازمی تبدیلی کے بعد انٹیگرل قدر",
  T_48_META_EVT_1001_D: "ٹیم پوائنٹس تبدیل ہونے پر متحرک ہوتا ہے۔",
  T_48_META_EVT_1001_P0_D: "پوائنٹس کے ساتھ ٹیمیں تبدیل ہوتی ہیں۔",
  T_48_META_EVT_1001_P1_D: "تبدیلی پوائنٹس کی قسم",
  T_48_META_EVT_1001_P2_D: "لازمی تبدیلی کے بعد انٹیگرل قدر",
  T_48_META_EVT_1002_D: "پلیئر کی رینکنگ تبدیل ہونے پر متحرک ہوتا ہے۔",
  T_48_META_EVT_1002_P0_D: "وہ کھلاڑی جن کی رینکنگ تبدیل ہوتی ہے۔",
  T_48_META_EVT_1002_P1_D: "درجہ بندی میں تبدیلی کے بعد درجہ بندی",
  T_48_META_EVT_1003_D: "فرسودہ",
  T_48_META_EVT_1003_P0_D: "فرسودہ",
  T_48_META_EVT_1003_P1_D: "درجہ بندی میں تبدیلی کے بعد درجہ بندی",
  T_48_META_EVT_11_D: "جب کھلاڑی باہر نکلتا ہے تو فائر ہوتا ہے۔",
  T_48_META_EVT_11_P0_D: "چھوڑنے والے کھلاڑی",
  T_48_META_EVT_12_D: "جب پلیئر کنٹرولر کسی ہستی کو چھوتا ہے تو یہ تب ہی متحرک ہوتا ہے جب کنٹرولر فعال طور پر حرکت کرتا ہے۔",
  T_48_META_EVT_12_P0_D: "اداروں کا سامنا ہوا۔",
  T_48_META_EVT_13_D: "موجودہ ہستی کو نقصان پہنچانے سے پہلے محرکات",
  T_48_META_EVT_13_P0_D: "نقصان اٹھانے والا ادارہ",
  T_48_META_EVT_13_P1_D: "نقصان کی قسم",
  T_48_META_EVT_13_P2_D: "نقصان کی مقدار",
  T_48_META_EVT_13_P3_D: "زخمی حصہ",
  T_48_META_EVT_14_D: "ہر بار چلنے کے قابل ہستی کے لوپ ہونے پر ٹرگر کیا جاتا ہے جب پلے ایبل ہستی ایک ساؤنڈ ایفیکٹ، اسپیشل ایفیکٹ وغیرہ ہوتی ہے، یہ ایونٹ صرف کلائنٹ پر اثر انداز ہوتا ہے۔",
  T_48_META_EVT_2_D: "جب منطقی فریم کو اپ ڈیٹ کیا جاتا ہے تو اس ایونٹ کے ٹرگر ہونے کی فریکوئنسی پلیٹ فارم اور سیٹنگز کے لحاظ سے مختلف ہوتی ہے۔",
  T_48_META_EVT_2002_D: "جب کھلاڑی مر جاتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_2002_P0_D: "مردہ کھلاڑی",
  T_48_META_EVT_2003_D: "جب کوئی کھلاڑی مدد کرتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_2003_P0_D: "وہ کھلاڑی جنہوں نے معاونت حاصل کی۔",
  T_48_META_EVT_2003_P1_D: "مارے گئے کھلاڑی",
  T_48_META_EVT_2004_D: "جب کھلاڑی نقصان پہنچاتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_2004_P0_D: "کھلاڑی جس نے نقصان پہنچایا",
  T_48_META_EVT_2004_P1_D: "جن کھلاڑیوں کو نقصان پہنچا",
  T_48_META_EVT_2004_P2_D: "نقصان کی قسم",
  T_48_META_EVT_2004_P3_D: "نقصان پہنچانا",
  T_48_META_EVT_2004_P4_D: "زخمی حصہ",
  T_48_META_EVT_2005_D: "اس وقت متحرک ہوتا ہے جب کوئی کھلاڑی قتل کا سبب بنتا ہے۔",
  T_48_META_EVT_2005_P0_D: "وہ کھلاڑی جو قتل کا سبب بنا",
  T_48_META_EVT_2005_P1_D: "مارے گئے کھلاڑی",
  T_48_META_EVT_2005_P2_D: "نقصان کی قسم",
  T_48_META_EVT_2006_D: "جب کوئی کھلاڑی گیم میں شامل ہوتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_2006_P0_D: "کھیل میں شامل ہونے والے کھلاڑی",
  T_48_META_EVT_2007_D: "جب کھلاڑی کو زندہ کیا جاتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_2007_P0_D: "دوبارہ زندہ کھلاڑی",
  T_48_META_EVT_2007_P1_D: "قیامت کا ذریعہ",
  T_48_META_EVT_2008_D: "اس وقت متحرک ہوتا ہے جب کھلاڑی کو گرایا جاتا ہے۔",
  T_48_META_EVT_2008_P0_D: "گرا ہوا کھلاڑی",
  T_48_META_EVT_2008_P1_D: "حملہ آور کھلاڑی",
  T_48_META_EVT_2009_D: "پلیئر کے منقطع ہونے پر فائر ہوتا ہے۔",
  T_48_META_EVT_2009_P0_D: "منقطع کھلاڑی",
  T_48_META_EVT_2010_D: "جب کھلاڑی دوبارہ جڑتا ہے تو فائر ہوتا ہے۔",
  T_48_META_EVT_2010_P0_D: "کھلاڑی دوبارہ جڑ رہے ہیں۔",
  T_48_META_EVT_2100_D: "جب ٹیم کو ہٹا دیا جاتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_2100_P0_D: "ہٹا دیا ٹیم",
  T_48_META_EVT_2101_D: "ٹیم کو شامل کرتے وقت متحرک کیا گیا۔",
  T_48_META_EVT_2101_P0_D: "ٹیمیں شامل کیں۔",
  T_48_META_EVT_2102_D: "جب ٹیم تباہ ہو جاتی ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_2102_P0_D: "جس ٹیم کا صفایا ہو گیا۔",
  T_48_META_EVT_3_D: "گیم ختم ہونے پر فائر ہو جاتا ہے اس ایونٹ کو سرور پر گیم ختم ہونے سے پہلے فائر کر دیا جاتا ہے۔",
  T_48_META_EVT_30_D: "جب منظر کامیابی کے ساتھ لوڈ ہو جاتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_30_P0_D: "منظر کا نام",
  T_48_META_EVT_3000_D: "موجودہ وجود کے بننے کے بعد آگ لگ جاتی ہے۔",
  T_48_META_EVT_3001_D: "موجودہ ہستی کے تباہ ہونے سے پہلے ٹرگر کیا گیا۔",
  T_48_META_EVT_3002_D: "جب کھلاڑی ٹرگر میں داخل ہوتا ہے تو فائر ہوتا ہے۔",
  T_48_META_EVT_3002_P0_D: "پلیئر ٹرگر میں داخل ہو رہا ہے۔",
  T_48_META_EVT_3003_D: "فائر اس وقت ہوتا ہے جب کھلاڑی ٹرگر چھوڑ دیتا ہے۔",
  T_48_META_EVT_3003_P0_D: "کھلاڑی ٹرگر چھوڑ رہا ہے۔",
  T_48_META_EVT_3004_D: "UI بٹن کنٹرول پر کلک کرنے کے بعد فائر کر دیا گیا۔",
  T_48_META_EVT_3004_P0_D: "وہ کھلاڑی جس نے کلک کیا۔",
  T_48_META_EVT_3005_D: "بلٹ ان UI میں ایک بٹن پر کلک کرنے پر فائر کیا جاتا ہے۔",
  T_48_META_EVT_3005_P0_D: "کلک کردہ بٹن کنٹرول کا نام",
  T_48_META_EVT_3006_D: "اس وقت متحرک ہوتا ہے جب کھلاڑی ویک بورڈ استعمال کر رہا ہو۔",
  T_48_META_EVT_3007_D: "موجودہ وجود کے دستیاب ہونے کے بعد آگ لگ جاتی ہے۔",
  T_48_META_EVT_3008_D: "موجودہ ہستی کے دستیاب نہ ہونے کے بعد آگ لگتی ہے۔",
  T_48_META_EVT_3009_D: "جب ہستی ٹرگر میں داخل ہوتی ہے، تو دونوں فریقوں کو ایونٹ موصول ہوتا ہے اور دوسری پارٹی کو ٹرگر ہونا چاہیے۔",
  T_48_META_EVT_3009_P0_D: "کاؤنٹر پارٹی ہستی جب ٹرگر ایونٹ ہوتا ہے۔",
  T_48_META_EVT_3010_D: "جب ہستی ٹرگر چھوڑ دیتی ہے تو دونوں فریقوں کو ایونٹ موصول ہوتا ہے اور دوسری پارٹی کا ٹرگر ہونا ضروری ہے۔",
  T_48_META_EVT_3010_P0_D: "کاؤنٹر پارٹی ہستی جب ٹرگر ایونٹ ہوتا ہے۔",
  T_48_META_EVT_3011_D: "موجودہ ہستی کے تباہ ہونے کے بعد متحرک کیا جاتا ہے۔",
  T_48_META_EVT_3011_P0_D: "حملہ آور ہستی، خالی ہو سکتی ہے۔",
  T_48_META_EVT_3011_P1_D: "نقصان کی قسم",
  T_48_META_EVT_3011_P2_D: "زخمی حصہ",
  T_48_META_EVT_3012_D: "موجودہ ہستی پر حملہ کرنے کے بعد متحرک ہوا۔",
  T_48_META_EVT_3012_P0_D: "حملہ آور ہستی، خالی ہو سکتی ہے۔",
  T_48_META_EVT_3012_P1_D: "نقصان کی قسم",
  T_48_META_EVT_3012_P2_D: "نقصان کی مقدار",
  T_48_META_EVT_3012_P3_D: "زخمی حصہ",
  T_48_META_EVT_3013_D: "موجودہ ہستی کو نقصان پہنچانے کے بعد محرکات",
  T_48_META_EVT_3013_P0_D: "نقصان اٹھانے والا ادارہ",
  T_48_META_EVT_3013_P1_D: "نقصان کی قسم",
  T_48_META_EVT_3013_P2_D: "نقصان کی مقدار",
  T_48_META_EVT_3013_P3_D: "زخمی حصہ",
  T_48_META_EVT_3014_D: "موجودہ ہستی کے دیگر اداروں کو تباہ کرنے کے بعد متحرک ہوتا ہے۔",
  T_48_META_EVT_3014_P0_D: "تباہ شدہ ہستی",
  T_48_META_EVT_3014_P1_D: "زخمی حصہ",
  T_48_META_EVT_3015_D: "جب کھلاڑی کو دوبارہ زندہ کیا جاتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3015_P0_D: "پلیئر قیامت کے ماخذ کی قسم",
  T_48_META_EVT_3016_D: "جب جنریٹر ایک ہستی پیدا کرتا ہے تو فائر ہوتا ہے۔",
  T_48_META_EVT_3016_P0_D: "تیار کردہ ہستی کی فہرست",
  T_48_META_EVT_3016_P1_D: "لہر نمبر",
  T_48_META_EVT_3017_D: "جب کھلاڑی گھٹنے ٹیکنے کی پوزیشن میں داخل ہوتا ہے تو اسے کال کیا جاتا ہے۔",
  T_48_META_EVT_3018_D: "جب ٹیم کے تمام ممبران مر جاتے ہیں تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3019_D: "ہیلمٹ، باڈی آرمر یا بیگ سے لیس ہونے پر متحرک ہوتا ہے۔",
  T_48_META_EVT_3019_P0_D: "آلات کی شناخت",
  T_48_META_EVT_3020_D: "ابتدائی، ثانوی یا ہنگامہ خیز ہتھیار رکھنے پر متحرک ہوتا ہے، بشمول مٹھی میں سوئچ کرتے وقت",
  T_48_META_EVT_3020_P0_D: "متحرک ہونے پر ہتھیاروں سے لیس ادارہ",
  T_48_META_EVT_3021_D: "پروپ استعمال کرنے کے بعد ٹرگر کیا جاتا ہے جس کے لیے وقت درکار ہوتا ہے استعمال کے مکمل ہونے کے بعد اس ایونٹ کو متحرک کرتا ہے۔",
  T_48_META_EVT_3021_P0_D: "پروپ ID",
  T_48_META_EVT_3021_P1_D: "prop entity، خالی ہو سکتی ہے۔",
  T_48_META_EVT_3021_P2_D: "پرپس کا استعمال کرتے ہوئے تخلیق کردہ نئی پروپ ہستی، خالی ہوسکتی ہے۔",
  T_48_META_EVT_3022_D: "جب کوئی آئٹم حاصل ہوتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3022_P0_D: "آئٹم کی قسم",
  T_48_META_EVT_3022_P1_D: "آئٹم ہستی، خالی ہو سکتی ہے۔",
  T_48_META_EVT_3023_D: "جب ہستی کا سکور تبدیل ہوتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3023_P0_D: "تبدیلی پوائنٹس کی قسم",
  T_48_META_EVT_3023_P1_D: "لازمی تبدیلی کے بعد انٹیگرل قدر",
  T_48_META_EVT_3024_D: "ٹرگر ہوتا ہے جب کسی ہستی کا درجہ تبدیل ہوتا ہے۔",
  T_48_META_EVT_3024_P0_D: "درجہ بندی میں تبدیلی کے بعد درجہ بندی",
  T_48_META_EVT_3025_D: "مدد پر محرک",
  T_48_META_EVT_3025_P0_D: "وہ شے جو ماری گئی۔",
  T_48_META_EVT_3026_D: "جب کوئی ہستی گاڑی میں داخل ہوتی ہے، بشمول ڈرائیور اور مسافر کے طور پر",
  T_48_META_EVT_3026_P0_D: "گاڑی میں داخل ہونے والی ہستی",
  T_48_META_EVT_3026_P1_D: "گاڑی میں داخل ہونا",
  T_48_META_EVT_3027_D: "اس وقت متحرک ہوتا ہے جب ہستی گاڑی سے نکلتی ہے۔",
  T_48_META_EVT_3027_P0_D: "گاڑی کو چھوڑنے والا ادارہ",
  T_48_META_EVT_3027_P1_D: "روانہ ہونے والی گاڑی",
  T_48_META_EVT_3028_D: "اس وقت متحرک ہوتا ہے جب ہستی گاڑی چلا رہی ہو اور گاڑی میں ڈرائیور ہو۔",
  T_48_META_EVT_3028_P0_D: "وہ ہستی جو گاڑی چلاتی ہے۔",
  T_48_META_EVT_3028_P1_D: "گاڑی چلانا",
  T_48_META_EVT_3029_D: "ٹرگر ہوتا ہے جب گاڑی کسی ہستی کے ذریعے داخل ہوتی ہے۔",
  T_48_META_EVT_3029_P0_D: "ٹرگر ہستی",
  T_48_META_EVT_3030_D: "گاڑی کی ہستی کے جانے پر ٹرگر ہوتا ہے۔",
  T_48_META_EVT_3030_P0_D: "ٹرگر ہستی",
  T_48_META_EVT_3031_D: "اس وقت متحرک ہوتا ہے جب گاڑی کسی ہستی کے ذریعے چلائی جاتی ہے۔",
  T_48_META_EVT_3031_P0_D: "ٹرگر ہستی",
  T_48_META_EVT_3032_D: "ہستی کے ٹیلی پورٹ کرنے کے لیے پورٹل استعمال کرنے کے بعد متحرک ہوا (متروک، براہ کرم OnBouncesOffTire استعمال کریں)",
  T_48_META_EVT_3032_P0_D: "پورٹل استعمال کرنے والے ادارے",
  T_48_META_EVT_3032_P1_D: "پورٹل استعمال کیا گیا۔",
  T_48_META_EVT_3033_D: "اس وقت متحرک ہوتا ہے جب ہستی باؤنس ہوتی ہے۔",
  T_48_META_EVT_3033_P0_D: "ٹرگر ہستی",
  T_48_META_EVT_3033_P1_D: "اچھلنے والی چیز کا استعمال کیا گیا۔",
  T_48_META_EVT_3034_D: "پورٹل ہستی کو ٹیلی پورٹ کرنے کے بعد متحرک ہوا۔",
  T_48_META_EVT_3034_P0_D: "ترسیل کرنے والا ادارہ",
  T_48_META_EVT_3035_D: "ٹائر ہستی کو اچھالنے کے بعد متحرک ہوتا ہے۔",
  T_48_META_EVT_3035_P0_D: "اچھالنے والی ہستی",
  T_48_META_EVT_3036_D: "اس وقت متحرک ہوتا ہے جب میکانزم ہستی کو ہوا میں دستک دیتا ہے۔",
  T_48_META_EVT_3036_P0_D: "وہ ہستیاں جو دستک دی گئیں۔",
  T_48_META_EVT_3036_P1_D: "مکینیکل اشیاء",
  T_48_META_EVT_3037_D: "فائر اس وقت ہوتا ہے جب کوئی ہستی محرک میں داخل ہوتی ہے۔",
  T_48_META_EVT_3037_P0_D: "اندراج کا محرک",
  T_48_META_EVT_3038_D: "فائر تب ہوتا ہے جب کوئی ہستی ٹرگر چھوڑ دیتی ہے۔",
  T_48_META_EVT_3038_P0_D: "روانگی کا محرک",
  T_48_META_EVT_3039_D: "اس وقت متحرک ہوتا ہے جب کوئی ہتھیار حاصل کیا جاتا ہے۔",
  T_48_META_EVT_3039_P0_D: "ہتھیار کا ادارہ",
  T_48_META_EVT_3040_D: "اس وقت متحرک ہوتا ہے جب ہستی کو میکانزم کے ذریعے دستک دیا جاتا ہے۔",
  T_48_META_EVT_3040_P0_D: "وہ ہستیاں جو دستک دی گئیں۔",
  T_48_META_EVT_3040_P1_D: "مکینیکل اشیاء",
  T_48_META_EVT_3041_D: "قابل ہدف ہستی کو نشانہ بناتے وقت متحرک ہوتا ہے۔",
  T_48_META_EVT_3041_P0_D: "ھدف شدہ ادارہ",
  T_48_META_EVT_3042_D: "جب کسی کھلاڑی کو نشانہ بنایا جاتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3042_P0_D: "کھلاڑی مقصد لے رہا ہے۔",
  T_48_META_EVT_3043_D: "جب گولی نشانے پر لگتی ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3043_P0_D: "ہدف مارا",
  T_48_META_EVT_3043_P1_D: "جہاں گولی لگی اس کی دنیا کوآرڈینیٹ",
  T_48_META_EVT_3044_D: "کسی ہتھیار سے ٹکرانے پر متحرک",
  T_48_META_EVT_3044_P0_D: "ہتھیار",
  T_48_META_EVT_3044_P1_D: "متاثرہ علاقے کے عالمی نقاط",
  T_48_META_EVT_3045_D: "اس وقت متحرک ہوتا ہے جب کھلاڑی اس سطح میں کسی چیز میں تبدیل ہونے کا انتخاب کرتا ہے۔",
  T_48_META_EVT_3045_P0_D: "کھلاڑی ایک ہستی میں تبدیل ہوتا ہے، نہ کہ منظر آبجیکٹ میں",
  T_48_META_EVT_3046_D: "جب کھلاڑی اس ریسپون پوائنٹ پر دوبارہ زندہ ہوتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3046_P0_D: "اس respawn پوائنٹ پر کھلاڑی دوبارہ زندہ ہو گئے۔",
  T_48_META_EVT_3047_D: "جب کھلاڑی ہتھیار چھوڑتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3047_P0_D: "مسترد شدہ ہتھیار کا ادارہ",
  T_48_META_EVT_3048_D: "اس وقت متحرک ہوتا ہے جب کھلاڑی ہتھیار کے علاوہ کوئی چیز گرا دیتا ہے۔",
  T_48_META_EVT_3048_P0_D: "آئٹم کی قسم",
  T_48_META_EVT_3048_P1_D: "آئٹم ہستی، خالی ہو سکتی ہے۔",
  T_48_META_EVT_3049_D: "فٹ بال بندوق سے ٹکرانے پر متحرک",
  T_48_META_EVT_3049_P0_D: "کھلاڑی",
  T_48_META_EVT_3049_P1_D: "مارنے کے بعد رفتار",
  T_48_META_EVT_3050_D: "جب فٹ بال کسی ہستی سے ٹکراتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3050_P0_D: "تصادم آبجیکٹ",
  T_48_META_EVT_3050_P1_D: "تصادم کے بعد رفتار",
  T_48_META_EVT_3051_D: "جب پلیئر کامیابی کے ساتھ صوتی چینل میں شامل ہوتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3051_P0_D: "وائس چینل ہستی",
  T_48_META_EVT_3052_D: "اس وقت متحرک ہوتا ہے جب کوئی کھلاڑی صوتی چینل میں شامل ہونے میں ناکام ہوتا ہے۔",
  T_48_META_EVT_3052_P0_D: "وائس چینل ہستی",
  T_48_META_EVT_3053_D: "جب پلیئر صوتی چینل سے باہر نکلتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3053_P0_D: "وائس چینل ہستی",
  T_48_META_EVT_3054_D: "جب فٹ بال گول میں داخل ہوتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3054_P0_D: "مقصد",
  T_48_META_EVT_3054_P1_D: "اسکورر، گول کرنے سے پہلے گیند کو چھونے والا آخری کھلاڑی",
  T_48_META_EVT_3054_P2_D: "اسسٹر، آخری کھلاڑی جو گول میں داخل ہونے سے پہلے گیند کو چھوتا ہے۔",
  T_48_META_EVT_3055_D: "جب کھلاڑی فائر بٹن دباتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3056_D: "جب کھلاڑی چھلانگ لگاتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3057_D: "جب کھلاڑی جھک رہا ہوتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3058_D: "جب کھلاڑی شکار ہوتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3059_D: "جب پلیئر سپرنٹ کرتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3060_D: "اس وقت متحرک ہوتا ہے جب اسٹور میں کوئی آئٹم کامیابی سے خریدی جاتی ہے۔",
  T_48_META_EVT_3060_P0_D: "وہ کھلاڑی جو سامان خریدتے ہیں۔",
  T_48_META_EVT_3060_P1_D: "اجناس",
  T_48_META_EVT_3061_D: "اس وقت متحرک ہوتا ہے جب کھلاڑی کے ذریعہ ہتھیار لیس ہوتا ہے۔",
  T_48_META_EVT_3061_P0_D: "ہتھیاروں سے لیس کھلاڑی",
  T_48_META_EVT_3062_D: "جب ایک یونٹ اس ہتھیار سے مارا جاتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3062_P0_D: "ہلاک شدہ ہستی",
  T_48_META_EVT_3063_D: "جب یہ ہتھیار کسی یونٹ کو نقصان پہنچانے کے لیے استعمال ہوتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3063_P0_D: "نقصان پہنچانے والا ادارہ",
  T_48_META_EVT_3063_P1_D: "نقصان پہنچانا",
  T_48_META_EVT_3064_D: "جب ہتھیار گولیوں کو تبدیل کرتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3065_D: "جب کوئی ہستی گاڑی میں داخل ہوتی ہے تو اس واقعہ کو ڈرائیور یا مسافر کے طور پر متحرک کیا جا سکتا ہے۔",
  T_48_META_EVT_3065_P0_D: "گاڑی میں داخل ہونا",
  T_48_META_EVT_3066_D: "اس وقت متحرک ہوتا ہے جب ہستی گاڑی سے نکلتی ہے۔",
  T_48_META_EVT_3066_P0_D: "روانہ ہونے والی گاڑی",
  T_48_META_EVT_3067_D: "اس وقت متحرک ہوتا ہے جب کوئی ہستی گاڑی چلاتی ہے۔",
  T_48_META_EVT_3067_P0_D: "گاڑی چلانا",
  T_48_META_EVT_3068_D: "پورٹل کا استعمال کرتے ہوئے کسی ہستی کے ٹیلی پورٹ کے بعد متحرک ہوا۔",
  T_48_META_EVT_3068_P0_D: "پورٹل استعمال کیا گیا۔",
  T_48_META_EVT_3069_D: "ٹائر کی طرف سے ہستی کو اچھالنے کے بعد متحرک ہوتا ہے۔",
  T_48_META_EVT_3069_P0_D: "استعمال شدہ ٹائر",
  T_48_META_EVT_3070_D: "اس وقت متحرک ہوتا ہے جب ہستی کو میکانزم کے ذریعے دستک دیا جاتا ہے۔",
  T_48_META_EVT_3070_P0_D: "مکینیکل اشیاء",
  T_48_META_EVT_3071_D: "پلیئر کے ذریعہ UI بٹن کنٹرول کو دبانے کے بعد متحرک ہوتا ہے۔",
  T_48_META_EVT_3071_P0_D: "ٹرگر پلیئر",
  T_48_META_EVT_3072_D: "UI بٹن کے کنٹرول کو اٹھانے کے بعد آگ لگ جاتی ہے۔",
  T_48_META_EVT_3072_P0_D: "ٹرگر پلیئر",
  T_48_META_EVT_3073_D: "پلیئر کے ذریعہ UI بٹن کنٹرول پر ڈبل کلک کرنے کے بعد متحرک ہوتا ہے۔",
  T_48_META_EVT_3073_P0_D: "ٹرگر پلیئر",
  T_48_META_EVT_3074_D: "جیل بریک کا علاقہ شروع ہوتا ہے۔",
  T_48_META_EVT_3075_D: "جیل بریک ایریا کا اختتام",
  T_48_META_EVT_3076_D: "جب کھلاڑی ویک بورڈ کا استعمال بند کر دیتا ہے تو ٹرگر ہوتا ہے۔",
  T_48_META_EVT_3077_D: "جب پلیئر کے ذریعہ UI ان پٹ باکس کنٹرول کے متنی مواد کو تبدیل کیا جاتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3077_P0_D: "ٹرگر پلیئر",
  T_48_META_EVT_3077_P1_D: "متن کا مواد تبدیل کر دیا گیا۔",
  T_48_META_EVT_3078_D: "فائر اس وقت ہوتا ہے جب کوئی کھیلنے کے قابل ہستی کھیلنا شروع کرتی ہے۔",
  T_48_META_EVT_3078_P0_D: "کھیلنے کے قابل ہستی",
  T_48_META_EVT_3079_D: "جب چلائے جانے کے قابل ہستی کا چلنا ختم ہو جاتا ہے تو اس کا اثر صرف کلائنٹ پر ہوتا ہے۔",
  T_48_META_EVT_3079_P0_D: "کھیلنے کے قابل ہستی",
  T_48_META_EVT_3080_D: "فائر اس وقت ہوتا ہے جب کھیلنے کے قابل ہستی کھیلنا جاری رکھتی ہے۔",
  T_48_META_EVT_3080_P0_D: "کھیلنے کے قابل ہستی",
  T_48_META_EVT_3081_D: "جب پلے ایبل ہستی پلے بیک کو روکتی ہے تو ٹرگر ہوتا ہے۔",
  T_48_META_EVT_3081_P0_D: "کھیلنے کے قابل ہستی",
  T_48_META_EVT_3082_D: "جیل ٹوٹنے والے کھلاڑی شامل ہو گئے۔",
  T_48_META_EVT_3082_P0_D: "ٹرگر پلیئر",
  T_48_META_EVT_3083_D: "جیل ٹوٹنے والے کھلاڑی باہر نکلتے ہیں۔",
  T_48_META_EVT_3083_P0_D: "ٹرگر پلیئر",
  T_48_META_EVT_3084_D: "الٹی گنتی کے اختتام پر فائر",
  T_48_META_EVT_3084_P0_D: "مالک ہستی",
  T_48_META_EVT_3085_D: "جب کوئی آئٹم اٹھایا جاتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3085_P0_D: "وہ کھلاڑی جس نے اس چیز کو اٹھایا",
  T_48_META_EVT_3086_D: "جب کسی آئٹم کو گرایا جاتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3086_P0_D: "وہ کھلاڑی جس نے آئٹم کو گرایا",
  T_48_META_EVT_3087_D: "جب یہ آئٹم لیس ہوتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3088_D: "جب کان بننے کے بعد آبجیکٹ شروع ہوتا ہے تو آگ لگ جاتی ہے۔",
  T_48_META_EVT_3089_D: "آگ اس وقت لگتی ہے جب کان بننے کے بعد شے متحرک ہوتی ہے۔",
  T_48_META_EVT_3089_P0_D: "کان بننے کے بعد آبجیکٹ کے ہدف کو متحرک کریں۔",
  T_48_META_EVT_3090_D: "اسٹور میں اشیاء خریدنے سے پہلے متحرک",
  T_48_META_EVT_3090_P0_D: "وہ کھلاڑی جو سامان خریدتے ہیں۔",
  T_48_META_EVT_3090_P1_D: "اجناس",
  T_48_META_EVT_3091_D: "جب یہ آلہ استعمال میں ہو تو فائر ہو جاتا ہے۔",
  T_48_META_EVT_3092_D: "جب گریپل گن سے فائر کیا جاتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3093_D: "اس وقت متحرک ہوتا ہے جب پروجیکٹائل پھینکے جانے کے بعد پھٹ جاتا ہے۔",
  T_48_META_EVT_3093_P0_D: "دھماکے کا مقام",
  T_48_META_EVT_3094_D: "اسپرے گن سے ٹکرانے پر متحرک",
  T_48_META_EVT_3094_P0_D: "سپرے بندوق ہستی",
  T_48_META_EVT_3094_P1_D: "ہٹ پوائنٹ",
  T_48_META_EVT_3094_P2_D: "عام مارو",
  T_48_META_EVT_3095_D: "پینٹ گن سے ٹکرانے پر متحرک ہوا۔",
  T_48_META_EVT_3095_P0_D: "اعتراض کو مارو",
  T_48_META_EVT_3095_P1_D: "ہٹ پوائنٹ",
  T_48_META_EVT_3095_P2_D: "عام مارو",
  T_48_META_EVT_3096_D: "جب گاڑی یا ڈائی بیرل پھٹتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3096_P0_D: "وہ کھلاڑی جس نے دھماکہ کیا۔",
  T_48_META_EVT_3096_P1_D: "دھماکے سے متاثر ہونے والے کھلاڑیوں کی فہرست",
  T_48_META_EVT_3097_D: "جب ہتھیار گولی چلانا بند کر دیتا ہے تو فائر کرتا ہے۔",
  T_48_META_EVT_3097_P0_D: "گولی باری روکنے پر موجودہ میگزین میں گولہ بارود کی مقدار باقی ہے۔",
  T_48_META_EVT_3098_D: "اس وقت متحرک ہوتا ہے جب تعاقب کا ہدف تعاقب کی حد میں داخل ہوتا ہے۔",
  T_48_META_EVT_3099_D: "اس وقت متحرک ہوتا ہے جب تعاقب کا ہدف تعاقب کی حد سے نکل جاتا ہے۔",
  T_48_META_EVT_31_D: "منظر سوئچ کے کامیاب ہونے پر ٹرگر ہوتا ہے۔",
  T_48_META_EVT_31_P0_D: "منظر کا نام",
  T_48_META_EVT_3100_D: "اس وقت متحرک ہوتا ہے جب حملے کا ہدف حملے کی حد میں داخل ہوتا ہے۔",
  T_48_META_EVT_3101_D: "اس وقت متحرک ہوتا ہے جب حملے کا ہدف حملے کی حد سے نکل جاتا ہے۔",
  T_48_META_EVT_3102_D: "یہ واقعہ اس وقت شروع ہوتا ہے جب کیمرہ رے کا پتہ لگانے کو کلائنٹ کلک ایونٹ کے ذریعے متحرک کیا جاتا ہے۔",
  T_48_META_EVT_3102_P0_D: "ٹرگر پلیئر",
  T_48_META_EVT_3102_P1_D: "آیا کیمرے کی کرن آبجیکٹ سے ٹکراتی ہے۔",
  T_48_META_EVT_3102_P2_D: "کیمرہ کی شعاع مقام سے ٹکراتی ہے۔",
  T_48_META_EVT_3102_P3_D: "کلائنٹ کیمرہ واقفیت",
  T_48_META_EVT_3102_P4_D: "کلائنٹ کیمرہ پوزیشن",
  T_48_META_EVT_3102_P5_D: "ہستی کو مارو",
  T_48_META_EVT_3103_D: "سٹور انٹرفیس کھلنے پر متحرک ہوتا ہے۔",
  T_48_META_EVT_3103_P0_D: "ٹرگر پلیئر",
  T_48_META_EVT_3104_D: "اسٹور انٹرفیس بند ہونے پر ٹرگر ہوتا ہے۔",
  T_48_META_EVT_3104_P0_D: "ٹرگر پلیئر",
  T_48_META_EVT_3105_D: "جب برتاؤ کے درخت کی منطق اس نوڈ میں داخل ہوتی ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3105_P0_D: "نوڈ کا نام",
  T_48_META_EVT_3105_P1_D: "مالک ہستی",
  T_48_META_EVT_3106_D: "جب رویے کے درخت کی منطق نوڈ سے باہر نکلتی ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3106_P0_D: "نوڈ کا نام",
  T_48_META_EVT_3106_P1_D: "مالک ہستی",
  T_48_META_EVT_3107_D: "جب سخت جسم بیدار ہوتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3108_D: "جب سخت جسم سو جاتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3109_D: "جب کھلاڑی حرکت کرتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3109_P0_D: "رویہ",
  T_48_META_EVT_3110_D: "جب کھلاڑی بیکار ہوتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3110_P0_D: "رویہ",
  T_48_META_EVT_3111_D: "اس وقت متحرک ہوتا ہے جب کھلاڑی کسی مہارت کا استعمال کرتا ہے۔",
  T_48_META_EVT_3111_P0_D: "مہارتیں استعمال کیں۔",
  T_48_META_EVT_3112_D: "جب کھلاڑی سپرنٹنگ مکمل کرتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3113_D: "SwitchEquipSlot کی گنتی کے تحت سلاٹ سے متعلقہ آئٹم حاصل کرتے وقت متحرک",
  T_48_META_EVT_3113_P0_D: "حاصل کردہ آئٹم ہستی",
  T_48_META_EVT_3114_D: "ہینڈ ہیلڈ آئٹمز کو سوئچ کرتے وقت متحرک ہوتا ہے، بشمول مٹھی میں سوئچ کرتے وقت",
  T_48_META_EVT_3114_P0_D: "سوئچ کرنے کے بعد رکھی ہوئی شے کی ہستی",
  T_48_META_EVT_3115_D: "اس وقت متحرک ہوتا ہے جب اسٹور میں کوئی کھلاڑی دوسروں سے سامان خریدنے کی درخواست کرتا ہے۔",
  T_48_META_EVT_3115_P0_D: "وہ کھلاڑی جس نے پروڈکٹ کی درخواست کی۔",
  T_48_META_EVT_3115_P1_D: "اجناس",
  T_48_META_EVT_3116_D: "اس وقت متحرک ہوتا ہے جب اسٹور میں کوئی کھلاڑی دوسروں سے سامان خریدنے کی درخواست کرتا ہے اور درخواست قبول کر لی جاتی ہے۔",
  T_48_META_EVT_3116_P0_D: "وہ کھلاڑی جو خریدنے میں مدد کرتے ہیں۔",
  T_48_META_EVT_3116_P1_D: "کھلاڑی خریداری میں مدد کی درخواست کر رہے ہیں۔",
  T_48_META_EVT_3116_P2_D: "اجناس",
  T_48_META_EVT_3117_D: "جب ایک مقررہ فریم کو اپ ڈیٹ کیا جاتا ہے تو ٹرگر ہوتا ہے، فریکوئنسی 30 بار فی سیکنڈ پر طے ہوتی ہے۔",
  T_48_META_EVT_3118_D: "توقف گیم API کو کال کرنے کے بعد متحرک ہوا۔",
  T_48_META_EVT_3119_D: "ریزیوم گیم API کو کال کرنے کے بعد متحرک ہوا۔",
  T_48_META_EVT_3120_D: "اس وقت متحرک ہوتا ہے جب کوئی کھلاڑی دوستوں کو شامل یا حذف کرتا ہے۔",
  T_48_META_EVT_3121_D: "Persona کی معلومات موصول ہونے پر متحرک ہوا۔",
  T_48_META_EVT_3121_P0_D: "معلوماتی مواد",
  T_48_META_EVT_3121_P1_D: "مرسل شخصیت",
  T_48_META_EVT_3122_D: "کھلاڑی کی چھلانگ کے اختتام پر فائر",
  T_48_META_EVT_3123_D: "جب کھلاڑی گرتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3124_D: "جب کھلاڑی گرنا ختم ہوتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3125_D: "Persona برتاؤ موصول ہونے پر متحرک ہوا۔",
  T_48_META_EVT_3125_P0_D: "رویہ",
  T_48_META_EVT_3125_P1_D: "مرسل شخصیت",
  T_48_META_EVT_3126_D: "جب ممبر کی معلومات میں تبدیلی آتی ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3126_P0_D: "تبدیلی کے بعد ممبر کی حیثیت",
  T_48_META_EVT_3127_D: "ممبر سینٹر میں داخل ہونے پر ٹرگر ہوا۔",
  T_48_META_EVT_3128_D: "ممبر سینٹر سے نکلتے وقت ٹرگر ہوا۔",
  T_48_META_EVT_3129_D: "اس وقت متحرک ہوتا ہے جب کھلاڑی نیچے کی حالت میں داخل ہوتا ہے۔",
  T_48_META_EVT_3129_P0_D: "حملہ آور ہستی، خالی ہو سکتی ہے۔",
  T_48_META_EVT_3130_D: "جب Persona اسٹیٹس موصول ہوتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_3130_P0_D: "مرسل شخصیت",
  T_48_META_EVT_3130_P1_D: "غلطی کا کوڈ",
  T_48_META_EVT_3131_D: "UI کے ذریعے Persona کو معلومات بھیجتے وقت متحرک ہوا۔",
  T_48_META_EVT_3131_P0_D: "معلوماتی مواد",
  T_48_META_EVT_3131_P1_D: "مرسل شخصیت",
  T_48_META_EVT_3132_D: "Persona کا اختتام موصول ہونے پر متحرک ہوا۔",
  T_48_META_EVT_3132_P0_D: "مرسل شخصیت",
  T_48_META_EVT_3132_P1_D: "غلطی کا کوڈ",
  T_48_META_EVT_32_D: "اس وقت متحرک ہوتا ہے جب کھلاڑی مناظر کو تبدیل کرتا ہے۔",
  T_48_META_EVT_32_P0_D: "منظر کا نام",
  T_48_META_EVT_3200_D: "اینیمیشن کلپ چلنا ختم ہونے پر فائر ہوتا ہے۔",
  T_48_META_EVT_3200_P0_D: "اینیمیشن کلپ کا نام",
  T_48_META_EVT_3201_D: "اینیمیشن اسٹیٹ پلے بیک مکمل ہونے پر متحرک ہوتا ہے۔",
  T_48_META_EVT_3201_P0_D: "حرکت پذیری ریاست کا نام",
  T_48_META_EVT_3204_D: "ٹوگل کنٹرول کی حالت تبدیل ہونے پر متحرک ہوتا ہے۔",
  T_48_META_EVT_3204_P0_D: "ٹرگر پلیئر",
  T_48_META_EVT_3204_P1_D: "ریاست",
  T_48_META_EVT_3260_D: "ٹچ پیڈ کو پلیئر کے ذریعے دبانے پر فائر ہوتا ہے۔",
  T_48_META_EVT_3260_P0_D: "ٹرگر پلیئر",
  T_48_META_EVT_3260_P1_D: "پریس پوزیشن",
  T_48_META_EVT_3261_D: "ٹچ پیڈ بلند ہونے پر آگ لگ جاتی ہے۔",
  T_48_META_EVT_3261_P0_D: "ٹرگر پلیئر",
  T_48_META_EVT_3261_P1_D: "اٹھایا پوزیشن",
  T_48_META_EVT_3262_D: "ٹچ پیڈ سلائیڈنگ شروع ہونے پر فائر ہوتا ہے۔",
  T_48_META_EVT_3262_P0_D: "ٹرگر پلیئر",
  T_48_META_EVT_3262_P1_D: "سلائیڈنگ پوزیشن شروع کریں۔",
  T_48_META_EVT_3263_D: "ٹچ پیڈ سلائیڈنگ کے دوران ٹرگر کیا گیا، یہ ایونٹ ہر فریم میں ایک بار ٹرگر ہو جائے گا۔",
  T_48_META_EVT_3263_P0_D: "ٹرگر پلیئر",
  T_48_META_EVT_3263_P1_D: "سلائیڈنگ پوزیشن شروع کریں۔",
  T_48_META_EVT_3263_P2_D: "نقل مکانی",
  T_48_META_EVT_3264_D: "ٹچ پیڈ سلائیڈ کے آخر میں آگ لگتی ہے۔",
  T_48_META_EVT_3264_P0_D: "ٹرگر پلیئر",
  T_48_META_EVT_3264_P1_D: "سلائیڈنگ پوزیشن ختم کریں۔",
  T_48_META_EVT_3265_D: "JoyStick کو دبانے پر آگ لگ جاتی ہے۔",
  T_48_META_EVT_3265_P0_D: "ٹرگر پلیئر",
  T_48_META_EVT_3266_D: "JoyStick اٹھانے پر آگ لگ جاتی ہے۔",
  T_48_META_EVT_3266_P0_D: "ٹرگر پلیئر",
  T_48_META_EVT_3267_D: "JoyStick استعمال کرتے وقت متحرک",
  T_48_META_EVT_3267_P0_D: "ٹرگر پلیئر",
  T_48_META_EVT_3267_P1_D: "آؤٹ پٹ نقل مکانی",
  T_48_META_EVT_3268_D: "اس وقت متحرک ہوتا ہے جب کھلاڑی دوسرے موقف سے کھڑا ہوتا ہے۔",
  T_48_META_EVT_3268_P0_D: "کھڑے ہونے سے پہلے کھلاڑی کی کرنسی",
  T_48_META_EVT_3269_D: "جب ہتھیار سے فائر کیا جاتا ہے تو متحرک ہوتا ہے۔",
  T_48_META_EVT_4_D: "ہر دور کے آغاز میں متحرک",
  T_48_META_EVT_4_P0_D: "راؤنڈ انڈیکس، 0 سے شروع ہوتا ہے۔",
  T_48_META_EVT_5_D: "ہر دور کے اختتام پر محرکات",
  T_48_META_EVT_5_P0_D: "راؤنڈ انڈیکس، 0 سے شروع ہوتا ہے۔",
  T_48_META_EVT_6_D: "جب کوئی ہستی آپس میں ٹکرا جاتی ہے تو صرف نصب شدہ باڈی اجزاء والی ہستی اس ایونٹ کو سپورٹ کرتی ہے۔",
  T_48_META_EVT_6_P0_D: "اداروں کا سامنا ہوا۔",
  T_48_META_EVT_7_D: "ہر مرحلے کے آغاز میں متحرک",
  T_48_META_EVT_7_P0_D: "اسٹیج ہستی",
  T_48_META_EVT_8_D: "ہر مرحلے کے اختتام پر متحرک",
  T_48_META_EVT_8_P0_D: "اسٹیج ہستی",
  T_48_META_EVT_9_D: "ہستی کے تصادم کے اختتام پر محرکات صرف نصب شدہ جسم کے اجزاء کے ساتھ اس واقعہ کی حمایت کرتے ہیں۔",
  T_48_META_EVT_9_P0_D: "اداروں کا سامنا ہوا۔",
  T_49_META_TYP_10_I1_D: "Tag List",
  T_49_META_TYP_10_I2_D: "Is it available for itself",
  T_49_META_TYP_10_I3_D: "Available in all parents",
  T_49_META_TYP_10_I4_D: "Whether it is available in the Scene or not",
  T_49_META_TYP_10_I5_D: "Whether logic update is turned on, when it is turned off, the script on this entity stops updating every frame",
  T_49_META_TYP_10_I6_D: "Entity name",
  T_49_META_TYP_10_I7_D: "Region filtering options, 0 for automatic calculation of controlled or uncontrolled, 1 for uncontrolled always synchronized, 2 for controlled",
  T_49_META_TYP_100_I0_D: "Setting the trigger range",
  T_49_META_TYP_100_I1_D: "Model Visibility",
  T_49_META_TYP_101_I0_D: "Player",
  T_49_META_TYP_101_I1_D: "TargetItemID",
  T_49_META_TYP_101_I2_D: "TargetRotation",
  T_49_META_TYP_101_I3_D: "TargetScale",
  T_49_META_TYP_1010_I1_D: "Timing duration in seconds",
  T_49_META_TYP_1010_I2_D: "The start time of the timings, in seconds of the game moment",
  T_49_META_TYP_1010_I3_D: "The update type of the timer, see `EUITimeUpdateType`, can be static, timed, or countdown.",
  T_49_META_TYP_1010_I4_D: "Display position, when there is a target to follow, it is the offset relative to the target origin, when there is no target to follow, it is the screen coordinates.",
  T_49_META_TYP_1011_I10_D: "Progress Icon Name",
  T_49_META_TYP_1011_I2_D: "Theme Color",
  T_49_META_TYP_1011_I3_D: "Whether to enable localized display",
  T_49_META_TYP_1011_I4_D: "Title",
  T_49_META_TYP_1011_I5_D: "Description",
  T_49_META_TYP_1011_I6_D: "Icon resource name",
  T_49_META_TYP_1011_I7_D: "Max Progress",
  T_49_META_TYP_1011_I8_D: "Current Progress",
  T_49_META_TYP_1011_I9_D: "Progress Icon",
  T_49_META_TYP_1012_I1_D: "Enable or disable localization",
  T_49_META_TYP_1012_I2_D: "Number of rounds text",
  T_49_META_TYP_1012_I3_D: "Round Num LocKey Params",
  T_49_META_TYP_1012_I5_D: "LeftColor",
  T_49_META_TYP_1012_I6_D: "RightColor",
  T_49_META_TYP_1013_I2_D: "Round Count Text",
  T_49_META_TYP_1013_I3_D: "Round Num LocKey Params",
  T_49_META_TYP_1014_I2_D: "First Score Title Text",
  T_49_META_TYP_1014_I3_D: "First Score",
  T_49_META_TYP_1014_I4_D: "First Score Params",
  T_49_META_TYP_1014_I5_D: "Title of the second score",
  T_49_META_TYP_1014_I6_D: "Second score value",
  T_49_META_TYP_1014_I7_D: "Second Score Value Params",
  T_49_META_TYP_1016_I1_D: "Show the corresponding status according to the value, Victory (1), Defeat (2), Tie (3), Booyah (4)",
  T_49_META_TYP_1016_I2_D: "Show if the score of 2 teams is true, otherwise hidden",
  T_49_META_TYP_1016_I3_D: "Left Team Score",
  T_49_META_TYP_1016_I4_D: "Right Team Score",
  T_49_META_TYP_1016_I5_D: "Phase end timestamps",
  T_49_META_TYP_1017_I1_D: "Left Team Name",
  T_49_META_TYP_1017_I2_D: "Left Description",
  T_49_META_TYP_1017_I3_D: "Right Team Name",
  T_49_META_TYP_1017_I4_D: "Right Description",
  T_49_META_TYP_1018_I1_D: "Round Num",
  T_49_META_TYP_1018_I4_D: "Left team score",
  T_49_META_TYP_1018_I6_D: "Score of the right team",
  T_49_META_TYP_1019_I1_D: "1 2 3 for win/loss/tie",
  T_49_META_TYP_102_I0_D: "Resurrection source type, player resurrects from death",
  T_49_META_TYP_102_I1_D: "Resurrection source type, player resurrects from downed state",
  T_49_META_TYP_1020_I2_D: "Text key to be displayed",
  T_49_META_TYP_1020_I3_D: "Array of parameters corresponding to the text key",
  T_49_META_TYP_1021_I1_D: "Base time in seconds",
  T_49_META_TYP_1021_I2_D: "Duration in seconds",
  T_49_META_TYP_1021_I3_D: "Display position, when there is a target to follow, it is the offset of the target origin, when there is no target to follow, it is the screen coordinate, default is Vector3(0).",
  T_49_META_TYP_1022_I2_D: "the key of the text to be displayed",
  T_49_META_TYP_1022_I3_D: "Array of parameters corresponding to the text key.",
  T_49_META_TYP_1023_I1_D: "show team score if it is true, otherwise it will be closed.",
  T_49_META_TYP_1023_I4_D: "If the status of the team is true, then display, otherwise it will be closed.",
  T_49_META_TYP_1023_I5_D: "Left player status array, 0: alive, 1: dead, 2: down.",
  T_49_META_TYP_1023_I6_D: "Right player status array, 0: alive, 1: dead, 2: down.",
  T_49_META_TYP_1023_I7_D: "Left Teammate Flag Count",
  T_49_META_TYP_1023_I8_D: "Right Teammate Flag Count",
  T_49_META_TYP_1024_I2_D: "Offset",
  T_49_META_TYP_1024_I3_D: "Rank",
  T_49_META_TYP_1024_I4_D: "Team Color",
  T_49_META_TYP_1024_I5_D: "Icon Name",
  T_49_META_TYP_1024_I6_D: "Displayed if border is true, otherwise it is off.",
  T_49_META_TYP_1024_I7_D: "Score Text Key",
  T_49_META_TYP_1024_I8_D: "Score Text Key Params",
  T_49_META_TYP_1028_I1_D: "Left Teammate Alive Num",
  T_49_META_TYP_1028_I2_D: "Right Teammate Alive Num",
  T_49_META_TYP_1028_I3_D: "Left Background Color",
  T_49_META_TYP_1028_I4_D: "Right Background Color",
  T_49_META_TYP_1028_I5_D: "Left Icon Name",
  T_49_META_TYP_1028_I6_D: "Right Icon Name",
  T_49_META_TYP_1029_I1_D: "Icon Name",
  T_49_META_TYP_1029_I2_D: "Background Icon Name",
  T_49_META_TYP_103_I0_D: "Primary Weapon A",
  T_49_META_TYP_103_I1_D: "Primary WeaponB",
  T_49_META_TYP_103_I10_D: "Freeze Bomb",
  T_49_META_TYP_103_I11_D: "Ice Wall",
  T_49_META_TYP_103_I12_D: "Landmine",
  T_49_META_TYP_103_I13_D: "Auto Turret",
  T_49_META_TYP_103_I14_D: "DummyGrenade",
  T_49_META_TYP_103_I16_D: "Skateboard, Camo ....",
  T_49_META_TYP_103_I2_D: "Secondary Weapon",
  T_49_META_TYP_103_I3_D: "Blast Weapon",
  T_49_META_TYP_103_I5_D: "HeavyWeapon",
  T_49_META_TYP_1030_I3_D: "Left Teammate Alive Num",
  T_49_META_TYP_1030_I4_D: "Right Teammate Alive Num",
  T_49_META_TYP_1030_I5_D: "Left team icon name",
  T_49_META_TYP_1030_I6_D: "Right team icon name",
  T_49_META_TYP_1031_I2_D: "Description of the message",
  T_49_META_TYP_1031_I3_D: "Countdown start timestamp, in seconds",
  T_49_META_TYP_1031_I4_D: "Description Params",
  T_49_META_TYP_1032_I1_D: "Tips Type",
  T_49_META_TYP_1032_I3_D: "Params",
  T_49_META_TYP_1033_I1_D: "Toggles phases, 0 for current round and 1 for next round",
  T_49_META_TYP_1033_I10_D: "Defeat prompt text, not filled in as default",
  T_49_META_TYP_1033_I11_D: "Round Income Title",
  T_49_META_TYP_1033_I12_D: "Round Income",
  T_49_META_TYP_1033_I13_D: "Round Income Detail Titles",
  T_49_META_TYP_1033_I14_D: "Round revenue value detail list, corresponding to the above detail title list one by one",
  T_49_META_TYP_1033_I15_D: "MVP Player Nickname",
  T_49_META_TYP_1033_I16_D: "Next Round Index",
  T_49_META_TYP_1033_I17_D: "Is Match Point",
  T_49_META_TYP_1033_I18_D: "Is Last Round",
  T_49_META_TYP_1033_I6_D: "Left team icon name",
  T_49_META_TYP_1033_I7_D: "Right team icon name",
  T_49_META_TYP_1033_I8_D: "Depending on the value, the corresponding status will be displayed, Victory (1), Defeat (2).",
  T_49_META_TYP_1033_I9_D: "Victory prompt text, default if not filled in",
  T_49_META_TYP_1036_I1_D: "Indicates how many levels there are in total",
  T_49_META_TYP_1036_I2_D: "Indicates the current bot level",
  T_49_META_TYP_1037_I1_D: "Indicates how many points are displayed",
  T_49_META_TYP_1039_I3_D: "Countdown start timestamp, in seconds",
  T_49_META_TYP_104_I0_D: "Style A",
  T_49_META_TYP_104_I1_D: "Style B",
  T_49_META_TYP_104_I2_D: "Style C",
  T_49_META_TYP_1040_I10_D: "ItemDescriptions",
  T_49_META_TYP_1040_I11_D: "Index of the selected item, start from 0, less than 0 means deselected.",
  T_49_META_TYP_1040_I12_D: "ButtonNames",
  T_49_META_TYP_1040_I13_D: "ButtonColors",
  T_49_META_TYP_1040_I2_D: "Count Down Key",
  T_49_META_TYP_1040_I3_D: "Countdown Time",
  T_49_META_TYP_1040_I4_D: "Description Key",
  T_49_META_TYP_1040_I5_D: "Array of description parameters",
  T_49_META_TYP_1040_I6_D: "ItemBackgrounds",
  T_49_META_TYP_1040_I7_D: "ItemBackgroundColors",
  T_49_META_TYP_1040_I8_D: "ItemIcons",
  T_49_META_TYP_1040_I9_D: "ItemNames",
  T_49_META_TYP_1041_I2_D: "Position",
  T_49_META_TYP_1041_I3_D: "Icon",
  T_49_META_TYP_1041_I4_D: "Label",
  T_49_META_TYP_1041_I5_D: "Background Color",
  T_49_META_TYP_1042_I1_D: "Local Position",
  T_49_META_TYP_1043_I4_D: "Color",
  T_49_META_TYP_1043_I5_D: "Label Key",
  T_49_META_TYP_1043_I6_D: "Label Params",
  T_49_META_TYP_1045_I2_D: "Button icon",
  T_49_META_TYP_1045_I3_D: "Icon Color",
  T_49_META_TYP_1045_I4_D: "Size, same width and height",
  T_49_META_TYP_1045_I5_D: "Position of the button relative to the anchor point in the lower right corner.",
  T_49_META_TYP_1045_I6_D: "Number of charge, less than 0 means hidden",
  T_49_META_TYP_1045_I7_D: "CD start time, in milliseconds",
  T_49_META_TYP_1045_I8_D: "CD duration, in milliseconds",
  T_49_META_TYP_1045_I9_D: "True, the button will be grayed out, False, it will be restored.",
  T_49_META_TYP_106_I1_D: "Enable",
  T_49_META_TYP_106_I2_D: "Disable",
  T_49_META_TYP_109_I0_D: "Chat Channel ID",
  T_49_META_TYP_109_I1_D: "Player List",
  T_49_META_TYP_11_I0_D: "Whether the current game is in illegal state, when it is in illegal state, it means the game has lost the value of confrontation, so it is recommended to end the game directly.",
  T_49_META_TYP_11_I1_D: "The length of the current game, in milliseconds.",
  T_49_META_TYP_11_I10_D: "Whether or not to reset equipment every round",
  T_49_META_TYP_11_I11_D: "Whether or not to enable out-of-zone mechanic",
  T_49_META_TYP_11_I12_D: "Safe Zone Size",
  T_49_META_TYP_11_I13_D: "Shrinking Start Time",
  T_49_META_TYP_11_I14_D: "Shrinking Duration",
  T_49_META_TYP_11_I15_D: "Out-of-Zone Damage",
  T_49_META_TYP_11_I18_D: "Revival Type",
  T_49_META_TYP_11_I2_D: "Current round index, through this value you can get the current round entity.",
  T_49_META_TYP_11_I27_D: "Total Round Count",
  T_49_META_TYP_11_I3_D: "Current phase index, by this value you can get the current phase entity.",
  T_49_META_TYP_11_I32_D: "Number of coins gained at the start of the round",
  T_49_META_TYP_11_I33_D: "Number of coins at kill",
  T_49_META_TYP_11_I34_D: "Number of coins when you win",
  T_49_META_TYP_11_I35_D: "Whether to show wallet UI",
  T_49_META_TYP_11_I36_D: "Skybox Entity",
  T_49_META_TYP_11_I37_D: "Cumulative running frames since game start",
  T_49_META_TYP_11_I38_D: "Enable Move",
  T_49_META_TYP_11_I39_D: "Whether to customize the settlement",
  T_49_META_TYP_11_I4_D: "Preset template ID for UGC mode.",
  T_49_META_TYP_11_I40_D: "Whether to allow joining in the middle of the game",
  T_49_META_TYP_11_I41_D: "Enable low frame rate mode, the game will run at 15FPS, otherwise 30FPS",
  T_49_META_TYP_11_I42_D: "Logical frame update interval between two game server updates",
  T_49_META_TYP_11_I43_D: "Fixed frame update interval in milliseconds",
  T_49_META_TYP_11_I5_D: "Disable player resurrection if off",
  T_49_META_TYP_11_I6_D: "Disable Bot resurrection if off",
  T_49_META_TYP_11_I7_D: "Resurrection time in seconds",
  T_49_META_TYP_11_I8_D: "Total number of teams in the game",
  T_49_META_TYP_11_I9_D: "Number of members in each team",
  T_49_META_TYP_110_I0_D: "ChannelA",
  T_49_META_TYP_110_I1_D: "ChannelB",
  T_49_META_TYP_110_I2_D: "ChannelC",
  T_49_META_TYP_110_I3_D: "ChannelD",
  T_49_META_TYP_110_I4_D: "ChannelE",
  T_49_META_TYP_110_I5_D: "ChannelF",
  T_49_META_TYP_111_I1_D: "Sprint",
  T_49_META_TYP_111_I2_D: "Attack",
  T_49_META_TYP_111_I3_D: "Jump",
  T_49_META_TYP_111_I4_D: "Window Jump",
  T_49_META_TYP_111_I5_D: "Drive",
  T_49_META_TYP_111_I6_D: "Enter Vehicle",
  T_49_META_TYP_111_I7_D: "Exit Vehicle",
  T_49_META_TYP_111_I8_D: "Dirve Vehicle",
  T_49_META_TYP_112_I0_D: "Enable",
  T_49_META_TYP_112_I1_D: "Disable",
  T_49_META_TYP_112_I2_D: "Invisible",
  T_49_META_TYP_117_I0_D: "Claps",
  T_49_META_TYP_117_I1_D: "Hihats",
  T_49_META_TYP_117_I2_D: "Kick",
  T_49_META_TYP_117_I3_D: "OpenHihats",
  T_49_META_TYP_117_I4_D: "Rides",
  T_49_META_TYP_117_I5_D: "Snares",
  T_49_META_TYP_118_I0_D: "Whether all members of the camp are in death",
  T_49_META_TYP_118_I1_D: "List of all team members",
  T_49_META_TYP_118_I2_D: "Allied Factions",
  T_49_META_TYP_118_I3_D: "Attackable Factions",
  T_49_META_TYP_118_I4_D: "Whether to show UI name",
  T_49_META_TYP_118_I5_D: "Whether to show map information",
  T_49_META_TYP_118_I6_D: 'Whether to "show" or not',
  T_49_META_TYP_118_I7_D: 'Whether to "show" or not',
  T_49_META_TYP_118_I8_D: "All Members",
  T_49_META_TYP_118_I9_D: "Is Show Quick Message",
  T_49_META_TYP_119_I0_D: "Yes",
  T_49_META_TYP_119_I1_D: "No",
  T_49_META_TYP_120_I1_D: "Target entity to follow, default is empty",
  T_49_META_TYP_120_I2_D: "UI color",
  T_49_META_TYP_120_I3_D: "UI length",
  T_49_META_TYP_120_I4_D: "Current progress value,0 to 1.0",
  T_49_META_TYP_120_I5_D: "Display position, when there is a target to follow, it is the offset relative to the target origin, when there is no target to follow, it is the screen coordinate, default is Vector3(0)",
  T_49_META_TYP_121_I0_D: "3s",
  T_49_META_TYP_121_I1_D: "5s",
  T_49_META_TYP_121_I2_D: "10s",
  T_49_META_TYP_121_I3_D: "15s",
  T_49_META_TYP_121_I4_D: "30s",
  T_49_META_TYP_121_I5_D: "9999s",
  T_49_META_TYP_122_I0_D: "Skybox Resource",
  T_49_META_TYP_122_I1_D: "Light Color",
  T_49_META_TYP_122_I10_D: "The GUID of the sub-scene it belongs to",
  T_49_META_TYP_122_I11_D: "Fog function switch",
  T_49_META_TYP_122_I12_D: "Fog Effect Mode",
  T_49_META_TYP_122_I13_D: "Exponential fog density",
  T_49_META_TYP_122_I14_D: "Start distance of linear fog",
  T_49_META_TYP_122_I15_D: "End distance of linear fog",
  T_49_META_TYP_122_I16_D: "Turn on the fog effect feature",
  T_49_META_TYP_122_I17_D: "Rotation angle of main light source",
  T_49_META_TYP_122_I18_D: "Enable the main light source rotation angle feature",
  T_49_META_TYP_122_I2_D: "Light Intensity",
  T_49_META_TYP_122_I3_D: "Darkness",
  T_49_META_TYP_122_I4_D: "Shadow Strength",
  T_49_META_TYP_122_I5_D: "Terrain Wetness",
  T_49_META_TYP_122_I6_D: "Lens Flare",
  T_49_META_TYP_122_I7_D: "Fog Color",
  T_49_META_TYP_122_I8_D: "Ambient Color",
  T_49_META_TYP_123_I0_D: "Day",
  T_49_META_TYP_123_I1_D: "Night",
  T_49_META_TYP_123_I2_D: "Dusk",
  T_49_META_TYP_123_I3_D: "City View",
  T_49_META_TYP_123_I4_D: "Colorful Sky",
  T_49_META_TYP_123_I5_D: "Frost Moon",
  T_49_META_TYP_124_I0_D: "Close Range",
  T_49_META_TYP_124_I1_D: "Medium Range",
  T_49_META_TYP_124_I2_D: "Long range",
  T_49_META_TYP_125_I0_D: "Diffuse Color",
  T_49_META_TYP_125_I2_D: "Diffuse Texture",
  T_49_META_TYP_125_I4_D: "Diffuse Alpha",
  T_49_META_TYP_126_I1_D: "Name",
  T_49_META_TYP_126_I2_D: "Current progress value",
  T_49_META_TYP_126_I3_D: "Maximum progress value",
  T_49_META_TYP_126_I4_D: "Screen coordinate, default is Vector3(0).",
  T_49_META_TYP_126_I5_D: "length of the progress bar, default is the length of the UI on the prefab.",
  T_49_META_TYP_127_I0_D: "Panning along an axis can be combined with three axes.",
  T_49_META_TYP_127_I1_D: "Rotate along an axis, three combinations possible",
  T_49_META_TYP_127_I2_D: "Zoom along an axis, three combinations possible",
  T_49_META_TYP_128_I0_D: "Bushes",
  T_49_META_TYP_128_I1_D: "Pumpkin",
  T_49_META_TYP_128_I2_D: "Scarecrow",
  T_49_META_TYP_128_I3_D: "Cabinet",
  T_49_META_TYP_129_I0_D: "Random Loot",
  T_49_META_TYP_129_I1_D: "AR Ammo",
  T_49_META_TYP_129_I2_D: "SMG Ammo",
  T_49_META_TYP_129_I3_D: "SN Ammo",
  T_49_META_TYP_129_I4_D: "HG Ammo",
  T_49_META_TYP_129_I5_D: "SG Bullets",
  T_49_META_TYP_129_I6_D: "Bow Ammo",
  T_49_META_TYP_13_I1_D: "Anchor coordinates relative to the parent node.",
  T_49_META_TYP_13_I10_D: "Widget and anchor frame size difference",
  T_49_META_TYP_13_I11_D: "Pivot",
  T_49_META_TYP_13_I12_D: "Depth",
  T_49_META_TYP_13_I14_D: "Order of all children in the same parent node",
  T_49_META_TYP_13_I15_D: "ParentID",
  T_49_META_TYP_13_I16_D: "UniqueID",
  T_49_META_TYP_13_I17_D: "Priority",
  T_49_META_TYP_13_I18_D: "Actual Position",
  T_49_META_TYP_13_I2_D: "Width",
  T_49_META_TYP_13_I4_D: "Z-axis rotation angle",
  T_49_META_TYP_13_I6_D: "Internal ID of the widget in the prefab",
  T_49_META_TYP_13_I7_D: "UI entity where it is located",
  T_49_META_TYP_13_I8_D: "Anchor Min",
  T_49_META_TYP_13_I9_D: "Anchor Max",
  T_49_META_TYP_130_I0_D: "Random Consumable Loot",
  T_49_META_TYP_130_I1_D: "MedKit",
  T_49_META_TYP_130_I2_D: "Repair Kit",
  T_49_META_TYP_130_I3_D: "Horizaline",
  T_49_META_TYP_130_I4_D: "Inhaler",
  T_49_META_TYP_131_I0_D: "Random Armor Loot",
  T_49_META_TYP_131_I1_D: "Level 1 Armor",
  T_49_META_TYP_131_I2_D: "Class II Armor",
  T_49_META_TYP_131_I3_D: "Tier 3 Armor",
  T_49_META_TYP_132_I0_D: "Random Throwing Object Loot",
  T_49_META_TYP_132_I1_D: "Grenade",
  T_49_META_TYP_132_I4_D: "Flash Freeze",
  T_49_META_TYP_133_I0_D: "Random Multiplier Loot",
  T_49_META_TYP_133_I1_D: "2x Scope",
  T_49_META_TYP_133_I2_D: "4x Scope",
  T_49_META_TYP_133_I3_D: "Thermal Scope",
  T_49_META_TYP_134_I0_D: "Random Weapon Loot",
  T_49_META_TYP_134_I5_D: "Shotgun",
  T_49_META_TYP_134_I8_D: "Football Gun",
  T_49_META_TYP_135_I0_D: "Loot bullet points",
  T_49_META_TYP_136_I0_D: "Loot Consumable Points",
  T_49_META_TYP_137_I0_D: "Loot Consumable Points",
  T_49_META_TYP_138_I0_D: "Loot Multiplier Points",
  T_49_META_TYP_139_I0_D: "Loot Armor Points",
  T_49_META_TYP_14_I0_D: "Player's current blood level",
  T_49_META_TYP_14_I1_D: "Player's current blood maximum",
  T_49_META_TYP_14_I11_D: "The player's camp",
  T_49_META_TYP_14_I12_D: "The player's damage multiplier, e.g. 2x configured as 2.0",
  T_49_META_TYP_14_I13_D: "Use the exact same rig as the male or female character, 0 means no model replacement",
  T_49_META_TYP_14_I14_D: "Does not conflict with existing velocity scaling",
  T_49_META_TYP_14_I15_D: "Does not conflict with existing jump height scaling",
  T_49_META_TYP_14_I16_D: "Identity,0 Normal Player,1 Hunter,2 Matrix Zombie,3 Normal Zombie,4 Evolved Zombie Type 1, 5 Evolved Zombie Type 2,6 Evolved Zombie Type 3",
  T_49_META_TYP_14_I17_D: "Zombie level, 1~3",
  T_49_META_TYP_14_I19_D: "Player's nickname",
  T_49_META_TYP_14_I2_D: "Determine the current player is AI player, AI is usually NPC or PVE monster",
  T_49_META_TYP_14_I20_D: "Percentage of damage dealt when taking damage, can be reduced or increased",
  T_49_META_TYP_14_I21_D: "Player's current EP",
  T_49_META_TYP_14_I22_D: "Player's maximum EP",
  T_49_META_TYP_14_I23_D: "Primary weapon currently in hand.",
  T_49_META_TYP_14_I24_D: "Is Drop on Eliminated",
  T_49_META_TYP_14_I26_D: "Aim Assist Type",
  T_49_META_TYP_14_I27_D: "Allow Lock by Aim Assist",
  T_49_META_TYP_14_I28_D: "Switch voice chat on/off: true to turn off voice, false to turn on voice",
  T_49_META_TYP_14_I29_D: "Switch quick chat: trueClose voice, falseOpen voice",
  T_49_META_TYP_14_I3_D: "Player Status",
  T_49_META_TYP_14_I30_D: "Channel",
  T_49_META_TYP_14_I35_D: "Switch pickup: trueCan't pickup, falseCan pickup",
  T_49_META_TYP_14_I36_D: "Toggle Discard Item: trueCan't discard, falseCan discard",
  T_49_META_TYP_14_I37_D: "Attackable Targets",
  T_49_META_TYP_14_I38_D: "Friendly Players",
  T_49_META_TYP_14_I39_D: "Faction",
  T_49_META_TYP_14_I4_D: "The player's survival time, if the player dies, the time will be recalculated.",
  T_49_META_TYP_14_I40_D: "Number in Faction",
  T_49_META_TYP_14_I41_D: "Camera the player is using",
  T_49_META_TYP_14_I42_D: "Custom Gravity",
  T_49_META_TYP_14_I43_D: "Helmet",
  T_49_META_TYP_14_I44_D: "Vest",
  T_49_META_TYP_14_I5_D: "Player's invincibility",
  T_49_META_TYP_14_I52_D: "User UID",
  T_49_META_TYP_14_I53_D: "Headshot Damage Reduction",
  T_49_META_TYP_14_I54_D: "AVATAR the player is bound to",
  T_49_META_TYP_14_I55_D: "Gender",
  T_49_META_TYP_14_I56_D: "Weapon Skin IDs",
  T_49_META_TYP_14_I57_D: "Player's spwan point",
  T_49_META_TYP_14_I58_D: "Player's resurrection point, if no checkpoints are recorded then the spwan point is used, otherwise checkpoints are used",
  T_49_META_TYP_14_I59_D: "Player's current position",
  T_49_META_TYP_14_I6_D: "The entity of the team the player belongs to",
  T_49_META_TYP_14_I60_D: "The player's current orientation",
  T_49_META_TYP_14_I61_D: "The node used to access the skinned rigs",
  T_49_META_TYP_14_I62_D: "Backpack",
  T_49_META_TYP_14_I63_D: "Temporary Shield Points",
  T_49_META_TYP_14_I64_D: "Vehicle Skin ID",
  T_49_META_TYP_14_I65_D: "Is Skip Stagger Animation",
  T_49_META_TYP_14_I66_D: "Is No Fall Damage",
  T_49_META_TYP_14_I67_D: "Current Handheld Item",
  T_49_META_TYP_14_I68_D: "Item Pickup Banlist",
  T_49_META_TYP_14_I69_D: "Player's resource ID",
  T_49_META_TYP_14_I7_D: "Current checkpoint ID",
  T_49_META_TYP_14_I70_D: "The target to which the Request Purchase message was sent",
  T_49_META_TYP_14_I71_D: "The resource ID of the currently playing Emote",
  T_49_META_TYP_14_I72_D: "Whether the currently playing Emote is looping or not",
  T_49_META_TYP_14_I73_D: "Handling of knockdown status",
  T_49_META_TYP_14_I74_D: "Whether to enable damage skipping, the default is True, which means it's enabled.",
  T_49_META_TYP_14_I76_D: "Whether to quit in the middle of the game",
  T_49_META_TYP_14_I77_D: "Clothing information to be kept when the player transforms into another character",
  T_49_META_TYP_14_I8_D: "ID of the checkpoint the target is traveling to",
  T_49_META_TYP_140_I0_D: "Wave 1",
  T_49_META_TYP_140_I1_D: "Wave 2",
  T_49_META_TYP_140_I2_D: "Wave 3",
  T_49_META_TYP_140_I3_D: "Continuous",
  T_49_META_TYP_141_I0_D: "Loot Soccer Random",
  T_49_META_TYP_141_I1_D: "Loot Soccer Shield",
  T_49_META_TYP_141_I2_D: "Freezing Grenade",
  T_49_META_TYP_142_I0_D: "Loot Soccer",
  T_49_META_TYP_143_I0_D: "Lead1C2",
  T_49_META_TYP_143_I1_D: "Lead1C2#",
  T_49_META_TYP_143_I10_D: "Lead1A2#",
  T_49_META_TYP_143_I11_D: "Lead1B2",
  T_49_META_TYP_143_I2_D: "Lead1D2",
  T_49_META_TYP_143_I3_D: "Lead1D2#",
  T_49_META_TYP_143_I4_D: "Lead1E2",
  T_49_META_TYP_143_I5_D: "Lead1F2",
  T_49_META_TYP_143_I6_D: "Lead1F2#",
  T_49_META_TYP_143_I7_D: "Lead1G2",
  T_49_META_TYP_143_I8_D: "Lead1G2#",
  T_49_META_TYP_143_I9_D: "Lead1A2",
  T_49_META_TYP_144_I0_D: "Lead2C2",
  T_49_META_TYP_144_I1_D: "Lead2C2#",
  T_49_META_TYP_144_I10_D: "Lead2A2#",
  T_49_META_TYP_144_I11_D: "Lead2B2",
  T_49_META_TYP_144_I2_D: "Lead2D2",
  T_49_META_TYP_144_I3_D: "Lead2D2#",
  T_49_META_TYP_144_I4_D: "Lead2E2",
  T_49_META_TYP_144_I5_D: "Lead2F2",
  T_49_META_TYP_144_I6_D: "Lead2F2#",
  T_49_META_TYP_144_I7_D: "Lead2G2",
  T_49_META_TYP_144_I8_D: "Lead2G2#",
  T_49_META_TYP_144_I9_D: "Lead2A2",
  T_49_META_TYP_145_I0_D: "Lead3C2",
  T_49_META_TYP_145_I1_D: "Lead3C2#",
  T_49_META_TYP_145_I10_D: "Lead3A2#",
  T_49_META_TYP_145_I11_D: "Lead3B2",
  T_49_META_TYP_145_I2_D: "Lead3D2",
  T_49_META_TYP_145_I3_D: "Lead3D2#",
  T_49_META_TYP_145_I4_D: "Lead3E2",
  T_49_META_TYP_145_I5_D: "Lead3F2",
  T_49_META_TYP_145_I6_D: "Lead3F2#",
  T_49_META_TYP_145_I7_D: "Lead3G2",
  T_49_META_TYP_145_I8_D: "Lead3G2#",
  T_49_META_TYP_145_I9_D: "Lead3A2",
  T_49_META_TYP_146_I0_D: "PianoC3",
  T_49_META_TYP_146_I1_D: "PianoC3#",
  T_49_META_TYP_146_I10_D: "PianoA3#",
  T_49_META_TYP_146_I11_D: "PianoB3",
  T_49_META_TYP_146_I12_D: "PianoC4",
  T_49_META_TYP_146_I13_D: "PianoC4#",
  T_49_META_TYP_146_I14_D: "PianoD4",
  T_49_META_TYP_146_I15_D: "PianoD4#",
  T_49_META_TYP_146_I16_D: "PianoE4",
  T_49_META_TYP_146_I17_D: "PianoF4",
  T_49_META_TYP_146_I18_D: "PianoF4#",
  T_49_META_TYP_146_I19_D: "PianoG4",
  T_49_META_TYP_146_I2_D: "PianoD3",
  T_49_META_TYP_146_I20_D: "PianoG4#",
  T_49_META_TYP_146_I21_D: "PianoA4",
  T_49_META_TYP_146_I22_D: "PianoA4#",
  T_49_META_TYP_146_I23_D: "PianoB4",
  T_49_META_TYP_146_I3_D: "PianoD3#",
  T_49_META_TYP_146_I4_D: "PianoE3",
  T_49_META_TYP_146_I5_D: "PianoF3",
  T_49_META_TYP_146_I6_D: "PianoF3#",
  T_49_META_TYP_146_I7_D: "PianoG3",
  T_49_META_TYP_146_I8_D: "PianoG3#",
  T_49_META_TYP_146_I9_D: "PianoA3",
  T_49_META_TYP_147_I0_D: "FF Classic (Shooting)",
  T_49_META_TYP_147_I1_D: "Third Person",
  T_49_META_TYP_147_I2_D: "First Person (Shooting)",
  T_49_META_TYP_147_I3_D: "Top-down perspective",
  T_49_META_TYP_147_I4_D: "Horizontal Scroll",
  T_49_META_TYP_147_I5_D: "Custom",
  T_49_META_TYP_147_I6_D: "Backchase",
  T_49_META_TYP_147_I7_D: "Player-controlled, free-moving camera",
  T_49_META_TYP_147_I8_D: "New version of the first person view camera",
  T_49_META_TYP_148_I0_D: "Provide many preset camera types and customized camera types.",
  T_49_META_TYP_148_I1_D: "Field of view is the camera's viewing angle",
  T_49_META_TYP_148_I10_D: "Camera Switch Animation Type",
  T_49_META_TYP_148_I11_D: "Transition time to this camera in milliseconds, only if the switch type is smooth.",
  T_49_META_TYP_148_I12_D: "Motion mode of the camera when there is an occlusion between the camera and the target.",
  T_49_META_TYP_148_I13_D: "How the camera renders the screen",
  T_49_META_TYP_148_I14_D: "Follow object offset reference coordinate system",
  T_49_META_TYP_148_I15_D: "Observing object offset reference coordinate system",
  T_49_META_TYP_148_I16_D: "The camera's rendering layer mask, which allows filtering the camera's rendered objects by visibility level",
  T_49_META_TYP_148_I17_D: "Viewing Angle Restriction",
  T_49_META_TYP_148_I2_D: "Generally refers to the offset of the camera's position from the player's home position, with different meanings for different camera types.",
  T_49_META_TYP_148_I3_D: "FOV is the offset of the camera's focus point from the player's home position, which varies by camera type.",
  T_49_META_TYP_148_I4_D: "Angle of rotation of the camera in the vertical direction",
  T_49_META_TYP_148_I5_D: "The angle of rotation of the camera in the horizontal direction.",
  T_49_META_TYP_148_I7_D: "The target that the camera is following",
  T_49_META_TYP_148_I8_D: "The target that the camera is looking at",
  T_49_META_TYP_148_I9_D: "The player who is using the camera",
  T_49_META_TYP_15_I0_D: "Whether all players in the team are currently dead",
  T_49_META_TYP_15_I1_D: "List of all players in the team",
  T_49_META_TYP_15_I3_D: "Hostile team list",
  T_49_META_TYP_15_I4_D: "List of friendly teams",
  T_49_META_TYP_15_I5_D: "Team number",
  T_49_META_TYP_150_I0_D: "Durability",
  T_49_META_TYP_150_I1_D: "The radius of the hemispheres at the ends of the capsule body.",
  T_49_META_TYP_150_I2_D: "Damage Factor",
  T_49_META_TYP_152_I1_D: "Custom Gravity",
  T_49_META_TYP_152_I2_D: "If or not need to show the trigger, True is show.",
  T_49_META_TYP_154_I0_D: "Cannot be dual-wielded",
  T_49_META_TYP_154_I1_D: "Can only be dual-wielded in combination with the same gun",
  T_49_META_TYP_154_I2_D: "Can be combo dual-wielded with another weapon as well as yourself",
  T_49_META_TYP_155_I0_D: "Level",
  T_49_META_TYP_155_I1_D: "Max. Durability",
  T_49_META_TYP_155_I2_D: "Current Durability",
  T_49_META_TYP_155_I3_D: "Damage Reduction Factor",
  T_49_META_TYP_155_I4_D: "Explode Damage Reduction Factor",
  T_49_META_TYP_155_I5_D: "Can Cost Durability",
  T_49_META_TYP_155_I6_D: "Can Destroy",
  T_49_META_TYP_156_I1_D: "Max. Durability",
  T_49_META_TYP_156_I2_D: "Current Durability",
  T_49_META_TYP_156_I3_D: "Damage Reduction Factor",
  T_49_META_TYP_156_I4_D: "Explode Damage Reduction Factor",
  T_49_META_TYP_156_I5_D: "Can Cost Durability",
  T_49_META_TYP_156_I6_D: "Can Destroy",
  T_49_META_TYP_157_I0_D: "No Animation",
  T_49_META_TYP_157_I1_D: "Smooth",
  T_49_META_TYP_158_I2_D: "UI anchor type enumeration, default value is 9 (Center)",
  T_49_META_TYP_158_I6_D: "Label Key",
  T_49_META_TYP_158_I7_D: "Label Params",
  T_49_META_TYP_158_I8_D: "Tweener Enabled",
  T_49_META_TYP_16_I1_D: "Item ID of the entity",
  T_49_META_TYP_16_I2_D: "Only for static loading of objects, to determine if the NavMesh is statically generated.",
  T_49_META_TYP_16_I3_D: "Whether it is dynamic blocking of NavMesh or not",
  T_49_META_TYP_16_I4_D: "Asynchronous loading",
  T_49_META_TYP_160_I0_D: "Brick A",
  T_49_META_TYP_160_I1_D: "Tile A",
  T_49_META_TYP_160_I10_D: "Sand A",
  T_49_META_TYP_160_I11_D: "Snow A",
  T_49_META_TYP_160_I12_D: "Wood A",
  T_49_META_TYP_160_I13_D: "Stone A",
  T_49_META_TYP_160_I14_D: "Lawn B",
  T_49_META_TYP_160_I15_D: "Brick B",
  T_49_META_TYP_160_I16_D: "Brick C",
  T_49_META_TYP_160_I17_D: "Clear",
  T_49_META_TYP_160_I2_D: "Tile B",
  T_49_META_TYP_160_I3_D: "Tile C",
  T_49_META_TYP_160_I4_D: "Bamboo A",
  T_49_META_TYP_160_I5_D: "Cement A",
  T_49_META_TYP_160_I6_D: "Container A",
  T_49_META_TYP_160_I7_D: "Lawn A",
  T_49_META_TYP_160_I8_D: "Ice A",
  T_49_META_TYP_160_I9_D: "Magma A",
  T_49_META_TYP_165_I0_D: "Whether to enable collision",
  T_49_META_TYP_165_I1_D: "Whether or not to act as a trigger",
  T_49_META_TYP_165_I2_D: "Physical layers, configure layers in the physics module, up to 16.",
  T_49_META_TYP_166_I0_D: "Emote1",
  T_49_META_TYP_166_I1_D: "Emote2",
  T_49_META_TYP_166_I2_D: "Emote3",
  T_49_META_TYP_166_I3_D: "Emote4",
  T_49_META_TYP_166_I4_D: "Emote5",
  T_49_META_TYP_167_I0_D: "VFX Texture Type",
  T_49_META_TYP_170_I0_D: "Visible or not, client stops rendering the target when it is not visible.",
  T_49_META_TYP_170_I1_D: "Visibility level, value in the range [0,15], affects the visibility in the camera.",
  T_49_META_TYP_171_I0_D: "Energy",
  T_49_META_TYP_172_I0_D: "Number of bullets",
  T_49_META_TYP_173_I0_D: "Extra Backpack Capacity",
  T_49_META_TYP_173_I1_D: "Priority of Skin configuration outside of the player's station.",
  T_49_META_TYP_173_I2_D: "Skin ID of the backpack, Skin configuration of the backpack itself",
  T_49_META_TYP_174_I2_D: "Max. Damage",
  T_49_META_TYP_174_I4_D: "Throw Speed",
  T_49_META_TYP_174_I5_D: "Explosion delay, in seconds",
  T_49_META_TYP_174_I6_D: "Self-Damage Factor",
  T_49_META_TYP_174_I7_D: "Friendly Fire DMG Coeff.",
  T_49_META_TYP_174_I8_D: "Ratio Vehicle Factor",
  T_49_META_TYP_174_I9_D: "Skin",
  T_49_META_TYP_175_I0_D: "Freeze Zone Radius",
  T_49_META_TYP_175_I1_D: "Frozen area duration in seconds",
  T_49_META_TYP_176_I0_D: "Weapon's primary type",
  T_49_META_TYP_176_I1_D: "Weapon Subtype",
  T_49_META_TYP_177_I0_D: "When there is an obstacle between the camera and the object to be followed, the camera will not change.",
  T_49_META_TYP_177_I1_D: "When there is an obstacle between the camera and the object to follow, the camera will be pushed closer to the object to follow.",
  T_49_META_TYP_177_I2_D: "When there is an occlusion between the camera and the object, the occlusion will become translucent.",
  T_49_META_TYP_178_I0_D: "When the camera looks at the object, the near object is big and the far object is small",
  T_49_META_TYP_178_I1_D: "Near and far objects are the same size when the camera is looking at them.",
  T_49_META_TYP_184_I0_D: "The UUID of the resource to be rendered.",
  T_49_META_TYP_185_I0_D: "Model mesh to use for rendering",
  T_49_META_TYP_185_I1_D: "The list of materials to use for rendering",
  T_49_META_TYP_187_I0_D: "Item ID",
  T_49_META_TYP_190_I0_D: "Open status",
  T_49_META_TYP_190_I1_D: "Match result",
  T_49_META_TYP_190_I10_D: "Scores1",
  T_49_META_TYP_190_I11_D: "Scores2",
  T_49_META_TYP_190_I12_D: "Scores3",
  T_49_META_TYP_190_I13_D: "Win MVPs",
  T_49_META_TYP_190_I14_D: "Lose MVPs",
  T_49_META_TYP_190_I15_D: "Show Match Details",
  T_49_META_TYP_190_I16_D: "Show Map Ratings",
  T_49_META_TYP_190_I17_D: "Show Gift",
  T_49_META_TYP_190_I18_D: "Show Report",
  T_49_META_TYP_190_I19_D: "Show Replay",
  T_49_META_TYP_190_I20_D: "Show Share",
  T_49_META_TYP_190_I21_D: "Show Lobby",
  T_49_META_TYP_190_I22_D: "Show Like",
  T_49_META_TYP_190_I23_D: "Show Add Friend",
  T_49_META_TYP_190_I24_D: "Show Ecconomy",
  T_49_META_TYP_190_I4_D: "Left Team",
  T_49_META_TYP_190_I5_D: "Right Team",
  T_49_META_TYP_190_I6_D: "Player Rank",
  T_49_META_TYP_190_I9_D: "Titles",
  T_49_META_TYP_191_I0_D: "Center Range",
  T_49_META_TYP_191_I4_D: "Center flash duration in milliseconds",
  T_49_META_TYP_191_I5_D: "Edge flash duration in milliseconds",
  T_49_META_TYP_191_I6_D: "Flashbang Hit Effect Switch",
  T_49_META_TYP_192_I3_D: "Duration of effect, in seconds",
  T_49_META_TYP_193_I1_D: "Match Title Left",
  T_49_META_TYP_193_I10_D: "Scores1",
  T_49_META_TYP_193_I11_D: "Scores2",
  T_49_META_TYP_193_I12_D: "Scores3",
  T_49_META_TYP_193_I13_D: "Scores4",
  T_49_META_TYP_193_I14_D: "Scores5",
  T_49_META_TYP_193_I15_D: "Win MVPs",
  T_49_META_TYP_193_I16_D: "Lose MVPs",
  T_49_META_TYP_193_I17_D: "Show Match Details",
  T_49_META_TYP_193_I18_D: "Show Map Ratings",
  T_49_META_TYP_193_I19_D: "Show Gift",
  T_49_META_TYP_193_I2_D: "Match Title Right",
  T_49_META_TYP_193_I20_D: "Show Report",
  T_49_META_TYP_193_I21_D: "Show Replay",
  T_49_META_TYP_193_I22_D: "Show Share",
  T_49_META_TYP_193_I23_D: "Show Lobby",
  T_49_META_TYP_193_I24_D: "Show Like",
  T_49_META_TYP_193_I25_D: "Show Add Friend",
  T_49_META_TYP_193_I26_D: "Show Ecconomy",
  T_49_META_TYP_193_I3_D: "Match result",
  T_49_META_TYP_193_I4_D: "Team Rank",
  T_49_META_TYP_193_I5_D: "Player Rank",
  T_49_META_TYP_193_I6_D: "Name of the team",
  T_49_META_TYP_193_I7_D: "Main Score Title",
  T_49_META_TYP_193_I8_D: "Main Scores",
  T_49_META_TYP_193_I9_D: "Titles",
  T_49_META_TYP_194_I0_D: "Time for the mine to take effect, in seconds",
  T_49_META_TYP_194_I1_D: "Trigger radius",
  T_49_META_TYP_194_I2_D: "Length of time it takes to trigger a mine within the mine's range, in seconds",
  T_49_META_TYP_194_I3_D: "Can Self Trigger",
  T_49_META_TYP_194_I4_D: "Can Teammates Trigger",
  T_49_META_TYP_194_I5_D: "Can Triggered by Vehicle",
  T_49_META_TYP_194_I6_D: "Duration of the mine's existence, which automatically explodes when it ends, from the time it is dropped, in units of seconds",
  T_49_META_TYP_194_I7_D: "Is Attackable",
  T_49_META_TYP_194_I8_D: "Life value",
  T_49_META_TYP_195_I0_D: "Once",
  T_49_META_TYP_195_I2_D: "Reciprocation",
  T_49_META_TYP_197_I0_D: "Whether the wave is playing or not",
  T_49_META_TYP_197_I1_D: "Flag bit",
  T_49_META_TYP_197_I2_D: "If checked, it will be played automatically upon creation.",
  T_49_META_TYP_198_I0_D: "The prop id of the accessory.",
  T_49_META_TYP_199_I0_D: "Max EP",
  T_49_META_TYP_199_I1_D: "Energy Cost",
  T_49_META_TYP_199_I10_D: "Fall Damage Ratio",
  T_49_META_TYP_199_I11_D: "Current Energy",
  T_49_META_TYP_199_I2_D: "UpEnergy Cost",
  T_49_META_TYP_199_I3_D: "Sprint Energy Cost",
  T_49_META_TYP_199_I4_D: "Rush Energy Cost",
  T_49_META_TYP_199_I5_D: "Base Horizontal Speed",
  T_49_META_TYP_199_I6_D: "Sprint Horizontal Speed",
  T_49_META_TYP_199_I7_D: "Base Vertical Speed",
  T_49_META_TYP_199_I8_D: "Sprint Vertical Speed",
  T_49_META_TYP_199_I9_D: "Sprint Distance",
  T_49_META_TYP_200_I0_D: "Area ID",
  T_49_META_TYP_200_I1_D: "Game ID",
  T_49_META_TYP_201_I0_D: "Percentage of slowdown: Percentage of slowdown of movement speed in open water for water objects",
  T_49_META_TYP_203_I0_D: "target entity",
  T_49_META_TYP_203_I1_D: "Prop ID",
  T_49_META_TYP_203_I10_D: "The moment when the game server starts ticking",
  T_49_META_TYP_203_I11_D: "Start Value",
  T_49_META_TYP_203_I12_D: "End Value",
  T_49_META_TYP_203_I13_D: "Percentage passed",
  T_49_META_TYP_203_I4_D: "Tween Style",
  T_49_META_TYP_203_I6_D: "Duration (s)",
  T_49_META_TYP_203_I7_D: "Is Reverse",
  T_49_META_TYP_203_I8_D: "Control Points",
  T_49_META_TYP_203_I9_D: "Forced synchronization of the game server state",
  T_49_META_TYP_204_I0_D: "Max. Double Jump Height",
  T_49_META_TYP_204_I1_D: "Fall Damage Percentage",
  T_49_META_TYP_204_I2_D: "Energy Recovery",
  T_49_META_TYP_204_I3_D: "Energy consumption",
  T_49_META_TYP_204_I4_D: "Max. Energy",
  T_49_META_TYP_205_I0_D: "Min. Fly Height",
  T_49_META_TYP_205_I1_D: "Min. End Height",
  T_49_META_TYP_205_I2_D: "Horizontal Glide Speed",
  T_49_META_TYP_205_I3_D: "Vertical Glide Speed",
  T_49_META_TYP_205_I4_D: "Fall Speed",
  T_49_META_TYP_205_I5_D: "Turning Speed",
  T_49_META_TYP_205_I6_D: "Fly Max. Height",
  T_49_META_TYP_205_I7_D: "Overheight Fall Speed",
  T_49_META_TYP_205_I8_D: "Speed change acceleration",
  T_49_META_TYP_206_I0_D: "Velocity",
  T_49_META_TYP_206_I1_D: "Acceleration",
  T_49_META_TYP_206_I10_D: "Maximum steering angle at high speed",
  T_49_META_TYP_206_I11_D: "Tween base rate of high speed steering angle",
  T_49_META_TYP_206_I2_D: "Sprint Speed",
  T_49_META_TYP_206_I3_D: "Duration of sprint, in seconds",
  T_49_META_TYP_206_I4_D: "Sprint cooldown, in seconds",
  T_49_META_TYP_206_I6_D: "Jump CD, in seconds",
  T_49_META_TYP_206_I7_D: "Sprint CD after boarding, in seconds",
  T_49_META_TYP_206_I8_D: "Get On Boost CD Switch",
  T_49_META_TYP_206_I9_D: "Get on board CD, in seconds",
  T_49_META_TYP_207_I1_D: "Start Index",
  T_49_META_TYP_207_I2_D: "End Position",
  T_49_META_TYP_207_I3_D: "Slide ID",
  T_49_META_TYP_207_I4_D: "Group ID",
  T_49_META_TYP_207_I5_D: "End or not",
  T_49_META_TYP_21_I0_D: "The base level of the UI",
  T_49_META_TYP_210_I1_D: "Initial Velocity",
  T_49_META_TYP_210_I2_D: "Acceleration",
  T_49_META_TYP_210_I3_D: "Max. Displacement",
  T_49_META_TYP_210_I4_D: "InitialWorldPosition",
  T_49_META_TYP_210_I5_D: "Forced synchronization of position information by game server",
  T_49_META_TYP_211_I0_D: "Local Position",
  T_49_META_TYP_211_I1_D: "World Position",
  T_49_META_TYP_212_I0_D: "Self",
  T_49_META_TYP_212_I2_D: "Offset coordinate",
  T_49_META_TYP_213_I0_D: "Self",
  T_49_META_TYP_213_I2_D: "Offset coordinate",
  T_49_META_TYP_215_I0_D: "Victory",
  T_49_META_TYP_215_I1_D: "Defeat",
  T_49_META_TYP_215_I2_D: "Booyah",
  T_49_META_TYP_215_I3_D: "Draw",
  T_49_META_TYP_218_I0_D: "Intensity",
  T_49_META_TYP_218_I1_D: "Range",
  T_49_META_TYP_218_I2_D: "Light color",
  T_49_META_TYP_22_I0_D: "Displayed if on is true, off otherwise",
  T_49_META_TYP_22_I1_D: "Prefab ID",
  T_49_META_TYP_22_I2_D: "The ID of the current largest widget",
  T_49_META_TYP_22_I3_D: "Base level of UI",
  T_49_META_TYP_22_I4_D: "Enable Player View",
  T_49_META_TYP_22_I5_D: "World Position",
  T_49_META_TYP_22_I6_D: "Whether or not it is in the Scene",
  T_49_META_TYP_22_I7_D: "Rotation in the world coordinate system",
  T_49_META_TYP_22_I8_D: "Zoom in the world coordinate system",
  T_49_META_TYP_221_I0_D: "The larger the value, the slower the speed of gear change.",
  T_49_META_TYP_222_I0_D: "Gear switching delay, the larger this value is, the slower the gear changes.",
  T_49_META_TYP_225_I0_D: "Turret Damage",
  T_49_META_TYP_225_I1_D: "Damage Interval (s)",
  T_49_META_TYP_225_I10_D: "Fire only at an angle",
  T_49_META_TYP_225_I11_D: "Damage Reduction Rate",
  T_49_META_TYP_225_I12_D: "Armor Penetration",
  T_49_META_TYP_225_I2_D: "Accuracy",
  T_49_META_TYP_225_I3_D: "Range",
  T_49_META_TYP_225_I4_D: "Angular Speed",
  T_49_META_TYP_225_I5_D: "Angle Up",
  T_49_META_TYP_225_I6_D: "Angle Down",
  T_49_META_TYP_225_I7_D: "Max. HP",
  T_49_META_TYP_225_I8_D: "Life Time (s)",
  T_49_META_TYP_225_I9_D: "Max. Turret Count",
  T_49_META_TYP_226_I0_D: "Turret current life value",
  T_49_META_TYP_226_I1_D: "Enable Attack",
  T_49_META_TYP_227_I0_D: "Simple Widget",
  T_49_META_TYP_227_I1_D: "Image Widget",
  T_49_META_TYP_227_I10_D: "Texture Widget",
  T_49_META_TYP_227_I11_D: "Profile Widget",
  T_49_META_TYP_227_I12_D: "Toggle Widget",
  T_49_META_TYP_227_I13_D: "Touch Pad Widget",
  T_49_META_TYP_227_I14_D: "Joystick Widget",
  T_49_META_TYP_227_I15_D: "Social Button Widget",
  T_49_META_TYP_227_I2_D: "Label Widget",
  T_49_META_TYP_227_I3_D: "Button Widget",
  T_49_META_TYP_227_I4_D: "Input Label Widget",
  T_49_META_TYP_227_I5_D: "Panel",
  T_49_META_TYP_227_I6_D: "Scroll Panel",
  T_49_META_TYP_227_I7_D: "Grid",
  T_49_META_TYP_227_I8_D: "Layout Widget",
  T_49_META_TYP_227_I9_D: "Container Widget",
  T_49_META_TYP_231_I0_D: "Durability Recovery",
  T_49_META_TYP_231_I1_D: "Effective time interval, in seconds",
  T_49_META_TYP_233_I2_D: "Time to expiration, in seconds",
  T_49_META_TYP_233_I4_D: "Icon resource name",
  T_49_META_TYP_234_I0_D: "Trigger time, in seconds",
  T_49_META_TYP_234_I1_D: "Can Self Trigger",
  T_49_META_TYP_234_I10_D: "Current life value",
  T_49_META_TYP_234_I2_D: "Can Teammates Trigger",
  T_49_META_TYP_234_I3_D: "Can Triggered by Vehicle",
  T_49_META_TYP_234_I4_D: "Duration in seconds",
  T_49_META_TYP_234_I5_D: "Is Attackable",
  T_49_META_TYP_234_I6_D: "Life value",
  T_49_META_TYP_235_I0_D: "Maximum life value",
  T_49_META_TYP_235_I2_D: "Max. Count",
  T_49_META_TYP_237_I0_D: "Throw Speed",
  T_49_META_TYP_237_I1_D: "Player Traction Speed",
  T_49_META_TYP_238_I0_D: "Spray Color",
  T_49_META_TYP_239_I0_D: "Initial speed",
  T_49_META_TYP_239_I1_D: "Acceleration speed (e.g. gravity)",
  T_49_META_TYP_24_I0_D: "Melee",
  T_49_META_TYP_24_I1_D: "Gun",
  T_49_META_TYP_24_I10_D: "Airdrop hit damage, monster suicide damage",
  T_49_META_TYP_24_I11_D: "Burning Damage on Vehicle Explosion",
  T_49_META_TYP_24_I12_D: "Oil Drum Explosion",
  T_49_META_TYP_24_I13_D: "Missile-Type Weapon",
  T_49_META_TYP_24_I14_D: "Monster",
  T_49_META_TYP_24_I15_D: "Damage Zone",
  T_49_META_TYP_24_I17_D: "Character Skill",
  T_49_META_TYP_24_I2_D: "Throw Attack",
  T_49_META_TYP_24_I3_D: "Safe Zone",
  T_49_META_TYP_24_I4_D: "Vehicle",
  T_49_META_TYP_24_I5_D: "Falling",
  T_49_META_TYP_24_I6_D: "KillZone",
  T_49_META_TYP_24_I7_D: "Exit",
  T_49_META_TYP_24_I8_D: "Disconnect",
  T_49_META_TYP_24_I9_D: "Vehicle Explosion",
  T_49_META_TYP_241_I0_D: "Traction speed",
  T_49_META_TYP_241_I1_D: "Swing speed",
  T_49_META_TYP_241_I2_D: "Turn on traction button",
  T_49_META_TYP_241_I3_D: "Turn on swing button",
  T_49_META_TYP_241_I4_D: "Motion anchor point",
  T_49_META_TYP_241_I5_D: "Swing Exit Acceleration",
  T_49_META_TYP_242_I2_D: "Left Effect Active",
  T_49_META_TYP_242_I3_D: "Right Effect Active",
  T_49_META_TYP_242_I4_D: "Central Line Active",
  T_49_META_TYP_242_I5_D: "Value",
  T_49_META_TYP_242_I7_D: "UI position, only the XY component is active",
  T_49_META_TYP_242_I8_D: "Position of the median [0,1]",
  T_49_META_TYP_243_I0_D: "Top Wear",
  T_49_META_TYP_243_I1_D: "Bottom Wear",
  T_49_META_TYP_243_I2_D: "Shoes",
  T_49_META_TYP_243_I3_D: "Facepaint",
  T_49_META_TYP_243_I4_D: "Headwear",
  T_49_META_TYP_243_I5_D: "Bodysuit",
  T_49_META_TYP_243_I6_D: "Facepaint",
  T_49_META_TYP_244_I0_D: "Text content to be displayed",
  T_49_META_TYP_244_I10_D: "List of players who can see this entity",
  T_49_META_TYP_244_I11_D: "Display level",
  T_49_META_TYP_244_I2_D: "Follow Target",
  T_49_META_TYP_244_I3_D: "When depth is ignored it can be displayed through the wall, otherwise it won't work",
  T_49_META_TYP_244_I4_D: "Always Facing Camera",
  T_49_META_TYP_244_I5_D: "When set to true, when the position is outside the screen, it will be displayed inside the screen.",
  T_49_META_TYP_244_I6_D: "Font Style",
  T_49_META_TYP_244_I7_D: "Font type",
  T_49_META_TYP_244_I8_D: "Font size",
  T_49_META_TYP_245_I0_D: "Effect Resource Path",
  T_49_META_TYP_245_I11_D: "Display Layers",
  T_49_META_TYP_245_I3_D: "When ignore depth, it can be displayed through the wall, otherwise it won't work.",
  T_49_META_TYP_245_I4_D: "When set to true, when the position is outside the screen, it will be displayed inside the screen.",
  T_49_META_TYP_245_I5_D: "Always Facing Camera",
  T_49_META_TYP_245_I6_D: "Render Type",
  T_49_META_TYP_245_I7_D: "Width",
  T_49_META_TYP_246_I0_D: "Orange",
  T_49_META_TYP_246_I1_D: "Purple",
  T_49_META_TYP_246_I2_D: "Red",
  T_49_META_TYP_246_I3_D: "Green",
  T_49_META_TYP_246_I4_D: "Blue",
  T_49_META_TYP_247_I1_D: "Sprint",
  T_49_META_TYP_247_I14_D: "Emote",
  T_49_META_TYP_247_I15_D: "Quick Chat",
  T_49_META_TYP_247_I16_D: "Pickups",
  T_49_META_TYP_247_I17_D: "Quick Chat Show",
  T_49_META_TYP_247_I18_D: "HP",
  T_49_META_TYP_247_I19_D: "EP",
  T_49_META_TYP_247_I2_D: "Attack",
  T_49_META_TYP_247_I20_D: "Armor",
  T_49_META_TYP_247_I21_D: "Reload",
  T_49_META_TYP_247_I22_D: "Quick Change Button",
  T_49_META_TYP_247_I23_D: "Carrier Speaker Button",
  T_49_META_TYP_247_I24_D: "Enable/disable voice (microphone) button",
  T_49_META_TYP_247_I25_D: "Enable/disable marker button",
  T_49_META_TYP_247_I27_D: "Enable/disable network signal button",
  T_49_META_TYP_247_I28_D: "Active Skill",
  T_49_META_TYP_247_I29_D: "Crosshair",
  T_49_META_TYP_247_I3_D: "Jump",
  T_49_META_TYP_247_I30_D: "Passive Skill",
  T_49_META_TYP_247_I4_D: "Killing Tips",
  T_49_META_TYP_247_I5_D: "Weapon Slot",
  T_49_META_TYP_247_I6_D: "Mini Map",
  T_49_META_TYP_247_I7_D: "Backpack UI",
  T_49_META_TYP_247_I8_D: "Medical Items",
  T_49_META_TYP_247_I9_D: "Displayed when True, otherwise turned off",
  T_49_META_TYP_249_I3_D: "Demolition weapons",
  T_49_META_TYP_249_I5_D: "HeavyWeapon",
  T_49_META_TYP_249_I8_D: "Freeze Bomb",
  T_49_META_TYP_249_I9_D: "DummyGrenade",
  T_49_META_TYP_25_I0_D: "Index of the current phase, corresponding to the index in the flow editor",
  T_49_META_TYP_25_I1_D: "Start time of the current phase, in ms.",
  T_49_META_TYP_25_I2_D: "The end time of the current phase in ms.",
  T_49_META_TYP_25_I3_D: "Duration of the current phase in ms.",
  T_49_META_TYP_250_I1_D: "Special effect color, RGBA four channels, single channel value range 0~255, stored in an Int32.",
  T_49_META_TYP_250_I3_D: "VFX Texture Type",
  T_49_META_TYP_250_I4_D: "Diffuse Alpha",
  T_49_META_TYP_2500_I1_D: "Is Default Spawn Point",
  T_49_META_TYP_2500_I3_D: "Whether or not a player has already been born in the birth point area.",
  T_49_META_TYP_2500_I4_D: "The coordinates of the currently assignable birth point location",
  T_49_META_TYP_2502_I0_D: "Whether it is a death trigger, when it is not a death trigger it is an invincibility trigger. (This is a legacy issue from OB32, please split the function in the future!)",
  T_49_META_TYP_2502_I1_D: "Whether to show trigger border, true for show",
  T_49_META_TYP_2503_I0_D: "Checkpoint ID",
  T_49_META_TYP_2503_I2_D: "Location of checkpoints",
  T_49_META_TYP_2507_I0_D: "Which camp the tower belongs to, if it is the same as the player, it won't attack the player.",
  T_49_META_TYP_2507_I1_D: "HP",
  T_49_META_TYP_2507_I10_D: "Object ID",
  T_49_META_TYP_2507_I2_D: "Max. HP",
  T_49_META_TYP_2507_I3_D: "Attack damage, the damage that can be done to the player by a single attack.",
  T_49_META_TYP_2507_I4_D: "The interval between attacks, in seconds.",
  T_49_META_TYP_2507_I5_D: "Attacks can be made in a radius from the center of the tower.",
  T_49_META_TYP_2507_I6_D: "Damage reduction rate, a decimal number less than 1, the final damage is the damage multiplied by (1 - damage reduction rate)",
  T_49_META_TYP_2507_I7_D: "Attack Target",
  T_49_META_TYP_2507_I8_D: "Angle",
  T_49_META_TYP_2507_I9_D: "Mini Sentry Status",
  T_49_META_TYP_2508_I0_D: "How many zombies will be spawned in each wave",
  T_49_META_TYP_2508_I1_D: "How many waves of zombies will be spawned in total",
  T_49_META_TYP_2508_I2_D: "Whether to spawn continuously, but there will be an upper limit for the same screen.",
  T_49_META_TYP_2508_I3_D: "How many waves will be spawned in the current wave?",
  T_49_META_TYP_2508_I5_D: "What kind of zombies are spawned in the current wave",
  T_49_META_TYP_2508_I6_D: "Whether the AI drops equipment or items when it dies.",
  T_49_META_TYP_2508_I7_D: "Start Spawn Time (s)",
  T_49_META_TYP_2508_I8_D: "The time interval between the next wave and the previous wave.",
  T_49_META_TYP_2509_I0_D: "The number of unit bodies that will be generated in each wave",
  T_49_META_TYP_2509_I1_D: "How many waves of unit generators will be generated in total",
  T_49_META_TYP_2509_I2_D: "How many waves are currently generated",
  T_49_META_TYP_2509_I4_D: "Which entity will be used as a template for each wave of generation",
  T_49_META_TYP_2509_I5_D: "When the units will start generating",
  T_49_META_TYP_2509_I6_D: "Whether or not to spawn consecutively, but there will be an upper limit of the same screen",
  T_49_META_TYP_2509_I7_D: "The time interval between the next wave and the previous wave.",
  T_49_META_TYP_2509_I8_D: "The prefabID of the template",
  T_49_META_TYP_2510_I0_D: "Spawn Point Count",
  T_49_META_TYP_252_I1_D: "Left Icon",
  T_49_META_TYP_252_I2_D: "Left Text",
  T_49_META_TYP_252_I3_D: "Left Score",
  T_49_META_TYP_252_I5_D: "Right Icon",
  T_49_META_TYP_252_I6_D: "Right Text",
  T_49_META_TYP_252_I7_D: "Right Score",
  T_49_META_TYP_252_I8_D: "Progress [0,1]",
  T_49_META_TYP_253_I0_D: "Select Icon",
  T_49_META_TYP_253_I1_D: "Text",
  T_49_META_TYP_253_I2_D: "Show Effect",
  T_49_META_TYP_253_I3_D: "UI position",
  T_49_META_TYP_254_I1_D: "For example, 1.25 means 1.25 times the normal speed.",
  T_49_META_TYP_254_I2_D: "Color",
  T_49_META_TYP_256_I0_D: "Completely stationary. Minimum Performance",
  T_49_META_TYP_256_I1_D: "Normal force application. Least performance",
  T_49_META_TYP_256_I2_D: "Motion can be controlled by scripting and can be considered as mass infinite",
  T_49_META_TYP_257_I0_D: "Functions of different types of rigid bodies",
  T_49_META_TYP_257_I1_D: "Use Gravity",
  T_49_META_TYP_257_I2_D: "Mass (kg), the minimum effective mass is 0.001kg, if it is 0, then it is infinite mass and will not move under force.",
  T_49_META_TYP_257_I3_D: "Position of the center of gravity, local coordinate system",
  T_49_META_TYP_257_I4_D: "Linear velocity of rigid body motion",
  T_49_META_TYP_257_I5_D: "Angular velocity of rigid body motion",
  T_49_META_TYP_257_I6_D: "Coefficient of natural decay of linear velocity, the larger the coefficient, the faster the decay of velocity.",
  T_49_META_TYP_257_I7_D: "Angular velocity natural decay coefficient, the larger the coefficient, the faster the velocity decays.",
  T_49_META_TYP_257_I8_D: "The constraints imposed on the rigid body, a collection of RigidbodyConstrainType.",
  T_49_META_TYP_258_I0_D: "2017-10-10 13:38:10 ",
  T_49_META_TYP_258_I1_D: "13:45 ",
  T_49_META_TYP_258_I2_D: "10/10/2017 1:45 PM ",
  T_49_META_TYP_258_I3_D: "10/10/2017",
  T_49_META_TYP_259_I0_D: "Background",
  T_49_META_TYP_259_I1_D: "Text",
  T_49_META_TYP_259_I2_D: "UI position",
  T_49_META_TYP_259_I4_D: "Text Color",
  T_49_META_TYP_260_I0_D: "Select Icon",
  T_49_META_TYP_260_I1_D: "Progress bar color",
  T_49_META_TYP_260_I2_D: "Value",
  T_49_META_TYP_260_I3_D: "Speed in m/s",
  T_49_META_TYP_260_I4_D: "Whether to display special effects",
  T_49_META_TYP_260_I5_D: "UI position [0,1].",
  T_49_META_TYP_260_I6_D: "Initial progress of the skill, value [0, 1], the progress will be synchronized to the current progress immediately after the UI is created.",
  T_49_META_TYP_260_I7_D: "Effect Color",
  T_49_META_TYP_260_I8_D: "Set the object scaling value",
  T_49_META_TYP_265_I1_D: "Background fill or not",
  T_49_META_TYP_265_I2_D: "Background Name",
  T_49_META_TYP_265_I3_D: "Background Color",
  T_49_META_TYP_265_I5_D: "BgAlpha",
  T_49_META_TYP_265_I6_D: "Crop type",
  T_49_META_TYP_265_I7_D: "Mask type is the name of the image selected for masking",
  T_49_META_TYP_265_I8_D: "Edge softening unit",
  T_49_META_TYP_267_I0_D: "Scroll start point, default is top left corner.",
  T_49_META_TYP_267_I1_D: "Support multiple scrolling directions",
  T_49_META_TYP_267_I10_D: "Horizontal Bar",
  T_49_META_TYP_267_I11_D: "Show position",
  T_49_META_TYP_267_I2_D: "XY direction drag component",
  T_49_META_TYP_267_I3_D: "Support multiple dragging effects",
  T_49_META_TYP_267_I4_D: "Scroll factor, the larger the value, the faster the scrolling.",
  T_49_META_TYP_267_I5_D: "Inertia factor, the larger the value, the larger the inertia when scrolling.",
  T_49_META_TYP_267_I6_D: "If or not the drag is limited to the viewport, default is checked.",
  T_49_META_TYP_267_I7_D: "When checked, the drag will start to move slowly, if unchecked, the drag will start to move at the speed of the mouse.",
  T_49_META_TYP_267_I8_D: "Exit dragging when it fits in the viewport.",
  T_49_META_TYP_267_I9_D: "Vertical Bar",
  T_49_META_TYP_268_I0_D: "Default",
  T_49_META_TYP_268_I1_D: "Close",
  T_49_META_TYP_268_I2_D: "Show",
  T_49_META_TYP_269_I0_D: "Owner",
  T_49_META_TYP_269_I1_D: "Set ID",
  T_49_META_TYP_269_I2_D: "Headwear ID",
  T_49_META_TYP_269_I3_D: "Face ID",
  T_49_META_TYP_269_I4_D: "Makeup ID",
  T_49_META_TYP_269_I5_D: "Upper Body ID",
  T_49_META_TYP_269_I6_D: "Bottom ID",
  T_49_META_TYP_269_I7_D: "Shoe ID",
  T_49_META_TYP_272_I0_D: "Female",
  T_49_META_TYP_272_I1_D: "Male",
  T_49_META_TYP_273_I0_D: "World coordinates of the center of the mini-map",
  T_49_META_TYP_273_I1_D: "Size of the mini-map, same width and height",
  T_49_META_TYP_273_I2_D: "Enable or disable the depth map display mode of the mini-map",
  T_49_META_TYP_274_I1_D: "Zoom size",
  T_49_META_TYP_274_I4_D: "Icon display level",
  T_49_META_TYP_275_I0_D: "Skeleton Scale",
  T_49_META_TYP_275_I1_D: "World coordinates of rig nodes",
  T_49_META_TYP_276_I0_D: "Head",
  T_49_META_TYP_276_I1_D: "Left Arm",
  T_49_META_TYP_276_I2_D: "Left Hand",
  T_49_META_TYP_276_I3_D: "Right Arm",
  T_49_META_TYP_276_I4_D: "Right Hand",
  T_49_META_TYP_276_I5_D: "Torso",
  T_49_META_TYP_276_I6_D: "Left Leg",
  T_49_META_TYP_276_I7_D: "Left Foot",
  T_49_META_TYP_276_I8_D: "Right Leg",
  T_49_META_TYP_276_I9_D: "Right Foot",
  T_49_META_TYP_277_I1_D: "Distance for camera ray detection",
  T_49_META_TYP_277_I2_D: "Collision layer mask for camera ray detection",
  T_49_META_TYP_277_I3_D: "Button position offset",
  T_49_META_TYP_277_I4_D: "Icon resource ID",
  T_49_META_TYP_277_I5_D: "Click area size",
  T_49_META_TYP_277_I6_D: "Whether objects are displayed at the target point",
  T_49_META_TYP_277_I7_D: "Objects displayed at the target point",
  T_49_META_TYP_278_I0_D: "Target entity for generating map pixels",
  T_49_META_TYP_28_I0_D: "Whether or not the team can reset every round.",
  T_49_META_TYP_280_I0_D: "Sphere radius",
  T_49_META_TYP_281_I0_D: "The radius of the hemispheres at both ends of the capsule.",
  T_49_META_TYP_29_I0_D: "Sphere",
  T_49_META_TYP_29_I1_D: "Light Beam",
  T_49_META_TYP_29_I10_D: "A pillar of light under the feet, now used for feedback when entering the finish line",
  T_49_META_TYP_29_I11_D: "Freeze",
  T_49_META_TYP_29_I12_D: "Light",
  T_49_META_TYP_29_I13_D: "Updraft",
  T_49_META_TYP_29_I14_D: "Gas Explosion",
  T_49_META_TYP_29_I15_D: "Hider Eliminated",
  T_49_META_TYP_29_I16_D: "Rampage",
  T_49_META_TYP_29_I17_D: "Clone Death",
  T_49_META_TYP_29_I18_D: "Shooting Feedback",
  T_49_META_TYP_29_I19_D: "Clone Death",
  T_49_META_TYP_29_I2_D: "Boom",
  T_49_META_TYP_29_I20_D: "Clone",
  T_49_META_TYP_29_I21_D: "Portal",
  T_49_META_TYP_29_I22_D: "Flashbang Smoke",
  T_49_META_TYP_29_I23_D: "Fireball",
  T_49_META_TYP_29_I24_D: "Burning in a Loop",
  T_49_META_TYP_29_I25_D: "Poison Gas",
  T_49_META_TYP_29_I26_D: "Heart",
  T_49_META_TYP_29_I29_D: "Door",
  T_49_META_TYP_29_I30_D: "Fireworks",
  T_49_META_TYP_29_I31_D: "Running Shoes VFX",
  T_49_META_TYP_29_I32_D: "Explosion VFX",
  T_49_META_TYP_29_I33_D: "Spawn Point VFX",
  T_49_META_TYP_29_I34_D: "Laser VFX",
  T_49_META_TYP_29_I35_D: "Skill Cast VFX",
  T_49_META_TYP_29_I36_D: "Bullet VFX",
  T_49_META_TYP_29_I37_D: "Bullet Hit VFX",
  T_49_META_TYP_29_I38_D: "Shooting VFX",
  T_49_META_TYP_29_I39_D: "Skill VFX",
  T_49_META_TYP_29_I40_D: "Halo",
  T_49_META_TYP_29_I41_D: "Bubbles",
  T_49_META_TYP_29_I42_D: "Smoke and Dust",
  T_49_META_TYP_29_I43_D: "Flying Debris",
  T_49_META_TYP_29_I44_D: "Lines",
  T_49_META_TYP_29_I45_D: "Flicker",
  T_49_META_TYP_29_I47_D: "Rising Particles",
  T_49_META_TYP_29_I48_D: "Smoke",
  T_49_META_TYP_29_I49_D: "Talisman",
  T_49_META_TYP_29_I50_D: "Frozen Area",
  T_49_META_TYP_29_I51_D: "Fog",
  T_49_META_TYP_29_I52_D: "Snowflake",
  T_49_META_TYP_29_I53_D: "Fire",
  T_49_META_TYP_29_I54_D: "Light Beam",
  T_49_META_TYP_29_I55_D: "Diffusing Poison Gas",
  T_49_META_TYP_29_I56_D: "Poison Gas",
  T_49_META_TYP_29_I57_D: "Explosion Flames",
  T_49_META_TYP_29_I58_D: "Light Effect",
  T_49_META_TYP_29_I59_D: "Star",
  T_49_META_TYP_29_I6_D: "Foot Halo",
  T_49_META_TYP_29_I60_D: "Blazing Bonfire",
  T_49_META_TYP_29_I61_D: "Water Splash",
  T_49_META_TYP_29_I62_D: "Electric Shock",
  T_49_META_TYP_29_I63_D: "Ink VFX",
  T_49_META_TYP_29_I64_D: "Blackhole VFX",
  T_49_META_TYP_29_I65_D: "Blackhole Explosion VFX",
  T_49_META_TYP_29_I66_D: "Crystal Ball VFX",
  T_49_META_TYP_29_I67_D: "Laser bullet effect",
  T_49_META_TYP_29_I68_D: "Drag effects",
  T_49_META_TYP_29_I69_D: "Clouds",
  T_49_META_TYP_29_I7_D: "Ground Marker",
  T_49_META_TYP_29_I8_D: "Smoke",
  T_49_META_TYP_29_I9_D: "Talisman Explosion",
  T_49_META_TYP_290_I0_D: "Refresh interval, the larger the number, the slower the refresh, in milliseconds.",
  T_49_META_TYP_290_I1_D: "Whether to enable debugging",
  T_49_META_TYP_291_I0_D: "Condition Node",
  T_49_META_TYP_291_I1_D: "Action Node",
  T_49_META_TYP_293_I0_D: "Behavior Tree ID",
  T_49_META_TYP_293_I1_D: "Attach Target",
  T_49_META_TYP_294_I1_D: "Layout Type",
  T_49_META_TYP_294_I10_D: "Sort Order",
  T_49_META_TYP_294_I2_D: "Content Origin",
  T_49_META_TYP_294_I3_D: "Alignment direction",
  T_49_META_TYP_294_I4_D: "Width and height of the sub-item grid",
  T_49_META_TYP_294_I5_D: "Cell Space",
  T_49_META_TYP_294_I6_D: "Constraint",
  T_49_META_TYP_294_I7_D: "Constraint Count",
  T_49_META_TYP_294_I8_D: "Vertical offset",
  T_49_META_TYP_294_I9_D: "Horizontal offset",
  T_49_META_TYP_295_I2_D: "Play Speed",
  T_49_META_TYP_296_I1_D: "Clip Length",
  T_49_META_TYP_297_I0_D: "Bound objects",
  T_49_META_TYP_297_I4_D: "Resource ID",
  T_49_META_TYP_298_I0_D: "Default",
  T_49_META_TYP_298_I2_D: "Once",
  T_49_META_TYP_30_I0_D: "Square",
  T_49_META_TYP_30_I1_D: "Quadrilateral",
  T_49_META_TYP_30_I10_D: "Arrow",
  T_49_META_TYP_30_I11_D: "Callout",
  T_49_META_TYP_30_I12_D: "Rock",
  T_49_META_TYP_30_I13_D: "Scissors",
  T_49_META_TYP_30_I14_D: "Paper",
  T_49_META_TYP_30_I15_D: "Like",
  T_49_META_TYP_30_I16_D: "Right",
  T_49_META_TYP_30_I17_D: "Wrong",
  T_49_META_TYP_30_I18_D: "Plus",
  T_49_META_TYP_30_I19_D: "Lightning",
  T_49_META_TYP_30_I2_D: "Right-Angled Trapezoid",
  T_49_META_TYP_30_I20_D: "Hearts",
  T_49_META_TYP_30_I21_D: "Star",
  T_49_META_TYP_30_I22_D: "Moon",
  T_49_META_TYP_30_I23_D: "Sun",
  T_49_META_TYP_30_I24_D: "Glasses",
  T_49_META_TYP_30_I25_D: "Key",
  T_49_META_TYP_30_I26_D: "Trophy",
  T_49_META_TYP_30_I27_D: "Flag",
  T_49_META_TYP_30_I28_D: "Hourglass",
  T_49_META_TYP_30_I29_D: "Folder",
  T_49_META_TYP_30_I3_D: "Trapezoid",
  T_49_META_TYP_30_I30_D: "Open Folder",
  T_49_META_TYP_30_I31_D: "House",
  T_49_META_TYP_30_I32_D: "Rest",
  T_49_META_TYP_30_I33_D: "Refresh",
  T_49_META_TYP_30_I34_D: "Loop",
  T_49_META_TYP_30_I35_D: "Magnifier",
  T_49_META_TYP_30_I36_D: "Trash Can",
  T_49_META_TYP_30_I37_D: "Return",
  T_49_META_TYP_30_I38_D: "Diamond",
  T_49_META_TYP_30_I39_D: "Swim Ring",
  T_49_META_TYP_30_I4_D: "Hexagon",
  T_49_META_TYP_30_I40_D: "Money",
  T_49_META_TYP_30_I41_D: "Lock",
  T_49_META_TYP_30_I42_D: "Settings",
  T_49_META_TYP_30_I43_D: "Exit",
  T_49_META_TYP_30_I44_D: "Dialogue",
  T_49_META_TYP_30_I45_D: "Crosshairs",
  T_49_META_TYP_30_I46_D: "Guns",
  T_49_META_TYP_30_I47_D: "Sword",
  T_49_META_TYP_30_I48_D: "Explosion",
  T_49_META_TYP_30_I49_D: "Aim",
  T_49_META_TYP_30_I5_D: "Circles",
  T_49_META_TYP_30_I50_D: "Cross",
  T_49_META_TYP_30_I51_D: "Defense",
  T_49_META_TYP_30_I52_D: "Zombie",
  T_49_META_TYP_30_I53_D: "Recycle",
  T_49_META_TYP_30_I54_D: "Gift",
  T_49_META_TYP_30_I55_D: "Clothes",
  T_49_META_TYP_30_I56_D: "Game",
  T_49_META_TYP_30_I57_D: "Player",
  T_49_META_TYP_30_I58_D: "Store",
  T_49_META_TYP_30_I59_D: "Exit",
  T_49_META_TYP_30_I6_D: "Triangle",
  T_49_META_TYP_30_I60_D: "Warning",
  T_49_META_TYP_30_I61_D: "Text",
  T_49_META_TYP_30_I62_D: "Timer Objects",
  T_49_META_TYP_30_I63_D: "Bell",
  T_49_META_TYP_30_I64_D: "Pet",
  T_49_META_TYP_30_I65_D: "Bomb",
  T_49_META_TYP_30_I66_D: "Repair",
  T_49_META_TYP_30_I67_D: "Smiling Face",
  T_49_META_TYP_30_I68_D: "Speaker",
  T_49_META_TYP_30_I7_D: "Exclamation Mark",
  T_49_META_TYP_30_I70_D: "Crown",
  T_49_META_TYP_30_I71_D: "Battle",
  T_49_META_TYP_30_I72_D: "Guild",
  T_49_META_TYP_30_I73_D: "Heartbeat",
  T_49_META_TYP_30_I74_D: "Music",
  T_49_META_TYP_30_I75_D: "Vehicle",
  T_49_META_TYP_30_I76_D: "Melee",
  T_49_META_TYP_30_I77_D: "Pistol",
  T_49_META_TYP_30_I78_D: "Rifle",
  T_49_META_TYP_30_I79_D: "Sniper Rifle",
  T_49_META_TYP_30_I8_D: "Question Mark",
  T_49_META_TYP_30_I80_D: "Shotgun",
  T_49_META_TYP_30_I81_D: "SMG",
  T_49_META_TYP_30_I82_D: "Healing Gun",
  T_49_META_TYP_30_I83_D: "Shatter Armor",
  T_49_META_TYP_30_I84_D: "Headshot",
  T_49_META_TYP_30_I85_D: "Skill 1",
  T_49_META_TYP_30_I86_D: "Skill 2",
  T_49_META_TYP_30_I87_D: "Skill 3",
  T_49_META_TYP_30_I88_D: "Skill 4",
  T_49_META_TYP_30_I89_D: "Skill 5",
  T_49_META_TYP_30_I9_D: "Mark",
  T_49_META_TYP_30_I90_D: "Skill 6",
  T_49_META_TYP_30_I91_D: "Skill 7",
  T_49_META_TYP_30_I92_D: "Skill 8",
  T_49_META_TYP_30_I93_D: "Skill 9",
  T_49_META_TYP_30_I94_D: "Skill 10",
  T_49_META_TYP_300_I0_D: "Resource ID",
  T_49_META_TYP_300_I2_D: "Rotation",
  T_49_META_TYP_300_I3_D: "Created Entity",
  T_49_META_TYP_301_I1_D: "Self-Destruct",
  T_49_META_TYP_301_I2_D: "Dash Attack",
  T_49_META_TYP_301_I3_D: "Shock Wave",
  T_49_META_TYP_301_I4_D: "Tornado Attack",
  T_49_META_TYP_301_I5_D: "Jump Attack",
  T_49_META_TYP_301_I6_D: "Shield Up",
  T_49_META_TYP_301_I7_D: "Shield Broken",
  T_49_META_TYP_302_I5_D: "Backpack",
  T_49_META_TYP_302_I7_D: "Skateboard, Camo ....",
  T_49_META_TYP_303_I0_D: "Add Max. Player HP",
  T_49_META_TYP_303_I1_D: "Restore Player HP Continuously",
  T_49_META_TYP_305_I0_D: "Finish",
  T_49_META_TYP_305_I1_D: "Running",
  T_49_META_TYP_307_I0_D: "Exp Per Damage",
  T_49_META_TYP_307_I1_D: "Exp Per Move Mile",
  T_49_META_TYP_307_I2_D: "EXP per Second",
  T_49_META_TYP_307_I3_D: "Chip Exp",
  T_49_META_TYP_307_I4_D: "Charge Max",
  T_49_META_TYP_308_I0_D: "Gel Maker",
  T_49_META_TYP_31_I0_D: "Grenade Explosion",
  T_49_META_TYP_31_I1_D: "Gun Sound",
  T_49_META_TYP_31_I10_D: "Hit Damage Sound",
  T_49_META_TYP_31_I11_D: "Upgrade Sound",
  T_49_META_TYP_31_I12_D: "Weakness hit sound effect",
  T_49_META_TYP_31_I13_D: "Player stepping sound effect",
  T_49_META_TYP_31_I14_D: "Equipment Repair Sound Effect",
  T_49_META_TYP_31_I15_D: "Equipment repair sound effect",
  T_49_META_TYP_31_I16_D: "Missing or lost sound effect",
  T_49_META_TYP_31_I17_D: "Reminder Sound",
  T_49_META_TYP_31_I18_D: "Soccer Ball Landing Sound Effect",
  T_49_META_TYP_31_I19_D: "Cheers Sound Effect",
  T_49_META_TYP_31_I2_D: "Countdown Beep",
  T_49_META_TYP_31_I20_D: "Bomb Alert Sound Effect",
  T_49_META_TYP_31_I21_D: "Bomb Before Explosion Sound Effect",
  T_49_META_TYP_31_I22_D: "Hunter Appearance Sound Effect",
  T_49_META_TYP_31_I23_D: "Final BGM Sound Effect",
  T_49_META_TYP_31_I24_D: "Resupply Box Refresh Sound Effect",
  T_49_META_TYP_31_I25_D: "Accelerator sound effect",
  T_49_META_TYP_31_I26_D: "Disappearing Sound",
  T_49_META_TYP_31_I27_D: "Visual Effects",
  T_49_META_TYP_31_I28_D: "Night Bugs",
  T_49_META_TYP_31_I29_D: "Dull percussion sound effect",
  T_49_META_TYP_31_I3_D: "UI Tap",
  T_49_META_TYP_31_I30_D: "Response Sound Effect",
  T_49_META_TYP_31_I31_D: "Discovery Surprise sound effect",
  T_49_META_TYP_31_I32_D: "Ghosts playing sound effect",
  T_49_META_TYP_31_I33_D: "Phase Start Sound Effect",
  T_49_META_TYP_31_I34_D: "Zombie sound effect",
  T_49_META_TYP_31_I35_D: "Scary sound effect",
  T_49_META_TYP_31_I36_D: "Transformation sound effect",
  T_49_META_TYP_31_I37_D: "Fast Heartbeat Sound Effect",
  T_49_META_TYP_31_I38_D: "Medium Heartbeat",
  T_49_META_TYP_31_I39_D: "Slow heartbeat sound effect",
  T_49_META_TYP_31_I4_D: "Female Screaming on Hit",
  T_49_META_TYP_31_I40_D: "Stampede sound effect",
  T_49_META_TYP_31_I41_D: "Clicking Sound",
  T_49_META_TYP_31_I42_D: "Skill Recovery Sound",
  T_49_META_TYP_31_I43_D: "Join Game Sound Effects",
  T_49_META_TYP_31_I44_D: "Mechanism Echo Sound",
  T_49_META_TYP_31_I45_D: "Mosquito sound effect",
  T_49_META_TYP_31_I46_D: "Clank 1 sound effect",
  T_49_META_TYP_31_I47_D: "Clank 2 sound effect",
  T_49_META_TYP_31_I48_D: "Mechanism opening sound effect",
  T_49_META_TYP_31_I49_D: "Energy Charge 1 sound effect",
  T_49_META_TYP_31_I5_D: "Male Screaming on Hit",
  T_49_META_TYP_31_I50_D: "Footsteps sound effect",
  T_49_META_TYP_31_I51_D: "Mission Success 1 sound effect",
  T_49_META_TYP_31_I52_D: "Danger Tone 1 sound effect",
  T_49_META_TYP_31_I53_D: "Danger tone 2 sound effect",
  T_49_META_TYP_31_I54_D: "Countdown 3 sound effect",
  T_49_META_TYP_31_I55_D: "Show Tips sound effect",
  T_49_META_TYP_31_I56_D: "Crow cawing ambient sound effect",
  T_49_META_TYP_31_I57_D: "Sound effect of teleporting to the wrong area with a teleport point",
  T_49_META_TYP_31_I58_D: "Sound effect of teleporting to the right area with a teleport point",
  T_49_META_TYP_31_I59_D: "Teleport sound effect",
  T_49_META_TYP_31_I6_D: "Gold Pickup Sound",
  T_49_META_TYP_31_I60_D: "Electric shock sound effect",
  T_49_META_TYP_31_I61_D: "Consumable sound effect",
  T_49_META_TYP_31_I62_D: "Electronic Fantasy Cute Background Music Sound Effects",
  T_49_META_TYP_31_I63_D: "Casual Game Background Music Sound Effects",
  T_49_META_TYP_31_I64_D: "Open Box",
  T_49_META_TYP_31_I65_D: "Level Up",
  T_49_META_TYP_31_I66_D: "Max. Level",
  T_49_META_TYP_31_I67_D: "Tap Button",
  T_49_META_TYP_31_I68_D: "Countdown",
  T_49_META_TYP_31_I69_D: "Defeat Enemy",
  T_49_META_TYP_31_I7_D: "Race past the finish line trigger sound effect",
  T_49_META_TYP_31_I70_D: "End",
  T_49_META_TYP_31_I71_D: "Forward",
  T_49_META_TYP_31_I72_D: "Victory",
  T_49_META_TYP_31_I73_D: "Training Base Checkpoints",
  T_49_META_TYP_31_I74_D: "Countdown",
  T_49_META_TYP_31_I75_D: "Game Start",
  T_49_META_TYP_31_I76_D: "Get Big Gold",
  T_49_META_TYP_31_I77_D: "Get Medium Gold",
  T_49_META_TYP_31_I78_D: "Get Small Gold",
  T_49_META_TYP_31_I79_D: "Join the Fray",
  T_49_META_TYP_31_I8_D: "Trigger Trigger Sound",
  T_49_META_TYP_31_I80_D: "Guild Supply",
  T_49_META_TYP_31_I81_D: "Speaker",
  T_49_META_TYP_31_I82_D: "Impeach Guild Leader",
  T_49_META_TYP_31_I83_D: "Save Warehouse",
  T_49_META_TYP_31_I84_D: "Special Gun Sound",
  T_49_META_TYP_31_I85_D: "Bullet Hit",
  T_49_META_TYP_31_I86_D: "Move",
  T_49_META_TYP_31_I87_D: "Tap Disable Button",
  T_49_META_TYP_31_I88_D: "Skill Charge Complete",
  T_49_META_TYP_31_I89_D: "Laser Skill",
  T_49_META_TYP_31_I9_D: "Degradation Sound",
  T_49_META_TYP_31_I90_D: "Get Consumable 2",
  T_49_META_TYP_31_I91_D: "Countdown 3",
  T_49_META_TYP_31_I92_D: "Game Over 2",
  T_49_META_TYP_31_I93_D: "Elimination Prompt",
  T_49_META_TYP_31_I94_D: "Explosion",
  T_49_META_TYP_31_I95_D: "Energy Orb Skill",
  T_49_META_TYP_31_I96_D: "Crimson Pool Skill",
  T_49_META_TYP_311_I1_D: "Max. Damage",
  T_49_META_TYP_311_I3_D: "The speed of the projectile after it is released, in m/s.",
  T_49_META_TYP_311_I4_D: "The time interval between when the projectile is released and when it takes effect, in seconds.",
  T_49_META_TYP_313_I0_D: "Zone Radius",
  T_49_META_TYP_313_I1_D: "Duration of countermeasure area, in seconds",
  T_49_META_TYP_314_I0_D: "Animation controller resource ID.",
  T_49_META_TYP_314_I1_D: "Animation Controller",
  T_49_META_TYP_315_I0_D: "The owner of the backpack.",
  T_49_META_TYP_315_I1_D: "The space of the backpack.",
  T_49_META_TYP_315_I2_D: "Used Capacity",
  T_49_META_TYP_315_I3_D: "All Supplies",
  T_49_META_TYP_316_I0_D: "Texture Resource",
  T_49_META_TYP_316_I1_D: "Shader Name",
  T_49_META_TYP_316_I11_D: "Flip method",
  T_49_META_TYP_316_I2_D: "UV Offset",
  T_49_META_TYP_316_I3_D: "UV Size",
  T_49_META_TYP_316_I4_D: "Fill Type",
  T_49_META_TYP_316_I5_D: "Border Left Right",
  T_49_META_TYP_316_I6_D: "Border Top Bottom",
  T_49_META_TYP_317_I0_D: "None",
  T_49_META_TYP_317_I1_D: "Freeze Position X",
  T_49_META_TYP_317_I2_D: "Freeze Position Y",
  T_49_META_TYP_317_I3_D: "Freeze Position Z",
  T_49_META_TYP_317_I4_D: "Restricted rotation around X-axis",
  T_49_META_TYP_317_I5_D: "Restriction of rotation around the Y-axis",
  T_49_META_TYP_317_I6_D: "Limit rotation around the Z-axis",
  T_49_META_TYP_317_I7_D: "Freeze Position",
  T_49_META_TYP_317_I8_D: "Freeze Rotation",
  T_49_META_TYP_317_I9_D: "Freeze All",
  T_49_META_TYP_318_I0_D: "Range",
  T_49_META_TYP_318_I1_D: "Full Damage Distance",
  T_49_META_TYP_318_I10_D: "Player Aiming Speed Factor",
  T_49_META_TYP_318_I11_D: "Scope Zoom-In Factor",
  T_49_META_TYP_318_I12_D: "FOV Magnification",
  T_49_META_TYP_318_I13_D: "ADS Magnification",
  T_49_META_TYP_318_I14_D: "ADS Magnification Time (s)",
  T_49_META_TYP_318_I15_D: "ADS Recovery Time (s)",
  T_49_META_TYP_318_I16_D: "Scope Min Damage Distance correction factor.",
  T_49_META_TYP_318_I17_D: "Allow ADS Aim Assist",
  T_49_META_TYP_318_I18_D: "Aim Assist Crosshairs Screen Range Attraction Ratio (0-1)",
  T_49_META_TYP_318_I19_D: "Aim Assist Distance Attenuation Coefficient (0-1)",
  T_49_META_TYP_318_I2_D: "Min. Damage Distance",
  T_49_META_TYP_318_I20_D: "Allow Aim Assist Distance First",
  T_49_META_TYP_318_I21_D: "Aim Assist Distance Priority Min. Distance",
  T_49_META_TYP_318_I22_D: "Aim Assist Distance Priority Max. Distance",
  T_49_META_TYP_318_I23_D: "Aim Assist Distance Priority Impact Coefficient (>=1)",
  T_49_META_TYP_318_I24_D: "ADS Rotation Sensitivity",
  T_49_META_TYP_318_I25_D: "Shrink Speed",
  T_49_META_TYP_318_I3_D: "Ammo Clip Size",
  T_49_META_TYP_318_I4_D: "Attack Interval",
  T_49_META_TYP_318_I5_D: "Reload Speed",
  T_49_META_TYP_318_I6_D: "Auto Reload Speed",
  T_49_META_TYP_318_I7_D: "Scatter Speed",
  T_49_META_TYP_318_I8_D: "Scattering rate when crouching and lying down, per 0.1 means 10% range increase per bullet aiming",
  T_49_META_TYP_318_I9_D: "Max. Spread",
  T_49_META_TYP_319_I0_D: "Simple",
  T_49_META_TYP_319_I1_D: "Sliced",
  T_49_META_TYP_319_I2_D: "Tiled",
  T_49_META_TYP_319_I3_D: "Filled",
  T_49_META_TYP_319_I4_D: "Fit",
  T_49_META_TYP_32_I0_D: "Player in normal active state",
  T_49_META_TYP_32_I1_D: "Player is knocked down",
  T_49_META_TYP_32_I2_D: "Player is dead",
  T_49_META_TYP_320_I0_D: "Horizontal",
  T_49_META_TYP_320_I1_D: "Vertical",
  T_49_META_TYP_320_I2_D: "Radial 90°",
  T_49_META_TYP_320_I3_D: "Radial 180°",
  T_49_META_TYP_320_I4_D: "Radial 360°",
  T_49_META_TYP_321_I0_D: "The maximum distance at which the targeting assist will be triggered.",
  T_49_META_TYP_321_I1_D: "The offset of the collimator when triggering targeting, if the offset point is not in the solid, the targeting will be disabled.",
  T_49_META_TYP_322_I0_D: "No",
  T_49_META_TYP_322_I1_D: "Head",
  T_49_META_TYP_322_I2_D: "Body",
  T_49_META_TYP_322_I3_D: "Limb",
  T_49_META_TYP_323_I0_D: "Scale",
  T_49_META_TYP_323_I1_D: "Account ID",
  T_49_META_TYP_323_I2_D: "Player Profile Information",
  T_49_META_TYP_323_I3_D: "Style",
  T_49_META_TYP_323_I4_D: "Show Rank",
  T_49_META_TYP_323_I5_D: "Show Pin",
  T_49_META_TYP_323_I6_D: "Show Nickname",
  T_49_META_TYP_324_I0_D: "Generate a specified amount of force",
  T_49_META_TYP_324_I1_D: "Generate an acceleration of a specified magnitude",
  T_49_META_TYP_324_I2_D: "Generate an impulse of a specified magnitude",
  T_49_META_TYP_324_I3_D: "Generate a specified amount of velocity",
  T_49_META_TYP_326_I0_D: "Account ID",
  T_49_META_TYP_326_I1_D: "Avatar ID",
  T_49_META_TYP_326_I2_D: "Banner ID",
  T_49_META_TYP_326_I3_D: "Pin ID",
  T_49_META_TYP_326_I4_D: "Player's nickname",
  T_49_META_TYP_326_I5_D: "BR Rank",
  T_49_META_TYP_326_I6_D: "Highest BR rank",
  T_49_META_TYP_326_I7_D: "CS Rank",
  T_49_META_TYP_326_I8_D: "Highest CS rank",
  T_49_META_TYP_327_I0_D: "Resource ID",
  T_49_META_TYP_327_I1_D: "Part Mask 1",
  T_49_META_TYP_327_I2_D: "Part Mask 2",
  T_49_META_TYP_327_I3_D: "Part Mask 3",
  T_49_META_TYP_327_I4_D: "Part Mask 4",
  T_49_META_TYP_329_I0_D: "Driver",
  T_49_META_TYP_329_I1_D: "Passenger A",
  T_49_META_TYP_329_I2_D: "Passenger B",
  T_49_META_TYP_329_I3_D: "Passenger C",
  T_49_META_TYP_33_I0_D: "Ascending order ignores zero values, zero values come last",
  T_49_META_TYP_33_I1_D: "Descending order, large to small",
  T_49_META_TYP_33_I2_D: "Ascending, smallest to largest",
  T_49_META_TYP_330_I4_D: "Duration of invincibility effect (in s)",
  T_49_META_TYP_330_I5_D: "Control Points",
  T_49_META_TYP_330_I8_D: "Delta Value",
  T_49_META_TYP_332_I0_D: "Is Loop",
  T_49_META_TYP_333_I0_D: "FZLanTingHei",
  T_49_META_TYP_333_I1_D: "SimplifiedArabic",
  T_49_META_TYP_333_I2_D: "NotoNastaliqUrdu",
  T_49_META_TYP_333_I3_D: "GFFLatin",
  T_49_META_TYP_333_I4_D: "AgencyFB",
  T_49_META_TYP_333_I5_D: "Supermarket",
  T_49_META_TYP_333_I6_D: "HindSiliguri",
  T_49_META_TYP_335_I0_D: "Resource path, default is empty",
  T_49_META_TYP_335_I1_D: "Play count, default is 1",
  T_49_META_TYP_335_I2_D: "Volume, default is 50",
  T_49_META_TYP_335_I3_D: "Max. Distance",
  T_49_META_TYP_335_I4_D: "Min. Distance",
  T_49_META_TYP_335_I5_D: "Whether the music is 3D or not",
  T_49_META_TYP_335_I6_D: "Priority",
  T_49_META_TYP_335_I7_D: "Wait time before start, in seconds",
  T_49_META_TYP_335_I8_D: "Is Playing",
  T_49_META_TYP_338_I0_D: "Movement status",
  T_49_META_TYP_338_I1_D: "Sprint",
  T_49_META_TYP_338_I2_D: "Attack",
  T_49_META_TYP_338_I3_D: "Jump",
  T_49_META_TYP_338_I4_D: "Overrun",
  T_49_META_TYP_338_I5_D: "Enter vehicle (driver)",
  T_49_META_TYP_338_I6_D: "Enter Carrier (Passenger)",
  T_49_META_TYP_338_I7_D: "Exit Vehicle",
  T_49_META_TYP_338_I8_D: "Drive",
  T_49_META_TYP_339_I0_D: "Damage Ratio Limb",
  T_49_META_TYP_339_I1_D: "Headshot DMG Coefficient",
  T_49_META_TYP_339_I2_D: "Max. Durability Multiplier",
  T_49_META_TYP_339_I3_D: "Extra HP Ratio",
  T_49_META_TYP_339_I4_D: "Additional Blast Damage Reduction Factor (%)",
  T_49_META_TYP_339_I5_D: "Extra Backpack Capacity",
  T_49_META_TYP_339_I6_D: "Replacement Priority",
  T_49_META_TYP_34_I0_D: "Default Fist",
  T_49_META_TYP_34_I1_D: "Kar98K",
  T_49_META_TYP_34_I10_D: "AWM2",
  T_49_META_TYP_34_I100_D: "Famas-I",
  T_49_META_TYP_34_I101_D: "Groza-X",
  T_49_META_TYP_34_I102_D: "SVD-Y",
  T_49_META_TYP_34_I103_D: "G36",
  T_49_META_TYP_34_I104_D: "M24",
  T_49_META_TYP_34_I105_D: "M4A1-I",
  T_49_META_TYP_34_I106_D: "M4A1-II",
  T_49_META_TYP_34_I107_D: "M4A1-III",
  T_49_META_TYP_34_I108_D: "M4A1-III",
  T_49_META_TYP_34_I109_D: "Shotgun",
  T_49_META_TYP_34_I11_D: "M1014",
  T_49_META_TYP_34_I110_D: "MAC10",
  T_49_META_TYP_34_I111_D: "Hand Cannon",
  T_49_META_TYP_34_I112_D: "IceGun",
  T_49_META_TYP_34_I113_D: "Shield Gun",
  T_49_META_TYP_34_I114_D: "MP5-II",
  T_49_META_TYP_34_I115_D: "MP5-III",
  T_49_META_TYP_34_I116_D: "Shield Gun",
  T_49_META_TYP_34_I117_D: "M60-II",
  T_49_META_TYP_34_I118_D: "M60-III",
  T_49_META_TYP_34_I119_D: "M60-III",
  T_49_META_TYP_34_I12_D: "M10142",
  T_49_META_TYP_34_I120_D: "VSS-II",
  T_49_META_TYP_34_I121_D: "VSS-III",
  T_49_META_TYP_34_I122_D: "M14-II",
  T_49_META_TYP_34_I123_D: "M14-III",
  T_49_META_TYP_34_I124_D: "M14-III",
  T_49_META_TYP_34_I125_D: "Kar98K-II",
  T_49_META_TYP_34_I126_D: "Kar98K-III",
  T_49_META_TYP_34_I127_D: "Kar98K-III",
  T_49_META_TYP_34_I128_D: "Kar98K-Ⅲ - Kar98K-III",
  T_49_META_TYP_34_I129_D: "Famas-III",
  T_49_META_TYP_34_I13_D: "Flame Grenade Gun",
  T_49_META_TYP_34_I133_D: "Flashbang",
  T_49_META_TYP_34_I134_D: "Smoke Grenade",
  T_49_META_TYP_34_I135_D: "Freezing Grenade",
  T_49_META_TYP_34_I136_D: "Bulletproof Vest Lv1",
  T_49_META_TYP_34_I137_D: "Body armor Lv2",
  T_49_META_TYP_34_I138_D: "Body armor Lv3",
  T_49_META_TYP_34_I139_D: "Helmet Lv1",
  T_49_META_TYP_34_I14_D: "AK",
  T_49_META_TYP_34_I140_D: "Helmet Lv2",
  T_49_META_TYP_34_I141_D: "Helmet Lv3",
  T_49_META_TYP_34_I142_D: "Explosion-proof Armor",
  T_49_META_TYP_34_I143_D: "Backpack Lv1",
  T_49_META_TYP_34_I144_D: "Backpack Lv2",
  T_49_META_TYP_34_I145_D: "Backpack Lv3",
  T_49_META_TYP_34_I146_D: "Muzzle Lv1",
  T_49_META_TYP_34_I147_D: "Muzzle Lv2",
  T_49_META_TYP_34_I148_D: "Muzzle Lv3",
  T_49_META_TYP_34_I149_D: "Silencer",
  T_49_META_TYP_34_I15_D: "AK2",
  T_49_META_TYP_34_I150_D: "Assault Muzzle",
  T_49_META_TYP_34_I151_D: "Wide Muzzle",
  T_49_META_TYP_34_I152_D: "Magazine Lv1",
  T_49_META_TYP_34_I153_D: "Magazine Lv2",
  T_49_META_TYP_34_I154_D: "Magazine Lv3",
  T_49_META_TYP_34_I155_D: "Double Bundle Magazine",
  T_49_META_TYP_34_I156_D: "Chain Magazine",
  T_49_META_TYP_34_I157_D: "Grip Lv1",
  T_49_META_TYP_34_I158_D: "Grip Lv2",
  T_49_META_TYP_34_I159_D: "Grip Lv3",
  T_49_META_TYP_34_I16_D: "UMP",
  T_49_META_TYP_34_I160_D: "Folding Bracket",
  T_49_META_TYP_34_I161_D: "Shooter's Rifle Grip",
  T_49_META_TYP_34_I162_D: "Shotgun Stocks",
  T_49_META_TYP_34_I163_D: "Sniper Stocks",
  T_49_META_TYP_34_I164_D: "Thermal Imaging Scope",
  T_49_META_TYP_34_I165_D: "Stock Lv1",
  T_49_META_TYP_34_I166_D: "Stock Lv2",
  T_49_META_TYP_34_I167_D: "Stock Lv3",
  T_49_META_TYP_34_I168_D: "Shield Expander",
  T_49_META_TYP_34_I169_D: "Full Body Armor",
  T_49_META_TYP_34_I17_D: "UMP2",
  T_49_META_TYP_34_I170_D: "Excess Jacket",
  T_49_META_TYP_34_I171_D: "Explosion-proof Jacket",
  T_49_META_TYP_34_I172_D: "Backpack Expander",
  T_49_META_TYP_34_I173_D: "Healing Breather",
  T_49_META_TYP_34_I174_D: "Horizaline",
  T_49_META_TYP_34_I175_D: "MedKit",
  T_49_META_TYP_34_I176_D: "Armor Repair Kit",
  T_49_META_TYP_34_I177_D: "An AI sentry tower made of high-tech materials that actively searches and attacks enemies within a certain range",
  T_49_META_TYP_34_I178_D: "Level 1 Mushroom",
  T_49_META_TYP_34_I179_D: "Level 2 Mushroom",
  T_49_META_TYP_34_I18_D: "MP5",
  T_49_META_TYP_34_I180_D: "Level 3 Mushroom",
  T_49_META_TYP_34_I181_D: "Level 4 Mushroom",
  T_49_META_TYP_34_I182_D: "Personal UAV",
  T_49_META_TYP_34_I184_D: "Sensor Mines",
  T_49_META_TYP_34_I185_D: "Jet Flying Shoes",
  T_49_META_TYP_34_I186_D: "Bouncing Power Shoes",
  T_49_META_TYP_34_I187_D: "Glider",
  T_49_META_TYP_34_I188_D: "Bait Grenade",
  T_49_META_TYP_34_I189_D: "Maglev Skateboard",
  T_49_META_TYP_34_I19_D: "Desert Eagle",
  T_49_META_TYP_34_I190_D: "Bomb Disposal Pliers",
  T_49_META_TYP_34_I191_D: "Gun Upgrader",
  T_49_META_TYP_34_I192_D: "Rifle Ammo",
  T_49_META_TYP_34_I193_D: "Pistol Ammo",
  T_49_META_TYP_34_I194_D: "Sniper Rifle Ammo",
  T_49_META_TYP_34_I195_D: "Shotgun Ammo",
  T_49_META_TYP_34_I196_D: "SMG Ammo",
  T_49_META_TYP_34_I197_D: "Arrows",
  T_49_META_TYP_34_I198_D: "M79 Grenade",
  T_49_META_TYP_34_I199_D: "Flamethrower Bullets",
  T_49_META_TYP_34_I2_D: "CROSSBOW",
  T_49_META_TYP_34_I20_D: "G18",
  T_49_META_TYP_34_I200_D: "THROWINGKNIFE2",
  T_49_META_TYP_34_I201_D: "Hook",
  T_49_META_TYP_34_I202_D: "Football Gun",
  T_49_META_TYP_34_I203_D: "Boxing",
  T_49_META_TYP_34_I204_D: "Flamethrower",
  T_49_META_TYP_34_I205_D: "MonkeygodCard",
  T_49_META_TYP_34_I206_D: "MadeManACard",
  T_49_META_TYP_34_I207_D: "DjmaleCard",
  T_49_META_TYP_34_I208_D: "GraffitistCard",
  T_49_META_TYP_34_I209_D: "DetectiveCard",
  T_49_META_TYP_34_I21_D: "M14",
  T_49_META_TYP_34_I210_D: "ProfessorCard",
  T_49_META_TYP_34_I211_D: "BountyHunterCard",
  T_49_META_TYP_34_I212_D: "SuperstarCard",
  T_49_META_TYP_34_I213_D: "XtremeCard",
  T_49_META_TYP_34_I214_D: "MusicBroCard",
  T_49_META_TYP_34_I215_D: "KentaCard",
  T_49_META_TYP_34_I216_D: "TRACKERCard",
  T_49_META_TYP_34_I217_D: "CrazygirlCard",
  T_49_META_TYP_34_I218_D: "RunSpeedUpCard",
  T_49_META_TYP_34_I219_D: "SantinoCard",
  T_49_META_TYP_34_I22_D: "SCAR",
  T_49_META_TYP_34_I220_D: "VillainCard",
  T_49_META_TYP_34_I23_D: "SCAR",
  T_49_META_TYP_34_I24_D: "SCAR-I",
  T_49_META_TYP_34_I25_D: "SCAR-II",
  T_49_META_TYP_34_I26_D: "SCAR-III",
  T_49_META_TYP_34_I27_D: "M1014-I",
  T_49_META_TYP_34_I28_D: "M1014-II",
  T_49_META_TYP_34_I29_D: "M1014-III",
  T_49_META_TYP_34_I3_D: "Loot Soccer Shield",
  T_49_META_TYP_34_I30_D: "Superheated Energy Gun",
  T_49_META_TYP_34_I31_D: "Superheated Gun-I",
  T_49_META_TYP_34_I32_D: "Superheat Gun-II",
  T_49_META_TYP_34_I33_D: "Superheat Gun-III",
  T_49_META_TYP_34_I34_D: "PLASMA-X",
  T_49_META_TYP_34_I35_D: "Heal Pistol-Y",
  T_49_META_TYP_34_I36_D: "Heal Sniper",
  T_49_META_TYP_34_I37_D: "Heal Pistol",
  T_49_META_TYP_34_I38_D: "VSS",
  T_49_META_TYP_34_I39_D: "Groza",
  T_49_META_TYP_34_I4_D: "FootballIce",
  T_49_META_TYP_34_I40_D: "Groza",
  T_49_META_TYP_34_I41_D: "MP40",
  T_49_META_TYP_34_I42_D: "MP40",
  T_49_META_TYP_34_I43_D: "Pan",
  T_49_META_TYP_34_I44_D: "Machete",
  T_49_META_TYP_34_I45_D: "SKS",
  T_49_META_TYP_34_I46_D: "M249",
  T_49_META_TYP_34_I47_D: "M249-X",
  T_49_META_TYP_34_I48_D: "M1873",
  T_49_META_TYP_34_I49_D: "M79",
  T_49_META_TYP_34_I5_D: "Bizon",
  T_49_META_TYP_34_I50_D: "FAMAS",
  T_49_META_TYP_34_I51_D: "M500",
  T_49_META_TYP_34_I52_D: "SVD",
  T_49_META_TYP_34_I53_D: "SVD",
  T_49_META_TYP_34_I54_D: "AC80",
  T_49_META_TYP_34_I55_D: "Baseball Bat",
  T_49_META_TYP_34_I56_D: "XM8",
  T_49_META_TYP_34_I57_D: "XM8",
  T_49_META_TYP_34_I58_D: "SPAS12",
  T_49_META_TYP_34_I59_D: "SPAS12",
  T_49_META_TYP_34_I6_D: "VSK94",
  T_49_META_TYP_34_I60_D: "M60",
  T_49_META_TYP_34_I61_D: "MGL140",
  T_49_META_TYP_34_I62_D: "P90",
  T_49_META_TYP_34_I63_D: "P90",
  T_49_META_TYP_34_I64_D: "AN94",
  T_49_META_TYP_34_I65_D: "Samurai Sword",
  T_49_META_TYP_34_I66_D: "CG15",
  T_49_META_TYP_34_I67_D: "RG550",
  T_49_META_TYP_34_I68_D: "Gatling",
  T_49_META_TYP_34_I7_D: "M4A1",
  T_49_META_TYP_34_I70_D: "Power Hook Gun",
  T_49_META_TYP_34_I71_D: "FF Knife",
  T_49_META_TYP_34_I72_D: "M1887",
  T_49_META_TYP_34_I73_D: "1887 with 3 bullets",
  T_49_META_TYP_34_I74_D: "M18872",
  T_49_META_TYP_34_I75_D: "THOMPSON",
  T_49_META_TYP_34_I76_D: "THOMPSON",
  T_49_META_TYP_34_I77_D: "M82B",
  T_49_META_TYP_34_I78_D: "M82B",
  T_49_META_TYP_34_I79_D: "AUG",
  T_49_META_TYP_34_I8_D: "USP",
  T_49_META_TYP_34_I80_D: "PARAFAL",
  T_49_META_TYP_34_I81_D: "PARAFAL",
  T_49_META_TYP_34_I82_D: "Woodpecker",
  T_49_META_TYP_34_I83_D: "VECTOR",
  T_49_META_TYP_34_I84_D: "MAG-7",
  T_49_META_TYP_34_I85_D: "MAG-7",
  T_49_META_TYP_34_I86_D: "Scythe",
  T_49_META_TYP_34_I87_D: "Big Head Hammer",
  T_49_META_TYP_34_I88_D: "Flying Dagger (pickable)",
  T_49_META_TYP_34_I89_D: "Kord",
  T_49_META_TYP_34_I9_D: "AWM",
  T_49_META_TYP_34_I90_D: "M1917",
  T_49_META_TYP_34_I91_D: "USP-2",
  T_49_META_TYP_34_I92_D: "Kingfisher",
  T_49_META_TYP_34_I93_D: "UZI",
  T_49_META_TYP_34_I94_D: "MP5-I",
  T_49_META_TYP_34_I95_D: "M60-I",
  T_49_META_TYP_34_I96_D: "VSS-I",
  T_49_META_TYP_34_I97_D: "M14-I",
  T_49_META_TYP_34_I98_D: "Kar98K-I",
  T_49_META_TYP_34_I99_D: "AWM_Y",
  T_49_META_TYP_340_I0_D: "Easy",
  T_49_META_TYP_340_I1_D: "Simple",
  T_49_META_TYP_340_I2_D: "Normal",
  T_49_META_TYP_340_I3_D: "Moderate",
  T_49_META_TYP_340_I4_D: "Hard",
  T_49_META_TYP_340_I5_D: "Inferno",
  T_49_META_TYP_342_I0_D: "Start Event",
  T_49_META_TYP_342_I1_D: "Stop Event",
  T_49_META_TYP_342_I2_D: "Pause Event",
  T_49_META_TYP_342_I3_D: "How long to wait after being created to start the timer, in milliseconds",
  T_49_META_TYP_342_I4_D: "Loop Count",
  T_49_META_TYP_342_I5_D: "Events",
  T_49_META_TYP_342_I6_D: "Countdown or positive timing",
  T_49_META_TYP_342_I7_D: "Player Status",
  T_49_META_TYP_342_I8_D: "Timing end time in seconds",
  T_49_META_TYP_345_I10_D: "Hand Cannon",
  T_49_META_TYP_345_I12_D: "Ice Wall Gun",
  T_49_META_TYP_345_I13_D: "Flamethrower",
  T_49_META_TYP_345_I4_D: "Shotgun",
  T_49_META_TYP_345_I6_D: "Special Gun",
  T_49_META_TYP_345_I8_D: "Accumulator",
  T_49_META_TYP_346_I0_D: "Rifle Ammo",
  T_49_META_TYP_346_I1_D: "Pistol Ammo",
  T_49_META_TYP_346_I2_D: "Sniper Rifle Ammo",
  T_49_META_TYP_346_I3_D: "Shotgun Ammo",
  T_49_META_TYP_346_I4_D: "SMG Ammo",
  T_49_META_TYP_346_I5_D: "Arrows",
  T_49_META_TYP_346_I6_D: "M79 Grenade",
  T_49_META_TYP_346_I7_D: "Hook",
  T_49_META_TYP_346_I8_D: "M79 Specialized Grenade",
  T_49_META_TYP_347_I3_D: "Can be combined with Relative Motion if true, must be combined with Absolute Motion if false, otherwise the property will not take effect correctly.",
  T_49_META_TYP_347_I6_D: "Delta Value",
  T_49_META_TYP_350_I0_D: "Sports Car",
  T_49_META_TYP_350_I1_D: "Motorbike",
  T_49_META_TYP_350_I2_D: "Jeep",
  T_49_META_TYP_350_I3_D: "SUV",
  T_49_META_TYP_350_I4_D: "Monster Truck",
  T_49_META_TYP_350_I5_D: "Mutant Truck",
  T_49_META_TYP_352_I1_D: "Unselected Sprite",
  T_49_META_TYP_352_I2_D: "Unchecked image type",
  T_49_META_TYP_352_I3_D: "Unselected Color",
  T_49_META_TYP_352_I4_D: "Selected Sprite",
  T_49_META_TYP_352_I5_D: "Selected Image Type",
  T_49_META_TYP_352_I6_D: "Selected Color",
  T_49_META_TYP_353_I0_D: "HP Recovery Amount",
  T_49_META_TYP_353_I1_D: "HP Recovery Speed (ms)",
  T_49_META_TYP_353_I2_D: "Time Required (ms)",
  T_49_META_TYP_354_I0_D: "EP Recovery Amount",
  T_49_META_TYP_355_I0_D: "HP Recovery Amount",
  T_49_META_TYP_355_I1_D: "EP Recovery Amount",
  T_49_META_TYP_355_I2_D: "Time Required (ms)",
  T_49_META_TYP_356_I0_D: "Drop Items",
  T_49_META_TYP_356_I1_D: "Drop box drop time ms",
  T_49_META_TYP_356_I2_D: "Airdrop State",
  T_49_META_TYP_357_I0_D: "Surface",
  T_49_META_TYP_357_I1_D: "Boundary",
  T_49_META_TYP_359_I0_D: "Whether to use a player controller with physics effects",
  T_49_META_TYP_359_I1_D: "Placed on a slope above this angle, it will slide downward",
  T_49_META_TYP_359_I10_D: "This gravity acceleration is only applied to this player's controller.",
  T_49_META_TYP_359_I11_D: "Mass in kg",
  T_49_META_TYP_359_I12_D: "If the slope exceeds the maximum uphill angle, the capsule will slide downward.",
  T_49_META_TYP_359_I16_D: "When enabled, movement is controlled by server-side blocks or scripts.",
  T_49_META_TYP_359_I17_D: "When enabled, the force applied when the character pushes on a rigid body can be customized.",
  T_49_META_TYP_359_I18_D: "The amount of force applied when the character pushes the rigid body",
  T_49_META_TYP_359_I19_D: "True when the lower part of the body touches the collision body, usually used to determine if the player is on the ground.",
  T_49_META_TYP_359_I2_D: "Only obstacles above this height will have a blocking effect, in the range [0,Height]",
  T_49_META_TYP_359_I20_D: "Customizable physics level, value [0,15].",
  T_49_META_TYP_359_I21_D: "Enable Rotate With Gravity",
  T_49_META_TYP_359_I3_D: "Allows embedding to change the depth of the capsule body. It can prevent the character from getting stuck or shaking, and is not recommended to be changed without special needs. Value range (0,Radius]",
  T_49_META_TYP_359_I4_D: "Minimum movement distance, any movement less than this value will not be executed. If there is no special need, it is recommended to keep it at 0.",
  T_49_META_TYP_359_I5_D: "The offset of the center of the collision box from the local coordinate origin.",
  T_49_META_TYP_359_I6_D: "Radius of the capsule, minimum value 0.01.",
  T_49_META_TYP_359_I7_D: "Total height of the capsule, including the upper and lower hemispheres, min. 2*Radius",
  T_49_META_TYP_359_I8_D: "Current linear velocity, in m/s",
  T_49_META_TYP_360_I0_D: "Left Firing Arc Angle",
  T_49_META_TYP_360_I1_D: "Right Firing Arc Angle",
  T_49_META_TYP_360_I2_D: "Min. Elevation Angle",
  T_49_META_TYP_360_I3_D: "Max. Depression Angle",
  T_49_META_TYP_360_I4_D: "Muzzle Velocity",
  T_49_META_TYP_362_I0_D: "Freeze time caused by hitting the player, in seconds",
  T_49_META_TYP_363_I0_D: "Disable Hud Request Purchase",
  T_49_META_TYP_363_I1_D: "Request help from team to buy",
  T_49_META_TYP_363_I2_D: "Purchase by requesting help from a camp",
  T_49_META_TYP_364_I0_D: "Is Center Position",
  T_49_META_TYP_364_I1_D: "Whether to loop playback",
  T_49_META_TYP_364_I2_D: "Animation name",
  T_49_META_TYP_364_I3_D: "Whether or not to autoplay",
  T_49_META_TYP_364_I4_D: "Use Custom Resource",
  T_49_META_TYP_366_I0_D: "Specifies the UUID of the Batch resource to render.",
  T_49_META_TYP_367_I1_D: "Show Tag",
  T_49_META_TYP_367_I2_D: "Icon style for marker targets",
  T_49_META_TYP_367_I3_D: "Overlay color of icons displayed on marked targets",
  T_49_META_TYP_367_I4_D: "Icon style displayed on a scale",
  T_49_META_TYP_367_I5_D: "Overlay color of the icon displayed on a scale",
  T_49_META_TYP_367_I6_D: "Always Show Mark",
  T_49_META_TYP_370_I0_D: "Main title",
  T_49_META_TYP_370_I1_D: "Subtitle",
  T_49_META_TYP_370_I2_D: "Upper background color",
  T_49_META_TYP_370_I3_D: "Bottom background color",
  T_49_META_TYP_371_I2_D: "Left Score",
  T_49_META_TYP_371_I3_D: "Right Score",
  T_49_META_TYP_371_I4_D: "The last score on the left, used to play the score switching Animation",
  T_49_META_TYP_371_I5_D: "The last score on the right, used to play the score toggle Animation",
  T_49_META_TYP_372_I0_D: "Standing",
  T_49_META_TYP_372_I1_D: "Show Crouch",
  T_49_META_TYP_372_I10_D: "High fall",
  T_49_META_TYP_372_I11_D: "Low fall, e.g. jumping",
  T_49_META_TYP_372_I12_D: "Flying shoes",
  T_49_META_TYP_372_I13_D: "Two jump jumps",
  T_49_META_TYP_372_I14_D: "Sitting on a chair",
  T_49_META_TYP_372_I15_D: "Ejected by catapult",
  T_49_META_TYP_372_I16_D: "Catapult preparation phase",
  T_49_META_TYP_372_I17_D: "Gliding on the consumable",
  T_49_META_TYP_372_I18_D: "Gliding prop drop",
  T_49_META_TYP_372_I19_D: "Bounced by tires",
  T_49_META_TYP_372_I2_D: "Running",
  T_49_META_TYP_372_I20_D: "Bounced by human tires",
  T_49_META_TYP_372_I21_D: "An Animation in the Party Zone",
  T_49_META_TYP_372_I22_D: "Ride a Flying Machine",
  T_49_META_TYP_372_I23_D: "Entering a Cannon",
  T_49_META_TYP_372_I24_D: "This is the state when coming out of a Cannon, Carrier, etc. if the ride object is flying",
  T_49_META_TYP_372_I25_D: "After jumping from a springboard",
  T_49_META_TYP_372_I26_D: "After getting off the zipline",
  T_49_META_TYP_372_I27_D: "Not used",
  T_49_META_TYP_372_I3_D: "Down and Crawl",
  T_49_META_TYP_372_I4_D: "Swimming",
  T_49_META_TYP_372_I5_D: "Falling vertically",
  T_49_META_TYP_372_I6_D: "Over the wall",
  T_49_META_TYP_372_I7_D: "Unused",
  T_49_META_TYP_372_I8_D: "Knocked down but not dead",
  T_49_META_TYP_372_I9_D: "Water Skateboarding",
  T_49_META_TYP_374_I0_D: "Life, level and stroke colors",
  T_49_META_TYP_374_I1_D: "When the life value decreases, the lost portion is briefly shown in this color.",
  T_49_META_TYP_374_I10_D: "Offset relative to the target to be followed",
  T_49_META_TYP_374_I11_D: "The amount of life between each line, if less than or equal to 0, it will not be shown.",
  T_49_META_TYP_374_I12_D: "Total HP",
  T_49_META_TYP_374_I13_D: "Current HP",
  T_49_META_TYP_374_I14_D: "When enabled, blood changes will be colored differently.",
  T_49_META_TYP_374_I15_D: "When enabled, the offset property is transferred to the world coordinate system using the local coordinate system.",
  T_49_META_TYP_374_I2_D: "When the life value increases, the increased part is briefly displayed in this color.",
  T_49_META_TYP_374_I3_D: "The color of the life value border and the bottom of the vignette.",
  T_49_META_TYP_374_I4_D: "Range 0~1, the transparency of the overall UI.",
  T_49_META_TYP_374_I5_D: "Determines the overall UI scaling, and the font will be scaled as well.",
  T_49_META_TYP_374_I6_D: "Indicates the name of the current blood bar owner",
  T_49_META_TYP_374_I8_D: "The length of the bloodstain portion on the screen",
  T_49_META_TYP_374_I9_D: "Must follow an entity with a Transform component.",
  T_49_META_TYP_375_I1_D: "Battle Entity",
  T_49_META_TYP_376_I1_D: "Battle Entity",
  T_49_META_TYP_38_I0_D: "Alpha",
  T_49_META_TYP_382_I0_D: "Default",
  T_49_META_TYP_382_I1_D: "Skip the knockdown state and just die",
  T_49_META_TYP_382_I2_D: "No Skip Knockdown",
  T_49_META_TYP_387_I1_D: "Allow Pressed Outside",
  T_49_META_TYP_389_I0_D: "Default offset of the base",
  T_49_META_TYP_389_I1_D: "Background Sprite",
  T_49_META_TYP_389_I10_D: "Inactivated Alpha",
  T_49_META_TYP_389_I2_D: "Background Radius",
  T_49_META_TYP_389_I3_D: "Joystick Cap Image",
  T_49_META_TYP_389_I4_D: "Joystick Cap Radius",
  T_49_META_TYP_389_I5_D: "Joystick Cap Drag Radius",
  T_49_META_TYP_389_I6_D: "Arrow Sprite",
  T_49_META_TYP_389_I7_D: "Arrow Size",
  T_49_META_TYP_389_I8_D: "Arrow Offset",
  T_49_META_TYP_389_I9_D: "Activated Alpha",
  T_49_META_TYP_39_I1_D: "Sprite Shape",
  T_49_META_TYP_39_I10_D: "Gradient Top",
  T_49_META_TYP_39_I11_D: "Gradient Bottom",
  T_49_META_TYP_39_I12_D: "Top Alpha",
  T_49_META_TYP_39_I13_D: "Bottom Alpha",
  T_49_META_TYP_39_I3_D: "Flip",
  T_49_META_TYP_39_I4_D: "Filled",
  T_49_META_TYP_39_I5_D: "Center Invisible",
  T_49_META_TYP_39_I6_D: "Fill Direction",
  T_49_META_TYP_39_I7_D: "Fill Value",
  T_49_META_TYP_39_I8_D: "Invert Fill",
  T_49_META_TYP_39_I9_D: "Gradient",
  T_49_META_TYP_392_I0_D: "Default is 0, unit is ms.",
  T_49_META_TYP_392_I1_D: "The time it takes to shrink the circle, in ms",
  T_49_META_TYP_392_I10_D: "The end time of the reduced circle, in ms",
  T_49_META_TYP_392_I12_D: "Radius of out-of-zone end circle.",
  T_49_META_TYP_392_I13_D: "Shrinking Start Time",
  T_49_META_TYP_392_I14_D: "Damage Interval (ms)",
  T_49_META_TYP_392_I3_D: "The amount of damage done to players in the out-of-zone in a single turn.",
  T_49_META_TYP_392_I4_D: "List of players in the safe zone",
  T_49_META_TYP_392_I5_D: "Safe zone disappearance time, no safe zone will be generated when the safe zone disappearance time is less than the effective time.",
  T_49_META_TYP_392_I6_D: "Group ID",
  T_49_META_TYP_392_I7_D: "Radius of the out-of-zone starting circle",
  T_49_META_TYP_392_I8_D: "End state",
  T_49_META_TYP_392_I9_D: "Status",
  T_49_META_TYP_394_I0_D: "Value is about 3.1416",
  T_49_META_TYP_394_I1_D: "Value about 2.7183",
  T_49_META_TYP_396_I0_D: "Title",
  T_49_META_TYP_396_I1_D: "Content",
  T_49_META_TYP_396_I2_D: "Options",
  T_49_META_TYP_396_I3_D: "ShowBackground",
  T_49_META_TYP_399_I0_D: "Jump Height",
  T_49_META_TYP_399_I1_D: "The number of consecutive jumps that can be performed before landing",
  T_49_META_TYP_399_I2_D: "How many jumps can be performed before landing",
  T_49_META_TYP_399_I3_D: "Enable Move In Midair",
  T_49_META_TYP_40_I1_D: "Label",
  T_49_META_TYP_40_I10_D: "Line Spacing",
  T_49_META_TYP_40_I11_D: "Overflow method",
  T_49_META_TYP_40_I12_D: "Font Style",
  T_49_META_TYP_40_I13_D: "Is Apply Shadow",
  T_49_META_TYP_40_I14_D: "Shadow Color",
  T_49_META_TYP_40_I15_D: "Shadow Offset",
  T_49_META_TYP_40_I3_D: "Localized Key, can be used in multiple languages",
  T_49_META_TYP_40_I5_D: "Alignment method",
  T_49_META_TYP_40_I6_D: "Alignment Vertical",
  T_49_META_TYP_40_I7_D: "Is Bold",
  T_49_META_TYP_40_I8_D: "Is Italic",
  T_49_META_TYP_40_I9_D: "Is Underline",
  T_49_META_TYP_400_I0_D: "Active",
  T_49_META_TYP_400_I1_D: "Passive",
  T_49_META_TYP_400_I2_D: "No Attack",
  T_49_META_TYP_401_I0_D: "Cannot fire.",
  T_49_META_TYP_401_I1_D: "Can fire continuously",
  T_49_META_TYP_401_I2_D: "Fires once per attack command",
  T_49_META_TYP_401_I3_D: "Three times per attack command.",
  T_49_META_TYP_401_I4_D: "Fires twice per attack command",
  T_49_META_TYP_401_I5_D: "Parry",
  T_49_META_TYP_402_I0_D: "Targets to friend",
  T_49_META_TYP_402_I1_D: "Function Type",
  T_49_META_TYP_402_I2_D: "Style",
  T_49_META_TYP_403_I0_D: "Add Friend",
  T_49_META_TYP_403_I1_D: "Report",
  T_49_META_TYP_404_I0_D: "Light",
  T_49_META_TYP_404_I1_D: "Dark",
  T_49_META_TYP_405_I0_D: "By Hierarchy",
  T_49_META_TYP_405_I1_D: "By Priority High To Low",
  T_49_META_TYP_405_I2_D: "By Priority Low To High",
  T_49_META_TYP_406_I0_D: "Control the distance of player's Animation.",
  T_49_META_TYP_406_I1_D: "Controls the height of the player's body during the move.",
  T_49_META_TYP_407_I0_D: "Local",
  T_49_META_TYP_407_I1_D: "Client",
  T_49_META_TYP_407_I2_D: "Server",
  T_49_META_TYP_407_I3_D: "Both",
  T_49_META_TYP_409_I0_D: "No errors",
  T_49_META_TYP_409_I1_D: "Data storage timeout, mainly for read operations",
  T_49_META_TYP_409_I10_D: "Failed team change - invalid target team",
  T_49_META_TYP_409_I11_D: "Failed team change - Dead player not allowed to change teams",
  T_49_META_TYP_409_I12_D: "Failed team change - not allowed to change team in vehicle",
  T_49_META_TYP_409_I2_D: "Data storage read/write frequency exceeds the limit",
  T_49_META_TYP_409_I3_D: "Parameter exceptions",
  T_49_META_TYP_409_I4_D: "Room creation failed: no valid PersonaIDs available",
  T_49_META_TYP_409_I5_D: "Undefined error status",
  T_49_META_TYP_409_I6_D: "Commercialization service shut down, users can no longer use the developer's service",
  T_49_META_TYP_409_I7_D: "Failed to change team - mode not supported",
  T_49_META_TYP_409_I8_D: "Failed to change team-Currently already in target team",
  T_49_META_TYP_409_I9_D: "Queue change failed-invalid target",
  T_49_META_TYP_41_I0_D: "Sprite Shape",
  T_49_META_TYP_41_I19_D: "Disable collision box",
  T_49_META_TYP_41_I3_D: "Disable Color",
  T_49_META_TYP_41_I4_D: "Pressed Color",
  T_49_META_TYP_41_I5_D: "Fill Type",
  T_49_META_TYP_41_I6_D: "Is FE Button",
  T_49_META_TYP_41_I7_D: "Pressed Sprite",
  T_49_META_TYP_41_I8_D: "Pressed Sprite Type",
  T_49_META_TYP_41_I9_D: "Flip Type",
  T_49_META_TYP_411_I0_D: "Forward Speed",
  T_49_META_TYP_411_I1_D: "Backward Speed",
  T_49_META_TYP_411_I2_D: "Up Speed",
  T_49_META_TYP_411_I3_D: "Down Speed",
  T_49_META_TYP_411_I4_D: "Grenade Min Damage",
  T_49_META_TYP_411_I5_D: "Grenade Max Damage",
  T_49_META_TYP_411_I6_D: "Grenade Range",
  T_49_META_TYP_412_I0_D: "Horsepower gained by the vehicle when using the gas button",
  T_49_META_TYP_412_I1_D: "Horsepower gained by the vehicle when using the reverse/brake button",
  T_49_META_TYP_412_I2_D: "Maximum steering angle at high speed",
  T_49_META_TYP_412_I3_D: "Speed threshold applied to the maximum steering angle at high speeds",
  T_49_META_TYP_412_I4_D: "After reaching the maximum speed, the carrier does not provide any more horsepower, but the carrier may exceed that maximum speed (e.g. through a downhill)",
  T_49_META_TYP_412_I5_D: "When the carrier is not being maneuvered, decelerate the carrier by multiplying IdleBrakeInput by BrakeTorque",
  T_49_META_TYP_412_I6_D: "Damage calculation for crashes, applying the parameters of the damage formula",
  T_49_META_TYP_412_I7_D: "Damage calculation for crashing, damage will not be increased even if the speed is exceeded.",
  T_49_META_TYP_412_I8_D: "Damage calculation for ramming, minimum damage",
  T_49_META_TYP_412_I9_D: "Damage calculation for ramming, maximum damage",
  T_49_META_TYP_413_I0_D: "Player (NPC) transformed costume",
  T_49_META_TYP_414_I1_D: "Wide Range",
  T_49_META_TYP_415_I0_D: "Persona ID",
  T_49_META_TYP_415_I1_D: "Nickname",
  T_49_META_TYP_415_I2_D: "Avatar",
  T_49_META_TYP_416_I1_D: "The Persona to which it is bound.",
  T_49_META_TYP_416_I2_D: "Offset",
  T_49_META_TYP_416_I3_D: "Height",
  T_49_META_TYP_416_I4_D: "Whether to reply to system messages",
  T_49_META_TYP_416_I5_D: "Persona nickname",
  T_49_META_TYP_416_I6_D: "PersonaAvatar",
  T_49_META_TYP_416_I7_D: "Nickname of the user",
  T_49_META_TYP_416_I8_D: "User Avatar",
  T_49_META_TYP_417_I0_D: "Resource ID",
  T_49_META_TYP_418_I0_D: "Membership expiration",
  T_49_META_TYP_418_I1_D: "Become a member",
  T_49_META_TYP_418_I2_D: "Renew membership",
  T_49_META_TYP_42_I0_D: "Default Text",
  T_49_META_TYP_42_I1_D: "Active Text",
  T_49_META_TYP_42_I10_D: "Max Length",
  T_49_META_TYP_42_I14_D: "Pressed Color",
  T_49_META_TYP_42_I16_D: "Localized Key, available in multiple languages",
  T_49_META_TYP_42_I3_D: "Alignment method",
  T_49_META_TYP_42_I4_D: "Alignment Vertical",
  T_49_META_TYP_42_I5_D: "Is Bold",
  T_49_META_TYP_42_I6_D: "Is Italic",
  T_49_META_TYP_42_I7_D: "Is Underline",
  T_49_META_TYP_42_I8_D: "Line Spacing",
  T_49_META_TYP_42_I9_D: "Word Wrap",
  T_49_META_TYP_424_I0_D: "Linear Fog",
  T_49_META_TYP_424_I1_D: "Exponential Fog",
  T_49_META_TYP_424_I2_D: "Exponential Square Fog",
  T_49_META_TYP_426_I0_D: "Intensity",
  T_49_META_TYP_426_I1_D: "Range",
  T_49_META_TYP_426_I2_D: "The angle of the cone in degrees.",
  T_49_META_TYP_426_I3_D: "Light color",
  T_49_META_TYP_428_I0_D: "Weapon Skin IDs",
  T_49_META_TYP_428_I2_D: "Suit ID",
  T_49_META_TYP_428_I3_D: "Headwear ID",
  T_49_META_TYP_428_I4_D: "Face ID",
  T_49_META_TYP_428_I5_D: "Makeup ID",
  T_49_META_TYP_428_I6_D: "Upper Body ID",
  T_49_META_TYP_428_I7_D: "Bottom ID",
  T_49_META_TYP_428_I8_D: "Shoe ID",
  T_49_META_TYP_431_I1_D: "The trajectory of the target entity",
  T_49_META_TYP_431_I3_D: "Movement speed, unit m/s",
  T_49_META_TYP_431_I4_D: `Whether the movement is toward the tangent line of the path or not 
Default is False, the movement of the object will not change the direction 
 If True, the movement of the object will face the path forward direction`,
  T_49_META_TYP_431_I5_D: "Played Percentage",
  T_49_META_TYP_432_I0_D: "Rollover angle, affects the radial rotation of the path from both sides of this point",
  T_49_META_TYP_432_I1_D: "The relative position of the tangent control point to the waypoint, which determines the path tangent.",
  T_49_META_TYP_433_I0_D: "Tween straight lines between path points",
  T_49_META_TYP_433_I1_D: "Tween curves between path points for smooth motion.",
  T_49_META_TYP_433_I2_D: "Supports manual adjustment of tangents to curve points",
  T_49_META_TYP_434_I0_D: "Path type",
  T_49_META_TYP_434_I1_D: "Total length of the path",
  T_49_META_TYP_434_I2_D: "Whether the path begins and ends at the same time",
  T_49_META_TYP_434_I3_D: "Collection of waypoints",
  T_49_META_TYP_437_I3_D: "Left Players",
  T_49_META_TYP_437_I4_D: "Right Players",
  T_49_META_TYP_437_I5_D: "Array of points type names",
  T_49_META_TYP_437_I6_D: "Left points array (List 1D: player; List 2D: points data filled according to customized points type)",
  T_49_META_TYP_437_I7_D: "Array of points on the right (List 1D: players; List 2D: points data filled in according to customized points types)",
  T_49_META_TYP_438_I1_D: "Grouped players array",
  T_49_META_TYP_438_I2_D: "Grouped Ranking Array",
  T_49_META_TYP_438_I3_D: "Array of grouped scores",
  T_49_META_TYP_438_I4_D: "Array of point type names",
  T_49_META_TYP_438_I5_D: "Grouped colors array",
  T_49_META_TYP_438_I6_D: "Array of players' points (corresponding to their order when not grouped)",
  T_49_META_TYP_442_I1_D: "Left Score",
  T_49_META_TYP_442_I10_D: "Right death icon",
  T_49_META_TYP_442_I2_D: "Right Score",
  T_49_META_TYP_442_I3_D: "Number of survivors on the left",
  T_49_META_TYP_442_I4_D: "Survivors on the right",
  T_49_META_TYP_442_I5_D: "Left Dead",
  T_49_META_TYP_442_I6_D: "Right Deaths",
  T_49_META_TYP_442_I7_D: "Left survivor icon",
  T_49_META_TYP_442_I8_D: "Right Survival Icon",
  T_49_META_TYP_442_I9_D: "Left Dead Icon",
  T_49_META_TYP_444_I0_D: "English",
  T_49_META_TYP_444_I1_D: "Simplified Chinese",
  T_49_META_TYP_444_I10_D: "French",
  T_49_META_TYP_444_I11_D: "German",
  T_49_META_TYP_444_I12_D: "Turkish",
  T_49_META_TYP_444_I13_D: "Hindi",
  T_49_META_TYP_444_I14_D: "Japanese",
  T_49_META_TYP_444_I15_D: "Romanian",
  T_49_META_TYP_444_I16_D: "Romanian",
  T_49_META_TYP_444_I17_D: "Burmese",
  T_49_META_TYP_444_I18_D: "Urdu",
  T_49_META_TYP_444_I19_D: "Bengali",
  T_49_META_TYP_444_I2_D: "Traditional Chinese",
  T_49_META_TYP_444_I3_D: "Thai",
  T_49_META_TYP_444_I4_D: "Vietnamese",
  T_49_META_TYP_444_I5_D: "Indonesian",
  T_49_META_TYP_444_I6_D: "Chinese (Simplified)",
  T_49_META_TYP_444_I7_D: "Spanish",
  T_49_META_TYP_444_I8_D: "Russian",
  T_49_META_TYP_444_I9_D: "Korean",
  T_49_META_TYP_51_I0_D: "Normal Zombie",
  T_49_META_TYP_51_I1_D: "Axe Zombie",
  T_49_META_TYP_51_I10_D: "Fly Bomb Bee",
  T_49_META_TYP_51_I11_D: "Zombie Dragon",
  T_49_META_TYP_51_I2_D: "Tossing Zombie",
  T_49_META_TYP_51_I3_D: "Self-Explode Zombie",
  T_49_META_TYP_51_I4_D: "Tyrant Zombie",
  T_49_META_TYP_51_I5_D: "Throw Red Zombie",
  T_49_META_TYP_51_I6_D: "MrV",
  T_49_META_TYP_51_I7_D: "Tank Zombie",
  T_49_META_TYP_51_I8_D: "Drill Zombie",
  T_49_META_TYP_51_I9_D: "Samurai",
  T_49_META_TYP_56_I10_D: "Explosion Delay",
  T_49_META_TYP_56_I11_D: "Explosion Range",
  T_49_META_TYP_56_I12_D: "Explosion Damage",
  T_49_META_TYP_56_I13_D: "Burning Time",
  T_49_META_TYP_56_I14_D: "Burning Damage",
  T_49_META_TYP_56_I15_D: "Burning Damage Interval",
  T_49_META_TYP_56_I17_D: "Vehicle Pilot",
  T_49_META_TYP_56_I18_D: "All passengers on the vehicle",
  T_49_META_TYP_56_I19_D: "Vehicle Skin ID",
  T_49_META_TYP_56_I20_D: "Prioritize Player Configuration",
  T_49_META_TYP_56_I21_D: "Max. HP",
  T_49_META_TYP_56_I22_D: "HP",
  T_49_META_TYP_57_I0_D: "Whether to teleport manually or automatically (default is manual)",
  T_49_META_TYP_58_I0_D: "Type of buff generated",
  T_49_META_TYP_58_I1_D: "The time in seconds from when the buff is picked up to when the next buff is generated.",
  T_49_META_TYP_59_I0_D: "Motion Type",
  T_49_META_TYP_59_I1_D: "Motion Value X",
  T_49_META_TYP_59_I2_D: "Motion Value Y",
  T_49_META_TYP_59_I3_D: "Motion Value Z",
  T_49_META_TYP_59_I4_D: "Movement Duration",
  T_49_META_TYP_59_I5_D: "Stop Duration",
  T_49_META_TYP_59_I6_D: "Disable Reciprocating",
  T_49_META_TYP_60_I0_D: "Loot weapon points",
  T_49_META_TYP_61_I0_D: "Bound Store",
  T_49_META_TYP_61_I1_D: "Setting the trigger range",
  T_49_META_TYP_61_I2_D: "Model Visibility",
  T_49_META_TYP_62_I0_D: "Velocity XZ",
  T_49_META_TYP_62_I1_D: "Velocity Y",
  T_49_META_TYP_64_I0_D: "Music component type",
  T_49_META_TYP_66_I0_D: "InstanceID",
  T_49_META_TYP_66_I1_D: "Path Point",
  T_49_META_TYP_68_I0_D: "AI's current blood level",
  T_49_META_TYP_68_I1_D: "AI's current maximum blood level",
  T_49_META_TYP_68_I10_D: "Whether the AI drops equipment or items when it dies.",
  T_49_META_TYP_68_I11_D: "Whether the AI is currently invincible",
  T_49_META_TYP_68_I12_D: "Percentage of damage dealt to the AI when it takes damage, can be reduced or increased",
  T_49_META_TYP_68_I13_D: "Type of AI",
  T_49_META_TYP_68_I14_D: "Whether to automatically search for enemies",
  T_49_META_TYP_68_I15_D: "0 is auto attack, 1 is defense attack, 2 is no attack at all.",
  T_49_META_TYP_68_I16_D: "Path ID",
  T_49_META_TYP_68_I17_D: "Chase Target",
  T_49_META_TYP_68_I18_D: "Attack Target",
  T_49_META_TYP_68_I19_D: "AI's birth point coordinates",
  T_49_META_TYP_68_I2_D: "Get the entity of the AI's team.",
  T_49_META_TYP_68_I20_D: "The team's camp number",
  T_49_META_TYP_68_I4_D: "Can only modify the attack power of normal attacks, skill attacks don't count.",
  T_49_META_TYP_68_I7_D: "AI's free movement range, can only modify the base value, if there is extra bonus, it will be added on top of that value.",
  T_49_META_TYP_68_I8_D: "AI's range to detect enemies, can only modify the base value, if there is an extra bonus, it will be added on top of that value.",
  T_49_META_TYP_68_I9_D: "True movement speed, if there is a skill acceleration it will be multiplied by it.",
  T_49_META_TYP_70_I0_D: "ID of the target entity that the formula works on, used by internal implementations, invisible to the player.",
  T_49_META_TYP_70_I1_D: "ID of the target entity property on which the formula works, used by internal implementations, not visible to the player",
  T_49_META_TYP_70_I2_D: "Minimum value allowed",
  T_49_META_TYP_70_I3_D: "Maximum value allowed",
  T_49_META_TYP_70_I4_D: "Base Coefficient",
  T_49_META_TYP_70_I5_D: "Pre-Accumulator",
  T_49_META_TYP_70_I6_D: "Multiplier",
  T_49_META_TYP_70_I7_D: "Multiply Accumulate",
  T_49_META_TYP_70_I8_D: "Post-Accumulator",
  T_49_META_TYP_71_I0_D: "Shop item number",
  T_49_META_TYP_71_I1_D: "Price",
  T_49_META_TYP_71_I10_D: "Is Purchasable",
  T_49_META_TYP_71_I2_D: "Money Type",
  T_49_META_TYP_71_I3_D: "Overall limit",
  T_49_META_TYP_71_I4_D: "Current overall limit",
  T_49_META_TYP_71_I5_D: "Shop item name",
  T_49_META_TYP_71_I6_D: "Shop Item Description",
  T_49_META_TYP_71_I7_D: "Shop Item List",
  T_49_META_TYP_71_I8_D: "ItemCounts",
  T_49_META_TYP_71_I9_D: "Resource path, empty by default",
  T_49_META_TYP_72_I1_D: "Shop Items",
  T_49_META_TYP_73_I1_D: "Shelfs",
  T_49_META_TYP_74_I0_D: "Weapon",
  T_49_META_TYP_74_I1_D: "Helmet",
  T_49_META_TYP_74_I2_D: "Vest",
  T_49_META_TYP_74_I3_D: "Grenade",
  T_49_META_TYP_75_I0_D: "One Way",
  T_49_META_TYP_75_I1_D: "Back And Forth",
  T_49_META_TYP_76_I0_D: "Patrols only, no attacks on targets along the way",
  T_49_META_TYP_76_I1_D: "Patrol While Attack",
  T_49_META_TYP_79_I0_D: "Weapon Attack Power",
  T_49_META_TYP_79_I1_D: "Attack Range",
  T_49_META_TYP_79_I10_D: "Bullet Spread Start Count",
  T_49_META_TYP_79_I11_D: "Weapon ID",
  T_49_META_TYP_79_I12_D: "Minimum wait time in seconds between shots, multiple bullets may be fired per shot depending on shot type",
  T_49_META_TYP_79_I13_D: "The player who owns the weapon",
  T_49_META_TYP_79_I14_D: "Is Consume Ammo",
  T_49_META_TYP_79_I15_D: "Dual wielding type (0 not dual wielding 1 and self 2 and any weapon)",
  T_49_META_TYP_79_I16_D: "Armor damage factor",
  T_49_META_TYP_79_I17_D: "Player movement speed effects",
  T_49_META_TYP_79_I18_D: "Damage percentage for hitting the torso",
  T_49_META_TYP_79_I19_D: "Percentage of damage that hits the head",
  T_49_META_TYP_79_I2_D: "The length of time to wait between bullets, in seconds.",
  T_49_META_TYP_79_I20_D: "Damage percentage for hitting limbs",
  T_49_META_TYP_79_I21_D: "Extra Damage Ratio (Vehicle, Oil Drum, Ice Wall)",
  T_49_META_TYP_79_I22_D: "Visible On Back",
  T_49_META_TYP_79_I23_D: "Extra damage for hitting the ground",
  T_49_META_TYP_79_I24_D: "Ammo per Shot",
  T_49_META_TYP_79_I25_D: "Bullet change speed (base speed * factor)",
  T_49_META_TYP_79_I26_D: "Current Ammo Count",
  T_49_META_TYP_79_I27_D: "Gunskin ID",
  T_49_META_TYP_79_I28_D: "When player configuration is prioritized, the gun skin configuration on the player overrides the gun skin property of the weapon itself",
  T_49_META_TYP_79_I29_D: "When writing in the gun skin's properties for a weapon, the weapon's base value is affected by the gun skin",
  T_49_META_TYP_79_I3_D: "Ammo Mag Size",
  T_49_META_TYP_79_I30_D: "Diffusion Increase Speed (0.1 = 10% expansion for each additional burst of collision)",
  T_49_META_TYP_79_I31_D: "Diffusion recovery speed",
  T_49_META_TYP_79_I32_D: "Player speed effect when firing",
  T_49_META_TYP_79_I33_D: "Diffusion size in case of movement (1.5 = 1.5 * basic collimator size)",
  T_49_META_TYP_79_I34_D: "Weapon Type",
  T_49_META_TYP_79_I36_D: "Fire Type",
  T_49_META_TYP_79_I37_D: "Is Single Shot",
  T_49_META_TYP_79_I38_D: "Is Silenced",
  T_49_META_TYP_79_I39_D: "ADS Sensitivity Multiplier",
  T_49_META_TYP_79_I4_D: "Initial Mag Count",
  T_49_META_TYP_79_I5_D: "Armor Penetration",
  T_49_META_TYP_79_I6_D: "Full Damage Distance",
  T_49_META_TYP_79_I7_D: "Min. Damage Distance",
  T_49_META_TYP_79_I8_D: "Min. Damage",
  T_49_META_TYP_79_I9_D: "The number of bullets that can be fired before the scattering begins",
  T_49_META_TYP_80_I1_D: "When true, manual disable is disabled.",
  T_49_META_TYP_80_I2_D: "Bound shop entities",
  T_49_META_TYP_80_I4_D: "Bound Money List",
  T_49_META_TYP_80_I5_D: "Bound Wallet ID",
  T_49_META_TYP_80_I6_D: "The type of the current UI player request target",
  T_49_META_TYP_80_I7_D: "Requested Item List",
  T_49_META_TYP_81_I0_D: "Random Buff",
  T_49_META_TYP_81_I1_D: "HP Buff",
  T_49_META_TYP_81_I2_D: "Bullet Buff",
  T_49_META_TYP_81_I3_D: "Armor Buff",
  T_49_META_TYP_82_I1_D: "Button icon",
  T_49_META_TYP_82_I3_D: "Position relative to the anchor point",
  T_49_META_TYP_83_I1_D: "TriggerPlayerID",
  T_49_META_TYP_83_I2_D: "Passed parameters",
  T_49_META_TYP_86_I0_D: "Min",
  T_49_META_TYP_86_I1_D: "Max",
  T_49_META_TYP_86_I2_D: "Base coefficient, multiplied by the original value before all calculations are performed.",
  T_49_META_TYP_86_I3_D: "Pre-accumulator, accumulates before multiplication, participates in multiplication calculations",
  T_49_META_TYP_86_I4_D: "Consecutive multipliers, for example (reduced to 90%, strengthened to 110%) have the effect of Value*90%*110%.",
  T_49_META_TYP_86_I5_D: "The effect of a multiplication accumulator, e.g. (add 10%, add 5%) is Value*(1+10%+5%)",
  T_49_META_TYP_86_I6_D: "Post accumulator, not involved in multiplication calculations, stacked at the end",
  T_49_META_TYP_88_I0_D: "Base type, the most basic in-game currency, the type of pricing for general shop items in the current version",
  T_49_META_TYP_89_I0_D: "Only base currency is available in the current version",
  T_49_META_TYP_89_I1_D: "Amount of currency",
  T_49_META_TYP_89_I2_D: "Currency icon",
  T_49_META_TYP_89_I3_D: "Currency icon color",
  T_49_META_TYP_90_I0_D: "The contents of the wallet are a bunch of currencies",
  T_49_META_TYP_92_I0_D: "Square Wooden Crate",
  T_49_META_TYP_92_I1_D: "Long Wooden Crate",
  T_49_META_TYP_92_I10_D: "Turret",
  T_49_META_TYP_92_I100_D: "Stairs",
  T_49_META_TYP_92_I101_D: "Stair Landing B",
  T_49_META_TYP_92_I102_D: "Stair Landing A",
  T_49_META_TYP_92_I103_D: "Phone Booth",
  T_49_META_TYP_92_I104_D: "BIS Themed Wall",
  T_49_META_TYP_92_I105_D: "BIS Themed Flower Bed",
  T_49_META_TYP_92_I106_D: "Vending Machine",
  T_49_META_TYP_92_I107_D: "Monster Entities",
  T_49_META_TYP_92_I108_D: "Unit Generator",
  T_49_META_TYP_92_I109_D: "Sports Car",
  T_49_META_TYP_92_I11_D: "Guardhouse",
  T_49_META_TYP_92_I110_D: "Tuk Tuk",
  T_49_META_TYP_92_I111_D: "Destructible Wooden Crate",
  T_49_META_TYP_92_I112_D: "SUV",
  T_49_META_TYP_92_I113_D: "Motorbike",
  T_49_META_TYP_92_I114_D: "Monster Truck",
  T_49_META_TYP_92_I115_D: "Coin Generator",
  T_49_META_TYP_92_I116_D: "Stair Landing C",
  T_49_META_TYP_92_I117_D: "Sign",
  T_49_META_TYP_92_I118_D: "Fence",
  T_49_META_TYP_92_I119_D: "Jersey Machine",
  T_49_META_TYP_92_I12_D: "Two-Story House",
  T_49_META_TYP_92_I121_D: "Concrete Pillar",
  T_49_META_TYP_92_I122_D: "Loot Soccer Item Box",
  T_49_META_TYP_92_I123_D: "Oil Drum",
  T_49_META_TYP_92_I124_D: "Low-Gravity Area",
  T_49_META_TYP_92_I125_D: "Weapon",
  T_49_META_TYP_92_I126_D: "Fence B",
  T_49_META_TYP_92_I127_D: "Small House A",
  T_49_META_TYP_92_I128_D: "Damaged Truck",
  T_49_META_TYP_92_I129_D: "Basic Sphere",
  T_49_META_TYP_92_I13_D: "Sand Sculpture",
  T_49_META_TYP_92_I130_D: "Basic Cone",
  T_49_META_TYP_92_I131_D: "Basic Cylinder",
  T_49_META_TYP_92_I132_D: "Consumable Generator",
  T_49_META_TYP_92_I133_D: "Custom Water Body",
  T_49_META_TYP_92_I134_D: "Arrow",
  T_49_META_TYP_92_I135_D: "Dyed Block",
  T_49_META_TYP_92_I136_D: "Dyed Oil Drum",
  T_49_META_TYP_92_I137_D: "Text",
  T_49_META_TYP_92_I138_D: "Icon",
  T_49_META_TYP_92_I139_D: "Ice Doll",
  T_49_META_TYP_92_I14_D: "Fountain",
  T_49_META_TYP_92_I140_D: "Capsule Trigger",
  T_49_META_TYP_92_I141_D: "Sphere Collision Trigger",
  T_49_META_TYP_92_I142_D: "Reflective Solid Color Basic Block 1",
  T_49_META_TYP_92_I143_D: "Bumper Car Manufacturer",
  T_49_META_TYP_92_I144_D: "Checkered Amusement Park Block",
  T_49_META_TYP_92_I145_D: "Large Screen",
  T_49_META_TYP_92_I146_D: "Podium",
  T_49_META_TYP_92_I147_D: "Giant Lollipop",
  T_49_META_TYP_92_I148_D: "Food Truck B",
  T_49_META_TYP_92_I15_D: "Cherry Blossom",
  T_49_META_TYP_92_I16_D: "One-Story House",
  T_49_META_TYP_92_I17_D: "Three-Story House",
  T_49_META_TYP_92_I18_D: "Banana Tree",
  T_49_META_TYP_92_I19_D: "Toilet",
  T_49_META_TYP_92_I2_D: "Bush-Covered Long Wooden Crate",
  T_49_META_TYP_92_I20_D: "Fence",
  T_49_META_TYP_92_I21_D: "Destructible Container",
  T_49_META_TYP_92_I22_D: "Destructible Fence",
  T_49_META_TYP_92_I23_D: "Tire",
  T_49_META_TYP_92_I24_D: "Bumper Car",
  T_49_META_TYP_92_I25_D: "Amphibious Vehicle",
  T_49_META_TYP_92_I26_D: "Jeep",
  T_49_META_TYP_92_I27_D: "Trash Can",
  T_49_META_TYP_92_I28_D: "Medical Tent",
  T_49_META_TYP_92_I29_D: "Garage",
  T_49_META_TYP_92_I3_D: "Haystack",
  T_49_META_TYP_92_I30_D: "Painted Wall",
  T_49_META_TYP_92_I31_D: "Torii",
  T_49_META_TYP_92_I32_D: "Iron Platform",
  T_49_META_TYP_92_I33_D: "Container House",
  T_49_META_TYP_92_I34_D: "Trailer",
  T_49_META_TYP_92_I35_D: "Wall A",
  T_49_META_TYP_92_I36_D: "Musical Notes - Piano",
  T_49_META_TYP_92_I37_D: "Musical Notes - Piano",
  T_49_META_TYP_92_I38_D: "Musical Notes - Drum",
  T_49_META_TYP_92_I39_D: "Musical Notes - Drum",
  T_49_META_TYP_92_I4_D: "Wrecked Car",
  T_49_META_TYP_92_I40_D: "Musical Notes - Synthesizer A",
  T_49_META_TYP_92_I41_D: "Musical Notes - Synthesizer A",
  T_49_META_TYP_92_I42_D: "Musical Notes - Synthesizer B",
  T_49_META_TYP_92_I43_D: "Musical Notes - Synthesizer B",
  T_49_META_TYP_92_I44_D: "Musical Notes - Synthesizer C",
  T_49_META_TYP_92_I45_D: "Musical Notes - Synthesizer C",
  T_49_META_TYP_92_I46_D: "Buff Generator",
  T_49_META_TYP_92_I47_D: "Propeller Mechanisms",
  T_49_META_TYP_92_I48_D: "Pan Loot",
  T_49_META_TYP_92_I49_D: "Cube Loot",
  T_49_META_TYP_92_I5_D: "Wrecked Bus",
  T_49_META_TYP_92_I50_D: "Circle Loot",
  T_49_META_TYP_92_I51_D: "Mallet Machine",
  T_49_META_TYP_92_I52_D: "Moving Board",
  T_49_META_TYP_92_I53_D: "Moving Target",
  T_49_META_TYP_92_I54_D: "Retractable Wall",
  T_49_META_TYP_92_I55_D: "Loot Point Weapon Component",
  T_49_META_TYP_92_I56_D: "Loot Point Bullet Component",
  T_49_META_TYP_92_I57_D: "Loot Point Expendable Item Component",
  T_49_META_TYP_92_I58_D: "Loot Point Thrown Item Component",
  T_49_META_TYP_92_I59_D: "Loot Point Multiplier Component",
  T_49_META_TYP_92_I6_D: "Container A",
  T_49_META_TYP_92_I60_D: "Loot Point Armor Component",
  T_49_META_TYP_92_I61_D: "I Pipe",
  T_49_META_TYP_92_I62_D: "T Pipe",
  T_49_META_TYP_92_I63_D: "Cross Pipe",
  T_49_META_TYP_92_I64_D: "Elbow Pipe",
  T_49_META_TYP_92_I65_D: "Giant Mushroom Cluster",
  T_49_META_TYP_92_I66_D: "Drying Rack",
  T_49_META_TYP_92_I67_D: "Plank Bridge",
  T_49_META_TYP_92_I68_D: "Lattice Screen",
  T_49_META_TYP_92_I69_D: "Concrete Column",
  T_49_META_TYP_92_I7_D: "Shipping Container B",
  T_49_META_TYP_92_I70_D: "Cactus",
  T_49_META_TYP_92_I71_D: "Dead Wood",
  T_49_META_TYP_92_I72_D: "Stone Lantern",
  T_49_META_TYP_92_I73_D: "Streetlight",
  T_49_META_TYP_92_I74_D: "Solar Panel",
  T_49_META_TYP_92_I75_D: "Air Conditioner",
  T_49_META_TYP_92_I76_D: "Square",
  T_49_META_TYP_92_I77_D: "Slope",
  T_49_META_TYP_92_I78_D: "Food Truck",
  T_49_META_TYP_92_I79_D: "Death or Invincibility Trigger",
  T_49_META_TYP_92_I8_D: "Shipping Container C",
  T_49_META_TYP_92_I80_D: "Checkpoint",
  T_49_META_TYP_92_I81_D: "End Position",
  T_49_META_TYP_92_I82_D: "Dice",
  T_49_META_TYP_92_I83_D: "Bench",
  T_49_META_TYP_92_I84_D: "Bus Stop",
  T_49_META_TYP_92_I85_D: "Dog House",
  T_49_META_TYP_92_I86_D: "Ad Board",
  T_49_META_TYP_92_I87_D: "Refinery Tank",
  T_49_META_TYP_92_I88_D: "Graffiti Wall",
  T_49_META_TYP_92_I89_D: "Stable",
  T_49_META_TYP_92_I9_D: "Cabin",
  T_49_META_TYP_92_I90_D: "Stone Arch Bridge",
  T_49_META_TYP_92_I91_D: "Patio Set With Umbrella",
  T_49_META_TYP_92_I92_D: "Finish Banner",
  T_49_META_TYP_92_I93_D: "Fortress",
  T_49_META_TYP_92_I94_D: "Monster Spawn Point",
  T_49_META_TYP_92_I95_D: "Mark",
  T_49_META_TYP_92_I97_D: "Custom Trigger",
  T_49_META_TYP_92_I98_D: "Double Door",
  T_49_META_TYP_92_I99_D: "Barricade",
  T_49_META_TYP_94_I0_D: "Add",
  T_49_META_TYP_94_I1_D: "Multiply",
  T_49_META_TYP_95_I0_D: "Money Type",
  T_49_META_TYP_95_I1_D: "Amount of currency",
  T_49_META_TYP_96_I0_D: "Get Wallet",
  T_49_META_TYP_96_I1_D: "Display position (anchor is top right corner)",
  T_49_META_TYP_97_I0_D: "Position in the world coordinate system",
  T_49_META_TYP_97_I1_D: "Rotation angle in the world coordinate system, XYZ components are pitch, yaw, and roll, respectively, and rotation order YXZ.",
  T_49_META_TYP_97_I10_D: "Local coordinate axis x-axis orientation",
  T_49_META_TYP_97_I11_D: "Local axis z-axis orientation",
  T_49_META_TYP_97_I2_D: "Zoom size in the world coordinate system",
  T_49_META_TYP_97_I3_D: "Parent node of this node",
  T_49_META_TYP_97_I4_D: "Rotation in the world coordinate system, expressed in quaternions",
  T_49_META_TYP_97_I5_D: "Position in local coordinate system",
  T_49_META_TYP_97_I6_D: "Rotation in the local coordinate system, expressed in quaternions",
  T_49_META_TYP_97_I7_D: "Rotation angle in the local coordinate system, with XYZ components for pitch, yaw, and roll, respectively, and rotation order YXZ.",
  T_49_META_TYP_97_I8_D: "Scaling dimension in the local coordinate system",
  T_49_META_TYP_97_I9_D: "Local coordinate axis y-axis orientation",
  T_49_META_TYP_99_I0_D: "Radius of the soccer ball",
  T_49_META_TYP_99_I1_D: "Friction coefficient at normal condition",
  T_49_META_TYP_99_I2_D: "Impact Friction",
  T_49_META_TYP_99_I3_D: "Min. Shooting Angle",
  T_49_META_TYP_99_I4_D: "Min. Elevation Angle",
  T_49_META_TYP_99_I5_D: "Reset Time",
  T_49_META_TYP_99_I6_D: "Max. Shooting Angle",
  T_49_META_TYP_99_I7_D: "Reset Position",
  T_49_META_TYPE_0_D: "Object, the root of the type hierarchy",
  T_49_META_TYPE_1_D: "A container for a set of data in a list",
  T_49_META_TYPE_10_D: "Entity base component, all components will combine this component",
  T_49_META_TYPE_100_D: "JerseyMachine",
  T_49_META_TYPE_101_D: "Morph Object",
  T_49_META_TYPE_1010_D: "Timer Info",
  T_49_META_TYPE_1011_D: "Opening Banner",
  T_49_META_TYPE_1012_D: "Banner entities start in two-team rounds, and modifying entity properties affects the display on the corresponding UI.",
  T_49_META_TYPE_1013_D: "General round start banner entity, modifying entity properties affects display content on corresponding UIs",
  T_49_META_TYPE_1014_D: "Team round score banner entity, modifying entity properties affects the display on the corresponding UI.",
  T_49_META_TYPE_1015_D: "Checkpoint Manager entity, modifying the entity properties will affect the display on the corresponding UI.",
  T_49_META_TYPE_1016_D: "End of round display entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1017_D: "If there are two teams at the start of the round, display the two teams' rivalry banner",
  T_49_META_TYPE_1018_D: "Score of the round between the two teams",
  T_49_META_TYPE_1019_D: "The final result is a tie",
  T_49_META_TYPE_102_D: "Resurrection source type: death, fall down",
  T_49_META_TYPE_1020_D: "Round count entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1021_D: "Phase countdown entity, modifying the entity's properties will affect the content displayed on the corresponding UI.",
  T_49_META_TYPE_1022_D: "Match information subheading entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1023_D: "Two teams match information entity, modify the entity property to affect the display content on the corresponding UI.",
  T_49_META_TYPE_1024_D: "Team match information UI entity, modify the entity property to affect the display content on the corresponding UI",
  T_49_META_TYPE_1027_D: "Describes the type of the type and returns that type when Typeof is used",
  T_49_META_TYPE_1028_D: "Camp information entity, modify the entity properties to affect the display content of the corresponding UI.",
  T_49_META_TYPE_1029_D: "The icon hint information entity, modifying the entity's properties will affect the content displayed on the corresponding UI.",
  T_49_META_TYPE_103_D: "Enumeration of item slots",
  T_49_META_TYPE_1030_D: "Short version of the two teams' match information entity, modifying the entity's properties will affect the content displayed on the corresponding UI.",
  T_49_META_TYPE_1031_D: "Timing prompt UI entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1032_D: "Floating word prompt entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1033_D: "Round switching entity, including current round settlement and next round start information, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1035_D: "Open scoreboard button UI entity, modifying entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_1036_D: "Infected mode, display the UI of current zombie level.",
  T_49_META_TYPE_1037_D: "Add points animation UI entity, modify the entity property to affect the display content on the corresponding UI.",
  T_49_META_TYPE_1038_D: "Infected mode zombie UI effects",
  T_49_META_TYPE_1039_D: "Countdown prompt entity, modifying the entity properties will affect the content displayed on the corresponding UI.",
  T_49_META_TYPE_104_D: "Jersey Style",
  T_49_META_TYPE_1040_D: "UI Card Selection Panel",
  T_49_META_TYPE_1041_D: "UI Identity Notification",
  T_49_META_TYPE_1042_D: "UI Countdown 5s",
  T_49_META_TYPE_1043_D: "UI Title Banner",
  T_49_META_TYPE_1044_D: "UI Built-In Switch",
  T_49_META_TYPE_1045_D: "UI Skill Button",
  T_49_META_TYPE_105_D: "Football Goal",
  T_49_META_TYPE_106_D: "Aiming aid type",
  T_49_META_TYPE_107_D: "Entities that can be targeted and hit, but not necessarily harmed",
  T_49_META_TYPE_108_D: "Integer types, 64-bit signed integers",
  T_49_META_TYPE_109_D: "The chat channel entity is a container that contains its channel ID and players.",
  T_49_META_TYPE_11_D: "Global entity, unique for the entire game",
  T_49_META_TYPE_110_D: "Idle chat channel",
  T_49_META_TYPE_111_D: "Behavior types",
  T_49_META_TYPE_112_D: "Player Behavior Status Type",
  T_49_META_TYPE_113_D: "Drum Music",
  T_49_META_TYPE_114_D: "Lead1 Music",
  T_49_META_TYPE_115_D: "Lead2 Music",
  T_49_META_TYPE_116_D: "Lead3 Music",
  T_49_META_TYPE_117_D: "Drumbeat music component type",
  T_49_META_TYPE_118_D: "Faction",
  T_49_META_TYPE_119_D: "Attackable options",
  T_49_META_TYPE_12_D: "Combat entities, can attack, take hits, kill, etc.",
  T_49_META_TYPE_120_D: "UI Progress Bar",
  T_49_META_TYPE_121_D: "Interval between waves",
  T_49_META_TYPE_122_D: "Skybox",
  T_49_META_TYPE_123_D: "Enumeration of skybox base types",
  T_49_META_TYPE_124_D: "Claim Range",
  T_49_META_TYPE_125_D: "Can modify the base appearance of objects, such as mapping and transparency",
  T_49_META_TYPE_126_D: "Health Bar",
  T_49_META_TYPE_127_D: "How to move objects",
  T_49_META_TYPE_128_D: "Morphable Object",
  T_49_META_TYPE_129_D: "Loot Ammo Type",
  T_49_META_TYPE_13_D: "UI Widget Entity",
  T_49_META_TYPE_130_D: "Loot Consumable Type",
  T_49_META_TYPE_131_D: "Loot Armor Type",
  T_49_META_TYPE_132_D: "Loot Throwable Type",
  T_49_META_TYPE_133_D: "Loot Scope Type",
  T_49_META_TYPE_134_D: "Loot Weapon Type",
  T_49_META_TYPE_135_D: "Generates ammo drops of the selected type",
  T_49_META_TYPE_136_D: "Generates a consumable drop of the selected type.",
  T_49_META_TYPE_137_D: "Generates a selected type of projectile drop",
  T_49_META_TYPE_138_D: "Spawns a scope drop of the selected type",
  T_49_META_TYPE_139_D: "Generates the selected type of armor drop.",
  T_49_META_TYPE_14_D: "In-game player entities, one per user",
  T_49_META_TYPE_140_D: "Wave",
  T_49_META_TYPE_141_D: "Loot Soccer Type",
  T_49_META_TYPE_142_D: "Loot Soccer Item Box",
  T_49_META_TYPE_143_D: "Lead1 music component type",
  T_49_META_TYPE_144_D: "Lead2 Music Component Type",
  T_49_META_TYPE_145_D: "Lead3 Music Component Type",
  T_49_META_TYPE_146_D: "Key Music Component Type",
  T_49_META_TYPE_147_D: "Multiple preset camera types available, as well as custom camera types",
  T_49_META_TYPE_148_D: "Camera components",
  T_49_META_TYPE_149_D: "Localization Key",
  T_49_META_TYPE_15_D: "In-game team entities, one per team",
  T_49_META_TYPE_150_D: "Oil Drum",
  T_49_META_TYPE_151_D: "Quaternion is a special four-dimensional vector used only to represent rotations",
  T_49_META_TYPE_152_D: "Low-Gravity Area",
  T_49_META_TYPE_153_D: "Entity containers that generate entities of the corresponding type at the location.",
  T_49_META_TYPE_154_D: "Dual-Wield Weapon Type",
  T_49_META_TYPE_155_D: "Helmet entity",
  T_49_META_TYPE_156_D: "Body armor",
  T_49_META_TYPE_157_D: "Camera Transition Type",
  T_49_META_TYPE_158_D: "Text prompt UI",
  T_49_META_TYPE_159_D: "Vector2",
  T_49_META_TYPE_16_D: "Level object entities",
  T_49_META_TYPE_160_D: "Texture Types",
  T_49_META_TYPE_161_D: "Un Replaceable Texture VFX",
  T_49_META_TYPE_162_D: "Type List",
  T_49_META_TYPE_163_D: "Type or Type List",
  T_49_META_TYPE_164_D: "Component is the base class of all entity components or specific component classes.",
  T_49_META_TYPE_165_D: "Collision box component",
  T_49_META_TYPE_166_D: "Emote",
  T_49_META_TYPE_167_D: "Special effect entity represents a displayed special effect (deleted, reusable).",
  T_49_META_TYPE_17_D: "Level Object List",
  T_49_META_TYPE_170_D: "Indicates whether visibility can be set",
  T_49_META_TYPE_171_D: "Mushroom",
  T_49_META_TYPE_172_D: "Ammo",
  T_49_META_TYPE_173_D: "Backpack",
  T_49_META_TYPE_174_D: "Grenade component",
  T_49_META_TYPE_175_D: "Freezing Grenade",
  T_49_META_TYPE_176_D: "Weapon Generator",
  T_49_META_TYPE_177_D: "Motion mode of the camera when there is an obstruction between the camera and the object it is following",
  T_49_META_TYPE_178_D: "Camera's imaging style when rendering a screen",
  T_49_META_TYPE_179_D: "Basic Sphere",
  T_49_META_TYPE_18_D: "(Deprecated, please do not use)",
  T_49_META_TYPE_180_D: "refers to a property of a component",
  T_49_META_TYPE_181_D: "Types used to describe mesh assets",
  T_49_META_TYPE_182_D: "A type used to describe a material asset",
  T_49_META_TYPE_183_D: "A type to describe a texture asset",
  T_49_META_TYPE_184_D: "Bridge rendering component for rendering with built-in model resources",
  T_49_META_TYPE_185_D: "Custom rendering component for rendering with custom model resources",
  T_49_META_TYPE_186_D: "A blank object component that can be used in conjunction with a renderer component, collider component, etc.",
  T_49_META_TYPE_187_D: "Container",
  T_49_META_TYPE_188_D: "Basic Cylinder",
  T_49_META_TYPE_189_D: "List of localized strings",
  T_49_META_TYPE_19_D: "A list template, where the type of content can be specified via T.",
  T_49_META_TYPE_190_D: "Two Team Score Panel",
  T_49_META_TYPE_191_D: "Tactical thrown weapon that blinds enemies within a certain range for a short period of time.",
  T_49_META_TYPE_192_D: "When used, it creates smoke that obscures events, which is a useful tool for interrupting enemy attacks.",
  T_49_META_TYPE_193_D: "Multi-Team Result Panel",
  T_49_META_TYPE_194_D: "Sensor mines that can be placed on the ground and will explode when an enemy approaches, be careful not to step on them yourself",
  T_49_META_TYPE_195_D: "Tween Campaign Playing Style",
  T_49_META_TYPE_197_D: "Playable Components",
  T_49_META_TYPE_198_D: "Item Base",
  T_49_META_TYPE_199_D: "Auxiliary equipment for aerial combat, but you need to keep an eye on the energy consumption at all times",
  T_49_META_TYPE_2_D: "Boolean types, to indicate true, false, or yes/no",
  T_49_META_TYPE_20_D: "A built-in enumeration of UI types, which is automatically generated by the type system.",
  T_49_META_TYPE_200_D: "Jailbreak area",
  T_49_META_TYPE_201_D: "Areas where you can swim after entering",
  T_49_META_TYPE_202_D: "ColliderID",
  T_49_META_TYPE_203_D: "Tween Movement",
  T_49_META_TYPE_204_D: "Shoes fitted with technological power-ups that allow you to jump in the air in two stages",
  T_49_META_TYPE_205_D: "A glider that can fly in the sky, use it to land from a high place to move farther away",
  T_49_META_TYPE_206_D: "Skateboard",
  T_49_META_TYPE_207_D: "Zipline",
  T_49_META_TYPE_208_D: "List of Playables",
  T_49_META_TYPE_209_D: "Playable or List of Playables",
  T_49_META_TYPE_21_D: "Built-in UI entities, which encapsulate specific functionality.",
  T_49_META_TYPE_210_D: "Trajectory Animation is an animation that simulates Trajectory movement.",
  T_49_META_TYPE_211_D: "Coordinate System",
  T_49_META_TYPE_212_D: "One object follows another object",
  T_49_META_TYPE_213_D: "An object's front face is always facing the other object.",
  T_49_META_TYPE_214_D: "An ID that describes a gallery sprite asset",
  T_49_META_TYPE_215_D: "results of a competition",
  T_49_META_TYPE_216_D: "Dictionary data container, the data elements are a pair of Key, Value.",
  T_49_META_TYPE_217_D: "Dictionary data template, can be specified by T1, T2 type of content",
  T_49_META_TYPE_218_D: "A type of light source that emits light of equal intensity in all directions from the position of the light source.",
  T_49_META_TYPE_219_D: "Motorcycle Carrier",
  T_49_META_TYPE_22_D: "Custom UIs, created by the player through the UI editor.",
  T_49_META_TYPE_220_D: "Assault vehicle (tricycle) carrier",
  T_49_META_TYPE_221_D: "Amphibious/Machine Gun Motorcycle Vehicle",
  T_49_META_TYPE_222_D: "Four-wheeled vehicle",
  T_49_META_TYPE_224_D: "Skill Type List",
  T_49_META_TYPE_225_D: "Artificial Intelligence Turret made of high-tech materials that actively searches for and attacks enemies within a certain range.",
  T_49_META_TYPE_226_D: "Turret generated by using turret consumable.",
  T_49_META_TYPE_227_D: "Custom UI widgets type enumeration",
  T_49_META_TYPE_23_D: "An enumeration of the level's object types, which is automatically generated by the system based on the type.",
  T_49_META_TYPE_231_D: "Repair Kit",
  T_49_META_TYPE_233_D: "Progress Circle",
  T_49_META_TYPE_234_D: "Landmine Created",
  T_49_META_TYPE_235_D: "Gloo Wall",
  T_49_META_TYPE_236_D: "Ice Wall Created",
  T_49_META_TYPE_237_D: "Hook Gun",
  T_49_META_TYPE_238_D: "Rainbow Paint Gun",
  T_49_META_TYPE_239_D: "Spray Rifle",
  T_49_META_TYPE_24_D: "Current system-defined damage types",
  T_49_META_TYPE_240_D: "Entities are the carriers of all components, components must be attached to entities to produce instances",
  T_49_META_TYPE_241_D: "Power Hook Gun",
  T_49_META_TYPE_242_D: "Score Bar",
  T_49_META_TYPE_243_D: "Clothing slots",
  T_49_META_TYPE_244_D: "Text entity represents a displayed text",
  T_49_META_TYPE_245_D: "Icon entity represents a displayed icon",
  T_49_META_TYPE_246_D: "Spray Color",
  T_49_META_TYPE_247_D: "Player UI type",
  T_49_META_TYPE_248_D: "General UI switch entity",
  T_49_META_TYPE_249_D: "Switch Equip Slot",
  T_49_META_TYPE_25_D: "Phases of the game, such as game start, game preparation, game end, etc.",
  T_49_META_TYPE_250_D: "Effects entity represents a displayed effect",
  T_49_META_TYPE_2500_D: "The player's birth point",
  T_49_META_TYPE_2501_D: "Triggers for triggering the player's (or other object's) entry and exit events",
  T_49_META_TYPE_2502_D: "Death or invulnerability triggers that control whether the player is dead or invulnerable effects when entering based on properties",
  T_49_META_TYPE_2503_D: "Race mode checkpoints",
  T_49_META_TYPE_2504_D: "Typically used in Race Mode to recognize when a player has entered a specified finish line. This is a specific trigger, custom triggers will be opened later, this endpoint is just a wrapper for custom triggers.",
  T_49_META_TYPE_2505_D: "Fence around the birth point, close it to leave the birth point",
  T_49_META_TYPE_2507_D: "Turret",
  T_49_META_TYPE_2508_D: "Monster Spawn",
  T_49_META_TYPE_2509_D: "Instances of the type can be generated on demand",
  T_49_META_TYPE_251_D: "Effect Container",
  T_49_META_TYPE_2510_D: "Player birth area (rectangle)",
  T_49_META_TYPE_252_D: "Spray Result UI",
  T_49_META_TYPE_253_D: "Hint Button",
  T_49_META_TYPE_254_D: "Heartbeat Effect",
  T_49_META_TYPE_255_D: "Timestamp Localization String",
  T_49_META_TYPE_256_D: "Rigidbody Type",
  T_49_META_TYPE_257_D: "Rigid body components",
  T_49_META_TYPE_258_D: "Timestamp Format Style Type",
  T_49_META_TYPE_259_D: "Tips",
  T_49_META_TYPE_26_D: "Rounds in a game, often a small game with several phases.",
  T_49_META_TYPE_260_D: "Progress Skill Button",
  T_49_META_TYPE_261_D: "Unique ID",
  T_49_META_TYPE_262_D: "Weapon Skin ID",
  T_49_META_TYPE_263_D: "Clothing ID",
  T_49_META_TYPE_264_D: "Consumable ID, when the version only has the weapon ID",
  T_49_META_TYPE_265_D: "UI panel entity",
  T_49_META_TYPE_267_D: "UI scroll view entity, UI edited by the player via the UI editor",
  T_49_META_TYPE_268_D: "A switch with three states, with the option to keep the original logic except for on and off.",
  T_49_META_TYPE_269_D: "The player's equipment.",
  T_49_META_TYPE_270_D: "Entity or Prefab ID",
  T_49_META_TYPE_271_D: "UI panel entity, UI edited by the player via the UI editor",
  T_49_META_TYPE_272_D: "Gender enumeration",
  T_49_META_TYPE_273_D: "Minimap",
  T_49_META_TYPE_274_D: "Icon displayed on the mini-map to follow the target",
  T_49_META_TYPE_275_D: "Individual part nodes in the skeleton",
  T_49_META_TYPE_276_D: "Nodes used to access skinned rigs",
  T_49_META_TYPE_277_D: "Client-side camera ray detection",
  T_49_META_TYPE_278_D: "Pixel blocks displayed on the mini-map, representing the collision size of the object at that location.",
  T_49_META_TYPE_279_D: "Color Drum",
  T_49_META_TYPE_28_D: "Reset at the beginning of each round.",
  T_49_META_TYPE_280_D: "Sphere Trigger",
  T_49_META_TYPE_281_D: "Capsule Trigger",
  T_49_META_TYPE_282_D: "Type describing the asset configuration ID, used to indicate that the parent package comes with the asset configuration ID, which needs to be parsed through the configuration table before loading",
  T_49_META_TYPE_283_D: "Describe the type of asset, used to indicate the identifier of the asset, can be loaded directly.",
  T_49_META_TYPE_284_D: "Indicates a humanoid model resource, which can be replaced with a player character.",
  T_49_META_TYPE_285_D: "A list or dictionary that can be traversed in a loop.",
  T_49_META_TYPE_286_D: "ID to describe the script asset",
  T_49_META_TYPE_287_D: "to describe the ID of a static script asset",
  T_49_META_TYPE_288_D: "to describe the ID of a custom UI asset",
  T_49_META_TYPE_289_D: "ID for describing the body of a preconfigured asset",
  T_49_META_TYPE_29_D: "Special effects",
  T_49_META_TYPE_290_D: "Behavior Tree",
  T_49_META_TYPE_291_D: "Behavior Tree Node Type",
  T_49_META_TYPE_292_D: "Behavior Tree Custom Node",
  T_49_META_TYPE_293_D: "Behavior Tree Attachable",
  T_49_META_TYPE_294_D: "UI layout entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_295_D: "State",
  T_49_META_TYPE_296_D: "Animation Clip",
  T_49_META_TYPE_297_D: "Animation Controller",
  T_49_META_TYPE_298_D: "Loop Type",
  T_49_META_TYPE_3_D: "Integer types, 32-bit signed integers",
  T_49_META_TYPE_30_D: "Icon",
  T_49_META_TYPE_300_D: "UI3DContainer entity, UI edited by the player via the UI Editor",
  T_49_META_TYPE_301_D: "AI Skill Type",
  T_49_META_TYPE_302_D: "Enumeration of equipment slots.",
  T_49_META_TYPE_303_D: "Corresponds to the Id column in BuffData.csv, please check with GPP before adding new items.",
  T_49_META_TYPE_304_D: "Buff Type List",
  T_49_META_TYPE_305_D: "Behavior Tree Node Status",
  T_49_META_TYPE_306_D: "Add buffs, remove buffs, and get a list of buffs already added.",
  T_49_META_TYPE_307_D: "Gloo Maker",
  T_49_META_TYPE_308_D: "Special Item ID Type",
  T_49_META_TYPE_309_D: "Thrown Object Props",
  T_49_META_TYPE_31_D: "Sound Effects",
  T_49_META_TYPE_310_D: "Crossbow",
  T_49_META_TYPE_311_D: "Grenade Base",
  T_49_META_TYPE_312_D: "Throwable props",
  T_49_META_TYPE_313_D: "Grenade DeIce Wall",
  T_49_META_TYPE_314_D: "Managing Animation Controllers and Resources",
  T_49_META_TYPE_315_D: "Player Backpack",
  T_49_META_TYPE_316_D: "UITexture entity, the UI edited by the player through the UI editor",
  T_49_META_TYPE_317_D: "Rigid body motion constraints, each of which can be used in combination",
  T_49_META_TYPE_318_D: "Attachment",
  T_49_META_TYPE_319_D: "Fill type enumeration",
  T_49_META_TYPE_32_D: "Player state type",
  T_49_META_TYPE_320_D: "Fill direction",
  T_49_META_TYPE_321_D: "Entities that can be target-assisted",
  T_49_META_TYPE_322_D: "Damaged Body Part Type",
  T_49_META_TYPE_323_D: "UIProfileInfo entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_324_D: "Several different effects of rigid body forces. Note that this only works for Dynamic types.",
  T_49_META_TYPE_325_D: "to describe the ID of a widget in a custom UI asset",
  T_49_META_TYPE_326_D: "Player profile information",
  T_49_META_TYPE_327_D: "Configure dressing according to each component",
  T_49_META_TYPE_328_D: "Behavior Tree ID",
  T_49_META_TYPE_329_D: "Seat Type",
  T_49_META_TYPE_33_D: "Sort by: ascending ignore zero value, descending, ascending",
  T_49_META_TYPE_330_D: "Self-relative movement",
  T_49_META_TYPE_331_D: "Bezier Curve",
  T_49_META_TYPE_332_D: "Loopable component",
  T_49_META_TYPE_333_D: "Font Type",
  T_49_META_TYPE_334_D: "Vehicle Skin ID",
  T_49_META_TYPE_335_D: "The sound entity represents a playing sound effect.",
  T_49_META_TYPE_336_D: "Sound Effect List",
  T_49_META_TYPE_337_D: "Sound Effect or Sound Effect List",
  T_49_META_TYPE_338_D: "Player behavior property synchronization entity",
  T_49_META_TYPE_339_D: "Equipment Accessory",
  T_49_META_TYPE_34_D: "Item ID",
  T_49_META_TYPE_340_D: "Bot Difficulty Type",
  T_49_META_TYPE_341_D: "Dictionary of integers",
  T_49_META_TYPE_342_D: "Timer objects",
  T_49_META_TYPE_343_D: "Flying Daggers (pickable)",
  T_49_META_TYPE_344_D: "Throwing Knife",
  T_49_META_TYPE_345_D: "Weapon Type",
  T_49_META_TYPE_346_D: "Ammo Type",
  T_49_META_TYPE_347_D: "Frame Self Relative",
  T_49_META_TYPE_348_D: "Function pointer to a function instance, used to implement dummy functions or delegate mechanism.",
  T_49_META_TYPE_349_D: "A handle to a concurrent program, which can be used to perform some handle operations.",
  T_49_META_TYPE_350_D: "Vehicle enumeration",
  T_49_META_TYPE_351_D: "Describes the type of the object",
  T_49_META_TYPE_352_D: "UIToggle entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_353_D: "MedKit",
  T_49_META_TYPE_354_D: "Inhaler",
  T_49_META_TYPE_355_D: "Horizaline",
  T_49_META_TYPE_356_D: "Airdrops, will start dropping from a high place after the preparation time is over",
  T_49_META_TYPE_357_D: "Descriptive colors for objects, such as borders, surfaces, etc. (deleted, reusable)",
  T_49_META_TYPE_358_D: "Refers to an event",
  T_49_META_TYPE_359_D: "Player controller with physics effects to apply forces.",
  T_49_META_TYPE_360_D: "Launch Pad",
  T_49_META_TYPE_361_D: "Folded cannon, when unfolded it can be used to launch people out, be careful not to launch yourself out of the safe zone!",
  T_49_META_TYPE_362_D: "Snowball fight! Punch it!",
  T_49_META_TYPE_363_D: "Shop request purchase",
  T_49_META_TYPE_364_D: "AnimationTrigger",
  T_49_META_TYPE_365_D: "Animation Trigger UI Component",
  T_49_META_TYPE_366_D: "Batch Combine Render",
  T_49_META_TYPE_367_D: "Top Compass",
  T_49_META_TYPE_368_D: "Custom character resource ID",
  T_49_META_TYPE_369_D: "Custom animation resource ID",
  T_49_META_TYPE_370_D: "Information displayed at the start of a round",
  T_49_META_TYPE_371_D: "At the end of each round, the results are displayed.",
  T_49_META_TYPE_372_D: "Player Stance Types",
  T_49_META_TYPE_373_D: "Collection ID, used for resource information collection",
  T_49_META_TYPE_374_D: "Follow Health Bar",
  T_49_META_TYPE_375_D: "Monster target type",
  T_49_META_TYPE_376_D: "Defense tower attack target type",
  T_49_META_TYPE_377_D: "Alias to refer to player entity, vehicle entity type",
  T_49_META_TYPE_378_D: "to describe the ID of an audio asset",
  T_49_META_TYPE_379_D: "ID to describe the configuration table asset",
  T_49_META_TYPE_38_D: "UI Empty Widget entity, UI edited by the player through the UI editor.",
  T_49_META_TYPE_380_D: "ID to describe the effects asset",
  T_49_META_TYPE_381_D: "ID to describe the Animation Controller asset",
  T_49_META_TYPE_382_D: "How knockdown status is handled",
  T_49_META_TYPE_383_D: "Surface or decorations on the map itself",
  T_49_META_TYPE_384_D: "Items",
  T_49_META_TYPE_385_D: "Character Skill ID",
  T_49_META_TYPE_386_D: "Skill ID List",
  T_49_META_TYPE_387_D: "UITouchPad entity, UI edited by the player via the UI editor",
  T_49_META_TYPE_388_D: "Backpack Skin ID",
  T_49_META_TYPE_389_D: "Joystick entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_39_D: "UI image entity, the UI edited by the player through the UI editor.",
  T_49_META_TYPE_390_D: "Hierarchical",
  T_49_META_TYPE_391_D: "Custom UI or Widget",
  T_49_META_TYPE_392_D: "Placeable out-of-zone objects",
  T_49_META_TYPE_393_D: "Entities with PhysicalCCT or Rigidbody component",
  T_49_META_TYPE_394_D: "Mathematical constants",
  T_49_META_TYPE_395_D: "Entities with PhysicalCCT or PlayerCCT components can move along with them.",
  T_49_META_TYPE_396_D: "Mid-Game Exit Configuration",
  T_49_META_TYPE_397_D: "Components used to describe collision shapes",
  T_49_META_TYPE_398_D: "String or Localization String",
  T_49_META_TYPE_399_D: "Character Controller with Physical Effects, for FF characters only.",
  T_49_META_TYPE_4_D: "Floating-point type, 32-bit single-precision floating-point number",
  T_49_META_TYPE_40_D: "UI Text entity, the UI edited by the player through the UI editor.",
  T_49_META_TYPE_400_D: "How to perform the attack behavior",
  T_49_META_TYPE_401_D: "Fire Type",
  T_49_META_TYPE_402_D: "Social Button Widget",
  T_49_META_TYPE_403_D: "Social Button Types",
  T_49_META_TYPE_404_D: "Social Button Styles",
  T_49_META_TYPE_405_D: "Layout Sort Type",
  T_49_META_TYPE_406_D: "Can be triggered to go over obstacles",
  T_49_META_TYPE_407_D: "Platform Type",
  T_49_META_TYPE_408_D: "Base Data Alias",
  T_49_META_TYPE_409_D: "Error code enumeration",
  T_49_META_TYPE_41_D: "UI button entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_410_D: "Alias that refers to a player entity or Transform entity type",
  T_49_META_TYPE_411_D: "Helicopter Carrier",
  T_49_META_TYPE_412_D: "Vehicle component, which is an extension of the Carrier component.",
  T_49_META_TYPE_413_D: "NPC",
  T_49_META_TYPE_414_D: "Limits the range of camera rotation angles",
  T_49_META_TYPE_415_D: "Persona",
  T_49_META_TYPE_416_D: "Persona Chat Window UI",
  T_49_META_TYPE_417_D: "Particle entity component",
  T_49_META_TYPE_418_D: "Member status enumeration",
  T_49_META_TYPE_419_D: "Gun Skin Type",
  T_49_META_TYPE_42_D: "UI input entity, UI edited by the player through the UI editor",
  T_49_META_TYPE_420_D: "Vehicle Skin Types",
  T_49_META_TYPE_421_D: "Skin",
  T_49_META_TYPE_422_D: "Backpack Skin Types",
  T_49_META_TYPE_423_D: "Persona ID",
  T_49_META_TYPE_424_D: "Fog effect base type",
  T_49_META_TYPE_425_D: "Particle asset ID",
  T_49_META_TYPE_426_D: "A type of light source that emits a cone of light in the negative Y-axis direction from the light source, defaulting to the ground.",
  T_49_META_TYPE_427_D: "NPC",
  T_49_META_TYPE_428_D: "Clothing information to be retained when the player transforms into another character.",
  T_49_META_TYPE_429_D: "Player or NPC entities",
  T_49_META_TYPE_43_D: "List of element types that must be player entities",
  T_49_META_TYPE_430_D: "Random Number Generator",
  T_49_META_TYPE_431_D: "Motion objects moving along a customized path",
  T_49_META_TYPE_432_D: "Custom Curve Path Waypoints",
  T_49_META_TYPE_433_D: "Custom curve path waypoint types",
  T_49_META_TYPE_434_D: "Custom Curve Paths",
  T_49_META_TYPE_435_D: "List of unique player identifiers",
  T_49_META_TYPE_436_D: "Error code list",
  T_49_META_TYPE_437_D: "Two teams match details UI entity, modify the entity property to affect the display content on the corresponding UI.",
  T_49_META_TYPE_438_D: "Multi-team match details UI entity, modifying the entity properties will affect the display content on the corresponding UI.",
  T_49_META_TYPE_439_D: "Combine",
  T_49_META_TYPE_44_D: "A list of entities whose element types must be team entities",
  T_49_META_TYPE_440_D: "Timeline",
  T_49_META_TYPE_441_D: "Timeline Resource ID",
  T_49_META_TYPE_442_D: "New two-team match information short version entity component, supports fully customizable headcount display",
  T_49_META_TYPE_443_D: "Dialog stream asset ID",
  T_49_META_TYPE_444_D: "Language Type",
  T_49_META_TYPE_45_D: "Bool List",
  T_49_META_TYPE_46_D: "Int List",
  T_49_META_TYPE_47_D: "Float List",
  T_49_META_TYPE_48_D: "String List",
  T_49_META_TYPE_49_D: "Vector3 List",
  T_49_META_TYPE_5_D: "String type, value is text content",
  T_49_META_TYPE_50_D: "A list of entities whose element types must be entities",
  T_49_META_TYPE_51_D: "Zombie Types",
  T_49_META_TYPE_53_D: "Common Level Object",
  T_49_META_TYPE_54_D: "Destructible Object",
  T_49_META_TYPE_55_D: "General Spawn Point",
  T_49_META_TYPE_56_D: "Vehicle",
  T_49_META_TYPE_57_D: "Players can be teleported to a specific location upon entry",
  T_49_META_TYPE_58_D: "Buffs can be generated on demand",
  T_49_META_TYPE_59_D: "Moving Platform",
  T_49_META_TYPE_6_D: "Three-dimensional vectors, which can represent spatial coordinates or spatial directions",
  T_49_META_TYPE_60_D: "Generates a weapon drop of the selected type.",
  T_49_META_TYPE_61_D: "Entering the trigger range opens the Bound Shop.",
  T_49_META_TYPE_62_D: "Bouncy Dice",
  T_49_META_TYPE_63_D: "Players step on them and they will be bounced to a specific location.",
  T_49_META_TYPE_64_D: "Players will make a sound when stepping on them",
  T_49_META_TYPE_65_D: "Basic Scalable",
  T_49_META_TYPE_66_D: "Custom Path",
  T_49_META_TYPE_67_D: "Path Point",
  T_49_META_TYPE_68_D: "AI monster entities, such as zombies",
  T_49_META_TYPE_69_D: "Large numbers are high precision floating point numbers",
  T_49_META_TYPE_7_D: "Numbers are type aliases that refer to integer, 64-bit integer, or floating-point types",
  T_49_META_TYPE_70_D: "Property formulas are used to calculate entity property values, only some player properties and weapon properties are supported for now.",
  T_49_META_TYPE_71_D: "Only used for entities sold in the shop, the concept of shop items is different from that of items purchased.",
  T_49_META_TYPE_72_D: "Contains several shop items.",
  T_49_META_TYPE_73_D: "Contains several shelves.",
  T_49_META_TYPE_74_D: "Item ID",
  T_49_META_TYPE_75_D: "Come Back",
  T_49_META_TYPE_76_D: "Patrol style",
  T_49_META_TYPE_77_D: "A generator entity that can generate and refresh objects.",
  T_49_META_TYPE_78_D: "A unit entity that can be used by the unit generator to absorb and generate units in batches.",
  T_49_META_TYPE_79_D: "Weapon",
  T_49_META_TYPE_8_D: "Conditionals are special Bool types",
  T_49_META_TYPE_80_D: "UI of the shop",
  T_49_META_TYPE_81_D: "Buff Type",
  T_49_META_TYPE_82_D: "UI Heartbeat",
  T_49_META_TYPE_83_D: "Interaction Button",
  T_49_META_TYPE_84_D: "Rankable entity, capable of being ranked",
  T_49_META_TYPE_85_D: "Scoreable entity, has its own score",
  T_49_META_TYPE_86_D: "Property formula factor type",
  T_49_META_TYPE_87_D: "Describes the type of RGBA color, the range of value is 0~255 for each channel.",
  T_49_META_TYPE_88_D: "Currency type, currently only the base currency type",
  T_49_META_TYPE_89_D: "Currency entity, which describes the type and amount of currency.",
  T_49_META_TYPE_9_D: "A set of conditions",
  T_49_META_TYPE_90_D: "Wallet entities are containers for a bunch of currency entities",
  T_49_META_TYPE_91_D: "Indicates an integer or integer array type.",
  T_49_META_TYPE_92_D: "Dynamic Create Level Object Type",
  T_49_META_TYPE_93_D: "Entities with formulable properties",
  T_49_META_TYPE_94_D: "Property modification",
  T_49_META_TYPE_95_D: "Coin Generator",
  T_49_META_TYPE_96_D: "Wallet",
  T_49_META_TYPE_97_D: "Position rotation and scaling, supports parent-child structure",
  T_49_META_TYPE_98_D: "List all available types",
  T_49_META_TYPE_99_D: "Football"
};
export {
  _ as default
};
